(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('.loader-overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:99999;background-color:#ffffffe6}.loader{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:100000;display:flex}.loading-label{margin:0 .5rem;font-size:1.5rem}.spinner{width:inherit;height:inherit;display:flex;align-items:center}.spinner .bounce1{animation-delay:-.32s}.spinner .bounce2{animation-delay:-.16s}.spinner>div{width:.5rem;height:.5rem;margin:0 .25rem;background-color:#0000009e;border-radius:100%;display:inline-block;animation:sk-bouncedelay 1.4s infinite ease-in-out both}@keyframes sk-bouncedelay{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}.button{display:flex;flex-direction:row;align-items:center;justify-content:center;gap:.5em;border-radius:12px;height:24px;border:none;padding:.6em 1.2em;font-size:1rem;font-weight:600;font-family:inherit;cursor:pointer}.button:focus-visible{outline:none}.button:disabled,.button:disabled:hover,.button:disabled:active{border-color:transparent;color:#727272;background-color:#d7d8da;cursor:not-allowed;box-shadow:none}.button:disabled>svg *,.button:disabled *,.button:disabled:hover>svg *,.button:disabled:hover *,.button:disabled:active>svg *,.button:disabled:active *{fill:#727272}.button-highlighted{background-color:#3e75cf;border:1px solid transparent;color:#fff}.button-highlighted:focus,.button-highlighted:focus-visible{outline:none;box-shadow:0 0 0 1px #fff,0 0 0 3px #3e75cf,0 0 0 6px #d8e3f5}.button-highlighted:focus:active,.button-highlighted:focus-visible:active{box-shadow:none}.button-highlighted:hover:not(:disabled){background-color:#3465a8;box-shadow:0 10px 10px -6px #0000005e}.button-highlighted:active:not(:disabled){border:1px solid transparent;background-color:#255096}.button-highlighted:focus,.button-highlighted :focus-visible{border:1px solid black;border-style:inset}.button-text,.button-link{background-color:inherit;padding:0}.button-text:disabled,.button-link:disabled{background-color:initial}.button-text:disabled:hover,.button-link:disabled:hover{background-color:initial}.button-text:hover:not(:focus,:disabled),.button-link:hover:not(:focus,:disabled){box-shadow:none}.button-text{padding:0 .5em;height:30px}.button-text:focus:not(:active),.button-text:focus-visible:not(:active){outline:none;box-shadow:0 0 0 1px inset #3e75cf,0 0 0 1px #3e75cf,0 0 0 4px #d8e3f5}.button-text:focus:not(:active):hover,.button-text:focus-visible:not(:active):hover{outline:none;box-shadow:0 0 0 1px inset #3e75cf,0 0 0 1px #3e75cf,0 0 0 4px #d8e3f5}.button-text:hover{background-color:#e9effa}.button-text:focus-visible{text-decoration:underline}.button-text:active:not(:disabled){text-decoration:underline}.button-link{color:#2d62b7;height:24px}.button-link:hover,.button-link:focus-visible{text-decoration:underline;color:#255096;box-shadow:none}.button-link:active:not(:disabled){color:#1d3f75;text-decoration:underline}.button-primary{color:#2d62b7;box-shadow:0 0 0 1px #6591d9;background-color:#fff}.button-primary:focus:not(:active),.button-primary:focus-visible:not(:active){outline:none;box-shadow:0 0 0 1px inset #3e75cf,0 0 0 1px #3e75cf,0 0 0 4px #d8e3f5}.button-primary:focus:not(:active):hover,.button-primary:focus-visible:not(:active):hover{outline:none;box-shadow:0 0 0 1px inset #3e75cf,0 0 0 1px #3e75cf,0 0 0 4px #d8e3f5}.button-primary:hover{color:#255096;background-color:#d8e3f5;box-shadow:0 10px 10px -6px #0000005e,0 0 0 1px #3e75cf}.button-primary:active{color:#1d3f75;background-color:#d8e3f5;box-shadow:0 0 0 1px #3e75cf}.button-primary:disabled{box-shadow:0 0 0 1px transparent}.button-passive{color:#2d62b7;background-color:transparent}.button-passive:focus:not(:active),.button-passive:focus-visible:not(:active){outline:none;box-shadow:0 0 0 1px inset #3e75cf,0 0 0 1px #3e75cf,0 0 0 4px #d8e3f5}.button-passive:focus:not(:active):hover,.button-passive:focus-visible:not(:active):hover{outline:none;box-shadow:0 0 0 1px inset #3e75cf,0 0 0 1px #3e75cf,0 0 0 4px #d8e3f5}.button-passive:hover{color:#255096;background-color:#d8e3f5}.button-passive:active{color:#1d3f75;background-color:#d8e3f5}.button-ghost{padding:0;height:initial;background-color:transparent}.button-icon{border-radius:8px;padding:.188rem;height:fit-content;background-color:transparent;border:1px solid transparent}.button-icon:hover{background-color:#2576c333}.button-icon:focus,.button-icon:focus-visible,.button-icon:active{border:1px solid rgba(0,0,0,.2);box-shadow:0 0 0 3px #2576c34d}.button-icon:active{background-color:#1960a4;color:#fff}.button-icon:active>svg,.button-icon:active path,.button-icon:active *{fill:#fff;opacity:1;fill-opacity:1}.button-icon:disabled:active>svg{fill-opacity:.6;opacity:.6}.button-capitalize{text-transform:capitalize}.button-nowrap{text-wrap:nowrap}.common-status{position:fixed;bottom:1.75rem;right:2rem;z-index:10100}.status-message{position:relative;width:42.375rem;padding:.5rem .65625rem;border:1px solid #d7d8da;border-radius:6px;background:white;display:flex;flex-direction:row;align-items:center;font-size:.875rem;transform:translate(1500px);opacity:0;animation:slideInOut 5.5s ease-in-out}.status-message:not(:first-child){margin-top:.5rem}.status-message-icon{margin-right:1rem}.status-message-text{flex:1}.status-message-close{padding:0;background-color:transparent}.status-message-close:hover,.status-message-close:active,.status-message-close:focus{background-color:transparent;opacity:.5}.status-message.success{border-color:#070;background-color:#d7e3d2}.status-message.warning{border-color:#943e00;color:#943e00;background-color:#f7e7de}.status-message.warning .status-message-icon path,.status-message.warning .status-message-close path{fill:#943e00}.status-message.error{border-color:#900;color:#900;background-color:#ead2d0}.status-message.error .status-message-icon path,.status-message.error .status-message-close path{fill:#900}@keyframes slideInOut{0%{opacity:0;transform:translate(120%)}5%{transform:translate(0);opacity:1}95%{transform:translate(0);opacity:1}to{transform:translate(120%);opacity:0}}.dropdown{position:relative;display:inline-block}.dropdown-button{display:flex;align-items:center;padding:3px 1rem;border:1px solid #1960a4;border-radius:12px;font-size:.875rem;font-weight:700;background-color:#1960a4;color:#fff;cursor:pointer}.dropdown-button-label{margin-right:10px}.dropdown-button.expanded .dropdown-icon{transform:rotateX(180deg)}.dropdown-options{position:absolute;top:27px;right:0;width:max-content;padding:15px 10px;border:1px solid #d7d8da;border-radius:4px;background-color:#fff;z-index:1}.dropdown-options.expanded{display:block}.dropdown-options.collapsed{display:none}.dropdown-options-group-label{margin-bottom:.5rem;font-size:.855rem;font-weight:700;color:#0000009e}.dropdown-options-button{display:flex;width:100%;align-items:center;margin-bottom:.5rem;padding:2px 5px;border:1px solid transparent;border-radius:12px;background-color:transparent;font-size:.875rem;font-weight:700;color:#000;cursor:pointer}.dropdown-options-button:last-child{margin-bottom:0}.dropdown-options-button-icon{margin:1px .75rem 0 0;fill:#000}.dropdown-options-button-icon path{fill-opacity:1}.dropdown-options-button:disabled{opacity:.5;cursor:default}.dropdown-options-button:hover{background-color:#2576c34d}.dropdown-options-button:hover:disabled{background-color:transparent}.dropdown-options-button:focus{border-color:#0003;background-color:#2576c34d;box-shadow:0 0 0 3px #2576c34d}.dropdown-options-button:active{border-color:#0003;background-color:#1960a4;color:#fff;text-decoration:none}.dropdown-options-button:active .dropdown-options-button-icon path{fill:#fff}.dropdown-options-button:active:disabled{border:none;background-color:transparent;color:#000}.dropdown-options-button:active:disabled .dropdown-options-button-icon path{fill:#000}.nav-block .dropdown-options{width:20rem}#editor-root .nav{position:sticky;position:-webkit-sticky;top:0;z-index:10;display:flex;flex-wrap:wrap;align-items:center;flex-direction:row;justify-content:space-between;padding-right:.75rem;border-bottom:1px solid #d7d8da;background-color:#fff}#editor-root .nav nav{display:flex;flex-wrap:wrap;align-self:stretch;padding-right:.75rem}#editor-root .nav nav a{text-decoration:none}#editor-root .nav nav .nav-link{display:flex;align-items:center;align-self:stretch;padding:.875rem .75rem;line-height:.875rem;font-size:.875rem;font-weight:400;color:#000}#editor-root .nav nav .nav-link:hover{background-color:#d7d8da}#editor-root .nav nav .nav-link.active{font-weight:600;background-color:#d7d8da}#editor-root .nav nav .nav-link.disabled{pointer-events:none;background-color:transparent;color:#d3d3d3}#editor-root .nav .nav-block{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;width:100%;justify-content:space-between}#editor-root .nav .nav-block-fixed-height{height:2.75rem}#editor-root .nav .nav-block-fixed-height nav{margin-left:.5rem;display:flex;align-items:center}#editor-root .nav .nav-block .heading{font-size:.875rem;font-weight:700}#editor-root .nav .nav-block .empty-block{min-width:2.203rem}#editor-root .nav .nav-language-select{display:flex;align-items:center;margin-left:.75rem}#editor-root .nav .locale-select{margin-left:auto}#editor-root .nav .nav-title{display:flex;align-self:stretch;align-items:center;border-left:1px solid #d7d8da;font-size:1rem;font-weight:600;padding:0 1.5rem}.overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:9999;background-color:#00000080}.modal{position:fixed;top:50%;left:50%;border:1px solid #ccc;transform:translate(-50%,-50%);background:#fff;-webkit-overflow-scrolling:touch;border-radius:8px;outline:none;padding:24px 24px 16px;z-index:10000}.modal-header{display:flex;flex-direction:row;align-items:center;gap:1rem}.modal-header .title{font-size:1.4rem;font-weight:500}.modal-header .close-button{height:24px;width:24px;display:flex;flex-direction:row;align-items:center;justify-content:center;background-color:transparent;padding:0;border:none;border-radius:0;cursor:pointer}.modal-header .close-button:hover{border:none!important}.modal-controls{display:flex;flex-direction:row;justify-content:flex-end;gap:16px}.modal-uncontrolled-authorities-warning .modal-controls{justify-content:space-between}.uncontrolled-authorities-contents{padding:1.5rem 0;white-space:pre-line}.record-controls{display:flex;flex-wrap:wrap;gap:.5rem}.record-controls :first-child{margin-right:auto}.preview-external-resource-controls{display:flex;flex-wrap:wrap;gap:.5rem}.preview-external-resource-controls :first-child{margin-right:auto}.footer{z-index:0;padding:.938rem;background-color:#fff;box-shadow:0 4px 32px #0000002d}.duplicate-group-container .expand-collapse-button{width:100%;display:flex;align-items:center;justify-content:flex-start;border-radius:.375rem;padding:.313rem;border:1px solid transparent;font-size:.75rem;color:#000;font-weight:initial}.duplicate-group-container .expand-collapse-button:focus,.duplicate-group-container .expand-collapse-button:focus-visible{background:rgba(37,118,195,.3);border:1px solid rgba(0,0,0,.2);box-shadow:0 0 0 3px #2576c34d}.duplicate-group-container .expand-collapse-button:focus:not(:active),.duplicate-group-container .expand-collapse-button:focus-visible:not(:active){box-shadow:0 0 0 3px #2576c34d}.duplicate-group-container .expand-collapse-button:hover{box-shadow:none;background:rgba(37,118,195,.2);border:1px solid transparent;outline:none}.duplicate-group-container .expand-collapse-button:active{background:#1960a4;border:1px solid rgba(0,0,0,.2);color:#fff;box-shadow:none}.duplicate-group-container .expand-collapse-button:active *>*{fill:#fff}.duplicate-group-container .expand-collapse-button .arrow-closed{transform:rotate(180deg)}.close-record-contents{padding:1.5rem 0}.modal-switch-to-new-record .modal-controls{justify-content:space-between}.prompt-content{padding:1.5rem 0}.input{width:100%;max-width:100%;box-sizing:border-box;height:2.3rem;border:1px solid gray;font-size:1rem;padding:0 .5rem}.select-input{border-radius:0;border:1px solid gray;padding:4px;height:27px}.select-input option:disabled,.select-input.placeholder,.select-input.placeholder option:disabled{color:#727272}.select-input.placeholder option{color:#000}.modal .advanced-search-container{padding:40px 0 24px;display:flex;flex-direction:column;gap:16px}.modal .advanced-search-container .search-row{display:flex;flex-direction:row;gap:16px;align-items:center}.modal .advanced-search-container .search-row .cell-bold{font-weight:600}.modal .advanced-search-container .search-row .cell-operator,.modal .advanced-search-container .search-row .cell-bold{width:93px}.modal .advanced-search-container .search-row .cell-qualifier{width:120px}.modal .advanced-search-container .search-row .cell-query{width:260px}.modal .advanced-search-container .search-row .cell-identifier{width:120px}.modal .advanced-search-container .search-row .text-input{border-radius:0;border:1px solid gray;padding:4px 5px;height:27px}.simple-lookup__dropdown-indicator:hover{cursor:pointer}.simple-lookup__dropdown-indicator__icon path{fill:#55585d}.simple-lookup__multi-value__remove:hover,.simple-lookup__clear-indicator:hover{cursor:pointer}.simple-lookup__multi-value__remove__icon,.simple-lookup__clear-indicator__icon{fill:#0009}.simple-lookup__clear-indicator:hover{opacity:.5}.edit-section-field-input.simple-lookup input{height:1.375rem;border:none}#app-root .simple-lookup__multi-value__remove:hover{background-color:#2576c333}.accordion{display:flex;flex-direction:column;gap:4px}.accordion-toggle{padding:0;width:100%}.accordion-toggle-button{padding:0;width:100%;z-index:1;font-size:1rem;font-weight:600}.accordion-toggle-container{display:flex;flex-direction:row;align-items:center;gap:.5rem;padding:4px 0;width:100%}.accordion-toggle-container .icon{height:1rem}.accordion-toggle-container .icon-collapsed{transform:rotate(180deg)}.date-picker-input{width:100%;height:24px;border:1px solid rgba(0,0,0,.42);padding:0 8px;font-family:Inter,system-ui,Avenir,Helvetica,Arial,sans-serif;background-color:#00000008;color:#000}.date-range-group{margin-bottom:1rem}.date-range-label{margin:0 0 4px;padding:0;font-size:1rem;font-weight:600}.textarea{box-sizing:border-box;height:26px;min-height:26px;padding:1px .5rem 0;border:1px solid gray;font-size:1rem;font-family:inherit}.textarea-full-width{width:100%;min-width:100%;max-width:100%}.textarea:focus{border:1px solid #3e75cf;outline:0;box-shadow:0 0 0 1px #3e75cf,0 0 0 1px #3e75cf,0 0 0 4px #d8e3f5}.embed-container .textarea{padding-top:3px}.button-group{display:inline-flex}.button-group.full-width{width:100%}.button-group.full-width>*{width:100%}.button-group>:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.button-group>:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.button-group>:not(:first-child,:last-child){border-radius:0}.button-group>:not(:first-child){margin-left:-1px}.search-segments{margin:15px 0 0}.search-segment-button.button-highlighted{z-index:100;border:1px solid #3e75cf}.search-segment-button.button-primary{border:1px solid #6591d9;box-shadow:none}.search-pane{display:flex;flex-direction:column;min-width:290px;width:290px;border-right:1px solid #d7d8da}.search-pane-header,.search-pane .meta-controls{display:flex;flex-direction:row;align-items:center;justify-content:space-between;border-bottom:1px solid #d7d8da}.search-pane-header-centered,.search-pane .meta-controls-centered{justify-content:center}.search-pane-header-centered>.search-button,.search-pane .meta-controls-centered>.search-button{width:100%;height:24px;border-radius:12px;line-height:24px}.search-pane-header-centered>.search-button:disabled,.search-pane .meta-controls-centered>.search-button:disabled{background-color:#d7d8da}.search-pane-header{height:2.75rem;min-height:2.75rem;padding:0 1rem;background-color:#00000008}.search-pane-header .close-ctl{height:2.125rem;width:2.125rem;padding:.5rem}.search-pane-header .close-ctl svg{height:12px;transform:rotate(-90deg)}.search-pane-header-title{font-size:.875rem}.search-pane-content{height:100%;padding:0 1rem .75rem;overflow-y:auto}.search-pane-content .primary-search{width:100%}.search-pane .meta-controls{padding-bottom:.75rem}.search-pane .header-caret{height:12px;transform:rotate(-90deg)}.search-pane .inputs{padding:16px 0 12px;display:flex;flex-direction:column}.search-pane .inputs .select-input,.search-pane .inputs .text-input{border-radius:0;border:1px solid gray;padding:4px}.search-pane .inputs .text-input{margin-top:-1px;padding:4px 5px;height:26px}.search-pane .inputs .select-textarea{margin-top:-1px}.search-pane .meta-controls{padding:8px 0}.search-pane .controls{padding-top:12px}.search-pane .controls .input-group label{display:flex;flex-direction:row;align-items:center}.preview-panel{padding:0 .938rem .75rem}.preview-panel .block{border:1px solid red;min-height:.5rem}.preview-panel .preview-entity{max-width:560px;width:100%}.preview-panel .preview-entity:not(:last-child){border-right:1px solid rgba(0,0,0,.1);padding-right:.938rem;margin-right:.938rem}.preview-panel .preview-block{border-bottom:1px solid rgba(0,0,0,.0980392157);margin-top:.75rem;padding-bottom:.75rem}.preview-panel .preview-block-contents{display:grid;align-items:start;grid-template-columns:repeat(auto-fit,minmax(14rem,1fr));gap:1rem}.preview-panel .preview-block>* :not(strong){font-size:.875rem}.preview-panel .preview-block .value-group-wrapper{word-wrap:break-word}.preview-panel .preview-block .preview-value-link{font-size:.875rem}.preview-panel .value-heading{padding-bottom:.219rem}.preview-panel .sub-heading{padding-bottom:.313rem;font-size:.919rem}.positioned-second{order:2}.preview-panel-row{margin:.938rem 0;display:flex;flex-direction:row;justify-content:center}.titled-preview{padding:0}.titled-preview-header{padding:.2rem .938rem;display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid rgba(0,0,0,.1);background-color:#0000000d}.titled-preview-header-plain{padding-top:.75rem;border-bottom:none;background-color:transparent}.titled-preview-header .details{padding:.7rem}.titled-preview-header .details h5{font-size:.95rem}.titled-preview-header .details span{color:#0009}.full-display-container{width:540px;border-left:1px solid rgba(0,0,0,.1)}.full-display-container .preview-contents-container{height:100%;overflow-y:scroll;padding:.938rem 0 4rem}.full-display-container>*{flex:1}.full-display-control-panel{display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding:0 .938rem;border-bottom:1px solid rgba(0,0,0,.1);background-color:#00000008;height:2.75rem}.full-display-control-panel .close{padding:.6rem}.full-display-control-panel .info{display:flex;flex-direction:column;align-items:center}.full-display-control-panel .info .title{font-size:.875rem;font-weight:700;max-width:20rem;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.full-display-control-panel .info .type{font-size:.75rem;color:#0000009e}.full-display-controls{display:flex;flex:1;flex-direction:row;align-items:center;justify-content:end;gap:.5rem}#editor-root .pagination{display:flex;flex-direction:row;justify-content:space-around;align-items:center;width:100%;min-height:41px;border-top:1px solid rgba(0,0,0,.1);margin-bottom:.8rem}#editor-root .pagination-button{display:flex;flex-direction:row;justify-content:center;align-items:center;padding:0 1rem;border-radius:2rem}#editor-root .pagination-button svg{margin-top:1px}#editor-root .pagination-button path{fill:#000}#editor-root .pagination-button:disabled path{fill:#e0dfdf}#editor-root .pagination-count{font-weight:600}.comparison{display:flex;flex-direction:column;width:700px;border-left:1px solid rgba(0,0,0,.1)}.comparison header{display:flex;flex-direction:column}.comparison header h2{display:flex;align-items:center;gap:.2rem;font-size:.875rem;line-height:normal}.comparison header .heading,.comparison header .subheading{padding:.5rem .7rem;display:flex;flex-direction:row;justify-content:space-between;align-items:center;border-bottom:1px solid rgba(0,0,0,.1)}.comparison header .heading>*,.comparison header .subheading>*{font-size:.875rem;font-weight:700}.comparison h3{display:flex;align-items:flex-start;gap:.625rem}.comparison .comparison-index{width:18px;height:18px;text-align:center;background-color:#9fc7ea;border-radius:.125rem;font-size:12px;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:5px}.comparison-contents{display:flex;flex-grow:1;overflow:hidden}.comparison-contents .entry{width:100%;min-width:50%;overflow-x:hidden;overflow-y:scroll;flex:1;border-right:1px solid rgba(0,0,0,.1)}.comparison-contents .entry-header{display:flex;flex-direction:column;gap:.2rem;padding:.938rem}.comparison-contents .entry-header-controls{display:flex;flex-direction:row;align-items:center;justify-content:space-between}.comparison-contents .entry .preview-entity{border-right:none}.comparison-contents .titled-preview{width:100%}.comparison-contents .insufficient-resource-amt{text-align:center;display:flex;flex-direction:column;align-items:center;align-self:center;width:100%;font-size:1.138rem;color:#0000009e}.comparison-contents .insufficient-resource-amt svg{width:2.5rem}.empty-placeholder{display:flex;flex-direction:column;align-items:center;gap:1rem;font-weight:600;margin:auto}.item-search{display:flex;flex-direction:row;height:100%}.item-search *{box-sizing:border-box}.item-search-content{width:100%;flex:1;min-width:500px}.item-search-content-container{display:flex;flex-direction:column;padding:1rem 1rem 2rem;width:100%;height:100%;overflow-y:auto}.search-control-pane{display:flex;padding:0 1rem;border-bottom:1px solid #d7d8da;background-color:#00000008;height:2.75rem;align-items:center}.search-control-pane .open-ctl{height:2.125rem;width:2.125rem;padding:.5rem}.search-control-pane .open-ctl svg{height:12px;transform:rotate(90deg)}.search-control-pane-title{display:flex;flex-direction:column;flex:1;text-align:center;padding:0 1rem;overflow:hidden}.search-control-pane-mainLabel{font-size:.875rem;line-height:1.3125rem;font-weight:700;color:#000;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.search-control-pane-subLabel{font-size:.75rem;line-height:1.25rem;color:#6c6c6c}.search-control-pane-embedded .search-control-pane-mainLabel{font-size:1rem;line-height:1.5rem}.search-control-pane-embedded .search-control-pane-subLabel{font-size:.86rem;line-height:1.43rem}.table{width:100%;border-spacing:0}.table.table-with-pagination{margin-bottom:2rem}.table tbody tr:nth-child(odd):not(.row-selected),.table tbody .table-row:nth-child(odd):not(.row-selected),.table-body tr:nth-child(odd):not(.row-selected),.table-body .table-row:nth-child(odd):not(.row-selected){background-color:#00000014}.table tbody tr:nth-child(2n):not(.row-selected),.table tbody .table-row:nth-child(2n):not(.row-selected),.table-body tr:nth-child(2n):not(.row-selected),.table-body .table-row:nth-child(2n):not(.row-selected){background-color:#00000008}.table tbody .row-selected,.table-body .row-selected{background-color:#d3e4f3}.table tbody .row-selected>*,.table-body .row-selected>*{border-color:#fff}.table thead tr>td{height:0;padding:0;border:none}.table thead tr>td .table-header-contents-wrapper{height:100%;padding:0 .625rem .2rem;border-bottom:5px solid #2d62b7;box-sizing:border-box}.table th,.table .table-head-cell,.table .table-head-empty{vertical-align:bottom;text-align:left;background-color:#00000008;padding:0 .65px 0 0}.table th:last-child,.table .table-head-cell:last-child,.table .table-head-empty:last-child{padding:0}.table th .table-header-contents-wrapper,.table .table-head-cell .table-header-contents-wrapper,.table .table-head-empty .table-header-contents-wrapper{padding:0 .625rem .2rem;border-bottom:5px solid #2d62b7}.table .table-head-empty{border:none}.table td,.table-cell{padding:0 .625rem}.table tr,.table td,.table-row,.table-cell{border:1px solid rgba(0,0,0,.1);word-wrap:break-word}.table tr:first-child,.table td:first-child,.table-row:first-child,.table-cell:first-child{border-top:0;border-left:0}.table tr:last-child,.table td:last-child,.table-row:last-child,.table-cell:last-child{border-right:0}.table tr:last-child td,.table tr:last-child .table-cell,.table td:last-child td,.table td:last-child .table-cell,.table-row:last-child td,.table-row:last-child .table-cell,.table-cell:last-child td,.table-cell:last-child .table-cell{border-bottom:0}.table tr:not(:first-child) td:first-child,.table tr:not(:first-child) .table-cell:first-child,.table td:not(:first-child) td:first-child,.table td:not(:first-child) .table-cell:first-child,.table-row:not(:first-child) td:first-child,.table-row:not(:first-child) .table-cell:first-child,.table-cell:not(:first-child) td:first-child,.table-cell:not(:first-child) .table-cell:first-child{border-top:0}.table tr+td,.table tr+tr,.table tr+.table-row,.table tr+.table-cell,.table td+td,.table td+tr,.table td+.table-row,.table td+.table-cell,.table-row+td,.table-row+tr,.table-row+.table-row,.table-row+.table-cell,.table-cell+td,.table-cell+tr,.table-cell+.table-row,.table-cell+.table-cell{border-top:0;border-left:0}.table td .table-cell.column-large{width:80%}.table .clickable{cursor:pointer}.table .cell-relative-20{width:20%;min-width:20%;max-width:20%}.table .cell-relative-45{width:45%;min-width:45%;max-width:45%}.table .cell-fixed{justify-content:center}.table .cell-fixed-100{width:100px;min-width:100px;max-width:100px}.table .cell-fixed-140{width:140px;min-width:140px;max-width:140px}.table .cell-fixed-170{width:170px;min-width:170px;max-width:170px}.table .cell-fixed-250{width:250px;min-width:250px;max-width:250px}.table .cell-fixed-370{width:370px;min-width:370px;max-width:370px}.table-flex{display:flex;flex-direction:column;height:100%;max-height:100%;overflow:hidden}.table-flex .table-head{overflow:hidden}.table-flex .table-head .table-row{border-bottom:5px solid #2d62b7;background-color:#fff}.table-flex .table-head-cell{position:relative;top:5px;padding-bottom:5px;padding-right:0;border-right:1px solid white;background:transparent}.table-flex .table-head-cell:last-child{border-right:0}.table-flex .table-row{display:flex}.table-flex .table-row .table-cell{display:flex;justify-content:flex-start;padding-top:5px;padding-bottom:5px;border-bottom:none}.table-flex .table-row .table-cell-content{display:flex;align-items:center}.table-flex .table-row .table-header-contents-wrapper{height:100%;font-weight:700;border-bottom:none}.table-flex .table-body-container{flex:1;height:100%;max-width:100%;min-width:100%;overflow:auto}#editor-root .action-items__container{text-align:center}#editor-root .action-items__container .button,#editor-root .action-items__container button{display:inline-block;min-height:2.5rem;min-width:2.5rem;padding:.6rem;box-sizing:border-box;text-align:center}.marc-field{vertical-align:top}.marc-field .field-code{font-weight:700}.marc-field .field-indicators{width:30px;white-space:pre;display:flex;justify-content:center}.marc-field .field-contents{white-space:pre-wrap}.marc-preview-container{display:flex;flex-direction:column;width:100%;overflow:hidden}.marc-preview-sub-label-date{margin-left:4px}.marc-preview-content{height:100%;padding:1rem 2rem;overflow-y:auto}.marc-preview-content-title{margin-bottom:1rem;font-size:1.25rem;font-weight:600}.modal-complex-lookup{height:100%;max-height:90vh;max-width:1240px;min-width:460px;width:75vw;padding:0;display:flex;flex-direction:column;overflow:hidden}.modal-complex-lookup .modal-header.modal-complex-lookup-header{padding:1rem;border-bottom:1px solid #dedede;font-size:.875rem;text-align:center}.modal-complex-lookup .modal-header.modal-complex-lookup-header-embedded.modal-complex-lookup-header,.modal-complex-lookup .modal-header.modal-complex-lookup-header-embedded .modal-complex-lookup-title{font-size:1rem}.modal-complex-lookup .modal-header .modal-complex-lookup-title{width:100%;font-size:.875rem;font-weight:700;text-align:center}.modal-complex-lookup .search-pane-header-title{flex:1;text-align:center}.modal-complex-lookup .search-control-pane{min-height:2.75rem}.modal-complex-lookup .search-result-list{height:100%}.modal-complex-lookup .item-search-content{display:flex;flex-direction:column;height:100%;min-width:auto}.modal-complex-lookup .item-search-content-container{padding:0;overflow:hidden}.modal-complex-lookup .item-search-content .search-result-list{min-width:100%;overflow-x:auto;font-size:.875rem}.modal-complex-lookup .item-search-content .search-result-list .button{font-size:.875rem}.modal-complex-lookup .item-search-content .search-result-list .button-link{height:auto;min-height:24px;font-weight:400}.modal-complex-lookup .item-search-content .search-result-list .button-link:hover,.modal-complex-lookup .item-search-content .search-result-list .button-link:active{text-decoration:none;cursor:default}.modal-complex-lookup .item-search-content .search-result-cell-content *{height:auto;text-align:left}.modal-complex-lookup .item-search-content .search-result .button-link{height:100%}.modal-complex-lookup .item-search-content .results-list .table-head .table-row,.modal-complex-lookup .item-search-content .results-list .table-body{width:1030px}.modal-complex-lookup .item-search-content .results-list .search-results-item-title{text-align:left}.modal-complex-lookup .item-search-content .results-list .search-results-item-title:hover{cursor:pointer;text-decoration:underline}.modal-complex-lookup .item-search-content .results-list .search-results-item-missing-match{font-weight:700}.modal-complex-lookup .item-search-content .results-list .search-results-item-missing-match-query{color:#900}.modal-complex-lookup .item-search-content .table-header-contents-wrapper{text-wrap:nowrap}.modal-complex-lookup .item-search-content .table-header-contents-wrapper,.modal-complex-lookup .item-search-content td{padding:5px 10px}.modal-complex-lookup-embedded{max-height:calc(100vh - 118px)}.modal-complex-lookup-embedded .complex-lookup-search-contents .search-result-list,.modal-complex-lookup-embedded .complex-lookup-search-contents .search-pane-header-title,.modal-complex-lookup-embedded .complex-lookup-search-contents .search-control-pane-mainLabel,.modal-complex-lookup-embedded .complex-lookup-search-contents .search-result-list .button,.modal-complex-lookup-embedded .complex-lookup-search-contents .select-input{font-size:1rem}.modal-complex-lookup-embedded .complex-lookup-search-contents .select-input{padding-top:0;padding-bottom:0;line-height:1.5rem}.modal .complex-lookup-search-contents{height:100%;flex:1;overflow:hidden}.modal .complex-lookup-search-contents .search-control-pane-mainLabel{margin:0}.modal .complex-lookup-search-contents .item-search{overflow:hidden}.modal .complex-lookup-search-contents .item-search-content{max-width:100%;overflow:hidden}.modal .complex-lookup-search-contents .item-search-content-message{padding:1rem}.modal .complex-lookup-search-empty{display:flex;flex-direction:row;justify-content:center;width:100%;color:#727272}.modal .complex-lookup-search-empty svg{height:1.25rem;width:1.25rem}#editor-root .complex-lookup-search-contents .pagination{margin-bottom:0}.complex-lookup{display:flex;align-items:center;max-width:100%}.complex-lookup-value{flex:1}.complex-lookup-select-button{padding:.25rem 1rem;border:none;font-weight:700;color:#1960a4;cursor:pointer}.complex-lookup-selected{display:flex;align-items:center;margin:4px 4px 4px 0;border:1px solid rgba(0,0,0,.2);line-height:1rem;background-color:#efefef}.complex-lookup-selected-label{display:block;padding:1px 12px 2px 4px;font-size:.875rem;color:#000}.complex-lookup-selected-icon-warning{min-height:.75rem;min-width:.75rem;margin:0 8px}.complex-lookup-selected-icon-warning path{fill:#0009}.complex-lookup-selected-delete{display:flex;align-items:center;align-self:stretch;min-height:1.125rem;width:1.125rem;padding:1px 3px;border:none;border-left:1px solid #d7d8da;background-color:transparent;cursor:pointer}.complex-lookup-selected-delete:hover{background-color:#2576c333}.complex-lookup-selected-delete svg path{color:#0000009e}.complex-lookup-selected-embedded .complex-lookup-selected-label{font-size:1rem}.complex-lookup-selected-embedded .complex-lookup-selected-icon-warning{min-height:.875rem;min-width:.875rem}.complex-lookup-selected-embedded .complex-lookup-selected-delete{min-height:1.4rem;width:1.4rem}.complex-lookup-selected-select-button{text-wrap:nowrap}.complex-lookup-selected-withWarning .complex-lookup-selected-label{padding-right:0}#editor-root .duplicate-group{display:flex;gap:.313rem}#editor-root .duplicate-group.duplicate-subcomponent{margin-left:.25rem}.field-with-meta-controls-container{display:flex;align-items:center}.field-with-meta-controls-container-extended{flex-direction:column;gap:.313rem}.field-with-meta-controls-container .extended-layout-meta{display:flex;align-self:flex-start;align-items:center;width:100%}.field-with-meta-controls-container .extended-layout-meta .label{width:100%}.field-with-meta-controls-container .children-container{display:flex;align-items:center;width:100%;justify-content:space-between}.field-with-meta-controls-container .label{width:11.25rem;min-width:11.25rem;margin-right:.5rem;justify-self:flex-start;font-weight:700;font-size:.919rem}.field-with-meta-controls-container .duplicate-group{margin-left:.5rem}.edit-section{display:flex;flex-direction:column;gap:.313rem;width:100%;padding:.75rem .938rem}.edit-section .input-group{display:flex;flex-direction:column;gap:.5rem}.edit-section-field-input{width:100%}.edit-section-group{position:relative;border:1px solid #3986c5;background-color:#c5daf420;border-radius:4px;padding:.313rem .938rem .938rem;display:flex;flex-direction:column;gap:.313rem}.edit-section-group-compact{padding-top:.938rem}.edit-section-group:focus-within{box-shadow:inset 0 0 0 1px #3986c5}.edit-section-group select,.edit-section-group input{height:1.5rem;font-size:1rem}.edit-section-group select{padding:0;padding-left:.313rem}.edit-section-group .group-label{font-size:.919rem;font-weight:700}.edit-section .toggle-expansion-button{color:#2f609f;font-size:.875rem;font-weight:700;text-decoration:underline}.edit-section .group-name-container{display:flex;justify-content:space-between;margin-bottom:.25rem;align-items:center}.edit-section .back-to-top{position:fixed;bottom:1rem;right:1rem}.edit-section .entity-heading{margin-bottom:.188rem}.edit-section .entity-heading .heading{font-size:1.138rem}.edit-section-passive .edit-section-group{border-color:#0000001a;background-color:#fafafa}.instances-list{padding:.75rem .938rem}.instances-list-header{display:flex;justify-content:space-between;padding-bottom:.5rem}.instances-list h3{font-size:1.138rem}.instances-list .no-instances{font-size:1.125rem;color:#0000009e;text-align:center;padding:2.5rem 0}.instances-list table th{background-color:transparent}.instances-list table tr{padding:.5rem 0}.instances-list table .publisher,.instances-list table .publication-date{max-width:10rem}.instances-list table .title .button-link{text-decoration:underline;text-align:left;height:100%}.instances-list table .edit-ctl{width:.5rem}.instances-list table .edit-ctl .button-primary{margin:.4rem 0;font-weight:600}.instances-list table td>*{font-weight:400}.preview-container{min-width:475px;max-width:475px;border-right:1px solid rgba(0,0,0,.0980392157)}.preview-container .preview-container-header{display:flex;justify-content:space-between;align-items:center;padding-bottom:.5rem}.preview-container .preview-container-header .header{font-size:1.138rem}.preview-container.positioned-second{border-left:1px solid rgba(0,0,0,.0980392157);border-right:none}.view-marc-modal{padding:15px 15px 15px 35px;width:100%}.view-marc-modal .marc-contents{overflow-y:scroll;height:100%}.edit-page{display:flex;flex-direction:row;justify-content:space-between;overflow:hidden;height:100%}.edit-page>*:not(.view-marc-modal){overflow:auto}.work-details-card{padding:1rem .5rem 1rem 1rem;background-color:#00000008;display:flex;flex-direction:column;align-items:flex-start;gap:.125rem}.work-details-card .heading{display:flex;flex-direction:row;align-items:center;width:100%;gap:1rem}.work-details-card .heading .button-ghost{background-color:transparent}.work-details-card .heading .button-ghost:active,.work-details-card .heading .button-ghost:focus,.work-details-card .heading .button-ghost:focus-visible{outline:none;box-shadow:none}.work-details-card .heading .toggle-icon{cursor:pointer;height:1.2rem;width:1.2rem}.work-details-card .heading .icon-collapsed{transform:rotate(180deg)}.work-details-card .heading .title{font-size:.875rem;font-weight:600;color:#3d3f42;display:flex;gap:.5rem;align-items:center}.work-details-card .heading .edit-button{margin-left:auto}.work-details-card .details{margin-left:2.25rem;display:flex;flex-direction:column;gap:.25rem}.work-details-card .details .title{justify-content:flex-start;font-size:1rem;font-weight:700;text-align:left;color:#2f609f}.work-details-card .details-item{font-size:.813rem}.work-details-card .details-item span:first-child{font-weight:600;margin-right:.5rem}.search-result-entry-container{display:flex;flex-direction:column;border:1px solid rgba(0,0,0,.1)}.search-result-entry-container a{text-decoration:underline}.search-result-entry-container .instance-list{font-size:.875rem}.search-result-entry-container .instance-list tr{height:2.5rem}.search-result-entry-container .instance-list .row-select-container{display:flex;flex-direction:row;align-items:center}.search-result-entry-container .instance-list .title{width:100%;min-width:15.625rem}.search-result-entry-container .instance-list .title .title-wrapper{display:flex;align-items:center;gap:.5rem}.search-result-entry-container .instance-list .title .title-wrapper button{font-size:.875rem;font-weight:400;text-decoration:underline;text-align:left;justify-content:initial;border-radius:0;height:auto;padding:.2rem 0}.search-result-entry-container .instance-list .title .title-wrapper .comparison-index{min-width:1.125rem;height:1.125rem;text-align:center;background-color:#9fc7ea;border-radius:.125rem;line-height:1.125rem}.search-result-entry-container .instance-list .identifier{min-width:10rem;max-width:10rem}.search-result-entry-container .instance-list .publisher{min-width:12.5rem;max-width:12.5rem}.search-result-entry-container .instance-list .publication-date{min-width:7.75rem;max-width:7.75rem}.search-result-entry-container .empty-or-closed{padding:1rem 1rem 1rem 3.75rem;display:flex;gap:.5rem;align-items:center;font-size:.875rem;height:100%}.search-result-entry-container .empty-or-closed>span{display:flex;gap:.5rem;align-items:center}.search-result-entry-container .empty-or-closed a{font-size:.813rem;font-weight:600;text-decoration:none}.search-result-list{display:flex;flex-direction:column;gap:1rem;min-width:70rem}.search{height:100%}.external-resource-loader{height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center}.external-resource-loader .contents{font-weight:500;font-size:1.5rem}.duplicate-imported-resource{padding-left:0;padding-right:0}.duplicate-imported-resource>*{padding:0 1.5rem}.duplicate-imported-resource-contents{padding:.75rem 1.5rem;margin:.75rem 0;border-top:1px solid rgba(0,0,0,.1);border-bottom:1px solid rgba(0,0,0,.1)}.duplicate-imported-resource .modal-controls{justify-content:space-between}.duplicate-imported-resource .title{font-size:1rem}.duplicate-imported-resource .modal-header{justify-content:space-between}.duplicate-imported-resource .modal-header .empty-block{min-width:1.5rem}.external-resource-preview{height:100%;padding:0 .938rem}body{margin:0;padding:0}html,body,body>#editor-root,#app-root,.embed-container{height:100%}h2,h3,h4,h5,h6{margin:0}#app-root{display:flex;flex-direction:column}.main-content{flex:1;overflow:auto}.welcome-screen{padding:12px}.no-overflow{overflow:hidden}#editor-root{font-family:Inter,system-ui,Avenir,Helvetica,Arial,sans-serif;line-height:1.5;font-weight:400}#editor-root body{margin:0;display:flex;min-width:320px;min-height:100vh}#editor-root #root{width:100%}#editor-root h1{font-size:3.2em;line-height:1.1}#editor-root select:disabled,#editor-root input:disabled{background-color:#ebebe4;color:#777}#editor-root select{cursor:pointer;outline:none}#editor-root select:focus,#editor-root select:focus-visible{border:1px solid #3e75cf;box-shadow:0 0 0 1px #3e75cf,0 0 0 1px #3e75cf,0 0 0 4px #d8e3f5}#editor-root select:focus:hover,#editor-root select:focus-visible:hover{border:1px solid #3e75cf;box-shadow:0 0 0 1px #3e75cf,0 0 0 1px #3e75cf,0 0 0 4px #d8e3f5}#editor-root select:focus-visible{position:relative}#editor-root select:disabled{cursor:default}#editor-root input[type=text]:not(#creatable-select-input){cursor:text;outline:none}#editor-root input[type=text]:not(#creatable-select-input):focus,#editor-root input[type=text]:not(#creatable-select-input):focus-visible{border:1px solid #3e75cf;box-shadow:0 0 0 1px #3e75cf,0 0 0 1px #3e75cf,0 0 0 4px #d8e3f5}#editor-root input[type=text]:not(#creatable-select-input):focus:hover,#editor-root input[type=text]:not(#creatable-select-input):focus-visible:hover{border:1px solid #3e75cf;box-shadow:0 0 0 1px #3e75cf,0 0 0 1px #3e75cf,0 0 0 4px #d8e3f5}#editor-root input:disabled{margin:0;opacity:.5;cursor:not-allowed}#editor-root input[type=checkbox]{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;margin:0;font:inherit;color:currentColor;width:1em;height:1em;border:.11em solid gray;border-radius:.3em;display:grid;place-content:center;cursor:pointer}#editor-root input[type=checkbox]:focus,#editor-root input[type=checkbox]:focus-visible{outline:none;box-shadow:0 0 0 1px #fff,0 0 0 3px #3e75cf,0 0 0 6px #d8e3f5}#editor-root input[type=checkbox]:focus:active,#editor-root input[type=checkbox]:focus-visible:active{box-shadow:none}#editor-root input[type=checkbox]:disabled{color:#d3d3d3;cursor:not-allowed}#editor-root input[type=checkbox]:before{content:"";width:.65em;height:.65em;transform:scale(0);transition:.12s transform ease-in-out;box-shadow:inset 10em 10em #fff;clip-path:polygon(19% 39%,37% 58%,84% 13%,96% 26%,37% 83%,7% 52%);background-color:CanvasText}#editor-root input[type=checkbox]:checked{border-color:#000;background-color:#000}#editor-root input[type=checkbox]:checked:before{transform:scale(1)}#editor-root input[type=radio]{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;margin:0;font:inherit;color:currentColor;width:1em;height:1em;border:.11em solid gray;border-radius:50%;transform:translateY(.2em);display:grid;place-content:center;cursor:pointer}#editor-root input[type=radio]:focus,#editor-root input[type=radio]:focus-visible{outline:none;box-shadow:0 0 0 1px #fff,0 0 0 3px #3e75cf,0 0 0 6px #d8e3f5}#editor-root input[type=radio]:focus:active,#editor-root input[type=radio]:focus-visible:active{box-shadow:none}#editor-root input[type=radio]:before{content:"";width:.45em;height:.45em;border-radius:50%;transform:scale(0);transition:.12s transform ease-in-out;box-shadow:inset 10em 10em #000}#editor-root input[type=radio]:checked:before{transform:scale(1)}#editor-root input[type=radio]:disabled{color:#d3d3d3;cursor:not-allowed}#editor-root hr{border:none;border-bottom:1px solid #d7d8da;width:100%;text-align:left;margin-left:0;margin-top:12px}#editor-root label{cursor:pointer;display:flex;flex-direction:row;gap:8px;align-items:center}#editor-root .invisible-text{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}')),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
var B5 = Object.defineProperty;
var U5 = (t, r, i) => r in t ? B5(t, r, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[r] = i;
var wn = (t, r, i) => (U5(t, typeof r != "symbol" ? r + "" : r, i), i);
function q_(t, r) {
  for (var i = 0; i < r.length; i++) {
    const u = r[i];
    if (typeof u != "string" && !Array.isArray(u)) {
      for (const c in u)
        if (c !== "default" && !(c in t)) {
          const v = Object.getOwnPropertyDescriptor(u, c);
          v && Object.defineProperty(t, c, v.get ? v : {
            enumerable: !0,
            get: () => u[c]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
}
var Dy = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function KT(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var lT = { exports: {} }, My = {}, sT = { exports: {} }, tr = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var KA;
function V5() {
  if (KA)
    return tr;
  KA = 1;
  var t = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), v = Symbol.for("react.provider"), h = Symbol.for("react.context"), y = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), S = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), T = Symbol.iterator;
  function _(q) {
    return q === null || typeof q != "object" ? null : (q = T && q[T] || q["@@iterator"], typeof q == "function" ? q : null);
  }
  var L = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, M = Object.assign, U = {};
  function B(q, pe, $e) {
    this.props = q, this.context = pe, this.refs = U, this.updater = $e || L;
  }
  B.prototype.isReactComponent = {}, B.prototype.setState = function(q, pe) {
    if (typeof q != "object" && typeof q != "function" && q != null)
      throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, q, pe, "setState");
  }, B.prototype.forceUpdate = function(q) {
    this.updater.enqueueForceUpdate(this, q, "forceUpdate");
  };
  function H() {
  }
  H.prototype = B.prototype;
  function Y(q, pe, $e) {
    this.props = q, this.context = pe, this.refs = U, this.updater = $e || L;
  }
  var G = Y.prototype = new H();
  G.constructor = Y, M(G, B.prototype), G.isPureReactComponent = !0;
  var Q = Array.isArray, W = Object.prototype.hasOwnProperty, oe = { current: null }, j = { key: !0, ref: !0, __self: !0, __source: !0 };
  function re(q, pe, $e) {
    var lt, ot = {}, nt = null, Rt = null;
    if (pe != null)
      for (lt in pe.ref !== void 0 && (Rt = pe.ref), pe.key !== void 0 && (nt = "" + pe.key), pe)
        W.call(pe, lt) && !j.hasOwnProperty(lt) && (ot[lt] = pe[lt]);
    var ht = arguments.length - 2;
    if (ht === 1)
      ot.children = $e;
    else if (1 < ht) {
      for (var dt = Array(ht), sn = 0; sn < ht; sn++)
        dt[sn] = arguments[sn + 2];
      ot.children = dt;
    }
    if (q && q.defaultProps)
      for (lt in ht = q.defaultProps, ht)
        ot[lt] === void 0 && (ot[lt] = ht[lt]);
    return { $$typeof: t, type: q, key: nt, ref: Rt, props: ot, _owner: oe.current };
  }
  function me(q, pe) {
    return { $$typeof: t, type: q.type, key: pe, ref: q.ref, props: q.props, _owner: q._owner };
  }
  function Se(q) {
    return typeof q == "object" && q !== null && q.$$typeof === t;
  }
  function Ne(q) {
    var pe = { "=": "=0", ":": "=2" };
    return "$" + q.replace(/[=:]/g, function($e) {
      return pe[$e];
    });
  }
  var Ge = /\/+/g;
  function ze(q, pe) {
    return typeof q == "object" && q !== null && q.key != null ? Ne("" + q.key) : pe.toString(36);
  }
  function qe(q, pe, $e, lt, ot) {
    var nt = typeof q;
    (nt === "undefined" || nt === "boolean") && (q = null);
    var Rt = !1;
    if (q === null)
      Rt = !0;
    else
      switch (nt) {
        case "string":
        case "number":
          Rt = !0;
          break;
        case "object":
          switch (q.$$typeof) {
            case t:
            case r:
              Rt = !0;
          }
      }
    if (Rt)
      return Rt = q, ot = ot(Rt), q = lt === "" ? "." + ze(Rt, 0) : lt, Q(ot) ? ($e = "", q != null && ($e = q.replace(Ge, "$&/") + "/"), qe(ot, pe, $e, "", function(sn) {
        return sn;
      })) : ot != null && (Se(ot) && (ot = me(ot, $e + (!ot.key || Rt && Rt.key === ot.key ? "" : ("" + ot.key).replace(Ge, "$&/") + "/") + q)), pe.push(ot)), 1;
    if (Rt = 0, lt = lt === "" ? "." : lt + ":", Q(q))
      for (var ht = 0; ht < q.length; ht++) {
        nt = q[ht];
        var dt = lt + ze(nt, ht);
        Rt += qe(nt, pe, $e, dt, ot);
      }
    else if (dt = _(q), typeof dt == "function")
      for (q = dt.call(q), ht = 0; !(nt = q.next()).done; )
        nt = nt.value, dt = lt + ze(nt, ht++), Rt += qe(nt, pe, $e, dt, ot);
    else if (nt === "object")
      throw pe = String(q), Error("Objects are not valid as a React child (found: " + (pe === "[object Object]" ? "object with keys {" + Object.keys(q).join(", ") + "}" : pe) + "). If you meant to render a collection of children, use an array instead.");
    return Rt;
  }
  function at(q, pe, $e) {
    if (q == null)
      return q;
    var lt = [], ot = 0;
    return qe(q, lt, "", "", function(nt) {
      return pe.call($e, nt, ot++);
    }), lt;
  }
  function st(q) {
    if (q._status === -1) {
      var pe = q._result;
      pe = pe(), pe.then(function($e) {
        (q._status === 0 || q._status === -1) && (q._status = 1, q._result = $e);
      }, function($e) {
        (q._status === 0 || q._status === -1) && (q._status = 2, q._result = $e);
      }), q._status === -1 && (q._status = 0, q._result = pe);
    }
    if (q._status === 1)
      return q._result.default;
    throw q._result;
  }
  var We = { current: null }, he = { transition: null }, ke = { ReactCurrentDispatcher: We, ReactCurrentBatchConfig: he, ReactCurrentOwner: oe };
  function _e() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return tr.Children = { map: at, forEach: function(q, pe, $e) {
    at(q, function() {
      pe.apply(this, arguments);
    }, $e);
  }, count: function(q) {
    var pe = 0;
    return at(q, function() {
      pe++;
    }), pe;
  }, toArray: function(q) {
    return at(q, function(pe) {
      return pe;
    }) || [];
  }, only: function(q) {
    if (!Se(q))
      throw Error("React.Children.only expected to receive a single React element child.");
    return q;
  } }, tr.Component = B, tr.Fragment = i, tr.Profiler = c, tr.PureComponent = Y, tr.StrictMode = u, tr.Suspense = g, tr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ke, tr.act = _e, tr.cloneElement = function(q, pe, $e) {
    if (q == null)
      throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + q + ".");
    var lt = M({}, q.props), ot = q.key, nt = q.ref, Rt = q._owner;
    if (pe != null) {
      if (pe.ref !== void 0 && (nt = pe.ref, Rt = oe.current), pe.key !== void 0 && (ot = "" + pe.key), q.type && q.type.defaultProps)
        var ht = q.type.defaultProps;
      for (dt in pe)
        W.call(pe, dt) && !j.hasOwnProperty(dt) && (lt[dt] = pe[dt] === void 0 && ht !== void 0 ? ht[dt] : pe[dt]);
    }
    var dt = arguments.length - 2;
    if (dt === 1)
      lt.children = $e;
    else if (1 < dt) {
      ht = Array(dt);
      for (var sn = 0; sn < dt; sn++)
        ht[sn] = arguments[sn + 2];
      lt.children = ht;
    }
    return { $$typeof: t, type: q.type, key: ot, ref: nt, props: lt, _owner: Rt };
  }, tr.createContext = function(q) {
    return q = { $$typeof: h, _currentValue: q, _currentValue2: q, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, q.Provider = { $$typeof: v, _context: q }, q.Consumer = q;
  }, tr.createElement = re, tr.createFactory = function(q) {
    var pe = re.bind(null, q);
    return pe.type = q, pe;
  }, tr.createRef = function() {
    return { current: null };
  }, tr.forwardRef = function(q) {
    return { $$typeof: y, render: q };
  }, tr.isValidElement = Se, tr.lazy = function(q) {
    return { $$typeof: x, _payload: { _status: -1, _result: q }, _init: st };
  }, tr.memo = function(q, pe) {
    return { $$typeof: S, type: q, compare: pe === void 0 ? null : pe };
  }, tr.startTransition = function(q) {
    var pe = he.transition;
    he.transition = {};
    try {
      q();
    } finally {
      he.transition = pe;
    }
  }, tr.unstable_act = _e, tr.useCallback = function(q, pe) {
    return We.current.useCallback(q, pe);
  }, tr.useContext = function(q) {
    return We.current.useContext(q);
  }, tr.useDebugValue = function() {
  }, tr.useDeferredValue = function(q) {
    return We.current.useDeferredValue(q);
  }, tr.useEffect = function(q, pe) {
    return We.current.useEffect(q, pe);
  }, tr.useId = function() {
    return We.current.useId();
  }, tr.useImperativeHandle = function(q, pe, $e) {
    return We.current.useImperativeHandle(q, pe, $e);
  }, tr.useInsertionEffect = function(q, pe) {
    return We.current.useInsertionEffect(q, pe);
  }, tr.useLayoutEffect = function(q, pe) {
    return We.current.useLayoutEffect(q, pe);
  }, tr.useMemo = function(q, pe) {
    return We.current.useMemo(q, pe);
  }, tr.useReducer = function(q, pe, $e) {
    return We.current.useReducer(q, pe, $e);
  }, tr.useRef = function(q) {
    return We.current.useRef(q);
  }, tr.useState = function(q) {
    return We.current.useState(q);
  }, tr.useSyncExternalStore = function(q, pe, $e) {
    return We.current.useSyncExternalStore(q, pe, $e);
  }, tr.useTransition = function() {
    return We.current.useTransition();
  }, tr.version = "18.3.1", tr;
}
var jy = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
jy.exports;
var qA;
function H5() {
  return qA || (qA = 1, function(t, r) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var i = "18.3.1", u = Symbol.for("react.element"), c = Symbol.for("react.portal"), v = Symbol.for("react.fragment"), h = Symbol.for("react.strict_mode"), y = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), S = Symbol.for("react.context"), x = Symbol.for("react.forward_ref"), T = Symbol.for("react.suspense"), _ = Symbol.for("react.suspense_list"), L = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), U = Symbol.for("react.offscreen"), B = Symbol.iterator, H = "@@iterator";
      function Y(P) {
        if (P === null || typeof P != "object")
          return null;
        var te = B && P[B] || P[H];
        return typeof te == "function" ? te : null;
      }
      var G = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, Q = {
        transition: null
      }, W = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, oe = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, j = {}, re = null;
      function me(P) {
        re = P;
      }
      j.setExtraStackFrame = function(P) {
        re = P;
      }, j.getCurrentStack = null, j.getStackAddendum = function() {
        var P = "";
        re && (P += re);
        var te = j.getCurrentStack;
        return te && (P += te() || ""), P;
      };
      var Se = !1, Ne = !1, Ge = !1, ze = !1, qe = !1, at = {
        ReactCurrentDispatcher: G,
        ReactCurrentBatchConfig: Q,
        ReactCurrentOwner: oe
      };
      at.ReactDebugCurrentFrame = j, at.ReactCurrentActQueue = W;
      function st(P) {
        {
          for (var te = arguments.length, Te = new Array(te > 1 ? te - 1 : 0), Oe = 1; Oe < te; Oe++)
            Te[Oe - 1] = arguments[Oe];
          he("warn", P, Te);
        }
      }
      function We(P) {
        {
          for (var te = arguments.length, Te = new Array(te > 1 ? te - 1 : 0), Oe = 1; Oe < te; Oe++)
            Te[Oe - 1] = arguments[Oe];
          he("error", P, Te);
        }
      }
      function he(P, te, Te) {
        {
          var Oe = at.ReactDebugCurrentFrame, Je = Oe.getStackAddendum();
          Je !== "" && (te += "%s", Te = Te.concat([Je]));
          var Xt = Te.map(function(pt) {
            return String(pt);
          });
          Xt.unshift("Warning: " + te), Function.prototype.apply.call(console[P], console, Xt);
        }
      }
      var ke = {};
      function _e(P, te) {
        {
          var Te = P.constructor, Oe = Te && (Te.displayName || Te.name) || "ReactClass", Je = Oe + "." + te;
          if (ke[Je])
            return;
          We("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", te, Oe), ke[Je] = !0;
        }
      }
      var q = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(P) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(P, te, Te) {
          _e(P, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(P, te, Te, Oe) {
          _e(P, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(P, te, Te, Oe) {
          _e(P, "setState");
        }
      }, pe = Object.assign, $e = {};
      Object.freeze($e);
      function lt(P, te, Te) {
        this.props = P, this.context = te, this.refs = $e, this.updater = Te || q;
      }
      lt.prototype.isReactComponent = {}, lt.prototype.setState = function(P, te) {
        if (typeof P != "object" && typeof P != "function" && P != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, P, te, "setState");
      }, lt.prototype.forceUpdate = function(P) {
        this.updater.enqueueForceUpdate(this, P, "forceUpdate");
      };
      {
        var ot = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, nt = function(P, te) {
          Object.defineProperty(lt.prototype, P, {
            get: function() {
              st("%s(...) is deprecated in plain JavaScript React classes. %s", te[0], te[1]);
            }
          });
        };
        for (var Rt in ot)
          ot.hasOwnProperty(Rt) && nt(Rt, ot[Rt]);
      }
      function ht() {
      }
      ht.prototype = lt.prototype;
      function dt(P, te, Te) {
        this.props = P, this.context = te, this.refs = $e, this.updater = Te || q;
      }
      var sn = dt.prototype = new ht();
      sn.constructor = dt, pe(sn, lt.prototype), sn.isPureReactComponent = !0;
      function bn() {
        var P = {
          current: null
        };
        return Object.seal(P), P;
      }
      var Ze = Array.isArray;
      function mn(P) {
        return Ze(P);
      }
      function fn(P) {
        {
          var te = typeof Symbol == "function" && Symbol.toStringTag, Te = te && P[Symbol.toStringTag] || P.constructor.name || "Object";
          return Te;
        }
      }
      function Gn(P) {
        try {
          return ar(P), !1;
        } catch {
          return !0;
        }
      }
      function ar(P) {
        return "" + P;
      }
      function Jn(P) {
        if (Gn(P))
          return We("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", fn(P)), ar(P);
      }
      function Ha(P, te, Te) {
        var Oe = P.displayName;
        if (Oe)
          return Oe;
        var Je = te.displayName || te.name || "";
        return Je !== "" ? Te + "(" + Je + ")" : Te;
      }
      function ja(P) {
        return P.displayName || "Context";
      }
      function qr(P) {
        if (P == null)
          return null;
        if (typeof P.tag == "number" && We("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof P == "function")
          return P.displayName || P.name || null;
        if (typeof P == "string")
          return P;
        switch (P) {
          case v:
            return "Fragment";
          case c:
            return "Portal";
          case y:
            return "Profiler";
          case h:
            return "StrictMode";
          case T:
            return "Suspense";
          case _:
            return "SuspenseList";
        }
        if (typeof P == "object")
          switch (P.$$typeof) {
            case S:
              var te = P;
              return ja(te) + ".Consumer";
            case g:
              var Te = P;
              return ja(Te._context) + ".Provider";
            case x:
              return Ha(P, P.render, "ForwardRef");
            case L:
              var Oe = P.displayName || null;
              return Oe !== null ? Oe : qr(P.type) || "Memo";
            case M: {
              var Je = P, Xt = Je._payload, pt = Je._init;
              try {
                return qr(pt(Xt));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var wr = Object.prototype.hasOwnProperty, Da = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Sa, xa, Or;
      Or = {};
      function fi(P) {
        if (wr.call(P, "ref")) {
          var te = Object.getOwnPropertyDescriptor(P, "ref").get;
          if (te && te.isReactWarning)
            return !1;
        }
        return P.ref !== void 0;
      }
      function pr(P) {
        if (wr.call(P, "key")) {
          var te = Object.getOwnPropertyDescriptor(P, "key").get;
          if (te && te.isReactWarning)
            return !1;
        }
        return P.key !== void 0;
      }
      function xr(P, te) {
        var Te = function() {
          Sa || (Sa = !0, We("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", te));
        };
        Te.isReactWarning = !0, Object.defineProperty(P, "key", {
          get: Te,
          configurable: !0
        });
      }
      function ca(P, te) {
        var Te = function() {
          xa || (xa = !0, We("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", te));
        };
        Te.isReactWarning = !0, Object.defineProperty(P, "ref", {
          get: Te,
          configurable: !0
        });
      }
      function Ka(P) {
        if (typeof P.ref == "string" && oe.current && P.__self && oe.current.stateNode !== P.__self) {
          var te = qr(oe.current.type);
          Or[te] || (We('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', te, P.ref), Or[te] = !0);
        }
      }
      var it = function(P, te, Te, Oe, Je, Xt, pt) {
        var Wt = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: u,
          // Built-in properties that belong on the element
          type: P,
          key: te,
          ref: Te,
          props: pt,
          // Record the component responsible for creating this element.
          _owner: Xt
        };
        return Wt._store = {}, Object.defineProperty(Wt._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Wt, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Oe
        }), Object.defineProperty(Wt, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Je
        }), Object.freeze && (Object.freeze(Wt.props), Object.freeze(Wt)), Wt;
      };
      function kt(P, te, Te) {
        var Oe, Je = {}, Xt = null, pt = null, Wt = null, Nn = null;
        if (te != null) {
          fi(te) && (pt = te.ref, Ka(te)), pr(te) && (Jn(te.key), Xt = "" + te.key), Wt = te.__self === void 0 ? null : te.__self, Nn = te.__source === void 0 ? null : te.__source;
          for (Oe in te)
            wr.call(te, Oe) && !Da.hasOwnProperty(Oe) && (Je[Oe] = te[Oe]);
        }
        var Yn = arguments.length - 2;
        if (Yn === 1)
          Je.children = Te;
        else if (Yn > 1) {
          for (var Ir = Array(Yn), xn = 0; xn < Yn; xn++)
            Ir[xn] = arguments[xn + 2];
          Object.freeze && Object.freeze(Ir), Je.children = Ir;
        }
        if (P && P.defaultProps) {
          var Mr = P.defaultProps;
          for (Oe in Mr)
            Je[Oe] === void 0 && (Je[Oe] = Mr[Oe]);
        }
        if (Xt || pt) {
          var Pn = typeof P == "function" ? P.displayName || P.name || "Unknown" : P;
          Xt && xr(Je, Pn), pt && ca(Je, Pn);
        }
        return it(P, Xt, pt, Wt, Nn, oe.current, Je);
      }
      function $t(P, te) {
        var Te = it(P.type, te, P.ref, P._self, P._source, P._owner, P.props);
        return Te;
      }
      function Fn(P, te, Te) {
        if (P == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + P + ".");
        var Oe, Je = pe({}, P.props), Xt = P.key, pt = P.ref, Wt = P._self, Nn = P._source, Yn = P._owner;
        if (te != null) {
          fi(te) && (pt = te.ref, Yn = oe.current), pr(te) && (Jn(te.key), Xt = "" + te.key);
          var Ir;
          P.type && P.type.defaultProps && (Ir = P.type.defaultProps);
          for (Oe in te)
            wr.call(te, Oe) && !Da.hasOwnProperty(Oe) && (te[Oe] === void 0 && Ir !== void 0 ? Je[Oe] = Ir[Oe] : Je[Oe] = te[Oe]);
        }
        var xn = arguments.length - 2;
        if (xn === 1)
          Je.children = Te;
        else if (xn > 1) {
          for (var Mr = Array(xn), Pn = 0; Pn < xn; Pn++)
            Mr[Pn] = arguments[Pn + 2];
          Je.children = Mr;
        }
        return it(P.type, Xt, pt, Wt, Nn, Yn, Je);
      }
      function zn(P) {
        return typeof P == "object" && P !== null && P.$$typeof === u;
      }
      var Ur = ".", Lr = ":";
      function Ga(P) {
        var te = /[=:]/g, Te = {
          "=": "=0",
          ":": "=2"
        }, Oe = P.replace(te, function(Je) {
          return Te[Je];
        });
        return "$" + Oe;
      }
      var Qn = !1, qa = /\/+/g;
      function Wn(P) {
        return P.replace(qa, "$&/");
      }
      function Xn(P, te) {
        return typeof P == "object" && P !== null && P.key != null ? (Jn(P.key), Ga("" + P.key)) : te.toString(36);
      }
      function So(P, te, Te, Oe, Je) {
        var Xt = typeof P;
        (Xt === "undefined" || Xt === "boolean") && (P = null);
        var pt = !1;
        if (P === null)
          pt = !0;
        else
          switch (Xt) {
            case "string":
            case "number":
              pt = !0;
              break;
            case "object":
              switch (P.$$typeof) {
                case u:
                case c:
                  pt = !0;
              }
          }
        if (pt) {
          var Wt = P, Nn = Je(Wt), Yn = Oe === "" ? Ur + Xn(Wt, 0) : Oe;
          if (mn(Nn)) {
            var Ir = "";
            Yn != null && (Ir = Wn(Yn) + "/"), So(Nn, te, Ir, "", function(ev) {
              return ev;
            });
          } else
            Nn != null && (zn(Nn) && (Nn.key && (!Wt || Wt.key !== Nn.key) && Jn(Nn.key), Nn = $t(
              Nn,
              // Keep both the (mapped) and old keys if they differ, just as
              // traverseAllChildren used to do for objects as children
              Te + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
              (Nn.key && (!Wt || Wt.key !== Nn.key) ? (
                // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
                // eslint-disable-next-line react-internal/safe-string-coercion
                Wn("" + Nn.key) + "/"
              ) : "") + Yn
            )), te.push(Nn));
          return 1;
        }
        var xn, Mr, Pn = 0, Hn = Oe === "" ? Ur : Oe + Lr;
        if (mn(P))
          for (var Zl = 0; Zl < P.length; Zl++)
            xn = P[Zl], Mr = Hn + Xn(xn, Zl), Pn += So(xn, te, Te, Mr, Je);
        else {
          var Ro = Y(P);
          if (typeof Ro == "function") {
            var uu = P;
            Ro === uu.entries && (Qn || st("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Qn = !0);
            for (var vd = Ro.call(uu), qn, Jo = 0; !(qn = vd.next()).done; )
              xn = qn.value, Mr = Hn + Xn(xn, Jo++), Pn += So(xn, te, Te, Mr, Je);
          } else if (Xt === "object") {
            var lc = String(P);
            throw new Error("Objects are not valid as a React child (found: " + (lc === "[object Object]" ? "object with keys {" + Object.keys(P).join(", ") + "}" : lc) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return Pn;
      }
      function Pi(P, te, Te) {
        if (P == null)
          return P;
        var Oe = [], Je = 0;
        return So(P, Oe, "", "", function(Xt) {
          return te.call(Te, Xt, Je++);
        }), Oe;
      }
      function Wl(P) {
        var te = 0;
        return Pi(P, function() {
          te++;
        }), te;
      }
      function Xl(P, te, Te) {
        Pi(P, function() {
          te.apply(this, arguments);
        }, Te);
      }
      function Xo(P) {
        return Pi(P, function(te) {
          return te;
        }) || [];
      }
      function ao(P) {
        if (!zn(P))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return P;
      }
      function Yl(P) {
        var te = {
          $$typeof: S,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: P,
          _currentValue2: P,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        te.Provider = {
          $$typeof: g,
          _context: te
        };
        var Te = !1, Oe = !1, Je = !1;
        {
          var Xt = {
            $$typeof: S,
            _context: te
          };
          Object.defineProperties(Xt, {
            Provider: {
              get: function() {
                return Oe || (Oe = !0, We("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), te.Provider;
              },
              set: function(pt) {
                te.Provider = pt;
              }
            },
            _currentValue: {
              get: function() {
                return te._currentValue;
              },
              set: function(pt) {
                te._currentValue = pt;
              }
            },
            _currentValue2: {
              get: function() {
                return te._currentValue2;
              },
              set: function(pt) {
                te._currentValue2 = pt;
              }
            },
            _threadCount: {
              get: function() {
                return te._threadCount;
              },
              set: function(pt) {
                te._threadCount = pt;
              }
            },
            Consumer: {
              get: function() {
                return Te || (Te = !0, We("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), te.Consumer;
              }
            },
            displayName: {
              get: function() {
                return te.displayName;
              },
              set: function(pt) {
                Je || (st("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", pt), Je = !0);
              }
            }
          }), te.Consumer = Xt;
        }
        return te._currentRenderer = null, te._currentRenderer2 = null, te;
      }
      var ki = -1, ne = 0, ce = 1, xe = 2;
      function Ue(P) {
        if (P._status === ki) {
          var te = P._result, Te = te();
          if (Te.then(function(Xt) {
            if (P._status === ne || P._status === ki) {
              var pt = P;
              pt._status = ce, pt._result = Xt;
            }
          }, function(Xt) {
            if (P._status === ne || P._status === ki) {
              var pt = P;
              pt._status = xe, pt._result = Xt;
            }
          }), P._status === ki) {
            var Oe = P;
            Oe._status = ne, Oe._result = Te;
          }
        }
        if (P._status === ce) {
          var Je = P._result;
          return Je === void 0 && We(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, Je), "default" in Je || We(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, Je), Je.default;
        } else
          throw P._result;
      }
      function rt(P) {
        var te = {
          // We use these fields to store the result.
          _status: ki,
          _result: P
        }, Te = {
          $$typeof: M,
          _payload: te,
          _init: Ue
        };
        {
          var Oe, Je;
          Object.defineProperties(Te, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return Oe;
              },
              set: function(Xt) {
                We("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Oe = Xt, Object.defineProperty(Te, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return Je;
              },
              set: function(Xt) {
                We("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Je = Xt, Object.defineProperty(Te, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return Te;
      }
      function _t(P) {
        P != null && P.$$typeof === L ? We("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof P != "function" ? We("forwardRef requires a render function but was given %s.", P === null ? "null" : typeof P) : P.length !== 0 && P.length !== 2 && We("forwardRef render functions accept exactly two parameters: props and ref. %s", P.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), P != null && (P.defaultProps != null || P.propTypes != null) && We("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var te = {
          $$typeof: x,
          render: P
        };
        {
          var Te;
          Object.defineProperty(te, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return Te;
            },
            set: function(Oe) {
              Te = Oe, !P.name && !P.displayName && (P.displayName = Oe);
            }
          });
        }
        return te;
      }
      var Vt;
      Vt = Symbol.for("react.module.reference");
      function J(P) {
        return !!(typeof P == "string" || typeof P == "function" || P === v || P === y || qe || P === h || P === T || P === _ || ze || P === U || Se || Ne || Ge || typeof P == "object" && P !== null && (P.$$typeof === M || P.$$typeof === L || P.$$typeof === g || P.$$typeof === S || P.$$typeof === x || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        P.$$typeof === Vt || P.getModuleId !== void 0));
      }
      function ve(P, te) {
        J(P) || We("memo: The first argument must be a component. Instead received: %s", P === null ? "null" : typeof P);
        var Te = {
          $$typeof: L,
          type: P,
          compare: te === void 0 ? null : te
        };
        {
          var Oe;
          Object.defineProperty(Te, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return Oe;
            },
            set: function(Je) {
              Oe = Je, !P.name && !P.displayName && (P.displayName = Je);
            }
          });
        }
        return Te;
      }
      function be() {
        var P = G.current;
        return P === null && We(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), P;
      }
      function Fe(P) {
        var te = be();
        if (P._context !== void 0) {
          var Te = P._context;
          Te.Consumer === P ? We("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : Te.Provider === P && We("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return te.useContext(P);
      }
      function ut(P) {
        var te = be();
        return te.useState(P);
      }
      function bt(P, te, Te) {
        var Oe = be();
        return Oe.useReducer(P, te, Te);
      }
      function Et(P) {
        var te = be();
        return te.useRef(P);
      }
      function Tt(P, te) {
        var Te = be();
        return Te.useEffect(P, te);
      }
      function Zt(P, te) {
        var Te = be();
        return Te.useInsertionEffect(P, te);
      }
      function nn(P, te) {
        var Te = be();
        return Te.useLayoutEffect(P, te);
      }
      function sr(P, te) {
        var Te = be();
        return Te.useCallback(P, te);
      }
      function Wr(P, te) {
        var Te = be();
        return Te.useMemo(P, te);
      }
      function Ma(P, te, Te) {
        var Oe = be();
        return Oe.useImperativeHandle(P, te, Te);
      }
      function hn(P, te) {
        {
          var Te = be();
          return Te.useDebugValue(P, te);
        }
      }
      function fa() {
        var P = be();
        return P.useTransition();
      }
      function Ra(P) {
        var te = be();
        return te.useDeferredValue(P);
      }
      function on() {
        var P = be();
        return P.useId();
      }
      function ei(P, te, Te) {
        var Oe = be();
        return Oe.useSyncExternalStore(P, te, Te);
      }
      var io = 0, An, hr, Ta, xl, Bn, xo, Ss;
      function ec() {
      }
      ec.__reactDisabledLog = !0;
      function eu() {
        {
          if (io === 0) {
            An = console.log, hr = console.info, Ta = console.warn, xl = console.error, Bn = console.group, xo = console.groupCollapsed, Ss = console.groupEnd;
            var P = {
              configurable: !0,
              enumerable: !0,
              value: ec,
              writable: !0
            };
            Object.defineProperties(console, {
              info: P,
              log: P,
              warn: P,
              error: P,
              group: P,
              groupCollapsed: P,
              groupEnd: P
            });
          }
          io++;
        }
      }
      function tu() {
        {
          if (io--, io === 0) {
            var P = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: pe({}, P, {
                value: An
              }),
              info: pe({}, P, {
                value: hr
              }),
              warn: pe({}, P, {
                value: Ta
              }),
              error: pe({}, P, {
                value: xl
              }),
              group: pe({}, P, {
                value: Bn
              }),
              groupCollapsed: pe({}, P, {
                value: xo
              }),
              groupEnd: pe({}, P, {
                value: Ss
              })
            });
          }
          io < 0 && We("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Yo = at.ReactCurrentDispatcher, ti;
      function xs(P, te, Te) {
        {
          if (ti === void 0)
            try {
              throw Error();
            } catch (Je) {
              var Oe = Je.stack.trim().match(/\n( *(at )?)/);
              ti = Oe && Oe[1] || "";
            }
          return `
` + ti + P;
        }
      }
      var nu = !1, Rs;
      {
        var tc = typeof WeakMap == "function" ? WeakMap : Map;
        Rs = new tc();
      }
      function ru(P, te) {
        if (!P || nu)
          return "";
        {
          var Te = Rs.get(P);
          if (Te !== void 0)
            return Te;
        }
        var Oe;
        nu = !0;
        var Je = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Xt;
        Xt = Yo.current, Yo.current = null, eu();
        try {
          if (te) {
            var pt = function() {
              throw Error();
            };
            if (Object.defineProperty(pt.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(pt, []);
              } catch (Hn) {
                Oe = Hn;
              }
              Reflect.construct(P, [], pt);
            } else {
              try {
                pt.call();
              } catch (Hn) {
                Oe = Hn;
              }
              P.call(pt.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Hn) {
              Oe = Hn;
            }
            P();
          }
        } catch (Hn) {
          if (Hn && Oe && typeof Hn.stack == "string") {
            for (var Wt = Hn.stack.split(`
`), Nn = Oe.stack.split(`
`), Yn = Wt.length - 1, Ir = Nn.length - 1; Yn >= 1 && Ir >= 0 && Wt[Yn] !== Nn[Ir]; )
              Ir--;
            for (; Yn >= 1 && Ir >= 0; Yn--, Ir--)
              if (Wt[Yn] !== Nn[Ir]) {
                if (Yn !== 1 || Ir !== 1)
                  do
                    if (Yn--, Ir--, Ir < 0 || Wt[Yn] !== Nn[Ir]) {
                      var xn = `
` + Wt[Yn].replace(" at new ", " at ");
                      return P.displayName && xn.includes("<anonymous>") && (xn = xn.replace("<anonymous>", P.displayName)), typeof P == "function" && Rs.set(P, xn), xn;
                    }
                  while (Yn >= 1 && Ir >= 0);
                break;
              }
          }
        } finally {
          nu = !1, Yo.current = Xt, tu(), Error.prepareStackTrace = Je;
        }
        var Mr = P ? P.displayName || P.name : "", Pn = Mr ? xs(Mr) : "";
        return typeof P == "function" && Rs.set(P, Pn), Pn;
      }
      function Ts(P, te, Te) {
        return ru(P, !1);
      }
      function wp(P) {
        var te = P.prototype;
        return !!(te && te.isReactComponent);
      }
      function $o(P, te, Te) {
        if (P == null)
          return "";
        if (typeof P == "function")
          return ru(P, wp(P));
        if (typeof P == "string")
          return xs(P);
        switch (P) {
          case T:
            return xs("Suspense");
          case _:
            return xs("SuspenseList");
        }
        if (typeof P == "object")
          switch (P.$$typeof) {
            case x:
              return Ts(P.render);
            case L:
              return $o(P.type, te, Te);
            case M: {
              var Oe = P, Je = Oe._payload, Xt = Oe._init;
              try {
                return $o(Xt(Je), te, Te);
              } catch {
              }
            }
          }
        return "";
      }
      var Kn = {}, Rl = at.ReactDebugCurrentFrame;
      function au(P) {
        if (P) {
          var te = P._owner, Te = $o(P.type, P._source, te ? te.type : null);
          Rl.setExtraStackFrame(Te);
        } else
          Rl.setExtraStackFrame(null);
      }
      function nc(P, te, Te, Oe, Je) {
        {
          var Xt = Function.call.bind(wr);
          for (var pt in P)
            if (Xt(P, pt)) {
              var Wt = void 0;
              try {
                if (typeof P[pt] != "function") {
                  var Nn = Error((Oe || "React class") + ": " + Te + " type `" + pt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof P[pt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Nn.name = "Invariant Violation", Nn;
                }
                Wt = P[pt](te, pt, Oe, Te, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Yn) {
                Wt = Yn;
              }
              Wt && !(Wt instanceof Error) && (au(Je), We("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Oe || "React class", Te, pt, typeof Wt), au(null)), Wt instanceof Error && !(Wt.message in Kn) && (Kn[Wt.message] = !0, au(Je), We("Failed %s type: %s", Te, Wt.message), au(null));
            }
        }
      }
      function Un(P) {
        if (P) {
          var te = P._owner, Te = $o(P.type, P._source, te ? te.type : null);
          me(Te);
        } else
          me(null);
      }
      var rc;
      rc = !1;
      function ac() {
        if (oe.current) {
          var P = qr(oe.current.type);
          if (P)
            return `

Check the render method of \`` + P + "`.";
        }
        return "";
      }
      function dn(P) {
        if (P !== void 0) {
          var te = P.fileName.replace(/^.*[\\\/]/, ""), Te = P.lineNumber;
          return `

Check your code at ` + te + ":" + Te + ".";
        }
        return "";
      }
      function iu(P) {
        return P != null ? dn(P.__source) : "";
      }
      var ra = {};
      function oo(P) {
        var te = ac();
        if (!te) {
          var Te = typeof P == "string" ? P : P.displayName || P.name;
          Te && (te = `

Check the top-level render call using <` + Te + ">.");
        }
        return te;
      }
      function Fi(P, te) {
        if (!(!P._store || P._store.validated || P.key != null)) {
          P._store.validated = !0;
          var Te = oo(te);
          if (!ra[Te]) {
            ra[Te] = !0;
            var Oe = "";
            P && P._owner && P._owner !== oe.current && (Oe = " It was passed a child from " + qr(P._owner.type) + "."), Un(P), We('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Te, Oe), Un(null);
          }
        }
      }
      function ws(P, te) {
        if (typeof P == "object") {
          if (mn(P))
            for (var Te = 0; Te < P.length; Te++) {
              var Oe = P[Te];
              zn(Oe) && Fi(Oe, te);
            }
          else if (zn(P))
            P._store && (P._store.validated = !0);
          else if (P) {
            var Je = Y(P);
            if (typeof Je == "function" && Je !== P.entries)
              for (var Xt = Je.call(P), pt; !(pt = Xt.next()).done; )
                zn(pt.value) && Fi(pt.value, te);
          }
        }
      }
      function da(P) {
        {
          var te = P.type;
          if (te == null || typeof te == "string")
            return;
          var Te;
          if (typeof te == "function")
            Te = te.propTypes;
          else if (typeof te == "object" && (te.$$typeof === x || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          te.$$typeof === L))
            Te = te.propTypes;
          else
            return;
          if (Te) {
            var Oe = qr(te);
            nc(Te, P.props, "prop", Oe, P);
          } else if (te.PropTypes !== void 0 && !rc) {
            rc = !0;
            var Je = qr(te);
            We("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Je || "Unknown");
          }
          typeof te.getDefaultProps == "function" && !te.getDefaultProps.isReactClassApproved && We("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function gr(P) {
        {
          for (var te = Object.keys(P.props), Te = 0; Te < te.length; Te++) {
            var Oe = te[Te];
            if (Oe !== "children" && Oe !== "key") {
              Un(P), We("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Oe), Un(null);
              break;
            }
          }
          P.ref !== null && (Un(P), We("Invalid attribute `ref` supplied to `React.Fragment`."), Un(null));
        }
      }
      function Ip(P, te, Te) {
        var Oe = J(P);
        if (!Oe) {
          var Je = "";
          (P === void 0 || typeof P == "object" && P !== null && Object.keys(P).length === 0) && (Je += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Xt = iu(te);
          Xt ? Je += Xt : Je += ac();
          var pt;
          P === null ? pt = "null" : mn(P) ? pt = "array" : P !== void 0 && P.$$typeof === u ? (pt = "<" + (qr(P.type) || "Unknown") + " />", Je = " Did you accidentally export a JSX literal instead of a component?") : pt = typeof P, We("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", pt, Je);
        }
        var Wt = kt.apply(this, arguments);
        if (Wt == null)
          return Wt;
        if (Oe)
          for (var Nn = 2; Nn < arguments.length; Nn++)
            ws(arguments[Nn], P);
        return P === v ? gr(Wt) : da(Wt), Wt;
      }
      var lo = !1;
      function Pa(P) {
        var te = Ip.bind(null, P);
        return te.type = P, lo || (lo = !0, st("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(te, "type", {
          enumerable: !1,
          get: function() {
            return st("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: P
            }), P;
          }
        }), te;
      }
      function $l(P, te, Te) {
        for (var Oe = Fn.apply(this, arguments), Je = 2; Je < arguments.length; Je++)
          ws(arguments[Je], Oe.type);
        return da(Oe), Oe;
      }
      function Ap(P, te) {
        var Te = Q.transition;
        Q.transition = {};
        var Oe = Q.transition;
        Q.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          P();
        } finally {
          if (Q.transition = Te, Te === null && Oe._updatedFibers) {
            var Je = Oe._updatedFibers.size;
            Je > 10 && st("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), Oe._updatedFibers.clear();
          }
        }
      }
      var Is = !1, ou = null;
      function Np(P) {
        if (ou === null)
          try {
            var te = ("require" + Math.random()).slice(0, 7), Te = t && t[te];
            ou = Te.call(t, "timers").setImmediate;
          } catch {
            ou = function(Je) {
              Is === !1 && (Is = !0, typeof MessageChannel > "u" && We("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var Xt = new MessageChannel();
              Xt.port1.onmessage = Je, Xt.port2.postMessage(void 0);
            };
          }
        return ou(P);
      }
      var Vn = 0, ir = !1;
      function As(P) {
        {
          var te = Vn;
          Vn++, W.current === null && (W.current = []);
          var Te = W.isBatchingLegacy, Oe;
          try {
            if (W.isBatchingLegacy = !0, Oe = P(), !Te && W.didScheduleLegacyUpdate) {
              var Je = W.current;
              Je !== null && (W.didScheduleLegacyUpdate = !1, su(Je));
            }
          } catch (Mr) {
            throw Zo(te), Mr;
          } finally {
            W.isBatchingLegacy = Te;
          }
          if (Oe !== null && typeof Oe == "object" && typeof Oe.then == "function") {
            var Xt = Oe, pt = !1, Wt = {
              then: function(Mr, Pn) {
                pt = !0, Xt.then(function(Hn) {
                  Zo(te), Vn === 0 ? ef(Hn, Mr, Pn) : Mr(Hn);
                }, function(Hn) {
                  Zo(te), Pn(Hn);
                });
              }
            };
            return !ir && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              pt || (ir = !0, We("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), Wt;
          } else {
            var Nn = Oe;
            if (Zo(te), Vn === 0) {
              var Yn = W.current;
              Yn !== null && (su(Yn), W.current = null);
              var Ir = {
                then: function(Mr, Pn) {
                  W.current === null ? (W.current = [], ef(Nn, Mr, Pn)) : Mr(Nn);
                }
              };
              return Ir;
            } else {
              var xn = {
                then: function(Mr, Pn) {
                  Mr(Nn);
                }
              };
              return xn;
            }
          }
        }
      }
      function Zo(P) {
        P !== Vn - 1 && We("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Vn = P;
      }
      function ef(P, te, Te) {
        {
          var Oe = W.current;
          if (Oe !== null)
            try {
              su(Oe), Np(function() {
                Oe.length === 0 ? (W.current = null, te(P)) : ef(P, te, Te);
              });
            } catch (Je) {
              Te(Je);
            }
          else
            te(P);
        }
      }
      var lu = !1;
      function su(P) {
        if (!lu) {
          lu = !0;
          var te = 0;
          try {
            for (; te < P.length; te++) {
              var Te = P[te];
              do
                Te = Te(!0);
              while (Te !== null);
            }
            P.length = 0;
          } catch (Oe) {
            throw P = P.slice(te + 1), Oe;
          } finally {
            lu = !1;
          }
        }
      }
      var ic = Ip, oc = $l, hd = Pa, Dr = {
        map: Pi,
        forEach: Xl,
        count: Wl,
        toArray: Xo,
        only: ao
      };
      r.Children = Dr, r.Component = lt, r.Fragment = v, r.Profiler = y, r.PureComponent = dt, r.StrictMode = h, r.Suspense = T, r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = at, r.act = As, r.cloneElement = oc, r.createContext = Yl, r.createElement = ic, r.createFactory = hd, r.createRef = bn, r.forwardRef = _t, r.isValidElement = zn, r.lazy = rt, r.memo = ve, r.startTransition = Ap, r.unstable_act = As, r.useCallback = sr, r.useContext = Fe, r.useDebugValue = hn, r.useDeferredValue = Ra, r.useEffect = Tt, r.useId = on, r.useImperativeHandle = Ma, r.useInsertionEffect = Zt, r.useLayoutEffect = nn, r.useMemo = Wr, r.useReducer = bt, r.useRef = Et, r.useState = ut, r.useSyncExternalStore = ei, r.useTransition = fa, r.version = i, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(jy, jy.exports)), jy.exports;
}
process.env.NODE_ENV === "production" ? sT.exports = V5() : sT.exports = H5();
var k = sT.exports;
const hC = /* @__PURE__ */ KT(k), uT = /* @__PURE__ */ q_({
  __proto__: null,
  default: hC
}, [k]);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var eN;
function j5() {
  if (eN)
    return My;
  eN = 1;
  var t = k, r = Symbol.for("react.element"), i = Symbol.for("react.fragment"), u = Object.prototype.hasOwnProperty, c = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, v = { key: !0, ref: !0, __self: !0, __source: !0 };
  function h(y, g, S) {
    var x, T = {}, _ = null, L = null;
    S !== void 0 && (_ = "" + S), g.key !== void 0 && (_ = "" + g.key), g.ref !== void 0 && (L = g.ref);
    for (x in g)
      u.call(g, x) && !v.hasOwnProperty(x) && (T[x] = g[x]);
    if (y && y.defaultProps)
      for (x in g = y.defaultProps, g)
        T[x] === void 0 && (T[x] = g[x]);
    return { $$typeof: r, type: y, key: _, ref: L, props: T, _owner: c.current };
  }
  return My.Fragment = i, My.jsx = h, My.jsxs = h, My;
}
var Py = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tN;
function G5() {
  return tN || (tN = 1, process.env.NODE_ENV !== "production" && function() {
    var t = k, r = Symbol.for("react.element"), i = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), v = Symbol.for("react.profiler"), h = Symbol.for("react.provider"), y = Symbol.for("react.context"), g = Symbol.for("react.forward_ref"), S = Symbol.for("react.suspense"), x = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), _ = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), M = Symbol.iterator, U = "@@iterator";
    function B(J) {
      if (J === null || typeof J != "object")
        return null;
      var ve = M && J[M] || J[U];
      return typeof ve == "function" ? ve : null;
    }
    var H = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Y(J) {
      {
        for (var ve = arguments.length, be = new Array(ve > 1 ? ve - 1 : 0), Fe = 1; Fe < ve; Fe++)
          be[Fe - 1] = arguments[Fe];
        G("error", J, be);
      }
    }
    function G(J, ve, be) {
      {
        var Fe = H.ReactDebugCurrentFrame, ut = Fe.getStackAddendum();
        ut !== "" && (ve += "%s", be = be.concat([ut]));
        var bt = be.map(function(Et) {
          return String(Et);
        });
        bt.unshift("Warning: " + ve), Function.prototype.apply.call(console[J], console, bt);
      }
    }
    var Q = !1, W = !1, oe = !1, j = !1, re = !1, me;
    me = Symbol.for("react.module.reference");
    function Se(J) {
      return !!(typeof J == "string" || typeof J == "function" || J === u || J === v || re || J === c || J === S || J === x || j || J === L || Q || W || oe || typeof J == "object" && J !== null && (J.$$typeof === _ || J.$$typeof === T || J.$$typeof === h || J.$$typeof === y || J.$$typeof === g || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      J.$$typeof === me || J.getModuleId !== void 0));
    }
    function Ne(J, ve, be) {
      var Fe = J.displayName;
      if (Fe)
        return Fe;
      var ut = ve.displayName || ve.name || "";
      return ut !== "" ? be + "(" + ut + ")" : be;
    }
    function Ge(J) {
      return J.displayName || "Context";
    }
    function ze(J) {
      if (J == null)
        return null;
      if (typeof J.tag == "number" && Y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof J == "function")
        return J.displayName || J.name || null;
      if (typeof J == "string")
        return J;
      switch (J) {
        case u:
          return "Fragment";
        case i:
          return "Portal";
        case v:
          return "Profiler";
        case c:
          return "StrictMode";
        case S:
          return "Suspense";
        case x:
          return "SuspenseList";
      }
      if (typeof J == "object")
        switch (J.$$typeof) {
          case y:
            var ve = J;
            return Ge(ve) + ".Consumer";
          case h:
            var be = J;
            return Ge(be._context) + ".Provider";
          case g:
            return Ne(J, J.render, "ForwardRef");
          case T:
            var Fe = J.displayName || null;
            return Fe !== null ? Fe : ze(J.type) || "Memo";
          case _: {
            var ut = J, bt = ut._payload, Et = ut._init;
            try {
              return ze(Et(bt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var qe = Object.assign, at = 0, st, We, he, ke, _e, q, pe;
    function $e() {
    }
    $e.__reactDisabledLog = !0;
    function lt() {
      {
        if (at === 0) {
          st = console.log, We = console.info, he = console.warn, ke = console.error, _e = console.group, q = console.groupCollapsed, pe = console.groupEnd;
          var J = {
            configurable: !0,
            enumerable: !0,
            value: $e,
            writable: !0
          };
          Object.defineProperties(console, {
            info: J,
            log: J,
            warn: J,
            error: J,
            group: J,
            groupCollapsed: J,
            groupEnd: J
          });
        }
        at++;
      }
    }
    function ot() {
      {
        if (at--, at === 0) {
          var J = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: qe({}, J, {
              value: st
            }),
            info: qe({}, J, {
              value: We
            }),
            warn: qe({}, J, {
              value: he
            }),
            error: qe({}, J, {
              value: ke
            }),
            group: qe({}, J, {
              value: _e
            }),
            groupCollapsed: qe({}, J, {
              value: q
            }),
            groupEnd: qe({}, J, {
              value: pe
            })
          });
        }
        at < 0 && Y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var nt = H.ReactCurrentDispatcher, Rt;
    function ht(J, ve, be) {
      {
        if (Rt === void 0)
          try {
            throw Error();
          } catch (ut) {
            var Fe = ut.stack.trim().match(/\n( *(at )?)/);
            Rt = Fe && Fe[1] || "";
          }
        return `
` + Rt + J;
      }
    }
    var dt = !1, sn;
    {
      var bn = typeof WeakMap == "function" ? WeakMap : Map;
      sn = new bn();
    }
    function Ze(J, ve) {
      if (!J || dt)
        return "";
      {
        var be = sn.get(J);
        if (be !== void 0)
          return be;
      }
      var Fe;
      dt = !0;
      var ut = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var bt;
      bt = nt.current, nt.current = null, lt();
      try {
        if (ve) {
          var Et = function() {
            throw Error();
          };
          if (Object.defineProperty(Et.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Et, []);
            } catch (fa) {
              Fe = fa;
            }
            Reflect.construct(J, [], Et);
          } else {
            try {
              Et.call();
            } catch (fa) {
              Fe = fa;
            }
            J.call(Et.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (fa) {
            Fe = fa;
          }
          J();
        }
      } catch (fa) {
        if (fa && Fe && typeof fa.stack == "string") {
          for (var Tt = fa.stack.split(`
`), Zt = Fe.stack.split(`
`), nn = Tt.length - 1, sr = Zt.length - 1; nn >= 1 && sr >= 0 && Tt[nn] !== Zt[sr]; )
            sr--;
          for (; nn >= 1 && sr >= 0; nn--, sr--)
            if (Tt[nn] !== Zt[sr]) {
              if (nn !== 1 || sr !== 1)
                do
                  if (nn--, sr--, sr < 0 || Tt[nn] !== Zt[sr]) {
                    var Wr = `
` + Tt[nn].replace(" at new ", " at ");
                    return J.displayName && Wr.includes("<anonymous>") && (Wr = Wr.replace("<anonymous>", J.displayName)), typeof J == "function" && sn.set(J, Wr), Wr;
                  }
                while (nn >= 1 && sr >= 0);
              break;
            }
        }
      } finally {
        dt = !1, nt.current = bt, ot(), Error.prepareStackTrace = ut;
      }
      var Ma = J ? J.displayName || J.name : "", hn = Ma ? ht(Ma) : "";
      return typeof J == "function" && sn.set(J, hn), hn;
    }
    function mn(J, ve, be) {
      return Ze(J, !1);
    }
    function fn(J) {
      var ve = J.prototype;
      return !!(ve && ve.isReactComponent);
    }
    function Gn(J, ve, be) {
      if (J == null)
        return "";
      if (typeof J == "function")
        return Ze(J, fn(J));
      if (typeof J == "string")
        return ht(J);
      switch (J) {
        case S:
          return ht("Suspense");
        case x:
          return ht("SuspenseList");
      }
      if (typeof J == "object")
        switch (J.$$typeof) {
          case g:
            return mn(J.render);
          case T:
            return Gn(J.type, ve, be);
          case _: {
            var Fe = J, ut = Fe._payload, bt = Fe._init;
            try {
              return Gn(bt(ut), ve, be);
            } catch {
            }
          }
        }
      return "";
    }
    var ar = Object.prototype.hasOwnProperty, Jn = {}, Ha = H.ReactDebugCurrentFrame;
    function ja(J) {
      if (J) {
        var ve = J._owner, be = Gn(J.type, J._source, ve ? ve.type : null);
        Ha.setExtraStackFrame(be);
      } else
        Ha.setExtraStackFrame(null);
    }
    function qr(J, ve, be, Fe, ut) {
      {
        var bt = Function.call.bind(ar);
        for (var Et in J)
          if (bt(J, Et)) {
            var Tt = void 0;
            try {
              if (typeof J[Et] != "function") {
                var Zt = Error((Fe || "React class") + ": " + be + " type `" + Et + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof J[Et] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Zt.name = "Invariant Violation", Zt;
              }
              Tt = J[Et](ve, Et, Fe, be, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (nn) {
              Tt = nn;
            }
            Tt && !(Tt instanceof Error) && (ja(ut), Y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Fe || "React class", be, Et, typeof Tt), ja(null)), Tt instanceof Error && !(Tt.message in Jn) && (Jn[Tt.message] = !0, ja(ut), Y("Failed %s type: %s", be, Tt.message), ja(null));
          }
      }
    }
    var wr = Array.isArray;
    function Da(J) {
      return wr(J);
    }
    function Sa(J) {
      {
        var ve = typeof Symbol == "function" && Symbol.toStringTag, be = ve && J[Symbol.toStringTag] || J.constructor.name || "Object";
        return be;
      }
    }
    function xa(J) {
      try {
        return Or(J), !1;
      } catch {
        return !0;
      }
    }
    function Or(J) {
      return "" + J;
    }
    function fi(J) {
      if (xa(J))
        return Y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Sa(J)), Or(J);
    }
    var pr = H.ReactCurrentOwner, xr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ca, Ka, it;
    it = {};
    function kt(J) {
      if (ar.call(J, "ref")) {
        var ve = Object.getOwnPropertyDescriptor(J, "ref").get;
        if (ve && ve.isReactWarning)
          return !1;
      }
      return J.ref !== void 0;
    }
    function $t(J) {
      if (ar.call(J, "key")) {
        var ve = Object.getOwnPropertyDescriptor(J, "key").get;
        if (ve && ve.isReactWarning)
          return !1;
      }
      return J.key !== void 0;
    }
    function Fn(J, ve) {
      if (typeof J.ref == "string" && pr.current && ve && pr.current.stateNode !== ve) {
        var be = ze(pr.current.type);
        it[be] || (Y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ze(pr.current.type), J.ref), it[be] = !0);
      }
    }
    function zn(J, ve) {
      {
        var be = function() {
          ca || (ca = !0, Y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ve));
        };
        be.isReactWarning = !0, Object.defineProperty(J, "key", {
          get: be,
          configurable: !0
        });
      }
    }
    function Ur(J, ve) {
      {
        var be = function() {
          Ka || (Ka = !0, Y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ve));
        };
        be.isReactWarning = !0, Object.defineProperty(J, "ref", {
          get: be,
          configurable: !0
        });
      }
    }
    var Lr = function(J, ve, be, Fe, ut, bt, Et) {
      var Tt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: J,
        key: ve,
        ref: be,
        props: Et,
        // Record the component responsible for creating this element.
        _owner: bt
      };
      return Tt._store = {}, Object.defineProperty(Tt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Tt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Fe
      }), Object.defineProperty(Tt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ut
      }), Object.freeze && (Object.freeze(Tt.props), Object.freeze(Tt)), Tt;
    };
    function Ga(J, ve, be, Fe, ut) {
      {
        var bt, Et = {}, Tt = null, Zt = null;
        be !== void 0 && (fi(be), Tt = "" + be), $t(ve) && (fi(ve.key), Tt = "" + ve.key), kt(ve) && (Zt = ve.ref, Fn(ve, ut));
        for (bt in ve)
          ar.call(ve, bt) && !xr.hasOwnProperty(bt) && (Et[bt] = ve[bt]);
        if (J && J.defaultProps) {
          var nn = J.defaultProps;
          for (bt in nn)
            Et[bt] === void 0 && (Et[bt] = nn[bt]);
        }
        if (Tt || Zt) {
          var sr = typeof J == "function" ? J.displayName || J.name || "Unknown" : J;
          Tt && zn(Et, sr), Zt && Ur(Et, sr);
        }
        return Lr(J, Tt, Zt, ut, Fe, pr.current, Et);
      }
    }
    var Qn = H.ReactCurrentOwner, qa = H.ReactDebugCurrentFrame;
    function Wn(J) {
      if (J) {
        var ve = J._owner, be = Gn(J.type, J._source, ve ? ve.type : null);
        qa.setExtraStackFrame(be);
      } else
        qa.setExtraStackFrame(null);
    }
    var Xn;
    Xn = !1;
    function So(J) {
      return typeof J == "object" && J !== null && J.$$typeof === r;
    }
    function Pi() {
      {
        if (Qn.current) {
          var J = ze(Qn.current.type);
          if (J)
            return `

Check the render method of \`` + J + "`.";
        }
        return "";
      }
    }
    function Wl(J) {
      {
        if (J !== void 0) {
          var ve = J.fileName.replace(/^.*[\\\/]/, ""), be = J.lineNumber;
          return `

Check your code at ` + ve + ":" + be + ".";
        }
        return "";
      }
    }
    var Xl = {};
    function Xo(J) {
      {
        var ve = Pi();
        if (!ve) {
          var be = typeof J == "string" ? J : J.displayName || J.name;
          be && (ve = `

Check the top-level render call using <` + be + ">.");
        }
        return ve;
      }
    }
    function ao(J, ve) {
      {
        if (!J._store || J._store.validated || J.key != null)
          return;
        J._store.validated = !0;
        var be = Xo(ve);
        if (Xl[be])
          return;
        Xl[be] = !0;
        var Fe = "";
        J && J._owner && J._owner !== Qn.current && (Fe = " It was passed a child from " + ze(J._owner.type) + "."), Wn(J), Y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', be, Fe), Wn(null);
      }
    }
    function Yl(J, ve) {
      {
        if (typeof J != "object")
          return;
        if (Da(J))
          for (var be = 0; be < J.length; be++) {
            var Fe = J[be];
            So(Fe) && ao(Fe, ve);
          }
        else if (So(J))
          J._store && (J._store.validated = !0);
        else if (J) {
          var ut = B(J);
          if (typeof ut == "function" && ut !== J.entries)
            for (var bt = ut.call(J), Et; !(Et = bt.next()).done; )
              So(Et.value) && ao(Et.value, ve);
        }
      }
    }
    function ki(J) {
      {
        var ve = J.type;
        if (ve == null || typeof ve == "string")
          return;
        var be;
        if (typeof ve == "function")
          be = ve.propTypes;
        else if (typeof ve == "object" && (ve.$$typeof === g || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ve.$$typeof === T))
          be = ve.propTypes;
        else
          return;
        if (be) {
          var Fe = ze(ve);
          qr(be, J.props, "prop", Fe, J);
        } else if (ve.PropTypes !== void 0 && !Xn) {
          Xn = !0;
          var ut = ze(ve);
          Y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ut || "Unknown");
        }
        typeof ve.getDefaultProps == "function" && !ve.getDefaultProps.isReactClassApproved && Y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ne(J) {
      {
        for (var ve = Object.keys(J.props), be = 0; be < ve.length; be++) {
          var Fe = ve[be];
          if (Fe !== "children" && Fe !== "key") {
            Wn(J), Y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Fe), Wn(null);
            break;
          }
        }
        J.ref !== null && (Wn(J), Y("Invalid attribute `ref` supplied to `React.Fragment`."), Wn(null));
      }
    }
    var ce = {};
    function xe(J, ve, be, Fe, ut, bt) {
      {
        var Et = Se(J);
        if (!Et) {
          var Tt = "";
          (J === void 0 || typeof J == "object" && J !== null && Object.keys(J).length === 0) && (Tt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Zt = Wl(ut);
          Zt ? Tt += Zt : Tt += Pi();
          var nn;
          J === null ? nn = "null" : Da(J) ? nn = "array" : J !== void 0 && J.$$typeof === r ? (nn = "<" + (ze(J.type) || "Unknown") + " />", Tt = " Did you accidentally export a JSX literal instead of a component?") : nn = typeof J, Y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", nn, Tt);
        }
        var sr = Ga(J, ve, be, ut, bt);
        if (sr == null)
          return sr;
        if (Et) {
          var Wr = ve.children;
          if (Wr !== void 0)
            if (Fe)
              if (Da(Wr)) {
                for (var Ma = 0; Ma < Wr.length; Ma++)
                  Yl(Wr[Ma], J);
                Object.freeze && Object.freeze(Wr);
              } else
                Y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Yl(Wr, J);
        }
        if (ar.call(ve, "key")) {
          var hn = ze(J), fa = Object.keys(ve).filter(function(ei) {
            return ei !== "key";
          }), Ra = fa.length > 0 ? "{key: someKey, " + fa.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ce[hn + Ra]) {
            var on = fa.length > 0 ? "{" + fa.join(": ..., ") + ": ...}" : "{}";
            Y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ra, hn, on, hn), ce[hn + Ra] = !0;
          }
        }
        return J === u ? ne(sr) : ki(sr), sr;
      }
    }
    function Ue(J, ve, be) {
      return xe(J, ve, be, !0);
    }
    function rt(J, ve, be) {
      return xe(J, ve, be, !1);
    }
    var _t = rt, Vt = Ue;
    Py.Fragment = u, Py.jsx = _t, Py.jsxs = Vt;
  }()), Py;
}
process.env.NODE_ENV === "production" ? lT.exports = j5() : lT.exports = G5();
var N = lT.exports, Gy = {}, cT = { exports: {} }, gs = {}, W1 = { exports: {} }, MR = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nN;
function z5() {
  return nN || (nN = 1, function(t) {
    function r(he, ke) {
      var _e = he.length;
      he.push(ke);
      e:
        for (; 0 < _e; ) {
          var q = _e - 1 >>> 1, pe = he[q];
          if (0 < c(pe, ke))
            he[q] = ke, he[_e] = pe, _e = q;
          else
            break e;
        }
    }
    function i(he) {
      return he.length === 0 ? null : he[0];
    }
    function u(he) {
      if (he.length === 0)
        return null;
      var ke = he[0], _e = he.pop();
      if (_e !== ke) {
        he[0] = _e;
        e:
          for (var q = 0, pe = he.length, $e = pe >>> 1; q < $e; ) {
            var lt = 2 * (q + 1) - 1, ot = he[lt], nt = lt + 1, Rt = he[nt];
            if (0 > c(ot, _e))
              nt < pe && 0 > c(Rt, ot) ? (he[q] = Rt, he[nt] = _e, q = nt) : (he[q] = ot, he[lt] = _e, q = lt);
            else if (nt < pe && 0 > c(Rt, _e))
              he[q] = Rt, he[nt] = _e, q = nt;
            else
              break e;
          }
      }
      return ke;
    }
    function c(he, ke) {
      var _e = he.sortIndex - ke.sortIndex;
      return _e !== 0 ? _e : he.id - ke.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var v = performance;
      t.unstable_now = function() {
        return v.now();
      };
    } else {
      var h = Date, y = h.now();
      t.unstable_now = function() {
        return h.now() - y;
      };
    }
    var g = [], S = [], x = 1, T = null, _ = 3, L = !1, M = !1, U = !1, B = typeof setTimeout == "function" ? setTimeout : null, H = typeof clearTimeout == "function" ? clearTimeout : null, Y = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function G(he) {
      for (var ke = i(S); ke !== null; ) {
        if (ke.callback === null)
          u(S);
        else if (ke.startTime <= he)
          u(S), ke.sortIndex = ke.expirationTime, r(g, ke);
        else
          break;
        ke = i(S);
      }
    }
    function Q(he) {
      if (U = !1, G(he), !M)
        if (i(g) !== null)
          M = !0, st(W);
        else {
          var ke = i(S);
          ke !== null && We(Q, ke.startTime - he);
        }
    }
    function W(he, ke) {
      M = !1, U && (U = !1, H(re), re = -1), L = !0;
      var _e = _;
      try {
        for (G(ke), T = i(g); T !== null && (!(T.expirationTime > ke) || he && !Ne()); ) {
          var q = T.callback;
          if (typeof q == "function") {
            T.callback = null, _ = T.priorityLevel;
            var pe = q(T.expirationTime <= ke);
            ke = t.unstable_now(), typeof pe == "function" ? T.callback = pe : T === i(g) && u(g), G(ke);
          } else
            u(g);
          T = i(g);
        }
        if (T !== null)
          var $e = !0;
        else {
          var lt = i(S);
          lt !== null && We(Q, lt.startTime - ke), $e = !1;
        }
        return $e;
      } finally {
        T = null, _ = _e, L = !1;
      }
    }
    var oe = !1, j = null, re = -1, me = 5, Se = -1;
    function Ne() {
      return !(t.unstable_now() - Se < me);
    }
    function Ge() {
      if (j !== null) {
        var he = t.unstable_now();
        Se = he;
        var ke = !0;
        try {
          ke = j(!0, he);
        } finally {
          ke ? ze() : (oe = !1, j = null);
        }
      } else
        oe = !1;
    }
    var ze;
    if (typeof Y == "function")
      ze = function() {
        Y(Ge);
      };
    else if (typeof MessageChannel < "u") {
      var qe = new MessageChannel(), at = qe.port2;
      qe.port1.onmessage = Ge, ze = function() {
        at.postMessage(null);
      };
    } else
      ze = function() {
        B(Ge, 0);
      };
    function st(he) {
      j = he, oe || (oe = !0, ze());
    }
    function We(he, ke) {
      re = B(function() {
        he(t.unstable_now());
      }, ke);
    }
    t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(he) {
      he.callback = null;
    }, t.unstable_continueExecution = function() {
      M || L || (M = !0, st(W));
    }, t.unstable_forceFrameRate = function(he) {
      0 > he || 125 < he ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : me = 0 < he ? Math.floor(1e3 / he) : 5;
    }, t.unstable_getCurrentPriorityLevel = function() {
      return _;
    }, t.unstable_getFirstCallbackNode = function() {
      return i(g);
    }, t.unstable_next = function(he) {
      switch (_) {
        case 1:
        case 2:
        case 3:
          var ke = 3;
          break;
        default:
          ke = _;
      }
      var _e = _;
      _ = ke;
      try {
        return he();
      } finally {
        _ = _e;
      }
    }, t.unstable_pauseExecution = function() {
    }, t.unstable_requestPaint = function() {
    }, t.unstable_runWithPriority = function(he, ke) {
      switch (he) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          he = 3;
      }
      var _e = _;
      _ = he;
      try {
        return ke();
      } finally {
        _ = _e;
      }
    }, t.unstable_scheduleCallback = function(he, ke, _e) {
      var q = t.unstable_now();
      switch (typeof _e == "object" && _e !== null ? (_e = _e.delay, _e = typeof _e == "number" && 0 < _e ? q + _e : q) : _e = q, he) {
        case 1:
          var pe = -1;
          break;
        case 2:
          pe = 250;
          break;
        case 5:
          pe = 1073741823;
          break;
        case 4:
          pe = 1e4;
          break;
        default:
          pe = 5e3;
      }
      return pe = _e + pe, he = { id: x++, callback: ke, priorityLevel: he, startTime: _e, expirationTime: pe, sortIndex: -1 }, _e > q ? (he.sortIndex = _e, r(S, he), i(g) === null && he === i(S) && (U ? (H(re), re = -1) : U = !0, We(Q, _e - q))) : (he.sortIndex = pe, r(g, he), M || L || (M = !0, st(W))), he;
    }, t.unstable_shouldYield = Ne, t.unstable_wrapCallback = function(he) {
      var ke = _;
      return function() {
        var _e = _;
        _ = ke;
        try {
          return he.apply(this, arguments);
        } finally {
          _ = _e;
        }
      };
    };
  }(MR)), MR;
}
var PR = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rN;
function W5() {
  return rN || (rN = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var r = !1, i = !1, u = 5;
      function c(it, kt) {
        var $t = it.length;
        it.push(kt), y(it, kt, $t);
      }
      function v(it) {
        return it.length === 0 ? null : it[0];
      }
      function h(it) {
        if (it.length === 0)
          return null;
        var kt = it[0], $t = it.pop();
        return $t !== kt && (it[0] = $t, g(it, $t, 0)), kt;
      }
      function y(it, kt, $t) {
        for (var Fn = $t; Fn > 0; ) {
          var zn = Fn - 1 >>> 1, Ur = it[zn];
          if (S(Ur, kt) > 0)
            it[zn] = kt, it[Fn] = Ur, Fn = zn;
          else
            return;
        }
      }
      function g(it, kt, $t) {
        for (var Fn = $t, zn = it.length, Ur = zn >>> 1; Fn < Ur; ) {
          var Lr = (Fn + 1) * 2 - 1, Ga = it[Lr], Qn = Lr + 1, qa = it[Qn];
          if (S(Ga, kt) < 0)
            Qn < zn && S(qa, Ga) < 0 ? (it[Fn] = qa, it[Qn] = kt, Fn = Qn) : (it[Fn] = Ga, it[Lr] = kt, Fn = Lr);
          else if (Qn < zn && S(qa, kt) < 0)
            it[Fn] = qa, it[Qn] = kt, Fn = Qn;
          else
            return;
        }
      }
      function S(it, kt) {
        var $t = it.sortIndex - kt.sortIndex;
        return $t !== 0 ? $t : it.id - kt.id;
      }
      var x = 1, T = 2, _ = 3, L = 4, M = 5;
      function U(it, kt) {
      }
      var B = typeof performance == "object" && typeof performance.now == "function";
      if (B) {
        var H = performance;
        t.unstable_now = function() {
          return H.now();
        };
      } else {
        var Y = Date, G = Y.now();
        t.unstable_now = function() {
          return Y.now() - G;
        };
      }
      var Q = 1073741823, W = -1, oe = 250, j = 5e3, re = 1e4, me = Q, Se = [], Ne = [], Ge = 1, ze = null, qe = _, at = !1, st = !1, We = !1, he = typeof setTimeout == "function" ? setTimeout : null, ke = typeof clearTimeout == "function" ? clearTimeout : null, _e = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function q(it) {
        for (var kt = v(Ne); kt !== null; ) {
          if (kt.callback === null)
            h(Ne);
          else if (kt.startTime <= it)
            h(Ne), kt.sortIndex = kt.expirationTime, c(Se, kt);
          else
            return;
          kt = v(Ne);
        }
      }
      function pe(it) {
        if (We = !1, q(it), !st)
          if (v(Se) !== null)
            st = !0, fi($e);
          else {
            var kt = v(Ne);
            kt !== null && pr(pe, kt.startTime - it);
          }
      }
      function $e(it, kt) {
        st = !1, We && (We = !1, xr()), at = !0;
        var $t = qe;
        try {
          var Fn;
          if (!i)
            return lt(it, kt);
        } finally {
          ze = null, qe = $t, at = !1;
        }
      }
      function lt(it, kt) {
        var $t = kt;
        for (q($t), ze = v(Se); ze !== null && !r && !(ze.expirationTime > $t && (!it || ja())); ) {
          var Fn = ze.callback;
          if (typeof Fn == "function") {
            ze.callback = null, qe = ze.priorityLevel;
            var zn = ze.expirationTime <= $t, Ur = Fn(zn);
            $t = t.unstable_now(), typeof Ur == "function" ? ze.callback = Ur : ze === v(Se) && h(Se), q($t);
          } else
            h(Se);
          ze = v(Se);
        }
        if (ze !== null)
          return !0;
        var Lr = v(Ne);
        return Lr !== null && pr(pe, Lr.startTime - $t), !1;
      }
      function ot(it, kt) {
        switch (it) {
          case x:
          case T:
          case _:
          case L:
          case M:
            break;
          default:
            it = _;
        }
        var $t = qe;
        qe = it;
        try {
          return kt();
        } finally {
          qe = $t;
        }
      }
      function nt(it) {
        var kt;
        switch (qe) {
          case x:
          case T:
          case _:
            kt = _;
            break;
          default:
            kt = qe;
            break;
        }
        var $t = qe;
        qe = kt;
        try {
          return it();
        } finally {
          qe = $t;
        }
      }
      function Rt(it) {
        var kt = qe;
        return function() {
          var $t = qe;
          qe = kt;
          try {
            return it.apply(this, arguments);
          } finally {
            qe = $t;
          }
        };
      }
      function ht(it, kt, $t) {
        var Fn = t.unstable_now(), zn;
        if (typeof $t == "object" && $t !== null) {
          var Ur = $t.delay;
          typeof Ur == "number" && Ur > 0 ? zn = Fn + Ur : zn = Fn;
        } else
          zn = Fn;
        var Lr;
        switch (it) {
          case x:
            Lr = W;
            break;
          case T:
            Lr = oe;
            break;
          case M:
            Lr = me;
            break;
          case L:
            Lr = re;
            break;
          case _:
          default:
            Lr = j;
            break;
        }
        var Ga = zn + Lr, Qn = {
          id: Ge++,
          callback: kt,
          priorityLevel: it,
          startTime: zn,
          expirationTime: Ga,
          sortIndex: -1
        };
        return zn > Fn ? (Qn.sortIndex = zn, c(Ne, Qn), v(Se) === null && Qn === v(Ne) && (We ? xr() : We = !0, pr(pe, zn - Fn))) : (Qn.sortIndex = Ga, c(Se, Qn), !st && !at && (st = !0, fi($e))), Qn;
      }
      function dt() {
      }
      function sn() {
        !st && !at && (st = !0, fi($e));
      }
      function bn() {
        return v(Se);
      }
      function Ze(it) {
        it.callback = null;
      }
      function mn() {
        return qe;
      }
      var fn = !1, Gn = null, ar = -1, Jn = u, Ha = -1;
      function ja() {
        var it = t.unstable_now() - Ha;
        return !(it < Jn);
      }
      function qr() {
      }
      function wr(it) {
        if (it < 0 || it > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        it > 0 ? Jn = Math.floor(1e3 / it) : Jn = u;
      }
      var Da = function() {
        if (Gn !== null) {
          var it = t.unstable_now();
          Ha = it;
          var kt = !0, $t = !0;
          try {
            $t = Gn(kt, it);
          } finally {
            $t ? Sa() : (fn = !1, Gn = null);
          }
        } else
          fn = !1;
      }, Sa;
      if (typeof _e == "function")
        Sa = function() {
          _e(Da);
        };
      else if (typeof MessageChannel < "u") {
        var xa = new MessageChannel(), Or = xa.port2;
        xa.port1.onmessage = Da, Sa = function() {
          Or.postMessage(null);
        };
      } else
        Sa = function() {
          he(Da, 0);
        };
      function fi(it) {
        Gn = it, fn || (fn = !0, Sa());
      }
      function pr(it, kt) {
        ar = he(function() {
          it(t.unstable_now());
        }, kt);
      }
      function xr() {
        ke(ar), ar = -1;
      }
      var ca = qr, Ka = null;
      t.unstable_IdlePriority = M, t.unstable_ImmediatePriority = x, t.unstable_LowPriority = L, t.unstable_NormalPriority = _, t.unstable_Profiling = Ka, t.unstable_UserBlockingPriority = T, t.unstable_cancelCallback = Ze, t.unstable_continueExecution = sn, t.unstable_forceFrameRate = wr, t.unstable_getCurrentPriorityLevel = mn, t.unstable_getFirstCallbackNode = bn, t.unstable_next = nt, t.unstable_pauseExecution = dt, t.unstable_requestPaint = ca, t.unstable_runWithPriority = ot, t.unstable_scheduleCallback = ht, t.unstable_shouldYield = ja, t.unstable_wrapCallback = Rt, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(PR)), PR;
}
var aN;
function e9() {
  return aN || (aN = 1, process.env.NODE_ENV === "production" ? W1.exports = z5() : W1.exports = W5()), W1.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var iN;
function X5() {
  if (iN)
    return gs;
  iN = 1;
  var t = k, r = e9();
  function i(a) {
    for (var o = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, p = 1; p < arguments.length; p++)
      o += "&args[]=" + encodeURIComponent(arguments[p]);
    return "Minified React error #" + a + "; visit " + o + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var u = /* @__PURE__ */ new Set(), c = {};
  function v(a, o) {
    h(a, o), h(a + "Capture", o);
  }
  function h(a, o) {
    for (c[a] = o, a = 0; a < o.length; a++)
      u.add(o[a]);
  }
  var y = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), g = Object.prototype.hasOwnProperty, S = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, x = {}, T = {};
  function _(a) {
    return g.call(T, a) ? !0 : g.call(x, a) ? !1 : S.test(a) ? T[a] = !0 : (x[a] = !0, !1);
  }
  function L(a, o, p, b) {
    if (p !== null && p.type === 0)
      return !1;
    switch (typeof o) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return b ? !1 : p !== null ? !p.acceptsBooleans : (a = a.toLowerCase().slice(0, 5), a !== "data-" && a !== "aria-");
      default:
        return !1;
    }
  }
  function M(a, o, p, b) {
    if (o === null || typeof o > "u" || L(a, o, p, b))
      return !0;
    if (b)
      return !1;
    if (p !== null)
      switch (p.type) {
        case 3:
          return !o;
        case 4:
          return o === !1;
        case 5:
          return isNaN(o);
        case 6:
          return isNaN(o) || 1 > o;
      }
    return !1;
  }
  function U(a, o, p, b, R, I, V) {
    this.acceptsBooleans = o === 2 || o === 3 || o === 4, this.attributeName = b, this.attributeNamespace = R, this.mustUseProperty = p, this.propertyName = a, this.type = o, this.sanitizeURL = I, this.removeEmptyString = V;
  }
  var B = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    B[a] = new U(a, 0, !1, a, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
    var o = a[0];
    B[o] = new U(o, 1, !1, a[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
    B[a] = new U(a, 2, !1, a.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
    B[a] = new U(a, 2, !1, a, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    B[a] = new U(a, 3, !1, a.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(a) {
    B[a] = new U(a, 3, !0, a, null, !1, !1);
  }), ["capture", "download"].forEach(function(a) {
    B[a] = new U(a, 4, !1, a, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(a) {
    B[a] = new U(a, 6, !1, a, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(a) {
    B[a] = new U(a, 5, !1, a.toLowerCase(), null, !1, !1);
  });
  var H = /[\-:]([a-z])/g;
  function Y(a) {
    return a[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var o = a.replace(
      H,
      Y
    );
    B[o] = new U(o, 1, !1, a, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var o = a.replace(H, Y);
    B[o] = new U(o, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(a) {
    var o = a.replace(H, Y);
    B[o] = new U(o, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(a) {
    B[a] = new U(a, 1, !1, a.toLowerCase(), null, !1, !1);
  }), B.xlinkHref = new U("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(a) {
    B[a] = new U(a, 1, !1, a.toLowerCase(), null, !0, !0);
  });
  function G(a, o, p, b) {
    var R = B.hasOwnProperty(o) ? B[o] : null;
    (R !== null ? R.type !== 0 : b || !(2 < o.length) || o[0] !== "o" && o[0] !== "O" || o[1] !== "n" && o[1] !== "N") && (M(o, p, R, b) && (p = null), b || R === null ? _(o) && (p === null ? a.removeAttribute(o) : a.setAttribute(o, "" + p)) : R.mustUseProperty ? a[R.propertyName] = p === null ? R.type === 3 ? !1 : "" : p : (o = R.attributeName, b = R.attributeNamespace, p === null ? a.removeAttribute(o) : (R = R.type, p = R === 3 || R === 4 && p === !0 ? "" : "" + p, b ? a.setAttributeNS(b, o, p) : a.setAttribute(o, p))));
  }
  var Q = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, W = Symbol.for("react.element"), oe = Symbol.for("react.portal"), j = Symbol.for("react.fragment"), re = Symbol.for("react.strict_mode"), me = Symbol.for("react.profiler"), Se = Symbol.for("react.provider"), Ne = Symbol.for("react.context"), Ge = Symbol.for("react.forward_ref"), ze = Symbol.for("react.suspense"), qe = Symbol.for("react.suspense_list"), at = Symbol.for("react.memo"), st = Symbol.for("react.lazy"), We = Symbol.for("react.offscreen"), he = Symbol.iterator;
  function ke(a) {
    return a === null || typeof a != "object" ? null : (a = he && a[he] || a["@@iterator"], typeof a == "function" ? a : null);
  }
  var _e = Object.assign, q;
  function pe(a) {
    if (q === void 0)
      try {
        throw Error();
      } catch (p) {
        var o = p.stack.trim().match(/\n( *(at )?)/);
        q = o && o[1] || "";
      }
    return `
` + q + a;
  }
  var $e = !1;
  function lt(a, o) {
    if (!a || $e)
      return "";
    $e = !0;
    var p = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (o)
        if (o = function() {
          throw Error();
        }, Object.defineProperty(o.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(o, []);
          } catch (we) {
            var b = we;
          }
          Reflect.construct(a, [], o);
        } else {
          try {
            o.call();
          } catch (we) {
            b = we;
          }
          a.call(o.prototype);
        }
      else {
        try {
          throw Error();
        } catch (we) {
          b = we;
        }
        a();
      }
    } catch (we) {
      if (we && b && typeof we.stack == "string") {
        for (var R = we.stack.split(`
`), I = b.stack.split(`
`), V = R.length - 1, K = I.length - 1; 1 <= V && 0 <= K && R[V] !== I[K]; )
          K--;
        for (; 1 <= V && 0 <= K; V--, K--)
          if (R[V] !== I[K]) {
            if (V !== 1 || K !== 1)
              do
                if (V--, K--, 0 > K || R[V] !== I[K]) {
                  var ie = `
` + R[V].replace(" at new ", " at ");
                  return a.displayName && ie.includes("<anonymous>") && (ie = ie.replace("<anonymous>", a.displayName)), ie;
                }
              while (1 <= V && 0 <= K);
            break;
          }
      }
    } finally {
      $e = !1, Error.prepareStackTrace = p;
    }
    return (a = a ? a.displayName || a.name : "") ? pe(a) : "";
  }
  function ot(a) {
    switch (a.tag) {
      case 5:
        return pe(a.type);
      case 16:
        return pe("Lazy");
      case 13:
        return pe("Suspense");
      case 19:
        return pe("SuspenseList");
      case 0:
      case 2:
      case 15:
        return a = lt(a.type, !1), a;
      case 11:
        return a = lt(a.type.render, !1), a;
      case 1:
        return a = lt(a.type, !0), a;
      default:
        return "";
    }
  }
  function nt(a) {
    if (a == null)
      return null;
    if (typeof a == "function")
      return a.displayName || a.name || null;
    if (typeof a == "string")
      return a;
    switch (a) {
      case j:
        return "Fragment";
      case oe:
        return "Portal";
      case me:
        return "Profiler";
      case re:
        return "StrictMode";
      case ze:
        return "Suspense";
      case qe:
        return "SuspenseList";
    }
    if (typeof a == "object")
      switch (a.$$typeof) {
        case Ne:
          return (a.displayName || "Context") + ".Consumer";
        case Se:
          return (a._context.displayName || "Context") + ".Provider";
        case Ge:
          var o = a.render;
          return a = a.displayName, a || (a = o.displayName || o.name || "", a = a !== "" ? "ForwardRef(" + a + ")" : "ForwardRef"), a;
        case at:
          return o = a.displayName || null, o !== null ? o : nt(a.type) || "Memo";
        case st:
          o = a._payload, a = a._init;
          try {
            return nt(a(o));
          } catch {
          }
      }
    return null;
  }
  function Rt(a) {
    var o = a.type;
    switch (a.tag) {
      case 24:
        return "Cache";
      case 9:
        return (o.displayName || "Context") + ".Consumer";
      case 10:
        return (o._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return a = o.render, a = a.displayName || a.name || "", o.displayName || (a !== "" ? "ForwardRef(" + a + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return o;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return nt(o);
      case 8:
        return o === re ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof o == "function")
          return o.displayName || o.name || null;
        if (typeof o == "string")
          return o;
    }
    return null;
  }
  function ht(a) {
    switch (typeof a) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return a;
      case "object":
        return a;
      default:
        return "";
    }
  }
  function dt(a) {
    var o = a.type;
    return (a = a.nodeName) && a.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
  }
  function sn(a) {
    var o = dt(a) ? "checked" : "value", p = Object.getOwnPropertyDescriptor(a.constructor.prototype, o), b = "" + a[o];
    if (!a.hasOwnProperty(o) && typeof p < "u" && typeof p.get == "function" && typeof p.set == "function") {
      var R = p.get, I = p.set;
      return Object.defineProperty(a, o, { configurable: !0, get: function() {
        return R.call(this);
      }, set: function(V) {
        b = "" + V, I.call(this, V);
      } }), Object.defineProperty(a, o, { enumerable: p.enumerable }), { getValue: function() {
        return b;
      }, setValue: function(V) {
        b = "" + V;
      }, stopTracking: function() {
        a._valueTracker = null, delete a[o];
      } };
    }
  }
  function bn(a) {
    a._valueTracker || (a._valueTracker = sn(a));
  }
  function Ze(a) {
    if (!a)
      return !1;
    var o = a._valueTracker;
    if (!o)
      return !0;
    var p = o.getValue(), b = "";
    return a && (b = dt(a) ? a.checked ? "true" : "false" : a.value), a = b, a !== p ? (o.setValue(a), !0) : !1;
  }
  function mn(a) {
    if (a = a || (typeof document < "u" ? document : void 0), typeof a > "u")
      return null;
    try {
      return a.activeElement || a.body;
    } catch {
      return a.body;
    }
  }
  function fn(a, o) {
    var p = o.checked;
    return _e({}, o, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: p ?? a._wrapperState.initialChecked });
  }
  function Gn(a, o) {
    var p = o.defaultValue == null ? "" : o.defaultValue, b = o.checked != null ? o.checked : o.defaultChecked;
    p = ht(o.value != null ? o.value : p), a._wrapperState = { initialChecked: b, initialValue: p, controlled: o.type === "checkbox" || o.type === "radio" ? o.checked != null : o.value != null };
  }
  function ar(a, o) {
    o = o.checked, o != null && G(a, "checked", o, !1);
  }
  function Jn(a, o) {
    ar(a, o);
    var p = ht(o.value), b = o.type;
    if (p != null)
      b === "number" ? (p === 0 && a.value === "" || a.value != p) && (a.value = "" + p) : a.value !== "" + p && (a.value = "" + p);
    else if (b === "submit" || b === "reset") {
      a.removeAttribute("value");
      return;
    }
    o.hasOwnProperty("value") ? ja(a, o.type, p) : o.hasOwnProperty("defaultValue") && ja(a, o.type, ht(o.defaultValue)), o.checked == null && o.defaultChecked != null && (a.defaultChecked = !!o.defaultChecked);
  }
  function Ha(a, o, p) {
    if (o.hasOwnProperty("value") || o.hasOwnProperty("defaultValue")) {
      var b = o.type;
      if (!(b !== "submit" && b !== "reset" || o.value !== void 0 && o.value !== null))
        return;
      o = "" + a._wrapperState.initialValue, p || o === a.value || (a.value = o), a.defaultValue = o;
    }
    p = a.name, p !== "" && (a.name = ""), a.defaultChecked = !!a._wrapperState.initialChecked, p !== "" && (a.name = p);
  }
  function ja(a, o, p) {
    (o !== "number" || mn(a.ownerDocument) !== a) && (p == null ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + p && (a.defaultValue = "" + p));
  }
  var qr = Array.isArray;
  function wr(a, o, p, b) {
    if (a = a.options, o) {
      o = {};
      for (var R = 0; R < p.length; R++)
        o["$" + p[R]] = !0;
      for (p = 0; p < a.length; p++)
        R = o.hasOwnProperty("$" + a[p].value), a[p].selected !== R && (a[p].selected = R), R && b && (a[p].defaultSelected = !0);
    } else {
      for (p = "" + ht(p), o = null, R = 0; R < a.length; R++) {
        if (a[R].value === p) {
          a[R].selected = !0, b && (a[R].defaultSelected = !0);
          return;
        }
        o !== null || a[R].disabled || (o = a[R]);
      }
      o !== null && (o.selected = !0);
    }
  }
  function Da(a, o) {
    if (o.dangerouslySetInnerHTML != null)
      throw Error(i(91));
    return _e({}, o, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
  }
  function Sa(a, o) {
    var p = o.value;
    if (p == null) {
      if (p = o.children, o = o.defaultValue, p != null) {
        if (o != null)
          throw Error(i(92));
        if (qr(p)) {
          if (1 < p.length)
            throw Error(i(93));
          p = p[0];
        }
        o = p;
      }
      o == null && (o = ""), p = o;
    }
    a._wrapperState = { initialValue: ht(p) };
  }
  function xa(a, o) {
    var p = ht(o.value), b = ht(o.defaultValue);
    p != null && (p = "" + p, p !== a.value && (a.value = p), o.defaultValue == null && a.defaultValue !== p && (a.defaultValue = p)), b != null && (a.defaultValue = "" + b);
  }
  function Or(a) {
    var o = a.textContent;
    o === a._wrapperState.initialValue && o !== "" && o !== null && (a.value = o);
  }
  function fi(a) {
    switch (a) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function pr(a, o) {
    return a == null || a === "http://www.w3.org/1999/xhtml" ? fi(o) : a === "http://www.w3.org/2000/svg" && o === "foreignObject" ? "http://www.w3.org/1999/xhtml" : a;
  }
  var xr, ca = function(a) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(o, p, b, R) {
      MSApp.execUnsafeLocalFunction(function() {
        return a(o, p, b, R);
      });
    } : a;
  }(function(a, o) {
    if (a.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in a)
      a.innerHTML = o;
    else {
      for (xr = xr || document.createElement("div"), xr.innerHTML = "<svg>" + o.valueOf().toString() + "</svg>", o = xr.firstChild; a.firstChild; )
        a.removeChild(a.firstChild);
      for (; o.firstChild; )
        a.appendChild(o.firstChild);
    }
  });
  function Ka(a, o) {
    if (o) {
      var p = a.firstChild;
      if (p && p === a.lastChild && p.nodeType === 3) {
        p.nodeValue = o;
        return;
      }
    }
    a.textContent = o;
  }
  var it = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, kt = ["Webkit", "ms", "Moz", "O"];
  Object.keys(it).forEach(function(a) {
    kt.forEach(function(o) {
      o = o + a.charAt(0).toUpperCase() + a.substring(1), it[o] = it[a];
    });
  });
  function $t(a, o, p) {
    return o == null || typeof o == "boolean" || o === "" ? "" : p || typeof o != "number" || o === 0 || it.hasOwnProperty(a) && it[a] ? ("" + o).trim() : o + "px";
  }
  function Fn(a, o) {
    a = a.style;
    for (var p in o)
      if (o.hasOwnProperty(p)) {
        var b = p.indexOf("--") === 0, R = $t(p, o[p], b);
        p === "float" && (p = "cssFloat"), b ? a.setProperty(p, R) : a[p] = R;
      }
  }
  var zn = _e({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Ur(a, o) {
    if (o) {
      if (zn[a] && (o.children != null || o.dangerouslySetInnerHTML != null))
        throw Error(i(137, a));
      if (o.dangerouslySetInnerHTML != null) {
        if (o.children != null)
          throw Error(i(60));
        if (typeof o.dangerouslySetInnerHTML != "object" || !("__html" in o.dangerouslySetInnerHTML))
          throw Error(i(61));
      }
      if (o.style != null && typeof o.style != "object")
        throw Error(i(62));
    }
  }
  function Lr(a, o) {
    if (a.indexOf("-") === -1)
      return typeof o.is == "string";
    switch (a) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Ga = null;
  function Qn(a) {
    return a = a.target || a.srcElement || window, a.correspondingUseElement && (a = a.correspondingUseElement), a.nodeType === 3 ? a.parentNode : a;
  }
  var qa = null, Wn = null, Xn = null;
  function So(a) {
    if (a = xi(a)) {
      if (typeof qa != "function")
        throw Error(i(280));
      var o = a.stateNode;
      o && (o = zt(o), qa(a.stateNode, a.type, o));
    }
  }
  function Pi(a) {
    Wn ? Xn ? Xn.push(a) : Xn = [a] : Wn = a;
  }
  function Wl() {
    if (Wn) {
      var a = Wn, o = Xn;
      if (Xn = Wn = null, So(a), o)
        for (a = 0; a < o.length; a++)
          So(o[a]);
    }
  }
  function Xl(a, o) {
    return a(o);
  }
  function Xo() {
  }
  var ao = !1;
  function Yl(a, o, p) {
    if (ao)
      return a(o, p);
    ao = !0;
    try {
      return Xl(a, o, p);
    } finally {
      ao = !1, (Wn !== null || Xn !== null) && (Xo(), Wl());
    }
  }
  function ki(a, o) {
    var p = a.stateNode;
    if (p === null)
      return null;
    var b = zt(p);
    if (b === null)
      return null;
    p = b[o];
    e:
      switch (o) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (b = !b.disabled) || (a = a.type, b = !(a === "button" || a === "input" || a === "select" || a === "textarea")), a = !b;
          break e;
        default:
          a = !1;
      }
    if (a)
      return null;
    if (p && typeof p != "function")
      throw Error(i(231, o, typeof p));
    return p;
  }
  var ne = !1;
  if (y)
    try {
      var ce = {};
      Object.defineProperty(ce, "passive", { get: function() {
        ne = !0;
      } }), window.addEventListener("test", ce, ce), window.removeEventListener("test", ce, ce);
    } catch {
      ne = !1;
    }
  function xe(a, o, p, b, R, I, V, K, ie) {
    var we = Array.prototype.slice.call(arguments, 3);
    try {
      o.apply(p, we);
    } catch (Qe) {
      this.onError(Qe);
    }
  }
  var Ue = !1, rt = null, _t = !1, Vt = null, J = { onError: function(a) {
    Ue = !0, rt = a;
  } };
  function ve(a, o, p, b, R, I, V, K, ie) {
    Ue = !1, rt = null, xe.apply(J, arguments);
  }
  function be(a, o, p, b, R, I, V, K, ie) {
    if (ve.apply(this, arguments), Ue) {
      if (Ue) {
        var we = rt;
        Ue = !1, rt = null;
      } else
        throw Error(i(198));
      _t || (_t = !0, Vt = we);
    }
  }
  function Fe(a) {
    var o = a, p = a;
    if (a.alternate)
      for (; o.return; )
        o = o.return;
    else {
      a = o;
      do
        o = a, o.flags & 4098 && (p = o.return), a = o.return;
      while (a);
    }
    return o.tag === 3 ? p : null;
  }
  function ut(a) {
    if (a.tag === 13) {
      var o = a.memoizedState;
      if (o === null && (a = a.alternate, a !== null && (o = a.memoizedState)), o !== null)
        return o.dehydrated;
    }
    return null;
  }
  function bt(a) {
    if (Fe(a) !== a)
      throw Error(i(188));
  }
  function Et(a) {
    var o = a.alternate;
    if (!o) {
      if (o = Fe(a), o === null)
        throw Error(i(188));
      return o !== a ? null : a;
    }
    for (var p = a, b = o; ; ) {
      var R = p.return;
      if (R === null)
        break;
      var I = R.alternate;
      if (I === null) {
        if (b = R.return, b !== null) {
          p = b;
          continue;
        }
        break;
      }
      if (R.child === I.child) {
        for (I = R.child; I; ) {
          if (I === p)
            return bt(R), a;
          if (I === b)
            return bt(R), o;
          I = I.sibling;
        }
        throw Error(i(188));
      }
      if (p.return !== b.return)
        p = R, b = I;
      else {
        for (var V = !1, K = R.child; K; ) {
          if (K === p) {
            V = !0, p = R, b = I;
            break;
          }
          if (K === b) {
            V = !0, b = R, p = I;
            break;
          }
          K = K.sibling;
        }
        if (!V) {
          for (K = I.child; K; ) {
            if (K === p) {
              V = !0, p = I, b = R;
              break;
            }
            if (K === b) {
              V = !0, b = I, p = R;
              break;
            }
            K = K.sibling;
          }
          if (!V)
            throw Error(i(189));
        }
      }
      if (p.alternate !== b)
        throw Error(i(190));
    }
    if (p.tag !== 3)
      throw Error(i(188));
    return p.stateNode.current === p ? a : o;
  }
  function Tt(a) {
    return a = Et(a), a !== null ? Zt(a) : null;
  }
  function Zt(a) {
    if (a.tag === 5 || a.tag === 6)
      return a;
    for (a = a.child; a !== null; ) {
      var o = Zt(a);
      if (o !== null)
        return o;
      a = a.sibling;
    }
    return null;
  }
  var nn = r.unstable_scheduleCallback, sr = r.unstable_cancelCallback, Wr = r.unstable_shouldYield, Ma = r.unstable_requestPaint, hn = r.unstable_now, fa = r.unstable_getCurrentPriorityLevel, Ra = r.unstable_ImmediatePriority, on = r.unstable_UserBlockingPriority, ei = r.unstable_NormalPriority, io = r.unstable_LowPriority, An = r.unstable_IdlePriority, hr = null, Ta = null;
  function xl(a) {
    if (Ta && typeof Ta.onCommitFiberRoot == "function")
      try {
        Ta.onCommitFiberRoot(hr, a, void 0, (a.current.flags & 128) === 128);
      } catch {
      }
  }
  var Bn = Math.clz32 ? Math.clz32 : ec, xo = Math.log, Ss = Math.LN2;
  function ec(a) {
    return a >>>= 0, a === 0 ? 32 : 31 - (xo(a) / Ss | 0) | 0;
  }
  var eu = 64, tu = 4194304;
  function Yo(a) {
    switch (a & -a) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return a & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return a & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return a;
    }
  }
  function ti(a, o) {
    var p = a.pendingLanes;
    if (p === 0)
      return 0;
    var b = 0, R = a.suspendedLanes, I = a.pingedLanes, V = p & 268435455;
    if (V !== 0) {
      var K = V & ~R;
      K !== 0 ? b = Yo(K) : (I &= V, I !== 0 && (b = Yo(I)));
    } else
      V = p & ~R, V !== 0 ? b = Yo(V) : I !== 0 && (b = Yo(I));
    if (b === 0)
      return 0;
    if (o !== 0 && o !== b && !(o & R) && (R = b & -b, I = o & -o, R >= I || R === 16 && (I & 4194240) !== 0))
      return o;
    if (b & 4 && (b |= p & 16), o = a.entangledLanes, o !== 0)
      for (a = a.entanglements, o &= b; 0 < o; )
        p = 31 - Bn(o), R = 1 << p, b |= a[p], o &= ~R;
    return b;
  }
  function xs(a, o) {
    switch (a) {
      case 1:
      case 2:
      case 4:
        return o + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return o + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function nu(a, o) {
    for (var p = a.suspendedLanes, b = a.pingedLanes, R = a.expirationTimes, I = a.pendingLanes; 0 < I; ) {
      var V = 31 - Bn(I), K = 1 << V, ie = R[V];
      ie === -1 ? (!(K & p) || K & b) && (R[V] = xs(K, o)) : ie <= o && (a.expiredLanes |= K), I &= ~K;
    }
  }
  function Rs(a) {
    return a = a.pendingLanes & -1073741825, a !== 0 ? a : a & 1073741824 ? 1073741824 : 0;
  }
  function tc() {
    var a = eu;
    return eu <<= 1, !(eu & 4194240) && (eu = 64), a;
  }
  function ru(a) {
    for (var o = [], p = 0; 31 > p; p++)
      o.push(a);
    return o;
  }
  function Ts(a, o, p) {
    a.pendingLanes |= o, o !== 536870912 && (a.suspendedLanes = 0, a.pingedLanes = 0), a = a.eventTimes, o = 31 - Bn(o), a[o] = p;
  }
  function wp(a, o) {
    var p = a.pendingLanes & ~o;
    a.pendingLanes = o, a.suspendedLanes = 0, a.pingedLanes = 0, a.expiredLanes &= o, a.mutableReadLanes &= o, a.entangledLanes &= o, o = a.entanglements;
    var b = a.eventTimes;
    for (a = a.expirationTimes; 0 < p; ) {
      var R = 31 - Bn(p), I = 1 << R;
      o[R] = 0, b[R] = -1, a[R] = -1, p &= ~I;
    }
  }
  function $o(a, o) {
    var p = a.entangledLanes |= o;
    for (a = a.entanglements; p; ) {
      var b = 31 - Bn(p), R = 1 << b;
      R & o | a[b] & o && (a[b] |= o), p &= ~R;
    }
  }
  var Kn = 0;
  function Rl(a) {
    return a &= -a, 1 < a ? 4 < a ? a & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var au, nc, Un, rc, ac, dn = !1, iu = [], ra = null, oo = null, Fi = null, ws = /* @__PURE__ */ new Map(), da = /* @__PURE__ */ new Map(), gr = [], Ip = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function lo(a, o) {
    switch (a) {
      case "focusin":
      case "focusout":
        ra = null;
        break;
      case "dragenter":
      case "dragleave":
        oo = null;
        break;
      case "mouseover":
      case "mouseout":
        Fi = null;
        break;
      case "pointerover":
      case "pointerout":
        ws.delete(o.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        da.delete(o.pointerId);
    }
  }
  function Pa(a, o, p, b, R, I) {
    return a === null || a.nativeEvent !== I ? (a = { blockedOn: o, domEventName: p, eventSystemFlags: b, nativeEvent: I, targetContainers: [R] }, o !== null && (o = xi(o), o !== null && nc(o)), a) : (a.eventSystemFlags |= b, o = a.targetContainers, R !== null && o.indexOf(R) === -1 && o.push(R), a);
  }
  function $l(a, o, p, b, R) {
    switch (o) {
      case "focusin":
        return ra = Pa(ra, a, o, p, b, R), !0;
      case "dragenter":
        return oo = Pa(oo, a, o, p, b, R), !0;
      case "mouseover":
        return Fi = Pa(Fi, a, o, p, b, R), !0;
      case "pointerover":
        var I = R.pointerId;
        return ws.set(I, Pa(ws.get(I) || null, a, o, p, b, R)), !0;
      case "gotpointercapture":
        return I = R.pointerId, da.set(I, Pa(da.get(I) || null, a, o, p, b, R)), !0;
    }
    return !1;
  }
  function Ap(a) {
    var o = Bi(a.target);
    if (o !== null) {
      var p = Fe(o);
      if (p !== null) {
        if (o = p.tag, o === 13) {
          if (o = ut(p), o !== null) {
            a.blockedOn = o, ac(a.priority, function() {
              Un(p);
            });
            return;
          }
        } else if (o === 3 && p.stateNode.current.memoizedState.isDehydrated) {
          a.blockedOn = p.tag === 3 ? p.stateNode.containerInfo : null;
          return;
        }
      }
    }
    a.blockedOn = null;
  }
  function Is(a) {
    if (a.blockedOn !== null)
      return !1;
    for (var o = a.targetContainers; 0 < o.length; ) {
      var p = oc(a.domEventName, a.eventSystemFlags, o[0], a.nativeEvent);
      if (p === null) {
        p = a.nativeEvent;
        var b = new p.constructor(p.type, p);
        Ga = b, p.target.dispatchEvent(b), Ga = null;
      } else
        return o = xi(p), o !== null && nc(o), a.blockedOn = p, !1;
      o.shift();
    }
    return !0;
  }
  function ou(a, o, p) {
    Is(a) && p.delete(o);
  }
  function Np() {
    dn = !1, ra !== null && Is(ra) && (ra = null), oo !== null && Is(oo) && (oo = null), Fi !== null && Is(Fi) && (Fi = null), ws.forEach(ou), da.forEach(ou);
  }
  function Vn(a, o) {
    a.blockedOn === o && (a.blockedOn = null, dn || (dn = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Np)));
  }
  function ir(a) {
    function o(R) {
      return Vn(R, a);
    }
    if (0 < iu.length) {
      Vn(iu[0], a);
      for (var p = 1; p < iu.length; p++) {
        var b = iu[p];
        b.blockedOn === a && (b.blockedOn = null);
      }
    }
    for (ra !== null && Vn(ra, a), oo !== null && Vn(oo, a), Fi !== null && Vn(Fi, a), ws.forEach(o), da.forEach(o), p = 0; p < gr.length; p++)
      b = gr[p], b.blockedOn === a && (b.blockedOn = null);
    for (; 0 < gr.length && (p = gr[0], p.blockedOn === null); )
      Ap(p), p.blockedOn === null && gr.shift();
  }
  var As = Q.ReactCurrentBatchConfig, Zo = !0;
  function ef(a, o, p, b) {
    var R = Kn, I = As.transition;
    As.transition = null;
    try {
      Kn = 1, su(a, o, p, b);
    } finally {
      Kn = R, As.transition = I;
    }
  }
  function lu(a, o, p, b) {
    var R = Kn, I = As.transition;
    As.transition = null;
    try {
      Kn = 4, su(a, o, p, b);
    } finally {
      Kn = R, As.transition = I;
    }
  }
  function su(a, o, p, b) {
    if (Zo) {
      var R = oc(a, o, p, b);
      if (R === null)
        Vp(a, o, b, ic, p), lo(a, b);
      else if ($l(R, a, o, p, b))
        b.stopPropagation();
      else if (lo(a, b), o & 4 && -1 < Ip.indexOf(a)) {
        for (; R !== null; ) {
          var I = xi(R);
          if (I !== null && au(I), I = oc(a, o, p, b), I === null && Vp(a, o, b, ic, p), I === R)
            break;
          R = I;
        }
        R !== null && b.stopPropagation();
      } else
        Vp(a, o, b, null, p);
    }
  }
  var ic = null;
  function oc(a, o, p, b) {
    if (ic = null, a = Qn(b), a = Bi(a), a !== null)
      if (o = Fe(a), o === null)
        a = null;
      else if (p = o.tag, p === 13) {
        if (a = ut(o), a !== null)
          return a;
        a = null;
      } else if (p === 3) {
        if (o.stateNode.current.memoizedState.isDehydrated)
          return o.tag === 3 ? o.stateNode.containerInfo : null;
        a = null;
      } else
        o !== a && (a = null);
    return ic = a, null;
  }
  function hd(a) {
    switch (a) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (fa()) {
          case Ra:
            return 1;
          case on:
            return 4;
          case ei:
          case io:
            return 16;
          case An:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Dr = null, P = null, te = null;
  function Te() {
    if (te)
      return te;
    var a, o = P, p = o.length, b, R = "value" in Dr ? Dr.value : Dr.textContent, I = R.length;
    for (a = 0; a < p && o[a] === R[a]; a++)
      ;
    var V = p - a;
    for (b = 1; b <= V && o[p - b] === R[I - b]; b++)
      ;
    return te = R.slice(a, 1 < b ? 1 - b : void 0);
  }
  function Oe(a) {
    var o = a.keyCode;
    return "charCode" in a ? (a = a.charCode, a === 0 && o === 13 && (a = 13)) : a = o, a === 10 && (a = 13), 32 <= a || a === 13 ? a : 0;
  }
  function Je() {
    return !0;
  }
  function Xt() {
    return !1;
  }
  function pt(a) {
    function o(p, b, R, I, V) {
      this._reactName = p, this._targetInst = R, this.type = b, this.nativeEvent = I, this.target = V, this.currentTarget = null;
      for (var K in a)
        a.hasOwnProperty(K) && (p = a[K], this[K] = p ? p(I) : I[K]);
      return this.isDefaultPrevented = (I.defaultPrevented != null ? I.defaultPrevented : I.returnValue === !1) ? Je : Xt, this.isPropagationStopped = Xt, this;
    }
    return _e(o.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var p = this.nativeEvent;
      p && (p.preventDefault ? p.preventDefault() : typeof p.returnValue != "unknown" && (p.returnValue = !1), this.isDefaultPrevented = Je);
    }, stopPropagation: function() {
      var p = this.nativeEvent;
      p && (p.stopPropagation ? p.stopPropagation() : typeof p.cancelBubble != "unknown" && (p.cancelBubble = !0), this.isPropagationStopped = Je);
    }, persist: function() {
    }, isPersistent: Je }), o;
  }
  var Wt = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(a) {
    return a.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Nn = pt(Wt), Yn = _e({}, Wt, { view: 0, detail: 0 }), Ir = pt(Yn), xn, Mr, Pn, Hn = _e({}, Yn, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: iv, button: 0, buttons: 0, relatedTarget: function(a) {
    return a.relatedTarget === void 0 ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
  }, movementX: function(a) {
    return "movementX" in a ? a.movementX : (a !== Pn && (Pn && a.type === "mousemove" ? (xn = a.screenX - Pn.screenX, Mr = a.screenY - Pn.screenY) : Mr = xn = 0, Pn = a), xn);
  }, movementY: function(a) {
    return "movementY" in a ? a.movementY : Mr;
  } }), Zl = pt(Hn), Ro = _e({}, Hn, { dataTransfer: 0 }), uu = pt(Ro), vd = _e({}, Yn, { relatedTarget: 0 }), qn = pt(vd), Jo = _e({}, Wt, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), lc = pt(Jo), ev = _e({}, Wt, { clipboardData: function(a) {
    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
  } }), tv = pt(ev), tb = _e({}, Wt, { data: 0 }), nv = pt(tb), rv = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, av = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, md = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function sc(a) {
    var o = this.nativeEvent;
    return o.getModifierState ? o.getModifierState(a) : (a = md[a]) ? !!o[a] : !1;
  }
  function iv() {
    return sc;
  }
  var Jl = _e({}, Yn, { key: function(a) {
    if (a.key) {
      var o = rv[a.key] || a.key;
      if (o !== "Unidentified")
        return o;
    }
    return a.type === "keypress" ? (a = Oe(a), a === 13 ? "Enter" : String.fromCharCode(a)) : a.type === "keydown" || a.type === "keyup" ? av[a.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: iv, charCode: function(a) {
    return a.type === "keypress" ? Oe(a) : 0;
  }, keyCode: function(a) {
    return a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
  }, which: function(a) {
    return a.type === "keypress" ? Oe(a) : a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
  } }), Rm = pt(Jl), gd = _e({}, Hn, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), tf = pt(gd), _p = _e({}, Yn, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: iv }), nb = pt(_p), nf = _e({}, Wt, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Op = pt(nf), so = _e({}, Hn, {
    deltaX: function(a) {
      return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
      return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Ql = pt(so), ur = [9, 13, 27, 32], To = y && "CompositionEvent" in window, Tl = null;
  y && "documentMode" in document && (Tl = document.documentMode);
  var bd = y && "TextEvent" in window && !Tl, ov = y && (!To || Tl && 8 < Tl && 11 >= Tl), rf = String.fromCharCode(32), Tm = !1;
  function wm(a, o) {
    switch (a) {
      case "keyup":
        return ur.indexOf(o.keyCode) !== -1;
      case "keydown":
        return o.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Lp(a) {
    return a = a.detail, typeof a == "object" && "data" in a ? a.data : null;
  }
  var af = !1;
  function of(a, o) {
    switch (a) {
      case "compositionend":
        return Lp(o);
      case "keypress":
        return o.which !== 32 ? null : (Tm = !0, rf);
      case "textInput":
        return a = o.data, a === rf && Tm ? null : a;
      default:
        return null;
    }
  }
  function rb(a, o) {
    if (af)
      return a === "compositionend" || !To && wm(a, o) ? (a = Te(), te = P = Dr = null, af = !1, a) : null;
    switch (a) {
      case "paste":
        return null;
      case "keypress":
        if (!(o.ctrlKey || o.altKey || o.metaKey) || o.ctrlKey && o.altKey) {
          if (o.char && 1 < o.char.length)
            return o.char;
          if (o.which)
            return String.fromCharCode(o.which);
        }
        return null;
      case "compositionend":
        return ov && o.locale !== "ko" ? null : o.data;
      default:
        return null;
    }
  }
  var Im = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function Dp(a) {
    var o = a && a.nodeName && a.nodeName.toLowerCase();
    return o === "input" ? !!Im[a.type] : o === "textarea";
  }
  function lv(a, o, p, b) {
    Pi(b), o = xd(o, "onChange"), 0 < o.length && (p = new Nn("onChange", "change", null, p, b), a.push({ event: p, listeners: o }));
  }
  var Qo = null, Ns = null;
  function lf(a) {
    Bp(a, 0);
  }
  function sf(a) {
    var o = Rn(a);
    if (Ze(o))
      return a;
  }
  function Am(a, o) {
    if (a === "change")
      return o;
  }
  var cu = !1;
  if (y) {
    var wo;
    if (y) {
      var Mp = "oninput" in document;
      if (!Mp) {
        var Nm = document.createElement("div");
        Nm.setAttribute("oninput", "return;"), Mp = typeof Nm.oninput == "function";
      }
      wo = Mp;
    } else
      wo = !1;
    cu = wo && (!document.documentMode || 9 < document.documentMode);
  }
  function _m() {
    Qo && (Qo.detachEvent("onpropertychange", Om), Ns = Qo = null);
  }
  function Om(a) {
    if (a.propertyName === "value" && sf(Ns)) {
      var o = [];
      lv(o, Ns, a, Qn(a)), Yl(lf, o);
    }
  }
  function ab(a, o, p) {
    a === "focusin" ? (_m(), Qo = o, Ns = p, Qo.attachEvent("onpropertychange", Om)) : a === "focusout" && _m();
  }
  function ib(a) {
    if (a === "selectionchange" || a === "keyup" || a === "keydown")
      return sf(Ns);
  }
  function uf(a, o) {
    if (a === "click")
      return sf(o);
  }
  function fe(a, o) {
    if (a === "input" || a === "change")
      return sf(o);
  }
  function De(a, o) {
    return a === o && (a !== 0 || 1 / a === 1 / o) || a !== a && o !== o;
  }
  var Re = typeof Object.is == "function" ? Object.is : De;
  function yt(a, o) {
    if (Re(a, o))
      return !0;
    if (typeof a != "object" || a === null || typeof o != "object" || o === null)
      return !1;
    var p = Object.keys(a), b = Object.keys(o);
    if (p.length !== b.length)
      return !1;
    for (b = 0; b < p.length; b++) {
      var R = p[b];
      if (!g.call(o, R) || !Re(a[R], o[R]))
        return !1;
    }
    return !0;
  }
  function gn(a) {
    for (; a && a.firstChild; )
      a = a.firstChild;
    return a;
  }
  function cr(a, o) {
    var p = gn(a);
    a = 0;
    for (var b; p; ) {
      if (p.nodeType === 3) {
        if (b = a + p.textContent.length, a <= o && b >= o)
          return { node: p, offset: o - a };
        a = b;
      }
      e: {
        for (; p; ) {
          if (p.nextSibling) {
            p = p.nextSibling;
            break e;
          }
          p = p.parentNode;
        }
        p = void 0;
      }
      p = gn(p);
    }
  }
  function ka(a, o) {
    return a && o ? a === o ? !0 : a && a.nodeType === 3 ? !1 : o && o.nodeType === 3 ? ka(a, o.parentNode) : "contains" in a ? a.contains(o) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(o) & 16) : !1 : !1;
  }
  function br() {
    for (var a = window, o = mn(); o instanceof a.HTMLIFrameElement; ) {
      try {
        var p = typeof o.contentWindow.location.href == "string";
      } catch {
        p = !1;
      }
      if (p)
        a = o.contentWindow;
      else
        break;
      o = mn(a.document);
    }
    return o;
  }
  function wl(a) {
    var o = a && a.nodeName && a.nodeName.toLowerCase();
    return o && (o === "input" && (a.type === "text" || a.type === "search" || a.type === "tel" || a.type === "url" || a.type === "password") || o === "textarea" || a.contentEditable === "true");
  }
  function Pp(a) {
    var o = br(), p = a.focusedElem, b = a.selectionRange;
    if (o !== p && p && p.ownerDocument && ka(p.ownerDocument.documentElement, p)) {
      if (b !== null && wl(p)) {
        if (o = b.start, a = b.end, a === void 0 && (a = o), "selectionStart" in p)
          p.selectionStart = o, p.selectionEnd = Math.min(a, p.value.length);
        else if (a = (o = p.ownerDocument || document) && o.defaultView || window, a.getSelection) {
          a = a.getSelection();
          var R = p.textContent.length, I = Math.min(b.start, R);
          b = b.end === void 0 ? I : Math.min(b.end, R), !a.extend && I > b && (R = b, b = I, I = R), R = cr(p, I);
          var V = cr(
            p,
            b
          );
          R && V && (a.rangeCount !== 1 || a.anchorNode !== R.node || a.anchorOffset !== R.offset || a.focusNode !== V.node || a.focusOffset !== V.offset) && (o = o.createRange(), o.setStart(R.node, R.offset), a.removeAllRanges(), I > b ? (a.addRange(o), a.extend(V.node, V.offset)) : (o.setEnd(V.node, V.offset), a.addRange(o)));
        }
      }
      for (o = [], a = p; a = a.parentNode; )
        a.nodeType === 1 && o.push({ element: a, left: a.scrollLeft, top: a.scrollTop });
      for (typeof p.focus == "function" && p.focus(), p = 0; p < o.length; p++)
        a = o[p], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
  }
  var Io = y && "documentMode" in document && 11 >= document.documentMode, uo = null, sv = null, Kl = null, cf = !1;
  function yd(a, o, p) {
    var b = p.window === p ? p.document : p.nodeType === 9 ? p : p.ownerDocument;
    cf || uo == null || uo !== mn(b) || (b = uo, "selectionStart" in b && wl(b) ? b = { start: b.selectionStart, end: b.selectionEnd } : (b = (b.ownerDocument && b.ownerDocument.defaultView || window).getSelection(), b = { anchorNode: b.anchorNode, anchorOffset: b.anchorOffset, focusNode: b.focusNode, focusOffset: b.focusOffset }), Kl && yt(Kl, b) || (Kl = b, b = xd(sv, "onSelect"), 0 < b.length && (o = new Nn("onSelect", "select", null, o, p), a.push({ event: o, listeners: b }), o.target = uo)));
  }
  function fr(a, o) {
    var p = {};
    return p[a.toLowerCase()] = o.toLowerCase(), p["Webkit" + a] = "webkit" + o, p["Moz" + a] = "moz" + o, p;
  }
  var uc = { animationend: fr("Animation", "AnimationEnd"), animationiteration: fr("Animation", "AnimationIteration"), animationstart: fr("Animation", "AnimationStart"), transitionend: fr("Transition", "TransitionEnd") }, kp = {}, ff = {};
  y && (ff = document.createElement("div").style, "AnimationEvent" in window || (delete uc.animationend.animation, delete uc.animationiteration.animation, delete uc.animationstart.animation), "TransitionEvent" in window || delete uc.transitionend.transition);
  function ni(a) {
    if (kp[a])
      return kp[a];
    if (!uc[a])
      return a;
    var o = uc[a], p;
    for (p in o)
      if (o.hasOwnProperty(p) && p in ff)
        return kp[a] = o[p];
    return a;
  }
  var uv = ni("animationend"), Lm = ni("animationiteration"), Cd = ni("animationstart"), _s = ni("transitionend"), Ed = /* @__PURE__ */ new Map(), cv = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Ko(a, o) {
    Ed.set(a, o), v(o, [a]);
  }
  for (var df = 0; df < cv.length; df++) {
    var fu = cv[df], Fp = fu.toLowerCase(), pf = fu[0].toUpperCase() + fu.slice(1);
    Ko(Fp, "on" + pf);
  }
  Ko(uv, "onAnimationEnd"), Ko(Lm, "onAnimationIteration"), Ko(Cd, "onAnimationStart"), Ko("dblclick", "onDoubleClick"), Ko("focusin", "onFocus"), Ko("focusout", "onBlur"), Ko(_s, "onTransitionEnd"), h("onMouseEnter", ["mouseout", "mouseover"]), h("onMouseLeave", ["mouseout", "mouseover"]), h("onPointerEnter", ["pointerout", "pointerover"]), h("onPointerLeave", ["pointerout", "pointerover"]), v("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), v("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), v("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), v("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), v("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), v("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Os = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), cc = new Set("cancel close invalid load scroll toggle".split(" ").concat(Os));
  function Sd(a, o, p) {
    var b = a.type || "unknown-event";
    a.currentTarget = p, be(b, o, void 0, a), a.currentTarget = null;
  }
  function Bp(a, o) {
    o = (o & 4) !== 0;
    for (var p = 0; p < a.length; p++) {
      var b = a[p], R = b.event;
      b = b.listeners;
      e: {
        var I = void 0;
        if (o)
          for (var V = b.length - 1; 0 <= V; V--) {
            var K = b[V], ie = K.instance, we = K.currentTarget;
            if (K = K.listener, ie !== I && R.isPropagationStopped())
              break e;
            Sd(R, K, we), I = ie;
          }
        else
          for (V = 0; V < b.length; V++) {
            if (K = b[V], ie = K.instance, we = K.currentTarget, K = K.listener, ie !== I && R.isPropagationStopped())
              break e;
            Sd(R, K, we), I = ie;
          }
      }
    }
    if (_t)
      throw a = Vt, _t = !1, Vt = null, a;
  }
  function Pr(a, o) {
    var p = o[jp];
    p === void 0 && (p = o[jp] = /* @__PURE__ */ new Set());
    var b = a + "__bubble";
    p.has(b) || (Up(o, a, 2, !1), p.add(b));
  }
  function du(a, o, p) {
    var b = 0;
    o && (b |= 4), Up(p, a, b, o);
  }
  var qo = "_reactListening" + Math.random().toString(36).slice(2);
  function Ls(a) {
    if (!a[qo]) {
      a[qo] = !0, u.forEach(function(p) {
        p !== "selectionchange" && (cc.has(p) || du(p, !1, a), du(p, !0, a));
      });
      var o = a.nodeType === 9 ? a : a.ownerDocument;
      o === null || o[qo] || (o[qo] = !0, du("selectionchange", !1, o));
    }
  }
  function Up(a, o, p, b) {
    switch (hd(o)) {
      case 1:
        var R = ef;
        break;
      case 4:
        R = lu;
        break;
      default:
        R = su;
    }
    p = R.bind(null, o, p, a), R = void 0, !ne || o !== "touchstart" && o !== "touchmove" && o !== "wheel" || (R = !0), b ? R !== void 0 ? a.addEventListener(o, p, { capture: !0, passive: R }) : a.addEventListener(o, p, !0) : R !== void 0 ? a.addEventListener(o, p, { passive: R }) : a.addEventListener(o, p, !1);
  }
  function Vp(a, o, p, b, R) {
    var I = b;
    if (!(o & 1) && !(o & 2) && b !== null)
      e:
        for (; ; ) {
          if (b === null)
            return;
          var V = b.tag;
          if (V === 3 || V === 4) {
            var K = b.stateNode.containerInfo;
            if (K === R || K.nodeType === 8 && K.parentNode === R)
              break;
            if (V === 4)
              for (V = b.return; V !== null; ) {
                var ie = V.tag;
                if ((ie === 3 || ie === 4) && (ie = V.stateNode.containerInfo, ie === R || ie.nodeType === 8 && ie.parentNode === R))
                  return;
                V = V.return;
              }
            for (; K !== null; ) {
              if (V = Bi(K), V === null)
                return;
              if (ie = V.tag, ie === 5 || ie === 6) {
                b = I = V;
                continue e;
              }
              K = K.parentNode;
            }
          }
          b = b.return;
        }
    Yl(function() {
      var we = I, Qe = Qn(p), Ke = [];
      e: {
        var Ye = Ed.get(a);
        if (Ye !== void 0) {
          var Ct = Nn, Ot = a;
          switch (a) {
            case "keypress":
              if (Oe(p) === 0)
                break e;
            case "keydown":
            case "keyup":
              Ct = Rm;
              break;
            case "focusin":
              Ot = "focus", Ct = qn;
              break;
            case "focusout":
              Ot = "blur", Ct = qn;
              break;
            case "beforeblur":
            case "afterblur":
              Ct = qn;
              break;
            case "click":
              if (p.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Ct = Zl;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Ct = uu;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Ct = nb;
              break;
            case uv:
            case Lm:
            case Cd:
              Ct = lc;
              break;
            case _s:
              Ct = Op;
              break;
            case "scroll":
              Ct = Ir;
              break;
            case "wheel":
              Ct = Ql;
              break;
            case "copy":
            case "cut":
            case "paste":
              Ct = tv;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Ct = tf;
          }
          var Lt = (o & 4) !== 0, Aa = !Lt && a === "scroll", ge = Lt ? Ye !== null ? Ye + "Capture" : null : Ye;
          Lt = [];
          for (var le = we, ye; le !== null; ) {
            ye = le;
            var tt = ye.stateNode;
            if (ye.tag === 5 && tt !== null && (ye = tt, ge !== null && (tt = ki(le, ge), tt != null && Lt.push(hf(le, tt, ye)))), Aa)
              break;
            le = le.return;
          }
          0 < Lt.length && (Ye = new Ct(Ye, Ot, null, p, Qe), Ke.push({ event: Ye, listeners: Lt }));
        }
      }
      if (!(o & 7)) {
        e: {
          if (Ye = a === "mouseover" || a === "pointerover", Ct = a === "mouseout" || a === "pointerout", Ye && p !== Ga && (Ot = p.relatedTarget || p.fromElement) && (Bi(Ot) || Ot[Ao]))
            break e;
          if ((Ct || Ye) && (Ye = Qe.window === Qe ? Qe : (Ye = Qe.ownerDocument) ? Ye.defaultView || Ye.parentWindow : window, Ct ? (Ot = p.relatedTarget || p.toElement, Ct = we, Ot = Ot ? Bi(Ot) : null, Ot !== null && (Aa = Fe(Ot), Ot !== Aa || Ot.tag !== 5 && Ot.tag !== 6) && (Ot = null)) : (Ct = null, Ot = we), Ct !== Ot)) {
            if (Lt = Zl, tt = "onMouseLeave", ge = "onMouseEnter", le = "mouse", (a === "pointerout" || a === "pointerover") && (Lt = tf, tt = "onPointerLeave", ge = "onPointerEnter", le = "pointer"), Aa = Ct == null ? Ye : Rn(Ct), ye = Ot == null ? Ye : Rn(Ot), Ye = new Lt(tt, le + "leave", Ct, p, Qe), Ye.target = Aa, Ye.relatedTarget = ye, tt = null, Bi(Qe) === we && (Lt = new Lt(ge, le + "enter", Ot, p, Qe), Lt.target = ye, Lt.relatedTarget = Aa, tt = Lt), Aa = tt, Ct && Ot)
              t: {
                for (Lt = Ct, ge = Ot, le = 0, ye = Lt; ye; ye = fc(ye))
                  le++;
                for (ye = 0, tt = ge; tt; tt = fc(tt))
                  ye++;
                for (; 0 < le - ye; )
                  Lt = fc(Lt), le--;
                for (; 0 < ye - le; )
                  ge = fc(ge), ye--;
                for (; le--; ) {
                  if (Lt === ge || ge !== null && Lt === ge.alternate)
                    break t;
                  Lt = fc(Lt), ge = fc(ge);
                }
                Lt = null;
              }
            else
              Lt = null;
            Ct !== null && wa(Ke, Ye, Ct, Lt, !1), Ot !== null && Aa !== null && wa(Ke, Aa, Ot, Lt, !0);
          }
        }
        e: {
          if (Ye = we ? Rn(we) : window, Ct = Ye.nodeName && Ye.nodeName.toLowerCase(), Ct === "select" || Ct === "input" && Ye.type === "file")
            var Bt = Am;
          else if (Dp(Ye))
            if (cu)
              Bt = fe;
            else {
              Bt = ib;
              var Jt = ab;
            }
          else
            (Ct = Ye.nodeName) && Ct.toLowerCase() === "input" && (Ye.type === "checkbox" || Ye.type === "radio") && (Bt = uf);
          if (Bt && (Bt = Bt(a, we))) {
            lv(Ke, Bt, p, Qe);
            break e;
          }
          Jt && Jt(a, Ye, we), a === "focusout" && (Jt = Ye._wrapperState) && Jt.controlled && Ye.type === "number" && ja(Ye, "number", Ye.value);
        }
        switch (Jt = we ? Rn(we) : window, a) {
          case "focusin":
            (Dp(Jt) || Jt.contentEditable === "true") && (uo = Jt, sv = we, Kl = null);
            break;
          case "focusout":
            Kl = sv = uo = null;
            break;
          case "mousedown":
            cf = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            cf = !1, yd(Ke, p, Qe);
            break;
          case "selectionchange":
            if (Io)
              break;
          case "keydown":
          case "keyup":
            yd(Ke, p, Qe);
        }
        var Nt;
        if (To)
          e: {
            switch (a) {
              case "compositionstart":
                var Qt = "onCompositionStart";
                break e;
              case "compositionend":
                Qt = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Qt = "onCompositionUpdate";
                break e;
            }
            Qt = void 0;
          }
        else
          af ? wm(a, p) && (Qt = "onCompositionEnd") : a === "keydown" && p.keyCode === 229 && (Qt = "onCompositionStart");
        Qt && (ov && p.locale !== "ko" && (af || Qt !== "onCompositionStart" ? Qt === "onCompositionEnd" && af && (Nt = Te()) : (Dr = Qe, P = "value" in Dr ? Dr.value : Dr.textContent, af = !0)), Jt = xd(we, Qt), 0 < Jt.length && (Qt = new nv(Qt, a, null, p, Qe), Ke.push({ event: Qt, listeners: Jt }), Nt ? Qt.data = Nt : (Nt = Lp(p), Nt !== null && (Qt.data = Nt)))), (Nt = bd ? of(a, p) : rb(a, p)) && (we = xd(we, "onBeforeInput"), 0 < we.length && (Qe = new nv("onBeforeInput", "beforeinput", null, p, Qe), Ke.push({ event: Qe, listeners: we }), Qe.data = Nt));
      }
      Bp(Ke, o);
    });
  }
  function hf(a, o, p) {
    return { instance: a, listener: o, currentTarget: p };
  }
  function xd(a, o) {
    for (var p = o + "Capture", b = []; a !== null; ) {
      var R = a, I = R.stateNode;
      R.tag === 5 && I !== null && (R = I, I = ki(a, p), I != null && b.unshift(hf(a, I, R)), I = ki(a, o), I != null && b.push(hf(a, I, R))), a = a.return;
    }
    return b;
  }
  function fc(a) {
    if (a === null)
      return null;
    do
      a = a.return;
    while (a && a.tag !== 5);
    return a || null;
  }
  function wa(a, o, p, b, R) {
    for (var I = o._reactName, V = []; p !== null && p !== b; ) {
      var K = p, ie = K.alternate, we = K.stateNode;
      if (ie !== null && ie === b)
        break;
      K.tag === 5 && we !== null && (K = we, R ? (ie = ki(p, I), ie != null && V.unshift(hf(p, ie, K))) : R || (ie = ki(p, I), ie != null && V.push(hf(p, ie, K)))), p = p.return;
    }
    V.length !== 0 && a.push({ event: o, listeners: V });
  }
  var ri = /\r\n?/g, ob = /\u0000|\uFFFD/g;
  function fv(a) {
    return (typeof a == "string" ? a : "" + a).replace(ri, `
`).replace(ob, "");
  }
  function Rd(a, o, p) {
    if (o = fv(o), fv(a) !== o && p)
      throw Error(i(425));
  }
  function Hp() {
  }
  var Td = null, Il = null;
  function dc(a, o) {
    return a === "textarea" || a === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
  }
  var el = typeof setTimeout == "function" ? setTimeout : void 0, vf = typeof clearTimeout == "function" ? clearTimeout : void 0, pc = typeof Promise == "function" ? Promise : void 0, mf = typeof queueMicrotask == "function" ? queueMicrotask : typeof pc < "u" ? function(a) {
    return pc.resolve(null).then(a).catch(gf);
  } : el;
  function gf(a) {
    setTimeout(function() {
      throw a;
    });
  }
  function pu(a, o) {
    var p = o, b = 0;
    do {
      var R = p.nextSibling;
      if (a.removeChild(p), R && R.nodeType === 8)
        if (p = R.data, p === "/$") {
          if (b === 0) {
            a.removeChild(R), ir(o);
            return;
          }
          b--;
        } else
          p !== "$" && p !== "$?" && p !== "$!" || b++;
      p = R;
    } while (p);
    ir(o);
  }
  function Al(a) {
    for (; a != null; a = a.nextSibling) {
      var o = a.nodeType;
      if (o === 1 || o === 3)
        break;
      if (o === 8) {
        if (o = a.data, o === "$" || o === "$!" || o === "$?")
          break;
        if (o === "/$")
          return null;
      }
    }
    return a;
  }
  function wd(a) {
    a = a.previousSibling;
    for (var o = 0; a; ) {
      if (a.nodeType === 8) {
        var p = a.data;
        if (p === "$" || p === "$!" || p === "$?") {
          if (o === 0)
            return a;
          o--;
        } else
          p === "/$" && o++;
      }
      a = a.previousSibling;
    }
    return null;
  }
  var hu = Math.random().toString(36).slice(2), ql = "__reactFiber$" + hu, es = "__reactProps$" + hu, Ao = "__reactContainer$" + hu, jp = "__reactEvents$" + hu, z = "__reactListeners$" + hu, vu = "__reactHandles$" + hu;
  function Bi(a) {
    var o = a[ql];
    if (o)
      return o;
    for (var p = a.parentNode; p; ) {
      if (o = p[Ao] || p[ql]) {
        if (p = o.alternate, o.child !== null || p !== null && p.child !== null)
          for (a = wd(a); a !== null; ) {
            if (p = a[ql])
              return p;
            a = wd(a);
          }
        return o;
      }
      a = p, p = a.parentNode;
    }
    return null;
  }
  function xi(a) {
    return a = a[ql] || a[Ao], !a || a.tag !== 5 && a.tag !== 6 && a.tag !== 13 && a.tag !== 3 ? null : a;
  }
  function Rn(a) {
    if (a.tag === 5 || a.tag === 6)
      return a.stateNode;
    throw Error(i(33));
  }
  function zt(a) {
    return a[es] || null;
  }
  var mu = [], Xr = -1;
  function ln(a) {
    return { current: a };
  }
  function vr(a) {
    0 > Xr || (a.current = mu[Xr], mu[Xr] = null, Xr--);
  }
  function yr(a, o) {
    Xr++, mu[Xr] = a.current, a.current = o;
  }
  var ts = {}, un = ln(ts), pa = ln(!1), ha = ts;
  function tl(a, o) {
    var p = a.type.contextTypes;
    if (!p)
      return ts;
    var b = a.stateNode;
    if (b && b.__reactInternalMemoizedUnmaskedChildContext === o)
      return b.__reactInternalMemoizedMaskedChildContext;
    var R = {}, I;
    for (I in p)
      R[I] = o[I];
    return b && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = o, a.__reactInternalMemoizedMaskedChildContext = R), R;
  }
  function ea(a) {
    return a = a.childContextTypes, a != null;
  }
  function nl() {
    vr(pa), vr(un);
  }
  function gu(a, o, p) {
    if (un.current !== ts)
      throw Error(i(168));
    yr(un, o), yr(pa, p);
  }
  function Id(a, o, p) {
    var b = a.stateNode;
    if (o = o.childContextTypes, typeof b.getChildContext != "function")
      return p;
    b = b.getChildContext();
    for (var R in b)
      if (!(R in o))
        throw Error(i(108, Rt(a) || "Unknown", R));
    return _e({}, p, b);
  }
  function rl(a) {
    return a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || ts, ha = un.current, yr(un, a), yr(pa, pa.current), !0;
  }
  function Dm(a, o, p) {
    var b = a.stateNode;
    if (!b)
      throw Error(i(169));
    p ? (a = Id(a, o, ha), b.__reactInternalMemoizedMergedChildContext = a, vr(pa), vr(un), yr(un, a)) : vr(pa), yr(pa, p);
  }
  var No = null, ai = !1, Ad = !1;
  function dv(a) {
    No === null ? No = [a] : No.push(a);
  }
  function Ds(a) {
    ai = !0, dv(a);
  }
  function co() {
    if (!Ad && No !== null) {
      Ad = !0;
      var a = 0, o = Kn;
      try {
        var p = No;
        for (Kn = 1; a < p.length; a++) {
          var b = p[a];
          do
            b = b(!0);
          while (b !== null);
        }
        No = null, ai = !1;
      } catch (R) {
        throw No !== null && (No = No.slice(a + 1)), nn(Ra, co), R;
      } finally {
        Kn = o, Ad = !1;
      }
    }
    return null;
  }
  var bu = [], ta = 0, hc = null, bf = 0, fo = [], Ri = 0, al = null, ii = 1, ns = "";
  function _o(a, o) {
    bu[ta++] = bf, bu[ta++] = hc, hc = a, bf = o;
  }
  function pv(a, o, p) {
    fo[Ri++] = ii, fo[Ri++] = ns, fo[Ri++] = al, al = a;
    var b = ii;
    a = ns;
    var R = 32 - Bn(b) - 1;
    b &= ~(1 << R), p += 1;
    var I = 32 - Bn(o) + R;
    if (30 < I) {
      var V = R - R % 5;
      I = (b & (1 << V) - 1).toString(32), b >>= V, R -= V, ii = 1 << 32 - Bn(o) + R | p << R | b, ns = I + a;
    } else
      ii = 1 << I | p << R | b, ns = a;
  }
  function yf(a) {
    a.return !== null && (_o(a, 1), pv(a, 1, 0));
  }
  function vc(a) {
    for (; a === hc; )
      hc = bu[--ta], bu[ta] = null, bf = bu[--ta], bu[ta] = null;
    for (; a === al; )
      al = fo[--Ri], fo[Ri] = null, ns = fo[--Ri], fo[Ri] = null, ii = fo[--Ri], fo[Ri] = null;
  }
  var Ti = null, po = null, Vr = !1, il = null;
  function Nl(a, o) {
    var p = hl(5, null, null, 0);
    p.elementType = "DELETED", p.stateNode = o, p.return = a, o = a.deletions, o === null ? (a.deletions = [p], a.flags |= 16) : o.push(p);
  }
  function Gp(a, o) {
    switch (a.tag) {
      case 5:
        var p = a.type;
        return o = o.nodeType !== 1 || p.toLowerCase() !== o.nodeName.toLowerCase() ? null : o, o !== null ? (a.stateNode = o, Ti = a, po = Al(o.firstChild), !0) : !1;
      case 6:
        return o = a.pendingProps === "" || o.nodeType !== 3 ? null : o, o !== null ? (a.stateNode = o, Ti = a, po = null, !0) : !1;
      case 13:
        return o = o.nodeType !== 8 ? null : o, o !== null ? (p = al !== null ? { id: ii, overflow: ns } : null, a.memoizedState = { dehydrated: o, treeContext: p, retryLane: 1073741824 }, p = hl(18, null, null, 0), p.stateNode = o, p.return = a, a.child = p, Ti = a, po = null, !0) : !1;
      default:
        return !1;
    }
  }
  function rs(a) {
    return (a.mode & 1) !== 0 && (a.flags & 128) === 0;
  }
  function Ui(a) {
    if (Vr) {
      var o = po;
      if (o) {
        var p = o;
        if (!Gp(a, o)) {
          if (rs(a))
            throw Error(i(418));
          o = Al(p.nextSibling);
          var b = Ti;
          o && Gp(a, o) ? Nl(b, p) : (a.flags = a.flags & -4097 | 2, Vr = !1, Ti = a);
        }
      } else {
        if (rs(a))
          throw Error(i(418));
        a.flags = a.flags & -4097 | 2, Vr = !1, Ti = a;
      }
    }
  }
  function Mm(a) {
    for (a = a.return; a !== null && a.tag !== 5 && a.tag !== 3 && a.tag !== 13; )
      a = a.return;
    Ti = a;
  }
  function Nd(a) {
    if (a !== Ti)
      return !1;
    if (!Vr)
      return Mm(a), Vr = !0, !1;
    var o;
    if ((o = a.tag !== 3) && !(o = a.tag !== 5) && (o = a.type, o = o !== "head" && o !== "body" && !dc(a.type, a.memoizedProps)), o && (o = po)) {
      if (rs(a))
        throw hv(), Error(i(418));
      for (; o; )
        Nl(a, o), o = Al(o.nextSibling);
    }
    if (Mm(a), a.tag === 13) {
      if (a = a.memoizedState, a = a !== null ? a.dehydrated : null, !a)
        throw Error(i(317));
      e: {
        for (a = a.nextSibling, o = 0; a; ) {
          if (a.nodeType === 8) {
            var p = a.data;
            if (p === "/$") {
              if (o === 0) {
                po = Al(a.nextSibling);
                break e;
              }
              o--;
            } else
              p !== "$" && p !== "$!" && p !== "$?" || o++;
          }
          a = a.nextSibling;
        }
        po = null;
      }
    } else
      po = Ti ? Al(a.stateNode.nextSibling) : null;
    return !0;
  }
  function hv() {
    for (var a = po; a; )
      a = Al(a.nextSibling);
  }
  function kr() {
    po = Ti = null, Vr = !1;
  }
  function as(a) {
    il === null ? il = [a] : il.push(a);
  }
  var _d = Q.ReactCurrentBatchConfig;
  function mc(a, o, p) {
    if (a = p.ref, a !== null && typeof a != "function" && typeof a != "object") {
      if (p._owner) {
        if (p = p._owner, p) {
          if (p.tag !== 1)
            throw Error(i(309));
          var b = p.stateNode;
        }
        if (!b)
          throw Error(i(147, a));
        var R = b, I = "" + a;
        return o !== null && o.ref !== null && typeof o.ref == "function" && o.ref._stringRef === I ? o.ref : (o = function(V) {
          var K = R.refs;
          V === null ? delete K[I] : K[I] = V;
        }, o._stringRef = I, o);
      }
      if (typeof a != "string")
        throw Error(i(284));
      if (!p._owner)
        throw Error(i(290, a));
    }
    return a;
  }
  function Oo(a, o) {
    throw a = Object.prototype.toString.call(o), Error(i(31, a === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : a));
  }
  function Pm(a) {
    var o = a._init;
    return o(a._payload);
  }
  function Od(a) {
    function o(ge, le) {
      if (a) {
        var ye = ge.deletions;
        ye === null ? (ge.deletions = [le], ge.flags |= 16) : ye.push(le);
      }
    }
    function p(ge, le) {
      if (!a)
        return null;
      for (; le !== null; )
        o(ge, le), le = le.sibling;
      return null;
    }
    function b(ge, le) {
      for (ge = /* @__PURE__ */ new Map(); le !== null; )
        le.key !== null ? ge.set(le.key, le) : ge.set(le.index, le), le = le.sibling;
      return ge;
    }
    function R(ge, le) {
      return ge = Ml(ge, le), ge.index = 0, ge.sibling = null, ge;
    }
    function I(ge, le, ye) {
      return ge.index = ye, a ? (ye = ge.alternate, ye !== null ? (ye = ye.index, ye < le ? (ge.flags |= 2, le) : ye) : (ge.flags |= 2, le)) : (ge.flags |= 1048576, le);
    }
    function V(ge) {
      return a && ge.alternate === null && (ge.flags |= 2), ge;
    }
    function K(ge, le, ye, tt) {
      return le === null || le.tag !== 6 ? (le = Eh(ye, ge.mode, tt), le.return = ge, le) : (le = R(le, ye), le.return = ge, le);
    }
    function ie(ge, le, ye, tt) {
      var Bt = ye.type;
      return Bt === j ? Qe(ge, le, ye.props.children, tt, ye.key) : le !== null && (le.elementType === Bt || typeof Bt == "object" && Bt !== null && Bt.$$typeof === st && Pm(Bt) === le.type) ? (tt = R(le, ye.props), tt.ref = mc(ge, le, ye), tt.return = ge, tt) : (tt = yh(ye.type, ye.key, ye.props, null, ge.mode, tt), tt.ref = mc(ge, le, ye), tt.return = ge, tt);
    }
    function we(ge, le, ye, tt) {
      return le === null || le.tag !== 4 || le.stateNode.containerInfo !== ye.containerInfo || le.stateNode.implementation !== ye.implementation ? (le = qd(ye, ge.mode, tt), le.return = ge, le) : (le = R(le, ye.children || []), le.return = ge, le);
    }
    function Qe(ge, le, ye, tt, Bt) {
      return le === null || le.tag !== 7 ? (le = Pc(ye, ge.mode, tt, Bt), le.return = ge, le) : (le = R(le, ye), le.return = ge, le);
    }
    function Ke(ge, le, ye) {
      if (typeof le == "string" && le !== "" || typeof le == "number")
        return le = Eh("" + le, ge.mode, ye), le.return = ge, le;
      if (typeof le == "object" && le !== null) {
        switch (le.$$typeof) {
          case W:
            return ye = yh(le.type, le.key, le.props, null, ge.mode, ye), ye.ref = mc(ge, null, le), ye.return = ge, ye;
          case oe:
            return le = qd(le, ge.mode, ye), le.return = ge, le;
          case st:
            var tt = le._init;
            return Ke(ge, tt(le._payload), ye);
        }
        if (qr(le) || ke(le))
          return le = Pc(le, ge.mode, ye, null), le.return = ge, le;
        Oo(ge, le);
      }
      return null;
    }
    function Ye(ge, le, ye, tt) {
      var Bt = le !== null ? le.key : null;
      if (typeof ye == "string" && ye !== "" || typeof ye == "number")
        return Bt !== null ? null : K(ge, le, "" + ye, tt);
      if (typeof ye == "object" && ye !== null) {
        switch (ye.$$typeof) {
          case W:
            return ye.key === Bt ? ie(ge, le, ye, tt) : null;
          case oe:
            return ye.key === Bt ? we(ge, le, ye, tt) : null;
          case st:
            return Bt = ye._init, Ye(
              ge,
              le,
              Bt(ye._payload),
              tt
            );
        }
        if (qr(ye) || ke(ye))
          return Bt !== null ? null : Qe(ge, le, ye, tt, null);
        Oo(ge, ye);
      }
      return null;
    }
    function Ct(ge, le, ye, tt, Bt) {
      if (typeof tt == "string" && tt !== "" || typeof tt == "number")
        return ge = ge.get(ye) || null, K(le, ge, "" + tt, Bt);
      if (typeof tt == "object" && tt !== null) {
        switch (tt.$$typeof) {
          case W:
            return ge = ge.get(tt.key === null ? ye : tt.key) || null, ie(le, ge, tt, Bt);
          case oe:
            return ge = ge.get(tt.key === null ? ye : tt.key) || null, we(le, ge, tt, Bt);
          case st:
            var Jt = tt._init;
            return Ct(ge, le, ye, Jt(tt._payload), Bt);
        }
        if (qr(tt) || ke(tt))
          return ge = ge.get(ye) || null, Qe(le, ge, tt, Bt, null);
        Oo(le, tt);
      }
      return null;
    }
    function Ot(ge, le, ye, tt) {
      for (var Bt = null, Jt = null, Nt = le, Qt = le = 0, Za = null; Nt !== null && Qt < ye.length; Qt++) {
        Nt.index > Qt ? (Za = Nt, Nt = null) : Za = Nt.sibling;
        var dr = Ye(ge, Nt, ye[Qt], tt);
        if (dr === null) {
          Nt === null && (Nt = Za);
          break;
        }
        a && Nt && dr.alternate === null && o(ge, Nt), le = I(dr, le, Qt), Jt === null ? Bt = dr : Jt.sibling = dr, Jt = dr, Nt = Za;
      }
      if (Qt === ye.length)
        return p(ge, Nt), Vr && _o(ge, Qt), Bt;
      if (Nt === null) {
        for (; Qt < ye.length; Qt++)
          Nt = Ke(ge, ye[Qt], tt), Nt !== null && (le = I(Nt, le, Qt), Jt === null ? Bt = Nt : Jt.sibling = Nt, Jt = Nt);
        return Vr && _o(ge, Qt), Bt;
      }
      for (Nt = b(ge, Nt); Qt < ye.length; Qt++)
        Za = Ct(Nt, ge, Qt, ye[Qt], tt), Za !== null && (a && Za.alternate !== null && Nt.delete(Za.key === null ? Qt : Za.key), le = I(Za, le, Qt), Jt === null ? Bt = Za : Jt.sibling = Za, Jt = Za);
      return a && Nt.forEach(function(Ws) {
        return o(ge, Ws);
      }), Vr && _o(ge, Qt), Bt;
    }
    function Lt(ge, le, ye, tt) {
      var Bt = ke(ye);
      if (typeof Bt != "function")
        throw Error(i(150));
      if (ye = Bt.call(ye), ye == null)
        throw Error(i(151));
      for (var Jt = Bt = null, Nt = le, Qt = le = 0, Za = null, dr = ye.next(); Nt !== null && !dr.done; Qt++, dr = ye.next()) {
        Nt.index > Qt ? (Za = Nt, Nt = null) : Za = Nt.sibling;
        var Ws = Ye(ge, Nt, dr.value, tt);
        if (Ws === null) {
          Nt === null && (Nt = Za);
          break;
        }
        a && Nt && Ws.alternate === null && o(ge, Nt), le = I(Ws, le, Qt), Jt === null ? Bt = Ws : Jt.sibling = Ws, Jt = Ws, Nt = Za;
      }
      if (dr.done)
        return p(
          ge,
          Nt
        ), Vr && _o(ge, Qt), Bt;
      if (Nt === null) {
        for (; !dr.done; Qt++, dr = ye.next())
          dr = Ke(ge, dr.value, tt), dr !== null && (le = I(dr, le, Qt), Jt === null ? Bt = dr : Jt.sibling = dr, Jt = dr);
        return Vr && _o(ge, Qt), Bt;
      }
      for (Nt = b(ge, Nt); !dr.done; Qt++, dr = ye.next())
        dr = Ct(Nt, ge, Qt, dr.value, tt), dr !== null && (a && dr.alternate !== null && Nt.delete(dr.key === null ? Qt : dr.key), le = I(dr, le, Qt), Jt === null ? Bt = dr : Jt.sibling = dr, Jt = dr);
      return a && Nt.forEach(function(Eb) {
        return o(ge, Eb);
      }), Vr && _o(ge, Qt), Bt;
    }
    function Aa(ge, le, ye, tt) {
      if (typeof ye == "object" && ye !== null && ye.type === j && ye.key === null && (ye = ye.props.children), typeof ye == "object" && ye !== null) {
        switch (ye.$$typeof) {
          case W:
            e: {
              for (var Bt = ye.key, Jt = le; Jt !== null; ) {
                if (Jt.key === Bt) {
                  if (Bt = ye.type, Bt === j) {
                    if (Jt.tag === 7) {
                      p(ge, Jt.sibling), le = R(Jt, ye.props.children), le.return = ge, ge = le;
                      break e;
                    }
                  } else if (Jt.elementType === Bt || typeof Bt == "object" && Bt !== null && Bt.$$typeof === st && Pm(Bt) === Jt.type) {
                    p(ge, Jt.sibling), le = R(Jt, ye.props), le.ref = mc(ge, Jt, ye), le.return = ge, ge = le;
                    break e;
                  }
                  p(ge, Jt);
                  break;
                } else
                  o(ge, Jt);
                Jt = Jt.sibling;
              }
              ye.type === j ? (le = Pc(ye.props.children, ge.mode, tt, ye.key), le.return = ge, ge = le) : (tt = yh(ye.type, ye.key, ye.props, null, ge.mode, tt), tt.ref = mc(ge, le, ye), tt.return = ge, ge = tt);
            }
            return V(ge);
          case oe:
            e: {
              for (Jt = ye.key; le !== null; ) {
                if (le.key === Jt)
                  if (le.tag === 4 && le.stateNode.containerInfo === ye.containerInfo && le.stateNode.implementation === ye.implementation) {
                    p(ge, le.sibling), le = R(le, ye.children || []), le.return = ge, ge = le;
                    break e;
                  } else {
                    p(ge, le);
                    break;
                  }
                else
                  o(ge, le);
                le = le.sibling;
              }
              le = qd(ye, ge.mode, tt), le.return = ge, ge = le;
            }
            return V(ge);
          case st:
            return Jt = ye._init, Aa(ge, le, Jt(ye._payload), tt);
        }
        if (qr(ye))
          return Ot(ge, le, ye, tt);
        if (ke(ye))
          return Lt(ge, le, ye, tt);
        Oo(ge, ye);
      }
      return typeof ye == "string" && ye !== "" || typeof ye == "number" ? (ye = "" + ye, le !== null && le.tag === 6 ? (p(ge, le.sibling), le = R(le, ye), le.return = ge, ge = le) : (p(ge, le), le = Eh(ye, ge.mode, tt), le.return = ge, ge = le), V(ge)) : p(ge, le);
    }
    return Aa;
  }
  var va = Od(!0), zp = Od(!1), is = ln(null), Ar = null, ct = null, Vi = null;
  function za() {
    Vi = ct = Ar = null;
  }
  function Wp(a) {
    var o = is.current;
    vr(is), a._currentValue = o;
  }
  function di(a, o, p) {
    for (; a !== null; ) {
      var b = a.alternate;
      if ((a.childLanes & o) !== o ? (a.childLanes |= o, b !== null && (b.childLanes |= o)) : b !== null && (b.childLanes & o) !== o && (b.childLanes |= o), a === p)
        break;
      a = a.return;
    }
  }
  function yu(a, o) {
    Ar = a, Vi = ct = null, a = a.dependencies, a !== null && a.firstContext !== null && (a.lanes & o && (zi = !0), a.firstContext = null);
  }
  function ol(a) {
    var o = a._currentValue;
    if (Vi !== a)
      if (a = { context: a, memoizedValue: o, next: null }, ct === null) {
        if (Ar === null)
          throw Error(i(308));
        ct = a, Ar.dependencies = { lanes: 0, firstContext: a };
      } else
        ct = ct.next = a;
    return o;
  }
  var gc = null;
  function Fa(a) {
    gc === null ? gc = [a] : gc.push(a);
  }
  function Xp(a, o, p, b) {
    var R = o.interleaved;
    return R === null ? (p.next = p, Fa(o)) : (p.next = R.next, R.next = p), o.interleaved = p, Ms(a, b);
  }
  function Ms(a, o) {
    a.lanes |= o;
    var p = a.alternate;
    for (p !== null && (p.lanes |= o), p = a, a = a.return; a !== null; )
      a.childLanes |= o, p = a.alternate, p !== null && (p.childLanes |= o), p = a, a = a.return;
    return p.tag === 3 ? p.stateNode : null;
  }
  var ll = !1;
  function Ld(a) {
    a.updateQueue = { baseState: a.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function Cf(a, o) {
    a = a.updateQueue, o.updateQueue === a && (o.updateQueue = { baseState: a.baseState, firstBaseUpdate: a.firstBaseUpdate, lastBaseUpdate: a.lastBaseUpdate, shared: a.shared, effects: a.effects });
  }
  function ho(a, o) {
    return { eventTime: a, lane: o, tag: 0, payload: null, callback: null, next: null };
  }
  function sl(a, o, p) {
    var b = a.updateQueue;
    if (b === null)
      return null;
    if (b = b.shared, kn & 2) {
      var R = b.pending;
      return R === null ? o.next = o : (o.next = R.next, R.next = o), b.pending = o, Ms(a, p);
    }
    return R = b.interleaved, R === null ? (o.next = o, Fa(b)) : (o.next = R.next, R.next = o), b.interleaved = o, Ms(a, p);
  }
  function Yp(a, o, p) {
    if (o = o.updateQueue, o !== null && (o = o.shared, (p & 4194240) !== 0)) {
      var b = o.lanes;
      b &= a.pendingLanes, p |= b, o.lanes = p, $o(a, p);
    }
  }
  function km(a, o) {
    var p = a.updateQueue, b = a.alternate;
    if (b !== null && (b = b.updateQueue, p === b)) {
      var R = null, I = null;
      if (p = p.firstBaseUpdate, p !== null) {
        do {
          var V = { eventTime: p.eventTime, lane: p.lane, tag: p.tag, payload: p.payload, callback: p.callback, next: null };
          I === null ? R = I = V : I = I.next = V, p = p.next;
        } while (p !== null);
        I === null ? R = I = o : I = I.next = o;
      } else
        R = I = o;
      p = { baseState: b.baseState, firstBaseUpdate: R, lastBaseUpdate: I, shared: b.shared, effects: b.effects }, a.updateQueue = p;
      return;
    }
    a = p.lastBaseUpdate, a === null ? p.firstBaseUpdate = o : a.next = o, p.lastBaseUpdate = o;
  }
  function Ef(a, o, p, b) {
    var R = a.updateQueue;
    ll = !1;
    var I = R.firstBaseUpdate, V = R.lastBaseUpdate, K = R.shared.pending;
    if (K !== null) {
      R.shared.pending = null;
      var ie = K, we = ie.next;
      ie.next = null, V === null ? I = we : V.next = we, V = ie;
      var Qe = a.alternate;
      Qe !== null && (Qe = Qe.updateQueue, K = Qe.lastBaseUpdate, K !== V && (K === null ? Qe.firstBaseUpdate = we : K.next = we, Qe.lastBaseUpdate = ie));
    }
    if (I !== null) {
      var Ke = R.baseState;
      V = 0, Qe = we = ie = null, K = I;
      do {
        var Ye = K.lane, Ct = K.eventTime;
        if ((b & Ye) === Ye) {
          Qe !== null && (Qe = Qe.next = {
            eventTime: Ct,
            lane: 0,
            tag: K.tag,
            payload: K.payload,
            callback: K.callback,
            next: null
          });
          e: {
            var Ot = a, Lt = K;
            switch (Ye = o, Ct = p, Lt.tag) {
              case 1:
                if (Ot = Lt.payload, typeof Ot == "function") {
                  Ke = Ot.call(Ct, Ke, Ye);
                  break e;
                }
                Ke = Ot;
                break e;
              case 3:
                Ot.flags = Ot.flags & -65537 | 128;
              case 0:
                if (Ot = Lt.payload, Ye = typeof Ot == "function" ? Ot.call(Ct, Ke, Ye) : Ot, Ye == null)
                  break e;
                Ke = _e({}, Ke, Ye);
                break e;
              case 2:
                ll = !0;
            }
          }
          K.callback !== null && K.lane !== 0 && (a.flags |= 64, Ye = R.effects, Ye === null ? R.effects = [K] : Ye.push(K));
        } else
          Ct = { eventTime: Ct, lane: Ye, tag: K.tag, payload: K.payload, callback: K.callback, next: null }, Qe === null ? (we = Qe = Ct, ie = Ke) : Qe = Qe.next = Ct, V |= Ye;
        if (K = K.next, K === null) {
          if (K = R.shared.pending, K === null)
            break;
          Ye = K, K = Ye.next, Ye.next = null, R.lastBaseUpdate = Ye, R.shared.pending = null;
        }
      } while (1);
      if (Qe === null && (ie = Ke), R.baseState = ie, R.firstBaseUpdate = we, R.lastBaseUpdate = Qe, o = R.shared.interleaved, o !== null) {
        R = o;
        do
          V |= R.lane, R = R.next;
        while (R !== o);
      } else
        I === null && (R.shared.lanes = 0);
      Ou |= V, a.lanes = V, a.memoizedState = Ke;
    }
  }
  function vv(a, o, p) {
    if (a = o.effects, o.effects = null, a !== null)
      for (o = 0; o < a.length; o++) {
        var b = a[o], R = b.callback;
        if (R !== null) {
          if (b.callback = null, b = p, typeof R != "function")
            throw Error(i(191, R));
          R.call(b);
        }
      }
  }
  var Dd = {}, _l = ln(Dd), Sf = ln(Dd), xf = ln(Dd);
  function Ps(a) {
    if (a === Dd)
      throw Error(i(174));
    return a;
  }
  function mv(a, o) {
    switch (yr(xf, o), yr(Sf, a), yr(_l, Dd), a = o.nodeType, a) {
      case 9:
      case 11:
        o = (o = o.documentElement) ? o.namespaceURI : pr(null, "");
        break;
      default:
        a = a === 8 ? o.parentNode : o, o = a.namespaceURI || null, a = a.tagName, o = pr(o, a);
    }
    vr(_l), yr(_l, o);
  }
  function Cu() {
    vr(_l), vr(Sf), vr(xf);
  }
  function gv(a) {
    Ps(xf.current);
    var o = Ps(_l.current), p = pr(o, a.type);
    o !== p && (yr(Sf, a), yr(_l, p));
  }
  function $p(a) {
    Sf.current === a && (vr(_l), vr(Sf));
  }
  var Yr = ln(0);
  function bc(a) {
    for (var o = a; o !== null; ) {
      if (o.tag === 13) {
        var p = o.memoizedState;
        if (p !== null && (p = p.dehydrated, p === null || p.data === "$?" || p.data === "$!"))
          return o;
      } else if (o.tag === 19 && o.memoizedProps.revealOrder !== void 0) {
        if (o.flags & 128)
          return o;
      } else if (o.child !== null) {
        o.child.return = o, o = o.child;
        continue;
      }
      if (o === a)
        break;
      for (; o.sibling === null; ) {
        if (o.return === null || o.return === a)
          return null;
        o = o.return;
      }
      o.sibling.return = o.return, o = o.sibling;
    }
    return null;
  }
  var Zp = [];
  function Jp() {
    for (var a = 0; a < Zp.length; a++)
      Zp[a]._workInProgressVersionPrimary = null;
    Zp.length = 0;
  }
  var Md = Q.ReactCurrentDispatcher, Pd = Q.ReactCurrentBatchConfig, Ft = 0, Ut = null, rn = null, _n = null, Hi = !1, Rf = !1, yc = 0, Ln = 0;
  function wi() {
    throw Error(i(321));
  }
  function kd(a, o) {
    if (o === null)
      return !1;
    for (var p = 0; p < o.length && p < a.length; p++)
      if (!Re(a[p], o[p]))
        return !1;
    return !0;
  }
  function je(a, o, p, b, R, I) {
    if (Ft = I, Ut = o, o.memoizedState = null, o.updateQueue = null, o.lanes = 0, Md.current = a === null || a.memoizedState === null ? lb : Rr, a = p(b, R), Rf) {
      I = 0;
      do {
        if (Rf = !1, yc = 0, 25 <= I)
          throw Error(i(301));
        I += 1, _n = rn = null, o.updateQueue = null, Md.current = Fs, a = p(b, R);
      } while (Rf);
    }
    if (Md.current = Ai, o = rn !== null && rn.next !== null, Ft = 0, _n = rn = Ut = null, Hi = !1, o)
      throw Error(i(300));
    return a;
  }
  function Ia() {
    var a = yc !== 0;
    return yc = 0, a;
  }
  function Ht() {
    var a = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return _n === null ? Ut.memoizedState = _n = a : _n = _n.next = a, _n;
  }
  function pi() {
    if (rn === null) {
      var a = Ut.alternate;
      a = a !== null ? a.memoizedState : null;
    } else
      a = rn.next;
    var o = _n === null ? Ut.memoizedState : _n.next;
    if (o !== null)
      _n = o, rn = a;
    else {
      if (a === null)
        throw Error(i(310));
      rn = a, a = { memoizedState: rn.memoizedState, baseState: rn.baseState, baseQueue: rn.baseQueue, queue: rn.queue, next: null }, _n === null ? Ut.memoizedState = _n = a : _n = _n.next = a;
    }
    return _n;
  }
  function na(a, o) {
    return typeof o == "function" ? o(a) : o;
  }
  function ks(a) {
    var o = pi(), p = o.queue;
    if (p === null)
      throw Error(i(311));
    p.lastRenderedReducer = a;
    var b = rn, R = b.baseQueue, I = p.pending;
    if (I !== null) {
      if (R !== null) {
        var V = R.next;
        R.next = I.next, I.next = V;
      }
      b.baseQueue = R = I, p.pending = null;
    }
    if (R !== null) {
      I = R.next, b = b.baseState;
      var K = V = null, ie = null, we = I;
      do {
        var Qe = we.lane;
        if ((Ft & Qe) === Qe)
          ie !== null && (ie = ie.next = { lane: 0, action: we.action, hasEagerState: we.hasEagerState, eagerState: we.eagerState, next: null }), b = we.hasEagerState ? we.eagerState : a(b, we.action);
        else {
          var Ke = {
            lane: Qe,
            action: we.action,
            hasEagerState: we.hasEagerState,
            eagerState: we.eagerState,
            next: null
          };
          ie === null ? (K = ie = Ke, V = b) : ie = ie.next = Ke, Ut.lanes |= Qe, Ou |= Qe;
        }
        we = we.next;
      } while (we !== null && we !== I);
      ie === null ? V = b : ie.next = K, Re(b, o.memoizedState) || (zi = !0), o.memoizedState = b, o.baseState = V, o.baseQueue = ie, p.lastRenderedState = b;
    }
    if (a = p.interleaved, a !== null) {
      R = a;
      do
        I = R.lane, Ut.lanes |= I, Ou |= I, R = R.next;
      while (R !== a);
    } else
      R === null && (p.lanes = 0);
    return [o.memoizedState, p.dispatch];
  }
  function ji(a) {
    var o = pi(), p = o.queue;
    if (p === null)
      throw Error(i(311));
    p.lastRenderedReducer = a;
    var b = p.dispatch, R = p.pending, I = o.memoizedState;
    if (R !== null) {
      p.pending = null;
      var V = R = R.next;
      do
        I = a(I, V.action), V = V.next;
      while (V !== R);
      Re(I, o.memoizedState) || (zi = !0), o.memoizedState = I, o.baseQueue === null && (o.baseState = I), p.lastRenderedState = I;
    }
    return [I, b];
  }
  function Eu() {
  }
  function Su(a, o) {
    var p = Ut, b = pi(), R = o(), I = !Re(b.memoizedState, R);
    if (I && (b.memoizedState = R, zi = !0), b = b.queue, ul(Ol.bind(null, p, b, a), [a]), b.getSnapshot !== o || I || _n !== null && _n.memoizedState.tag & 1) {
      if (p.flags |= 2048, xu(9, Ii.bind(null, p, b, R, o), void 0, null), ga === null)
        throw Error(i(349));
      Ft & 30 || Cc(p, o, R);
    }
    return R;
  }
  function Cc(a, o, p) {
    a.flags |= 16384, a = { getSnapshot: o, value: p }, o = Ut.updateQueue, o === null ? (o = { lastEffect: null, stores: null }, Ut.updateQueue = o, o.stores = [a]) : (p = o.stores, p === null ? o.stores = [a] : p.push(a));
  }
  function Ii(a, o, p, b) {
    o.value = p, o.getSnapshot = b, Tf(o) && Fd(a);
  }
  function Ol(a, o, p) {
    return p(function() {
      Tf(o) && Fd(a);
    });
  }
  function Tf(a) {
    var o = a.getSnapshot;
    a = a.value;
    try {
      var p = o();
      return !Re(a, p);
    } catch {
      return !0;
    }
  }
  function Fd(a) {
    var o = Ms(a, 1);
    o !== null && oa(o, a, 1, -1);
  }
  function Ec(a) {
    var o = Ht();
    return typeof a == "function" && (a = a()), o.memoizedState = o.baseState = a, a = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: na, lastRenderedState: a }, o.queue = a, a = a.dispatch = Af.bind(null, Ut, a), [o.memoizedState, a];
  }
  function xu(a, o, p, b) {
    return a = { tag: a, create: o, destroy: p, deps: b, next: null }, o = Ut.updateQueue, o === null ? (o = { lastEffect: null, stores: null }, Ut.updateQueue = o, o.lastEffect = a.next = a) : (p = o.lastEffect, p === null ? o.lastEffect = a.next = a : (b = p.next, p.next = a, a.next = b, o.lastEffect = a)), a;
  }
  function wf() {
    return pi().memoizedState;
  }
  function Sc(a, o, p, b) {
    var R = Ht();
    Ut.flags |= a, R.memoizedState = xu(1 | o, p, void 0, b === void 0 ? null : b);
  }
  function Ru(a, o, p, b) {
    var R = pi();
    b = b === void 0 ? null : b;
    var I = void 0;
    if (rn !== null) {
      var V = rn.memoizedState;
      if (I = V.destroy, b !== null && kd(b, V.deps)) {
        R.memoizedState = xu(o, p, I, b);
        return;
      }
    }
    Ut.flags |= a, R.memoizedState = xu(1 | o, p, I, b);
  }
  function If(a, o) {
    return Sc(8390656, 8, a, o);
  }
  function ul(a, o) {
    return Ru(2048, 8, a, o);
  }
  function Qp(a, o) {
    return Ru(4, 2, a, o);
  }
  function Ll(a, o) {
    return Ru(4, 4, a, o);
  }
  function Bd(a, o) {
    if (typeof o == "function")
      return a = a(), o(a), function() {
        o(null);
      };
    if (o != null)
      return a = a(), o.current = a, function() {
        o.current = null;
      };
  }
  function Ud(a, o, p) {
    return p = p != null ? p.concat([a]) : null, Ru(4, 4, Bd.bind(null, o, a), p);
  }
  function Tu() {
  }
  function xc(a, o) {
    var p = pi();
    o = o === void 0 ? null : o;
    var b = p.memoizedState;
    return b !== null && o !== null && kd(o, b[1]) ? b[0] : (p.memoizedState = [a, o], a);
  }
  function Kp(a, o) {
    var p = pi();
    o = o === void 0 ? null : o;
    var b = p.memoizedState;
    return b !== null && o !== null && kd(o, b[1]) ? b[0] : (a = a(), p.memoizedState = [a, o], a);
  }
  function qp(a, o, p) {
    return Ft & 21 ? (Re(p, o) || (p = tc(), Ut.lanes |= p, Ou |= p, a.baseState = !0), o) : (a.baseState && (a.baseState = !1, zi = !0), a.memoizedState = p);
  }
  function eh(a, o) {
    var p = Kn;
    Kn = p !== 0 && 4 > p ? p : 4, a(!0);
    var b = Pd.transition;
    Pd.transition = {};
    try {
      a(!1), o();
    } finally {
      Kn = p, Pd.transition = b;
    }
  }
  function Vd() {
    return pi().memoizedState;
  }
  function Fm(a, o, p) {
    var b = zs(a);
    if (p = { lane: b, action: p, hasEagerState: !1, eagerState: null, next: null }, th(a))
      Wa(o, p);
    else if (p = Xp(a, o, p, b), p !== null) {
      var R = si();
      oa(p, a, b, R), hi(p, o, b);
    }
  }
  function Af(a, o, p) {
    var b = zs(a), R = { lane: b, action: p, hasEagerState: !1, eagerState: null, next: null };
    if (th(a))
      Wa(o, R);
    else {
      var I = a.alternate;
      if (a.lanes === 0 && (I === null || I.lanes === 0) && (I = o.lastRenderedReducer, I !== null))
        try {
          var V = o.lastRenderedState, K = I(V, p);
          if (R.hasEagerState = !0, R.eagerState = K, Re(K, V)) {
            var ie = o.interleaved;
            ie === null ? (R.next = R, Fa(o)) : (R.next = ie.next, ie.next = R), o.interleaved = R;
            return;
          }
        } catch {
        } finally {
        }
      p = Xp(a, o, R, b), p !== null && (R = si(), oa(p, a, b, R), hi(p, o, b));
    }
  }
  function th(a) {
    var o = a.alternate;
    return a === Ut || o !== null && o === Ut;
  }
  function Wa(a, o) {
    Rf = Hi = !0;
    var p = a.pending;
    p === null ? o.next = o : (o.next = p.next, p.next = o), a.pending = o;
  }
  function hi(a, o, p) {
    if (p & 4194240) {
      var b = o.lanes;
      b &= a.pendingLanes, p |= b, o.lanes = p, $o(a, p);
    }
  }
  var Ai = { readContext: ol, useCallback: wi, useContext: wi, useEffect: wi, useImperativeHandle: wi, useInsertionEffect: wi, useLayoutEffect: wi, useMemo: wi, useReducer: wi, useRef: wi, useState: wi, useDebugValue: wi, useDeferredValue: wi, useTransition: wi, useMutableSource: wi, useSyncExternalStore: wi, useId: wi, unstable_isNewReconciler: !1 }, lb = { readContext: ol, useCallback: function(a, o) {
    return Ht().memoizedState = [a, o === void 0 ? null : o], a;
  }, useContext: ol, useEffect: If, useImperativeHandle: function(a, o, p) {
    return p = p != null ? p.concat([a]) : null, Sc(
      4194308,
      4,
      Bd.bind(null, o, a),
      p
    );
  }, useLayoutEffect: function(a, o) {
    return Sc(4194308, 4, a, o);
  }, useInsertionEffect: function(a, o) {
    return Sc(4, 2, a, o);
  }, useMemo: function(a, o) {
    var p = Ht();
    return o = o === void 0 ? null : o, a = a(), p.memoizedState = [a, o], a;
  }, useReducer: function(a, o, p) {
    var b = Ht();
    return o = p !== void 0 ? p(o) : o, b.memoizedState = b.baseState = o, a = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: a, lastRenderedState: o }, b.queue = a, a = a.dispatch = Fm.bind(null, Ut, a), [b.memoizedState, a];
  }, useRef: function(a) {
    var o = Ht();
    return a = { current: a }, o.memoizedState = a;
  }, useState: Ec, useDebugValue: Tu, useDeferredValue: function(a) {
    return Ht().memoizedState = a;
  }, useTransition: function() {
    var a = Ec(!1), o = a[0];
    return a = eh.bind(null, a[1]), Ht().memoizedState = a, [o, a];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(a, o, p) {
    var b = Ut, R = Ht();
    if (Vr) {
      if (p === void 0)
        throw Error(i(407));
      p = p();
    } else {
      if (p = o(), ga === null)
        throw Error(i(349));
      Ft & 30 || Cc(b, o, p);
    }
    R.memoizedState = p;
    var I = { value: p, getSnapshot: o };
    return R.queue = I, If(Ol.bind(
      null,
      b,
      I,
      a
    ), [a]), b.flags |= 2048, xu(9, Ii.bind(null, b, I, p, o), void 0, null), p;
  }, useId: function() {
    var a = Ht(), o = ga.identifierPrefix;
    if (Vr) {
      var p = ns, b = ii;
      p = (b & ~(1 << 32 - Bn(b) - 1)).toString(32) + p, o = ":" + o + "R" + p, p = yc++, 0 < p && (o += "H" + p.toString(32)), o += ":";
    } else
      p = Ln++, o = ":" + o + "r" + p.toString(32) + ":";
    return a.memoizedState = o;
  }, unstable_isNewReconciler: !1 }, Rr = {
    readContext: ol,
    useCallback: xc,
    useContext: ol,
    useEffect: ul,
    useImperativeHandle: Ud,
    useInsertionEffect: Qp,
    useLayoutEffect: Ll,
    useMemo: Kp,
    useReducer: ks,
    useRef: wf,
    useState: function() {
      return ks(na);
    },
    useDebugValue: Tu,
    useDeferredValue: function(a) {
      var o = pi();
      return qp(o, rn.memoizedState, a);
    },
    useTransition: function() {
      var a = ks(na)[0], o = pi().memoizedState;
      return [a, o];
    },
    useMutableSource: Eu,
    useSyncExternalStore: Su,
    useId: Vd,
    unstable_isNewReconciler: !1
  }, Fs = { readContext: ol, useCallback: xc, useContext: ol, useEffect: ul, useImperativeHandle: Ud, useInsertionEffect: Qp, useLayoutEffect: Ll, useMemo: Kp, useReducer: ji, useRef: wf, useState: function() {
    return ji(na);
  }, useDebugValue: Tu, useDeferredValue: function(a) {
    var o = pi();
    return rn === null ? o.memoizedState = a : qp(o, rn.memoizedState, a);
  }, useTransition: function() {
    var a = ji(na)[0], o = pi().memoizedState;
    return [a, o];
  }, useMutableSource: Eu, useSyncExternalStore: Su, useId: Vd, unstable_isNewReconciler: !1 };
  function Gi(a, o) {
    if (a && a.defaultProps) {
      o = _e({}, o), a = a.defaultProps;
      for (var p in a)
        o[p] === void 0 && (o[p] = a[p]);
      return o;
    }
    return o;
  }
  function wu(a, o, p, b) {
    o = a.memoizedState, p = p(b, o), p = p == null ? o : _e({}, o, p), a.memoizedState = p, a.lanes === 0 && (a.updateQueue.baseState = p);
  }
  var Rc = { isMounted: function(a) {
    return (a = a._reactInternals) ? Fe(a) === a : !1;
  }, enqueueSetState: function(a, o, p) {
    a = a._reactInternals;
    var b = si(), R = zs(a), I = ho(b, R);
    I.payload = o, p != null && (I.callback = p), o = sl(a, I, R), o !== null && (oa(o, a, R, b), Yp(o, a, R));
  }, enqueueReplaceState: function(a, o, p) {
    a = a._reactInternals;
    var b = si(), R = zs(a), I = ho(b, R);
    I.tag = 1, I.payload = o, p != null && (I.callback = p), o = sl(a, I, R), o !== null && (oa(o, a, R, b), Yp(o, a, R));
  }, enqueueForceUpdate: function(a, o) {
    a = a._reactInternals;
    var p = si(), b = zs(a), R = ho(p, b);
    R.tag = 2, o != null && (R.callback = o), o = sl(a, R, b), o !== null && (oa(o, a, b, p), Yp(o, a, b));
  } };
  function bv(a, o, p, b, R, I, V) {
    return a = a.stateNode, typeof a.shouldComponentUpdate == "function" ? a.shouldComponentUpdate(b, I, V) : o.prototype && o.prototype.isPureReactComponent ? !yt(p, b) || !yt(R, I) : !0;
  }
  function Tc(a, o, p) {
    var b = !1, R = ts, I = o.contextType;
    return typeof I == "object" && I !== null ? I = ol(I) : (R = ea(o) ? ha : un.current, b = o.contextTypes, I = (b = b != null) ? tl(a, R) : ts), o = new o(p, I), a.memoizedState = o.state !== null && o.state !== void 0 ? o.state : null, o.updater = Rc, a.stateNode = o, o._reactInternals = a, b && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = R, a.__reactInternalMemoizedMaskedChildContext = I), o;
  }
  function Nf(a, o, p, b) {
    a = o.state, typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(p, b), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(p, b), o.state !== a && Rc.enqueueReplaceState(o, o.state, null);
  }
  function yv(a, o, p, b) {
    var R = a.stateNode;
    R.props = p, R.state = a.memoizedState, R.refs = {}, Ld(a);
    var I = o.contextType;
    typeof I == "object" && I !== null ? R.context = ol(I) : (I = ea(o) ? ha : un.current, R.context = tl(a, I)), R.state = a.memoizedState, I = o.getDerivedStateFromProps, typeof I == "function" && (wu(a, o, I, p), R.state = a.memoizedState), typeof o.getDerivedStateFromProps == "function" || typeof R.getSnapshotBeforeUpdate == "function" || typeof R.UNSAFE_componentWillMount != "function" && typeof R.componentWillMount != "function" || (o = R.state, typeof R.componentWillMount == "function" && R.componentWillMount(), typeof R.UNSAFE_componentWillMount == "function" && R.UNSAFE_componentWillMount(), o !== R.state && Rc.enqueueReplaceState(R, R.state, null), Ef(a, p, R, b), R.state = a.memoizedState), typeof R.componentDidMount == "function" && (a.flags |= 4194308);
  }
  function Bs(a, o) {
    try {
      var p = "", b = o;
      do
        p += ot(b), b = b.return;
      while (b);
      var R = p;
    } catch (I) {
      R = `
Error generating stack: ` + I.message + `
` + I.stack;
    }
    return { value: a, source: o, stack: R, digest: null };
  }
  function nh(a, o, p) {
    return { value: a, source: null, stack: p ?? null, digest: o ?? null };
  }
  function Iu(a, o) {
    try {
      console.error(o.value);
    } catch (p) {
      setTimeout(function() {
        throw p;
      });
    }
  }
  var Cv = typeof WeakMap == "function" ? WeakMap : Map;
  function Hd(a, o, p) {
    p = ho(-1, p), p.tag = 3, p.payload = { element: null };
    var b = o.value;
    return p.callback = function() {
      ph || (ph = !0, Rv = b), Iu(a, o);
    }, p;
  }
  function rh(a, o, p) {
    p = ho(-1, p), p.tag = 3;
    var b = a.type.getDerivedStateFromError;
    if (typeof b == "function") {
      var R = o.value;
      p.payload = function() {
        return b(R);
      }, p.callback = function() {
        Iu(a, o);
      };
    }
    var I = a.stateNode;
    return I !== null && typeof I.componentDidCatch == "function" && (p.callback = function() {
      Iu(a, o), typeof b != "function" && (dl === null ? dl = /* @__PURE__ */ new Set([this]) : dl.add(this));
      var V = o.stack;
      this.componentDidCatch(o.value, { componentStack: V !== null ? V : "" });
    }), p;
  }
  function Au(a, o, p) {
    var b = a.pingCache;
    if (b === null) {
      b = a.pingCache = new Cv();
      var R = /* @__PURE__ */ new Set();
      b.set(o, R);
    } else
      R = b.get(o), R === void 0 && (R = /* @__PURE__ */ new Set(), b.set(o, R));
    R.has(p) || (R.add(p), a = vb.bind(null, a, o, p), o.then(a, a));
  }
  function Bm(a) {
    do {
      var o;
      if ((o = a.tag === 13) && (o = a.memoizedState, o = o !== null ? o.dehydrated !== null : !0), o)
        return a;
      a = a.return;
    } while (a !== null);
    return null;
  }
  function ah(a, o, p, b, R) {
    return a.mode & 1 ? (a.flags |= 65536, a.lanes = R, a) : (a === o ? a.flags |= 65536 : (a.flags |= 128, p.flags |= 131072, p.flags &= -52805, p.tag === 1 && (p.alternate === null ? p.tag = 17 : (o = ho(-1, 1), o.tag = 2, sl(p, o, 1))), p.lanes |= 1), a);
  }
  var jd = Q.ReactCurrentOwner, zi = !1;
  function aa(a, o, p, b) {
    o.child = a === null ? zp(o, null, p, b) : va(o, a.child, p, b);
  }
  function _f(a, o, p, b, R) {
    p = p.render;
    var I = o.ref;
    return yu(o, R), b = je(a, o, p, b, I, R), p = Ia(), a !== null && !zi ? (o.updateQueue = a.updateQueue, o.flags &= -2053, a.lanes &= ~R, ia(a, o, R)) : (Vr && p && yf(o), o.flags |= 1, aa(a, o, b, R), o.child);
  }
  function Us(a, o, p, b, R) {
    if (a === null) {
      var I = p.type;
      return typeof I == "function" && !bh(I) && I.defaultProps === void 0 && p.compare === null && p.defaultProps === void 0 ? (o.tag = 15, o.type = I, cl(a, o, I, b, R)) : (a = yh(p.type, null, b, o, o.mode, R), a.ref = o.ref, a.return = o, o.child = a);
    }
    if (I = a.child, !(a.lanes & R)) {
      var V = I.memoizedProps;
      if (p = p.compare, p = p !== null ? p : yt, p(V, b) && a.ref === o.ref)
        return ia(a, o, R);
    }
    return o.flags |= 1, a = Ml(I, b), a.ref = o.ref, a.return = o, o.child = a;
  }
  function cl(a, o, p, b, R) {
    if (a !== null) {
      var I = a.memoizedProps;
      if (yt(I, b) && a.ref === o.ref)
        if (zi = !1, o.pendingProps = b = I, (a.lanes & R) !== 0)
          a.flags & 131072 && (zi = !0);
        else
          return o.lanes = a.lanes, ia(a, o, R);
    }
    return yn(a, o, p, b, R);
  }
  function Wi(a, o, p) {
    var b = o.pendingProps, R = b.children, I = a !== null ? a.memoizedState : null;
    if (b.mode === "hidden")
      if (!(o.mode & 1))
        o.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, yr(Ff, vo), vo |= p;
      else {
        if (!(p & 1073741824))
          return a = I !== null ? I.baseLanes | p : p, o.lanes = o.childLanes = 1073741824, o.memoizedState = { baseLanes: a, cachePool: null, transitions: null }, o.updateQueue = null, yr(Ff, vo), vo |= a, null;
        o.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, b = I !== null ? I.baseLanes : p, yr(Ff, vo), vo |= b;
      }
    else
      I !== null ? (b = I.baseLanes | p, o.memoizedState = null) : b = p, yr(Ff, vo), vo |= b;
    return aa(a, o, R, p), o.child;
  }
  function Nu(a, o) {
    var p = o.ref;
    (a === null && p !== null || a !== null && a.ref !== p) && (o.flags |= 512, o.flags |= 2097152);
  }
  function yn(a, o, p, b, R) {
    var I = ea(p) ? ha : un.current;
    return I = tl(o, I), yu(o, R), p = je(a, o, p, b, I, R), b = Ia(), a !== null && !zi ? (o.updateQueue = a.updateQueue, o.flags &= -2053, a.lanes &= ~R, ia(a, o, R)) : (Vr && b && yf(o), o.flags |= 1, aa(a, o, p, R), o.child);
  }
  function Of(a, o, p, b, R) {
    if (ea(p)) {
      var I = !0;
      rl(o);
    } else
      I = !1;
    if (yu(o, R), o.stateNode === null)
      zd(a, o), Tc(o, p, b), yv(o, p, b, R), b = !0;
    else if (a === null) {
      var V = o.stateNode, K = o.memoizedProps;
      V.props = K;
      var ie = V.context, we = p.contextType;
      typeof we == "object" && we !== null ? we = ol(we) : (we = ea(p) ? ha : un.current, we = tl(o, we));
      var Qe = p.getDerivedStateFromProps, Ke = typeof Qe == "function" || typeof V.getSnapshotBeforeUpdate == "function";
      Ke || typeof V.UNSAFE_componentWillReceiveProps != "function" && typeof V.componentWillReceiveProps != "function" || (K !== b || ie !== we) && Nf(o, V, b, we), ll = !1;
      var Ye = o.memoizedState;
      V.state = Ye, Ef(o, b, V, R), ie = o.memoizedState, K !== b || Ye !== ie || pa.current || ll ? (typeof Qe == "function" && (wu(o, p, Qe, b), ie = o.memoizedState), (K = ll || bv(o, p, K, b, Ye, ie, we)) ? (Ke || typeof V.UNSAFE_componentWillMount != "function" && typeof V.componentWillMount != "function" || (typeof V.componentWillMount == "function" && V.componentWillMount(), typeof V.UNSAFE_componentWillMount == "function" && V.UNSAFE_componentWillMount()), typeof V.componentDidMount == "function" && (o.flags |= 4194308)) : (typeof V.componentDidMount == "function" && (o.flags |= 4194308), o.memoizedProps = b, o.memoizedState = ie), V.props = b, V.state = ie, V.context = we, b = K) : (typeof V.componentDidMount == "function" && (o.flags |= 4194308), b = !1);
    } else {
      V = o.stateNode, Cf(a, o), K = o.memoizedProps, we = o.type === o.elementType ? K : Gi(o.type, K), V.props = we, Ke = o.pendingProps, Ye = V.context, ie = p.contextType, typeof ie == "object" && ie !== null ? ie = ol(ie) : (ie = ea(p) ? ha : un.current, ie = tl(o, ie));
      var Ct = p.getDerivedStateFromProps;
      (Qe = typeof Ct == "function" || typeof V.getSnapshotBeforeUpdate == "function") || typeof V.UNSAFE_componentWillReceiveProps != "function" && typeof V.componentWillReceiveProps != "function" || (K !== Ke || Ye !== ie) && Nf(o, V, b, ie), ll = !1, Ye = o.memoizedState, V.state = Ye, Ef(o, b, V, R);
      var Ot = o.memoizedState;
      K !== Ke || Ye !== Ot || pa.current || ll ? (typeof Ct == "function" && (wu(o, p, Ct, b), Ot = o.memoizedState), (we = ll || bv(o, p, we, b, Ye, Ot, ie) || !1) ? (Qe || typeof V.UNSAFE_componentWillUpdate != "function" && typeof V.componentWillUpdate != "function" || (typeof V.componentWillUpdate == "function" && V.componentWillUpdate(b, Ot, ie), typeof V.UNSAFE_componentWillUpdate == "function" && V.UNSAFE_componentWillUpdate(b, Ot, ie)), typeof V.componentDidUpdate == "function" && (o.flags |= 4), typeof V.getSnapshotBeforeUpdate == "function" && (o.flags |= 1024)) : (typeof V.componentDidUpdate != "function" || K === a.memoizedProps && Ye === a.memoizedState || (o.flags |= 4), typeof V.getSnapshotBeforeUpdate != "function" || K === a.memoizedProps && Ye === a.memoizedState || (o.flags |= 1024), o.memoizedProps = b, o.memoizedState = Ot), V.props = b, V.state = Ot, V.context = ie, b = we) : (typeof V.componentDidUpdate != "function" || K === a.memoizedProps && Ye === a.memoizedState || (o.flags |= 4), typeof V.getSnapshotBeforeUpdate != "function" || K === a.memoizedProps && Ye === a.memoizedState || (o.flags |= 1024), b = !1);
    }
    return ih(a, o, p, b, I, R);
  }
  function ih(a, o, p, b, R, I) {
    Nu(a, o);
    var V = (o.flags & 128) !== 0;
    if (!b && !V)
      return R && Dm(o, p, !1), ia(a, o, I);
    b = o.stateNode, jd.current = o;
    var K = V && typeof p.getDerivedStateFromError != "function" ? null : b.render();
    return o.flags |= 1, a !== null && V ? (o.child = va(o, a.child, null, I), o.child = va(o, null, K, I)) : aa(a, o, K, I), o.memoizedState = b.state, R && Dm(o, p, !0), o.child;
  }
  function sb(a) {
    var o = a.stateNode;
    o.pendingContext ? gu(a, o.pendingContext, o.pendingContext !== o.context) : o.context && gu(a, o.context, !1), mv(a, o.containerInfo);
  }
  function os(a, o, p, b, R) {
    return kr(), as(R), o.flags |= 256, aa(a, o, p, b), o.child;
  }
  var wc = { dehydrated: null, treeContext: null, retryLane: 0 };
  function Vs(a) {
    return { baseLanes: a, cachePool: null, transitions: null };
  }
  function oh(a, o, p) {
    var b = o.pendingProps, R = Yr.current, I = !1, V = (o.flags & 128) !== 0, K;
    if ((K = V) || (K = a !== null && a.memoizedState === null ? !1 : (R & 2) !== 0), K ? (I = !0, o.flags &= -129) : (a === null || a.memoizedState !== null) && (R |= 1), yr(Yr, R & 1), a === null)
      return Ui(o), a = o.memoizedState, a !== null && (a = a.dehydrated, a !== null) ? (o.mode & 1 ? a.data === "$!" ? o.lanes = 8 : o.lanes = 1073741824 : o.lanes = 1, null) : (V = b.children, a = b.fallback, I ? (b = o.mode, I = o.child, V = { mode: "hidden", children: V }, !(b & 1) && I !== null ? (I.childLanes = 0, I.pendingProps = V) : I = Ch(V, b, 0, null), a = Pc(a, b, p, null), I.return = o, a.return = o, I.sibling = a, o.child = I, o.child.memoizedState = Vs(p), o.memoizedState = wc, a) : Ic(o, V));
    if (R = a.memoizedState, R !== null && (K = R.dehydrated, K !== null))
      return Yt(a, o, V, b, K, R, p);
    if (I) {
      I = b.fallback, V = o.mode, R = a.child, K = R.sibling;
      var ie = { mode: "hidden", children: b.children };
      return !(V & 1) && o.child !== R ? (b = o.child, b.childLanes = 0, b.pendingProps = ie, o.deletions = null) : (b = Ml(R, ie), b.subtreeFlags = R.subtreeFlags & 14680064), K !== null ? I = Ml(K, I) : (I = Pc(I, V, p, null), I.flags |= 2), I.return = o, b.return = o, b.sibling = I, o.child = b, b = I, I = o.child, V = a.child.memoizedState, V = V === null ? Vs(p) : { baseLanes: V.baseLanes | p, cachePool: null, transitions: V.transitions }, I.memoizedState = V, I.childLanes = a.childLanes & ~p, o.memoizedState = wc, b;
    }
    return I = a.child, a = I.sibling, b = Ml(I, { mode: "visible", children: b.children }), !(o.mode & 1) && (b.lanes = p), b.return = o, b.sibling = null, a !== null && (p = o.deletions, p === null ? (o.deletions = [a], o.flags |= 16) : p.push(a)), o.child = b, o.memoizedState = null, b;
  }
  function Ic(a, o) {
    return o = Ch({ mode: "visible", children: o }, a.mode, 0, null), o.return = a, a.child = o;
  }
  function Hs(a, o, p, b) {
    return b !== null && as(b), va(o, a.child, null, p), a = Ic(o, o.pendingProps.children), a.flags |= 2, o.memoizedState = null, a;
  }
  function Yt(a, o, p, b, R, I, V) {
    if (p)
      return o.flags & 256 ? (o.flags &= -257, b = nh(Error(i(422))), Hs(a, o, V, b)) : o.memoizedState !== null ? (o.child = a.child, o.flags |= 128, null) : (I = b.fallback, R = o.mode, b = Ch({ mode: "visible", children: b.children }, R, 0, null), I = Pc(I, R, V, null), I.flags |= 2, b.return = o, I.return = o, b.sibling = I, o.child = b, o.mode & 1 && va(o, a.child, null, V), o.child.memoizedState = Vs(V), o.memoizedState = wc, I);
    if (!(o.mode & 1))
      return Hs(a, o, V, null);
    if (R.data === "$!") {
      if (b = R.nextSibling && R.nextSibling.dataset, b)
        var K = b.dgst;
      return b = K, I = Error(i(419)), b = nh(I, b, void 0), Hs(a, o, V, b);
    }
    if (K = (V & a.childLanes) !== 0, zi || K) {
      if (b = ga, b !== null) {
        switch (V & -V) {
          case 4:
            R = 2;
            break;
          case 16:
            R = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            R = 32;
            break;
          case 536870912:
            R = 268435456;
            break;
          default:
            R = 0;
        }
        R = R & (b.suspendedLanes | V) ? 0 : R, R !== 0 && R !== I.retryLane && (I.retryLane = R, Ms(a, R), oa(b, a, R, -1));
      }
      return Kd(), b = nh(Error(i(421))), Hs(a, o, V, b);
    }
    return R.data === "$?" ? (o.flags |= 128, o.child = a.child, o = Av.bind(null, a), R._reactRetry = o, null) : (a = I.treeContext, po = Al(R.nextSibling), Ti = o, Vr = !0, il = null, a !== null && (fo[Ri++] = ii, fo[Ri++] = ns, fo[Ri++] = al, ii = a.id, ns = a.overflow, al = o), o = Ic(o, b.children), o.flags |= 4096, o);
  }
  function Gd(a, o, p) {
    a.lanes |= o;
    var b = a.alternate;
    b !== null && (b.lanes |= o), di(a.return, o, p);
  }
  function Lf(a, o, p, b, R) {
    var I = a.memoizedState;
    I === null ? a.memoizedState = { isBackwards: o, rendering: null, renderingStartTime: 0, last: b, tail: p, tailMode: R } : (I.isBackwards = o, I.rendering = null, I.renderingStartTime = 0, I.last = b, I.tail = p, I.tailMode = R);
  }
  function js(a, o, p) {
    var b = o.pendingProps, R = b.revealOrder, I = b.tail;
    if (aa(a, o, b.children, p), b = Yr.current, b & 2)
      b = b & 1 | 2, o.flags |= 128;
    else {
      if (a !== null && a.flags & 128)
        e:
          for (a = o.child; a !== null; ) {
            if (a.tag === 13)
              a.memoizedState !== null && Gd(a, p, o);
            else if (a.tag === 19)
              Gd(a, p, o);
            else if (a.child !== null) {
              a.child.return = a, a = a.child;
              continue;
            }
            if (a === o)
              break e;
            for (; a.sibling === null; ) {
              if (a.return === null || a.return === o)
                break e;
              a = a.return;
            }
            a.sibling.return = a.return, a = a.sibling;
          }
      b &= 1;
    }
    if (yr(Yr, b), !(o.mode & 1))
      o.memoizedState = null;
    else
      switch (R) {
        case "forwards":
          for (p = o.child, R = null; p !== null; )
            a = p.alternate, a !== null && bc(a) === null && (R = p), p = p.sibling;
          p = R, p === null ? (R = o.child, o.child = null) : (R = p.sibling, p.sibling = null), Lf(o, !1, R, p, I);
          break;
        case "backwards":
          for (p = null, R = o.child, o.child = null; R !== null; ) {
            if (a = R.alternate, a !== null && bc(a) === null) {
              o.child = R;
              break;
            }
            a = R.sibling, R.sibling = p, p = R, R = a;
          }
          Lf(o, !0, p, null, I);
          break;
        case "together":
          Lf(o, !1, null, null, void 0);
          break;
        default:
          o.memoizedState = null;
      }
    return o.child;
  }
  function zd(a, o) {
    !(o.mode & 1) && a !== null && (a.alternate = null, o.alternate = null, o.flags |= 2);
  }
  function ia(a, o, p) {
    if (a !== null && (o.dependencies = a.dependencies), Ou |= o.lanes, !(p & o.childLanes))
      return null;
    if (a !== null && o.child !== a.child)
      throw Error(i(153));
    if (o.child !== null) {
      for (a = o.child, p = Ml(a, a.pendingProps), o.child = p, p.return = o; a.sibling !== null; )
        a = a.sibling, p = p.sibling = Ml(a, a.pendingProps), p.return = o;
      p.sibling = null;
    }
    return o.child;
  }
  function ls(a, o, p) {
    switch (o.tag) {
      case 3:
        sb(o), kr();
        break;
      case 5:
        gv(o);
        break;
      case 1:
        ea(o.type) && rl(o);
        break;
      case 4:
        mv(o, o.stateNode.containerInfo);
        break;
      case 10:
        var b = o.type._context, R = o.memoizedProps.value;
        yr(is, b._currentValue), b._currentValue = R;
        break;
      case 13:
        if (b = o.memoizedState, b !== null)
          return b.dehydrated !== null ? (yr(Yr, Yr.current & 1), o.flags |= 128, null) : p & o.child.childLanes ? oh(a, o, p) : (yr(Yr, Yr.current & 1), a = ia(a, o, p), a !== null ? a.sibling : null);
        yr(Yr, Yr.current & 1);
        break;
      case 19:
        if (b = (p & o.childLanes) !== 0, a.flags & 128) {
          if (b)
            return js(a, o, p);
          o.flags |= 128;
        }
        if (R = o.memoizedState, R !== null && (R.rendering = null, R.tail = null, R.lastEffect = null), yr(Yr, Yr.current), b)
          break;
        return null;
      case 22:
      case 23:
        return o.lanes = 0, Wi(a, o, p);
    }
    return ia(a, o, p);
  }
  var $r, Df, Mf, Lo;
  $r = function(a, o) {
    for (var p = o.child; p !== null; ) {
      if (p.tag === 5 || p.tag === 6)
        a.appendChild(p.stateNode);
      else if (p.tag !== 4 && p.child !== null) {
        p.child.return = p, p = p.child;
        continue;
      }
      if (p === o)
        break;
      for (; p.sibling === null; ) {
        if (p.return === null || p.return === o)
          return;
        p = p.return;
      }
      p.sibling.return = p.return, p = p.sibling;
    }
  }, Df = function() {
  }, Mf = function(a, o, p, b) {
    var R = a.memoizedProps;
    if (R !== b) {
      a = o.stateNode, Ps(_l.current);
      var I = null;
      switch (p) {
        case "input":
          R = fn(a, R), b = fn(a, b), I = [];
          break;
        case "select":
          R = _e({}, R, { value: void 0 }), b = _e({}, b, { value: void 0 }), I = [];
          break;
        case "textarea":
          R = Da(a, R), b = Da(a, b), I = [];
          break;
        default:
          typeof R.onClick != "function" && typeof b.onClick == "function" && (a.onclick = Hp);
      }
      Ur(p, b);
      var V;
      p = null;
      for (we in R)
        if (!b.hasOwnProperty(we) && R.hasOwnProperty(we) && R[we] != null)
          if (we === "style") {
            var K = R[we];
            for (V in K)
              K.hasOwnProperty(V) && (p || (p = {}), p[V] = "");
          } else
            we !== "dangerouslySetInnerHTML" && we !== "children" && we !== "suppressContentEditableWarning" && we !== "suppressHydrationWarning" && we !== "autoFocus" && (c.hasOwnProperty(we) ? I || (I = []) : (I = I || []).push(we, null));
      for (we in b) {
        var ie = b[we];
        if (K = R != null ? R[we] : void 0, b.hasOwnProperty(we) && ie !== K && (ie != null || K != null))
          if (we === "style")
            if (K) {
              for (V in K)
                !K.hasOwnProperty(V) || ie && ie.hasOwnProperty(V) || (p || (p = {}), p[V] = "");
              for (V in ie)
                ie.hasOwnProperty(V) && K[V] !== ie[V] && (p || (p = {}), p[V] = ie[V]);
            } else
              p || (I || (I = []), I.push(
                we,
                p
              )), p = ie;
          else
            we === "dangerouslySetInnerHTML" ? (ie = ie ? ie.__html : void 0, K = K ? K.__html : void 0, ie != null && K !== ie && (I = I || []).push(we, ie)) : we === "children" ? typeof ie != "string" && typeof ie != "number" || (I = I || []).push(we, "" + ie) : we !== "suppressContentEditableWarning" && we !== "suppressHydrationWarning" && (c.hasOwnProperty(we) ? (ie != null && we === "onScroll" && Pr("scroll", a), I || K === ie || (I = [])) : (I = I || []).push(we, ie));
      }
      p && (I = I || []).push("style", p);
      var we = I;
      (o.updateQueue = we) && (o.flags |= 4);
    }
  }, Lo = function(a, o, p, b) {
    p !== b && (o.flags |= 4);
  };
  function ma(a, o) {
    if (!Vr)
      switch (a.tailMode) {
        case "hidden":
          o = a.tail;
          for (var p = null; o !== null; )
            o.alternate !== null && (p = o), o = o.sibling;
          p === null ? a.tail = null : p.sibling = null;
          break;
        case "collapsed":
          p = a.tail;
          for (var b = null; p !== null; )
            p.alternate !== null && (b = p), p = p.sibling;
          b === null ? o || a.tail === null ? a.tail = null : a.tail.sibling = null : b.sibling = null;
      }
  }
  function vi(a) {
    var o = a.alternate !== null && a.alternate.child === a.child, p = 0, b = 0;
    if (o)
      for (var R = a.child; R !== null; )
        p |= R.lanes | R.childLanes, b |= R.subtreeFlags & 14680064, b |= R.flags & 14680064, R.return = a, R = R.sibling;
    else
      for (R = a.child; R !== null; )
        p |= R.lanes | R.childLanes, b |= R.subtreeFlags, b |= R.flags, R.return = a, R = R.sibling;
    return a.subtreeFlags |= b, a.childLanes = p, o;
  }
  function ub(a, o, p) {
    var b = o.pendingProps;
    switch (vc(o), o.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return vi(o), null;
      case 1:
        return ea(o.type) && nl(), vi(o), null;
      case 3:
        return b = o.stateNode, Cu(), vr(pa), vr(un), Jp(), b.pendingContext && (b.context = b.pendingContext, b.pendingContext = null), (a === null || a.child === null) && (Nd(o) ? o.flags |= 4 : a === null || a.memoizedState.isDehydrated && !(o.flags & 256) || (o.flags |= 1024, il !== null && (Tv(il), il = null))), Df(a, o), vi(o), null;
      case 5:
        $p(o);
        var R = Ps(xf.current);
        if (p = o.type, a !== null && o.stateNode != null)
          Mf(a, o, p, b, R), a.ref !== o.ref && (o.flags |= 512, o.flags |= 2097152);
        else {
          if (!b) {
            if (o.stateNode === null)
              throw Error(i(166));
            return vi(o), null;
          }
          if (a = Ps(_l.current), Nd(o)) {
            b = o.stateNode, p = o.type;
            var I = o.memoizedProps;
            switch (b[ql] = o, b[es] = I, a = (o.mode & 1) !== 0, p) {
              case "dialog":
                Pr("cancel", b), Pr("close", b);
                break;
              case "iframe":
              case "object":
              case "embed":
                Pr("load", b);
                break;
              case "video":
              case "audio":
                for (R = 0; R < Os.length; R++)
                  Pr(Os[R], b);
                break;
              case "source":
                Pr("error", b);
                break;
              case "img":
              case "image":
              case "link":
                Pr(
                  "error",
                  b
                ), Pr("load", b);
                break;
              case "details":
                Pr("toggle", b);
                break;
              case "input":
                Gn(b, I), Pr("invalid", b);
                break;
              case "select":
                b._wrapperState = { wasMultiple: !!I.multiple }, Pr("invalid", b);
                break;
              case "textarea":
                Sa(b, I), Pr("invalid", b);
            }
            Ur(p, I), R = null;
            for (var V in I)
              if (I.hasOwnProperty(V)) {
                var K = I[V];
                V === "children" ? typeof K == "string" ? b.textContent !== K && (I.suppressHydrationWarning !== !0 && Rd(b.textContent, K, a), R = ["children", K]) : typeof K == "number" && b.textContent !== "" + K && (I.suppressHydrationWarning !== !0 && Rd(
                  b.textContent,
                  K,
                  a
                ), R = ["children", "" + K]) : c.hasOwnProperty(V) && K != null && V === "onScroll" && Pr("scroll", b);
              }
            switch (p) {
              case "input":
                bn(b), Ha(b, I, !0);
                break;
              case "textarea":
                bn(b), Or(b);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof I.onClick == "function" && (b.onclick = Hp);
            }
            b = R, o.updateQueue = b, b !== null && (o.flags |= 4);
          } else {
            V = R.nodeType === 9 ? R : R.ownerDocument, a === "http://www.w3.org/1999/xhtml" && (a = fi(p)), a === "http://www.w3.org/1999/xhtml" ? p === "script" ? (a = V.createElement("div"), a.innerHTML = "<script><\/script>", a = a.removeChild(a.firstChild)) : typeof b.is == "string" ? a = V.createElement(p, { is: b.is }) : (a = V.createElement(p), p === "select" && (V = a, b.multiple ? V.multiple = !0 : b.size && (V.size = b.size))) : a = V.createElementNS(a, p), a[ql] = o, a[es] = b, $r(a, o, !1, !1), o.stateNode = a;
            e: {
              switch (V = Lr(p, b), p) {
                case "dialog":
                  Pr("cancel", a), Pr("close", a), R = b;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Pr("load", a), R = b;
                  break;
                case "video":
                case "audio":
                  for (R = 0; R < Os.length; R++)
                    Pr(Os[R], a);
                  R = b;
                  break;
                case "source":
                  Pr("error", a), R = b;
                  break;
                case "img":
                case "image":
                case "link":
                  Pr(
                    "error",
                    a
                  ), Pr("load", a), R = b;
                  break;
                case "details":
                  Pr("toggle", a), R = b;
                  break;
                case "input":
                  Gn(a, b), R = fn(a, b), Pr("invalid", a);
                  break;
                case "option":
                  R = b;
                  break;
                case "select":
                  a._wrapperState = { wasMultiple: !!b.multiple }, R = _e({}, b, { value: void 0 }), Pr("invalid", a);
                  break;
                case "textarea":
                  Sa(a, b), R = Da(a, b), Pr("invalid", a);
                  break;
                default:
                  R = b;
              }
              Ur(p, R), K = R;
              for (I in K)
                if (K.hasOwnProperty(I)) {
                  var ie = K[I];
                  I === "style" ? Fn(a, ie) : I === "dangerouslySetInnerHTML" ? (ie = ie ? ie.__html : void 0, ie != null && ca(a, ie)) : I === "children" ? typeof ie == "string" ? (p !== "textarea" || ie !== "") && Ka(a, ie) : typeof ie == "number" && Ka(a, "" + ie) : I !== "suppressContentEditableWarning" && I !== "suppressHydrationWarning" && I !== "autoFocus" && (c.hasOwnProperty(I) ? ie != null && I === "onScroll" && Pr("scroll", a) : ie != null && G(a, I, ie, V));
                }
              switch (p) {
                case "input":
                  bn(a), Ha(a, b, !1);
                  break;
                case "textarea":
                  bn(a), Or(a);
                  break;
                case "option":
                  b.value != null && a.setAttribute("value", "" + ht(b.value));
                  break;
                case "select":
                  a.multiple = !!b.multiple, I = b.value, I != null ? wr(a, !!b.multiple, I, !1) : b.defaultValue != null && wr(
                    a,
                    !!b.multiple,
                    b.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof R.onClick == "function" && (a.onclick = Hp);
              }
              switch (p) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  b = !!b.autoFocus;
                  break e;
                case "img":
                  b = !0;
                  break e;
                default:
                  b = !1;
              }
            }
            b && (o.flags |= 4);
          }
          o.ref !== null && (o.flags |= 512, o.flags |= 2097152);
        }
        return vi(o), null;
      case 6:
        if (a && o.stateNode != null)
          Lo(a, o, a.memoizedProps, b);
        else {
          if (typeof b != "string" && o.stateNode === null)
            throw Error(i(166));
          if (p = Ps(xf.current), Ps(_l.current), Nd(o)) {
            if (b = o.stateNode, p = o.memoizedProps, b[ql] = o, (I = b.nodeValue !== p) && (a = Ti, a !== null))
              switch (a.tag) {
                case 3:
                  Rd(b.nodeValue, p, (a.mode & 1) !== 0);
                  break;
                case 5:
                  a.memoizedProps.suppressHydrationWarning !== !0 && Rd(b.nodeValue, p, (a.mode & 1) !== 0);
              }
            I && (o.flags |= 4);
          } else
            b = (p.nodeType === 9 ? p : p.ownerDocument).createTextNode(b), b[ql] = o, o.stateNode = b;
        }
        return vi(o), null;
      case 13:
        if (vr(Yr), b = o.memoizedState, a === null || a.memoizedState !== null && a.memoizedState.dehydrated !== null) {
          if (Vr && po !== null && o.mode & 1 && !(o.flags & 128))
            hv(), kr(), o.flags |= 98560, I = !1;
          else if (I = Nd(o), b !== null && b.dehydrated !== null) {
            if (a === null) {
              if (!I)
                throw Error(i(318));
              if (I = o.memoizedState, I = I !== null ? I.dehydrated : null, !I)
                throw Error(i(317));
              I[ql] = o;
            } else
              kr(), !(o.flags & 128) && (o.memoizedState = null), o.flags |= 4;
            vi(o), I = !1;
          } else
            il !== null && (Tv(il), il = null), I = !0;
          if (!I)
            return o.flags & 65536 ? o : null;
        }
        return o.flags & 128 ? (o.lanes = p, o) : (b = b !== null, b !== (a !== null && a.memoizedState !== null) && b && (o.child.flags |= 8192, o.mode & 1 && (a === null || Yr.current & 1 ? Ya === 0 && (Ya = 3) : Kd())), o.updateQueue !== null && (o.flags |= 4), vi(o), null);
      case 4:
        return Cu(), Df(a, o), a === null && Ls(o.stateNode.containerInfo), vi(o), null;
      case 10:
        return Wp(o.type._context), vi(o), null;
      case 17:
        return ea(o.type) && nl(), vi(o), null;
      case 19:
        if (vr(Yr), I = o.memoizedState, I === null)
          return vi(o), null;
        if (b = (o.flags & 128) !== 0, V = I.rendering, V === null)
          if (b)
            ma(I, !1);
          else {
            if (Ya !== 0 || a !== null && a.flags & 128)
              for (a = o.child; a !== null; ) {
                if (V = bc(a), V !== null) {
                  for (o.flags |= 128, ma(I, !1), b = V.updateQueue, b !== null && (o.updateQueue = b, o.flags |= 4), o.subtreeFlags = 0, b = p, p = o.child; p !== null; )
                    I = p, a = b, I.flags &= 14680066, V = I.alternate, V === null ? (I.childLanes = 0, I.lanes = a, I.child = null, I.subtreeFlags = 0, I.memoizedProps = null, I.memoizedState = null, I.updateQueue = null, I.dependencies = null, I.stateNode = null) : (I.childLanes = V.childLanes, I.lanes = V.lanes, I.child = V.child, I.subtreeFlags = 0, I.deletions = null, I.memoizedProps = V.memoizedProps, I.memoizedState = V.memoizedState, I.updateQueue = V.updateQueue, I.type = V.type, a = V.dependencies, I.dependencies = a === null ? null : { lanes: a.lanes, firstContext: a.firstContext }), p = p.sibling;
                  return yr(Yr, Yr.current & 1 | 2), o.child;
                }
                a = a.sibling;
              }
            I.tail !== null && hn() > Lc && (o.flags |= 128, b = !0, ma(I, !1), o.lanes = 4194304);
          }
        else {
          if (!b)
            if (a = bc(V), a !== null) {
              if (o.flags |= 128, b = !0, p = a.updateQueue, p !== null && (o.updateQueue = p, o.flags |= 4), ma(I, !0), I.tail === null && I.tailMode === "hidden" && !V.alternate && !Vr)
                return vi(o), null;
            } else
              2 * hn() - I.renderingStartTime > Lc && p !== 1073741824 && (o.flags |= 128, b = !0, ma(I, !1), o.lanes = 4194304);
          I.isBackwards ? (V.sibling = o.child, o.child = V) : (p = I.last, p !== null ? p.sibling = V : o.child = V, I.last = V);
        }
        return I.tail !== null ? (o = I.tail, I.rendering = o, I.tail = o.sibling, I.renderingStartTime = hn(), o.sibling = null, p = Yr.current, yr(Yr, b ? p & 1 | 2 : p & 1), o) : (vi(o), null);
      case 22:
      case 23:
        return vh(), b = o.memoizedState !== null, a !== null && a.memoizedState !== null !== b && (o.flags |= 8192), b && o.mode & 1 ? vo & 1073741824 && (vi(o), o.subtreeFlags & 6 && (o.flags |= 8192)) : vi(o), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(i(156, o.tag));
  }
  function cb(a, o) {
    switch (vc(o), o.tag) {
      case 1:
        return ea(o.type) && nl(), a = o.flags, a & 65536 ? (o.flags = a & -65537 | 128, o) : null;
      case 3:
        return Cu(), vr(pa), vr(un), Jp(), a = o.flags, a & 65536 && !(a & 128) ? (o.flags = a & -65537 | 128, o) : null;
      case 5:
        return $p(o), null;
      case 13:
        if (vr(Yr), a = o.memoizedState, a !== null && a.dehydrated !== null) {
          if (o.alternate === null)
            throw Error(i(340));
          kr();
        }
        return a = o.flags, a & 65536 ? (o.flags = a & -65537 | 128, o) : null;
      case 19:
        return vr(Yr), null;
      case 4:
        return Cu(), null;
      case 10:
        return Wp(o.type._context), null;
      case 22:
      case 23:
        return vh(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Pf = !1, Zr = !1, oi = typeof WeakSet == "function" ? WeakSet : Set, xt = null;
  function kf(a, o) {
    var p = a.ref;
    if (p !== null)
      if (typeof p == "function")
        try {
          p(null);
        } catch (b) {
          la(a, o, b);
        }
      else
        p.current = null;
  }
  function Wd(a, o, p) {
    try {
      p();
    } catch (b) {
      la(a, o, b);
    }
  }
  var lh = !1;
  function fb(a, o) {
    if (Td = Zo, a = br(), wl(a)) {
      if ("selectionStart" in a)
        var p = { start: a.selectionStart, end: a.selectionEnd };
      else
        e: {
          p = (p = a.ownerDocument) && p.defaultView || window;
          var b = p.getSelection && p.getSelection();
          if (b && b.rangeCount !== 0) {
            p = b.anchorNode;
            var R = b.anchorOffset, I = b.focusNode;
            b = b.focusOffset;
            try {
              p.nodeType, I.nodeType;
            } catch {
              p = null;
              break e;
            }
            var V = 0, K = -1, ie = -1, we = 0, Qe = 0, Ke = a, Ye = null;
            t:
              for (; ; ) {
                for (var Ct; Ke !== p || R !== 0 && Ke.nodeType !== 3 || (K = V + R), Ke !== I || b !== 0 && Ke.nodeType !== 3 || (ie = V + b), Ke.nodeType === 3 && (V += Ke.nodeValue.length), (Ct = Ke.firstChild) !== null; )
                  Ye = Ke, Ke = Ct;
                for (; ; ) {
                  if (Ke === a)
                    break t;
                  if (Ye === p && ++we === R && (K = V), Ye === I && ++Qe === b && (ie = V), (Ct = Ke.nextSibling) !== null)
                    break;
                  Ke = Ye, Ye = Ke.parentNode;
                }
                Ke = Ct;
              }
            p = K === -1 || ie === -1 ? null : { start: K, end: ie };
          } else
            p = null;
        }
      p = p || { start: 0, end: 0 };
    } else
      p = null;
    for (Il = { focusedElem: a, selectionRange: p }, Zo = !1, xt = o; xt !== null; )
      if (o = xt, a = o.child, (o.subtreeFlags & 1028) !== 0 && a !== null)
        a.return = o, xt = a;
      else
        for (; xt !== null; ) {
          o = xt;
          try {
            var Ot = o.alternate;
            if (o.flags & 1024)
              switch (o.tag) {
                case 0:
                case 11:
                case 15:
                  break;
                case 1:
                  if (Ot !== null) {
                    var Lt = Ot.memoizedProps, Aa = Ot.memoizedState, ge = o.stateNode, le = ge.getSnapshotBeforeUpdate(o.elementType === o.type ? Lt : Gi(o.type, Lt), Aa);
                    ge.__reactInternalSnapshotBeforeUpdate = le;
                  }
                  break;
                case 3:
                  var ye = o.stateNode.containerInfo;
                  ye.nodeType === 1 ? ye.textContent = "" : ye.nodeType === 9 && ye.documentElement && ye.removeChild(ye.documentElement);
                  break;
                case 5:
                case 6:
                case 4:
                case 17:
                  break;
                default:
                  throw Error(i(163));
              }
          } catch (tt) {
            la(o, o.return, tt);
          }
          if (a = o.sibling, a !== null) {
            a.return = o.return, xt = a;
            break;
          }
          xt = o.return;
        }
    return Ot = lh, lh = !1, Ot;
  }
  function ss(a, o, p) {
    var b = o.updateQueue;
    if (b = b !== null ? b.lastEffect : null, b !== null) {
      var R = b = b.next;
      do {
        if ((R.tag & a) === a) {
          var I = R.destroy;
          R.destroy = void 0, I !== void 0 && Wd(o, p, I);
        }
        R = R.next;
      } while (R !== b);
    }
  }
  function Xd(a, o) {
    if (o = o.updateQueue, o = o !== null ? o.lastEffect : null, o !== null) {
      var p = o = o.next;
      do {
        if ((p.tag & a) === a) {
          var b = p.create;
          p.destroy = b();
        }
        p = p.next;
      } while (p !== o);
    }
  }
  function Yd(a) {
    var o = a.ref;
    if (o !== null) {
      var p = a.stateNode;
      switch (a.tag) {
        case 5:
          a = p;
          break;
        default:
          a = p;
      }
      typeof o == "function" ? o(a) : o.current = a;
    }
  }
  function Um(a) {
    var o = a.alternate;
    o !== null && (a.alternate = null, Um(o)), a.child = null, a.deletions = null, a.sibling = null, a.tag === 5 && (o = a.stateNode, o !== null && (delete o[ql], delete o[es], delete o[jp], delete o[z], delete o[vu])), a.stateNode = null, a.return = null, a.dependencies = null, a.memoizedProps = null, a.memoizedState = null, a.pendingProps = null, a.stateNode = null, a.updateQueue = null;
  }
  function Ev(a) {
    return a.tag === 5 || a.tag === 3 || a.tag === 4;
  }
  function Vm(a) {
    e:
      for (; ; ) {
        for (; a.sibling === null; ) {
          if (a.return === null || Ev(a.return))
            return null;
          a = a.return;
        }
        for (a.sibling.return = a.return, a = a.sibling; a.tag !== 5 && a.tag !== 6 && a.tag !== 18; ) {
          if (a.flags & 2 || a.child === null || a.tag === 4)
            continue e;
          a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2))
          return a.stateNode;
      }
  }
  function $d(a, o, p) {
    var b = a.tag;
    if (b === 5 || b === 6)
      a = a.stateNode, o ? p.nodeType === 8 ? p.parentNode.insertBefore(a, o) : p.insertBefore(a, o) : (p.nodeType === 8 ? (o = p.parentNode, o.insertBefore(a, p)) : (o = p, o.appendChild(a)), p = p._reactRootContainer, p != null || o.onclick !== null || (o.onclick = Hp));
    else if (b !== 4 && (a = a.child, a !== null))
      for ($d(a, o, p), a = a.sibling; a !== null; )
        $d(a, o, p), a = a.sibling;
  }
  function Ac(a, o, p) {
    var b = a.tag;
    if (b === 5 || b === 6)
      a = a.stateNode, o ? p.insertBefore(a, o) : p.appendChild(a);
    else if (b !== 4 && (a = a.child, a !== null))
      for (Ac(a, o, p), a = a.sibling; a !== null; )
        Ac(a, o, p), a = a.sibling;
  }
  var Jr = null, li = !1;
  function mi(a, o, p) {
    for (p = p.child; p !== null; )
      Nc(a, o, p), p = p.sibling;
  }
  function Nc(a, o, p) {
    if (Ta && typeof Ta.onCommitFiberUnmount == "function")
      try {
        Ta.onCommitFiberUnmount(hr, p);
      } catch {
      }
    switch (p.tag) {
      case 5:
        Zr || kf(p, o);
      case 6:
        var b = Jr, R = li;
        Jr = null, mi(a, o, p), Jr = b, li = R, Jr !== null && (li ? (a = Jr, p = p.stateNode, a.nodeType === 8 ? a.parentNode.removeChild(p) : a.removeChild(p)) : Jr.removeChild(p.stateNode));
        break;
      case 18:
        Jr !== null && (li ? (a = Jr, p = p.stateNode, a.nodeType === 8 ? pu(a.parentNode, p) : a.nodeType === 1 && pu(a, p), ir(a)) : pu(Jr, p.stateNode));
        break;
      case 4:
        b = Jr, R = li, Jr = p.stateNode.containerInfo, li = !0, mi(a, o, p), Jr = b, li = R;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Zr && (b = p.updateQueue, b !== null && (b = b.lastEffect, b !== null))) {
          R = b = b.next;
          do {
            var I = R, V = I.destroy;
            I = I.tag, V !== void 0 && (I & 2 || I & 4) && Wd(p, o, V), R = R.next;
          } while (R !== b);
        }
        mi(a, o, p);
        break;
      case 1:
        if (!Zr && (kf(p, o), b = p.stateNode, typeof b.componentWillUnmount == "function"))
          try {
            b.props = p.memoizedProps, b.state = p.memoizedState, b.componentWillUnmount();
          } catch (K) {
            la(p, o, K);
          }
        mi(a, o, p);
        break;
      case 21:
        mi(a, o, p);
        break;
      case 22:
        p.mode & 1 ? (Zr = (b = Zr) || p.memoizedState !== null, mi(a, o, p), Zr = b) : mi(a, o, p);
        break;
      default:
        mi(a, o, p);
    }
  }
  function us(a) {
    var o = a.updateQueue;
    if (o !== null) {
      a.updateQueue = null;
      var p = a.stateNode;
      p === null && (p = a.stateNode = new oi()), o.forEach(function(b) {
        var R = mb.bind(null, a, b);
        p.has(b) || (p.add(b), b.then(R, R));
      });
    }
  }
  function Ba(a, o) {
    var p = o.deletions;
    if (p !== null)
      for (var b = 0; b < p.length; b++) {
        var R = p[b];
        try {
          var I = a, V = o, K = V;
          e:
            for (; K !== null; ) {
              switch (K.tag) {
                case 5:
                  Jr = K.stateNode, li = !1;
                  break e;
                case 3:
                  Jr = K.stateNode.containerInfo, li = !0;
                  break e;
                case 4:
                  Jr = K.stateNode.containerInfo, li = !0;
                  break e;
              }
              K = K.return;
            }
          if (Jr === null)
            throw Error(i(160));
          Nc(I, V, R), Jr = null, li = !1;
          var ie = R.alternate;
          ie !== null && (ie.return = null), R.return = null;
        } catch (we) {
          la(R, o, we);
        }
      }
    if (o.subtreeFlags & 12854)
      for (o = o.child; o !== null; )
        Sv(o, a), o = o.sibling;
  }
  function Sv(a, o) {
    var p = a.alternate, b = a.flags;
    switch (a.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (Ba(o, a), Dl(a), b & 4) {
          try {
            ss(3, a, a.return), Xd(3, a);
          } catch (Lt) {
            la(a, a.return, Lt);
          }
          try {
            ss(5, a, a.return);
          } catch (Lt) {
            la(a, a.return, Lt);
          }
        }
        break;
      case 1:
        Ba(o, a), Dl(a), b & 512 && p !== null && kf(p, p.return);
        break;
      case 5:
        if (Ba(o, a), Dl(a), b & 512 && p !== null && kf(p, p.return), a.flags & 32) {
          var R = a.stateNode;
          try {
            Ka(R, "");
          } catch (Lt) {
            la(a, a.return, Lt);
          }
        }
        if (b & 4 && (R = a.stateNode, R != null)) {
          var I = a.memoizedProps, V = p !== null ? p.memoizedProps : I, K = a.type, ie = a.updateQueue;
          if (a.updateQueue = null, ie !== null)
            try {
              K === "input" && I.type === "radio" && I.name != null && ar(R, I), Lr(K, V);
              var we = Lr(K, I);
              for (V = 0; V < ie.length; V += 2) {
                var Qe = ie[V], Ke = ie[V + 1];
                Qe === "style" ? Fn(R, Ke) : Qe === "dangerouslySetInnerHTML" ? ca(R, Ke) : Qe === "children" ? Ka(R, Ke) : G(R, Qe, Ke, we);
              }
              switch (K) {
                case "input":
                  Jn(R, I);
                  break;
                case "textarea":
                  xa(R, I);
                  break;
                case "select":
                  var Ye = R._wrapperState.wasMultiple;
                  R._wrapperState.wasMultiple = !!I.multiple;
                  var Ct = I.value;
                  Ct != null ? wr(R, !!I.multiple, Ct, !1) : Ye !== !!I.multiple && (I.defaultValue != null ? wr(
                    R,
                    !!I.multiple,
                    I.defaultValue,
                    !0
                  ) : wr(R, !!I.multiple, I.multiple ? [] : "", !1));
              }
              R[es] = I;
            } catch (Lt) {
              la(a, a.return, Lt);
            }
        }
        break;
      case 6:
        if (Ba(o, a), Dl(a), b & 4) {
          if (a.stateNode === null)
            throw Error(i(162));
          R = a.stateNode, I = a.memoizedProps;
          try {
            R.nodeValue = I;
          } catch (Lt) {
            la(a, a.return, Lt);
          }
        }
        break;
      case 3:
        if (Ba(o, a), Dl(a), b & 4 && p !== null && p.memoizedState.isDehydrated)
          try {
            ir(o.containerInfo);
          } catch (Lt) {
            la(a, a.return, Lt);
          }
        break;
      case 4:
        Ba(o, a), Dl(a);
        break;
      case 13:
        Ba(o, a), Dl(a), R = a.child, R.flags & 8192 && (I = R.memoizedState !== null, R.stateNode.isHidden = I, !I || R.alternate !== null && R.alternate.memoizedState !== null || (dh = hn())), b & 4 && us(a);
        break;
      case 22:
        if (Qe = p !== null && p.memoizedState !== null, a.mode & 1 ? (Zr = (we = Zr) || Qe, Ba(o, a), Zr = we) : Ba(o, a), Dl(a), b & 8192) {
          if (we = a.memoizedState !== null, (a.stateNode.isHidden = we) && !Qe && a.mode & 1)
            for (xt = a, Qe = a.child; Qe !== null; ) {
              for (Ke = xt = Qe; xt !== null; ) {
                switch (Ye = xt, Ct = Ye.child, Ye.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    ss(4, Ye, Ye.return);
                    break;
                  case 1:
                    kf(Ye, Ye.return);
                    var Ot = Ye.stateNode;
                    if (typeof Ot.componentWillUnmount == "function") {
                      b = Ye, p = Ye.return;
                      try {
                        o = b, Ot.props = o.memoizedProps, Ot.state = o.memoizedState, Ot.componentWillUnmount();
                      } catch (Lt) {
                        la(b, p, Lt);
                      }
                    }
                    break;
                  case 5:
                    kf(Ye, Ye.return);
                    break;
                  case 22:
                    if (Ye.memoizedState !== null) {
                      _u(Ke);
                      continue;
                    }
                }
                Ct !== null ? (Ct.return = Ye, xt = Ct) : _u(Ke);
              }
              Qe = Qe.sibling;
            }
          e:
            for (Qe = null, Ke = a; ; ) {
              if (Ke.tag === 5) {
                if (Qe === null) {
                  Qe = Ke;
                  try {
                    R = Ke.stateNode, we ? (I = R.style, typeof I.setProperty == "function" ? I.setProperty("display", "none", "important") : I.display = "none") : (K = Ke.stateNode, ie = Ke.memoizedProps.style, V = ie != null && ie.hasOwnProperty("display") ? ie.display : null, K.style.display = $t("display", V));
                  } catch (Lt) {
                    la(a, a.return, Lt);
                  }
                }
              } else if (Ke.tag === 6) {
                if (Qe === null)
                  try {
                    Ke.stateNode.nodeValue = we ? "" : Ke.memoizedProps;
                  } catch (Lt) {
                    la(a, a.return, Lt);
                  }
              } else if ((Ke.tag !== 22 && Ke.tag !== 23 || Ke.memoizedState === null || Ke === a) && Ke.child !== null) {
                Ke.child.return = Ke, Ke = Ke.child;
                continue;
              }
              if (Ke === a)
                break e;
              for (; Ke.sibling === null; ) {
                if (Ke.return === null || Ke.return === a)
                  break e;
                Qe === Ke && (Qe = null), Ke = Ke.return;
              }
              Qe === Ke && (Qe = null), Ke.sibling.return = Ke.return, Ke = Ke.sibling;
            }
        }
        break;
      case 19:
        Ba(o, a), Dl(a), b & 4 && us(a);
        break;
      case 21:
        break;
      default:
        Ba(
          o,
          a
        ), Dl(a);
    }
  }
  function Dl(a) {
    var o = a.flags;
    if (o & 2) {
      try {
        e: {
          for (var p = a.return; p !== null; ) {
            if (Ev(p)) {
              var b = p;
              break e;
            }
            p = p.return;
          }
          throw Error(i(160));
        }
        switch (b.tag) {
          case 5:
            var R = b.stateNode;
            b.flags & 32 && (Ka(R, ""), b.flags &= -33);
            var I = Vm(a);
            Ac(a, I, R);
            break;
          case 3:
          case 4:
            var V = b.stateNode.containerInfo, K = Vm(a);
            $d(a, K, V);
            break;
          default:
            throw Error(i(161));
        }
      } catch (ie) {
        la(a, a.return, ie);
      }
      a.flags &= -3;
    }
    o & 4096 && (a.flags &= -4097);
  }
  function sh(a, o, p) {
    xt = a, uh(a);
  }
  function uh(a, o, p) {
    for (var b = (a.mode & 1) !== 0; xt !== null; ) {
      var R = xt, I = R.child;
      if (R.tag === 22 && b) {
        var V = R.memoizedState !== null || Pf;
        if (!V) {
          var K = R.alternate, ie = K !== null && K.memoizedState !== null || Zr;
          K = Pf;
          var we = Zr;
          if (Pf = V, (Zr = ie) && !we)
            for (xt = R; xt !== null; )
              V = xt, ie = V.child, V.tag === 22 && V.memoizedState !== null ? xv(R) : ie !== null ? (ie.return = V, xt = ie) : xv(R);
          for (; I !== null; )
            xt = I, uh(I), I = I.sibling;
          xt = R, Pf = K, Zr = we;
        }
        Xi(a);
      } else
        R.subtreeFlags & 8772 && I !== null ? (I.return = R, xt = I) : Xi(a);
    }
  }
  function Xi(a) {
    for (; xt !== null; ) {
      var o = xt;
      if (o.flags & 8772) {
        var p = o.alternate;
        try {
          if (o.flags & 8772)
            switch (o.tag) {
              case 0:
              case 11:
              case 15:
                Zr || Xd(5, o);
                break;
              case 1:
                var b = o.stateNode;
                if (o.flags & 4 && !Zr)
                  if (p === null)
                    b.componentDidMount();
                  else {
                    var R = o.elementType === o.type ? p.memoizedProps : Gi(o.type, p.memoizedProps);
                    b.componentDidUpdate(R, p.memoizedState, b.__reactInternalSnapshotBeforeUpdate);
                  }
                var I = o.updateQueue;
                I !== null && vv(o, I, b);
                break;
              case 3:
                var V = o.updateQueue;
                if (V !== null) {
                  if (p = null, o.child !== null)
                    switch (o.child.tag) {
                      case 5:
                        p = o.child.stateNode;
                        break;
                      case 1:
                        p = o.child.stateNode;
                    }
                  vv(o, V, p);
                }
                break;
              case 5:
                var K = o.stateNode;
                if (p === null && o.flags & 4) {
                  p = K;
                  var ie = o.memoizedProps;
                  switch (o.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      ie.autoFocus && p.focus();
                      break;
                    case "img":
                      ie.src && (p.src = ie.src);
                  }
                }
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (o.memoizedState === null) {
                  var we = o.alternate;
                  if (we !== null) {
                    var Qe = we.memoizedState;
                    if (Qe !== null) {
                      var Ke = Qe.dehydrated;
                      Ke !== null && ir(Ke);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(i(163));
            }
          Zr || o.flags & 512 && Yd(o);
        } catch (Ye) {
          la(o, o.return, Ye);
        }
      }
      if (o === a) {
        xt = null;
        break;
      }
      if (p = o.sibling, p !== null) {
        p.return = o.return, xt = p;
        break;
      }
      xt = o.return;
    }
  }
  function _u(a) {
    for (; xt !== null; ) {
      var o = xt;
      if (o === a) {
        xt = null;
        break;
      }
      var p = o.sibling;
      if (p !== null) {
        p.return = o.return, xt = p;
        break;
      }
      xt = o.return;
    }
  }
  function xv(a) {
    for (; xt !== null; ) {
      var o = xt;
      try {
        switch (o.tag) {
          case 0:
          case 11:
          case 15:
            var p = o.return;
            try {
              Xd(4, o);
            } catch (ie) {
              la(o, p, ie);
            }
            break;
          case 1:
            var b = o.stateNode;
            if (typeof b.componentDidMount == "function") {
              var R = o.return;
              try {
                b.componentDidMount();
              } catch (ie) {
                la(o, R, ie);
              }
            }
            var I = o.return;
            try {
              Yd(o);
            } catch (ie) {
              la(o, I, ie);
            }
            break;
          case 5:
            var V = o.return;
            try {
              Yd(o);
            } catch (ie) {
              la(o, V, ie);
            }
        }
      } catch (ie) {
        la(o, o.return, ie);
      }
      if (o === a) {
        xt = null;
        break;
      }
      var K = o.sibling;
      if (K !== null) {
        K.return = o.return, xt = K;
        break;
      }
      xt = o.return;
    }
  }
  var Hm = Math.ceil, _c = Q.ReactCurrentDispatcher, ch = Q.ReactCurrentOwner, fl = Q.ReactCurrentBatchConfig, kn = 0, ga = null, Qr = null, Xa = 0, vo = 0, Ff = ln(0), Ya = 0, Zd = null, Ou = 0, Oc = 0, fh = 0, Lu = null, Ni = null, dh = 0, Lc = 1 / 0, Gs = null, ph = !1, Rv = null, dl = null, Bf = !1, pl = null, Yi = 0, Jd = 0, hh = null, Qd = -1, Du = 0;
  function si() {
    return kn & 6 ? hn() : Qd !== -1 ? Qd : Qd = hn();
  }
  function zs(a) {
    return a.mode & 1 ? kn & 2 && Xa !== 0 ? Xa & -Xa : _d.transition !== null ? (Du === 0 && (Du = tc()), Du) : (a = Kn, a !== 0 || (a = window.event, a = a === void 0 ? 16 : hd(a.type)), a) : 1;
  }
  function oa(a, o, p, b) {
    if (50 < Jd)
      throw Jd = 0, hh = null, Error(i(185));
    Ts(a, p, b), (!(kn & 2) || a !== ga) && (a === ga && (!(kn & 2) && (Oc |= p), Ya === 4 && cs(a, Xa)), $a(a, b), p === 1 && kn === 0 && !(o.mode & 1) && (Lc = hn() + 500, ai && co()));
  }
  function $a(a, o) {
    var p = a.callbackNode;
    nu(a, o);
    var b = ti(a, a === ga ? Xa : 0);
    if (b === 0)
      p !== null && sr(p), a.callbackNode = null, a.callbackPriority = 0;
    else if (o = b & -b, a.callbackPriority !== o) {
      if (p != null && sr(p), o === 1)
        a.tag === 0 ? Ds(Vf.bind(null, a)) : dv(Vf.bind(null, a)), mf(function() {
          !(kn & 6) && co();
        }), p = null;
      else {
        switch (Rl(b)) {
          case 1:
            p = Ra;
            break;
          case 4:
            p = on;
            break;
          case 16:
            p = ei;
            break;
          case 536870912:
            p = An;
            break;
          default:
            p = ei;
        }
        p = $m(p, Uf.bind(null, a));
      }
      a.callbackPriority = o, a.callbackNode = p;
    }
  }
  function Uf(a, o) {
    if (Qd = -1, Du = 0, kn & 6)
      throw Error(i(327));
    var p = a.callbackNode;
    if (Hf() && a.callbackNode !== p)
      return null;
    var b = ti(a, a === ga ? Xa : 0);
    if (b === 0)
      return null;
    if (b & 30 || b & a.expiredLanes || o)
      o = mh(a, b);
    else {
      o = b;
      var R = kn;
      kn |= 2;
      var I = Gm();
      (ga !== a || Xa !== o) && (Gs = null, Lc = hn() + 500, Mc(a, o));
      do
        try {
          pb();
          break;
        } catch (K) {
          jm(a, K);
        }
      while (1);
      za(), _c.current = I, kn = R, Qr !== null ? o = 0 : (ga = null, Xa = 0, o = Ya);
    }
    if (o !== 0) {
      if (o === 2 && (R = Rs(a), R !== 0 && (b = R, o = Dc(a, R))), o === 1)
        throw p = Zd, Mc(a, 0), cs(a, b), $a(a, hn()), p;
      if (o === 6)
        cs(a, b);
      else {
        if (R = a.current.alternate, !(b & 30) && !wv(R) && (o = mh(a, b), o === 2 && (I = Rs(a), I !== 0 && (b = I, o = Dc(a, I))), o === 1))
          throw p = Zd, Mc(a, 0), cs(a, b), $a(a, hn()), p;
        switch (a.finishedWork = R, a.finishedLanes = b, o) {
          case 0:
          case 1:
            throw Error(i(345));
          case 2:
            Mu(a, Ni, Gs);
            break;
          case 3:
            if (cs(a, b), (b & 130023424) === b && (o = dh + 500 - hn(), 10 < o)) {
              if (ti(a, 0) !== 0)
                break;
              if (R = a.suspendedLanes, (R & b) !== b) {
                si(), a.pingedLanes |= a.suspendedLanes & R;
                break;
              }
              a.timeoutHandle = el(Mu.bind(null, a, Ni, Gs), o);
              break;
            }
            Mu(a, Ni, Gs);
            break;
          case 4:
            if (cs(a, b), (b & 4194240) === b)
              break;
            for (o = a.eventTimes, R = -1; 0 < b; ) {
              var V = 31 - Bn(b);
              I = 1 << V, V = o[V], V > R && (R = V), b &= ~I;
            }
            if (b = R, b = hn() - b, b = (120 > b ? 120 : 480 > b ? 480 : 1080 > b ? 1080 : 1920 > b ? 1920 : 3e3 > b ? 3e3 : 4320 > b ? 4320 : 1960 * Hm(b / 1960)) - b, 10 < b) {
              a.timeoutHandle = el(Mu.bind(null, a, Ni, Gs), b);
              break;
            }
            Mu(a, Ni, Gs);
            break;
          case 5:
            Mu(a, Ni, Gs);
            break;
          default:
            throw Error(i(329));
        }
      }
    }
    return $a(a, hn()), a.callbackNode === p ? Uf.bind(null, a) : null;
  }
  function Dc(a, o) {
    var p = Lu;
    return a.current.memoizedState.isDehydrated && (Mc(a, o).flags |= 256), a = mh(a, o), a !== 2 && (o = Ni, Ni = p, o !== null && Tv(o)), a;
  }
  function Tv(a) {
    Ni === null ? Ni = a : Ni.push.apply(Ni, a);
  }
  function wv(a) {
    for (var o = a; ; ) {
      if (o.flags & 16384) {
        var p = o.updateQueue;
        if (p !== null && (p = p.stores, p !== null))
          for (var b = 0; b < p.length; b++) {
            var R = p[b], I = R.getSnapshot;
            R = R.value;
            try {
              if (!Re(I(), R))
                return !1;
            } catch {
              return !1;
            }
          }
      }
      if (p = o.child, o.subtreeFlags & 16384 && p !== null)
        p.return = o, o = p;
      else {
        if (o === a)
          break;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === a)
            return !0;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
    }
    return !0;
  }
  function cs(a, o) {
    for (o &= ~fh, o &= ~Oc, a.suspendedLanes |= o, a.pingedLanes &= ~o, a = a.expirationTimes; 0 < o; ) {
      var p = 31 - Bn(o), b = 1 << p;
      a[p] = -1, o &= ~b;
    }
  }
  function Vf(a) {
    if (kn & 6)
      throw Error(i(327));
    Hf();
    var o = ti(a, 0);
    if (!(o & 1))
      return $a(a, hn()), null;
    var p = mh(a, o);
    if (a.tag !== 0 && p === 2) {
      var b = Rs(a);
      b !== 0 && (o = b, p = Dc(a, b));
    }
    if (p === 1)
      throw p = Zd, Mc(a, 0), cs(a, o), $a(a, hn()), p;
    if (p === 6)
      throw Error(i(345));
    return a.finishedWork = a.current.alternate, a.finishedLanes = o, Mu(a, Ni, Gs), $a(a, hn()), null;
  }
  function Iv(a, o) {
    var p = kn;
    kn |= 1;
    try {
      return a(o);
    } finally {
      kn = p, kn === 0 && (Lc = hn() + 500, ai && co());
    }
  }
  function fs(a) {
    pl !== null && pl.tag === 0 && !(kn & 6) && Hf();
    var o = kn;
    kn |= 1;
    var p = fl.transition, b = Kn;
    try {
      if (fl.transition = null, Kn = 1, a)
        return a();
    } finally {
      Kn = b, fl.transition = p, kn = o, !(kn & 6) && co();
    }
  }
  function vh() {
    vo = Ff.current, vr(Ff);
  }
  function Mc(a, o) {
    a.finishedWork = null, a.finishedLanes = 0;
    var p = a.timeoutHandle;
    if (p !== -1 && (a.timeoutHandle = -1, vf(p)), Qr !== null)
      for (p = Qr.return; p !== null; ) {
        var b = p;
        switch (vc(b), b.tag) {
          case 1:
            b = b.type.childContextTypes, b != null && nl();
            break;
          case 3:
            Cu(), vr(pa), vr(un), Jp();
            break;
          case 5:
            $p(b);
            break;
          case 4:
            Cu();
            break;
          case 13:
            vr(Yr);
            break;
          case 19:
            vr(Yr);
            break;
          case 10:
            Wp(b.type._context);
            break;
          case 22:
          case 23:
            vh();
        }
        p = p.return;
      }
    if (ga = a, Qr = a = Ml(a.current, null), Xa = vo = o, Ya = 0, Zd = null, fh = Oc = Ou = 0, Ni = Lu = null, gc !== null) {
      for (o = 0; o < gc.length; o++)
        if (p = gc[o], b = p.interleaved, b !== null) {
          p.interleaved = null;
          var R = b.next, I = p.pending;
          if (I !== null) {
            var V = I.next;
            I.next = R, b.next = V;
          }
          p.pending = b;
        }
      gc = null;
    }
    return a;
  }
  function jm(a, o) {
    do {
      var p = Qr;
      try {
        if (za(), Md.current = Ai, Hi) {
          for (var b = Ut.memoizedState; b !== null; ) {
            var R = b.queue;
            R !== null && (R.pending = null), b = b.next;
          }
          Hi = !1;
        }
        if (Ft = 0, _n = rn = Ut = null, Rf = !1, yc = 0, ch.current = null, p === null || p.return === null) {
          Ya = 1, Zd = o, Qr = null;
          break;
        }
        e: {
          var I = a, V = p.return, K = p, ie = o;
          if (o = Xa, K.flags |= 32768, ie !== null && typeof ie == "object" && typeof ie.then == "function") {
            var we = ie, Qe = K, Ke = Qe.tag;
            if (!(Qe.mode & 1) && (Ke === 0 || Ke === 11 || Ke === 15)) {
              var Ye = Qe.alternate;
              Ye ? (Qe.updateQueue = Ye.updateQueue, Qe.memoizedState = Ye.memoizedState, Qe.lanes = Ye.lanes) : (Qe.updateQueue = null, Qe.memoizedState = null);
            }
            var Ct = Bm(V);
            if (Ct !== null) {
              Ct.flags &= -257, ah(Ct, V, K, I, o), Ct.mode & 1 && Au(I, we, o), o = Ct, ie = we;
              var Ot = o.updateQueue;
              if (Ot === null) {
                var Lt = /* @__PURE__ */ new Set();
                Lt.add(ie), o.updateQueue = Lt;
              } else
                Ot.add(ie);
              break e;
            } else {
              if (!(o & 1)) {
                Au(I, we, o), Kd();
                break e;
              }
              ie = Error(i(426));
            }
          } else if (Vr && K.mode & 1) {
            var Aa = Bm(V);
            if (Aa !== null) {
              !(Aa.flags & 65536) && (Aa.flags |= 256), ah(Aa, V, K, I, o), as(Bs(ie, K));
              break e;
            }
          }
          I = ie = Bs(ie, K), Ya !== 4 && (Ya = 2), Lu === null ? Lu = [I] : Lu.push(I), I = V;
          do {
            switch (I.tag) {
              case 3:
                I.flags |= 65536, o &= -o, I.lanes |= o;
                var ge = Hd(I, ie, o);
                km(I, ge);
                break e;
              case 1:
                K = ie;
                var le = I.type, ye = I.stateNode;
                if (!(I.flags & 128) && (typeof le.getDerivedStateFromError == "function" || ye !== null && typeof ye.componentDidCatch == "function" && (dl === null || !dl.has(ye)))) {
                  I.flags |= 65536, o &= -o, I.lanes |= o;
                  var tt = rh(I, K, o);
                  km(I, tt);
                  break e;
                }
            }
            I = I.return;
          } while (I !== null);
        }
        Wm(p);
      } catch (Bt) {
        o = Bt, Qr === p && p !== null && (Qr = p = p.return);
        continue;
      }
      break;
    } while (1);
  }
  function Gm() {
    var a = _c.current;
    return _c.current = Ai, a === null ? Ai : a;
  }
  function Kd() {
    (Ya === 0 || Ya === 3 || Ya === 2) && (Ya = 4), ga === null || !(Ou & 268435455) && !(Oc & 268435455) || cs(ga, Xa);
  }
  function mh(a, o) {
    var p = kn;
    kn |= 2;
    var b = Gm();
    (ga !== a || Xa !== o) && (Gs = null, Mc(a, o));
    do
      try {
        db();
        break;
      } catch (R) {
        jm(a, R);
      }
    while (1);
    if (za(), kn = p, _c.current = b, Qr !== null)
      throw Error(i(261));
    return ga = null, Xa = 0, Ya;
  }
  function db() {
    for (; Qr !== null; )
      zm(Qr);
  }
  function pb() {
    for (; Qr !== null && !Wr(); )
      zm(Qr);
  }
  function zm(a) {
    var o = Ym(a.alternate, a, vo);
    a.memoizedProps = a.pendingProps, o === null ? Wm(a) : Qr = o, ch.current = null;
  }
  function Wm(a) {
    var o = a;
    do {
      var p = o.alternate;
      if (a = o.return, o.flags & 32768) {
        if (p = cb(p, o), p !== null) {
          p.flags &= 32767, Qr = p;
          return;
        }
        if (a !== null)
          a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
        else {
          Ya = 6, Qr = null;
          return;
        }
      } else if (p = ub(p, o, vo), p !== null) {
        Qr = p;
        return;
      }
      if (o = o.sibling, o !== null) {
        Qr = o;
        return;
      }
      Qr = o = a;
    } while (o !== null);
    Ya === 0 && (Ya = 5);
  }
  function Mu(a, o, p) {
    var b = Kn, R = fl.transition;
    try {
      fl.transition = null, Kn = 1, hb(a, o, p, b);
    } finally {
      fl.transition = R, Kn = b;
    }
    return null;
  }
  function hb(a, o, p, b) {
    do
      Hf();
    while (pl !== null);
    if (kn & 6)
      throw Error(i(327));
    p = a.finishedWork;
    var R = a.finishedLanes;
    if (p === null)
      return null;
    if (a.finishedWork = null, a.finishedLanes = 0, p === a.current)
      throw Error(i(177));
    a.callbackNode = null, a.callbackPriority = 0;
    var I = p.lanes | p.childLanes;
    if (wp(a, I), a === ga && (Qr = ga = null, Xa = 0), !(p.subtreeFlags & 2064) && !(p.flags & 2064) || Bf || (Bf = !0, $m(ei, function() {
      return Hf(), null;
    })), I = (p.flags & 15990) !== 0, p.subtreeFlags & 15990 || I) {
      I = fl.transition, fl.transition = null;
      var V = Kn;
      Kn = 1;
      var K = kn;
      kn |= 4, ch.current = null, fb(a, p), Sv(p, a), Pp(Il), Zo = !!Td, Il = Td = null, a.current = p, sh(p), Ma(), kn = K, Kn = V, fl.transition = I;
    } else
      a.current = p;
    if (Bf && (Bf = !1, pl = a, Yi = R), I = a.pendingLanes, I === 0 && (dl = null), xl(p.stateNode), $a(a, hn()), o !== null)
      for (b = a.onRecoverableError, p = 0; p < o.length; p++)
        R = o[p], b(R.value, { componentStack: R.stack, digest: R.digest });
    if (ph)
      throw ph = !1, a = Rv, Rv = null, a;
    return Yi & 1 && a.tag !== 0 && Hf(), I = a.pendingLanes, I & 1 ? a === hh ? Jd++ : (Jd = 0, hh = a) : Jd = 0, co(), null;
  }
  function Hf() {
    if (pl !== null) {
      var a = Rl(Yi), o = fl.transition, p = Kn;
      try {
        if (fl.transition = null, Kn = 16 > a ? 16 : a, pl === null)
          var b = !1;
        else {
          if (a = pl, pl = null, Yi = 0, kn & 6)
            throw Error(i(331));
          var R = kn;
          for (kn |= 4, xt = a.current; xt !== null; ) {
            var I = xt, V = I.child;
            if (xt.flags & 16) {
              var K = I.deletions;
              if (K !== null) {
                for (var ie = 0; ie < K.length; ie++) {
                  var we = K[ie];
                  for (xt = we; xt !== null; ) {
                    var Qe = xt;
                    switch (Qe.tag) {
                      case 0:
                      case 11:
                      case 15:
                        ss(8, Qe, I);
                    }
                    var Ke = Qe.child;
                    if (Ke !== null)
                      Ke.return = Qe, xt = Ke;
                    else
                      for (; xt !== null; ) {
                        Qe = xt;
                        var Ye = Qe.sibling, Ct = Qe.return;
                        if (Um(Qe), Qe === we) {
                          xt = null;
                          break;
                        }
                        if (Ye !== null) {
                          Ye.return = Ct, xt = Ye;
                          break;
                        }
                        xt = Ct;
                      }
                  }
                }
                var Ot = I.alternate;
                if (Ot !== null) {
                  var Lt = Ot.child;
                  if (Lt !== null) {
                    Ot.child = null;
                    do {
                      var Aa = Lt.sibling;
                      Lt.sibling = null, Lt = Aa;
                    } while (Lt !== null);
                  }
                }
                xt = I;
              }
            }
            if (I.subtreeFlags & 2064 && V !== null)
              V.return = I, xt = V;
            else
              e:
                for (; xt !== null; ) {
                  if (I = xt, I.flags & 2048)
                    switch (I.tag) {
                      case 0:
                      case 11:
                      case 15:
                        ss(9, I, I.return);
                    }
                  var ge = I.sibling;
                  if (ge !== null) {
                    ge.return = I.return, xt = ge;
                    break e;
                  }
                  xt = I.return;
                }
          }
          var le = a.current;
          for (xt = le; xt !== null; ) {
            V = xt;
            var ye = V.child;
            if (V.subtreeFlags & 2064 && ye !== null)
              ye.return = V, xt = ye;
            else
              e:
                for (V = le; xt !== null; ) {
                  if (K = xt, K.flags & 2048)
                    try {
                      switch (K.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Xd(9, K);
                      }
                    } catch (Bt) {
                      la(K, K.return, Bt);
                    }
                  if (K === V) {
                    xt = null;
                    break e;
                  }
                  var tt = K.sibling;
                  if (tt !== null) {
                    tt.return = K.return, xt = tt;
                    break e;
                  }
                  xt = K.return;
                }
          }
          if (kn = R, co(), Ta && typeof Ta.onPostCommitFiberRoot == "function")
            try {
              Ta.onPostCommitFiberRoot(hr, a);
            } catch {
            }
          b = !0;
        }
        return b;
      } finally {
        Kn = p, fl.transition = o;
      }
    }
    return !1;
  }
  function gh(a, o, p) {
    o = Bs(p, o), o = Hd(a, o, 1), a = sl(a, o, 1), o = si(), a !== null && (Ts(a, 1, o), $a(a, o));
  }
  function la(a, o, p) {
    if (a.tag === 3)
      gh(a, a, p);
    else
      for (; o !== null; ) {
        if (o.tag === 3) {
          gh(o, a, p);
          break;
        } else if (o.tag === 1) {
          var b = o.stateNode;
          if (typeof o.type.getDerivedStateFromError == "function" || typeof b.componentDidCatch == "function" && (dl === null || !dl.has(b))) {
            a = Bs(p, a), a = rh(o, a, 1), o = sl(o, a, 1), a = si(), o !== null && (Ts(o, 1, a), $a(o, a));
            break;
          }
        }
        o = o.return;
      }
  }
  function vb(a, o, p) {
    var b = a.pingCache;
    b !== null && b.delete(o), o = si(), a.pingedLanes |= a.suspendedLanes & p, ga === a && (Xa & p) === p && (Ya === 4 || Ya === 3 && (Xa & 130023424) === Xa && 500 > hn() - dh ? Mc(a, 0) : fh |= p), $a(a, o);
  }
  function Xm(a, o) {
    o === 0 && (a.mode & 1 ? (o = tu, tu <<= 1, !(tu & 130023424) && (tu = 4194304)) : o = 1);
    var p = si();
    a = Ms(a, o), a !== null && (Ts(a, o, p), $a(a, p));
  }
  function Av(a) {
    var o = a.memoizedState, p = 0;
    o !== null && (p = o.retryLane), Xm(a, p);
  }
  function mb(a, o) {
    var p = 0;
    switch (a.tag) {
      case 13:
        var b = a.stateNode, R = a.memoizedState;
        R !== null && (p = R.retryLane);
        break;
      case 19:
        b = a.stateNode;
        break;
      default:
        throw Error(i(314));
    }
    b !== null && b.delete(o), Xm(a, p);
  }
  var Ym;
  Ym = function(a, o, p) {
    if (a !== null)
      if (a.memoizedProps !== o.pendingProps || pa.current)
        zi = !0;
      else {
        if (!(a.lanes & p) && !(o.flags & 128))
          return zi = !1, ls(a, o, p);
        zi = !!(a.flags & 131072);
      }
    else
      zi = !1, Vr && o.flags & 1048576 && pv(o, bf, o.index);
    switch (o.lanes = 0, o.tag) {
      case 2:
        var b = o.type;
        zd(a, o), a = o.pendingProps;
        var R = tl(o, un.current);
        yu(o, p), R = je(null, o, b, a, R, p);
        var I = Ia();
        return o.flags |= 1, typeof R == "object" && R !== null && typeof R.render == "function" && R.$$typeof === void 0 ? (o.tag = 1, o.memoizedState = null, o.updateQueue = null, ea(b) ? (I = !0, rl(o)) : I = !1, o.memoizedState = R.state !== null && R.state !== void 0 ? R.state : null, Ld(o), R.updater = Rc, o.stateNode = R, R._reactInternals = o, yv(o, b, a, p), o = ih(null, o, b, !0, I, p)) : (o.tag = 0, Vr && I && yf(o), aa(null, o, R, p), o = o.child), o;
      case 16:
        b = o.elementType;
        e: {
          switch (zd(a, o), a = o.pendingProps, R = b._init, b = R(b._payload), o.type = b, R = o.tag = gb(b), a = Gi(b, a), R) {
            case 0:
              o = yn(null, o, b, a, p);
              break e;
            case 1:
              o = Of(null, o, b, a, p);
              break e;
            case 11:
              o = _f(null, o, b, a, p);
              break e;
            case 14:
              o = Us(null, o, b, Gi(b.type, a), p);
              break e;
          }
          throw Error(i(
            306,
            b,
            ""
          ));
        }
        return o;
      case 0:
        return b = o.type, R = o.pendingProps, R = o.elementType === b ? R : Gi(b, R), yn(a, o, b, R, p);
      case 1:
        return b = o.type, R = o.pendingProps, R = o.elementType === b ? R : Gi(b, R), Of(a, o, b, R, p);
      case 3:
        e: {
          if (sb(o), a === null)
            throw Error(i(387));
          b = o.pendingProps, I = o.memoizedState, R = I.element, Cf(a, o), Ef(o, b, null, p);
          var V = o.memoizedState;
          if (b = V.element, I.isDehydrated)
            if (I = { element: b, isDehydrated: !1, cache: V.cache, pendingSuspenseBoundaries: V.pendingSuspenseBoundaries, transitions: V.transitions }, o.updateQueue.baseState = I, o.memoizedState = I, o.flags & 256) {
              R = Bs(Error(i(423)), o), o = os(a, o, b, p, R);
              break e;
            } else if (b !== R) {
              R = Bs(Error(i(424)), o), o = os(a, o, b, p, R);
              break e;
            } else
              for (po = Al(o.stateNode.containerInfo.firstChild), Ti = o, Vr = !0, il = null, p = zp(o, null, b, p), o.child = p; p; )
                p.flags = p.flags & -3 | 4096, p = p.sibling;
          else {
            if (kr(), b === R) {
              o = ia(a, o, p);
              break e;
            }
            aa(a, o, b, p);
          }
          o = o.child;
        }
        return o;
      case 5:
        return gv(o), a === null && Ui(o), b = o.type, R = o.pendingProps, I = a !== null ? a.memoizedProps : null, V = R.children, dc(b, R) ? V = null : I !== null && dc(b, I) && (o.flags |= 32), Nu(a, o), aa(a, o, V, p), o.child;
      case 6:
        return a === null && Ui(o), null;
      case 13:
        return oh(a, o, p);
      case 4:
        return mv(o, o.stateNode.containerInfo), b = o.pendingProps, a === null ? o.child = va(o, null, b, p) : aa(a, o, b, p), o.child;
      case 11:
        return b = o.type, R = o.pendingProps, R = o.elementType === b ? R : Gi(b, R), _f(a, o, b, R, p);
      case 7:
        return aa(a, o, o.pendingProps, p), o.child;
      case 8:
        return aa(a, o, o.pendingProps.children, p), o.child;
      case 12:
        return aa(a, o, o.pendingProps.children, p), o.child;
      case 10:
        e: {
          if (b = o.type._context, R = o.pendingProps, I = o.memoizedProps, V = R.value, yr(is, b._currentValue), b._currentValue = V, I !== null)
            if (Re(I.value, V)) {
              if (I.children === R.children && !pa.current) {
                o = ia(a, o, p);
                break e;
              }
            } else
              for (I = o.child, I !== null && (I.return = o); I !== null; ) {
                var K = I.dependencies;
                if (K !== null) {
                  V = I.child;
                  for (var ie = K.firstContext; ie !== null; ) {
                    if (ie.context === b) {
                      if (I.tag === 1) {
                        ie = ho(-1, p & -p), ie.tag = 2;
                        var we = I.updateQueue;
                        if (we !== null) {
                          we = we.shared;
                          var Qe = we.pending;
                          Qe === null ? ie.next = ie : (ie.next = Qe.next, Qe.next = ie), we.pending = ie;
                        }
                      }
                      I.lanes |= p, ie = I.alternate, ie !== null && (ie.lanes |= p), di(
                        I.return,
                        p,
                        o
                      ), K.lanes |= p;
                      break;
                    }
                    ie = ie.next;
                  }
                } else if (I.tag === 10)
                  V = I.type === o.type ? null : I.child;
                else if (I.tag === 18) {
                  if (V = I.return, V === null)
                    throw Error(i(341));
                  V.lanes |= p, K = V.alternate, K !== null && (K.lanes |= p), di(V, p, o), V = I.sibling;
                } else
                  V = I.child;
                if (V !== null)
                  V.return = I;
                else
                  for (V = I; V !== null; ) {
                    if (V === o) {
                      V = null;
                      break;
                    }
                    if (I = V.sibling, I !== null) {
                      I.return = V.return, V = I;
                      break;
                    }
                    V = V.return;
                  }
                I = V;
              }
          aa(a, o, R.children, p), o = o.child;
        }
        return o;
      case 9:
        return R = o.type, b = o.pendingProps.children, yu(o, p), R = ol(R), b = b(R), o.flags |= 1, aa(a, o, b, p), o.child;
      case 14:
        return b = o.type, R = Gi(b, o.pendingProps), R = Gi(b.type, R), Us(a, o, b, R, p);
      case 15:
        return cl(a, o, o.type, o.pendingProps, p);
      case 17:
        return b = o.type, R = o.pendingProps, R = o.elementType === b ? R : Gi(b, R), zd(a, o), o.tag = 1, ea(b) ? (a = !0, rl(o)) : a = !1, yu(o, p), Tc(o, b, R), yv(o, b, R, p), ih(null, o, b, !0, a, p);
      case 19:
        return js(a, o, p);
      case 22:
        return Wi(a, o, p);
    }
    throw Error(i(156, o.tag));
  };
  function $m(a, o) {
    return nn(a, o);
  }
  function Zm(a, o, p, b) {
    this.tag = a, this.key = p, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = o, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = b, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function hl(a, o, p, b) {
    return new Zm(a, o, p, b);
  }
  function bh(a) {
    return a = a.prototype, !(!a || !a.isReactComponent);
  }
  function gb(a) {
    if (typeof a == "function")
      return bh(a) ? 1 : 0;
    if (a != null) {
      if (a = a.$$typeof, a === Ge)
        return 11;
      if (a === at)
        return 14;
    }
    return 2;
  }
  function Ml(a, o) {
    var p = a.alternate;
    return p === null ? (p = hl(a.tag, o, a.key, a.mode), p.elementType = a.elementType, p.type = a.type, p.stateNode = a.stateNode, p.alternate = a, a.alternate = p) : (p.pendingProps = o, p.type = a.type, p.flags = 0, p.subtreeFlags = 0, p.deletions = null), p.flags = a.flags & 14680064, p.childLanes = a.childLanes, p.lanes = a.lanes, p.child = a.child, p.memoizedProps = a.memoizedProps, p.memoizedState = a.memoizedState, p.updateQueue = a.updateQueue, o = a.dependencies, p.dependencies = o === null ? null : { lanes: o.lanes, firstContext: o.firstContext }, p.sibling = a.sibling, p.index = a.index, p.ref = a.ref, p;
  }
  function yh(a, o, p, b, R, I) {
    var V = 2;
    if (b = a, typeof a == "function")
      bh(a) && (V = 1);
    else if (typeof a == "string")
      V = 5;
    else
      e:
        switch (a) {
          case j:
            return Pc(p.children, R, I, o);
          case re:
            V = 8, R |= 8;
            break;
          case me:
            return a = hl(12, p, o, R | 2), a.elementType = me, a.lanes = I, a;
          case ze:
            return a = hl(13, p, o, R), a.elementType = ze, a.lanes = I, a;
          case qe:
            return a = hl(19, p, o, R), a.elementType = qe, a.lanes = I, a;
          case We:
            return Ch(p, R, I, o);
          default:
            if (typeof a == "object" && a !== null)
              switch (a.$$typeof) {
                case Se:
                  V = 10;
                  break e;
                case Ne:
                  V = 9;
                  break e;
                case Ge:
                  V = 11;
                  break e;
                case at:
                  V = 14;
                  break e;
                case st:
                  V = 16, b = null;
                  break e;
              }
            throw Error(i(130, a == null ? a : typeof a, ""));
        }
    return o = hl(V, p, o, R), o.elementType = a, o.type = b, o.lanes = I, o;
  }
  function Pc(a, o, p, b) {
    return a = hl(7, a, b, o), a.lanes = p, a;
  }
  function Ch(a, o, p, b) {
    return a = hl(22, a, b, o), a.elementType = We, a.lanes = p, a.stateNode = { isHidden: !1 }, a;
  }
  function Eh(a, o, p) {
    return a = hl(6, a, null, o), a.lanes = p, a;
  }
  function qd(a, o, p) {
    return o = hl(4, a.children !== null ? a.children : [], a.key, o), o.lanes = p, o.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation }, o;
  }
  function ep(a, o, p, b, R) {
    this.tag = o, this.containerInfo = a, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = ru(0), this.expirationTimes = ru(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = ru(0), this.identifierPrefix = b, this.onRecoverableError = R, this.mutableSourceEagerHydrationData = null;
  }
  function Nv(a, o, p, b, R, I, V, K, ie) {
    return a = new ep(a, o, p, K, ie), o === 1 ? (o = 1, I === !0 && (o |= 8)) : o = 0, I = hl(3, null, null, o), a.current = I, I.stateNode = a, I.memoizedState = { element: b, isDehydrated: p, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Ld(I), a;
  }
  function Jm(a, o, p) {
    var b = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: oe, key: b == null ? null : "" + b, children: a, containerInfo: o, implementation: p };
  }
  function _v(a) {
    if (!a)
      return ts;
    a = a._reactInternals;
    e: {
      if (Fe(a) !== a || a.tag !== 1)
        throw Error(i(170));
      var o = a;
      do {
        switch (o.tag) {
          case 3:
            o = o.stateNode.context;
            break e;
          case 1:
            if (ea(o.type)) {
              o = o.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        o = o.return;
      } while (o !== null);
      throw Error(i(171));
    }
    if (a.tag === 1) {
      var p = a.type;
      if (ea(p))
        return Id(a, p, o);
    }
    return o;
  }
  function Ov(a, o, p, b, R, I, V, K, ie) {
    return a = Nv(p, b, !0, a, R, I, V, K, ie), a.context = _v(null), p = a.current, b = si(), R = zs(p), I = ho(b, R), I.callback = o ?? null, sl(p, I, R), a.current.lanes = R, Ts(a, R, b), $a(a, b), a;
  }
  function Sh(a, o, p, b) {
    var R = o.current, I = si(), V = zs(R);
    return p = _v(p), o.context === null ? o.context = p : o.pendingContext = p, o = ho(I, V), o.payload = { element: a }, b = b === void 0 ? null : b, b !== null && (o.callback = b), a = sl(R, o, V), a !== null && (oa(a, R, V, I), Yp(a, R, V)), V;
  }
  function tp(a) {
    if (a = a.current, !a.child)
      return null;
    switch (a.child.tag) {
      case 5:
        return a.child.stateNode;
      default:
        return a.child.stateNode;
    }
  }
  function Qm(a, o) {
    if (a = a.memoizedState, a !== null && a.dehydrated !== null) {
      var p = a.retryLane;
      a.retryLane = p !== 0 && p < o ? p : o;
    }
  }
  function Lv(a, o) {
    Qm(a, o), (a = a.alternate) && Qm(a, o);
  }
  function bb() {
    return null;
  }
  var Dv = typeof reportError == "function" ? reportError : function(a) {
    console.error(a);
  };
  function np(a) {
    this._internalRoot = a;
  }
  jf.prototype.render = np.prototype.render = function(a) {
    var o = this._internalRoot;
    if (o === null)
      throw Error(i(409));
    Sh(a, o, null, null);
  }, jf.prototype.unmount = np.prototype.unmount = function() {
    var a = this._internalRoot;
    if (a !== null) {
      this._internalRoot = null;
      var o = a.containerInfo;
      fs(function() {
        Sh(null, a, null, null);
      }), o[Ao] = null;
    }
  };
  function jf(a) {
    this._internalRoot = a;
  }
  jf.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
      var o = rc();
      a = { blockedOn: null, target: a, priority: o };
      for (var p = 0; p < gr.length && o !== 0 && o < gr[p].priority; p++)
        ;
      gr.splice(p, 0, a), p === 0 && Ap(a);
    }
  };
  function Pu(a) {
    return !(!a || a.nodeType !== 1 && a.nodeType !== 9 && a.nodeType !== 11);
  }
  function xh(a) {
    return !(!a || a.nodeType !== 1 && a.nodeType !== 9 && a.nodeType !== 11 && (a.nodeType !== 8 || a.nodeValue !== " react-mount-point-unstable "));
  }
  function Km() {
  }
  function yb(a, o, p, b, R) {
    if (R) {
      if (typeof b == "function") {
        var I = b;
        b = function() {
          var we = tp(V);
          I.call(we);
        };
      }
      var V = Ov(o, b, a, 0, null, !1, !1, "", Km);
      return a._reactRootContainer = V, a[Ao] = V.current, Ls(a.nodeType === 8 ? a.parentNode : a), fs(), V;
    }
    for (; R = a.lastChild; )
      a.removeChild(R);
    if (typeof b == "function") {
      var K = b;
      b = function() {
        var we = tp(ie);
        K.call(we);
      };
    }
    var ie = Nv(a, 0, !1, null, null, !1, !1, "", Km);
    return a._reactRootContainer = ie, a[Ao] = ie.current, Ls(a.nodeType === 8 ? a.parentNode : a), fs(function() {
      Sh(o, ie, p, b);
    }), ie;
  }
  function kc(a, o, p, b, R) {
    var I = p._reactRootContainer;
    if (I) {
      var V = I;
      if (typeof R == "function") {
        var K = R;
        R = function() {
          var ie = tp(V);
          K.call(ie);
        };
      }
      Sh(o, V, a, R);
    } else
      V = yb(p, o, a, R, b);
    return tp(V);
  }
  au = function(a) {
    switch (a.tag) {
      case 3:
        var o = a.stateNode;
        if (o.current.memoizedState.isDehydrated) {
          var p = Yo(o.pendingLanes);
          p !== 0 && ($o(o, p | 1), $a(o, hn()), !(kn & 6) && (Lc = hn() + 500, co()));
        }
        break;
      case 13:
        fs(function() {
          var b = Ms(a, 1);
          if (b !== null) {
            var R = si();
            oa(b, a, 1, R);
          }
        }), Lv(a, 1);
    }
  }, nc = function(a) {
    if (a.tag === 13) {
      var o = Ms(a, 134217728);
      if (o !== null) {
        var p = si();
        oa(o, a, 134217728, p);
      }
      Lv(a, 134217728);
    }
  }, Un = function(a) {
    if (a.tag === 13) {
      var o = zs(a), p = Ms(a, o);
      if (p !== null) {
        var b = si();
        oa(p, a, o, b);
      }
      Lv(a, o);
    }
  }, rc = function() {
    return Kn;
  }, ac = function(a, o) {
    var p = Kn;
    try {
      return Kn = a, o();
    } finally {
      Kn = p;
    }
  }, qa = function(a, o, p) {
    switch (o) {
      case "input":
        if (Jn(a, p), o = p.name, p.type === "radio" && o != null) {
          for (p = a; p.parentNode; )
            p = p.parentNode;
          for (p = p.querySelectorAll("input[name=" + JSON.stringify("" + o) + '][type="radio"]'), o = 0; o < p.length; o++) {
            var b = p[o];
            if (b !== a && b.form === a.form) {
              var R = zt(b);
              if (!R)
                throw Error(i(90));
              Ze(b), Jn(b, R);
            }
          }
        }
        break;
      case "textarea":
        xa(a, p);
        break;
      case "select":
        o = p.value, o != null && wr(a, !!p.multiple, o, !1);
    }
  }, Xl = Iv, Xo = fs;
  var Cb = { usingClientEntryPoint: !1, Events: [xi, Rn, zt, Pi, Wl, Iv] }, rp = { findFiberByHostInstance: Bi, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, qm = { bundleType: rp.bundleType, version: rp.version, rendererPackageName: rp.rendererPackageName, rendererConfig: rp.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Q.ReactCurrentDispatcher, findHostInstanceByFiber: function(a) {
    return a = Tt(a), a === null ? null : a.stateNode;
  }, findFiberByHostInstance: rp.findFiberByHostInstance || bb, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Rh = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Rh.isDisabled && Rh.supportsFiber)
      try {
        hr = Rh.inject(qm), Ta = Rh;
      } catch {
      }
  }
  return gs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Cb, gs.createPortal = function(a, o) {
    var p = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!Pu(o))
      throw Error(i(200));
    return Jm(a, o, null, p);
  }, gs.createRoot = function(a, o) {
    if (!Pu(a))
      throw Error(i(299));
    var p = !1, b = "", R = Dv;
    return o != null && (o.unstable_strictMode === !0 && (p = !0), o.identifierPrefix !== void 0 && (b = o.identifierPrefix), o.onRecoverableError !== void 0 && (R = o.onRecoverableError)), o = Nv(a, 1, !1, null, null, p, !1, b, R), a[Ao] = o.current, Ls(a.nodeType === 8 ? a.parentNode : a), new np(o);
  }, gs.findDOMNode = function(a) {
    if (a == null)
      return null;
    if (a.nodeType === 1)
      return a;
    var o = a._reactInternals;
    if (o === void 0)
      throw typeof a.render == "function" ? Error(i(188)) : (a = Object.keys(a).join(","), Error(i(268, a)));
    return a = Tt(o), a = a === null ? null : a.stateNode, a;
  }, gs.flushSync = function(a) {
    return fs(a);
  }, gs.hydrate = function(a, o, p) {
    if (!xh(o))
      throw Error(i(200));
    return kc(null, a, o, !0, p);
  }, gs.hydrateRoot = function(a, o, p) {
    if (!Pu(a))
      throw Error(i(405));
    var b = p != null && p.hydratedSources || null, R = !1, I = "", V = Dv;
    if (p != null && (p.unstable_strictMode === !0 && (R = !0), p.identifierPrefix !== void 0 && (I = p.identifierPrefix), p.onRecoverableError !== void 0 && (V = p.onRecoverableError)), o = Ov(o, null, a, 1, p ?? null, R, !1, I, V), a[Ao] = o.current, Ls(a), b)
      for (a = 0; a < b.length; a++)
        p = b[a], R = p._getVersion, R = R(p._source), o.mutableSourceEagerHydrationData == null ? o.mutableSourceEagerHydrationData = [p, R] : o.mutableSourceEagerHydrationData.push(
          p,
          R
        );
    return new jf(o);
  }, gs.render = function(a, o, p) {
    if (!xh(o))
      throw Error(i(200));
    return kc(null, a, o, !1, p);
  }, gs.unmountComponentAtNode = function(a) {
    if (!xh(a))
      throw Error(i(40));
    return a._reactRootContainer ? (fs(function() {
      kc(null, null, a, !1, function() {
        a._reactRootContainer = null, a[Ao] = null;
      });
    }), !0) : !1;
  }, gs.unstable_batchedUpdates = Iv, gs.unstable_renderSubtreeIntoContainer = function(a, o, p, b) {
    if (!xh(p))
      throw Error(i(200));
    if (a == null || a._reactInternals === void 0)
      throw Error(i(38));
    return kc(a, o, p, !1, b);
  }, gs.version = "18.3.1-next-f1338f8080-20240426", gs;
}
var bs = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oN;
function Y5() {
  return oN || (oN = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = k, r = e9(), i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, u = !1;
    function c(e) {
      u = e;
    }
    function v(e) {
      if (!u) {
        for (var n = arguments.length, l = new Array(n > 1 ? n - 1 : 0), f = 1; f < n; f++)
          l[f - 1] = arguments[f];
        y("warn", e, l);
      }
    }
    function h(e) {
      if (!u) {
        for (var n = arguments.length, l = new Array(n > 1 ? n - 1 : 0), f = 1; f < n; f++)
          l[f - 1] = arguments[f];
        y("error", e, l);
      }
    }
    function y(e, n, l) {
      {
        var f = i.ReactDebugCurrentFrame, m = f.getStackAddendum();
        m !== "" && (n += "%s", l = l.concat([m]));
        var E = l.map(function(w) {
          return String(w);
        });
        E.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, E);
      }
    }
    var g = 0, S = 1, x = 2, T = 3, _ = 4, L = 5, M = 6, U = 7, B = 8, H = 9, Y = 10, G = 11, Q = 12, W = 13, oe = 14, j = 15, re = 16, me = 17, Se = 18, Ne = 19, Ge = 21, ze = 22, qe = 23, at = 24, st = 25, We = !0, he = !1, ke = !1, _e = !1, q = !1, pe = !0, $e = !1, lt = !0, ot = !0, nt = !0, Rt = !0, ht = /* @__PURE__ */ new Set(), dt = {}, sn = {};
    function bn(e, n) {
      Ze(e, n), Ze(e + "Capture", n);
    }
    function Ze(e, n) {
      dt[e] && h("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), dt[e] = n;
      {
        var l = e.toLowerCase();
        sn[l] = e, e === "onDoubleClick" && (sn.ondblclick = e);
      }
      for (var f = 0; f < n.length; f++)
        ht.add(n[f]);
    }
    var mn = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", fn = Object.prototype.hasOwnProperty;
    function Gn(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, l = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return l;
      }
    }
    function ar(e) {
      try {
        return Jn(e), !1;
      } catch {
        return !0;
      }
    }
    function Jn(e) {
      return "" + e;
    }
    function Ha(e, n) {
      if (ar(e))
        return h("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", n, Gn(e)), Jn(e);
    }
    function ja(e) {
      if (ar(e))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Gn(e)), Jn(e);
    }
    function qr(e, n) {
      if (ar(e))
        return h("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", n, Gn(e)), Jn(e);
    }
    function wr(e, n) {
      if (ar(e))
        return h("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", n, Gn(e)), Jn(e);
    }
    function Da(e) {
      if (ar(e))
        return h("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Gn(e)), Jn(e);
    }
    function Sa(e) {
      if (ar(e))
        return h("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Gn(e)), Jn(e);
    }
    var xa = 0, Or = 1, fi = 2, pr = 3, xr = 4, ca = 5, Ka = 6, it = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", kt = it + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", $t = new RegExp("^[" + it + "][" + kt + "]*$"), Fn = {}, zn = {};
    function Ur(e) {
      return fn.call(zn, e) ? !0 : fn.call(Fn, e) ? !1 : $t.test(e) ? (zn[e] = !0, !0) : (Fn[e] = !0, h("Invalid attribute name: `%s`", e), !1);
    }
    function Lr(e, n, l) {
      return n !== null ? n.type === xa : l ? !1 : e.length > 2 && (e[0] === "o" || e[0] === "O") && (e[1] === "n" || e[1] === "N");
    }
    function Ga(e, n, l, f) {
      if (l !== null && l.type === xa)
        return !1;
      switch (typeof n) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (f)
            return !1;
          if (l !== null)
            return !l.acceptsBooleans;
          var m = e.toLowerCase().slice(0, 5);
          return m !== "data-" && m !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Qn(e, n, l, f) {
      if (n === null || typeof n > "u" || Ga(e, n, l, f))
        return !0;
      if (f)
        return !1;
      if (l !== null)
        switch (l.type) {
          case pr:
            return !n;
          case xr:
            return n === !1;
          case ca:
            return isNaN(n);
          case Ka:
            return isNaN(n) || n < 1;
        }
      return !1;
    }
    function qa(e) {
      return Xn.hasOwnProperty(e) ? Xn[e] : null;
    }
    function Wn(e, n, l, f, m, E, w) {
      this.acceptsBooleans = n === fi || n === pr || n === xr, this.attributeName = f, this.attributeNamespace = m, this.mustUseProperty = l, this.propertyName = e, this.type = n, this.sanitizeURL = E, this.removeEmptyString = w;
    }
    var Xn = {}, So = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    So.forEach(function(e) {
      Xn[e] = new Wn(
        e,
        xa,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
      var n = e[0], l = e[1];
      Xn[n] = new Wn(
        n,
        Or,
        !1,
        // mustUseProperty
        l,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
      Xn[e] = new Wn(
        e,
        fi,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
      Xn[e] = new Wn(
        e,
        fi,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(e) {
      Xn[e] = new Wn(
        e,
        pr,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      Xn[e] = new Wn(
        e,
        pr,
        !0,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      Xn[e] = new Wn(
        e,
        xr,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      Xn[e] = new Wn(
        e,
        Ka,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(e) {
      Xn[e] = new Wn(
        e,
        ca,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Pi = /[\-\:]([a-z])/g, Wl = function(e) {
      return e[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var n = e.replace(Pi, Wl);
      Xn[n] = new Wn(
        n,
        Or,
        !1,
        // mustUseProperty
        e,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var n = e.replace(Pi, Wl);
      Xn[n] = new Wn(
        n,
        Or,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var n = e.replace(Pi, Wl);
      Xn[n] = new Wn(
        n,
        Or,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(e) {
      Xn[e] = new Wn(
        e,
        Or,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Xl = "xlinkHref";
    Xn[Xl] = new Wn(
      "xlinkHref",
      Or,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(e) {
      Xn[e] = new Wn(
        e,
        Or,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var Xo = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, ao = !1;
    function Yl(e) {
      !ao && Xo.test(e) && (ao = !0, h("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(e)));
    }
    function ki(e, n, l, f) {
      if (f.mustUseProperty) {
        var m = f.propertyName;
        return e[m];
      } else {
        Ha(l, n), f.sanitizeURL && Yl("" + l);
        var E = f.attributeName, w = null;
        if (f.type === xr) {
          if (e.hasAttribute(E)) {
            var O = e.getAttribute(E);
            return O === "" ? !0 : Qn(n, l, f, !1) ? O : O === "" + l ? l : O;
          }
        } else if (e.hasAttribute(E)) {
          if (Qn(n, l, f, !1))
            return e.getAttribute(E);
          if (f.type === pr)
            return l;
          w = e.getAttribute(E);
        }
        return Qn(n, l, f, !1) ? w === null ? l : w : w === "" + l ? l : w;
      }
    }
    function ne(e, n, l, f) {
      {
        if (!Ur(n))
          return;
        if (!e.hasAttribute(n))
          return l === void 0 ? void 0 : null;
        var m = e.getAttribute(n);
        return Ha(l, n), m === "" + l ? l : m;
      }
    }
    function ce(e, n, l, f) {
      var m = qa(n);
      if (!Lr(n, m, f)) {
        if (Qn(n, l, m, f) && (l = null), f || m === null) {
          if (Ur(n)) {
            var E = n;
            l === null ? e.removeAttribute(E) : (Ha(l, n), e.setAttribute(E, "" + l));
          }
          return;
        }
        var w = m.mustUseProperty;
        if (w) {
          var O = m.propertyName;
          if (l === null) {
            var D = m.type;
            e[O] = D === pr ? !1 : "";
          } else
            e[O] = l;
          return;
        }
        var X = m.attributeName, Z = m.attributeNamespace;
        if (l === null)
          e.removeAttribute(X);
        else {
          var ue = m.type, se;
          ue === pr || ue === xr && l === !0 ? se = "" : (Ha(l, X), se = "" + l, m.sanitizeURL && Yl(se.toString())), Z ? e.setAttributeNS(Z, X, se) : e.setAttribute(X, se);
        }
      }
    }
    var xe = Symbol.for("react.element"), Ue = Symbol.for("react.portal"), rt = Symbol.for("react.fragment"), _t = Symbol.for("react.strict_mode"), Vt = Symbol.for("react.profiler"), J = Symbol.for("react.provider"), ve = Symbol.for("react.context"), be = Symbol.for("react.forward_ref"), Fe = Symbol.for("react.suspense"), ut = Symbol.for("react.suspense_list"), bt = Symbol.for("react.memo"), Et = Symbol.for("react.lazy"), Tt = Symbol.for("react.scope"), Zt = Symbol.for("react.debug_trace_mode"), nn = Symbol.for("react.offscreen"), sr = Symbol.for("react.legacy_hidden"), Wr = Symbol.for("react.cache"), Ma = Symbol.for("react.tracing_marker"), hn = Symbol.iterator, fa = "@@iterator";
    function Ra(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = hn && e[hn] || e[fa];
      return typeof n == "function" ? n : null;
    }
    var on = Object.assign, ei = 0, io, An, hr, Ta, xl, Bn, xo;
    function Ss() {
    }
    Ss.__reactDisabledLog = !0;
    function ec() {
      {
        if (ei === 0) {
          io = console.log, An = console.info, hr = console.warn, Ta = console.error, xl = console.group, Bn = console.groupCollapsed, xo = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Ss,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        ei++;
      }
    }
    function eu() {
      {
        if (ei--, ei === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: on({}, e, {
              value: io
            }),
            info: on({}, e, {
              value: An
            }),
            warn: on({}, e, {
              value: hr
            }),
            error: on({}, e, {
              value: Ta
            }),
            group: on({}, e, {
              value: xl
            }),
            groupCollapsed: on({}, e, {
              value: Bn
            }),
            groupEnd: on({}, e, {
              value: xo
            })
          });
        }
        ei < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var tu = i.ReactCurrentDispatcher, Yo;
    function ti(e, n, l) {
      {
        if (Yo === void 0)
          try {
            throw Error();
          } catch (m) {
            var f = m.stack.trim().match(/\n( *(at )?)/);
            Yo = f && f[1] || "";
          }
        return `
` + Yo + e;
      }
    }
    var xs = !1, nu;
    {
      var Rs = typeof WeakMap == "function" ? WeakMap : Map;
      nu = new Rs();
    }
    function tc(e, n) {
      if (!e || xs)
        return "";
      {
        var l = nu.get(e);
        if (l !== void 0)
          return l;
      }
      var f;
      xs = !0;
      var m = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var E;
      E = tu.current, tu.current = null, ec();
      try {
        if (n) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (Ae) {
              f = Ae;
            }
            Reflect.construct(e, [], w);
          } else {
            try {
              w.call();
            } catch (Ae) {
              f = Ae;
            }
            e.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ae) {
            f = Ae;
          }
          e();
        }
      } catch (Ae) {
        if (Ae && f && typeof Ae.stack == "string") {
          for (var O = Ae.stack.split(`
`), D = f.stack.split(`
`), X = O.length - 1, Z = D.length - 1; X >= 1 && Z >= 0 && O[X] !== D[Z]; )
            Z--;
          for (; X >= 1 && Z >= 0; X--, Z--)
            if (O[X] !== D[Z]) {
              if (X !== 1 || Z !== 1)
                do
                  if (X--, Z--, Z < 0 || O[X] !== D[Z]) {
                    var ue = `
` + O[X].replace(" at new ", " at ");
                    return e.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", e.displayName)), typeof e == "function" && nu.set(e, ue), ue;
                  }
                while (X >= 1 && Z >= 0);
              break;
            }
        }
      } finally {
        xs = !1, tu.current = E, eu(), Error.prepareStackTrace = m;
      }
      var se = e ? e.displayName || e.name : "", Ie = se ? ti(se) : "";
      return typeof e == "function" && nu.set(e, Ie), Ie;
    }
    function ru(e, n, l) {
      return tc(e, !0);
    }
    function Ts(e, n, l) {
      return tc(e, !1);
    }
    function wp(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function $o(e, n, l) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return tc(e, wp(e));
      if (typeof e == "string")
        return ti(e);
      switch (e) {
        case Fe:
          return ti("Suspense");
        case ut:
          return ti("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case be:
            return Ts(e.render);
          case bt:
            return $o(e.type, n, l);
          case Et: {
            var f = e, m = f._payload, E = f._init;
            try {
              return $o(E(m), n, l);
            } catch {
            }
          }
        }
      return "";
    }
    function Kn(e) {
      switch (e._debugOwner && e._debugOwner.type, e._debugSource, e.tag) {
        case L:
          return ti(e.type);
        case re:
          return ti("Lazy");
        case W:
          return ti("Suspense");
        case Ne:
          return ti("SuspenseList");
        case g:
        case x:
        case j:
          return Ts(e.type);
        case G:
          return Ts(e.type.render);
        case S:
          return ru(e.type);
        default:
          return "";
      }
    }
    function Rl(e) {
      try {
        var n = "", l = e;
        do
          n += Kn(l), l = l.return;
        while (l);
        return n;
      } catch (f) {
        return `
Error generating stack: ` + f.message + `
` + f.stack;
      }
    }
    function au(e, n, l) {
      var f = e.displayName;
      if (f)
        return f;
      var m = n.displayName || n.name || "";
      return m !== "" ? l + "(" + m + ")" : l;
    }
    function nc(e) {
      return e.displayName || "Context";
    }
    function Un(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case rt:
          return "Fragment";
        case Ue:
          return "Portal";
        case Vt:
          return "Profiler";
        case _t:
          return "StrictMode";
        case Fe:
          return "Suspense";
        case ut:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case ve:
            var n = e;
            return nc(n) + ".Consumer";
          case J:
            var l = e;
            return nc(l._context) + ".Provider";
          case be:
            return au(e, e.render, "ForwardRef");
          case bt:
            var f = e.displayName || null;
            return f !== null ? f : Un(e.type) || "Memo";
          case Et: {
            var m = e, E = m._payload, w = m._init;
            try {
              return Un(w(E));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function rc(e, n, l) {
      var f = n.displayName || n.name || "";
      return e.displayName || (f !== "" ? l + "(" + f + ")" : l);
    }
    function ac(e) {
      return e.displayName || "Context";
    }
    function dn(e) {
      var n = e.tag, l = e.type;
      switch (n) {
        case at:
          return "Cache";
        case H:
          var f = l;
          return ac(f) + ".Consumer";
        case Y:
          var m = l;
          return ac(m._context) + ".Provider";
        case Se:
          return "DehydratedFragment";
        case G:
          return rc(l, l.render, "ForwardRef");
        case U:
          return "Fragment";
        case L:
          return l;
        case _:
          return "Portal";
        case T:
          return "Root";
        case M:
          return "Text";
        case re:
          return Un(l);
        case B:
          return l === _t ? "StrictMode" : "Mode";
        case ze:
          return "Offscreen";
        case Q:
          return "Profiler";
        case Ge:
          return "Scope";
        case W:
          return "Suspense";
        case Ne:
          return "SuspenseList";
        case st:
          return "TracingMarker";
        case S:
        case g:
        case me:
        case x:
        case oe:
        case j:
          if (typeof l == "function")
            return l.displayName || l.name || null;
          if (typeof l == "string")
            return l;
          break;
      }
      return null;
    }
    var iu = i.ReactDebugCurrentFrame, ra = null, oo = !1;
    function Fi() {
      {
        if (ra === null)
          return null;
        var e = ra._debugOwner;
        if (e !== null && typeof e < "u")
          return dn(e);
      }
      return null;
    }
    function ws() {
      return ra === null ? "" : Rl(ra);
    }
    function da() {
      iu.getCurrentStack = null, ra = null, oo = !1;
    }
    function gr(e) {
      iu.getCurrentStack = e === null ? null : ws, ra = e, oo = !1;
    }
    function Ip() {
      return ra;
    }
    function lo(e) {
      oo = e;
    }
    function Pa(e) {
      return "" + e;
    }
    function $l(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return Sa(e), e;
        default:
          return "";
      }
    }
    var Ap = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function Is(e, n) {
      Ap[n.type] || n.onChange || n.onInput || n.readOnly || n.disabled || n.value == null || h("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), n.onChange || n.readOnly || n.disabled || n.checked == null || h("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function ou(e) {
      var n = e.type, l = e.nodeName;
      return l && l.toLowerCase() === "input" && (n === "checkbox" || n === "radio");
    }
    function Np(e) {
      return e._valueTracker;
    }
    function Vn(e) {
      e._valueTracker = null;
    }
    function ir(e) {
      var n = "";
      return e && (ou(e) ? n = e.checked ? "true" : "false" : n = e.value), n;
    }
    function As(e) {
      var n = ou(e) ? "checked" : "value", l = Object.getOwnPropertyDescriptor(e.constructor.prototype, n);
      Sa(e[n]);
      var f = "" + e[n];
      if (!(e.hasOwnProperty(n) || typeof l > "u" || typeof l.get != "function" || typeof l.set != "function")) {
        var m = l.get, E = l.set;
        Object.defineProperty(e, n, {
          configurable: !0,
          get: function() {
            return m.call(this);
          },
          set: function(O) {
            Sa(O), f = "" + O, E.call(this, O);
          }
        }), Object.defineProperty(e, n, {
          enumerable: l.enumerable
        });
        var w = {
          getValue: function() {
            return f;
          },
          setValue: function(O) {
            Sa(O), f = "" + O;
          },
          stopTracking: function() {
            Vn(e), delete e[n];
          }
        };
        return w;
      }
    }
    function Zo(e) {
      Np(e) || (e._valueTracker = As(e));
    }
    function ef(e) {
      if (!e)
        return !1;
      var n = Np(e);
      if (!n)
        return !0;
      var l = n.getValue(), f = ir(e);
      return f !== l ? (n.setValue(f), !0) : !1;
    }
    function lu(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
        return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    var su = !1, ic = !1, oc = !1, hd = !1;
    function Dr(e) {
      var n = e.type === "checkbox" || e.type === "radio";
      return n ? e.checked != null : e.value != null;
    }
    function P(e, n) {
      var l = e, f = n.checked, m = on({}, n, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: f ?? l._wrapperState.initialChecked
      });
      return m;
    }
    function te(e, n) {
      Is("input", n), n.checked !== void 0 && n.defaultChecked !== void 0 && !ic && (h("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Fi() || "A component", n.type), ic = !0), n.value !== void 0 && n.defaultValue !== void 0 && !su && (h("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Fi() || "A component", n.type), su = !0);
      var l = e, f = n.defaultValue == null ? "" : n.defaultValue;
      l._wrapperState = {
        initialChecked: n.checked != null ? n.checked : n.defaultChecked,
        initialValue: $l(n.value != null ? n.value : f),
        controlled: Dr(n)
      };
    }
    function Te(e, n) {
      var l = e, f = n.checked;
      f != null && ce(l, "checked", f, !1);
    }
    function Oe(e, n) {
      var l = e;
      {
        var f = Dr(n);
        !l._wrapperState.controlled && f && !hd && (h("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), hd = !0), l._wrapperState.controlled && !f && !oc && (h("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), oc = !0);
      }
      Te(e, n);
      var m = $l(n.value), E = n.type;
      if (m != null)
        E === "number" ? (m === 0 && l.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        l.value != m) && (l.value = Pa(m)) : l.value !== Pa(m) && (l.value = Pa(m));
      else if (E === "submit" || E === "reset") {
        l.removeAttribute("value");
        return;
      }
      n.hasOwnProperty("value") ? Wt(l, n.type, m) : n.hasOwnProperty("defaultValue") && Wt(l, n.type, $l(n.defaultValue)), n.checked == null && n.defaultChecked != null && (l.defaultChecked = !!n.defaultChecked);
    }
    function Je(e, n, l) {
      var f = e;
      if (n.hasOwnProperty("value") || n.hasOwnProperty("defaultValue")) {
        var m = n.type, E = m === "submit" || m === "reset";
        if (E && (n.value === void 0 || n.value === null))
          return;
        var w = Pa(f._wrapperState.initialValue);
        l || w !== f.value && (f.value = w), f.defaultValue = w;
      }
      var O = f.name;
      O !== "" && (f.name = ""), f.defaultChecked = !f.defaultChecked, f.defaultChecked = !!f._wrapperState.initialChecked, O !== "" && (f.name = O);
    }
    function Xt(e, n) {
      var l = e;
      Oe(l, n), pt(l, n);
    }
    function pt(e, n) {
      var l = n.name;
      if (n.type === "radio" && l != null) {
        for (var f = e; f.parentNode; )
          f = f.parentNode;
        Ha(l, "name");
        for (var m = f.querySelectorAll("input[name=" + JSON.stringify("" + l) + '][type="radio"]'), E = 0; E < m.length; E++) {
          var w = m[E];
          if (!(w === e || w.form !== e.form)) {
            var O = en(w);
            if (!O)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            ef(w), Oe(w, O);
          }
        }
      }
    }
    function Wt(e, n, l) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (n !== "number" || lu(e.ownerDocument) !== e) && (l == null ? e.defaultValue = Pa(e._wrapperState.initialValue) : e.defaultValue !== Pa(l) && (e.defaultValue = Pa(l)));
    }
    var Nn = !1, Yn = !1, Ir = !1;
    function xn(e, n) {
      n.value == null && (typeof n.children == "object" && n.children !== null ? t.Children.forEach(n.children, function(l) {
        l != null && (typeof l == "string" || typeof l == "number" || Yn || (Yn = !0, h("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : n.dangerouslySetInnerHTML != null && (Ir || (Ir = !0, h("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), n.selected != null && !Nn && (h("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Nn = !0);
    }
    function Mr(e, n) {
      n.value != null && e.setAttribute("value", Pa($l(n.value)));
    }
    var Pn = Array.isArray;
    function Hn(e) {
      return Pn(e);
    }
    var Zl;
    Zl = !1;
    function Ro() {
      var e = Fi();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    var uu = ["value", "defaultValue"];
    function vd(e) {
      {
        Is("select", e);
        for (var n = 0; n < uu.length; n++) {
          var l = uu[n];
          if (e[l] != null) {
            var f = Hn(e[l]);
            e.multiple && !f ? h("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", l, Ro()) : !e.multiple && f && h("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", l, Ro());
          }
        }
      }
    }
    function qn(e, n, l, f) {
      var m = e.options;
      if (n) {
        for (var E = l, w = {}, O = 0; O < E.length; O++)
          w["$" + E[O]] = !0;
        for (var D = 0; D < m.length; D++) {
          var X = w.hasOwnProperty("$" + m[D].value);
          m[D].selected !== X && (m[D].selected = X), X && f && (m[D].defaultSelected = !0);
        }
      } else {
        for (var Z = Pa($l(l)), ue = null, se = 0; se < m.length; se++) {
          if (m[se].value === Z) {
            m[se].selected = !0, f && (m[se].defaultSelected = !0);
            return;
          }
          ue === null && !m[se].disabled && (ue = m[se]);
        }
        ue !== null && (ue.selected = !0);
      }
    }
    function Jo(e, n) {
      return on({}, n, {
        value: void 0
      });
    }
    function lc(e, n) {
      var l = e;
      vd(n), l._wrapperState = {
        wasMultiple: !!n.multiple
      }, n.value !== void 0 && n.defaultValue !== void 0 && !Zl && (h("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Zl = !0);
    }
    function ev(e, n) {
      var l = e;
      l.multiple = !!n.multiple;
      var f = n.value;
      f != null ? qn(l, !!n.multiple, f, !1) : n.defaultValue != null && qn(l, !!n.multiple, n.defaultValue, !0);
    }
    function tv(e, n) {
      var l = e, f = l._wrapperState.wasMultiple;
      l._wrapperState.wasMultiple = !!n.multiple;
      var m = n.value;
      m != null ? qn(l, !!n.multiple, m, !1) : f !== !!n.multiple && (n.defaultValue != null ? qn(l, !!n.multiple, n.defaultValue, !0) : qn(l, !!n.multiple, n.multiple ? [] : "", !1));
    }
    function tb(e, n) {
      var l = e, f = n.value;
      f != null && qn(l, !!n.multiple, f, !1);
    }
    var nv = !1;
    function rv(e, n) {
      var l = e;
      if (n.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var f = on({}, n, {
        value: void 0,
        defaultValue: void 0,
        children: Pa(l._wrapperState.initialValue)
      });
      return f;
    }
    function av(e, n) {
      var l = e;
      Is("textarea", n), n.value !== void 0 && n.defaultValue !== void 0 && !nv && (h("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", Fi() || "A component"), nv = !0);
      var f = n.value;
      if (f == null) {
        var m = n.children, E = n.defaultValue;
        if (m != null) {
          h("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (E != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Hn(m)) {
              if (m.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              m = m[0];
            }
            E = m;
          }
        }
        E == null && (E = ""), f = E;
      }
      l._wrapperState = {
        initialValue: $l(f)
      };
    }
    function md(e, n) {
      var l = e, f = $l(n.value), m = $l(n.defaultValue);
      if (f != null) {
        var E = Pa(f);
        E !== l.value && (l.value = E), n.defaultValue == null && l.defaultValue !== E && (l.defaultValue = E);
      }
      m != null && (l.defaultValue = Pa(m));
    }
    function sc(e, n) {
      var l = e, f = l.textContent;
      f === l._wrapperState.initialValue && f !== "" && f !== null && (l.value = f);
    }
    function iv(e, n) {
      md(e, n);
    }
    var Jl = "http://www.w3.org/1999/xhtml", Rm = "http://www.w3.org/1998/Math/MathML", gd = "http://www.w3.org/2000/svg";
    function tf(e) {
      switch (e) {
        case "svg":
          return gd;
        case "math":
          return Rm;
        default:
          return Jl;
      }
    }
    function _p(e, n) {
      return e == null || e === Jl ? tf(n) : e === gd && n === "foreignObject" ? Jl : e;
    }
    var nb = function(e) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(n, l, f, m) {
        MSApp.execUnsafeLocalFunction(function() {
          return e(n, l, f, m);
        });
      } : e;
    }, nf, Op = nb(function(e, n) {
      if (e.namespaceURI === gd && !("innerHTML" in e)) {
        nf = nf || document.createElement("div"), nf.innerHTML = "<svg>" + n.valueOf().toString() + "</svg>";
        for (var l = nf.firstChild; e.firstChild; )
          e.removeChild(e.firstChild);
        for (; l.firstChild; )
          e.appendChild(l.firstChild);
        return;
      }
      e.innerHTML = n;
    }), so = 1, Ql = 3, ur = 8, To = 9, Tl = 11, bd = function(e, n) {
      if (n) {
        var l = e.firstChild;
        if (l && l === e.lastChild && l.nodeType === Ql) {
          l.nodeValue = n;
          return;
        }
      }
      e.textContent = n;
    }, ov = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, rf = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function Tm(e, n) {
      return e + n.charAt(0).toUpperCase() + n.substring(1);
    }
    var wm = ["Webkit", "ms", "Moz", "O"];
    Object.keys(rf).forEach(function(e) {
      wm.forEach(function(n) {
        rf[Tm(n, e)] = rf[e];
      });
    });
    function Lp(e, n, l) {
      var f = n == null || typeof n == "boolean" || n === "";
      return f ? "" : !l && typeof n == "number" && n !== 0 && !(rf.hasOwnProperty(e) && rf[e]) ? n + "px" : (wr(n, e), ("" + n).trim());
    }
    var af = /([A-Z])/g, of = /^ms-/;
    function rb(e) {
      return e.replace(af, "-$1").toLowerCase().replace(of, "-ms-");
    }
    var Im = function() {
    };
    {
      var Dp = /^(?:webkit|moz|o)[A-Z]/, lv = /^-ms-/, Qo = /-(.)/g, Ns = /;\s*$/, lf = {}, sf = {}, Am = !1, cu = !1, wo = function(e) {
        return e.replace(Qo, function(n, l) {
          return l.toUpperCase();
        });
      }, Mp = function(e) {
        lf.hasOwnProperty(e) && lf[e] || (lf[e] = !0, h(
          "Unsupported style property %s. Did you mean %s?",
          e,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          wo(e.replace(lv, "ms-"))
        ));
      }, Nm = function(e) {
        lf.hasOwnProperty(e) && lf[e] || (lf[e] = !0, h("Unsupported vendor-prefixed style property %s. Did you mean %s?", e, e.charAt(0).toUpperCase() + e.slice(1)));
      }, _m = function(e, n) {
        sf.hasOwnProperty(n) && sf[n] || (sf[n] = !0, h(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, e, n.replace(Ns, "")));
      }, Om = function(e, n) {
        Am || (Am = !0, h("`NaN` is an invalid value for the `%s` css style property.", e));
      }, ab = function(e, n) {
        cu || (cu = !0, h("`Infinity` is an invalid value for the `%s` css style property.", e));
      };
      Im = function(e, n) {
        e.indexOf("-") > -1 ? Mp(e) : Dp.test(e) ? Nm(e) : Ns.test(n) && _m(e, n), typeof n == "number" && (isNaN(n) ? Om(e, n) : isFinite(n) || ab(e, n));
      };
    }
    var ib = Im;
    function uf(e) {
      {
        var n = "", l = "";
        for (var f in e)
          if (e.hasOwnProperty(f)) {
            var m = e[f];
            if (m != null) {
              var E = f.indexOf("--") === 0;
              n += l + (E ? f : rb(f)) + ":", n += Lp(f, m, E), l = ";";
            }
          }
        return n || null;
      }
    }
    function fe(e, n) {
      var l = e.style;
      for (var f in n)
        if (n.hasOwnProperty(f)) {
          var m = f.indexOf("--") === 0;
          m || ib(f, n[f]);
          var E = Lp(f, n[f], m);
          f === "float" && (f = "cssFloat"), m ? l.setProperty(f, E) : l[f] = E;
        }
    }
    function De(e) {
      return e == null || typeof e == "boolean" || e === "";
    }
    function Re(e) {
      var n = {};
      for (var l in e)
        for (var f = ov[l] || [l], m = 0; m < f.length; m++)
          n[f[m]] = l;
      return n;
    }
    function yt(e, n) {
      {
        if (!n)
          return;
        var l = Re(e), f = Re(n), m = {};
        for (var E in l) {
          var w = l[E], O = f[E];
          if (O && w !== O) {
            var D = w + "," + O;
            if (m[D])
              continue;
            m[D] = !0, h("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", De(e[w]) ? "Removing" : "Updating", w, O);
          }
        }
      }
    }
    var gn = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, cr = on({
      menuitem: !0
    }, gn), ka = "__html";
    function br(e, n) {
      if (n) {
        if (cr[e] && (n.children != null || n.dangerouslySetInnerHTML != null))
          throw new Error(e + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (n.dangerouslySetInnerHTML != null) {
          if (n.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof n.dangerouslySetInnerHTML != "object" || !(ka in n.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!n.suppressContentEditableWarning && n.contentEditable && n.children != null && h("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), n.style != null && typeof n.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function wl(e, n) {
      if (e.indexOf("-") === -1)
        return typeof n.is == "string";
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Pp = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Io = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, uo = {}, sv = new RegExp("^(aria)-[" + kt + "]*$"), Kl = new RegExp("^(aria)[A-Z][" + kt + "]*$");
    function cf(e, n) {
      {
        if (fn.call(uo, n) && uo[n])
          return !0;
        if (Kl.test(n)) {
          var l = "aria-" + n.slice(4).toLowerCase(), f = Io.hasOwnProperty(l) ? l : null;
          if (f == null)
            return h("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", n), uo[n] = !0, !0;
          if (n !== f)
            return h("Invalid ARIA attribute `%s`. Did you mean `%s`?", n, f), uo[n] = !0, !0;
        }
        if (sv.test(n)) {
          var m = n.toLowerCase(), E = Io.hasOwnProperty(m) ? m : null;
          if (E == null)
            return uo[n] = !0, !1;
          if (n !== E)
            return h("Unknown ARIA attribute `%s`. Did you mean `%s`?", n, E), uo[n] = !0, !0;
        }
      }
      return !0;
    }
    function yd(e, n) {
      {
        var l = [];
        for (var f in n) {
          var m = cf(e, f);
          m || l.push(f);
        }
        var E = l.map(function(w) {
          return "`" + w + "`";
        }).join(", ");
        l.length === 1 ? h("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", E, e) : l.length > 1 && h("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", E, e);
      }
    }
    function fr(e, n) {
      wl(e, n) || yd(e, n);
    }
    var uc = !1;
    function kp(e, n) {
      {
        if (e !== "input" && e !== "textarea" && e !== "select")
          return;
        n != null && n.value === null && !uc && (uc = !0, e === "select" && n.multiple ? h("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : h("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
      }
    }
    var ff = function() {
    };
    {
      var ni = {}, uv = /^on./, Lm = /^on[^A-Z]/, Cd = new RegExp("^(aria)-[" + kt + "]*$"), _s = new RegExp("^(aria)[A-Z][" + kt + "]*$");
      ff = function(e, n, l, f) {
        if (fn.call(ni, n) && ni[n])
          return !0;
        var m = n.toLowerCase();
        if (m === "onfocusin" || m === "onfocusout")
          return h("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), ni[n] = !0, !0;
        if (f != null) {
          var E = f.registrationNameDependencies, w = f.possibleRegistrationNames;
          if (E.hasOwnProperty(n))
            return !0;
          var O = w.hasOwnProperty(m) ? w[m] : null;
          if (O != null)
            return h("Invalid event handler property `%s`. Did you mean `%s`?", n, O), ni[n] = !0, !0;
          if (uv.test(n))
            return h("Unknown event handler property `%s`. It will be ignored.", n), ni[n] = !0, !0;
        } else if (uv.test(n))
          return Lm.test(n) && h("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", n), ni[n] = !0, !0;
        if (Cd.test(n) || _s.test(n))
          return !0;
        if (m === "innerhtml")
          return h("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), ni[n] = !0, !0;
        if (m === "aria")
          return h("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), ni[n] = !0, !0;
        if (m === "is" && l !== null && l !== void 0 && typeof l != "string")
          return h("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof l), ni[n] = !0, !0;
        if (typeof l == "number" && isNaN(l))
          return h("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", n), ni[n] = !0, !0;
        var D = qa(n), X = D !== null && D.type === xa;
        if (Pp.hasOwnProperty(m)) {
          var Z = Pp[m];
          if (Z !== n)
            return h("Invalid DOM property `%s`. Did you mean `%s`?", n, Z), ni[n] = !0, !0;
        } else if (!X && n !== m)
          return h("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", n, m), ni[n] = !0, !0;
        return typeof l == "boolean" && Ga(n, l, D, !1) ? (l ? h('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', l, n, n, l, n) : h('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', l, n, n, l, n, n, n), ni[n] = !0, !0) : X ? !0 : Ga(n, l, D, !1) ? (ni[n] = !0, !1) : ((l === "false" || l === "true") && D !== null && D.type === pr && (h("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", l, n, l === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', n, l), ni[n] = !0), !0);
      };
    }
    var Ed = function(e, n, l) {
      {
        var f = [];
        for (var m in n) {
          var E = ff(e, m, n[m], l);
          E || f.push(m);
        }
        var w = f.map(function(O) {
          return "`" + O + "`";
        }).join(", ");
        f.length === 1 ? h("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", w, e) : f.length > 1 && h("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", w, e);
      }
    };
    function cv(e, n, l) {
      wl(e, n) || Ed(e, n, l);
    }
    var Ko = 1, df = 2, fu = 4, Fp = Ko | df | fu, pf = null;
    function Os(e) {
      pf !== null && h("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), pf = e;
    }
    function cc() {
      pf === null && h("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), pf = null;
    }
    function Sd(e) {
      return e === pf;
    }
    function Bp(e) {
      var n = e.target || e.srcElement || window;
      return n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === Ql ? n.parentNode : n;
    }
    var Pr = null, du = null, qo = null;
    function Ls(e) {
      var n = ft(e);
      if (n) {
        if (typeof Pr != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var l = n.stateNode;
        if (l) {
          var f = en(l);
          Pr(n.stateNode, n.type, f);
        }
      }
    }
    function Up(e) {
      Pr = e;
    }
    function Vp(e) {
      du ? qo ? qo.push(e) : qo = [e] : du = e;
    }
    function hf() {
      return du !== null || qo !== null;
    }
    function xd() {
      if (du) {
        var e = du, n = qo;
        if (du = null, qo = null, Ls(e), n)
          for (var l = 0; l < n.length; l++)
            Ls(n[l]);
      }
    }
    var fc = function(e, n) {
      return e(n);
    }, wa = function() {
    }, ri = !1;
    function ob() {
      var e = hf();
      e && (wa(), xd());
    }
    function fv(e, n, l) {
      if (ri)
        return e(n, l);
      ri = !0;
      try {
        return fc(e, n, l);
      } finally {
        ri = !1, ob();
      }
    }
    function Rd(e, n, l) {
      fc = e, wa = l;
    }
    function Hp(e) {
      return e === "button" || e === "input" || e === "select" || e === "textarea";
    }
    function Td(e, n, l) {
      switch (e) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(l.disabled && Hp(n));
        default:
          return !1;
      }
    }
    function Il(e, n) {
      var l = e.stateNode;
      if (l === null)
        return null;
      var f = en(l);
      if (f === null)
        return null;
      var m = f[n];
      if (Td(n, e.type, f))
        return null;
      if (m && typeof m != "function")
        throw new Error("Expected `" + n + "` listener to be a function, instead got a value of `" + typeof m + "` type.");
      return m;
    }
    var dc = !1;
    if (mn)
      try {
        var el = {};
        Object.defineProperty(el, "passive", {
          get: function() {
            dc = !0;
          }
        }), window.addEventListener("test", el, el), window.removeEventListener("test", el, el);
      } catch {
        dc = !1;
      }
    function vf(e, n, l, f, m, E, w, O, D) {
      var X = Array.prototype.slice.call(arguments, 3);
      try {
        n.apply(l, X);
      } catch (Z) {
        this.onError(Z);
      }
    }
    var pc = vf;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var mf = document.createElement("react");
      pc = function(n, l, f, m, E, w, O, D, X) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var Z = document.createEvent("Event"), ue = !1, se = !0, Ie = window.event, Ae = Object.getOwnPropertyDescriptor(window, "event");
        function Me() {
          mf.removeEventListener(Pe, Kt, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = Ie);
        }
        var gt = Array.prototype.slice.call(arguments, 3);
        function Kt() {
          ue = !0, Me(), l.apply(f, gt), se = !1;
        }
        var jt, lr = !1, Zn = !1;
        function Ce(Ee) {
          if (jt = Ee.error, lr = !0, jt === null && Ee.colno === 0 && Ee.lineno === 0 && (Zn = !0), Ee.defaultPrevented && jt != null && typeof jt == "object")
            try {
              jt._suppressLogging = !0;
            } catch {
            }
        }
        var Pe = "react-" + (n || "invokeguardedcallback");
        if (window.addEventListener("error", Ce), mf.addEventListener(Pe, Kt, !1), Z.initEvent(Pe, !1, !1), mf.dispatchEvent(Z), Ae && Object.defineProperty(window, "event", Ae), ue && se && (lr ? Zn && (jt = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : jt = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(jt)), window.removeEventListener("error", Ce), !ue)
          return Me(), vf.apply(this, arguments);
      };
    }
    var gf = pc, pu = !1, Al = null, wd = !1, hu = null, ql = {
      onError: function(e) {
        pu = !0, Al = e;
      }
    };
    function es(e, n, l, f, m, E, w, O, D) {
      pu = !1, Al = null, gf.apply(ql, arguments);
    }
    function Ao(e, n, l, f, m, E, w, O, D) {
      if (es.apply(this, arguments), pu) {
        var X = vu();
        wd || (wd = !0, hu = X);
      }
    }
    function jp() {
      if (wd) {
        var e = hu;
        throw wd = !1, hu = null, e;
      }
    }
    function z() {
      return pu;
    }
    function vu() {
      if (pu) {
        var e = Al;
        return pu = !1, Al = null, e;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Bi(e) {
      return e._reactInternals;
    }
    function xi(e) {
      return e._reactInternals !== void 0;
    }
    function Rn(e, n) {
      e._reactInternals = n;
    }
    var zt = (
      /*                      */
      0
    ), mu = (
      /*                */
      1
    ), Xr = (
      /*                    */
      2
    ), ln = (
      /*                       */
      4
    ), vr = (
      /*                */
      16
    ), yr = (
      /*                 */
      32
    ), ts = (
      /*                     */
      64
    ), un = (
      /*                   */
      128
    ), pa = (
      /*            */
      256
    ), ha = (
      /*                          */
      512
    ), tl = (
      /*                     */
      1024
    ), ea = (
      /*                      */
      2048
    ), nl = (
      /*                    */
      4096
    ), gu = (
      /*                   */
      8192
    ), Id = (
      /*             */
      16384
    ), rl = ea | ln | ts | ha | tl | Id, Dm = (
      /*               */
      32767
    ), No = (
      /*                   */
      32768
    ), ai = (
      /*                */
      65536
    ), Ad = (
      /* */
      131072
    ), dv = (
      /*                       */
      1048576
    ), Ds = (
      /*                    */
      2097152
    ), co = (
      /*                 */
      4194304
    ), bu = (
      /*                */
      8388608
    ), ta = (
      /*               */
      16777216
    ), hc = (
      /*              */
      33554432
    ), bf = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      ln | tl | 0
    ), fo = Xr | ln | vr | yr | ha | nl | gu, Ri = ln | ts | ha | gu, al = ea | vr, ii = co | bu | Ds, ns = i.ReactCurrentOwner;
    function _o(e) {
      var n = e, l = e;
      if (e.alternate)
        for (; n.return; )
          n = n.return;
      else {
        var f = n;
        do
          n = f, (n.flags & (Xr | nl)) !== zt && (l = n.return), f = n.return;
        while (f);
      }
      return n.tag === T ? l : null;
    }
    function pv(e) {
      if (e.tag === W) {
        var n = e.memoizedState;
        if (n === null) {
          var l = e.alternate;
          l !== null && (n = l.memoizedState);
        }
        if (n !== null)
          return n.dehydrated;
      }
      return null;
    }
    function yf(e) {
      return e.tag === T ? e.stateNode.containerInfo : null;
    }
    function vc(e) {
      return _o(e) === e;
    }
    function Ti(e) {
      {
        var n = ns.current;
        if (n !== null && n.tag === S) {
          var l = n, f = l.stateNode;
          f._warnedAboutRefsInRender || h("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", dn(l) || "A component"), f._warnedAboutRefsInRender = !0;
        }
      }
      var m = Bi(e);
      return m ? _o(m) === m : !1;
    }
    function po(e) {
      if (_o(e) !== e)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Vr(e) {
      var n = e.alternate;
      if (!n) {
        var l = _o(e);
        if (l === null)
          throw new Error("Unable to find node on an unmounted component.");
        return l !== e ? null : e;
      }
      for (var f = e, m = n; ; ) {
        var E = f.return;
        if (E === null)
          break;
        var w = E.alternate;
        if (w === null) {
          var O = E.return;
          if (O !== null) {
            f = m = O;
            continue;
          }
          break;
        }
        if (E.child === w.child) {
          for (var D = E.child; D; ) {
            if (D === f)
              return po(E), e;
            if (D === m)
              return po(E), n;
            D = D.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (f.return !== m.return)
          f = E, m = w;
        else {
          for (var X = !1, Z = E.child; Z; ) {
            if (Z === f) {
              X = !0, f = E, m = w;
              break;
            }
            if (Z === m) {
              X = !0, m = E, f = w;
              break;
            }
            Z = Z.sibling;
          }
          if (!X) {
            for (Z = w.child; Z; ) {
              if (Z === f) {
                X = !0, f = w, m = E;
                break;
              }
              if (Z === m) {
                X = !0, m = w, f = E;
                break;
              }
              Z = Z.sibling;
            }
            if (!X)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (f.alternate !== m)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (f.tag !== T)
        throw new Error("Unable to find node on an unmounted component.");
      return f.stateNode.current === f ? e : n;
    }
    function il(e) {
      var n = Vr(e);
      return n !== null ? Nl(n) : null;
    }
    function Nl(e) {
      if (e.tag === L || e.tag === M)
        return e;
      for (var n = e.child; n !== null; ) {
        var l = Nl(n);
        if (l !== null)
          return l;
        n = n.sibling;
      }
      return null;
    }
    function Gp(e) {
      var n = Vr(e);
      return n !== null ? rs(n) : null;
    }
    function rs(e) {
      if (e.tag === L || e.tag === M)
        return e;
      for (var n = e.child; n !== null; ) {
        if (n.tag !== _) {
          var l = rs(n);
          if (l !== null)
            return l;
        }
        n = n.sibling;
      }
      return null;
    }
    var Ui = r.unstable_scheduleCallback, Mm = r.unstable_cancelCallback, Nd = r.unstable_shouldYield, hv = r.unstable_requestPaint, kr = r.unstable_now, as = r.unstable_getCurrentPriorityLevel, _d = r.unstable_ImmediatePriority, mc = r.unstable_UserBlockingPriority, Oo = r.unstable_NormalPriority, Pm = r.unstable_LowPriority, Od = r.unstable_IdlePriority, va = r.unstable_yieldValue, zp = r.unstable_setDisableYieldValue, is = null, Ar = null, ct = null, Vi = !1, za = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Wp(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var n = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (n.isDisabled)
        return !0;
      if (!n.supportsFiber)
        return h("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        ot && (e = on({}, e, {
          getLaneLabelMap: Ms,
          injectProfilingHooks: Xp
        })), is = n.inject(e), Ar = n;
      } catch (l) {
        h("React instrumentation encountered an error: %s.", l);
      }
      return !!n.checkDCE;
    }
    function di(e, n) {
      if (Ar && typeof Ar.onScheduleFiberRoot == "function")
        try {
          Ar.onScheduleFiberRoot(is, e, n);
        } catch (l) {
          Vi || (Vi = !0, h("React instrumentation encountered an error: %s", l));
        }
    }
    function yu(e, n) {
      if (Ar && typeof Ar.onCommitFiberRoot == "function")
        try {
          var l = (e.current.flags & un) === un;
          if (nt) {
            var f;
            switch (n) {
              case ia:
                f = _d;
                break;
              case ls:
                f = mc;
                break;
              case $r:
                f = Oo;
                break;
              case Df:
                f = Od;
                break;
              default:
                f = Oo;
                break;
            }
            Ar.onCommitFiberRoot(is, e, f, l);
          }
        } catch (m) {
          Vi || (Vi = !0, h("React instrumentation encountered an error: %s", m));
        }
    }
    function ol(e) {
      if (Ar && typeof Ar.onPostCommitFiberRoot == "function")
        try {
          Ar.onPostCommitFiberRoot(is, e);
        } catch (n) {
          Vi || (Vi = !0, h("React instrumentation encountered an error: %s", n));
        }
    }
    function gc(e) {
      if (Ar && typeof Ar.onCommitFiberUnmount == "function")
        try {
          Ar.onCommitFiberUnmount(is, e);
        } catch (n) {
          Vi || (Vi = !0, h("React instrumentation encountered an error: %s", n));
        }
    }
    function Fa(e) {
      if (typeof va == "function" && (zp(e), c(e)), Ar && typeof Ar.setStrictMode == "function")
        try {
          Ar.setStrictMode(is, e);
        } catch (n) {
          Vi || (Vi = !0, h("React instrumentation encountered an error: %s", n));
        }
    }
    function Xp(e) {
      ct = e;
    }
    function Ms() {
      {
        for (var e = /* @__PURE__ */ new Map(), n = 1, l = 0; l < kd; l++) {
          var f = lb(n);
          e.set(n, f), n *= 2;
        }
        return e;
      }
    }
    function ll(e) {
      ct !== null && typeof ct.markCommitStarted == "function" && ct.markCommitStarted(e);
    }
    function Ld() {
      ct !== null && typeof ct.markCommitStopped == "function" && ct.markCommitStopped();
    }
    function Cf(e) {
      ct !== null && typeof ct.markComponentRenderStarted == "function" && ct.markComponentRenderStarted(e);
    }
    function ho() {
      ct !== null && typeof ct.markComponentRenderStopped == "function" && ct.markComponentRenderStopped();
    }
    function sl(e) {
      ct !== null && typeof ct.markComponentPassiveEffectMountStarted == "function" && ct.markComponentPassiveEffectMountStarted(e);
    }
    function Yp() {
      ct !== null && typeof ct.markComponentPassiveEffectMountStopped == "function" && ct.markComponentPassiveEffectMountStopped();
    }
    function km(e) {
      ct !== null && typeof ct.markComponentPassiveEffectUnmountStarted == "function" && ct.markComponentPassiveEffectUnmountStarted(e);
    }
    function Ef() {
      ct !== null && typeof ct.markComponentPassiveEffectUnmountStopped == "function" && ct.markComponentPassiveEffectUnmountStopped();
    }
    function vv(e) {
      ct !== null && typeof ct.markComponentLayoutEffectMountStarted == "function" && ct.markComponentLayoutEffectMountStarted(e);
    }
    function Dd() {
      ct !== null && typeof ct.markComponentLayoutEffectMountStopped == "function" && ct.markComponentLayoutEffectMountStopped();
    }
    function _l(e) {
      ct !== null && typeof ct.markComponentLayoutEffectUnmountStarted == "function" && ct.markComponentLayoutEffectUnmountStarted(e);
    }
    function Sf() {
      ct !== null && typeof ct.markComponentLayoutEffectUnmountStopped == "function" && ct.markComponentLayoutEffectUnmountStopped();
    }
    function xf(e, n, l) {
      ct !== null && typeof ct.markComponentErrored == "function" && ct.markComponentErrored(e, n, l);
    }
    function Ps(e, n, l) {
      ct !== null && typeof ct.markComponentSuspended == "function" && ct.markComponentSuspended(e, n, l);
    }
    function mv(e) {
      ct !== null && typeof ct.markLayoutEffectsStarted == "function" && ct.markLayoutEffectsStarted(e);
    }
    function Cu() {
      ct !== null && typeof ct.markLayoutEffectsStopped == "function" && ct.markLayoutEffectsStopped();
    }
    function gv(e) {
      ct !== null && typeof ct.markPassiveEffectsStarted == "function" && ct.markPassiveEffectsStarted(e);
    }
    function $p() {
      ct !== null && typeof ct.markPassiveEffectsStopped == "function" && ct.markPassiveEffectsStopped();
    }
    function Yr(e) {
      ct !== null && typeof ct.markRenderStarted == "function" && ct.markRenderStarted(e);
    }
    function bc() {
      ct !== null && typeof ct.markRenderYielded == "function" && ct.markRenderYielded();
    }
    function Zp() {
      ct !== null && typeof ct.markRenderStopped == "function" && ct.markRenderStopped();
    }
    function Jp(e) {
      ct !== null && typeof ct.markRenderScheduled == "function" && ct.markRenderScheduled(e);
    }
    function Md(e, n) {
      ct !== null && typeof ct.markForceUpdateScheduled == "function" && ct.markForceUpdateScheduled(e, n);
    }
    function Pd(e, n) {
      ct !== null && typeof ct.markStateUpdateScheduled == "function" && ct.markStateUpdateScheduled(e, n);
    }
    var Ft = (
      /*                         */
      0
    ), Ut = (
      /*                 */
      1
    ), rn = (
      /*                    */
      2
    ), _n = (
      /*               */
      8
    ), Hi = (
      /*              */
      16
    ), Rf = Math.clz32 ? Math.clz32 : wi, yc = Math.log, Ln = Math.LN2;
    function wi(e) {
      var n = e >>> 0;
      return n === 0 ? 32 : 31 - (yc(n) / Ln | 0) | 0;
    }
    var kd = 31, je = (
      /*                        */
      0
    ), Ia = (
      /*                          */
      0
    ), Ht = (
      /*                        */
      1
    ), pi = (
      /*    */
      2
    ), na = (
      /*             */
      4
    ), ks = (
      /*            */
      8
    ), ji = (
      /*                     */
      16
    ), Eu = (
      /*                */
      32
    ), Su = (
      /*                       */
      4194240
    ), Cc = (
      /*                        */
      64
    ), Ii = (
      /*                        */
      128
    ), Ol = (
      /*                        */
      256
    ), Tf = (
      /*                        */
      512
    ), Fd = (
      /*                        */
      1024
    ), Ec = (
      /*                        */
      2048
    ), xu = (
      /*                        */
      4096
    ), wf = (
      /*                        */
      8192
    ), Sc = (
      /*                        */
      16384
    ), Ru = (
      /*                       */
      32768
    ), If = (
      /*                       */
      65536
    ), ul = (
      /*                       */
      131072
    ), Qp = (
      /*                       */
      262144
    ), Ll = (
      /*                       */
      524288
    ), Bd = (
      /*                       */
      1048576
    ), Ud = (
      /*                       */
      2097152
    ), Tu = (
      /*                            */
      130023424
    ), xc = (
      /*                             */
      4194304
    ), Kp = (
      /*                             */
      8388608
    ), qp = (
      /*                             */
      16777216
    ), eh = (
      /*                             */
      33554432
    ), Vd = (
      /*                             */
      67108864
    ), Fm = xc, Af = (
      /*          */
      134217728
    ), th = (
      /*                          */
      268435455
    ), Wa = (
      /*               */
      268435456
    ), hi = (
      /*                        */
      536870912
    ), Ai = (
      /*                   */
      1073741824
    );
    function lb(e) {
      {
        if (e & Ht)
          return "Sync";
        if (e & pi)
          return "InputContinuousHydration";
        if (e & na)
          return "InputContinuous";
        if (e & ks)
          return "DefaultHydration";
        if (e & ji)
          return "Default";
        if (e & Eu)
          return "TransitionHydration";
        if (e & Su)
          return "Transition";
        if (e & Tu)
          return "Retry";
        if (e & Af)
          return "SelectiveHydration";
        if (e & Wa)
          return "IdleHydration";
        if (e & hi)
          return "Idle";
        if (e & Ai)
          return "Offscreen";
      }
    }
    var Rr = -1, Fs = Cc, Gi = xc;
    function wu(e) {
      switch (aa(e)) {
        case Ht:
          return Ht;
        case pi:
          return pi;
        case na:
          return na;
        case ks:
          return ks;
        case ji:
          return ji;
        case Eu:
          return Eu;
        case Cc:
        case Ii:
        case Ol:
        case Tf:
        case Fd:
        case Ec:
        case xu:
        case wf:
        case Sc:
        case Ru:
        case If:
        case ul:
        case Qp:
        case Ll:
        case Bd:
        case Ud:
          return e & Su;
        case xc:
        case Kp:
        case qp:
        case eh:
        case Vd:
          return e & Tu;
        case Af:
          return Af;
        case Wa:
          return Wa;
        case hi:
          return hi;
        case Ai:
          return Ai;
        default:
          return h("Should have found matching lanes. This is a bug in React."), e;
      }
    }
    function Rc(e, n) {
      var l = e.pendingLanes;
      if (l === je)
        return je;
      var f = je, m = e.suspendedLanes, E = e.pingedLanes, w = l & th;
      if (w !== je) {
        var O = w & ~m;
        if (O !== je)
          f = wu(O);
        else {
          var D = w & E;
          D !== je && (f = wu(D));
        }
      } else {
        var X = l & ~m;
        X !== je ? f = wu(X) : E !== je && (f = wu(E));
      }
      if (f === je)
        return je;
      if (n !== je && n !== f && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (n & m) === je) {
        var Z = aa(f), ue = aa(n);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          Z >= ue || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          Z === ji && (ue & Su) !== je
        )
          return n;
      }
      (f & na) !== je && (f |= l & ji);
      var se = e.entangledLanes;
      if (se !== je)
        for (var Ie = e.entanglements, Ae = f & se; Ae > 0; ) {
          var Me = Us(Ae), gt = 1 << Me;
          f |= Ie[Me], Ae &= ~gt;
        }
      return f;
    }
    function bv(e, n) {
      for (var l = e.eventTimes, f = Rr; n > 0; ) {
        var m = Us(n), E = 1 << m, w = l[m];
        w > f && (f = w), n &= ~E;
      }
      return f;
    }
    function Tc(e, n) {
      switch (e) {
        case Ht:
        case pi:
        case na:
          return n + 250;
        case ks:
        case ji:
        case Eu:
        case Cc:
        case Ii:
        case Ol:
        case Tf:
        case Fd:
        case Ec:
        case xu:
        case wf:
        case Sc:
        case Ru:
        case If:
        case ul:
        case Qp:
        case Ll:
        case Bd:
        case Ud:
          return n + 5e3;
        case xc:
        case Kp:
        case qp:
        case eh:
        case Vd:
          return Rr;
        case Af:
        case Wa:
        case hi:
        case Ai:
          return Rr;
        default:
          return h("Should have found matching lanes. This is a bug in React."), Rr;
      }
    }
    function Nf(e, n) {
      for (var l = e.pendingLanes, f = e.suspendedLanes, m = e.pingedLanes, E = e.expirationTimes, w = l; w > 0; ) {
        var O = Us(w), D = 1 << O, X = E[O];
        X === Rr ? ((D & f) === je || (D & m) !== je) && (E[O] = Tc(D, n)) : X <= n && (e.expiredLanes |= D), w &= ~D;
      }
    }
    function yv(e) {
      return wu(e.pendingLanes);
    }
    function Bs(e) {
      var n = e.pendingLanes & ~Ai;
      return n !== je ? n : n & Ai ? Ai : je;
    }
    function nh(e) {
      return (e & Ht) !== je;
    }
    function Iu(e) {
      return (e & th) !== je;
    }
    function Cv(e) {
      return (e & Tu) === e;
    }
    function Hd(e) {
      var n = Ht | na | ji;
      return (e & n) === je;
    }
    function rh(e) {
      return (e & Su) === e;
    }
    function Au(e, n) {
      var l = pi | na | ks | ji;
      return (n & l) !== je;
    }
    function Bm(e, n) {
      return (n & e.expiredLanes) !== je;
    }
    function ah(e) {
      return (e & Su) !== je;
    }
    function jd() {
      var e = Fs;
      return Fs <<= 1, (Fs & Su) === je && (Fs = Cc), e;
    }
    function zi() {
      var e = Gi;
      return Gi <<= 1, (Gi & Tu) === je && (Gi = xc), e;
    }
    function aa(e) {
      return e & -e;
    }
    function _f(e) {
      return aa(e);
    }
    function Us(e) {
      return 31 - Rf(e);
    }
    function cl(e) {
      return Us(e);
    }
    function Wi(e, n) {
      return (e & n) !== je;
    }
    function Nu(e, n) {
      return (e & n) === n;
    }
    function yn(e, n) {
      return e | n;
    }
    function Of(e, n) {
      return e & ~n;
    }
    function ih(e, n) {
      return e & n;
    }
    function sb(e) {
      return e;
    }
    function os(e, n) {
      return e !== Ia && e < n ? e : n;
    }
    function wc(e) {
      for (var n = [], l = 0; l < kd; l++)
        n.push(e);
      return n;
    }
    function Vs(e, n, l) {
      e.pendingLanes |= n, n !== hi && (e.suspendedLanes = je, e.pingedLanes = je);
      var f = e.eventTimes, m = cl(n);
      f[m] = l;
    }
    function oh(e, n) {
      e.suspendedLanes |= n, e.pingedLanes &= ~n;
      for (var l = e.expirationTimes, f = n; f > 0; ) {
        var m = Us(f), E = 1 << m;
        l[m] = Rr, f &= ~E;
      }
    }
    function Ic(e, n, l) {
      e.pingedLanes |= e.suspendedLanes & n;
    }
    function Hs(e, n) {
      var l = e.pendingLanes & ~n;
      e.pendingLanes = n, e.suspendedLanes = je, e.pingedLanes = je, e.expiredLanes &= n, e.mutableReadLanes &= n, e.entangledLanes &= n;
      for (var f = e.entanglements, m = e.eventTimes, E = e.expirationTimes, w = l; w > 0; ) {
        var O = Us(w), D = 1 << O;
        f[O] = je, m[O] = Rr, E[O] = Rr, w &= ~D;
      }
    }
    function Yt(e, n) {
      for (var l = e.entangledLanes |= n, f = e.entanglements, m = l; m; ) {
        var E = Us(m), w = 1 << E;
        // Is this one of the newly entangled lanes?
        w & n | // Is this lane transitively entangled with the newly entangled lanes?
        f[E] & n && (f[E] |= n), m &= ~w;
      }
    }
    function Gd(e, n) {
      var l = aa(n), f;
      switch (l) {
        case na:
          f = pi;
          break;
        case ji:
          f = ks;
          break;
        case Cc:
        case Ii:
        case Ol:
        case Tf:
        case Fd:
        case Ec:
        case xu:
        case wf:
        case Sc:
        case Ru:
        case If:
        case ul:
        case Qp:
        case Ll:
        case Bd:
        case Ud:
        case xc:
        case Kp:
        case qp:
        case eh:
        case Vd:
          f = Eu;
          break;
        case hi:
          f = Wa;
          break;
        default:
          f = Ia;
          break;
      }
      return (f & (e.suspendedLanes | n)) !== Ia ? Ia : f;
    }
    function Lf(e, n, l) {
      if (za)
        for (var f = e.pendingUpdatersLaneMap; l > 0; ) {
          var m = cl(l), E = 1 << m, w = f[m];
          w.add(n), l &= ~E;
        }
    }
    function js(e, n) {
      if (za)
        for (var l = e.pendingUpdatersLaneMap, f = e.memoizedUpdaters; n > 0; ) {
          var m = cl(n), E = 1 << m, w = l[m];
          w.size > 0 && (w.forEach(function(O) {
            var D = O.alternate;
            (D === null || !f.has(D)) && f.add(O);
          }), w.clear()), n &= ~E;
        }
    }
    function zd(e, n) {
      return null;
    }
    var ia = Ht, ls = na, $r = ji, Df = hi, Mf = Ia;
    function Lo() {
      return Mf;
    }
    function ma(e) {
      Mf = e;
    }
    function vi(e, n) {
      var l = Mf;
      try {
        return Mf = e, n();
      } finally {
        Mf = l;
      }
    }
    function ub(e, n) {
      return e !== 0 && e < n ? e : n;
    }
    function cb(e, n) {
      return e === 0 || e > n ? e : n;
    }
    function Pf(e, n) {
      return e !== 0 && e < n;
    }
    function Zr(e) {
      var n = aa(e);
      return Pf(ia, n) ? Pf(ls, n) ? Iu(n) ? $r : Df : ls : ia;
    }
    function oi(e) {
      var n = e.current.memoizedState;
      return n.isDehydrated;
    }
    var xt;
    function kf(e) {
      xt = e;
    }
    function Wd(e) {
      xt(e);
    }
    var lh;
    function fb(e) {
      lh = e;
    }
    var ss;
    function Xd(e) {
      ss = e;
    }
    var Yd;
    function Um(e) {
      Yd = e;
    }
    var Ev;
    function Vm(e) {
      Ev = e;
    }
    var $d = !1, Ac = [], Jr = null, li = null, mi = null, Nc = /* @__PURE__ */ new Map(), us = /* @__PURE__ */ new Map(), Ba = [], Sv = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function Dl(e) {
      return Sv.indexOf(e) > -1;
    }
    function sh(e, n, l, f, m) {
      return {
        blockedOn: e,
        domEventName: n,
        eventSystemFlags: l,
        nativeEvent: m,
        targetContainers: [f]
      };
    }
    function uh(e, n) {
      switch (e) {
        case "focusin":
        case "focusout":
          Jr = null;
          break;
        case "dragenter":
        case "dragleave":
          li = null;
          break;
        case "mouseover":
        case "mouseout":
          mi = null;
          break;
        case "pointerover":
        case "pointerout": {
          var l = n.pointerId;
          Nc.delete(l);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var f = n.pointerId;
          us.delete(f);
          break;
        }
      }
    }
    function Xi(e, n, l, f, m, E) {
      if (e === null || e.nativeEvent !== E) {
        var w = sh(n, l, f, m, E);
        if (n !== null) {
          var O = ft(n);
          O !== null && lh(O);
        }
        return w;
      }
      e.eventSystemFlags |= f;
      var D = e.targetContainers;
      return m !== null && D.indexOf(m) === -1 && D.push(m), e;
    }
    function _u(e, n, l, f, m) {
      switch (n) {
        case "focusin": {
          var E = m;
          return Jr = Xi(Jr, e, n, l, f, E), !0;
        }
        case "dragenter": {
          var w = m;
          return li = Xi(li, e, n, l, f, w), !0;
        }
        case "mouseover": {
          var O = m;
          return mi = Xi(mi, e, n, l, f, O), !0;
        }
        case "pointerover": {
          var D = m, X = D.pointerId;
          return Nc.set(X, Xi(Nc.get(X) || null, e, n, l, f, D)), !0;
        }
        case "gotpointercapture": {
          var Z = m, ue = Z.pointerId;
          return us.set(ue, Xi(us.get(ue) || null, e, n, l, f, Z)), !0;
        }
      }
      return !1;
    }
    function xv(e) {
      var n = Xe(e.target);
      if (n !== null) {
        var l = _o(n);
        if (l !== null) {
          var f = l.tag;
          if (f === W) {
            var m = pv(l);
            if (m !== null) {
              e.blockedOn = m, Ev(e.priority, function() {
                ss(l);
              });
              return;
            }
          } else if (f === T) {
            var E = l.stateNode;
            if (oi(E)) {
              e.blockedOn = yf(l);
              return;
            }
          }
        }
      }
      e.blockedOn = null;
    }
    function Hm(e) {
      for (var n = Yd(), l = {
        blockedOn: null,
        target: e,
        priority: n
      }, f = 0; f < Ba.length && Pf(n, Ba[f].priority); f++)
        ;
      Ba.splice(f, 0, l), f === 0 && xv(l);
    }
    function _c(e) {
      if (e.blockedOn !== null)
        return !1;
      for (var n = e.targetContainers; n.length > 0; ) {
        var l = n[0], f = Ni(e.domEventName, e.eventSystemFlags, l, e.nativeEvent);
        if (f === null) {
          var m = e.nativeEvent, E = new m.constructor(m.type, m);
          Os(E), m.target.dispatchEvent(E), cc();
        } else {
          var w = ft(f);
          return w !== null && lh(w), e.blockedOn = f, !1;
        }
        n.shift();
      }
      return !0;
    }
    function ch(e, n, l) {
      _c(e) && l.delete(n);
    }
    function fl() {
      $d = !1, Jr !== null && _c(Jr) && (Jr = null), li !== null && _c(li) && (li = null), mi !== null && _c(mi) && (mi = null), Nc.forEach(ch), us.forEach(ch);
    }
    function kn(e, n) {
      e.blockedOn === n && (e.blockedOn = null, $d || ($d = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, fl)));
    }
    function ga(e) {
      if (Ac.length > 0) {
        kn(Ac[0], e);
        for (var n = 1; n < Ac.length; n++) {
          var l = Ac[n];
          l.blockedOn === e && (l.blockedOn = null);
        }
      }
      Jr !== null && kn(Jr, e), li !== null && kn(li, e), mi !== null && kn(mi, e);
      var f = function(O) {
        return kn(O, e);
      };
      Nc.forEach(f), us.forEach(f);
      for (var m = 0; m < Ba.length; m++) {
        var E = Ba[m];
        E.blockedOn === e && (E.blockedOn = null);
      }
      for (; Ba.length > 0; ) {
        var w = Ba[0];
        if (w.blockedOn !== null)
          break;
        xv(w), w.blockedOn === null && Ba.shift();
      }
    }
    var Qr = i.ReactCurrentBatchConfig, Xa = !0;
    function vo(e) {
      Xa = !!e;
    }
    function Ff() {
      return Xa;
    }
    function Ya(e, n, l) {
      var f = dh(n), m;
      switch (f) {
        case ia:
          m = Zd;
          break;
        case ls:
          m = Ou;
          break;
        case $r:
        default:
          m = Oc;
          break;
      }
      return m.bind(null, n, l, e);
    }
    function Zd(e, n, l, f) {
      var m = Lo(), E = Qr.transition;
      Qr.transition = null;
      try {
        ma(ia), Oc(e, n, l, f);
      } finally {
        ma(m), Qr.transition = E;
      }
    }
    function Ou(e, n, l, f) {
      var m = Lo(), E = Qr.transition;
      Qr.transition = null;
      try {
        ma(ls), Oc(e, n, l, f);
      } finally {
        ma(m), Qr.transition = E;
      }
    }
    function Oc(e, n, l, f) {
      Xa && fh(e, n, l, f);
    }
    function fh(e, n, l, f) {
      var m = Ni(e, n, l, f);
      if (m === null) {
        wb(e, n, f, Lu, l), uh(e, f);
        return;
      }
      if (_u(m, e, n, l, f)) {
        f.stopPropagation();
        return;
      }
      if (uh(e, f), n & fu && Dl(e)) {
        for (; m !== null; ) {
          var E = ft(m);
          E !== null && Wd(E);
          var w = Ni(e, n, l, f);
          if (w === null && wb(e, n, f, Lu, l), w === m)
            break;
          m = w;
        }
        m !== null && f.stopPropagation();
        return;
      }
      wb(e, n, f, null, l);
    }
    var Lu = null;
    function Ni(e, n, l, f) {
      Lu = null;
      var m = Bp(f), E = Xe(m);
      if (E !== null) {
        var w = _o(E);
        if (w === null)
          E = null;
        else {
          var O = w.tag;
          if (O === W) {
            var D = pv(w);
            if (D !== null)
              return D;
            E = null;
          } else if (O === T) {
            var X = w.stateNode;
            if (oi(X))
              return yf(w);
            E = null;
          } else
            w !== E && (E = null);
        }
      }
      return Lu = E, null;
    }
    function dh(e) {
      switch (e) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return ia;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return ls;
        case "message": {
          var n = as();
          switch (n) {
            case _d:
              return ia;
            case mc:
              return ls;
            case Oo:
            case Pm:
              return $r;
            case Od:
              return Df;
            default:
              return $r;
          }
        }
        default:
          return $r;
      }
    }
    function Lc(e, n, l) {
      return e.addEventListener(n, l, !1), l;
    }
    function Gs(e, n, l) {
      return e.addEventListener(n, l, !0), l;
    }
    function ph(e, n, l, f) {
      return e.addEventListener(n, l, {
        capture: !0,
        passive: f
      }), l;
    }
    function Rv(e, n, l, f) {
      return e.addEventListener(n, l, {
        passive: f
      }), l;
    }
    var dl = null, Bf = null, pl = null;
    function Yi(e) {
      return dl = e, Bf = Qd(), !0;
    }
    function Jd() {
      dl = null, Bf = null, pl = null;
    }
    function hh() {
      if (pl)
        return pl;
      var e, n = Bf, l = n.length, f, m = Qd(), E = m.length;
      for (e = 0; e < l && n[e] === m[e]; e++)
        ;
      var w = l - e;
      for (f = 1; f <= w && n[l - f] === m[E - f]; f++)
        ;
      var O = f > 1 ? 1 - f : void 0;
      return pl = m.slice(e, O), pl;
    }
    function Qd() {
      return "value" in dl ? dl.value : dl.textContent;
    }
    function Du(e) {
      var n, l = e.keyCode;
      return "charCode" in e ? (n = e.charCode, n === 0 && l === 13 && (n = 13)) : n = l, n === 10 && (n = 13), n >= 32 || n === 13 ? n : 0;
    }
    function si() {
      return !0;
    }
    function zs() {
      return !1;
    }
    function oa(e) {
      function n(l, f, m, E, w) {
        this._reactName = l, this._targetInst = m, this.type = f, this.nativeEvent = E, this.target = w, this.currentTarget = null;
        for (var O in e)
          if (e.hasOwnProperty(O)) {
            var D = e[O];
            D ? this[O] = D(E) : this[O] = E[O];
          }
        var X = E.defaultPrevented != null ? E.defaultPrevented : E.returnValue === !1;
        return X ? this.isDefaultPrevented = si : this.isDefaultPrevented = zs, this.isPropagationStopped = zs, this;
      }
      return on(n.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var l = this.nativeEvent;
          l && (l.preventDefault ? l.preventDefault() : typeof l.returnValue != "unknown" && (l.returnValue = !1), this.isDefaultPrevented = si);
        },
        stopPropagation: function() {
          var l = this.nativeEvent;
          l && (l.stopPropagation ? l.stopPropagation() : typeof l.cancelBubble != "unknown" && (l.cancelBubble = !0), this.isPropagationStopped = si);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: si
      }), n;
    }
    var $a = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Uf = oa($a), Dc = on({}, $a, {
      view: 0,
      detail: 0
    }), Tv = oa(Dc), wv, cs, Vf;
    function Iv(e) {
      e !== Vf && (Vf && e.type === "mousemove" ? (wv = e.screenX - Vf.screenX, cs = e.screenY - Vf.screenY) : (wv = 0, cs = 0), Vf = e);
    }
    var fs = on({}, Dc, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Av,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (Iv(e), wv);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : cs;
      }
    }), vh = oa(fs), Mc = on({}, fs, {
      dataTransfer: 0
    }), jm = oa(Mc), Gm = on({}, Dc, {
      relatedTarget: 0
    }), Kd = oa(Gm), mh = on({}, $a, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), db = oa(mh), pb = on({}, $a, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), zm = oa(pb), Wm = on({}, $a, {
      data: 0
    }), Mu = oa(Wm), hb = Mu, Hf = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, gh = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function la(e) {
      if (e.key) {
        var n = Hf[e.key] || e.key;
        if (n !== "Unidentified")
          return n;
      }
      if (e.type === "keypress") {
        var l = Du(e);
        return l === 13 ? "Enter" : String.fromCharCode(l);
      }
      return e.type === "keydown" || e.type === "keyup" ? gh[e.keyCode] || "Unidentified" : "";
    }
    var vb = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function Xm(e) {
      var n = this, l = n.nativeEvent;
      if (l.getModifierState)
        return l.getModifierState(e);
      var f = vb[e];
      return f ? !!l[f] : !1;
    }
    function Av(e) {
      return Xm;
    }
    var mb = on({}, Dc, {
      key: la,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Av,
      // Legacy Interface
      charCode: function(e) {
        return e.type === "keypress" ? Du(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? Du(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), Ym = oa(mb), $m = on({}, fs, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), Zm = oa($m), hl = on({}, Dc, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Av
    }), bh = oa(hl), gb = on({}, $a, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Ml = oa(gb), yh = on({}, fs, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in e ? -e.wheelDeltaX : 0
        );
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in e ? -e.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in e ? -e.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), Pc = oa(yh), Ch = [9, 13, 27, 32], Eh = 229, qd = mn && "CompositionEvent" in window, ep = null;
    mn && "documentMode" in document && (ep = document.documentMode);
    var Nv = mn && "TextEvent" in window && !ep, Jm = mn && (!qd || ep && ep > 8 && ep <= 11), _v = 32, Ov = String.fromCharCode(_v);
    function Sh() {
      bn("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), bn("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), bn("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), bn("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var tp = !1;
    function Qm(e) {
      return (e.ctrlKey || e.altKey || e.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(e.ctrlKey && e.altKey);
    }
    function Lv(e) {
      switch (e) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function bb(e, n) {
      return e === "keydown" && n.keyCode === Eh;
    }
    function Dv(e, n) {
      switch (e) {
        case "keyup":
          return Ch.indexOf(n.keyCode) !== -1;
        case "keydown":
          return n.keyCode !== Eh;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function np(e) {
      var n = e.detail;
      return typeof n == "object" && "data" in n ? n.data : null;
    }
    function jf(e) {
      return e.locale === "ko";
    }
    var Pu = !1;
    function xh(e, n, l, f, m) {
      var E, w;
      if (qd ? E = Lv(n) : Pu ? Dv(n, f) && (E = "onCompositionEnd") : bb(n, f) && (E = "onCompositionStart"), !E)
        return null;
      Jm && !jf(f) && (!Pu && E === "onCompositionStart" ? Pu = Yi(m) : E === "onCompositionEnd" && Pu && (w = hh()));
      var O = Sn(l, E);
      if (O.length > 0) {
        var D = new Mu(E, n, null, f, m);
        if (e.push({
          event: D,
          listeners: O
        }), w)
          D.data = w;
        else {
          var X = np(f);
          X !== null && (D.data = X);
        }
      }
    }
    function Km(e, n) {
      switch (e) {
        case "compositionend":
          return np(n);
        case "keypress":
          var l = n.which;
          return l !== _v ? null : (tp = !0, Ov);
        case "textInput":
          var f = n.data;
          return f === Ov && tp ? null : f;
        default:
          return null;
      }
    }
    function yb(e, n) {
      if (Pu) {
        if (e === "compositionend" || !qd && Dv(e, n)) {
          var l = hh();
          return Jd(), Pu = !1, l;
        }
        return null;
      }
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!Qm(n)) {
            if (n.char && n.char.length > 1)
              return n.char;
            if (n.which)
              return String.fromCharCode(n.which);
          }
          return null;
        case "compositionend":
          return Jm && !jf(n) ? null : n.data;
        default:
          return null;
      }
    }
    function kc(e, n, l, f, m) {
      var E;
      if (Nv ? E = Km(n, f) : E = yb(n, f), !E)
        return null;
      var w = Sn(l, "onBeforeInput");
      if (w.length > 0) {
        var O = new hb("onBeforeInput", "beforeinput", null, f, m);
        e.push({
          event: O,
          listeners: w
        }), O.data = E;
      }
    }
    function Cb(e, n, l, f, m, E, w) {
      xh(e, n, l, f, m), kc(e, n, l, f, m);
    }
    var rp = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function qm(e) {
      var n = e && e.nodeName && e.nodeName.toLowerCase();
      return n === "input" ? !!rp[e.type] : n === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Rh(e) {
      if (!mn)
        return !1;
      var n = "on" + e, l = n in document;
      if (!l) {
        var f = document.createElement("div");
        f.setAttribute(n, "return;"), l = typeof f[n] == "function";
      }
      return l;
    }
    function a() {
      bn("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function o(e, n, l, f) {
      Vp(f);
      var m = Sn(n, "onChange");
      if (m.length > 0) {
        var E = new Uf("onChange", "change", null, l, f);
        e.push({
          event: E,
          listeners: m
        });
      }
    }
    var p = null, b = null;
    function R(e) {
      var n = e.nodeName && e.nodeName.toLowerCase();
      return n === "select" || n === "input" && e.type === "file";
    }
    function I(e) {
      var n = [];
      o(n, b, e, Bp(e)), fv(V, n);
    }
    function V(e) {
      Tb(e, 0);
    }
    function K(e) {
      var n = Dt(e);
      if (ef(n))
        return e;
    }
    function ie(e, n) {
      if (e === "change")
        return n;
    }
    var we = !1;
    mn && (we = Rh("input") && (!document.documentMode || document.documentMode > 9));
    function Qe(e, n) {
      p = e, b = n, p.attachEvent("onpropertychange", Ye);
    }
    function Ke() {
      p && (p.detachEvent("onpropertychange", Ye), p = null, b = null);
    }
    function Ye(e) {
      e.propertyName === "value" && K(b) && I(e);
    }
    function Ct(e, n, l) {
      e === "focusin" ? (Ke(), Qe(n, l)) : e === "focusout" && Ke();
    }
    function Ot(e, n) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return K(b);
    }
    function Lt(e) {
      var n = e.nodeName;
      return n && n.toLowerCase() === "input" && (e.type === "checkbox" || e.type === "radio");
    }
    function Aa(e, n) {
      if (e === "click")
        return K(n);
    }
    function ge(e, n) {
      if (e === "input" || e === "change")
        return K(n);
    }
    function le(e) {
      var n = e._wrapperState;
      !n || !n.controlled || e.type !== "number" || Wt(e, "number", e.value);
    }
    function ye(e, n, l, f, m, E, w) {
      var O = l ? Dt(l) : window, D, X;
      if (R(O) ? D = ie : qm(O) ? we ? D = ge : (D = Ot, X = Ct) : Lt(O) && (D = Aa), D) {
        var Z = D(n, l);
        if (Z) {
          o(e, Z, f, m);
          return;
        }
      }
      X && X(n, O, l), n === "focusout" && le(O);
    }
    function tt() {
      Ze("onMouseEnter", ["mouseout", "mouseover"]), Ze("onMouseLeave", ["mouseout", "mouseover"]), Ze("onPointerEnter", ["pointerout", "pointerover"]), Ze("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function Bt(e, n, l, f, m, E, w) {
      var O = n === "mouseover" || n === "pointerover", D = n === "mouseout" || n === "pointerout";
      if (O && !Sd(f)) {
        var X = f.relatedTarget || f.fromElement;
        if (X && (Xe(X) || Be(X)))
          return;
      }
      if (!(!D && !O)) {
        var Z;
        if (m.window === m)
          Z = m;
        else {
          var ue = m.ownerDocument;
          ue ? Z = ue.defaultView || ue.parentWindow : Z = window;
        }
        var se, Ie;
        if (D) {
          var Ae = f.relatedTarget || f.toElement;
          if (se = l, Ie = Ae ? Xe(Ae) : null, Ie !== null) {
            var Me = _o(Ie);
            (Ie !== Me || Ie.tag !== L && Ie.tag !== M) && (Ie = null);
          }
        } else
          se = null, Ie = l;
        if (se !== Ie) {
          var gt = vh, Kt = "onMouseLeave", jt = "onMouseEnter", lr = "mouse";
          (n === "pointerout" || n === "pointerover") && (gt = Zm, Kt = "onPointerLeave", jt = "onPointerEnter", lr = "pointer");
          var Zn = se == null ? Z : Dt(se), Ce = Ie == null ? Z : Dt(Ie), Pe = new gt(Kt, lr + "leave", se, f, m);
          Pe.target = Zn, Pe.relatedTarget = Ce;
          var Ee = null, et = Xe(m);
          if (et === l) {
            var It = new gt(jt, lr + "enter", Ie, f, m);
            It.target = Ce, It.relatedTarget = Zn, Ee = It;
          }
          oE(e, Pe, Ee, se, Ie);
        }
      }
    }
    function Jt(e, n) {
      return e === n && (e !== 0 || 1 / e === 1 / n) || e !== e && n !== n;
    }
    var Nt = typeof Object.is == "function" ? Object.is : Jt;
    function Qt(e, n) {
      if (Nt(e, n))
        return !0;
      if (typeof e != "object" || e === null || typeof n != "object" || n === null)
        return !1;
      var l = Object.keys(e), f = Object.keys(n);
      if (l.length !== f.length)
        return !1;
      for (var m = 0; m < l.length; m++) {
        var E = l[m];
        if (!fn.call(n, E) || !Nt(e[E], n[E]))
          return !1;
      }
      return !0;
    }
    function Za(e) {
      for (; e && e.firstChild; )
        e = e.firstChild;
      return e;
    }
    function dr(e) {
      for (; e; ) {
        if (e.nextSibling)
          return e.nextSibling;
        e = e.parentNode;
      }
    }
    function Ws(e, n) {
      for (var l = Za(e), f = 0, m = 0; l; ) {
        if (l.nodeType === Ql) {
          if (m = f + l.textContent.length, f <= n && m >= n)
            return {
              node: l,
              offset: n - f
            };
          f = m;
        }
        l = Za(dr(l));
      }
    }
    function Eb(e) {
      var n = e.ownerDocument, l = n && n.defaultView || window, f = l.getSelection && l.getSelection();
      if (!f || f.rangeCount === 0)
        return null;
      var m = f.anchorNode, E = f.anchorOffset, w = f.focusNode, O = f.focusOffset;
      try {
        m.nodeType, w.nodeType;
      } catch {
        return null;
      }
      return XC(e, m, E, w, O);
    }
    function XC(e, n, l, f, m) {
      var E = 0, w = -1, O = -1, D = 0, X = 0, Z = e, ue = null;
      e:
        for (; ; ) {
          for (var se = null; Z === n && (l === 0 || Z.nodeType === Ql) && (w = E + l), Z === f && (m === 0 || Z.nodeType === Ql) && (O = E + m), Z.nodeType === Ql && (E += Z.nodeValue.length), (se = Z.firstChild) !== null; )
            ue = Z, Z = se;
          for (; ; ) {
            if (Z === e)
              break e;
            if (ue === n && ++D === l && (w = E), ue === f && ++X === m && (O = E), (se = Z.nextSibling) !== null)
              break;
            Z = ue, ue = Z.parentNode;
          }
          Z = se;
        }
      return w === -1 || O === -1 ? null : {
        start: w,
        end: O
      };
    }
    function YC(e, n) {
      var l = e.ownerDocument || document, f = l && l.defaultView || window;
      if (f.getSelection) {
        var m = f.getSelection(), E = e.textContent.length, w = Math.min(n.start, E), O = n.end === void 0 ? w : Math.min(n.end, E);
        if (!m.extend && w > O) {
          var D = O;
          O = w, w = D;
        }
        var X = Ws(e, w), Z = Ws(e, O);
        if (X && Z) {
          if (m.rangeCount === 1 && m.anchorNode === X.node && m.anchorOffset === X.offset && m.focusNode === Z.node && m.focusOffset === Z.offset)
            return;
          var ue = l.createRange();
          ue.setStart(X.node, X.offset), m.removeAllRanges(), w > O ? (m.addRange(ue), m.extend(Z.node, Z.offset)) : (ue.setEnd(Z.node, Z.offset), m.addRange(ue));
        }
      }
    }
    function f0(e) {
      return e && e.nodeType === Ql;
    }
    function d0(e, n) {
      return !e || !n ? !1 : e === n ? !0 : f0(e) ? !1 : f0(n) ? d0(e, n.parentNode) : "contains" in e ? e.contains(n) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(n) & 16) : !1;
    }
    function $C(e) {
      return e && e.ownerDocument && d0(e.ownerDocument.documentElement, e);
    }
    function ZC(e) {
      try {
        return typeof e.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function p0() {
      for (var e = window, n = lu(); n instanceof e.HTMLIFrameElement; ) {
        if (ZC(n))
          e = n.contentWindow;
        else
          return n;
        n = lu(e.document);
      }
      return n;
    }
    function Sb(e) {
      var n = e && e.nodeName && e.nodeName.toLowerCase();
      return n && (n === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || n === "textarea" || e.contentEditable === "true");
    }
    function Xs() {
      var e = p0();
      return {
        focusedElem: e,
        selectionRange: Sb(e) ? QC(e) : null
      };
    }
    function JC(e) {
      var n = p0(), l = e.focusedElem, f = e.selectionRange;
      if (n !== l && $C(l)) {
        f !== null && Sb(l) && ap(l, f);
        for (var m = [], E = l; E = E.parentNode; )
          E.nodeType === so && m.push({
            element: E,
            left: E.scrollLeft,
            top: E.scrollTop
          });
        typeof l.focus == "function" && l.focus();
        for (var w = 0; w < m.length; w++) {
          var O = m[w];
          O.element.scrollLeft = O.left, O.element.scrollTop = O.top;
        }
      }
    }
    function QC(e) {
      var n;
      return "selectionStart" in e ? n = {
        start: e.selectionStart,
        end: e.selectionEnd
      } : n = Eb(e), n || {
        start: 0,
        end: 0
      };
    }
    function ap(e, n) {
      var l = n.start, f = n.end;
      f === void 0 && (f = l), "selectionStart" in e ? (e.selectionStart = l, e.selectionEnd = Math.min(f, e.value.length)) : YC(e, n);
    }
    var Tn = mn && "documentMode" in document && document.documentMode <= 11;
    function KC() {
      bn("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var gi = null, Na = null, Mv = null, ku = !1;
    function qC(e) {
      if ("selectionStart" in e && Sb(e))
        return {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      var n = e.ownerDocument && e.ownerDocument.defaultView || window, l = n.getSelection();
      return {
        anchorNode: l.anchorNode,
        anchorOffset: l.anchorOffset,
        focusNode: l.focusNode,
        focusOffset: l.focusOffset
      };
    }
    function eE(e) {
      return e.window === e ? e.document : e.nodeType === To ? e : e.ownerDocument;
    }
    function h0(e, n, l) {
      var f = eE(l);
      if (!(ku || gi == null || gi !== lu(f))) {
        var m = qC(gi);
        if (!Mv || !Qt(Mv, m)) {
          Mv = m;
          var E = Sn(Na, "onSelect");
          if (E.length > 0) {
            var w = new Uf("onSelect", "select", null, n, l);
            e.push({
              event: w,
              listeners: E
            }), w.target = gi;
          }
        }
      }
    }
    function tE(e, n, l, f, m, E, w) {
      var O = l ? Dt(l) : window;
      switch (n) {
        case "focusin":
          (qm(O) || O.contentEditable === "true") && (gi = O, Na = l, Mv = null);
          break;
        case "focusout":
          gi = null, Na = null, Mv = null;
          break;
        case "mousedown":
          ku = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          ku = !1, h0(e, f, m);
          break;
        case "selectionchange":
          if (Tn)
            break;
        case "keydown":
        case "keyup":
          h0(e, f, m);
      }
    }
    function eg(e, n) {
      var l = {};
      return l[e.toLowerCase()] = n.toLowerCase(), l["Webkit" + e] = "webkit" + n, l["Moz" + e] = "moz" + n, l;
    }
    var Gf = {
      animationend: eg("Animation", "AnimationEnd"),
      animationiteration: eg("Animation", "AnimationIteration"),
      animationstart: eg("Animation", "AnimationStart"),
      transitionend: eg("Transition", "TransitionEnd")
    }, xb = {}, Fu = {};
    mn && (Fu = document.createElement("div").style, "AnimationEvent" in window || (delete Gf.animationend.animation, delete Gf.animationiteration.animation, delete Gf.animationstart.animation), "TransitionEvent" in window || delete Gf.transitionend.transition);
    function Pv(e) {
      if (xb[e])
        return xb[e];
      if (!Gf[e])
        return e;
      var n = Gf[e];
      for (var l in n)
        if (n.hasOwnProperty(l) && l in Fu)
          return xb[e] = n[l];
      return e;
    }
    var kv = Pv("animationend"), ba = Pv("animationiteration"), _a = Pv("animationstart"), Rb = Pv("transitionend"), v0 = /* @__PURE__ */ new Map(), m0 = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function zf(e, n) {
      v0.set(e, n), bn(n, [e]);
    }
    function nE() {
      for (var e = 0; e < m0.length; e++) {
        var n = m0[e], l = n.toLowerCase(), f = n[0].toUpperCase() + n.slice(1);
        zf(l, "on" + f);
      }
      zf(kv, "onAnimationEnd"), zf(ba, "onAnimationIteration"), zf(_a, "onAnimationStart"), zf("dblclick", "onDoubleClick"), zf("focusin", "onFocus"), zf("focusout", "onBlur"), zf(Rb, "onTransitionEnd");
    }
    function rE(e, n, l, f, m, E, w) {
      var O = v0.get(n);
      if (O !== void 0) {
        var D = Uf, X = n;
        switch (n) {
          case "keypress":
            if (Du(f) === 0)
              return;
          case "keydown":
          case "keyup":
            D = Ym;
            break;
          case "focusin":
            X = "focus", D = Kd;
            break;
          case "focusout":
            X = "blur", D = Kd;
            break;
          case "beforeblur":
          case "afterblur":
            D = Kd;
            break;
          case "click":
            if (f.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            D = vh;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            D = jm;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            D = bh;
            break;
          case kv:
          case ba:
          case _a:
            D = db;
            break;
          case Rb:
            D = Ml;
            break;
          case "scroll":
            D = Tv;
            break;
          case "wheel":
            D = Pc;
            break;
          case "copy":
          case "cut":
          case "paste":
            D = zm;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            D = Zm;
            break;
        }
        var Z = (E & fu) !== 0;
        {
          var ue = !Z && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          n === "scroll", se = Fc(l, O, f.type, Z, ue);
          if (se.length > 0) {
            var Ie = new D(O, X, null, f, m);
            e.push({
              event: Ie,
              listeners: se
            });
          }
        }
      }
    }
    nE(), tt(), a(), KC(), Sh();
    function aE(e, n, l, f, m, E, w) {
      rE(e, n, l, f, m, E);
      var O = (E & Fp) === 0;
      O && (Bt(e, n, l, f, m), ye(e, n, l, f, m), tE(e, n, l, f, m), Cb(e, n, l, f, m));
    }
    var Th = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], ip = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Th));
    function tg(e, n, l) {
      var f = e.type || "unknown-event";
      e.currentTarget = l, Ao(f, n, void 0, e), e.currentTarget = null;
    }
    function iE(e, n, l) {
      var f;
      if (l)
        for (var m = n.length - 1; m >= 0; m--) {
          var E = n[m], w = E.instance, O = E.currentTarget, D = E.listener;
          if (w !== f && e.isPropagationStopped())
            return;
          tg(e, D, O), f = w;
        }
      else
        for (var X = 0; X < n.length; X++) {
          var Z = n[X], ue = Z.instance, se = Z.currentTarget, Ie = Z.listener;
          if (ue !== f && e.isPropagationStopped())
            return;
          tg(e, Ie, se), f = ue;
        }
    }
    function Tb(e, n) {
      for (var l = (n & fu) !== 0, f = 0; f < e.length; f++) {
        var m = e[f], E = m.event, w = m.listeners;
        iE(E, w, l);
      }
      jp();
    }
    function ng(e, n, l, f, m) {
      var E = Bp(l), w = [];
      aE(w, e, f, l, E, n), Tb(w, n);
    }
    function $n(e, n) {
      ip.has(e) || h('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', e);
      var l = !1, f = cn(n), m = Nr(e, l);
      f.has(m) || (g0(n, e, df, l), f.add(m));
    }
    function Wf(e, n, l) {
      ip.has(e) && !n && h('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', e);
      var f = 0;
      n && (f |= fu), g0(l, e, f, n);
    }
    var rg = "_reactListening" + Math.random().toString(36).slice(2);
    function Fv(e) {
      if (!e[rg]) {
        e[rg] = !0, ht.forEach(function(l) {
          l !== "selectionchange" && (ip.has(l) || Wf(l, !1, e), Wf(l, !0, e));
        });
        var n = e.nodeType === To ? e : e.ownerDocument;
        n !== null && (n[rg] || (n[rg] = !0, Wf("selectionchange", !1, n)));
      }
    }
    function g0(e, n, l, f, m) {
      var E = Ya(e, n, l), w = void 0;
      dc && (n === "touchstart" || n === "touchmove" || n === "wheel") && (w = !0), e = e, f ? w !== void 0 ? ph(e, n, E, w) : Gs(e, n, E) : w !== void 0 ? Rv(e, n, E, w) : Lc(e, n, E);
    }
    function b0(e, n) {
      return e === n || e.nodeType === ur && e.parentNode === n;
    }
    function wb(e, n, l, f, m) {
      var E = f;
      if (!(n & Ko) && !(n & df)) {
        var w = m;
        if (f !== null) {
          var O = f;
          e:
            for (; ; ) {
              if (O === null)
                return;
              var D = O.tag;
              if (D === T || D === _) {
                var X = O.stateNode.containerInfo;
                if (b0(X, w))
                  break;
                if (D === _)
                  for (var Z = O.return; Z !== null; ) {
                    var ue = Z.tag;
                    if (ue === T || ue === _) {
                      var se = Z.stateNode.containerInfo;
                      if (b0(se, w))
                        return;
                    }
                    Z = Z.return;
                  }
                for (; X !== null; ) {
                  var Ie = Xe(X);
                  if (Ie === null)
                    return;
                  var Ae = Ie.tag;
                  if (Ae === L || Ae === M) {
                    O = E = Ie;
                    continue e;
                  }
                  X = X.parentNode;
                }
              }
              O = O.return;
            }
        }
      }
      fv(function() {
        return ng(e, n, l, E);
      });
    }
    function wh(e, n, l) {
      return {
        instance: e,
        listener: n,
        currentTarget: l
      };
    }
    function Fc(e, n, l, f, m, E) {
      for (var w = n !== null ? n + "Capture" : null, O = f ? w : n, D = [], X = e, Z = null; X !== null; ) {
        var ue = X, se = ue.stateNode, Ie = ue.tag;
        if (Ie === L && se !== null && (Z = se, O !== null)) {
          var Ae = Il(X, O);
          Ae != null && D.push(wh(X, Ae, Z));
        }
        if (m)
          break;
        X = X.return;
      }
      return D;
    }
    function Sn(e, n) {
      for (var l = n + "Capture", f = [], m = e; m !== null; ) {
        var E = m, w = E.stateNode, O = E.tag;
        if (O === L && w !== null) {
          var D = w, X = Il(m, l);
          X != null && f.unshift(wh(m, X, D));
          var Z = Il(m, n);
          Z != null && f.push(wh(m, Z, D));
        }
        m = m.return;
      }
      return f;
    }
    function op(e) {
      if (e === null)
        return null;
      do
        e = e.return;
      while (e && e.tag !== L);
      return e || null;
    }
    function ds(e, n) {
      for (var l = e, f = n, m = 0, E = l; E; E = op(E))
        m++;
      for (var w = 0, O = f; O; O = op(O))
        w++;
      for (; m - w > 0; )
        l = op(l), m--;
      for (; w - m > 0; )
        f = op(f), w--;
      for (var D = m; D--; ) {
        if (l === f || f !== null && l === f.alternate)
          return l;
        l = op(l), f = op(f);
      }
      return null;
    }
    function Ib(e, n, l, f, m) {
      for (var E = n._reactName, w = [], O = l; O !== null && O !== f; ) {
        var D = O, X = D.alternate, Z = D.stateNode, ue = D.tag;
        if (X !== null && X === f)
          break;
        if (ue === L && Z !== null) {
          var se = Z;
          if (m) {
            var Ie = Il(O, E);
            Ie != null && w.unshift(wh(O, Ie, se));
          } else if (!m) {
            var Ae = Il(O, E);
            Ae != null && w.push(wh(O, Ae, se));
          }
        }
        O = O.return;
      }
      w.length !== 0 && e.push({
        event: n,
        listeners: w
      });
    }
    function oE(e, n, l, f, m) {
      var E = f && m ? ds(f, m) : null;
      f !== null && Ib(e, n, f, E, !1), m !== null && l !== null && Ib(e, l, m, E, !0);
    }
    function Nr(e, n) {
      return e + "__" + (n ? "capture" : "bubble");
    }
    var vl = !1, Ih = "dangerouslySetInnerHTML", lp = "suppressContentEditableWarning", Xf = "suppressHydrationWarning", y0 = "autoFocus", sp = "children", up = "style", ag = "__html", Ab, ig, Bv, C0, og, E0, S0;
    Ab = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, ig = function(e, n) {
      fr(e, n), kp(e, n), cv(e, n, {
        registrationNameDependencies: dt,
        possibleRegistrationNames: sn
      });
    }, E0 = mn && !document.documentMode, Bv = function(e, n, l) {
      if (!vl) {
        var f = lg(l), m = lg(n);
        m !== f && (vl = !0, h("Prop `%s` did not match. Server: %s Client: %s", e, JSON.stringify(m), JSON.stringify(f)));
      }
    }, C0 = function(e) {
      if (!vl) {
        vl = !0;
        var n = [];
        e.forEach(function(l) {
          n.push(l);
        }), h("Extra attributes from the server: %s", n);
      }
    }, og = function(e, n) {
      n === !1 ? h("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : h("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof n);
    }, S0 = function(e, n) {
      var l = e.namespaceURI === Jl ? e.ownerDocument.createElement(e.tagName) : e.ownerDocument.createElementNS(e.namespaceURI, e.tagName);
      return l.innerHTML = n, l.innerHTML;
    };
    var lE = /\r\n?/g, Nb = /\u0000|\uFFFD/g;
    function lg(e) {
      Da(e);
      var n = typeof e == "string" ? e : "" + e;
      return n.replace(lE, `
`).replace(Nb, "");
    }
    function Ah(e, n, l, f) {
      var m = lg(n), E = lg(e);
      if (E !== m && (f && (vl || (vl = !0, h('Text content did not match. Server: "%s" Client: "%s"', E, m))), l && We))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function x0(e) {
      return e.nodeType === To ? e : e.ownerDocument;
    }
    function sE() {
    }
    function sg(e) {
      e.onclick = sE;
    }
    function _i(e, n, l, f, m) {
      for (var E in f)
        if (f.hasOwnProperty(E)) {
          var w = f[E];
          if (E === up)
            w && Object.freeze(w), fe(n, w);
          else if (E === Ih) {
            var O = w ? w[ag] : void 0;
            O != null && Op(n, O);
          } else if (E === sp)
            if (typeof w == "string") {
              var D = e !== "textarea" || w !== "";
              D && bd(n, w);
            } else
              typeof w == "number" && bd(n, "" + w);
          else
            E === lp || E === Xf || E === y0 || (dt.hasOwnProperty(E) ? w != null && (typeof w != "function" && og(E, w), E === "onScroll" && $n("scroll", n)) : w != null && ce(n, E, w, m));
        }
    }
    function ml(e, n, l, f) {
      for (var m = 0; m < n.length; m += 2) {
        var E = n[m], w = n[m + 1];
        E === up ? fe(e, w) : E === Ih ? Op(e, w) : E === sp ? bd(e, w) : ce(e, E, w, f);
      }
    }
    function uE(e, n, l, f) {
      var m, E = x0(l), w, O = f;
      if (O === Jl && (O = tf(e)), O === Jl) {
        if (m = wl(e, n), !m && e !== e.toLowerCase() && h("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", e), e === "script") {
          var D = E.createElement("div");
          D.innerHTML = "<script><\/script>";
          var X = D.firstChild;
          w = D.removeChild(X);
        } else if (typeof n.is == "string")
          w = E.createElement(e, {
            is: n.is
          });
        else if (w = E.createElement(e), e === "select") {
          var Z = w;
          n.multiple ? Z.multiple = !0 : n.size && (Z.size = n.size);
        }
      } else
        w = E.createElementNS(O, e);
      return O === Jl && !m && Object.prototype.toString.call(w) === "[object HTMLUnknownElement]" && !fn.call(Ab, e) && (Ab[e] = !0, h("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", e)), w;
    }
    function cE(e, n) {
      return x0(n).createTextNode(e);
    }
    function fE(e, n, l, f) {
      var m = wl(n, l);
      ig(n, l);
      var E;
      switch (n) {
        case "dialog":
          $n("cancel", e), $n("close", e), E = l;
          break;
        case "iframe":
        case "object":
        case "embed":
          $n("load", e), E = l;
          break;
        case "video":
        case "audio":
          for (var w = 0; w < Th.length; w++)
            $n(Th[w], e);
          E = l;
          break;
        case "source":
          $n("error", e), E = l;
          break;
        case "img":
        case "image":
        case "link":
          $n("error", e), $n("load", e), E = l;
          break;
        case "details":
          $n("toggle", e), E = l;
          break;
        case "input":
          te(e, l), E = P(e, l), $n("invalid", e);
          break;
        case "option":
          xn(e, l), E = l;
          break;
        case "select":
          lc(e, l), E = Jo(e, l), $n("invalid", e);
          break;
        case "textarea":
          av(e, l), E = rv(e, l), $n("invalid", e);
          break;
        default:
          E = l;
      }
      switch (br(n, E), _i(n, e, f, E, m), n) {
        case "input":
          Zo(e), Je(e, l, !1);
          break;
        case "textarea":
          Zo(e), sc(e);
          break;
        case "option":
          Mr(e, l);
          break;
        case "select":
          ev(e, l);
          break;
        default:
          typeof E.onClick == "function" && sg(e);
          break;
      }
    }
    function R0(e, n, l, f, m) {
      ig(n, f);
      var E = null, w, O;
      switch (n) {
        case "input":
          w = P(e, l), O = P(e, f), E = [];
          break;
        case "select":
          w = Jo(e, l), O = Jo(e, f), E = [];
          break;
        case "textarea":
          w = rv(e, l), O = rv(e, f), E = [];
          break;
        default:
          w = l, O = f, typeof w.onClick != "function" && typeof O.onClick == "function" && sg(e);
          break;
      }
      br(n, O);
      var D, X, Z = null;
      for (D in w)
        if (!(O.hasOwnProperty(D) || !w.hasOwnProperty(D) || w[D] == null))
          if (D === up) {
            var ue = w[D];
            for (X in ue)
              ue.hasOwnProperty(X) && (Z || (Z = {}), Z[X] = "");
          } else
            D === Ih || D === sp || D === lp || D === Xf || D === y0 || (dt.hasOwnProperty(D) ? E || (E = []) : (E = E || []).push(D, null));
      for (D in O) {
        var se = O[D], Ie = w != null ? w[D] : void 0;
        if (!(!O.hasOwnProperty(D) || se === Ie || se == null && Ie == null))
          if (D === up)
            if (se && Object.freeze(se), Ie) {
              for (X in Ie)
                Ie.hasOwnProperty(X) && (!se || !se.hasOwnProperty(X)) && (Z || (Z = {}), Z[X] = "");
              for (X in se)
                se.hasOwnProperty(X) && Ie[X] !== se[X] && (Z || (Z = {}), Z[X] = se[X]);
            } else
              Z || (E || (E = []), E.push(D, Z)), Z = se;
          else if (D === Ih) {
            var Ae = se ? se[ag] : void 0, Me = Ie ? Ie[ag] : void 0;
            Ae != null && Me !== Ae && (E = E || []).push(D, Ae);
          } else
            D === sp ? (typeof se == "string" || typeof se == "number") && (E = E || []).push(D, "" + se) : D === lp || D === Xf || (dt.hasOwnProperty(D) ? (se != null && (typeof se != "function" && og(D, se), D === "onScroll" && $n("scroll", e)), !E && Ie !== se && (E = [])) : (E = E || []).push(D, se));
      }
      return Z && (yt(Z, O[up]), (E = E || []).push(up, Z)), E;
    }
    function dE(e, n, l, f, m) {
      l === "input" && m.type === "radio" && m.name != null && Te(e, m);
      var E = wl(l, f), w = wl(l, m);
      switch (ml(e, n, E, w), l) {
        case "input":
          Oe(e, m);
          break;
        case "textarea":
          md(e, m);
          break;
        case "select":
          tv(e, m);
          break;
      }
    }
    function pE(e) {
      {
        var n = e.toLowerCase();
        return Pp.hasOwnProperty(n) && Pp[n] || null;
      }
    }
    function hE(e, n, l, f, m, E, w) {
      var O, D;
      switch (O = wl(n, l), ig(n, l), n) {
        case "dialog":
          $n("cancel", e), $n("close", e);
          break;
        case "iframe":
        case "object":
        case "embed":
          $n("load", e);
          break;
        case "video":
        case "audio":
          for (var X = 0; X < Th.length; X++)
            $n(Th[X], e);
          break;
        case "source":
          $n("error", e);
          break;
        case "img":
        case "image":
        case "link":
          $n("error", e), $n("load", e);
          break;
        case "details":
          $n("toggle", e);
          break;
        case "input":
          te(e, l), $n("invalid", e);
          break;
        case "option":
          xn(e, l);
          break;
        case "select":
          lc(e, l), $n("invalid", e);
          break;
        case "textarea":
          av(e, l), $n("invalid", e);
          break;
      }
      br(n, l);
      {
        D = /* @__PURE__ */ new Set();
        for (var Z = e.attributes, ue = 0; ue < Z.length; ue++) {
          var se = Z[ue].name.toLowerCase();
          switch (se) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              D.add(Z[ue].name);
          }
        }
      }
      var Ie = null;
      for (var Ae in l)
        if (l.hasOwnProperty(Ae)) {
          var Me = l[Ae];
          if (Ae === sp)
            typeof Me == "string" ? e.textContent !== Me && (l[Xf] !== !0 && Ah(e.textContent, Me, E, w), Ie = [sp, Me]) : typeof Me == "number" && e.textContent !== "" + Me && (l[Xf] !== !0 && Ah(e.textContent, Me, E, w), Ie = [sp, "" + Me]);
          else if (dt.hasOwnProperty(Ae))
            Me != null && (typeof Me != "function" && og(Ae, Me), Ae === "onScroll" && $n("scroll", e));
          else if (w && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof O == "boolean") {
            var gt = void 0, Kt = O && $e ? null : qa(Ae);
            if (l[Xf] !== !0) {
              if (!(Ae === lp || Ae === Xf || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              Ae === "value" || Ae === "checked" || Ae === "selected")) {
                if (Ae === Ih) {
                  var jt = e.innerHTML, lr = Me ? Me[ag] : void 0;
                  if (lr != null) {
                    var Zn = S0(e, lr);
                    Zn !== jt && Bv(Ae, jt, Zn);
                  }
                } else if (Ae === up) {
                  if (D.delete(Ae), E0) {
                    var Ce = uf(Me);
                    gt = e.getAttribute("style"), Ce !== gt && Bv(Ae, gt, Ce);
                  }
                } else if (O && !$e)
                  D.delete(Ae.toLowerCase()), gt = ne(e, Ae, Me), Me !== gt && Bv(Ae, gt, Me);
                else if (!Lr(Ae, Kt, O) && !Qn(Ae, Me, Kt, O)) {
                  var Pe = !1;
                  if (Kt !== null)
                    D.delete(Kt.attributeName), gt = ki(e, Ae, Me, Kt);
                  else {
                    var Ee = f;
                    if (Ee === Jl && (Ee = tf(n)), Ee === Jl)
                      D.delete(Ae.toLowerCase());
                    else {
                      var et = pE(Ae);
                      et !== null && et !== Ae && (Pe = !0, D.delete(et)), D.delete(Ae);
                    }
                    gt = ne(e, Ae, Me);
                  }
                  var It = $e;
                  !It && Me !== gt && !Pe && Bv(Ae, gt, Me);
                }
              }
            }
          }
        }
      switch (w && // $FlowFixMe - Should be inferred as not undefined.
      D.size > 0 && l[Xf] !== !0 && C0(D), n) {
        case "input":
          Zo(e), Je(e, l, !0);
          break;
        case "textarea":
          Zo(e), sc(e);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof l.onClick == "function" && sg(e);
          break;
      }
      return Ie;
    }
    function T0(e, n, l) {
      var f = e.nodeValue !== n;
      return f;
    }
    function _b(e, n) {
      {
        if (vl)
          return;
        vl = !0, h("Did not expect server HTML to contain a <%s> in <%s>.", n.nodeName.toLowerCase(), e.nodeName.toLowerCase());
      }
    }
    function Ob(e, n) {
      {
        if (vl)
          return;
        vl = !0, h('Did not expect server HTML to contain the text node "%s" in <%s>.', n.nodeValue, e.nodeName.toLowerCase());
      }
    }
    function Lb(e, n, l) {
      {
        if (vl)
          return;
        vl = !0, h("Expected server HTML to contain a matching <%s> in <%s>.", n, e.nodeName.toLowerCase());
      }
    }
    function ug(e, n) {
      {
        if (n === "" || vl)
          return;
        vl = !0, h('Expected server HTML to contain a matching text node for "%s" in <%s>.', n, e.nodeName.toLowerCase());
      }
    }
    function w0(e, n, l) {
      switch (n) {
        case "input":
          Xt(e, l);
          return;
        case "textarea":
          iv(e, l);
          return;
        case "select":
          tb(e, l);
          return;
      }
    }
    var Uv = function() {
    }, Vv = function() {
    };
    {
      var vE = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], I0 = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], Nh = I0.concat(["button"]), mE = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], A0 = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      Vv = function(e, n) {
        var l = on({}, e || A0), f = {
          tag: n
        };
        return I0.indexOf(n) !== -1 && (l.aTagInScope = null, l.buttonTagInScope = null, l.nobrTagInScope = null), Nh.indexOf(n) !== -1 && (l.pTagInButtonScope = null), vE.indexOf(n) !== -1 && n !== "address" && n !== "div" && n !== "p" && (l.listItemTagAutoclosing = null, l.dlItemTagAutoclosing = null), l.current = f, n === "form" && (l.formTag = f), n === "a" && (l.aTagInScope = f), n === "button" && (l.buttonTagInScope = f), n === "nobr" && (l.nobrTagInScope = f), n === "p" && (l.pTagInButtonScope = f), n === "li" && (l.listItemTagAutoclosing = f), (n === "dd" || n === "dt") && (l.dlItemTagAutoclosing = f), l;
      };
      var gE = function(e, n) {
        switch (n) {
          case "select":
            return e === "option" || e === "optgroup" || e === "#text";
          case "optgroup":
            return e === "option" || e === "#text";
          case "option":
            return e === "#text";
          case "tr":
            return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return e === "tr" || e === "style" || e === "script" || e === "template";
          case "colgroup":
            return e === "col" || e === "template";
          case "table":
            return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
          case "head":
            return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
          case "html":
            return e === "head" || e === "body" || e === "frameset";
          case "frameset":
            return e === "frame";
          case "#document":
            return e === "html";
        }
        switch (e) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return n !== "h1" && n !== "h2" && n !== "h3" && n !== "h4" && n !== "h5" && n !== "h6";
          case "rp":
          case "rt":
            return mE.indexOf(n) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return n == null;
        }
        return !0;
      }, bE = function(e, n) {
        switch (e) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return n.pTagInButtonScope;
          case "form":
            return n.formTag || n.pTagInButtonScope;
          case "li":
            return n.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return n.dlItemTagAutoclosing;
          case "button":
            return n.buttonTagInScope;
          case "a":
            return n.aTagInScope;
          case "nobr":
            return n.nobrTagInScope;
        }
        return null;
      }, N0 = {};
      Uv = function(e, n, l) {
        l = l || A0;
        var f = l.current, m = f && f.tag;
        n != null && (e != null && h("validateDOMNesting: when childText is passed, childTag should be null"), e = "#text");
        var E = gE(e, m) ? null : f, w = E ? null : bE(e, l), O = E || w;
        if (O) {
          var D = O.tag, X = !!E + "|" + e + "|" + D;
          if (!N0[X]) {
            N0[X] = !0;
            var Z = e, ue = "";
            if (e === "#text" ? /\S/.test(n) ? Z = "Text nodes" : (Z = "Whitespace text nodes", ue = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : Z = "<" + e + ">", E) {
              var se = "";
              D === "table" && e === "tr" && (se += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), h("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", Z, D, ue, se);
            } else
              h("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", Z, D);
          }
        }
      };
    }
    var Hv = "suppressHydrationWarning", jv = "$", cg = "/$", Gv = "$?", zv = "$!", yE = "style", Db = null, Mb = null;
    function CE(e) {
      var n, l, f = e.nodeType;
      switch (f) {
        case To:
        case Tl: {
          n = f === To ? "#document" : "#fragment";
          var m = e.documentElement;
          l = m ? m.namespaceURI : _p(null, "");
          break;
        }
        default: {
          var E = f === ur ? e.parentNode : e, w = E.namespaceURI || null;
          n = E.tagName, l = _p(w, n);
          break;
        }
      }
      {
        var O = n.toLowerCase(), D = Vv(null, O);
        return {
          namespace: l,
          ancestorInfo: D
        };
      }
    }
    function EE(e, n, l) {
      {
        var f = e, m = _p(f.namespace, n), E = Vv(f.ancestorInfo, n);
        return {
          namespace: m,
          ancestorInfo: E
        };
      }
    }
    function Y2(e) {
      return e;
    }
    function SE(e) {
      Db = Ff(), Mb = Xs();
      var n = null;
      return vo(!1), n;
    }
    function xE(e) {
      JC(Mb), vo(Db), Db = null, Mb = null;
    }
    function RE(e, n, l, f, m) {
      var E;
      {
        var w = f;
        if (Uv(e, null, w.ancestorInfo), typeof n.children == "string" || typeof n.children == "number") {
          var O = "" + n.children, D = Vv(w.ancestorInfo, e);
          Uv(null, O, D);
        }
        E = w.namespace;
      }
      var X = uE(e, n, l, E);
      return ae(m, X), On(X, n), X;
    }
    function TE(e, n) {
      e.appendChild(n);
    }
    function wE(e, n, l, f, m) {
      switch (fE(e, n, l, f), n) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!l.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function IE(e, n, l, f, m, E) {
      {
        var w = E;
        if (typeof f.children != typeof l.children && (typeof f.children == "string" || typeof f.children == "number")) {
          var O = "" + f.children, D = Vv(w.ancestorInfo, n);
          Uv(null, O, D);
        }
      }
      return R0(e, n, l, f);
    }
    function Pb(e, n) {
      return e === "textarea" || e === "noscript" || typeof n.children == "string" || typeof n.children == "number" || typeof n.dangerouslySetInnerHTML == "object" && n.dangerouslySetInnerHTML !== null && n.dangerouslySetInnerHTML.__html != null;
    }
    function AE(e, n, l, f) {
      {
        var m = l;
        Uv(null, e, m.ancestorInfo);
      }
      var E = cE(e, n);
      return ae(f, E), E;
    }
    function NE() {
      var e = window.event;
      return e === void 0 ? $r : dh(e.type);
    }
    var kb = typeof setTimeout == "function" ? setTimeout : void 0, _E = typeof clearTimeout == "function" ? clearTimeout : void 0, Fb = -1, _0 = typeof Promise == "function" ? Promise : void 0, OE = typeof queueMicrotask == "function" ? queueMicrotask : typeof _0 < "u" ? function(e) {
      return _0.resolve(null).then(e).catch(LE);
    } : kb;
    function LE(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function DE(e, n, l, f) {
      switch (n) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          l.autoFocus && e.focus();
          return;
        case "img": {
          l.src && (e.src = l.src);
          return;
        }
      }
    }
    function Bb(e, n, l, f, m, E) {
      dE(e, n, l, f, m), On(e, m);
    }
    function Ub(e) {
      bd(e, "");
    }
    function O0(e, n, l) {
      e.nodeValue = l;
    }
    function ME(e, n) {
      e.appendChild(n);
    }
    function PE(e, n) {
      var l;
      e.nodeType === ur ? (l = e.parentNode, l.insertBefore(n, e)) : (l = e, l.appendChild(n));
      var f = e._reactRootContainer;
      f == null && l.onclick === null && sg(l);
    }
    function kE(e, n, l) {
      e.insertBefore(n, l);
    }
    function Vb(e, n, l) {
      e.nodeType === ur ? e.parentNode.insertBefore(n, l) : e.insertBefore(n, l);
    }
    function FE(e, n) {
      e.removeChild(n);
    }
    function BE(e, n) {
      e.nodeType === ur ? e.parentNode.removeChild(n) : e.removeChild(n);
    }
    function Hb(e, n) {
      var l = n, f = 0;
      do {
        var m = l.nextSibling;
        if (e.removeChild(l), m && m.nodeType === ur) {
          var E = m.data;
          if (E === cg)
            if (f === 0) {
              e.removeChild(m), ga(n);
              return;
            } else
              f--;
          else
            (E === jv || E === Gv || E === zv) && f++;
        }
        l = m;
      } while (l);
      ga(n);
    }
    function gl(e, n) {
      e.nodeType === ur ? Hb(e.parentNode, n) : e.nodeType === so && Hb(e, n), ga(e);
    }
    function jb(e) {
      e = e;
      var n = e.style;
      typeof n.setProperty == "function" ? n.setProperty("display", "none", "important") : n.display = "none";
    }
    function UE(e) {
      e.nodeValue = "";
    }
    function VE(e, n) {
      e = e;
      var l = n[yE], f = l != null && l.hasOwnProperty("display") ? l.display : null;
      e.style.display = Lp("display", f);
    }
    function HE(e, n) {
      e.nodeValue = n;
    }
    function jE(e) {
      e.nodeType === so ? e.textContent = "" : e.nodeType === To && e.documentElement && e.removeChild(e.documentElement);
    }
    function Gb(e, n, l) {
      return e.nodeType !== so || n.toLowerCase() !== e.nodeName.toLowerCase() ? null : e;
    }
    function GE(e, n) {
      return n === "" || e.nodeType !== Ql ? null : e;
    }
    function zb(e) {
      return e.nodeType !== ur ? null : e;
    }
    function L0(e) {
      return e.data === Gv;
    }
    function Wb(e) {
      return e.data === zv;
    }
    function zE(e) {
      var n = e.nextSibling && e.nextSibling.dataset, l, f, m;
      return n && (l = n.dgst, f = n.msg, m = n.stck), {
        message: f,
        digest: l,
        stack: m
      };
    }
    function WE(e, n) {
      e._reactRetry = n;
    }
    function Wv(e) {
      for (; e != null; e = e.nextSibling) {
        var n = e.nodeType;
        if (n === so || n === Ql)
          break;
        if (n === ur) {
          var l = e.data;
          if (l === jv || l === zv || l === Gv)
            break;
          if (l === cg)
            return null;
        }
      }
      return e;
    }
    function Xv(e) {
      return Wv(e.nextSibling);
    }
    function XE(e) {
      return Wv(e.firstChild);
    }
    function YE(e) {
      return Wv(e.firstChild);
    }
    function Xb(e) {
      return Wv(e.nextSibling);
    }
    function Yb(e, n, l, f, m, E, w) {
      ae(E, e), On(e, l);
      var O;
      {
        var D = m;
        O = D.namespace;
      }
      var X = (E.mode & Ut) !== Ft;
      return hE(e, n, l, O, f, X, w);
    }
    function $E(e, n, l, f) {
      return ae(l, e), l.mode & Ut, T0(e, n);
    }
    function ZE(e, n) {
      ae(n, e);
    }
    function JE(e) {
      for (var n = e.nextSibling, l = 0; n; ) {
        if (n.nodeType === ur) {
          var f = n.data;
          if (f === cg) {
            if (l === 0)
              return Xv(n);
            l--;
          } else
            (f === jv || f === zv || f === Gv) && l++;
        }
        n = n.nextSibling;
      }
      return null;
    }
    function D0(e) {
      for (var n = e.previousSibling, l = 0; n; ) {
        if (n.nodeType === ur) {
          var f = n.data;
          if (f === jv || f === zv || f === Gv) {
            if (l === 0)
              return n;
            l--;
          } else
            f === cg && l++;
        }
        n = n.previousSibling;
      }
      return null;
    }
    function QE(e) {
      ga(e);
    }
    function KE(e) {
      ga(e);
    }
    function qE(e) {
      return e !== "head" && e !== "body";
    }
    function eS(e, n, l, f) {
      var m = !0;
      Ah(n.nodeValue, l, f, m);
    }
    function tS(e, n, l, f, m, E) {
      if (n[Hv] !== !0) {
        var w = !0;
        Ah(f.nodeValue, m, E, w);
      }
    }
    function nS(e, n) {
      n.nodeType === so ? _b(e, n) : n.nodeType === ur || Ob(e, n);
    }
    function rS(e, n) {
      {
        var l = e.parentNode;
        l !== null && (n.nodeType === so ? _b(l, n) : n.nodeType === ur || Ob(l, n));
      }
    }
    function aS(e, n, l, f, m) {
      (m || n[Hv] !== !0) && (f.nodeType === so ? _b(l, f) : f.nodeType === ur || Ob(l, f));
    }
    function iS(e, n, l) {
      Lb(e, n);
    }
    function oS(e, n) {
      ug(e, n);
    }
    function lS(e, n, l) {
      {
        var f = e.parentNode;
        f !== null && Lb(f, n);
      }
    }
    function sS(e, n) {
      {
        var l = e.parentNode;
        l !== null && ug(l, n);
      }
    }
    function uS(e, n, l, f, m, E) {
      (E || n[Hv] !== !0) && Lb(l, f);
    }
    function cS(e, n, l, f, m) {
      (m || n[Hv] !== !0) && ug(l, f);
    }
    function fS(e) {
      h("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", e.nodeName.toLowerCase());
    }
    function dS(e) {
      Fv(e);
    }
    var _h = Math.random().toString(36).slice(2), s = "__reactFiber$" + _h, d = "__reactProps$" + _h, C = "__reactContainer$" + _h, A = "__reactEvents$" + _h, F = "__reactListeners$" + _h, $ = "__reactHandles$" + _h;
    function ee(e) {
      delete e[s], delete e[d], delete e[A], delete e[F], delete e[$];
    }
    function ae(e, n) {
      n[s] = e;
    }
    function de(e, n) {
      n[C] = e;
    }
    function He(e) {
      e[C] = null;
    }
    function Be(e) {
      return !!e[C];
    }
    function Xe(e) {
      var n = e[s];
      if (n)
        return n;
      for (var l = e.parentNode; l; ) {
        if (n = l[C] || l[s], n) {
          var f = n.alternate;
          if (n.child !== null || f !== null && f.child !== null)
            for (var m = D0(e); m !== null; ) {
              var E = m[s];
              if (E)
                return E;
              m = D0(m);
            }
          return n;
        }
        e = l, l = e.parentNode;
      }
      return null;
    }
    function ft(e) {
      var n = e[s] || e[C];
      return n && (n.tag === L || n.tag === M || n.tag === W || n.tag === T) ? n : null;
    }
    function Dt(e) {
      if (e.tag === L || e.tag === M)
        return e.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function en(e) {
      return e[d] || null;
    }
    function On(e, n) {
      e[d] = n;
    }
    function cn(e) {
      var n = e[A];
      return n === void 0 && (n = e[A] = /* @__PURE__ */ new Set()), n;
    }
    var jn = {}, er = i.ReactDebugCurrentFrame;
    function mo(e) {
      if (e) {
        var n = e._owner, l = $o(e.type, e._source, n ? n.type : null);
        er.setExtraStackFrame(l);
      } else
        er.setExtraStackFrame(null);
    }
    function sa(e, n, l, f, m) {
      {
        var E = Function.call.bind(fn);
        for (var w in e)
          if (E(e, w)) {
            var O = void 0;
            try {
              if (typeof e[w] != "function") {
                var D = Error((f || "React class") + ": " + l + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw D.name = "Invariant Violation", D;
              }
              O = e[w](n, w, f, l, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (X) {
              O = X;
            }
            O && !(O instanceof Error) && (mo(m), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", f || "React class", l, w, typeof O), mo(null)), O instanceof Error && !(O.message in jn) && (jn[O.message] = !0, mo(m), h("Failed %s type: %s", l, O.message), mo(null));
          }
      }
    }
    var Do = [], ya;
    ya = [];
    var bi = -1;
    function go(e) {
      return {
        current: e
      };
    }
    function $i(e, n) {
      if (bi < 0) {
        h("Unexpected pop.");
        return;
      }
      n !== ya[bi] && h("Unexpected Fiber popped."), e.current = Do[bi], Do[bi] = null, ya[bi] = null, bi--;
    }
    function bl(e, n, l) {
      bi++, Do[bi] = e.current, ya[bi] = l, e.current = n;
    }
    var pS;
    pS = {};
    var Ys = {};
    Object.freeze(Ys);
    var cp = go(Ys), Yf = go(!1), hS = Ys;
    function fg(e, n, l) {
      return l && $f(n) ? hS : cp.current;
    }
    function $2(e, n, l) {
      {
        var f = e.stateNode;
        f.__reactInternalMemoizedUnmaskedChildContext = n, f.__reactInternalMemoizedMaskedChildContext = l;
      }
    }
    function dg(e, n) {
      {
        var l = e.type, f = l.contextTypes;
        if (!f)
          return Ys;
        var m = e.stateNode;
        if (m && m.__reactInternalMemoizedUnmaskedChildContext === n)
          return m.__reactInternalMemoizedMaskedChildContext;
        var E = {};
        for (var w in f)
          E[w] = n[w];
        {
          var O = dn(e) || "Unknown";
          sa(f, E, "context", O);
        }
        return m && $2(e, n, E), E;
      }
    }
    function M0() {
      return Yf.current;
    }
    function $f(e) {
      {
        var n = e.childContextTypes;
        return n != null;
      }
    }
    function P0(e) {
      $i(Yf, e), $i(cp, e);
    }
    function vS(e) {
      $i(Yf, e), $i(cp, e);
    }
    function Z2(e, n, l) {
      {
        if (cp.current !== Ys)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        bl(cp, n, e), bl(Yf, l, e);
      }
    }
    function J2(e, n, l) {
      {
        var f = e.stateNode, m = n.childContextTypes;
        if (typeof f.getChildContext != "function") {
          {
            var E = dn(e) || "Unknown";
            pS[E] || (pS[E] = !0, h("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", E, E));
          }
          return l;
        }
        var w = f.getChildContext();
        for (var O in w)
          if (!(O in m))
            throw new Error((dn(e) || "Unknown") + '.getChildContext(): key "' + O + '" is not defined in childContextTypes.');
        {
          var D = dn(e) || "Unknown";
          sa(m, w, "child context", D);
        }
        return on({}, l, w);
      }
    }
    function k0(e) {
      {
        var n = e.stateNode, l = n && n.__reactInternalMemoizedMergedChildContext || Ys;
        return hS = cp.current, bl(cp, l, e), bl(Yf, Yf.current, e), !0;
      }
    }
    function Q2(e, n, l) {
      {
        var f = e.stateNode;
        if (!f)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (l) {
          var m = J2(e, n, hS);
          f.__reactInternalMemoizedMergedChildContext = m, $i(Yf, e), $i(cp, e), bl(cp, m, e), bl(Yf, l, e);
        } else
          $i(Yf, e), bl(Yf, l, e);
      }
    }
    function z4(e) {
      {
        if (!vc(e) || e.tag !== S)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var n = e;
        do {
          switch (n.tag) {
            case T:
              return n.stateNode.context;
            case S: {
              var l = n.type;
              if ($f(l))
                return n.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          n = n.return;
        } while (n !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Oh = 0, F0 = 1, fp = null, mS = !1, gS = !1;
    function K2(e) {
      fp === null ? fp = [e] : fp.push(e);
    }
    function W4(e) {
      mS = !0, K2(e);
    }
    function q2() {
      mS && Lh();
    }
    function Lh() {
      if (!gS && fp !== null) {
        gS = !0;
        var e = 0, n = Lo();
        try {
          var l = !0, f = fp;
          for (ma(ia); e < f.length; e++) {
            var m = f[e];
            do
              m = m(l);
            while (m !== null);
          }
          fp = null, mS = !1;
        } catch (E) {
          throw fp !== null && (fp = fp.slice(e + 1)), Ui(_d, Lh), E;
        } finally {
          ma(n), gS = !1;
        }
      }
      return null;
    }
    var pg = [], hg = 0, B0 = null, U0 = 0, Bu = [], Uu = 0, Yv = null, dp = 1, pp = "";
    function X4(e) {
      return Zv(), (e.flags & dv) !== zt;
    }
    function Y4(e) {
      return Zv(), U0;
    }
    function $4() {
      var e = pp, n = dp, l = n & ~Z4(n);
      return l.toString(32) + e;
    }
    function $v(e, n) {
      Zv(), pg[hg++] = U0, pg[hg++] = B0, B0 = e, U0 = n;
    }
    function ew(e, n, l) {
      Zv(), Bu[Uu++] = dp, Bu[Uu++] = pp, Bu[Uu++] = Yv, Yv = e;
      var f = dp, m = pp, E = V0(f) - 1, w = f & ~(1 << E), O = l + 1, D = V0(n) + E;
      if (D > 30) {
        var X = E - E % 5, Z = (1 << X) - 1, ue = (w & Z).toString(32), se = w >> X, Ie = E - X, Ae = V0(n) + Ie, Me = O << Ie, gt = Me | se, Kt = ue + m;
        dp = 1 << Ae | gt, pp = Kt;
      } else {
        var jt = O << E, lr = jt | w, Zn = m;
        dp = 1 << D | lr, pp = Zn;
      }
    }
    function bS(e) {
      Zv();
      var n = e.return;
      if (n !== null) {
        var l = 1, f = 0;
        $v(e, l), ew(e, l, f);
      }
    }
    function V0(e) {
      return 32 - Rf(e);
    }
    function Z4(e) {
      return 1 << V0(e) - 1;
    }
    function yS(e) {
      for (; e === B0; )
        B0 = pg[--hg], pg[hg] = null, U0 = pg[--hg], pg[hg] = null;
      for (; e === Yv; )
        Yv = Bu[--Uu], Bu[Uu] = null, pp = Bu[--Uu], Bu[Uu] = null, dp = Bu[--Uu], Bu[Uu] = null;
    }
    function J4() {
      return Zv(), Yv !== null ? {
        id: dp,
        overflow: pp
      } : null;
    }
    function Q4(e, n) {
      Zv(), Bu[Uu++] = dp, Bu[Uu++] = pp, Bu[Uu++] = Yv, dp = n.id, pp = n.overflow, Yv = e;
    }
    function Zv() {
      Po() || h("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var Mo = null, Vu = null, Bc = !1, Jv = !1, Dh = null;
    function K4() {
      Bc && h("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function tw() {
      Jv = !0;
    }
    function q4() {
      return Jv;
    }
    function eL(e) {
      var n = e.stateNode.containerInfo;
      return Vu = YE(n), Mo = e, Bc = !0, Dh = null, Jv = !1, !0;
    }
    function tL(e, n, l) {
      return Vu = Xb(n), Mo = e, Bc = !0, Dh = null, Jv = !1, l !== null && Q4(e, l), !0;
    }
    function nw(e, n) {
      switch (e.tag) {
        case T: {
          nS(e.stateNode.containerInfo, n);
          break;
        }
        case L: {
          var l = (e.mode & Ut) !== Ft;
          aS(
            e.type,
            e.memoizedProps,
            e.stateNode,
            n,
            // TODO: Delete this argument when we remove the legacy root API.
            l
          );
          break;
        }
        case W: {
          var f = e.memoizedState;
          f.dehydrated !== null && rS(f.dehydrated, n);
          break;
        }
      }
    }
    function rw(e, n) {
      nw(e, n);
      var l = i5();
      l.stateNode = n, l.return = e;
      var f = e.deletions;
      f === null ? (e.deletions = [l], e.flags |= vr) : f.push(l);
    }
    function CS(e, n) {
      {
        if (Jv)
          return;
        switch (e.tag) {
          case T: {
            var l = e.stateNode.containerInfo;
            switch (n.tag) {
              case L:
                var f = n.type;
                n.pendingProps, iS(l, f);
                break;
              case M:
                var m = n.pendingProps;
                oS(l, m);
                break;
            }
            break;
          }
          case L: {
            var E = e.type, w = e.memoizedProps, O = e.stateNode;
            switch (n.tag) {
              case L: {
                var D = n.type, X = n.pendingProps, Z = (e.mode & Ut) !== Ft;
                uS(
                  E,
                  w,
                  O,
                  D,
                  X,
                  // TODO: Delete this argument when we remove the legacy root API.
                  Z
                );
                break;
              }
              case M: {
                var ue = n.pendingProps, se = (e.mode & Ut) !== Ft;
                cS(
                  E,
                  w,
                  O,
                  ue,
                  // TODO: Delete this argument when we remove the legacy root API.
                  se
                );
                break;
              }
            }
            break;
          }
          case W: {
            var Ie = e.memoizedState, Ae = Ie.dehydrated;
            if (Ae !== null)
              switch (n.tag) {
                case L:
                  var Me = n.type;
                  n.pendingProps, lS(Ae, Me);
                  break;
                case M:
                  var gt = n.pendingProps;
                  sS(Ae, gt);
                  break;
              }
            break;
          }
          default:
            return;
        }
      }
    }
    function aw(e, n) {
      n.flags = n.flags & ~nl | Xr, CS(e, n);
    }
    function iw(e, n) {
      switch (e.tag) {
        case L: {
          var l = e.type;
          e.pendingProps;
          var f = Gb(n, l);
          return f !== null ? (e.stateNode = f, Mo = e, Vu = XE(f), !0) : !1;
        }
        case M: {
          var m = e.pendingProps, E = GE(n, m);
          return E !== null ? (e.stateNode = E, Mo = e, Vu = null, !0) : !1;
        }
        case W: {
          var w = zb(n);
          if (w !== null) {
            var O = {
              dehydrated: w,
              treeContext: J4(),
              retryLane: Ai
            };
            e.memoizedState = O;
            var D = o5(w);
            return D.return = e, e.child = D, Mo = e, Vu = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function ES(e) {
      return (e.mode & Ut) !== Ft && (e.flags & un) === zt;
    }
    function SS(e) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function xS(e) {
      if (Bc) {
        var n = Vu;
        if (!n) {
          ES(e) && (CS(Mo, e), SS()), aw(Mo, e), Bc = !1, Mo = e;
          return;
        }
        var l = n;
        if (!iw(e, n)) {
          ES(e) && (CS(Mo, e), SS()), n = Xv(l);
          var f = Mo;
          if (!n || !iw(e, n)) {
            aw(Mo, e), Bc = !1, Mo = e;
            return;
          }
          rw(f, l);
        }
      }
    }
    function nL(e, n, l) {
      var f = e.stateNode, m = !Jv, E = Yb(f, e.type, e.memoizedProps, n, l, e, m);
      return e.updateQueue = E, E !== null;
    }
    function rL(e) {
      var n = e.stateNode, l = e.memoizedProps, f = $E(n, l, e);
      if (f) {
        var m = Mo;
        if (m !== null)
          switch (m.tag) {
            case T: {
              var E = m.stateNode.containerInfo, w = (m.mode & Ut) !== Ft;
              eS(
                E,
                n,
                l,
                // TODO: Delete this argument when we remove the legacy root API.
                w
              );
              break;
            }
            case L: {
              var O = m.type, D = m.memoizedProps, X = m.stateNode, Z = (m.mode & Ut) !== Ft;
              tS(
                O,
                D,
                X,
                n,
                l,
                // TODO: Delete this argument when we remove the legacy root API.
                Z
              );
              break;
            }
          }
      }
      return f;
    }
    function aL(e) {
      var n = e.memoizedState, l = n !== null ? n.dehydrated : null;
      if (!l)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      ZE(l, e);
    }
    function iL(e) {
      var n = e.memoizedState, l = n !== null ? n.dehydrated : null;
      if (!l)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return JE(l);
    }
    function ow(e) {
      for (var n = e.return; n !== null && n.tag !== L && n.tag !== T && n.tag !== W; )
        n = n.return;
      Mo = n;
    }
    function H0(e) {
      if (e !== Mo)
        return !1;
      if (!Bc)
        return ow(e), Bc = !0, !1;
      if (e.tag !== T && (e.tag !== L || qE(e.type) && !Pb(e.type, e.memoizedProps))) {
        var n = Vu;
        if (n)
          if (ES(e))
            lw(e), SS();
          else
            for (; n; )
              rw(e, n), n = Xv(n);
      }
      return ow(e), e.tag === W ? Vu = iL(e) : Vu = Mo ? Xv(e.stateNode) : null, !0;
    }
    function oL() {
      return Bc && Vu !== null;
    }
    function lw(e) {
      for (var n = Vu; n; )
        nw(e, n), n = Xv(n);
    }
    function vg() {
      Mo = null, Vu = null, Bc = !1, Jv = !1;
    }
    function sw() {
      Dh !== null && (tA(Dh), Dh = null);
    }
    function Po() {
      return Bc;
    }
    function RS(e) {
      Dh === null ? Dh = [e] : Dh.push(e);
    }
    var lL = i.ReactCurrentBatchConfig, sL = null;
    function uL() {
      return lL.transition;
    }
    var Uc = {
      recordUnsafeLifecycleWarnings: function(e, n) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(e, n) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var cL = function(e) {
        for (var n = null, l = e; l !== null; )
          l.mode & _n && (n = l), l = l.return;
        return n;
      }, Qv = function(e) {
        var n = [];
        return e.forEach(function(l) {
          n.push(l);
        }), n.sort().join(", ");
      }, $b = [], Zb = [], Jb = [], Qb = [], Kb = [], qb = [], Kv = /* @__PURE__ */ new Set();
      Uc.recordUnsafeLifecycleWarnings = function(e, n) {
        Kv.has(e.type) || (typeof n.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        n.componentWillMount.__suppressDeprecationWarning !== !0 && $b.push(e), e.mode & _n && typeof n.UNSAFE_componentWillMount == "function" && Zb.push(e), typeof n.componentWillReceiveProps == "function" && n.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Jb.push(e), e.mode & _n && typeof n.UNSAFE_componentWillReceiveProps == "function" && Qb.push(e), typeof n.componentWillUpdate == "function" && n.componentWillUpdate.__suppressDeprecationWarning !== !0 && Kb.push(e), e.mode & _n && typeof n.UNSAFE_componentWillUpdate == "function" && qb.push(e));
      }, Uc.flushPendingUnsafeLifecycleWarnings = function() {
        var e = /* @__PURE__ */ new Set();
        $b.length > 0 && ($b.forEach(function(se) {
          e.add(dn(se) || "Component"), Kv.add(se.type);
        }), $b = []);
        var n = /* @__PURE__ */ new Set();
        Zb.length > 0 && (Zb.forEach(function(se) {
          n.add(dn(se) || "Component"), Kv.add(se.type);
        }), Zb = []);
        var l = /* @__PURE__ */ new Set();
        Jb.length > 0 && (Jb.forEach(function(se) {
          l.add(dn(se) || "Component"), Kv.add(se.type);
        }), Jb = []);
        var f = /* @__PURE__ */ new Set();
        Qb.length > 0 && (Qb.forEach(function(se) {
          f.add(dn(se) || "Component"), Kv.add(se.type);
        }), Qb = []);
        var m = /* @__PURE__ */ new Set();
        Kb.length > 0 && (Kb.forEach(function(se) {
          m.add(dn(se) || "Component"), Kv.add(se.type);
        }), Kb = []);
        var E = /* @__PURE__ */ new Set();
        if (qb.length > 0 && (qb.forEach(function(se) {
          E.add(dn(se) || "Component"), Kv.add(se.type);
        }), qb = []), n.size > 0) {
          var w = Qv(n);
          h(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, w);
        }
        if (f.size > 0) {
          var O = Qv(f);
          h(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, O);
        }
        if (E.size > 0) {
          var D = Qv(E);
          h(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, D);
        }
        if (e.size > 0) {
          var X = Qv(e);
          v(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, X);
        }
        if (l.size > 0) {
          var Z = Qv(l);
          v(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Z);
        }
        if (m.size > 0) {
          var ue = Qv(m);
          v(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, ue);
        }
      };
      var j0 = /* @__PURE__ */ new Map(), uw = /* @__PURE__ */ new Set();
      Uc.recordLegacyContextWarning = function(e, n) {
        var l = cL(e);
        if (l === null) {
          h("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!uw.has(e.type)) {
          var f = j0.get(l);
          (e.type.contextTypes != null || e.type.childContextTypes != null || n !== null && typeof n.getChildContext == "function") && (f === void 0 && (f = [], j0.set(l, f)), f.push(e));
        }
      }, Uc.flushLegacyContextWarning = function() {
        j0.forEach(function(e, n) {
          if (e.length !== 0) {
            var l = e[0], f = /* @__PURE__ */ new Set();
            e.forEach(function(E) {
              f.add(dn(E) || "Component"), uw.add(E.type);
            });
            var m = Qv(f);
            try {
              gr(l), h(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, m);
            } finally {
              da();
            }
          }
        });
      }, Uc.discardPendingWarnings = function() {
        $b = [], Zb = [], Jb = [], Qb = [], Kb = [], qb = [], j0 = /* @__PURE__ */ new Map();
      };
    }
    var TS, wS, IS, AS, NS, cw = function(e, n) {
    };
    TS = !1, wS = !1, IS = {}, AS = {}, NS = {}, cw = function(e, n) {
      if (!(e === null || typeof e != "object") && !(!e._store || e._store.validated || e.key != null)) {
        if (typeof e._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        e._store.validated = !0;
        var l = dn(n) || "Component";
        AS[l] || (AS[l] = !0, h('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function fL(e) {
      return e.prototype && e.prototype.isReactComponent;
    }
    function ey(e, n, l) {
      var f = l.ref;
      if (f !== null && typeof f != "function" && typeof f != "object") {
        if ((e.mode & _n || lt) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(l._owner && l._self && l._owner.stateNode !== l._self) && // Will already throw with "Function components cannot have string refs"
        !(l._owner && l._owner.tag !== S) && // Will already warn with "Function components cannot be given refs"
        !(typeof l.type == "function" && !fL(l.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        l._owner) {
          var m = dn(e) || "Component";
          IS[m] || (h('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', m, f), IS[m] = !0);
        }
        if (l._owner) {
          var E = l._owner, w;
          if (E) {
            var O = E;
            if (O.tag !== S)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            w = O.stateNode;
          }
          if (!w)
            throw new Error("Missing owner for string ref " + f + ". This error is likely caused by a bug in React. Please file an issue.");
          var D = w;
          qr(f, "ref");
          var X = "" + f;
          if (n !== null && n.ref !== null && typeof n.ref == "function" && n.ref._stringRef === X)
            return n.ref;
          var Z = function(ue) {
            var se = D.refs;
            ue === null ? delete se[X] : se[X] = ue;
          };
          return Z._stringRef = X, Z;
        } else {
          if (typeof f != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!l._owner)
            throw new Error("Element ref was specified as a string (" + f + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return f;
    }
    function G0(e, n) {
      var l = Object.prototype.toString.call(n);
      throw new Error("Objects are not valid as a React child (found: " + (l === "[object Object]" ? "object with keys {" + Object.keys(n).join(", ") + "}" : l) + "). If you meant to render a collection of children, use an array instead.");
    }
    function z0(e) {
      {
        var n = dn(e) || "Component";
        if (NS[n])
          return;
        NS[n] = !0, h("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function fw(e) {
      var n = e._payload, l = e._init;
      return l(n);
    }
    function dw(e) {
      function n(Ce, Pe) {
        if (e) {
          var Ee = Ce.deletions;
          Ee === null ? (Ce.deletions = [Pe], Ce.flags |= vr) : Ee.push(Pe);
        }
      }
      function l(Ce, Pe) {
        if (!e)
          return null;
        for (var Ee = Pe; Ee !== null; )
          n(Ce, Ee), Ee = Ee.sibling;
        return null;
      }
      function f(Ce, Pe) {
        for (var Ee = /* @__PURE__ */ new Map(), et = Pe; et !== null; )
          et.key !== null ? Ee.set(et.key, et) : Ee.set(et.index, et), et = et.sibling;
        return Ee;
      }
      function m(Ce, Pe) {
        var Ee = lm(Ce, Pe);
        return Ee.index = 0, Ee.sibling = null, Ee;
      }
      function E(Ce, Pe, Ee) {
        if (Ce.index = Ee, !e)
          return Ce.flags |= dv, Pe;
        var et = Ce.alternate;
        if (et !== null) {
          var It = et.index;
          return It < Pe ? (Ce.flags |= Xr, Pe) : It;
        } else
          return Ce.flags |= Xr, Pe;
      }
      function w(Ce) {
        return e && Ce.alternate === null && (Ce.flags |= Xr), Ce;
      }
      function O(Ce, Pe, Ee, et) {
        if (Pe === null || Pe.tag !== M) {
          var It = RR(Ee, Ce.mode, et);
          return It.return = Ce, It;
        } else {
          var St = m(Pe, Ee);
          return St.return = Ce, St;
        }
      }
      function D(Ce, Pe, Ee, et) {
        var It = Ee.type;
        if (It === rt)
          return Z(Ce, Pe, Ee.props.children, et, Ee.key);
        if (Pe !== null && (Pe.elementType === It || // Keep this check inline so it only runs on the false path:
        gA(Pe, Ee) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof It == "object" && It !== null && It.$$typeof === Et && fw(It) === Pe.type)) {
          var St = m(Pe, Ee.props);
          return St.ref = ey(Ce, Pe, Ee), St.return = Ce, St._debugSource = Ee._source, St._debugOwner = Ee._owner, St;
        }
        var pn = xR(Ee, Ce.mode, et);
        return pn.ref = ey(Ce, Pe, Ee), pn.return = Ce, pn;
      }
      function X(Ce, Pe, Ee, et) {
        if (Pe === null || Pe.tag !== _ || Pe.stateNode.containerInfo !== Ee.containerInfo || Pe.stateNode.implementation !== Ee.implementation) {
          var It = TR(Ee, Ce.mode, et);
          return It.return = Ce, It;
        } else {
          var St = m(Pe, Ee.children || []);
          return St.return = Ce, St;
        }
      }
      function Z(Ce, Pe, Ee, et, It) {
        if (Pe === null || Pe.tag !== U) {
          var St = zh(Ee, Ce.mode, et, It);
          return St.return = Ce, St;
        } else {
          var pn = m(Pe, Ee);
          return pn.return = Ce, pn;
        }
      }
      function ue(Ce, Pe, Ee) {
        if (typeof Pe == "string" && Pe !== "" || typeof Pe == "number") {
          var et = RR("" + Pe, Ce.mode, Ee);
          return et.return = Ce, et;
        }
        if (typeof Pe == "object" && Pe !== null) {
          switch (Pe.$$typeof) {
            case xe: {
              var It = xR(Pe, Ce.mode, Ee);
              return It.ref = ey(Ce, null, Pe), It.return = Ce, It;
            }
            case Ue: {
              var St = TR(Pe, Ce.mode, Ee);
              return St.return = Ce, St;
            }
            case Et: {
              var pn = Pe._payload, En = Pe._init;
              return ue(Ce, En(pn), Ee);
            }
          }
          if (Hn(Pe) || Ra(Pe)) {
            var jr = zh(Pe, Ce.mode, Ee, null);
            return jr.return = Ce, jr;
          }
          G0(Ce, Pe);
        }
        return typeof Pe == "function" && z0(Ce), null;
      }
      function se(Ce, Pe, Ee, et) {
        var It = Pe !== null ? Pe.key : null;
        if (typeof Ee == "string" && Ee !== "" || typeof Ee == "number")
          return It !== null ? null : O(Ce, Pe, "" + Ee, et);
        if (typeof Ee == "object" && Ee !== null) {
          switch (Ee.$$typeof) {
            case xe:
              return Ee.key === It ? D(Ce, Pe, Ee, et) : null;
            case Ue:
              return Ee.key === It ? X(Ce, Pe, Ee, et) : null;
            case Et: {
              var St = Ee._payload, pn = Ee._init;
              return se(Ce, Pe, pn(St), et);
            }
          }
          if (Hn(Ee) || Ra(Ee))
            return It !== null ? null : Z(Ce, Pe, Ee, et, null);
          G0(Ce, Ee);
        }
        return typeof Ee == "function" && z0(Ce), null;
      }
      function Ie(Ce, Pe, Ee, et, It) {
        if (typeof et == "string" && et !== "" || typeof et == "number") {
          var St = Ce.get(Ee) || null;
          return O(Pe, St, "" + et, It);
        }
        if (typeof et == "object" && et !== null) {
          switch (et.$$typeof) {
            case xe: {
              var pn = Ce.get(et.key === null ? Ee : et.key) || null;
              return D(Pe, pn, et, It);
            }
            case Ue: {
              var En = Ce.get(et.key === null ? Ee : et.key) || null;
              return X(Pe, En, et, It);
            }
            case Et:
              var jr = et._payload, Cr = et._init;
              return Ie(Ce, Pe, Ee, Cr(jr), It);
          }
          if (Hn(et) || Ra(et)) {
            var yi = Ce.get(Ee) || null;
            return Z(Pe, yi, et, It, null);
          }
          G0(Pe, et);
        }
        return typeof et == "function" && z0(Pe), null;
      }
      function Ae(Ce, Pe, Ee) {
        {
          if (typeof Ce != "object" || Ce === null)
            return Pe;
          switch (Ce.$$typeof) {
            case xe:
            case Ue:
              cw(Ce, Ee);
              var et = Ce.key;
              if (typeof et != "string")
                break;
              if (Pe === null) {
                Pe = /* @__PURE__ */ new Set(), Pe.add(et);
                break;
              }
              if (!Pe.has(et)) {
                Pe.add(et);
                break;
              }
              h("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", et);
              break;
            case Et:
              var It = Ce._payload, St = Ce._init;
              Ae(St(It), Pe, Ee);
              break;
          }
        }
        return Pe;
      }
      function Me(Ce, Pe, Ee, et) {
        for (var It = null, St = 0; St < Ee.length; St++) {
          var pn = Ee[St];
          It = Ae(pn, It, Ce);
        }
        for (var En = null, jr = null, Cr = Pe, yi = 0, Er = 0, ui = null; Cr !== null && Er < Ee.length; Er++) {
          Cr.index > Er ? (ui = Cr, Cr = null) : ui = Cr.sibling;
          var Cl = se(Ce, Cr, Ee[Er], et);
          if (Cl === null) {
            Cr === null && (Cr = ui);
            break;
          }
          e && Cr && Cl.alternate === null && n(Ce, Cr), yi = E(Cl, yi, Er), jr === null ? En = Cl : jr.sibling = Cl, jr = Cl, Cr = ui;
        }
        if (Er === Ee.length) {
          if (l(Ce, Cr), Po()) {
            var jo = Er;
            $v(Ce, jo);
          }
          return En;
        }
        if (Cr === null) {
          for (; Er < Ee.length; Er++) {
            var Zs = ue(Ce, Ee[Er], et);
            Zs !== null && (yi = E(Zs, yi, Er), jr === null ? En = Zs : jr.sibling = Zs, jr = Zs);
          }
          if (Po()) {
            var Bl = Er;
            $v(Ce, Bl);
          }
          return En;
        }
        for (var Ul = f(Ce, Cr); Er < Ee.length; Er++) {
          var El = Ie(Ul, Ce, Er, Ee[Er], et);
          El !== null && (e && El.alternate !== null && Ul.delete(El.key === null ? Er : El.key), yi = E(El, yi, Er), jr === null ? En = El : jr.sibling = El, jr = El);
        }
        if (e && Ul.forEach(function(Mg) {
          return n(Ce, Mg);
        }), Po()) {
          var Cp = Er;
          $v(Ce, Cp);
        }
        return En;
      }
      function gt(Ce, Pe, Ee, et) {
        var It = Ra(Ee);
        if (typeof It != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          Ee[Symbol.toStringTag] === "Generator" && (wS || h("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), wS = !0), Ee.entries === It && (TS || h("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), TS = !0);
          var St = It.call(Ee);
          if (St)
            for (var pn = null, En = St.next(); !En.done; En = St.next()) {
              var jr = En.value;
              pn = Ae(jr, pn, Ce);
            }
        }
        var Cr = It.call(Ee);
        if (Cr == null)
          throw new Error("An iterable object provided no iterator.");
        for (var yi = null, Er = null, ui = Pe, Cl = 0, jo = 0, Zs = null, Bl = Cr.next(); ui !== null && !Bl.done; jo++, Bl = Cr.next()) {
          ui.index > jo ? (Zs = ui, ui = null) : Zs = ui.sibling;
          var Ul = se(Ce, ui, Bl.value, et);
          if (Ul === null) {
            ui === null && (ui = Zs);
            break;
          }
          e && ui && Ul.alternate === null && n(Ce, ui), Cl = E(Ul, Cl, jo), Er === null ? yi = Ul : Er.sibling = Ul, Er = Ul, ui = Zs;
        }
        if (Bl.done) {
          if (l(Ce, ui), Po()) {
            var El = jo;
            $v(Ce, El);
          }
          return yi;
        }
        if (ui === null) {
          for (; !Bl.done; jo++, Bl = Cr.next()) {
            var Cp = ue(Ce, Bl.value, et);
            Cp !== null && (Cl = E(Cp, Cl, jo), Er === null ? yi = Cp : Er.sibling = Cp, Er = Cp);
          }
          if (Po()) {
            var Mg = jo;
            $v(Ce, Mg);
          }
          return yi;
        }
        for (var Ly = f(Ce, ui); !Bl.done; jo++, Bl = Cr.next()) {
          var nd = Ie(Ly, Ce, jo, Bl.value, et);
          nd !== null && (e && nd.alternate !== null && Ly.delete(nd.key === null ? jo : nd.key), Cl = E(nd, Cl, jo), Er === null ? yi = nd : Er.sibling = nd, Er = nd);
        }
        if (e && Ly.forEach(function(F5) {
          return n(Ce, F5);
        }), Po()) {
          var k5 = jo;
          $v(Ce, k5);
        }
        return yi;
      }
      function Kt(Ce, Pe, Ee, et) {
        if (Pe !== null && Pe.tag === M) {
          l(Ce, Pe.sibling);
          var It = m(Pe, Ee);
          return It.return = Ce, It;
        }
        l(Ce, Pe);
        var St = RR(Ee, Ce.mode, et);
        return St.return = Ce, St;
      }
      function jt(Ce, Pe, Ee, et) {
        for (var It = Ee.key, St = Pe; St !== null; ) {
          if (St.key === It) {
            var pn = Ee.type;
            if (pn === rt) {
              if (St.tag === U) {
                l(Ce, St.sibling);
                var En = m(St, Ee.props.children);
                return En.return = Ce, En._debugSource = Ee._source, En._debugOwner = Ee._owner, En;
              }
            } else if (St.elementType === pn || // Keep this check inline so it only runs on the false path:
            gA(St, Ee) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof pn == "object" && pn !== null && pn.$$typeof === Et && fw(pn) === St.type) {
              l(Ce, St.sibling);
              var jr = m(St, Ee.props);
              return jr.ref = ey(Ce, St, Ee), jr.return = Ce, jr._debugSource = Ee._source, jr._debugOwner = Ee._owner, jr;
            }
            l(Ce, St);
            break;
          } else
            n(Ce, St);
          St = St.sibling;
        }
        if (Ee.type === rt) {
          var Cr = zh(Ee.props.children, Ce.mode, et, Ee.key);
          return Cr.return = Ce, Cr;
        } else {
          var yi = xR(Ee, Ce.mode, et);
          return yi.ref = ey(Ce, Pe, Ee), yi.return = Ce, yi;
        }
      }
      function lr(Ce, Pe, Ee, et) {
        for (var It = Ee.key, St = Pe; St !== null; ) {
          if (St.key === It)
            if (St.tag === _ && St.stateNode.containerInfo === Ee.containerInfo && St.stateNode.implementation === Ee.implementation) {
              l(Ce, St.sibling);
              var pn = m(St, Ee.children || []);
              return pn.return = Ce, pn;
            } else {
              l(Ce, St);
              break;
            }
          else
            n(Ce, St);
          St = St.sibling;
        }
        var En = TR(Ee, Ce.mode, et);
        return En.return = Ce, En;
      }
      function Zn(Ce, Pe, Ee, et) {
        var It = typeof Ee == "object" && Ee !== null && Ee.type === rt && Ee.key === null;
        if (It && (Ee = Ee.props.children), typeof Ee == "object" && Ee !== null) {
          switch (Ee.$$typeof) {
            case xe:
              return w(jt(Ce, Pe, Ee, et));
            case Ue:
              return w(lr(Ce, Pe, Ee, et));
            case Et:
              var St = Ee._payload, pn = Ee._init;
              return Zn(Ce, Pe, pn(St), et);
          }
          if (Hn(Ee))
            return Me(Ce, Pe, Ee, et);
          if (Ra(Ee))
            return gt(Ce, Pe, Ee, et);
          G0(Ce, Ee);
        }
        return typeof Ee == "string" && Ee !== "" || typeof Ee == "number" ? w(Kt(Ce, Pe, "" + Ee, et)) : (typeof Ee == "function" && z0(Ce), l(Ce, Pe));
      }
      return Zn;
    }
    var mg = dw(!0), pw = dw(!1);
    function dL(e, n) {
      if (e !== null && n.child !== e.child)
        throw new Error("Resuming work not yet implemented.");
      if (n.child !== null) {
        var l = n.child, f = lm(l, l.pendingProps);
        for (n.child = f, f.return = n; l.sibling !== null; )
          l = l.sibling, f = f.sibling = lm(l, l.pendingProps), f.return = n;
        f.sibling = null;
      }
    }
    function pL(e, n) {
      for (var l = e.child; l !== null; )
        e5(l, n), l = l.sibling;
    }
    var _S = go(null), OS;
    OS = {};
    var W0 = null, gg = null, LS = null, X0 = !1;
    function Y0() {
      W0 = null, gg = null, LS = null, X0 = !1;
    }
    function hw() {
      X0 = !0;
    }
    function vw() {
      X0 = !1;
    }
    function mw(e, n, l) {
      bl(_S, n._currentValue, e), n._currentValue = l, n._currentRenderer !== void 0 && n._currentRenderer !== null && n._currentRenderer !== OS && h("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), n._currentRenderer = OS;
    }
    function DS(e, n) {
      var l = _S.current;
      $i(_S, n), e._currentValue = l;
    }
    function MS(e, n, l) {
      for (var f = e; f !== null; ) {
        var m = f.alternate;
        if (Nu(f.childLanes, n) ? m !== null && !Nu(m.childLanes, n) && (m.childLanes = yn(m.childLanes, n)) : (f.childLanes = yn(f.childLanes, n), m !== null && (m.childLanes = yn(m.childLanes, n))), f === l)
          break;
        f = f.return;
      }
      f !== l && h("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function hL(e, n, l) {
      vL(e, n, l);
    }
    function vL(e, n, l) {
      var f = e.child;
      for (f !== null && (f.return = e); f !== null; ) {
        var m = void 0, E = f.dependencies;
        if (E !== null) {
          m = f.child;
          for (var w = E.firstContext; w !== null; ) {
            if (w.context === n) {
              if (f.tag === S) {
                var O = _f(l), D = hp(Rr, O);
                D.tag = Z0;
                var X = f.updateQueue;
                if (X !== null) {
                  var Z = X.shared, ue = Z.pending;
                  ue === null ? D.next = D : (D.next = ue.next, ue.next = D), Z.pending = D;
                }
              }
              f.lanes = yn(f.lanes, l);
              var se = f.alternate;
              se !== null && (se.lanes = yn(se.lanes, l)), MS(f.return, l, e), E.lanes = yn(E.lanes, l);
              break;
            }
            w = w.next;
          }
        } else if (f.tag === Y)
          m = f.type === e.type ? null : f.child;
        else if (f.tag === Se) {
          var Ie = f.return;
          if (Ie === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          Ie.lanes = yn(Ie.lanes, l);
          var Ae = Ie.alternate;
          Ae !== null && (Ae.lanes = yn(Ae.lanes, l)), MS(Ie, l, e), m = f.sibling;
        } else
          m = f.child;
        if (m !== null)
          m.return = f;
        else
          for (m = f; m !== null; ) {
            if (m === e) {
              m = null;
              break;
            }
            var Me = m.sibling;
            if (Me !== null) {
              Me.return = m.return, m = Me;
              break;
            }
            m = m.return;
          }
        f = m;
      }
    }
    function bg(e, n) {
      W0 = e, gg = null, LS = null;
      var l = e.dependencies;
      if (l !== null) {
        var f = l.firstContext;
        f !== null && (Wi(l.lanes, n) && vy(), l.firstContext = null);
      }
    }
    function Oi(e) {
      X0 && h("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var n = e._currentValue;
      if (LS !== e) {
        var l = {
          context: e,
          memoizedValue: n,
          next: null
        };
        if (gg === null) {
          if (W0 === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          gg = l, W0.dependencies = {
            lanes: je,
            firstContext: l
          };
        } else
          gg = gg.next = l;
      }
      return n;
    }
    var qv = null;
    function PS(e) {
      qv === null ? qv = [e] : qv.push(e);
    }
    function mL() {
      if (qv !== null) {
        for (var e = 0; e < qv.length; e++) {
          var n = qv[e], l = n.interleaved;
          if (l !== null) {
            n.interleaved = null;
            var f = l.next, m = n.pending;
            if (m !== null) {
              var E = m.next;
              m.next = f, l.next = E;
            }
            n.pending = l;
          }
        }
        qv = null;
      }
    }
    function gw(e, n, l, f) {
      var m = n.interleaved;
      return m === null ? (l.next = l, PS(n)) : (l.next = m.next, m.next = l), n.interleaved = l, $0(e, f);
    }
    function gL(e, n, l, f) {
      var m = n.interleaved;
      m === null ? (l.next = l, PS(n)) : (l.next = m.next, m.next = l), n.interleaved = l;
    }
    function bL(e, n, l, f) {
      var m = n.interleaved;
      return m === null ? (l.next = l, PS(n)) : (l.next = m.next, m.next = l), n.interleaved = l, $0(e, f);
    }
    function ps(e, n) {
      return $0(e, n);
    }
    var yL = $0;
    function $0(e, n) {
      e.lanes = yn(e.lanes, n);
      var l = e.alternate;
      l !== null && (l.lanes = yn(l.lanes, n)), l === null && (e.flags & (Xr | nl)) !== zt && pA(e);
      for (var f = e, m = e.return; m !== null; )
        m.childLanes = yn(m.childLanes, n), l = m.alternate, l !== null ? l.childLanes = yn(l.childLanes, n) : (m.flags & (Xr | nl)) !== zt && pA(e), f = m, m = m.return;
      if (f.tag === T) {
        var E = f.stateNode;
        return E;
      } else
        return null;
    }
    var bw = 0, yw = 1, Z0 = 2, kS = 3, J0 = !1, FS, Q0;
    FS = !1, Q0 = null;
    function BS(e) {
      var n = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: je
        },
        effects: null
      };
      e.updateQueue = n;
    }
    function Cw(e, n) {
      var l = n.updateQueue, f = e.updateQueue;
      if (l === f) {
        var m = {
          baseState: f.baseState,
          firstBaseUpdate: f.firstBaseUpdate,
          lastBaseUpdate: f.lastBaseUpdate,
          shared: f.shared,
          effects: f.effects
        };
        n.updateQueue = m;
      }
    }
    function hp(e, n) {
      var l = {
        eventTime: e,
        lane: n,
        tag: bw,
        payload: null,
        callback: null,
        next: null
      };
      return l;
    }
    function Mh(e, n, l) {
      var f = e.updateQueue;
      if (f === null)
        return null;
      var m = f.shared;
      if (Q0 === m && !FS && (h("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), FS = !0), g3()) {
        var E = m.pending;
        return E === null ? n.next = n : (n.next = E.next, E.next = n), m.pending = n, yL(e, l);
      } else
        return bL(e, m, n, l);
    }
    function K0(e, n, l) {
      var f = n.updateQueue;
      if (f !== null) {
        var m = f.shared;
        if (ah(l)) {
          var E = m.lanes;
          E = ih(E, e.pendingLanes);
          var w = yn(E, l);
          m.lanes = w, Yt(e, w);
        }
      }
    }
    function US(e, n) {
      var l = e.updateQueue, f = e.alternate;
      if (f !== null) {
        var m = f.updateQueue;
        if (l === m) {
          var E = null, w = null, O = l.firstBaseUpdate;
          if (O !== null) {
            var D = O;
            do {
              var X = {
                eventTime: D.eventTime,
                lane: D.lane,
                tag: D.tag,
                payload: D.payload,
                callback: D.callback,
                next: null
              };
              w === null ? E = w = X : (w.next = X, w = X), D = D.next;
            } while (D !== null);
            w === null ? E = w = n : (w.next = n, w = n);
          } else
            E = w = n;
          l = {
            baseState: m.baseState,
            firstBaseUpdate: E,
            lastBaseUpdate: w,
            shared: m.shared,
            effects: m.effects
          }, e.updateQueue = l;
          return;
        }
      }
      var Z = l.lastBaseUpdate;
      Z === null ? l.firstBaseUpdate = n : Z.next = n, l.lastBaseUpdate = n;
    }
    function CL(e, n, l, f, m, E) {
      switch (l.tag) {
        case yw: {
          var w = l.payload;
          if (typeof w == "function") {
            hw();
            var O = w.call(E, f, m);
            {
              if (e.mode & _n) {
                Fa(!0);
                try {
                  w.call(E, f, m);
                } finally {
                  Fa(!1);
                }
              }
              vw();
            }
            return O;
          }
          return w;
        }
        case kS:
          e.flags = e.flags & ~ai | un;
        case bw: {
          var D = l.payload, X;
          if (typeof D == "function") {
            hw(), X = D.call(E, f, m);
            {
              if (e.mode & _n) {
                Fa(!0);
                try {
                  D.call(E, f, m);
                } finally {
                  Fa(!1);
                }
              }
              vw();
            }
          } else
            X = D;
          return X == null ? f : on({}, f, X);
        }
        case Z0:
          return J0 = !0, f;
      }
      return f;
    }
    function q0(e, n, l, f) {
      var m = e.updateQueue;
      J0 = !1, Q0 = m.shared;
      var E = m.firstBaseUpdate, w = m.lastBaseUpdate, O = m.shared.pending;
      if (O !== null) {
        m.shared.pending = null;
        var D = O, X = D.next;
        D.next = null, w === null ? E = X : w.next = X, w = D;
        var Z = e.alternate;
        if (Z !== null) {
          var ue = Z.updateQueue, se = ue.lastBaseUpdate;
          se !== w && (se === null ? ue.firstBaseUpdate = X : se.next = X, ue.lastBaseUpdate = D);
        }
      }
      if (E !== null) {
        var Ie = m.baseState, Ae = je, Me = null, gt = null, Kt = null, jt = E;
        do {
          var lr = jt.lane, Zn = jt.eventTime;
          if (Nu(f, lr)) {
            if (Kt !== null) {
              var Pe = {
                eventTime: Zn,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Ia,
                tag: jt.tag,
                payload: jt.payload,
                callback: jt.callback,
                next: null
              };
              Kt = Kt.next = Pe;
            }
            Ie = CL(e, m, jt, Ie, n, l);
            var Ee = jt.callback;
            if (Ee !== null && // If the update was already committed, we should not queue its
            // callback again.
            jt.lane !== Ia) {
              e.flags |= ts;
              var et = m.effects;
              et === null ? m.effects = [jt] : et.push(jt);
            }
          } else {
            var Ce = {
              eventTime: Zn,
              lane: lr,
              tag: jt.tag,
              payload: jt.payload,
              callback: jt.callback,
              next: null
            };
            Kt === null ? (gt = Kt = Ce, Me = Ie) : Kt = Kt.next = Ce, Ae = yn(Ae, lr);
          }
          if (jt = jt.next, jt === null) {
            if (O = m.shared.pending, O === null)
              break;
            var It = O, St = It.next;
            It.next = null, jt = St, m.lastBaseUpdate = It, m.shared.pending = null;
          }
        } while (!0);
        Kt === null && (Me = Ie), m.baseState = Me, m.firstBaseUpdate = gt, m.lastBaseUpdate = Kt;
        var pn = m.shared.interleaved;
        if (pn !== null) {
          var En = pn;
          do
            Ae = yn(Ae, En.lane), En = En.next;
          while (En !== pn);
        } else
          E === null && (m.shared.lanes = je);
        Iy(Ae), e.lanes = Ae, e.memoizedState = Ie;
      }
      Q0 = null;
    }
    function EL(e, n) {
      if (typeof e != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + e));
      e.call(n);
    }
    function Ew() {
      J0 = !1;
    }
    function e1() {
      return J0;
    }
    function Sw(e, n, l) {
      var f = n.effects;
      if (n.effects = null, f !== null)
        for (var m = 0; m < f.length; m++) {
          var E = f[m], w = E.callback;
          w !== null && (E.callback = null, EL(w, l));
        }
    }
    var ty = {}, Ph = go(ty), ny = go(ty), t1 = go(ty);
    function n1(e) {
      if (e === ty)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return e;
    }
    function xw() {
      var e = n1(t1.current);
      return e;
    }
    function VS(e, n) {
      bl(t1, n, e), bl(ny, e, e), bl(Ph, ty, e);
      var l = CE(n);
      $i(Ph, e), bl(Ph, l, e);
    }
    function yg(e) {
      $i(Ph, e), $i(ny, e), $i(t1, e);
    }
    function HS() {
      var e = n1(Ph.current);
      return e;
    }
    function Rw(e) {
      n1(t1.current);
      var n = n1(Ph.current), l = EE(n, e.type);
      n !== l && (bl(ny, e, e), bl(Ph, l, e));
    }
    function jS(e) {
      ny.current === e && ($i(Ph, e), $i(ny, e));
    }
    var SL = 0, Tw = 1, ww = 1, ry = 2, Vc = go(SL);
    function GS(e, n) {
      return (e & n) !== 0;
    }
    function Cg(e) {
      return e & Tw;
    }
    function zS(e, n) {
      return e & Tw | n;
    }
    function xL(e, n) {
      return e | n;
    }
    function kh(e, n) {
      bl(Vc, n, e);
    }
    function Eg(e) {
      $i(Vc, e);
    }
    function RL(e, n) {
      var l = e.memoizedState;
      return l !== null ? l.dehydrated !== null : (e.memoizedProps, !0);
    }
    function r1(e) {
      for (var n = e; n !== null; ) {
        if (n.tag === W) {
          var l = n.memoizedState;
          if (l !== null) {
            var f = l.dehydrated;
            if (f === null || L0(f) || Wb(f))
              return n;
          }
        } else if (n.tag === Ne && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        n.memoizedProps.revealOrder !== void 0) {
          var m = (n.flags & un) !== zt;
          if (m)
            return n;
        } else if (n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === e)
          return null;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === e)
            return null;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
      return null;
    }
    var hs = (
      /*   */
      0
    ), Zi = (
      /* */
      1
    ), Zf = (
      /*  */
      2
    ), Ji = (
      /*    */
      4
    ), ko = (
      /*   */
      8
    ), WS = [];
    function XS() {
      for (var e = 0; e < WS.length; e++) {
        var n = WS[e];
        n._workInProgressVersionPrimary = null;
      }
      WS.length = 0;
    }
    function TL(e, n) {
      var l = n._getVersion, f = l(n._source);
      e.mutableSourceEagerHydrationData == null ? e.mutableSourceEagerHydrationData = [n, f] : e.mutableSourceEagerHydrationData.push(n, f);
    }
    var wt = i.ReactCurrentDispatcher, ay = i.ReactCurrentBatchConfig, YS, Sg;
    YS = /* @__PURE__ */ new Set();
    var em = je, Hr = null, Qi = null, Ki = null, a1 = !1, iy = !1, oy = 0, wL = 0, IL = 25, Ve = null, Hu = null, Fh = -1, $S = !1;
    function _r() {
      {
        var e = Ve;
        Hu === null ? Hu = [e] : Hu.push(e);
      }
    }
    function vt() {
      {
        var e = Ve;
        Hu !== null && (Fh++, Hu[Fh] !== e && AL(e));
      }
    }
    function xg(e) {
      e != null && !Hn(e) && h("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", Ve, typeof e);
    }
    function AL(e) {
      {
        var n = dn(Hr);
        if (!YS.has(n) && (YS.add(n), Hu !== null)) {
          for (var l = "", f = 30, m = 0; m <= Fh; m++) {
            for (var E = Hu[m], w = m === Fh ? e : E, O = m + 1 + ". " + E; O.length < f; )
              O += " ";
            O += w + `
`, l += O;
          }
          h(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, n, l);
        }
      }
    }
    function yl() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function ZS(e, n) {
      if ($S)
        return !1;
      if (n === null)
        return h("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Ve), !1;
      e.length !== n.length && h(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Ve, "[" + n.join(", ") + "]", "[" + e.join(", ") + "]");
      for (var l = 0; l < n.length && l < e.length; l++)
        if (!Nt(e[l], n[l]))
          return !1;
      return !0;
    }
    function Rg(e, n, l, f, m, E) {
      em = E, Hr = n, Hu = e !== null ? e._debugHookTypes : null, Fh = -1, $S = e !== null && e.type !== n.type, n.memoizedState = null, n.updateQueue = null, n.lanes = je, e !== null && e.memoizedState !== null ? wt.current = $w : Hu !== null ? wt.current = Yw : wt.current = Xw;
      var w = l(f, m);
      if (iy) {
        var O = 0;
        do {
          if (iy = !1, oy = 0, O >= IL)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          O += 1, $S = !1, Qi = null, Ki = null, n.updateQueue = null, Fh = -1, wt.current = Zw, w = l(f, m);
        } while (iy);
      }
      wt.current = g1, n._debugHookTypes = Hu;
      var D = Qi !== null && Qi.next !== null;
      if (em = je, Hr = null, Qi = null, Ki = null, Ve = null, Hu = null, Fh = -1, e !== null && (e.flags & ii) !== (n.flags & ii) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (e.mode & Ut) !== Ft && h("Internal React error: Expected static flag was missing. Please notify the React team."), a1 = !1, D)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return w;
    }
    function Tg() {
      var e = oy !== 0;
      return oy = 0, e;
    }
    function Iw(e, n, l) {
      n.updateQueue = e.updateQueue, (n.mode & Hi) !== Ft ? n.flags &= ~(hc | ta | ea | ln) : n.flags &= ~(ea | ln), e.lanes = Of(e.lanes, l);
    }
    function Aw() {
      if (wt.current = g1, a1) {
        for (var e = Hr.memoizedState; e !== null; ) {
          var n = e.queue;
          n !== null && (n.pending = null), e = e.next;
        }
        a1 = !1;
      }
      em = je, Hr = null, Qi = null, Ki = null, Hu = null, Fh = -1, Ve = null, Hw = !1, iy = !1, oy = 0;
    }
    function Jf() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Ki === null ? Hr.memoizedState = Ki = e : Ki = Ki.next = e, Ki;
    }
    function ju() {
      var e;
      if (Qi === null) {
        var n = Hr.alternate;
        n !== null ? e = n.memoizedState : e = null;
      } else
        e = Qi.next;
      var l;
      if (Ki === null ? l = Hr.memoizedState : l = Ki.next, l !== null)
        Ki = l, l = Ki.next, Qi = e;
      else {
        if (e === null)
          throw new Error("Rendered more hooks than during the previous render.");
        Qi = e;
        var f = {
          memoizedState: Qi.memoizedState,
          baseState: Qi.baseState,
          baseQueue: Qi.baseQueue,
          queue: Qi.queue,
          next: null
        };
        Ki === null ? Hr.memoizedState = Ki = f : Ki = Ki.next = f;
      }
      return Ki;
    }
    function Nw() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function JS(e, n) {
      return typeof n == "function" ? n(e) : n;
    }
    function QS(e, n, l) {
      var f = Jf(), m;
      l !== void 0 ? m = l(n) : m = n, f.memoizedState = f.baseState = m;
      var E = {
        pending: null,
        interleaved: null,
        lanes: je,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: m
      };
      f.queue = E;
      var w = E.dispatch = LL.bind(null, Hr, E);
      return [f.memoizedState, w];
    }
    function KS(e, n, l) {
      var f = ju(), m = f.queue;
      if (m === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      m.lastRenderedReducer = e;
      var E = Qi, w = E.baseQueue, O = m.pending;
      if (O !== null) {
        if (w !== null) {
          var D = w.next, X = O.next;
          w.next = X, O.next = D;
        }
        E.baseQueue !== w && h("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), E.baseQueue = w = O, m.pending = null;
      }
      if (w !== null) {
        var Z = w.next, ue = E.baseState, se = null, Ie = null, Ae = null, Me = Z;
        do {
          var gt = Me.lane;
          if (Nu(em, gt)) {
            if (Ae !== null) {
              var jt = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Ia,
                action: Me.action,
                hasEagerState: Me.hasEagerState,
                eagerState: Me.eagerState,
                next: null
              };
              Ae = Ae.next = jt;
            }
            if (Me.hasEagerState)
              ue = Me.eagerState;
            else {
              var lr = Me.action;
              ue = e(ue, lr);
            }
          } else {
            var Kt = {
              lane: gt,
              action: Me.action,
              hasEagerState: Me.hasEagerState,
              eagerState: Me.eagerState,
              next: null
            };
            Ae === null ? (Ie = Ae = Kt, se = ue) : Ae = Ae.next = Kt, Hr.lanes = yn(Hr.lanes, gt), Iy(gt);
          }
          Me = Me.next;
        } while (Me !== null && Me !== Z);
        Ae === null ? se = ue : Ae.next = Ie, Nt(ue, f.memoizedState) || vy(), f.memoizedState = ue, f.baseState = se, f.baseQueue = Ae, m.lastRenderedState = ue;
      }
      var Zn = m.interleaved;
      if (Zn !== null) {
        var Ce = Zn;
        do {
          var Pe = Ce.lane;
          Hr.lanes = yn(Hr.lanes, Pe), Iy(Pe), Ce = Ce.next;
        } while (Ce !== Zn);
      } else
        w === null && (m.lanes = je);
      var Ee = m.dispatch;
      return [f.memoizedState, Ee];
    }
    function qS(e, n, l) {
      var f = ju(), m = f.queue;
      if (m === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      m.lastRenderedReducer = e;
      var E = m.dispatch, w = m.pending, O = f.memoizedState;
      if (w !== null) {
        m.pending = null;
        var D = w.next, X = D;
        do {
          var Z = X.action;
          O = e(O, Z), X = X.next;
        } while (X !== D);
        Nt(O, f.memoizedState) || vy(), f.memoizedState = O, f.baseQueue === null && (f.baseState = O), m.lastRenderedState = O;
      }
      return [O, E];
    }
    function pz(e, n, l) {
    }
    function hz(e, n, l) {
    }
    function ex(e, n, l) {
      var f = Hr, m = Jf(), E, w = Po();
      if (w) {
        if (l === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        E = l(), Sg || E !== l() && (h("The result of getServerSnapshot should be cached to avoid an infinite loop"), Sg = !0);
      } else {
        if (E = n(), !Sg) {
          var O = n();
          Nt(E, O) || (h("The result of getSnapshot should be cached to avoid an infinite loop"), Sg = !0);
        }
        var D = k1();
        if (D === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Au(D, em) || _w(f, n, E);
      }
      m.memoizedState = E;
      var X = {
        value: E,
        getSnapshot: n
      };
      return m.queue = X, u1(Lw.bind(null, f, X, e), [e]), f.flags |= ea, ly(Zi | ko, Ow.bind(null, f, X, E, n), void 0, null), E;
    }
    function i1(e, n, l) {
      var f = Hr, m = ju(), E = n();
      if (!Sg) {
        var w = n();
        Nt(E, w) || (h("The result of getSnapshot should be cached to avoid an infinite loop"), Sg = !0);
      }
      var O = m.memoizedState, D = !Nt(O, E);
      D && (m.memoizedState = E, vy());
      var X = m.queue;
      if (uy(Lw.bind(null, f, X, e), [e]), X.getSnapshot !== n || D || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Ki !== null && Ki.memoizedState.tag & Zi) {
        f.flags |= ea, ly(Zi | ko, Ow.bind(null, f, X, E, n), void 0, null);
        var Z = k1();
        if (Z === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Au(Z, em) || _w(f, n, E);
      }
      return E;
    }
    function _w(e, n, l) {
      e.flags |= Id;
      var f = {
        getSnapshot: n,
        value: l
      }, m = Hr.updateQueue;
      if (m === null)
        m = Nw(), Hr.updateQueue = m, m.stores = [f];
      else {
        var E = m.stores;
        E === null ? m.stores = [f] : E.push(f);
      }
    }
    function Ow(e, n, l, f) {
      n.value = l, n.getSnapshot = f, Dw(n) && Mw(e);
    }
    function Lw(e, n, l) {
      var f = function() {
        Dw(n) && Mw(e);
      };
      return l(f);
    }
    function Dw(e) {
      var n = e.getSnapshot, l = e.value;
      try {
        var f = n();
        return !Nt(l, f);
      } catch {
        return !0;
      }
    }
    function Mw(e) {
      var n = ps(e, Ht);
      n !== null && no(n, e, Ht, Rr);
    }
    function o1(e) {
      var n = Jf();
      typeof e == "function" && (e = e()), n.memoizedState = n.baseState = e;
      var l = {
        pending: null,
        interleaved: null,
        lanes: je,
        dispatch: null,
        lastRenderedReducer: JS,
        lastRenderedState: e
      };
      n.queue = l;
      var f = l.dispatch = DL.bind(null, Hr, l);
      return [n.memoizedState, f];
    }
    function tx(e) {
      return KS(JS);
    }
    function nx(e) {
      return qS(JS);
    }
    function ly(e, n, l, f) {
      var m = {
        tag: e,
        create: n,
        destroy: l,
        deps: f,
        // Circular
        next: null
      }, E = Hr.updateQueue;
      if (E === null)
        E = Nw(), Hr.updateQueue = E, E.lastEffect = m.next = m;
      else {
        var w = E.lastEffect;
        if (w === null)
          E.lastEffect = m.next = m;
        else {
          var O = w.next;
          w.next = m, m.next = O, E.lastEffect = m;
        }
      }
      return m;
    }
    function rx(e) {
      var n = Jf();
      {
        var l = {
          current: e
        };
        return n.memoizedState = l, l;
      }
    }
    function l1(e) {
      var n = ju();
      return n.memoizedState;
    }
    function sy(e, n, l, f) {
      var m = Jf(), E = f === void 0 ? null : f;
      Hr.flags |= e, m.memoizedState = ly(Zi | n, l, void 0, E);
    }
    function s1(e, n, l, f) {
      var m = ju(), E = f === void 0 ? null : f, w = void 0;
      if (Qi !== null) {
        var O = Qi.memoizedState;
        if (w = O.destroy, E !== null) {
          var D = O.deps;
          if (ZS(E, D)) {
            m.memoizedState = ly(n, l, w, E);
            return;
          }
        }
      }
      Hr.flags |= e, m.memoizedState = ly(Zi | n, l, w, E);
    }
    function u1(e, n) {
      return (Hr.mode & Hi) !== Ft ? sy(hc | ea | bu, ko, e, n) : sy(ea | bu, ko, e, n);
    }
    function uy(e, n) {
      return s1(ea, ko, e, n);
    }
    function ax(e, n) {
      return sy(ln, Zf, e, n);
    }
    function c1(e, n) {
      return s1(ln, Zf, e, n);
    }
    function ix(e, n) {
      var l = ln;
      return l |= co, (Hr.mode & Hi) !== Ft && (l |= ta), sy(l, Ji, e, n);
    }
    function f1(e, n) {
      return s1(ln, Ji, e, n);
    }
    function Pw(e, n) {
      if (typeof n == "function") {
        var l = n, f = e();
        return l(f), function() {
          l(null);
        };
      } else if (n != null) {
        var m = n;
        m.hasOwnProperty("current") || h("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(m).join(", ") + "}");
        var E = e();
        return m.current = E, function() {
          m.current = null;
        };
      }
    }
    function ox(e, n, l) {
      typeof n != "function" && h("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", n !== null ? typeof n : "null");
      var f = l != null ? l.concat([e]) : null, m = ln;
      return m |= co, (Hr.mode & Hi) !== Ft && (m |= ta), sy(m, Ji, Pw.bind(null, n, e), f);
    }
    function d1(e, n, l) {
      typeof n != "function" && h("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", n !== null ? typeof n : "null");
      var f = l != null ? l.concat([e]) : null;
      return s1(ln, Ji, Pw.bind(null, n, e), f);
    }
    function NL(e, n) {
    }
    var p1 = NL;
    function lx(e, n) {
      var l = Jf(), f = n === void 0 ? null : n;
      return l.memoizedState = [e, f], e;
    }
    function h1(e, n) {
      var l = ju(), f = n === void 0 ? null : n, m = l.memoizedState;
      if (m !== null && f !== null) {
        var E = m[1];
        if (ZS(f, E))
          return m[0];
      }
      return l.memoizedState = [e, f], e;
    }
    function sx(e, n) {
      var l = Jf(), f = n === void 0 ? null : n, m = e();
      return l.memoizedState = [m, f], m;
    }
    function v1(e, n) {
      var l = ju(), f = n === void 0 ? null : n, m = l.memoizedState;
      if (m !== null && f !== null) {
        var E = m[1];
        if (ZS(f, E))
          return m[0];
      }
      var w = e();
      return l.memoizedState = [w, f], w;
    }
    function ux(e) {
      var n = Jf();
      return n.memoizedState = e, e;
    }
    function kw(e) {
      var n = ju(), l = Qi, f = l.memoizedState;
      return Bw(n, f, e);
    }
    function Fw(e) {
      var n = ju();
      if (Qi === null)
        return n.memoizedState = e, e;
      var l = Qi.memoizedState;
      return Bw(n, l, e);
    }
    function Bw(e, n, l) {
      var f = !Hd(em);
      if (f) {
        if (!Nt(l, n)) {
          var m = jd();
          Hr.lanes = yn(Hr.lanes, m), Iy(m), e.baseState = !0;
        }
        return n;
      } else
        return e.baseState && (e.baseState = !1, vy()), e.memoizedState = l, l;
    }
    function _L(e, n, l) {
      var f = Lo();
      ma(ub(f, ls)), e(!0);
      var m = ay.transition;
      ay.transition = {};
      var E = ay.transition;
      ay.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        e(!1), n();
      } finally {
        if (ma(f), ay.transition = m, m === null && E._updatedFibers) {
          var w = E._updatedFibers.size;
          w > 10 && v("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), E._updatedFibers.clear();
        }
      }
    }
    function cx() {
      var e = o1(!1), n = e[0], l = e[1], f = _L.bind(null, l), m = Jf();
      return m.memoizedState = f, [n, f];
    }
    function Uw() {
      var e = tx(), n = e[0], l = ju(), f = l.memoizedState;
      return [n, f];
    }
    function Vw() {
      var e = nx(), n = e[0], l = ju(), f = l.memoizedState;
      return [n, f];
    }
    var Hw = !1;
    function OL() {
      return Hw;
    }
    function fx() {
      var e = Jf(), n = k1(), l = n.identifierPrefix, f;
      if (Po()) {
        var m = $4();
        f = ":" + l + "R" + m;
        var E = oy++;
        E > 0 && (f += "H" + E.toString(32)), f += ":";
      } else {
        var w = wL++;
        f = ":" + l + "r" + w.toString(32) + ":";
      }
      return e.memoizedState = f, f;
    }
    function m1() {
      var e = ju(), n = e.memoizedState;
      return n;
    }
    function LL(e, n, l) {
      typeof arguments[3] == "function" && h("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var f = jh(e), m = {
        lane: f,
        action: l,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (jw(e))
        Gw(n, m);
      else {
        var E = gw(e, n, m, f);
        if (E !== null) {
          var w = Fl();
          no(E, e, f, w), zw(E, n, f);
        }
      }
      Ww(e, f);
    }
    function DL(e, n, l) {
      typeof arguments[3] == "function" && h("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var f = jh(e), m = {
        lane: f,
        action: l,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (jw(e))
        Gw(n, m);
      else {
        var E = e.alternate;
        if (e.lanes === je && (E === null || E.lanes === je)) {
          var w = n.lastRenderedReducer;
          if (w !== null) {
            var O;
            O = wt.current, wt.current = Hc;
            try {
              var D = n.lastRenderedState, X = w(D, l);
              if (m.hasEagerState = !0, m.eagerState = X, Nt(X, D)) {
                gL(e, n, m, f);
                return;
              }
            } catch {
            } finally {
              wt.current = O;
            }
          }
        }
        var Z = gw(e, n, m, f);
        if (Z !== null) {
          var ue = Fl();
          no(Z, e, f, ue), zw(Z, n, f);
        }
      }
      Ww(e, f);
    }
    function jw(e) {
      var n = e.alternate;
      return e === Hr || n !== null && n === Hr;
    }
    function Gw(e, n) {
      iy = a1 = !0;
      var l = e.pending;
      l === null ? n.next = n : (n.next = l.next, l.next = n), e.pending = n;
    }
    function zw(e, n, l) {
      if (ah(l)) {
        var f = n.lanes;
        f = ih(f, e.pendingLanes);
        var m = yn(f, l);
        n.lanes = m, Yt(e, m);
      }
    }
    function Ww(e, n, l) {
      Pd(e, n);
    }
    var g1 = {
      readContext: Oi,
      useCallback: yl,
      useContext: yl,
      useEffect: yl,
      useImperativeHandle: yl,
      useInsertionEffect: yl,
      useLayoutEffect: yl,
      useMemo: yl,
      useReducer: yl,
      useRef: yl,
      useState: yl,
      useDebugValue: yl,
      useDeferredValue: yl,
      useTransition: yl,
      useMutableSource: yl,
      useSyncExternalStore: yl,
      useId: yl,
      unstable_isNewReconciler: he
    }, Xw = null, Yw = null, $w = null, Zw = null, Qf = null, Hc = null, b1 = null;
    {
      var dx = function() {
        h("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Cn = function() {
        h("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      Xw = {
        readContext: function(e) {
          return Oi(e);
        },
        useCallback: function(e, n) {
          return Ve = "useCallback", _r(), xg(n), lx(e, n);
        },
        useContext: function(e) {
          return Ve = "useContext", _r(), Oi(e);
        },
        useEffect: function(e, n) {
          return Ve = "useEffect", _r(), xg(n), u1(e, n);
        },
        useImperativeHandle: function(e, n, l) {
          return Ve = "useImperativeHandle", _r(), xg(l), ox(e, n, l);
        },
        useInsertionEffect: function(e, n) {
          return Ve = "useInsertionEffect", _r(), xg(n), ax(e, n);
        },
        useLayoutEffect: function(e, n) {
          return Ve = "useLayoutEffect", _r(), xg(n), ix(e, n);
        },
        useMemo: function(e, n) {
          Ve = "useMemo", _r(), xg(n);
          var l = wt.current;
          wt.current = Qf;
          try {
            return sx(e, n);
          } finally {
            wt.current = l;
          }
        },
        useReducer: function(e, n, l) {
          Ve = "useReducer", _r();
          var f = wt.current;
          wt.current = Qf;
          try {
            return QS(e, n, l);
          } finally {
            wt.current = f;
          }
        },
        useRef: function(e) {
          return Ve = "useRef", _r(), rx(e);
        },
        useState: function(e) {
          Ve = "useState", _r();
          var n = wt.current;
          wt.current = Qf;
          try {
            return o1(e);
          } finally {
            wt.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return Ve = "useDebugValue", _r(), void 0;
        },
        useDeferredValue: function(e) {
          return Ve = "useDeferredValue", _r(), ux(e);
        },
        useTransition: function() {
          return Ve = "useTransition", _r(), cx();
        },
        useMutableSource: function(e, n, l) {
          return Ve = "useMutableSource", _r(), void 0;
        },
        useSyncExternalStore: function(e, n, l) {
          return Ve = "useSyncExternalStore", _r(), ex(e, n, l);
        },
        useId: function() {
          return Ve = "useId", _r(), fx();
        },
        unstable_isNewReconciler: he
      }, Yw = {
        readContext: function(e) {
          return Oi(e);
        },
        useCallback: function(e, n) {
          return Ve = "useCallback", vt(), lx(e, n);
        },
        useContext: function(e) {
          return Ve = "useContext", vt(), Oi(e);
        },
        useEffect: function(e, n) {
          return Ve = "useEffect", vt(), u1(e, n);
        },
        useImperativeHandle: function(e, n, l) {
          return Ve = "useImperativeHandle", vt(), ox(e, n, l);
        },
        useInsertionEffect: function(e, n) {
          return Ve = "useInsertionEffect", vt(), ax(e, n);
        },
        useLayoutEffect: function(e, n) {
          return Ve = "useLayoutEffect", vt(), ix(e, n);
        },
        useMemo: function(e, n) {
          Ve = "useMemo", vt();
          var l = wt.current;
          wt.current = Qf;
          try {
            return sx(e, n);
          } finally {
            wt.current = l;
          }
        },
        useReducer: function(e, n, l) {
          Ve = "useReducer", vt();
          var f = wt.current;
          wt.current = Qf;
          try {
            return QS(e, n, l);
          } finally {
            wt.current = f;
          }
        },
        useRef: function(e) {
          return Ve = "useRef", vt(), rx(e);
        },
        useState: function(e) {
          Ve = "useState", vt();
          var n = wt.current;
          wt.current = Qf;
          try {
            return o1(e);
          } finally {
            wt.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return Ve = "useDebugValue", vt(), void 0;
        },
        useDeferredValue: function(e) {
          return Ve = "useDeferredValue", vt(), ux(e);
        },
        useTransition: function() {
          return Ve = "useTransition", vt(), cx();
        },
        useMutableSource: function(e, n, l) {
          return Ve = "useMutableSource", vt(), void 0;
        },
        useSyncExternalStore: function(e, n, l) {
          return Ve = "useSyncExternalStore", vt(), ex(e, n, l);
        },
        useId: function() {
          return Ve = "useId", vt(), fx();
        },
        unstable_isNewReconciler: he
      }, $w = {
        readContext: function(e) {
          return Oi(e);
        },
        useCallback: function(e, n) {
          return Ve = "useCallback", vt(), h1(e, n);
        },
        useContext: function(e) {
          return Ve = "useContext", vt(), Oi(e);
        },
        useEffect: function(e, n) {
          return Ve = "useEffect", vt(), uy(e, n);
        },
        useImperativeHandle: function(e, n, l) {
          return Ve = "useImperativeHandle", vt(), d1(e, n, l);
        },
        useInsertionEffect: function(e, n) {
          return Ve = "useInsertionEffect", vt(), c1(e, n);
        },
        useLayoutEffect: function(e, n) {
          return Ve = "useLayoutEffect", vt(), f1(e, n);
        },
        useMemo: function(e, n) {
          Ve = "useMemo", vt();
          var l = wt.current;
          wt.current = Hc;
          try {
            return v1(e, n);
          } finally {
            wt.current = l;
          }
        },
        useReducer: function(e, n, l) {
          Ve = "useReducer", vt();
          var f = wt.current;
          wt.current = Hc;
          try {
            return KS(e, n, l);
          } finally {
            wt.current = f;
          }
        },
        useRef: function(e) {
          return Ve = "useRef", vt(), l1();
        },
        useState: function(e) {
          Ve = "useState", vt();
          var n = wt.current;
          wt.current = Hc;
          try {
            return tx(e);
          } finally {
            wt.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return Ve = "useDebugValue", vt(), p1();
        },
        useDeferredValue: function(e) {
          return Ve = "useDeferredValue", vt(), kw(e);
        },
        useTransition: function() {
          return Ve = "useTransition", vt(), Uw();
        },
        useMutableSource: function(e, n, l) {
          return Ve = "useMutableSource", vt(), void 0;
        },
        useSyncExternalStore: function(e, n, l) {
          return Ve = "useSyncExternalStore", vt(), i1(e, n);
        },
        useId: function() {
          return Ve = "useId", vt(), m1();
        },
        unstable_isNewReconciler: he
      }, Zw = {
        readContext: function(e) {
          return Oi(e);
        },
        useCallback: function(e, n) {
          return Ve = "useCallback", vt(), h1(e, n);
        },
        useContext: function(e) {
          return Ve = "useContext", vt(), Oi(e);
        },
        useEffect: function(e, n) {
          return Ve = "useEffect", vt(), uy(e, n);
        },
        useImperativeHandle: function(e, n, l) {
          return Ve = "useImperativeHandle", vt(), d1(e, n, l);
        },
        useInsertionEffect: function(e, n) {
          return Ve = "useInsertionEffect", vt(), c1(e, n);
        },
        useLayoutEffect: function(e, n) {
          return Ve = "useLayoutEffect", vt(), f1(e, n);
        },
        useMemo: function(e, n) {
          Ve = "useMemo", vt();
          var l = wt.current;
          wt.current = b1;
          try {
            return v1(e, n);
          } finally {
            wt.current = l;
          }
        },
        useReducer: function(e, n, l) {
          Ve = "useReducer", vt();
          var f = wt.current;
          wt.current = b1;
          try {
            return qS(e, n, l);
          } finally {
            wt.current = f;
          }
        },
        useRef: function(e) {
          return Ve = "useRef", vt(), l1();
        },
        useState: function(e) {
          Ve = "useState", vt();
          var n = wt.current;
          wt.current = b1;
          try {
            return nx(e);
          } finally {
            wt.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return Ve = "useDebugValue", vt(), p1();
        },
        useDeferredValue: function(e) {
          return Ve = "useDeferredValue", vt(), Fw(e);
        },
        useTransition: function() {
          return Ve = "useTransition", vt(), Vw();
        },
        useMutableSource: function(e, n, l) {
          return Ve = "useMutableSource", vt(), void 0;
        },
        useSyncExternalStore: function(e, n, l) {
          return Ve = "useSyncExternalStore", vt(), i1(e, n);
        },
        useId: function() {
          return Ve = "useId", vt(), m1();
        },
        unstable_isNewReconciler: he
      }, Qf = {
        readContext: function(e) {
          return dx(), Oi(e);
        },
        useCallback: function(e, n) {
          return Ve = "useCallback", Cn(), _r(), lx(e, n);
        },
        useContext: function(e) {
          return Ve = "useContext", Cn(), _r(), Oi(e);
        },
        useEffect: function(e, n) {
          return Ve = "useEffect", Cn(), _r(), u1(e, n);
        },
        useImperativeHandle: function(e, n, l) {
          return Ve = "useImperativeHandle", Cn(), _r(), ox(e, n, l);
        },
        useInsertionEffect: function(e, n) {
          return Ve = "useInsertionEffect", Cn(), _r(), ax(e, n);
        },
        useLayoutEffect: function(e, n) {
          return Ve = "useLayoutEffect", Cn(), _r(), ix(e, n);
        },
        useMemo: function(e, n) {
          Ve = "useMemo", Cn(), _r();
          var l = wt.current;
          wt.current = Qf;
          try {
            return sx(e, n);
          } finally {
            wt.current = l;
          }
        },
        useReducer: function(e, n, l) {
          Ve = "useReducer", Cn(), _r();
          var f = wt.current;
          wt.current = Qf;
          try {
            return QS(e, n, l);
          } finally {
            wt.current = f;
          }
        },
        useRef: function(e) {
          return Ve = "useRef", Cn(), _r(), rx(e);
        },
        useState: function(e) {
          Ve = "useState", Cn(), _r();
          var n = wt.current;
          wt.current = Qf;
          try {
            return o1(e);
          } finally {
            wt.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return Ve = "useDebugValue", Cn(), _r(), void 0;
        },
        useDeferredValue: function(e) {
          return Ve = "useDeferredValue", Cn(), _r(), ux(e);
        },
        useTransition: function() {
          return Ve = "useTransition", Cn(), _r(), cx();
        },
        useMutableSource: function(e, n, l) {
          return Ve = "useMutableSource", Cn(), _r(), void 0;
        },
        useSyncExternalStore: function(e, n, l) {
          return Ve = "useSyncExternalStore", Cn(), _r(), ex(e, n, l);
        },
        useId: function() {
          return Ve = "useId", Cn(), _r(), fx();
        },
        unstable_isNewReconciler: he
      }, Hc = {
        readContext: function(e) {
          return dx(), Oi(e);
        },
        useCallback: function(e, n) {
          return Ve = "useCallback", Cn(), vt(), h1(e, n);
        },
        useContext: function(e) {
          return Ve = "useContext", Cn(), vt(), Oi(e);
        },
        useEffect: function(e, n) {
          return Ve = "useEffect", Cn(), vt(), uy(e, n);
        },
        useImperativeHandle: function(e, n, l) {
          return Ve = "useImperativeHandle", Cn(), vt(), d1(e, n, l);
        },
        useInsertionEffect: function(e, n) {
          return Ve = "useInsertionEffect", Cn(), vt(), c1(e, n);
        },
        useLayoutEffect: function(e, n) {
          return Ve = "useLayoutEffect", Cn(), vt(), f1(e, n);
        },
        useMemo: function(e, n) {
          Ve = "useMemo", Cn(), vt();
          var l = wt.current;
          wt.current = Hc;
          try {
            return v1(e, n);
          } finally {
            wt.current = l;
          }
        },
        useReducer: function(e, n, l) {
          Ve = "useReducer", Cn(), vt();
          var f = wt.current;
          wt.current = Hc;
          try {
            return KS(e, n, l);
          } finally {
            wt.current = f;
          }
        },
        useRef: function(e) {
          return Ve = "useRef", Cn(), vt(), l1();
        },
        useState: function(e) {
          Ve = "useState", Cn(), vt();
          var n = wt.current;
          wt.current = Hc;
          try {
            return tx(e);
          } finally {
            wt.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return Ve = "useDebugValue", Cn(), vt(), p1();
        },
        useDeferredValue: function(e) {
          return Ve = "useDeferredValue", Cn(), vt(), kw(e);
        },
        useTransition: function() {
          return Ve = "useTransition", Cn(), vt(), Uw();
        },
        useMutableSource: function(e, n, l) {
          return Ve = "useMutableSource", Cn(), vt(), void 0;
        },
        useSyncExternalStore: function(e, n, l) {
          return Ve = "useSyncExternalStore", Cn(), vt(), i1(e, n);
        },
        useId: function() {
          return Ve = "useId", Cn(), vt(), m1();
        },
        unstable_isNewReconciler: he
      }, b1 = {
        readContext: function(e) {
          return dx(), Oi(e);
        },
        useCallback: function(e, n) {
          return Ve = "useCallback", Cn(), vt(), h1(e, n);
        },
        useContext: function(e) {
          return Ve = "useContext", Cn(), vt(), Oi(e);
        },
        useEffect: function(e, n) {
          return Ve = "useEffect", Cn(), vt(), uy(e, n);
        },
        useImperativeHandle: function(e, n, l) {
          return Ve = "useImperativeHandle", Cn(), vt(), d1(e, n, l);
        },
        useInsertionEffect: function(e, n) {
          return Ve = "useInsertionEffect", Cn(), vt(), c1(e, n);
        },
        useLayoutEffect: function(e, n) {
          return Ve = "useLayoutEffect", Cn(), vt(), f1(e, n);
        },
        useMemo: function(e, n) {
          Ve = "useMemo", Cn(), vt();
          var l = wt.current;
          wt.current = Hc;
          try {
            return v1(e, n);
          } finally {
            wt.current = l;
          }
        },
        useReducer: function(e, n, l) {
          Ve = "useReducer", Cn(), vt();
          var f = wt.current;
          wt.current = Hc;
          try {
            return qS(e, n, l);
          } finally {
            wt.current = f;
          }
        },
        useRef: function(e) {
          return Ve = "useRef", Cn(), vt(), l1();
        },
        useState: function(e) {
          Ve = "useState", Cn(), vt();
          var n = wt.current;
          wt.current = Hc;
          try {
            return nx(e);
          } finally {
            wt.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return Ve = "useDebugValue", Cn(), vt(), p1();
        },
        useDeferredValue: function(e) {
          return Ve = "useDeferredValue", Cn(), vt(), Fw(e);
        },
        useTransition: function() {
          return Ve = "useTransition", Cn(), vt(), Vw();
        },
        useMutableSource: function(e, n, l) {
          return Ve = "useMutableSource", Cn(), vt(), void 0;
        },
        useSyncExternalStore: function(e, n, l) {
          return Ve = "useSyncExternalStore", Cn(), vt(), i1(e, n);
        },
        useId: function() {
          return Ve = "useId", Cn(), vt(), m1();
        },
        unstable_isNewReconciler: he
      };
    }
    var Bh = r.unstable_now, Jw = 0, y1 = -1, cy = -1, C1 = -1, px = !1, E1 = !1;
    function Qw() {
      return px;
    }
    function ML() {
      E1 = !0;
    }
    function PL() {
      px = !1, E1 = !1;
    }
    function kL() {
      px = E1, E1 = !1;
    }
    function Kw() {
      return Jw;
    }
    function qw() {
      Jw = Bh();
    }
    function hx(e) {
      cy = Bh(), e.actualStartTime < 0 && (e.actualStartTime = Bh());
    }
    function eI(e) {
      cy = -1;
    }
    function S1(e, n) {
      if (cy >= 0) {
        var l = Bh() - cy;
        e.actualDuration += l, n && (e.selfBaseDuration = l), cy = -1;
      }
    }
    function Kf(e) {
      if (y1 >= 0) {
        var n = Bh() - y1;
        y1 = -1;
        for (var l = e.return; l !== null; ) {
          switch (l.tag) {
            case T:
              var f = l.stateNode;
              f.effectDuration += n;
              return;
            case Q:
              var m = l.stateNode;
              m.effectDuration += n;
              return;
          }
          l = l.return;
        }
      }
    }
    function vx(e) {
      if (C1 >= 0) {
        var n = Bh() - C1;
        C1 = -1;
        for (var l = e.return; l !== null; ) {
          switch (l.tag) {
            case T:
              var f = l.stateNode;
              f !== null && (f.passiveEffectDuration += n);
              return;
            case Q:
              var m = l.stateNode;
              m !== null && (m.passiveEffectDuration += n);
              return;
          }
          l = l.return;
        }
      }
    }
    function qf() {
      y1 = Bh();
    }
    function mx() {
      C1 = Bh();
    }
    function gx(e) {
      for (var n = e.child; n; )
        e.actualDuration += n.actualDuration, n = n.sibling;
    }
    function jc(e, n) {
      if (e && e.defaultProps) {
        var l = on({}, n), f = e.defaultProps;
        for (var m in f)
          l[m] === void 0 && (l[m] = f[m]);
        return l;
      }
      return n;
    }
    var bx = {}, yx, Cx, Ex, Sx, xx, tI, x1, Rx, Tx, wx, fy;
    {
      yx = /* @__PURE__ */ new Set(), Cx = /* @__PURE__ */ new Set(), Ex = /* @__PURE__ */ new Set(), Sx = /* @__PURE__ */ new Set(), Rx = /* @__PURE__ */ new Set(), xx = /* @__PURE__ */ new Set(), Tx = /* @__PURE__ */ new Set(), wx = /* @__PURE__ */ new Set(), fy = /* @__PURE__ */ new Set();
      var nI = /* @__PURE__ */ new Set();
      x1 = function(e, n) {
        if (!(e === null || typeof e == "function")) {
          var l = n + "_" + e;
          nI.has(l) || (nI.add(l), h("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", n, e));
        }
      }, tI = function(e, n) {
        if (n === void 0) {
          var l = Un(e) || "Component";
          xx.has(l) || (xx.add(l), h("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", l));
        }
      }, Object.defineProperty(bx, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(bx);
    }
    function Ix(e, n, l, f) {
      var m = e.memoizedState, E = l(f, m);
      {
        if (e.mode & _n) {
          Fa(!0);
          try {
            E = l(f, m);
          } finally {
            Fa(!1);
          }
        }
        tI(n, E);
      }
      var w = E == null ? m : on({}, m, E);
      if (e.memoizedState = w, e.lanes === je) {
        var O = e.updateQueue;
        O.baseState = w;
      }
    }
    var Ax = {
      isMounted: Ti,
      enqueueSetState: function(e, n, l) {
        var f = Bi(e), m = Fl(), E = jh(f), w = hp(m, E);
        w.payload = n, l != null && (x1(l, "setState"), w.callback = l);
        var O = Mh(f, w, E);
        O !== null && (no(O, f, E, m), K0(O, f, E)), Pd(f, E);
      },
      enqueueReplaceState: function(e, n, l) {
        var f = Bi(e), m = Fl(), E = jh(f), w = hp(m, E);
        w.tag = yw, w.payload = n, l != null && (x1(l, "replaceState"), w.callback = l);
        var O = Mh(f, w, E);
        O !== null && (no(O, f, E, m), K0(O, f, E)), Pd(f, E);
      },
      enqueueForceUpdate: function(e, n) {
        var l = Bi(e), f = Fl(), m = jh(l), E = hp(f, m);
        E.tag = Z0, n != null && (x1(n, "forceUpdate"), E.callback = n);
        var w = Mh(l, E, m);
        w !== null && (no(w, l, m, f), K0(w, l, m)), Md(l, m);
      }
    };
    function rI(e, n, l, f, m, E, w) {
      var O = e.stateNode;
      if (typeof O.shouldComponentUpdate == "function") {
        var D = O.shouldComponentUpdate(f, E, w);
        {
          if (e.mode & _n) {
            Fa(!0);
            try {
              D = O.shouldComponentUpdate(f, E, w);
            } finally {
              Fa(!1);
            }
          }
          D === void 0 && h("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Un(n) || "Component");
        }
        return D;
      }
      return n.prototype && n.prototype.isPureReactComponent ? !Qt(l, f) || !Qt(m, E) : !0;
    }
    function FL(e, n, l) {
      var f = e.stateNode;
      {
        var m = Un(n) || "Component", E = f.render;
        E || (n.prototype && typeof n.prototype.render == "function" ? h("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", m) : h("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", m)), f.getInitialState && !f.getInitialState.isReactClassApproved && !f.state && h("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", m), f.getDefaultProps && !f.getDefaultProps.isReactClassApproved && h("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", m), f.propTypes && h("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", m), f.contextType && h("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", m), n.childContextTypes && !fy.has(n) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & _n) === Ft && (fy.add(n), h(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, m)), n.contextTypes && !fy.has(n) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & _n) === Ft && (fy.add(n), h(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, m)), f.contextTypes && h("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", m), n.contextType && n.contextTypes && !Tx.has(n) && (Tx.add(n), h("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", m)), typeof f.componentShouldUpdate == "function" && h("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", m), n.prototype && n.prototype.isPureReactComponent && typeof f.shouldComponentUpdate < "u" && h("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Un(n) || "A pure component"), typeof f.componentDidUnmount == "function" && h("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", m), typeof f.componentDidReceiveProps == "function" && h("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", m), typeof f.componentWillRecieveProps == "function" && h("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", m), typeof f.UNSAFE_componentWillRecieveProps == "function" && h("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", m);
        var w = f.props !== l;
        f.props !== void 0 && w && h("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", m, m), f.defaultProps && h("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", m, m), typeof f.getSnapshotBeforeUpdate == "function" && typeof f.componentDidUpdate != "function" && !Ex.has(n) && (Ex.add(n), h("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Un(n))), typeof f.getDerivedStateFromProps == "function" && h("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", m), typeof f.getDerivedStateFromError == "function" && h("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", m), typeof n.getSnapshotBeforeUpdate == "function" && h("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", m);
        var O = f.state;
        O && (typeof O != "object" || Hn(O)) && h("%s.state: must be set to an object or null", m), typeof f.getChildContext == "function" && typeof n.childContextTypes != "object" && h("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", m);
      }
    }
    function aI(e, n) {
      n.updater = Ax, e.stateNode = n, Rn(n, e), n._reactInternalInstance = bx;
    }
    function iI(e, n, l) {
      var f = !1, m = Ys, E = Ys, w = n.contextType;
      if ("contextType" in n) {
        var O = (
          // Allow null for conditional declaration
          w === null || w !== void 0 && w.$$typeof === ve && w._context === void 0
        );
        if (!O && !wx.has(n)) {
          wx.add(n);
          var D = "";
          w === void 0 ? D = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof w != "object" ? D = " However, it is set to a " + typeof w + "." : w.$$typeof === J ? D = " Did you accidentally pass the Context.Provider instead?" : w._context !== void 0 ? D = " Did you accidentally pass the Context.Consumer instead?" : D = " However, it is set to an object with keys {" + Object.keys(w).join(", ") + "}.", h("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Un(n) || "Component", D);
        }
      }
      if (typeof w == "object" && w !== null)
        E = Oi(w);
      else {
        m = fg(e, n, !0);
        var X = n.contextTypes;
        f = X != null, E = f ? dg(e, m) : Ys;
      }
      var Z = new n(l, E);
      if (e.mode & _n) {
        Fa(!0);
        try {
          Z = new n(l, E);
        } finally {
          Fa(!1);
        }
      }
      var ue = e.memoizedState = Z.state !== null && Z.state !== void 0 ? Z.state : null;
      aI(e, Z);
      {
        if (typeof n.getDerivedStateFromProps == "function" && ue === null) {
          var se = Un(n) || "Component";
          Cx.has(se) || (Cx.add(se), h("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", se, Z.state === null ? "null" : "undefined", se));
        }
        if (typeof n.getDerivedStateFromProps == "function" || typeof Z.getSnapshotBeforeUpdate == "function") {
          var Ie = null, Ae = null, Me = null;
          if (typeof Z.componentWillMount == "function" && Z.componentWillMount.__suppressDeprecationWarning !== !0 ? Ie = "componentWillMount" : typeof Z.UNSAFE_componentWillMount == "function" && (Ie = "UNSAFE_componentWillMount"), typeof Z.componentWillReceiveProps == "function" && Z.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Ae = "componentWillReceiveProps" : typeof Z.UNSAFE_componentWillReceiveProps == "function" && (Ae = "UNSAFE_componentWillReceiveProps"), typeof Z.componentWillUpdate == "function" && Z.componentWillUpdate.__suppressDeprecationWarning !== !0 ? Me = "componentWillUpdate" : typeof Z.UNSAFE_componentWillUpdate == "function" && (Me = "UNSAFE_componentWillUpdate"), Ie !== null || Ae !== null || Me !== null) {
            var gt = Un(n) || "Component", Kt = typeof n.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Sx.has(gt) || (Sx.add(gt), h(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, gt, Kt, Ie !== null ? `
  ` + Ie : "", Ae !== null ? `
  ` + Ae : "", Me !== null ? `
  ` + Me : ""));
          }
        }
      }
      return f && $2(e, m, E), Z;
    }
    function BL(e, n) {
      var l = n.state;
      typeof n.componentWillMount == "function" && n.componentWillMount(), typeof n.UNSAFE_componentWillMount == "function" && n.UNSAFE_componentWillMount(), l !== n.state && (h("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", dn(e) || "Component"), Ax.enqueueReplaceState(n, n.state, null));
    }
    function oI(e, n, l, f) {
      var m = n.state;
      if (typeof n.componentWillReceiveProps == "function" && n.componentWillReceiveProps(l, f), typeof n.UNSAFE_componentWillReceiveProps == "function" && n.UNSAFE_componentWillReceiveProps(l, f), n.state !== m) {
        {
          var E = dn(e) || "Component";
          yx.has(E) || (yx.add(E), h("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", E));
        }
        Ax.enqueueReplaceState(n, n.state, null);
      }
    }
    function Nx(e, n, l, f) {
      FL(e, n, l);
      var m = e.stateNode;
      m.props = l, m.state = e.memoizedState, m.refs = {}, BS(e);
      var E = n.contextType;
      if (typeof E == "object" && E !== null)
        m.context = Oi(E);
      else {
        var w = fg(e, n, !0);
        m.context = dg(e, w);
      }
      {
        if (m.state === l) {
          var O = Un(n) || "Component";
          Rx.has(O) || (Rx.add(O), h("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", O));
        }
        e.mode & _n && Uc.recordLegacyContextWarning(e, m), Uc.recordUnsafeLifecycleWarnings(e, m);
      }
      m.state = e.memoizedState;
      var D = n.getDerivedStateFromProps;
      if (typeof D == "function" && (Ix(e, n, D, l), m.state = e.memoizedState), typeof n.getDerivedStateFromProps != "function" && typeof m.getSnapshotBeforeUpdate != "function" && (typeof m.UNSAFE_componentWillMount == "function" || typeof m.componentWillMount == "function") && (BL(e, m), q0(e, l, m, f), m.state = e.memoizedState), typeof m.componentDidMount == "function") {
        var X = ln;
        X |= co, (e.mode & Hi) !== Ft && (X |= ta), e.flags |= X;
      }
    }
    function UL(e, n, l, f) {
      var m = e.stateNode, E = e.memoizedProps;
      m.props = E;
      var w = m.context, O = n.contextType, D = Ys;
      if (typeof O == "object" && O !== null)
        D = Oi(O);
      else {
        var X = fg(e, n, !0);
        D = dg(e, X);
      }
      var Z = n.getDerivedStateFromProps, ue = typeof Z == "function" || typeof m.getSnapshotBeforeUpdate == "function";
      !ue && (typeof m.UNSAFE_componentWillReceiveProps == "function" || typeof m.componentWillReceiveProps == "function") && (E !== l || w !== D) && oI(e, m, l, D), Ew();
      var se = e.memoizedState, Ie = m.state = se;
      if (q0(e, l, m, f), Ie = e.memoizedState, E === l && se === Ie && !M0() && !e1()) {
        if (typeof m.componentDidMount == "function") {
          var Ae = ln;
          Ae |= co, (e.mode & Hi) !== Ft && (Ae |= ta), e.flags |= Ae;
        }
        return !1;
      }
      typeof Z == "function" && (Ix(e, n, Z, l), Ie = e.memoizedState);
      var Me = e1() || rI(e, n, E, l, se, Ie, D);
      if (Me) {
        if (!ue && (typeof m.UNSAFE_componentWillMount == "function" || typeof m.componentWillMount == "function") && (typeof m.componentWillMount == "function" && m.componentWillMount(), typeof m.UNSAFE_componentWillMount == "function" && m.UNSAFE_componentWillMount()), typeof m.componentDidMount == "function") {
          var gt = ln;
          gt |= co, (e.mode & Hi) !== Ft && (gt |= ta), e.flags |= gt;
        }
      } else {
        if (typeof m.componentDidMount == "function") {
          var Kt = ln;
          Kt |= co, (e.mode & Hi) !== Ft && (Kt |= ta), e.flags |= Kt;
        }
        e.memoizedProps = l, e.memoizedState = Ie;
      }
      return m.props = l, m.state = Ie, m.context = D, Me;
    }
    function VL(e, n, l, f, m) {
      var E = n.stateNode;
      Cw(e, n);
      var w = n.memoizedProps, O = n.type === n.elementType ? w : jc(n.type, w);
      E.props = O;
      var D = n.pendingProps, X = E.context, Z = l.contextType, ue = Ys;
      if (typeof Z == "object" && Z !== null)
        ue = Oi(Z);
      else {
        var se = fg(n, l, !0);
        ue = dg(n, se);
      }
      var Ie = l.getDerivedStateFromProps, Ae = typeof Ie == "function" || typeof E.getSnapshotBeforeUpdate == "function";
      !Ae && (typeof E.UNSAFE_componentWillReceiveProps == "function" || typeof E.componentWillReceiveProps == "function") && (w !== D || X !== ue) && oI(n, E, f, ue), Ew();
      var Me = n.memoizedState, gt = E.state = Me;
      if (q0(n, f, E, m), gt = n.memoizedState, w === D && Me === gt && !M0() && !e1() && !ke)
        return typeof E.componentDidUpdate == "function" && (w !== e.memoizedProps || Me !== e.memoizedState) && (n.flags |= ln), typeof E.getSnapshotBeforeUpdate == "function" && (w !== e.memoizedProps || Me !== e.memoizedState) && (n.flags |= tl), !1;
      typeof Ie == "function" && (Ix(n, l, Ie, f), gt = n.memoizedState);
      var Kt = e1() || rI(n, l, O, f, Me, gt, ue) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      ke;
      return Kt ? (!Ae && (typeof E.UNSAFE_componentWillUpdate == "function" || typeof E.componentWillUpdate == "function") && (typeof E.componentWillUpdate == "function" && E.componentWillUpdate(f, gt, ue), typeof E.UNSAFE_componentWillUpdate == "function" && E.UNSAFE_componentWillUpdate(f, gt, ue)), typeof E.componentDidUpdate == "function" && (n.flags |= ln), typeof E.getSnapshotBeforeUpdate == "function" && (n.flags |= tl)) : (typeof E.componentDidUpdate == "function" && (w !== e.memoizedProps || Me !== e.memoizedState) && (n.flags |= ln), typeof E.getSnapshotBeforeUpdate == "function" && (w !== e.memoizedProps || Me !== e.memoizedState) && (n.flags |= tl), n.memoizedProps = f, n.memoizedState = gt), E.props = f, E.state = gt, E.context = ue, Kt;
    }
    function tm(e, n) {
      return {
        value: e,
        source: n,
        stack: Rl(n),
        digest: null
      };
    }
    function _x(e, n, l) {
      return {
        value: e,
        source: null,
        stack: l ?? null,
        digest: n ?? null
      };
    }
    function HL(e, n) {
      return !0;
    }
    function Ox(e, n) {
      try {
        var l = HL(e, n);
        if (l === !1)
          return;
        var f = n.value, m = n.source, E = n.stack, w = E !== null ? E : "";
        if (f != null && f._suppressLogging) {
          if (e.tag === S)
            return;
          console.error(f);
        }
        var O = m ? dn(m) : null, D = O ? "The above error occurred in the <" + O + "> component:" : "The above error occurred in one of your React components:", X;
        if (e.tag === T)
          X = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var Z = dn(e) || "Anonymous";
          X = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + Z + ".");
        }
        var ue = D + `
` + w + `

` + ("" + X);
        console.error(ue);
      } catch (se) {
        setTimeout(function() {
          throw se;
        });
      }
    }
    var jL = typeof WeakMap == "function" ? WeakMap : Map;
    function lI(e, n, l) {
      var f = hp(Rr, l);
      f.tag = kS, f.payload = {
        element: null
      };
      var m = n.value;
      return f.callback = function() {
        M3(m), Ox(e, n);
      }, f;
    }
    function Lx(e, n, l) {
      var f = hp(Rr, l);
      f.tag = kS;
      var m = e.type.getDerivedStateFromError;
      if (typeof m == "function") {
        var E = n.value;
        f.payload = function() {
          return m(E);
        }, f.callback = function() {
          bA(e), Ox(e, n);
        };
      }
      var w = e.stateNode;
      return w !== null && typeof w.componentDidCatch == "function" && (f.callback = function() {
        bA(e), Ox(e, n), typeof m != "function" && L3(this);
        var D = n.value, X = n.stack;
        this.componentDidCatch(D, {
          componentStack: X !== null ? X : ""
        }), typeof m != "function" && (Wi(e.lanes, Ht) || h("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", dn(e) || "Unknown"));
      }), f;
    }
    function sI(e, n, l) {
      var f = e.pingCache, m;
      if (f === null ? (f = e.pingCache = new jL(), m = /* @__PURE__ */ new Set(), f.set(n, m)) : (m = f.get(n), m === void 0 && (m = /* @__PURE__ */ new Set(), f.set(n, m))), !m.has(l)) {
        m.add(l);
        var E = P3.bind(null, e, n, l);
        za && Ay(e, l), n.then(E, E);
      }
    }
    function GL(e, n, l, f) {
      var m = e.updateQueue;
      if (m === null) {
        var E = /* @__PURE__ */ new Set();
        E.add(l), e.updateQueue = E;
      } else
        m.add(l);
    }
    function zL(e, n) {
      var l = e.tag;
      if ((e.mode & Ut) === Ft && (l === g || l === G || l === j)) {
        var f = e.alternate;
        f ? (e.updateQueue = f.updateQueue, e.memoizedState = f.memoizedState, e.lanes = f.lanes) : (e.updateQueue = null, e.memoizedState = null);
      }
    }
    function uI(e) {
      var n = e;
      do {
        if (n.tag === W && RL(n))
          return n;
        n = n.return;
      } while (n !== null);
      return null;
    }
    function cI(e, n, l, f, m) {
      if ((e.mode & Ut) === Ft) {
        if (e === n)
          e.flags |= ai;
        else {
          if (e.flags |= un, l.flags |= Ad, l.flags &= ~(rl | No), l.tag === S) {
            var E = l.alternate;
            if (E === null)
              l.tag = me;
            else {
              var w = hp(Rr, Ht);
              w.tag = Z0, Mh(l, w, Ht);
            }
          }
          l.lanes = yn(l.lanes, Ht);
        }
        return e;
      }
      return e.flags |= ai, e.lanes = m, e;
    }
    function WL(e, n, l, f, m) {
      if (l.flags |= No, za && Ay(e, m), f !== null && typeof f == "object" && typeof f.then == "function") {
        var E = f;
        zL(l), Po() && l.mode & Ut && tw();
        var w = uI(n);
        if (w !== null) {
          w.flags &= ~pa, cI(w, n, l, e, m), w.mode & Ut && sI(e, E, m), GL(w, e, E);
          return;
        } else {
          if (!nh(m)) {
            sI(e, E, m), fR();
            return;
          }
          var O = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          f = O;
        }
      } else if (Po() && l.mode & Ut) {
        tw();
        var D = uI(n);
        if (D !== null) {
          (D.flags & ai) === zt && (D.flags |= pa), cI(D, n, l, e, m), RS(tm(f, l));
          return;
        }
      }
      f = tm(f, l), R3(f);
      var X = n;
      do {
        switch (X.tag) {
          case T: {
            var Z = f;
            X.flags |= ai;
            var ue = _f(m);
            X.lanes = yn(X.lanes, ue);
            var se = lI(X, Z, ue);
            US(X, se);
            return;
          }
          case S:
            var Ie = f, Ae = X.type, Me = X.stateNode;
            if ((X.flags & un) === zt && (typeof Ae.getDerivedStateFromError == "function" || Me !== null && typeof Me.componentDidCatch == "function" && !uA(Me))) {
              X.flags |= ai;
              var gt = _f(m);
              X.lanes = yn(X.lanes, gt);
              var Kt = Lx(X, Ie, gt);
              US(X, Kt);
              return;
            }
            break;
        }
        X = X.return;
      } while (X !== null);
    }
    function XL() {
      return null;
    }
    var dy = i.ReactCurrentOwner, Gc = !1, Dx, py, Mx, Px, kx, nm, Fx, R1, hy;
    Dx = {}, py = {}, Mx = {}, Px = {}, kx = {}, nm = !1, Fx = {}, R1 = {}, hy = {};
    function Pl(e, n, l, f) {
      e === null ? n.child = pw(n, null, l, f) : n.child = mg(n, e.child, l, f);
    }
    function YL(e, n, l, f) {
      n.child = mg(n, e.child, null, f), n.child = mg(n, null, l, f);
    }
    function fI(e, n, l, f, m) {
      if (n.type !== n.elementType) {
        var E = l.propTypes;
        E && sa(
          E,
          f,
          // Resolved props
          "prop",
          Un(l)
        );
      }
      var w = l.render, O = n.ref, D, X;
      bg(n, m), Cf(n);
      {
        if (dy.current = n, lo(!0), D = Rg(e, n, w, f, O, m), X = Tg(), n.mode & _n) {
          Fa(!0);
          try {
            D = Rg(e, n, w, f, O, m), X = Tg();
          } finally {
            Fa(!1);
          }
        }
        lo(!1);
      }
      return ho(), e !== null && !Gc ? (Iw(e, n, m), vp(e, n, m)) : (Po() && X && bS(n), n.flags |= mu, Pl(e, n, D, m), n.child);
    }
    function dI(e, n, l, f, m) {
      if (e === null) {
        var E = l.type;
        if (K3(E) && l.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        l.defaultProps === void 0) {
          var w = E;
          return w = Dg(E), n.tag = j, n.type = w, Vx(n, E), pI(e, n, w, f, m);
        }
        {
          var O = E.propTypes;
          if (O && sa(
            O,
            f,
            // Resolved props
            "prop",
            Un(E)
          ), l.defaultProps !== void 0) {
            var D = Un(E) || "Unknown";
            hy[D] || (h("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", D), hy[D] = !0);
          }
        }
        var X = SR(l.type, null, f, n, n.mode, m);
        return X.ref = n.ref, X.return = n, n.child = X, X;
      }
      {
        var Z = l.type, ue = Z.propTypes;
        ue && sa(
          ue,
          f,
          // Resolved props
          "prop",
          Un(Z)
        );
      }
      var se = e.child, Ie = Xx(e, m);
      if (!Ie) {
        var Ae = se.memoizedProps, Me = l.compare;
        if (Me = Me !== null ? Me : Qt, Me(Ae, f) && e.ref === n.ref)
          return vp(e, n, m);
      }
      n.flags |= mu;
      var gt = lm(se, f);
      return gt.ref = n.ref, gt.return = n, n.child = gt, gt;
    }
    function pI(e, n, l, f, m) {
      if (n.type !== n.elementType) {
        var E = n.elementType;
        if (E.$$typeof === Et) {
          var w = E, O = w._payload, D = w._init;
          try {
            E = D(O);
          } catch {
            E = null;
          }
          var X = E && E.propTypes;
          X && sa(
            X,
            f,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Un(E)
          );
        }
      }
      if (e !== null) {
        var Z = e.memoizedProps;
        if (Qt(Z, f) && e.ref === n.ref && // Prevent bailout if the implementation changed due to hot reload.
        n.type === e.type)
          if (Gc = !1, n.pendingProps = f = Z, Xx(e, m))
            (e.flags & Ad) !== zt && (Gc = !0);
          else
            return n.lanes = e.lanes, vp(e, n, m);
      }
      return Bx(e, n, l, f, m);
    }
    function hI(e, n, l) {
      var f = n.pendingProps, m = f.children, E = e !== null ? e.memoizedState : null;
      if (f.mode === "hidden" || _e)
        if ((n.mode & Ut) === Ft) {
          var w = {
            baseLanes: je,
            cachePool: null,
            transitions: null
          };
          n.memoizedState = w, F1(n, l);
        } else if (Wi(l, Ai)) {
          var ue = {
            baseLanes: je,
            cachePool: null,
            transitions: null
          };
          n.memoizedState = ue;
          var se = E !== null ? E.baseLanes : l;
          F1(n, se);
        } else {
          var O = null, D;
          if (E !== null) {
            var X = E.baseLanes;
            D = yn(X, l);
          } else
            D = l;
          n.lanes = n.childLanes = Ai;
          var Z = {
            baseLanes: D,
            cachePool: O,
            transitions: null
          };
          return n.memoizedState = Z, n.updateQueue = null, F1(n, D), null;
        }
      else {
        var Ie;
        E !== null ? (Ie = yn(E.baseLanes, l), n.memoizedState = null) : Ie = l, F1(n, Ie);
      }
      return Pl(e, n, m, l), n.child;
    }
    function $L(e, n, l) {
      var f = n.pendingProps;
      return Pl(e, n, f, l), n.child;
    }
    function ZL(e, n, l) {
      var f = n.pendingProps.children;
      return Pl(e, n, f, l), n.child;
    }
    function JL(e, n, l) {
      {
        n.flags |= ln;
        {
          var f = n.stateNode;
          f.effectDuration = 0, f.passiveEffectDuration = 0;
        }
      }
      var m = n.pendingProps, E = m.children;
      return Pl(e, n, E, l), n.child;
    }
    function vI(e, n) {
      var l = n.ref;
      (e === null && l !== null || e !== null && e.ref !== l) && (n.flags |= ha, n.flags |= Ds);
    }
    function Bx(e, n, l, f, m) {
      if (n.type !== n.elementType) {
        var E = l.propTypes;
        E && sa(
          E,
          f,
          // Resolved props
          "prop",
          Un(l)
        );
      }
      var w;
      {
        var O = fg(n, l, !0);
        w = dg(n, O);
      }
      var D, X;
      bg(n, m), Cf(n);
      {
        if (dy.current = n, lo(!0), D = Rg(e, n, l, f, w, m), X = Tg(), n.mode & _n) {
          Fa(!0);
          try {
            D = Rg(e, n, l, f, w, m), X = Tg();
          } finally {
            Fa(!1);
          }
        }
        lo(!1);
      }
      return ho(), e !== null && !Gc ? (Iw(e, n, m), vp(e, n, m)) : (Po() && X && bS(n), n.flags |= mu, Pl(e, n, D, m), n.child);
    }
    function mI(e, n, l, f, m) {
      {
        switch (p5(n)) {
          case !1: {
            var E = n.stateNode, w = n.type, O = new w(n.memoizedProps, E.context), D = O.state;
            E.updater.enqueueSetState(E, D, null);
            break;
          }
          case !0: {
            n.flags |= un, n.flags |= ai;
            var X = new Error("Simulated error coming from DevTools"), Z = _f(m);
            n.lanes = yn(n.lanes, Z);
            var ue = Lx(n, tm(X, n), Z);
            US(n, ue);
            break;
          }
        }
        if (n.type !== n.elementType) {
          var se = l.propTypes;
          se && sa(
            se,
            f,
            // Resolved props
            "prop",
            Un(l)
          );
        }
      }
      var Ie;
      $f(l) ? (Ie = !0, k0(n)) : Ie = !1, bg(n, m);
      var Ae = n.stateNode, Me;
      Ae === null ? (w1(e, n), iI(n, l, f), Nx(n, l, f, m), Me = !0) : e === null ? Me = UL(n, l, f, m) : Me = VL(e, n, l, f, m);
      var gt = Ux(e, n, l, Me, Ie, m);
      {
        var Kt = n.stateNode;
        Me && Kt.props !== f && (nm || h("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", dn(n) || "a component"), nm = !0);
      }
      return gt;
    }
    function Ux(e, n, l, f, m, E) {
      vI(e, n);
      var w = (n.flags & un) !== zt;
      if (!f && !w)
        return m && Q2(n, l, !1), vp(e, n, E);
      var O = n.stateNode;
      dy.current = n;
      var D;
      if (w && typeof l.getDerivedStateFromError != "function")
        D = null, eI();
      else {
        Cf(n);
        {
          if (lo(!0), D = O.render(), n.mode & _n) {
            Fa(!0);
            try {
              O.render();
            } finally {
              Fa(!1);
            }
          }
          lo(!1);
        }
        ho();
      }
      return n.flags |= mu, e !== null && w ? YL(e, n, D, E) : Pl(e, n, D, E), n.memoizedState = O.state, m && Q2(n, l, !0), n.child;
    }
    function gI(e) {
      var n = e.stateNode;
      n.pendingContext ? Z2(e, n.pendingContext, n.pendingContext !== n.context) : n.context && Z2(e, n.context, !1), VS(e, n.containerInfo);
    }
    function QL(e, n, l) {
      if (gI(n), e === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var f = n.pendingProps, m = n.memoizedState, E = m.element;
      Cw(e, n), q0(n, f, null, l);
      var w = n.memoizedState;
      n.stateNode;
      var O = w.element;
      if (m.isDehydrated) {
        var D = {
          element: O,
          isDehydrated: !1,
          cache: w.cache,
          pendingSuspenseBoundaries: w.pendingSuspenseBoundaries,
          transitions: w.transitions
        }, X = n.updateQueue;
        if (X.baseState = D, n.memoizedState = D, n.flags & pa) {
          var Z = tm(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), n);
          return bI(e, n, O, l, Z);
        } else if (O !== E) {
          var ue = tm(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), n);
          return bI(e, n, O, l, ue);
        } else {
          eL(n);
          var se = pw(n, null, O, l);
          n.child = se;
          for (var Ie = se; Ie; )
            Ie.flags = Ie.flags & ~Xr | nl, Ie = Ie.sibling;
        }
      } else {
        if (vg(), O === E)
          return vp(e, n, l);
        Pl(e, n, O, l);
      }
      return n.child;
    }
    function bI(e, n, l, f, m) {
      return vg(), RS(m), n.flags |= pa, Pl(e, n, l, f), n.child;
    }
    function KL(e, n, l) {
      Rw(n), e === null && xS(n);
      var f = n.type, m = n.pendingProps, E = e !== null ? e.memoizedProps : null, w = m.children, O = Pb(f, m);
      return O ? w = null : E !== null && Pb(f, E) && (n.flags |= yr), vI(e, n), Pl(e, n, w, l), n.child;
    }
    function qL(e, n) {
      return e === null && xS(n), null;
    }
    function eD(e, n, l, f) {
      w1(e, n);
      var m = n.pendingProps, E = l, w = E._payload, O = E._init, D = O(w);
      n.type = D;
      var X = n.tag = q3(D), Z = jc(D, m), ue;
      switch (X) {
        case g:
          return Vx(n, D), n.type = D = Dg(D), ue = Bx(null, n, D, Z, f), ue;
        case S:
          return n.type = D = mR(D), ue = mI(null, n, D, Z, f), ue;
        case G:
          return n.type = D = gR(D), ue = fI(null, n, D, Z, f), ue;
        case oe: {
          if (n.type !== n.elementType) {
            var se = D.propTypes;
            se && sa(
              se,
              Z,
              // Resolved for outer only
              "prop",
              Un(D)
            );
          }
          return ue = dI(
            null,
            n,
            D,
            jc(D.type, Z),
            // The inner type can have defaults too
            f
          ), ue;
        }
      }
      var Ie = "";
      throw D !== null && typeof D == "object" && D.$$typeof === Et && (Ie = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + D + ". " + ("Lazy element type must resolve to a class or function." + Ie));
    }
    function tD(e, n, l, f, m) {
      w1(e, n), n.tag = S;
      var E;
      return $f(l) ? (E = !0, k0(n)) : E = !1, bg(n, m), iI(n, l, f), Nx(n, l, f, m), Ux(null, n, l, !0, E, m);
    }
    function nD(e, n, l, f) {
      w1(e, n);
      var m = n.pendingProps, E;
      {
        var w = fg(n, l, !1);
        E = dg(n, w);
      }
      bg(n, f);
      var O, D;
      Cf(n);
      {
        if (l.prototype && typeof l.prototype.render == "function") {
          var X = Un(l) || "Unknown";
          Dx[X] || (h("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", X, X), Dx[X] = !0);
        }
        n.mode & _n && Uc.recordLegacyContextWarning(n, null), lo(!0), dy.current = n, O = Rg(null, n, l, m, E, f), D = Tg(), lo(!1);
      }
      if (ho(), n.flags |= mu, typeof O == "object" && O !== null && typeof O.render == "function" && O.$$typeof === void 0) {
        var Z = Un(l) || "Unknown";
        py[Z] || (h("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Z, Z, Z), py[Z] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof O == "object" && O !== null && typeof O.render == "function" && O.$$typeof === void 0
      ) {
        {
          var ue = Un(l) || "Unknown";
          py[ue] || (h("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ue, ue, ue), py[ue] = !0);
        }
        n.tag = S, n.memoizedState = null, n.updateQueue = null;
        var se = !1;
        return $f(l) ? (se = !0, k0(n)) : se = !1, n.memoizedState = O.state !== null && O.state !== void 0 ? O.state : null, BS(n), aI(n, O), Nx(n, l, m, f), Ux(null, n, l, !0, se, f);
      } else {
        if (n.tag = g, n.mode & _n) {
          Fa(!0);
          try {
            O = Rg(null, n, l, m, E, f), D = Tg();
          } finally {
            Fa(!1);
          }
        }
        return Po() && D && bS(n), Pl(null, n, O, f), Vx(n, l), n.child;
      }
    }
    function Vx(e, n) {
      {
        if (n && n.childContextTypes && h("%s(...): childContextTypes cannot be defined on a function component.", n.displayName || n.name || "Component"), e.ref !== null) {
          var l = "", f = Fi();
          f && (l += `

Check the render method of \`` + f + "`.");
          var m = f || "", E = e._debugSource;
          E && (m = E.fileName + ":" + E.lineNumber), kx[m] || (kx[m] = !0, h("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", l));
        }
        if (n.defaultProps !== void 0) {
          var w = Un(n) || "Unknown";
          hy[w] || (h("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", w), hy[w] = !0);
        }
        if (typeof n.getDerivedStateFromProps == "function") {
          var O = Un(n) || "Unknown";
          Px[O] || (h("%s: Function components do not support getDerivedStateFromProps.", O), Px[O] = !0);
        }
        if (typeof n.contextType == "object" && n.contextType !== null) {
          var D = Un(n) || "Unknown";
          Mx[D] || (h("%s: Function components do not support contextType.", D), Mx[D] = !0);
        }
      }
    }
    var Hx = {
      dehydrated: null,
      treeContext: null,
      retryLane: Ia
    };
    function jx(e) {
      return {
        baseLanes: e,
        cachePool: XL(),
        transitions: null
      };
    }
    function rD(e, n) {
      var l = null;
      return {
        baseLanes: yn(e.baseLanes, n),
        cachePool: l,
        transitions: e.transitions
      };
    }
    function aD(e, n, l, f) {
      if (n !== null) {
        var m = n.memoizedState;
        if (m === null)
          return !1;
      }
      return GS(e, ry);
    }
    function iD(e, n) {
      return Of(e.childLanes, n);
    }
    function yI(e, n, l) {
      var f = n.pendingProps;
      h5(n) && (n.flags |= un);
      var m = Vc.current, E = !1, w = (n.flags & un) !== zt;
      if (w || aD(m, e) ? (E = !0, n.flags &= ~un) : (e === null || e.memoizedState !== null) && (m = xL(m, ww)), m = Cg(m), kh(n, m), e === null) {
        xS(n);
        var O = n.memoizedState;
        if (O !== null) {
          var D = O.dehydrated;
          if (D !== null)
            return cD(n, D);
        }
        var X = f.children, Z = f.fallback;
        if (E) {
          var ue = oD(n, X, Z, l), se = n.child;
          return se.memoizedState = jx(l), n.memoizedState = Hx, ue;
        } else
          return Gx(n, X);
      } else {
        var Ie = e.memoizedState;
        if (Ie !== null) {
          var Ae = Ie.dehydrated;
          if (Ae !== null)
            return fD(e, n, w, f, Ae, Ie, l);
        }
        if (E) {
          var Me = f.fallback, gt = f.children, Kt = sD(e, n, gt, Me, l), jt = n.child, lr = e.child.memoizedState;
          return jt.memoizedState = lr === null ? jx(l) : rD(lr, l), jt.childLanes = iD(e, l), n.memoizedState = Hx, Kt;
        } else {
          var Zn = f.children, Ce = lD(e, n, Zn, l);
          return n.memoizedState = null, Ce;
        }
      }
    }
    function Gx(e, n, l) {
      var f = e.mode, m = {
        mode: "visible",
        children: n
      }, E = zx(m, f);
      return E.return = e, e.child = E, E;
    }
    function oD(e, n, l, f) {
      var m = e.mode, E = e.child, w = {
        mode: "hidden",
        children: n
      }, O, D;
      return (m & Ut) === Ft && E !== null ? (O = E, O.childLanes = je, O.pendingProps = w, e.mode & rn && (O.actualDuration = 0, O.actualStartTime = -1, O.selfBaseDuration = 0, O.treeBaseDuration = 0), D = zh(l, m, f, null)) : (O = zx(w, m), D = zh(l, m, f, null)), O.return = e, D.return = e, O.sibling = D, e.child = O, D;
    }
    function zx(e, n, l) {
      return CA(e, n, je, null);
    }
    function CI(e, n) {
      return lm(e, n);
    }
    function lD(e, n, l, f) {
      var m = e.child, E = m.sibling, w = CI(m, {
        mode: "visible",
        children: l
      });
      if ((n.mode & Ut) === Ft && (w.lanes = f), w.return = n, w.sibling = null, E !== null) {
        var O = n.deletions;
        O === null ? (n.deletions = [E], n.flags |= vr) : O.push(E);
      }
      return n.child = w, w;
    }
    function sD(e, n, l, f, m) {
      var E = n.mode, w = e.child, O = w.sibling, D = {
        mode: "hidden",
        children: l
      }, X;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (E & Ut) === Ft && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        n.child !== w
      ) {
        var Z = n.child;
        X = Z, X.childLanes = je, X.pendingProps = D, n.mode & rn && (X.actualDuration = 0, X.actualStartTime = -1, X.selfBaseDuration = w.selfBaseDuration, X.treeBaseDuration = w.treeBaseDuration), n.deletions = null;
      } else
        X = CI(w, D), X.subtreeFlags = w.subtreeFlags & ii;
      var ue;
      return O !== null ? ue = lm(O, f) : (ue = zh(f, E, m, null), ue.flags |= Xr), ue.return = n, X.return = n, X.sibling = ue, n.child = X, ue;
    }
    function T1(e, n, l, f) {
      f !== null && RS(f), mg(n, e.child, null, l);
      var m = n.pendingProps, E = m.children, w = Gx(n, E);
      return w.flags |= Xr, n.memoizedState = null, w;
    }
    function uD(e, n, l, f, m) {
      var E = n.mode, w = {
        mode: "visible",
        children: l
      }, O = zx(w, E), D = zh(f, E, m, null);
      return D.flags |= Xr, O.return = n, D.return = n, O.sibling = D, n.child = O, (n.mode & Ut) !== Ft && mg(n, e.child, null, m), D;
    }
    function cD(e, n, l) {
      return (e.mode & Ut) === Ft ? (h("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), e.lanes = Ht) : Wb(n) ? e.lanes = ks : e.lanes = Ai, null;
    }
    function fD(e, n, l, f, m, E, w) {
      if (l)
        if (n.flags & pa) {
          n.flags &= ~pa;
          var Ce = _x(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return T1(e, n, w, Ce);
        } else {
          if (n.memoizedState !== null)
            return n.child = e.child, n.flags |= un, null;
          var Pe = f.children, Ee = f.fallback, et = uD(e, n, Pe, Ee, w), It = n.child;
          return It.memoizedState = jx(w), n.memoizedState = Hx, et;
        }
      else {
        if (K4(), (n.mode & Ut) === Ft)
          return T1(
            e,
            n,
            w,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (Wb(m)) {
          var O, D, X;
          {
            var Z = zE(m);
            O = Z.digest, D = Z.message, X = Z.stack;
          }
          var ue;
          D ? ue = new Error(D) : ue = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var se = _x(ue, O, X);
          return T1(e, n, w, se);
        }
        var Ie = Wi(w, e.childLanes);
        if (Gc || Ie) {
          var Ae = k1();
          if (Ae !== null) {
            var Me = Gd(Ae, w);
            if (Me !== Ia && Me !== E.retryLane) {
              E.retryLane = Me;
              var gt = Rr;
              ps(e, Me), no(Ae, e, Me, gt);
            }
          }
          fR();
          var Kt = _x(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return T1(e, n, w, Kt);
        } else if (L0(m)) {
          n.flags |= un, n.child = e.child;
          var jt = k3.bind(null, e);
          return WE(m, jt), null;
        } else {
          tL(n, m, E.treeContext);
          var lr = f.children, Zn = Gx(n, lr);
          return Zn.flags |= nl, Zn;
        }
      }
    }
    function EI(e, n, l) {
      e.lanes = yn(e.lanes, n);
      var f = e.alternate;
      f !== null && (f.lanes = yn(f.lanes, n)), MS(e.return, n, l);
    }
    function dD(e, n, l) {
      for (var f = n; f !== null; ) {
        if (f.tag === W) {
          var m = f.memoizedState;
          m !== null && EI(f, l, e);
        } else if (f.tag === Ne)
          EI(f, l, e);
        else if (f.child !== null) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === e)
          return;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === e)
            return;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
    }
    function pD(e) {
      for (var n = e, l = null; n !== null; ) {
        var f = n.alternate;
        f !== null && r1(f) === null && (l = n), n = n.sibling;
      }
      return l;
    }
    function hD(e) {
      if (e !== void 0 && e !== "forwards" && e !== "backwards" && e !== "together" && !Fx[e])
        if (Fx[e] = !0, typeof e == "string")
          switch (e.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              h('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', e, e.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              h('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', e, e.toLowerCase());
              break;
            }
            default:
              h('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
              break;
          }
        else
          h('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
    }
    function vD(e, n) {
      e !== void 0 && !R1[e] && (e !== "collapsed" && e !== "hidden" ? (R1[e] = !0, h('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', e)) : n !== "forwards" && n !== "backwards" && (R1[e] = !0, h('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', e)));
    }
    function SI(e, n) {
      {
        var l = Hn(e), f = !l && typeof Ra(e) == "function";
        if (l || f) {
          var m = l ? "array" : "iterable";
          return h("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", m, n, m), !1;
        }
      }
      return !0;
    }
    function mD(e, n) {
      if ((n === "forwards" || n === "backwards") && e !== void 0 && e !== null && e !== !1)
        if (Hn(e)) {
          for (var l = 0; l < e.length; l++)
            if (!SI(e[l], l))
              return;
        } else {
          var f = Ra(e);
          if (typeof f == "function") {
            var m = f.call(e);
            if (m)
              for (var E = m.next(), w = 0; !E.done; E = m.next()) {
                if (!SI(E.value, w))
                  return;
                w++;
              }
          } else
            h('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', n);
        }
    }
    function Wx(e, n, l, f, m) {
      var E = e.memoizedState;
      E === null ? e.memoizedState = {
        isBackwards: n,
        rendering: null,
        renderingStartTime: 0,
        last: f,
        tail: l,
        tailMode: m
      } : (E.isBackwards = n, E.rendering = null, E.renderingStartTime = 0, E.last = f, E.tail = l, E.tailMode = m);
    }
    function xI(e, n, l) {
      var f = n.pendingProps, m = f.revealOrder, E = f.tail, w = f.children;
      hD(m), vD(E, m), mD(w, m), Pl(e, n, w, l);
      var O = Vc.current, D = GS(O, ry);
      if (D)
        O = zS(O, ry), n.flags |= un;
      else {
        var X = e !== null && (e.flags & un) !== zt;
        X && dD(n, n.child, l), O = Cg(O);
      }
      if (kh(n, O), (n.mode & Ut) === Ft)
        n.memoizedState = null;
      else
        switch (m) {
          case "forwards": {
            var Z = pD(n.child), ue;
            Z === null ? (ue = n.child, n.child = null) : (ue = Z.sibling, Z.sibling = null), Wx(
              n,
              !1,
              // isBackwards
              ue,
              Z,
              E
            );
            break;
          }
          case "backwards": {
            var se = null, Ie = n.child;
            for (n.child = null; Ie !== null; ) {
              var Ae = Ie.alternate;
              if (Ae !== null && r1(Ae) === null) {
                n.child = Ie;
                break;
              }
              var Me = Ie.sibling;
              Ie.sibling = se, se = Ie, Ie = Me;
            }
            Wx(
              n,
              !0,
              // isBackwards
              se,
              null,
              // last
              E
            );
            break;
          }
          case "together": {
            Wx(
              n,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            n.memoizedState = null;
        }
      return n.child;
    }
    function gD(e, n, l) {
      VS(n, n.stateNode.containerInfo);
      var f = n.pendingProps;
      return e === null ? n.child = mg(n, null, f, l) : Pl(e, n, f, l), n.child;
    }
    var RI = !1;
    function bD(e, n, l) {
      var f = n.type, m = f._context, E = n.pendingProps, w = n.memoizedProps, O = E.value;
      {
        "value" in E || RI || (RI = !0, h("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var D = n.type.propTypes;
        D && sa(D, E, "prop", "Context.Provider");
      }
      if (mw(n, m, O), w !== null) {
        var X = w.value;
        if (Nt(X, O)) {
          if (w.children === E.children && !M0())
            return vp(e, n, l);
        } else
          hL(n, m, l);
      }
      var Z = E.children;
      return Pl(e, n, Z, l), n.child;
    }
    var TI = !1;
    function yD(e, n, l) {
      var f = n.type;
      f._context === void 0 ? f !== f.Consumer && (TI || (TI = !0, h("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : f = f._context;
      var m = n.pendingProps, E = m.children;
      typeof E != "function" && h("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), bg(n, l);
      var w = Oi(f);
      Cf(n);
      var O;
      return dy.current = n, lo(!0), O = E(w), lo(!1), ho(), n.flags |= mu, Pl(e, n, O, l), n.child;
    }
    function vy() {
      Gc = !0;
    }
    function w1(e, n) {
      (n.mode & Ut) === Ft && e !== null && (e.alternate = null, n.alternate = null, n.flags |= Xr);
    }
    function vp(e, n, l) {
      return e !== null && (n.dependencies = e.dependencies), eI(), Iy(n.lanes), Wi(l, n.childLanes) ? (dL(e, n), n.child) : null;
    }
    function CD(e, n, l) {
      {
        var f = n.return;
        if (f === null)
          throw new Error("Cannot swap the root fiber.");
        if (e.alternate = null, n.alternate = null, l.index = n.index, l.sibling = n.sibling, l.return = n.return, l.ref = n.ref, n === f.child)
          f.child = l;
        else {
          var m = f.child;
          if (m === null)
            throw new Error("Expected parent to have a child.");
          for (; m.sibling !== n; )
            if (m = m.sibling, m === null)
              throw new Error("Expected to find the previous sibling.");
          m.sibling = l;
        }
        var E = f.deletions;
        return E === null ? (f.deletions = [e], f.flags |= vr) : E.push(e), l.flags |= Xr, l;
      }
    }
    function Xx(e, n) {
      var l = e.lanes;
      return !!Wi(l, n);
    }
    function ED(e, n, l) {
      switch (n.tag) {
        case T:
          gI(n), n.stateNode, vg();
          break;
        case L:
          Rw(n);
          break;
        case S: {
          var f = n.type;
          $f(f) && k0(n);
          break;
        }
        case _:
          VS(n, n.stateNode.containerInfo);
          break;
        case Y: {
          var m = n.memoizedProps.value, E = n.type._context;
          mw(n, E, m);
          break;
        }
        case Q:
          {
            var w = Wi(l, n.childLanes);
            w && (n.flags |= ln);
            {
              var O = n.stateNode;
              O.effectDuration = 0, O.passiveEffectDuration = 0;
            }
          }
          break;
        case W: {
          var D = n.memoizedState;
          if (D !== null) {
            if (D.dehydrated !== null)
              return kh(n, Cg(Vc.current)), n.flags |= un, null;
            var X = n.child, Z = X.childLanes;
            if (Wi(l, Z))
              return yI(e, n, l);
            kh(n, Cg(Vc.current));
            var ue = vp(e, n, l);
            return ue !== null ? ue.sibling : null;
          } else
            kh(n, Cg(Vc.current));
          break;
        }
        case Ne: {
          var se = (e.flags & un) !== zt, Ie = Wi(l, n.childLanes);
          if (se) {
            if (Ie)
              return xI(e, n, l);
            n.flags |= un;
          }
          var Ae = n.memoizedState;
          if (Ae !== null && (Ae.rendering = null, Ae.tail = null, Ae.lastEffect = null), kh(n, Vc.current), Ie)
            break;
          return null;
        }
        case ze:
        case qe:
          return n.lanes = je, hI(e, n, l);
      }
      return vp(e, n, l);
    }
    function wI(e, n, l) {
      if (n._debugNeedsRemount && e !== null)
        return CD(e, n, SR(n.type, n.key, n.pendingProps, n._debugOwner || null, n.mode, n.lanes));
      if (e !== null) {
        var f = e.memoizedProps, m = n.pendingProps;
        if (f !== m || M0() || // Force a re-render if the implementation changed due to hot reload:
        n.type !== e.type)
          Gc = !0;
        else {
          var E = Xx(e, l);
          if (!E && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (n.flags & un) === zt)
            return Gc = !1, ED(e, n, l);
          (e.flags & Ad) !== zt ? Gc = !0 : Gc = !1;
        }
      } else if (Gc = !1, Po() && X4(n)) {
        var w = n.index, O = Y4();
        ew(n, O, w);
      }
      switch (n.lanes = je, n.tag) {
        case x:
          return nD(e, n, n.type, l);
        case re: {
          var D = n.elementType;
          return eD(e, n, D, l);
        }
        case g: {
          var X = n.type, Z = n.pendingProps, ue = n.elementType === X ? Z : jc(X, Z);
          return Bx(e, n, X, ue, l);
        }
        case S: {
          var se = n.type, Ie = n.pendingProps, Ae = n.elementType === se ? Ie : jc(se, Ie);
          return mI(e, n, se, Ae, l);
        }
        case T:
          return QL(e, n, l);
        case L:
          return KL(e, n, l);
        case M:
          return qL(e, n);
        case W:
          return yI(e, n, l);
        case _:
          return gD(e, n, l);
        case G: {
          var Me = n.type, gt = n.pendingProps, Kt = n.elementType === Me ? gt : jc(Me, gt);
          return fI(e, n, Me, Kt, l);
        }
        case U:
          return $L(e, n, l);
        case B:
          return ZL(e, n, l);
        case Q:
          return JL(e, n, l);
        case Y:
          return bD(e, n, l);
        case H:
          return yD(e, n, l);
        case oe: {
          var jt = n.type, lr = n.pendingProps, Zn = jc(jt, lr);
          if (n.type !== n.elementType) {
            var Ce = jt.propTypes;
            Ce && sa(
              Ce,
              Zn,
              // Resolved for outer only
              "prop",
              Un(jt)
            );
          }
          return Zn = jc(jt.type, Zn), dI(e, n, jt, Zn, l);
        }
        case j:
          return pI(e, n, n.type, n.pendingProps, l);
        case me: {
          var Pe = n.type, Ee = n.pendingProps, et = n.elementType === Pe ? Ee : jc(Pe, Ee);
          return tD(e, n, Pe, et, l);
        }
        case Ne:
          return xI(e, n, l);
        case Ge:
          break;
        case ze:
          return hI(e, n, l);
      }
      throw new Error("Unknown unit of work tag (" + n.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function wg(e) {
      e.flags |= ln;
    }
    function II(e) {
      e.flags |= ha, e.flags |= Ds;
    }
    var AI, Yx, NI, _I;
    AI = function(e, n, l, f) {
      for (var m = n.child; m !== null; ) {
        if (m.tag === L || m.tag === M)
          TE(e, m.stateNode);
        else if (m.tag !== _) {
          if (m.child !== null) {
            m.child.return = m, m = m.child;
            continue;
          }
        }
        if (m === n)
          return;
        for (; m.sibling === null; ) {
          if (m.return === null || m.return === n)
            return;
          m = m.return;
        }
        m.sibling.return = m.return, m = m.sibling;
      }
    }, Yx = function(e, n) {
    }, NI = function(e, n, l, f, m) {
      var E = e.memoizedProps;
      if (E !== f) {
        var w = n.stateNode, O = HS(), D = IE(w, l, E, f, m, O);
        n.updateQueue = D, D && wg(n);
      }
    }, _I = function(e, n, l, f) {
      l !== f && wg(n);
    };
    function my(e, n) {
      if (!Po())
        switch (e.tailMode) {
          case "hidden": {
            for (var l = e.tail, f = null; l !== null; )
              l.alternate !== null && (f = l), l = l.sibling;
            f === null ? e.tail = null : f.sibling = null;
            break;
          }
          case "collapsed": {
            for (var m = e.tail, E = null; m !== null; )
              m.alternate !== null && (E = m), m = m.sibling;
            E === null ? !n && e.tail !== null ? e.tail.sibling = null : e.tail = null : E.sibling = null;
            break;
          }
        }
    }
    function Fo(e) {
      var n = e.alternate !== null && e.alternate.child === e.child, l = je, f = zt;
      if (n) {
        if ((e.mode & rn) !== Ft) {
          for (var D = e.selfBaseDuration, X = e.child; X !== null; )
            l = yn(l, yn(X.lanes, X.childLanes)), f |= X.subtreeFlags & ii, f |= X.flags & ii, D += X.treeBaseDuration, X = X.sibling;
          e.treeBaseDuration = D;
        } else
          for (var Z = e.child; Z !== null; )
            l = yn(l, yn(Z.lanes, Z.childLanes)), f |= Z.subtreeFlags & ii, f |= Z.flags & ii, Z.return = e, Z = Z.sibling;
        e.subtreeFlags |= f;
      } else {
        if ((e.mode & rn) !== Ft) {
          for (var m = e.actualDuration, E = e.selfBaseDuration, w = e.child; w !== null; )
            l = yn(l, yn(w.lanes, w.childLanes)), f |= w.subtreeFlags, f |= w.flags, m += w.actualDuration, E += w.treeBaseDuration, w = w.sibling;
          e.actualDuration = m, e.treeBaseDuration = E;
        } else
          for (var O = e.child; O !== null; )
            l = yn(l, yn(O.lanes, O.childLanes)), f |= O.subtreeFlags, f |= O.flags, O.return = e, O = O.sibling;
        e.subtreeFlags |= f;
      }
      return e.childLanes = l, n;
    }
    function SD(e, n, l) {
      if (oL() && (n.mode & Ut) !== Ft && (n.flags & un) === zt)
        return lw(n), vg(), n.flags |= pa | No | ai, !1;
      var f = H0(n);
      if (l !== null && l.dehydrated !== null)
        if (e === null) {
          if (!f)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (aL(n), Fo(n), (n.mode & rn) !== Ft) {
            var m = l !== null;
            if (m) {
              var E = n.child;
              E !== null && (n.treeBaseDuration -= E.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (vg(), (n.flags & un) === zt && (n.memoizedState = null), n.flags |= ln, Fo(n), (n.mode & rn) !== Ft) {
            var w = l !== null;
            if (w) {
              var O = n.child;
              O !== null && (n.treeBaseDuration -= O.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return sw(), !0;
    }
    function OI(e, n, l) {
      var f = n.pendingProps;
      switch (yS(n), n.tag) {
        case x:
        case re:
        case j:
        case g:
        case G:
        case U:
        case B:
        case Q:
        case H:
        case oe:
          return Fo(n), null;
        case S: {
          var m = n.type;
          return $f(m) && P0(n), Fo(n), null;
        }
        case T: {
          var E = n.stateNode;
          if (yg(n), vS(n), XS(), E.pendingContext && (E.context = E.pendingContext, E.pendingContext = null), e === null || e.child === null) {
            var w = H0(n);
            if (w)
              wg(n);
            else if (e !== null) {
              var O = e.memoizedState;
              // Check if this is a client root
              (!O.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (n.flags & pa) !== zt) && (n.flags |= tl, sw());
            }
          }
          return Yx(e, n), Fo(n), null;
        }
        case L: {
          jS(n);
          var D = xw(), X = n.type;
          if (e !== null && n.stateNode != null)
            NI(e, n, X, f, D), e.ref !== n.ref && II(n);
          else {
            if (!f) {
              if (n.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return Fo(n), null;
            }
            var Z = HS(), ue = H0(n);
            if (ue)
              nL(n, D, Z) && wg(n);
            else {
              var se = RE(X, f, D, Z, n);
              AI(se, n, !1, !1), n.stateNode = se, wE(se, X, f, D) && wg(n);
            }
            n.ref !== null && II(n);
          }
          return Fo(n), null;
        }
        case M: {
          var Ie = f;
          if (e && n.stateNode != null) {
            var Ae = e.memoizedProps;
            _I(e, n, Ae, Ie);
          } else {
            if (typeof Ie != "string" && n.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Me = xw(), gt = HS(), Kt = H0(n);
            Kt ? rL(n) && wg(n) : n.stateNode = AE(Ie, Me, gt, n);
          }
          return Fo(n), null;
        }
        case W: {
          Eg(n);
          var jt = n.memoizedState;
          if (e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            var lr = SD(e, n, jt);
            if (!lr)
              return n.flags & ai ? n : null;
          }
          if ((n.flags & un) !== zt)
            return n.lanes = l, (n.mode & rn) !== Ft && gx(n), n;
          var Zn = jt !== null, Ce = e !== null && e.memoizedState !== null;
          if (Zn !== Ce && Zn) {
            var Pe = n.child;
            if (Pe.flags |= gu, (n.mode & Ut) !== Ft) {
              var Ee = e === null && (n.memoizedProps.unstable_avoidThisFallback !== !0 || !q);
              Ee || GS(Vc.current, ww) ? x3() : fR();
            }
          }
          var et = n.updateQueue;
          if (et !== null && (n.flags |= ln), Fo(n), (n.mode & rn) !== Ft && Zn) {
            var It = n.child;
            It !== null && (n.treeBaseDuration -= It.treeBaseDuration);
          }
          return null;
        }
        case _:
          return yg(n), Yx(e, n), e === null && dS(n.stateNode.containerInfo), Fo(n), null;
        case Y:
          var St = n.type._context;
          return DS(St, n), Fo(n), null;
        case me: {
          var pn = n.type;
          return $f(pn) && P0(n), Fo(n), null;
        }
        case Ne: {
          Eg(n);
          var En = n.memoizedState;
          if (En === null)
            return Fo(n), null;
          var jr = (n.flags & un) !== zt, Cr = En.rendering;
          if (Cr === null)
            if (jr)
              my(En, !1);
            else {
              var yi = T3() && (e === null || (e.flags & un) === zt);
              if (!yi)
                for (var Er = n.child; Er !== null; ) {
                  var ui = r1(Er);
                  if (ui !== null) {
                    jr = !0, n.flags |= un, my(En, !1);
                    var Cl = ui.updateQueue;
                    return Cl !== null && (n.updateQueue = Cl, n.flags |= ln), n.subtreeFlags = zt, pL(n, l), kh(n, zS(Vc.current, ry)), n.child;
                  }
                  Er = Er.sibling;
                }
              En.tail !== null && kr() > KI() && (n.flags |= un, jr = !0, my(En, !1), n.lanes = Fm);
            }
          else {
            if (!jr) {
              var jo = r1(Cr);
              if (jo !== null) {
                n.flags |= un, jr = !0;
                var Zs = jo.updateQueue;
                if (Zs !== null && (n.updateQueue = Zs, n.flags |= ln), my(En, !0), En.tail === null && En.tailMode === "hidden" && !Cr.alternate && !Po())
                  return Fo(n), null;
              } else
                // The time it took to render last row is greater than the remaining
                // time we have to render. So rendering one more row would likely
                // exceed it.
                kr() * 2 - En.renderingStartTime > KI() && l !== Ai && (n.flags |= un, jr = !0, my(En, !1), n.lanes = Fm);
            }
            if (En.isBackwards)
              Cr.sibling = n.child, n.child = Cr;
            else {
              var Bl = En.last;
              Bl !== null ? Bl.sibling = Cr : n.child = Cr, En.last = Cr;
            }
          }
          if (En.tail !== null) {
            var Ul = En.tail;
            En.rendering = Ul, En.tail = Ul.sibling, En.renderingStartTime = kr(), Ul.sibling = null;
            var El = Vc.current;
            return jr ? El = zS(El, ry) : El = Cg(El), kh(n, El), Ul;
          }
          return Fo(n), null;
        }
        case Ge:
          break;
        case ze:
        case qe: {
          cR(n);
          var Cp = n.memoizedState, Mg = Cp !== null;
          if (e !== null) {
            var Ly = e.memoizedState, nd = Ly !== null;
            nd !== Mg && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !_e && (n.flags |= gu);
          }
          return !Mg || (n.mode & Ut) === Ft ? Fo(n) : Wi(td, Ai) && (Fo(n), n.subtreeFlags & (Xr | ln) && (n.flags |= gu)), null;
        }
        case at:
          return null;
        case st:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + n.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function xD(e, n, l) {
      switch (yS(n), n.tag) {
        case S: {
          var f = n.type;
          $f(f) && P0(n);
          var m = n.flags;
          return m & ai ? (n.flags = m & ~ai | un, (n.mode & rn) !== Ft && gx(n), n) : null;
        }
        case T: {
          n.stateNode, yg(n), vS(n), XS();
          var E = n.flags;
          return (E & ai) !== zt && (E & un) === zt ? (n.flags = E & ~ai | un, n) : null;
        }
        case L:
          return jS(n), null;
        case W: {
          Eg(n);
          var w = n.memoizedState;
          if (w !== null && w.dehydrated !== null) {
            if (n.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            vg();
          }
          var O = n.flags;
          return O & ai ? (n.flags = O & ~ai | un, (n.mode & rn) !== Ft && gx(n), n) : null;
        }
        case Ne:
          return Eg(n), null;
        case _:
          return yg(n), null;
        case Y:
          var D = n.type._context;
          return DS(D, n), null;
        case ze:
        case qe:
          return cR(n), null;
        case at:
          return null;
        default:
          return null;
      }
    }
    function LI(e, n, l) {
      switch (yS(n), n.tag) {
        case S: {
          var f = n.type.childContextTypes;
          f != null && P0(n);
          break;
        }
        case T: {
          n.stateNode, yg(n), vS(n), XS();
          break;
        }
        case L: {
          jS(n);
          break;
        }
        case _:
          yg(n);
          break;
        case W:
          Eg(n);
          break;
        case Ne:
          Eg(n);
          break;
        case Y:
          var m = n.type._context;
          DS(m, n);
          break;
        case ze:
        case qe:
          cR(n);
          break;
      }
    }
    var DI = null;
    DI = /* @__PURE__ */ new Set();
    var I1 = !1, Bo = !1, RD = typeof WeakSet == "function" ? WeakSet : Set, Mt = null, Ig = null, Ag = null;
    function TD(e) {
      es(null, function() {
        throw e;
      }), vu();
    }
    var wD = function(e, n) {
      if (n.props = e.memoizedProps, n.state = e.memoizedState, e.mode & rn)
        try {
          qf(), n.componentWillUnmount();
        } finally {
          Kf(e);
        }
      else
        n.componentWillUnmount();
    };
    function MI(e, n) {
      try {
        Uh(Ji, e);
      } catch (l) {
        ua(e, n, l);
      }
    }
    function $x(e, n, l) {
      try {
        wD(e, l);
      } catch (f) {
        ua(e, n, f);
      }
    }
    function ID(e, n, l) {
      try {
        l.componentDidMount();
      } catch (f) {
        ua(e, n, f);
      }
    }
    function PI(e, n) {
      try {
        FI(e);
      } catch (l) {
        ua(e, n, l);
      }
    }
    function Ng(e, n) {
      var l = e.ref;
      if (l !== null)
        if (typeof l == "function") {
          var f;
          try {
            if (nt && Rt && e.mode & rn)
              try {
                qf(), f = l(null);
              } finally {
                Kf(e);
              }
            else
              f = l(null);
          } catch (m) {
            ua(e, n, m);
          }
          typeof f == "function" && h("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", dn(e));
        } else
          l.current = null;
    }
    function A1(e, n, l) {
      try {
        l();
      } catch (f) {
        ua(e, n, f);
      }
    }
    var kI = !1;
    function AD(e, n) {
      SE(e.containerInfo), Mt = n, ND();
      var l = kI;
      return kI = !1, l;
    }
    function ND() {
      for (; Mt !== null; ) {
        var e = Mt, n = e.child;
        (e.subtreeFlags & bf) !== zt && n !== null ? (n.return = e, Mt = n) : _D();
      }
    }
    function _D() {
      for (; Mt !== null; ) {
        var e = Mt;
        gr(e);
        try {
          OD(e);
        } catch (l) {
          ua(e, e.return, l);
        }
        da();
        var n = e.sibling;
        if (n !== null) {
          n.return = e.return, Mt = n;
          return;
        }
        Mt = e.return;
      }
    }
    function OD(e) {
      var n = e.alternate, l = e.flags;
      if ((l & tl) !== zt) {
        switch (gr(e), e.tag) {
          case g:
          case G:
          case j:
            break;
          case S: {
            if (n !== null) {
              var f = n.memoizedProps, m = n.memoizedState, E = e.stateNode;
              e.type === e.elementType && !nm && (E.props !== e.memoizedProps && h("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", dn(e) || "instance"), E.state !== e.memoizedState && h("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", dn(e) || "instance"));
              var w = E.getSnapshotBeforeUpdate(e.elementType === e.type ? f : jc(e.type, f), m);
              {
                var O = DI;
                w === void 0 && !O.has(e.type) && (O.add(e.type), h("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", dn(e)));
              }
              E.__reactInternalSnapshotBeforeUpdate = w;
            }
            break;
          }
          case T: {
            {
              var D = e.stateNode;
              jE(D.containerInfo);
            }
            break;
          }
          case L:
          case M:
          case _:
          case me:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        da();
      }
    }
    function zc(e, n, l) {
      var f = n.updateQueue, m = f !== null ? f.lastEffect : null;
      if (m !== null) {
        var E = m.next, w = E;
        do {
          if ((w.tag & e) === e) {
            var O = w.destroy;
            w.destroy = void 0, O !== void 0 && ((e & ko) !== hs ? km(n) : (e & Ji) !== hs && _l(n), (e & Zf) !== hs && Ny(!0), A1(n, l, O), (e & Zf) !== hs && Ny(!1), (e & ko) !== hs ? Ef() : (e & Ji) !== hs && Sf());
          }
          w = w.next;
        } while (w !== E);
      }
    }
    function Uh(e, n) {
      var l = n.updateQueue, f = l !== null ? l.lastEffect : null;
      if (f !== null) {
        var m = f.next, E = m;
        do {
          if ((E.tag & e) === e) {
            (e & ko) !== hs ? sl(n) : (e & Ji) !== hs && vv(n);
            var w = E.create;
            (e & Zf) !== hs && Ny(!0), E.destroy = w(), (e & Zf) !== hs && Ny(!1), (e & ko) !== hs ? Yp() : (e & Ji) !== hs && Dd();
            {
              var O = E.destroy;
              if (O !== void 0 && typeof O != "function") {
                var D = void 0;
                (E.tag & Ji) !== zt ? D = "useLayoutEffect" : (E.tag & Zf) !== zt ? D = "useInsertionEffect" : D = "useEffect";
                var X = void 0;
                O === null ? X = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof O.then == "function" ? X = `

It looks like you wrote ` + D + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + D + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : X = " You returned: " + O, h("%s must not return anything besides a function, which is used for clean-up.%s", D, X);
              }
            }
          }
          E = E.next;
        } while (E !== m);
      }
    }
    function LD(e, n) {
      if ((n.flags & ln) !== zt)
        switch (n.tag) {
          case Q: {
            var l = n.stateNode.passiveEffectDuration, f = n.memoizedProps, m = f.id, E = f.onPostCommit, w = Kw(), O = n.alternate === null ? "mount" : "update";
            Qw() && (O = "nested-update"), typeof E == "function" && E(m, O, l, w);
            var D = n.return;
            e:
              for (; D !== null; ) {
                switch (D.tag) {
                  case T:
                    var X = D.stateNode;
                    X.passiveEffectDuration += l;
                    break e;
                  case Q:
                    var Z = D.stateNode;
                    Z.passiveEffectDuration += l;
                    break e;
                }
                D = D.return;
              }
            break;
          }
        }
    }
    function DD(e, n, l, f) {
      if ((l.flags & Ri) !== zt)
        switch (l.tag) {
          case g:
          case G:
          case j: {
            if (!Bo)
              if (l.mode & rn)
                try {
                  qf(), Uh(Ji | Zi, l);
                } finally {
                  Kf(l);
                }
              else
                Uh(Ji | Zi, l);
            break;
          }
          case S: {
            var m = l.stateNode;
            if (l.flags & ln && !Bo)
              if (n === null)
                if (l.type === l.elementType && !nm && (m.props !== l.memoizedProps && h("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", dn(l) || "instance"), m.state !== l.memoizedState && h("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", dn(l) || "instance")), l.mode & rn)
                  try {
                    qf(), m.componentDidMount();
                  } finally {
                    Kf(l);
                  }
                else
                  m.componentDidMount();
              else {
                var E = l.elementType === l.type ? n.memoizedProps : jc(l.type, n.memoizedProps), w = n.memoizedState;
                if (l.type === l.elementType && !nm && (m.props !== l.memoizedProps && h("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", dn(l) || "instance"), m.state !== l.memoizedState && h("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", dn(l) || "instance")), l.mode & rn)
                  try {
                    qf(), m.componentDidUpdate(E, w, m.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Kf(l);
                  }
                else
                  m.componentDidUpdate(E, w, m.__reactInternalSnapshotBeforeUpdate);
              }
            var O = l.updateQueue;
            O !== null && (l.type === l.elementType && !nm && (m.props !== l.memoizedProps && h("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", dn(l) || "instance"), m.state !== l.memoizedState && h("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", dn(l) || "instance")), Sw(l, O, m));
            break;
          }
          case T: {
            var D = l.updateQueue;
            if (D !== null) {
              var X = null;
              if (l.child !== null)
                switch (l.child.tag) {
                  case L:
                    X = l.child.stateNode;
                    break;
                  case S:
                    X = l.child.stateNode;
                    break;
                }
              Sw(l, D, X);
            }
            break;
          }
          case L: {
            var Z = l.stateNode;
            if (n === null && l.flags & ln) {
              var ue = l.type, se = l.memoizedProps;
              DE(Z, ue, se);
            }
            break;
          }
          case M:
            break;
          case _:
            break;
          case Q: {
            {
              var Ie = l.memoizedProps, Ae = Ie.onCommit, Me = Ie.onRender, gt = l.stateNode.effectDuration, Kt = Kw(), jt = n === null ? "mount" : "update";
              Qw() && (jt = "nested-update"), typeof Me == "function" && Me(l.memoizedProps.id, jt, l.actualDuration, l.treeBaseDuration, l.actualStartTime, Kt);
              {
                typeof Ae == "function" && Ae(l.memoizedProps.id, jt, gt, Kt), _3(l);
                var lr = l.return;
                e:
                  for (; lr !== null; ) {
                    switch (lr.tag) {
                      case T:
                        var Zn = lr.stateNode;
                        Zn.effectDuration += gt;
                        break e;
                      case Q:
                        var Ce = lr.stateNode;
                        Ce.effectDuration += gt;
                        break e;
                    }
                    lr = lr.return;
                  }
              }
            }
            break;
          }
          case W: {
            HD(e, l);
            break;
          }
          case Ne:
          case me:
          case Ge:
          case ze:
          case qe:
          case st:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      Bo || l.flags & ha && FI(l);
    }
    function MD(e) {
      switch (e.tag) {
        case g:
        case G:
        case j: {
          if (e.mode & rn)
            try {
              qf(), MI(e, e.return);
            } finally {
              Kf(e);
            }
          else
            MI(e, e.return);
          break;
        }
        case S: {
          var n = e.stateNode;
          typeof n.componentDidMount == "function" && ID(e, e.return, n), PI(e, e.return);
          break;
        }
        case L: {
          PI(e, e.return);
          break;
        }
      }
    }
    function PD(e, n) {
      for (var l = null, f = e; ; ) {
        if (f.tag === L) {
          if (l === null) {
            l = f;
            try {
              var m = f.stateNode;
              n ? jb(m) : VE(f.stateNode, f.memoizedProps);
            } catch (w) {
              ua(e, e.return, w);
            }
          }
        } else if (f.tag === M) {
          if (l === null)
            try {
              var E = f.stateNode;
              n ? UE(E) : HE(E, f.memoizedProps);
            } catch (w) {
              ua(e, e.return, w);
            }
        } else if (!((f.tag === ze || f.tag === qe) && f.memoizedState !== null && f !== e)) {
          if (f.child !== null) {
            f.child.return = f, f = f.child;
            continue;
          }
        }
        if (f === e)
          return;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === e)
            return;
          l === f && (l = null), f = f.return;
        }
        l === f && (l = null), f.sibling.return = f.return, f = f.sibling;
      }
    }
    function FI(e) {
      var n = e.ref;
      if (n !== null) {
        var l = e.stateNode, f;
        switch (e.tag) {
          case L:
            f = l;
            break;
          default:
            f = l;
        }
        if (typeof n == "function") {
          var m;
          if (e.mode & rn)
            try {
              qf(), m = n(f);
            } finally {
              Kf(e);
            }
          else
            m = n(f);
          typeof m == "function" && h("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", dn(e));
        } else
          n.hasOwnProperty("current") || h("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", dn(e)), n.current = f;
      }
    }
    function kD(e) {
      var n = e.alternate;
      n !== null && (n.return = null), e.return = null;
    }
    function BI(e) {
      var n = e.alternate;
      n !== null && (e.alternate = null, BI(n));
      {
        if (e.child = null, e.deletions = null, e.sibling = null, e.tag === L) {
          var l = e.stateNode;
          l !== null && ee(l);
        }
        e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
      }
    }
    function FD(e) {
      for (var n = e.return; n !== null; ) {
        if (UI(n))
          return n;
        n = n.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function UI(e) {
      return e.tag === L || e.tag === T || e.tag === _;
    }
    function VI(e) {
      var n = e;
      e:
        for (; ; ) {
          for (; n.sibling === null; ) {
            if (n.return === null || UI(n.return))
              return null;
            n = n.return;
          }
          for (n.sibling.return = n.return, n = n.sibling; n.tag !== L && n.tag !== M && n.tag !== Se; ) {
            if (n.flags & Xr || n.child === null || n.tag === _)
              continue e;
            n.child.return = n, n = n.child;
          }
          if (!(n.flags & Xr))
            return n.stateNode;
        }
    }
    function BD(e) {
      var n = FD(e);
      switch (n.tag) {
        case L: {
          var l = n.stateNode;
          n.flags & yr && (Ub(l), n.flags &= ~yr);
          var f = VI(e);
          Jx(e, f, l);
          break;
        }
        case T:
        case _: {
          var m = n.stateNode.containerInfo, E = VI(e);
          Zx(e, E, m);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function Zx(e, n, l) {
      var f = e.tag, m = f === L || f === M;
      if (m) {
        var E = e.stateNode;
        n ? Vb(l, E, n) : PE(l, E);
      } else if (f !== _) {
        var w = e.child;
        if (w !== null) {
          Zx(w, n, l);
          for (var O = w.sibling; O !== null; )
            Zx(O, n, l), O = O.sibling;
        }
      }
    }
    function Jx(e, n, l) {
      var f = e.tag, m = f === L || f === M;
      if (m) {
        var E = e.stateNode;
        n ? kE(l, E, n) : ME(l, E);
      } else if (f !== _) {
        var w = e.child;
        if (w !== null) {
          Jx(w, n, l);
          for (var O = w.sibling; O !== null; )
            Jx(O, n, l), O = O.sibling;
        }
      }
    }
    var Uo = null, Wc = !1;
    function UD(e, n, l) {
      {
        var f = n;
        e:
          for (; f !== null; ) {
            switch (f.tag) {
              case L: {
                Uo = f.stateNode, Wc = !1;
                break e;
              }
              case T: {
                Uo = f.stateNode.containerInfo, Wc = !0;
                break e;
              }
              case _: {
                Uo = f.stateNode.containerInfo, Wc = !0;
                break e;
              }
            }
            f = f.return;
          }
        if (Uo === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        HI(e, n, l), Uo = null, Wc = !1;
      }
      kD(l);
    }
    function Vh(e, n, l) {
      for (var f = l.child; f !== null; )
        HI(e, n, f), f = f.sibling;
    }
    function HI(e, n, l) {
      switch (gc(l), l.tag) {
        case L:
          Bo || Ng(l, n);
        case M: {
          {
            var f = Uo, m = Wc;
            Uo = null, Vh(e, n, l), Uo = f, Wc = m, Uo !== null && (Wc ? BE(Uo, l.stateNode) : FE(Uo, l.stateNode));
          }
          return;
        }
        case Se: {
          Uo !== null && (Wc ? gl(Uo, l.stateNode) : Hb(Uo, l.stateNode));
          return;
        }
        case _: {
          {
            var E = Uo, w = Wc;
            Uo = l.stateNode.containerInfo, Wc = !0, Vh(e, n, l), Uo = E, Wc = w;
          }
          return;
        }
        case g:
        case G:
        case oe:
        case j: {
          if (!Bo) {
            var O = l.updateQueue;
            if (O !== null) {
              var D = O.lastEffect;
              if (D !== null) {
                var X = D.next, Z = X;
                do {
                  var ue = Z, se = ue.destroy, Ie = ue.tag;
                  se !== void 0 && ((Ie & Zf) !== hs ? A1(l, n, se) : (Ie & Ji) !== hs && (_l(l), l.mode & rn ? (qf(), A1(l, n, se), Kf(l)) : A1(l, n, se), Sf())), Z = Z.next;
                } while (Z !== X);
              }
            }
          }
          Vh(e, n, l);
          return;
        }
        case S: {
          if (!Bo) {
            Ng(l, n);
            var Ae = l.stateNode;
            typeof Ae.componentWillUnmount == "function" && $x(l, n, Ae);
          }
          Vh(e, n, l);
          return;
        }
        case Ge: {
          Vh(e, n, l);
          return;
        }
        case ze: {
          if (
            // TODO: Remove this dead flag
            l.mode & Ut
          ) {
            var Me = Bo;
            Bo = Me || l.memoizedState !== null, Vh(e, n, l), Bo = Me;
          } else
            Vh(e, n, l);
          break;
        }
        default: {
          Vh(e, n, l);
          return;
        }
      }
    }
    function VD(e) {
      e.memoizedState;
    }
    function HD(e, n) {
      var l = n.memoizedState;
      if (l === null) {
        var f = n.alternate;
        if (f !== null) {
          var m = f.memoizedState;
          if (m !== null) {
            var E = m.dehydrated;
            E !== null && KE(E);
          }
        }
      }
    }
    function jI(e) {
      var n = e.updateQueue;
      if (n !== null) {
        e.updateQueue = null;
        var l = e.stateNode;
        l === null && (l = e.stateNode = new RD()), n.forEach(function(f) {
          var m = F3.bind(null, e, f);
          if (!l.has(f)) {
            if (l.add(f), za)
              if (Ig !== null && Ag !== null)
                Ay(Ag, Ig);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            f.then(m, m);
          }
        });
      }
    }
    function jD(e, n, l) {
      Ig = l, Ag = e, gr(n), GI(n, e), gr(n), Ig = null, Ag = null;
    }
    function Xc(e, n, l) {
      var f = n.deletions;
      if (f !== null)
        for (var m = 0; m < f.length; m++) {
          var E = f[m];
          try {
            UD(e, n, E);
          } catch (D) {
            ua(E, n, D);
          }
        }
      var w = Ip();
      if (n.subtreeFlags & fo)
        for (var O = n.child; O !== null; )
          gr(O), GI(O, e), O = O.sibling;
      gr(w);
    }
    function GI(e, n, l) {
      var f = e.alternate, m = e.flags;
      switch (e.tag) {
        case g:
        case G:
        case oe:
        case j: {
          if (Xc(n, e), ed(e), m & ln) {
            try {
              zc(Zf | Zi, e, e.return), Uh(Zf | Zi, e);
            } catch (pn) {
              ua(e, e.return, pn);
            }
            if (e.mode & rn) {
              try {
                qf(), zc(Ji | Zi, e, e.return);
              } catch (pn) {
                ua(e, e.return, pn);
              }
              Kf(e);
            } else
              try {
                zc(Ji | Zi, e, e.return);
              } catch (pn) {
                ua(e, e.return, pn);
              }
          }
          return;
        }
        case S: {
          Xc(n, e), ed(e), m & ha && f !== null && Ng(f, f.return);
          return;
        }
        case L: {
          Xc(n, e), ed(e), m & ha && f !== null && Ng(f, f.return);
          {
            if (e.flags & yr) {
              var E = e.stateNode;
              try {
                Ub(E);
              } catch (pn) {
                ua(e, e.return, pn);
              }
            }
            if (m & ln) {
              var w = e.stateNode;
              if (w != null) {
                var O = e.memoizedProps, D = f !== null ? f.memoizedProps : O, X = e.type, Z = e.updateQueue;
                if (e.updateQueue = null, Z !== null)
                  try {
                    Bb(w, Z, X, D, O, e);
                  } catch (pn) {
                    ua(e, e.return, pn);
                  }
              }
            }
          }
          return;
        }
        case M: {
          if (Xc(n, e), ed(e), m & ln) {
            if (e.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var ue = e.stateNode, se = e.memoizedProps, Ie = f !== null ? f.memoizedProps : se;
            try {
              O0(ue, Ie, se);
            } catch (pn) {
              ua(e, e.return, pn);
            }
          }
          return;
        }
        case T: {
          if (Xc(n, e), ed(e), m & ln && f !== null) {
            var Ae = f.memoizedState;
            if (Ae.isDehydrated)
              try {
                QE(n.containerInfo);
              } catch (pn) {
                ua(e, e.return, pn);
              }
          }
          return;
        }
        case _: {
          Xc(n, e), ed(e);
          return;
        }
        case W: {
          Xc(n, e), ed(e);
          var Me = e.child;
          if (Me.flags & gu) {
            var gt = Me.stateNode, Kt = Me.memoizedState, jt = Kt !== null;
            if (gt.isHidden = jt, jt) {
              var lr = Me.alternate !== null && Me.alternate.memoizedState !== null;
              lr || S3();
            }
          }
          if (m & ln) {
            try {
              VD(e);
            } catch (pn) {
              ua(e, e.return, pn);
            }
            jI(e);
          }
          return;
        }
        case ze: {
          var Zn = f !== null && f.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            e.mode & Ut
          ) {
            var Ce = Bo;
            Bo = Ce || Zn, Xc(n, e), Bo = Ce;
          } else
            Xc(n, e);
          if (ed(e), m & gu) {
            var Pe = e.stateNode, Ee = e.memoizedState, et = Ee !== null, It = e;
            if (Pe.isHidden = et, et && !Zn && (It.mode & Ut) !== Ft) {
              Mt = It;
              for (var St = It.child; St !== null; )
                Mt = St, zD(St), St = St.sibling;
            }
            PD(It, et);
          }
          return;
        }
        case Ne: {
          Xc(n, e), ed(e), m & ln && jI(e);
          return;
        }
        case Ge:
          return;
        default: {
          Xc(n, e), ed(e);
          return;
        }
      }
    }
    function ed(e) {
      var n = e.flags;
      if (n & Xr) {
        try {
          BD(e);
        } catch (l) {
          ua(e, e.return, l);
        }
        e.flags &= ~Xr;
      }
      n & nl && (e.flags &= ~nl);
    }
    function GD(e, n, l) {
      Ig = l, Ag = n, Mt = e, zI(e, n, l), Ig = null, Ag = null;
    }
    function zI(e, n, l) {
      for (var f = (e.mode & Ut) !== Ft; Mt !== null; ) {
        var m = Mt, E = m.child;
        if (m.tag === ze && f) {
          var w = m.memoizedState !== null, O = w || I1;
          if (O) {
            Qx(e, n, l);
            continue;
          } else {
            var D = m.alternate, X = D !== null && D.memoizedState !== null, Z = X || Bo, ue = I1, se = Bo;
            I1 = O, Bo = Z, Bo && !se && (Mt = m, WD(m));
            for (var Ie = E; Ie !== null; )
              Mt = Ie, zI(
                Ie,
                // New root; bubble back up to here and stop.
                n,
                l
              ), Ie = Ie.sibling;
            Mt = m, I1 = ue, Bo = se, Qx(e, n, l);
            continue;
          }
        }
        (m.subtreeFlags & Ri) !== zt && E !== null ? (E.return = m, Mt = E) : Qx(e, n, l);
      }
    }
    function Qx(e, n, l) {
      for (; Mt !== null; ) {
        var f = Mt;
        if ((f.flags & Ri) !== zt) {
          var m = f.alternate;
          gr(f);
          try {
            DD(n, m, f, l);
          } catch (w) {
            ua(f, f.return, w);
          }
          da();
        }
        if (f === e) {
          Mt = null;
          return;
        }
        var E = f.sibling;
        if (E !== null) {
          E.return = f.return, Mt = E;
          return;
        }
        Mt = f.return;
      }
    }
    function zD(e) {
      for (; Mt !== null; ) {
        var n = Mt, l = n.child;
        switch (n.tag) {
          case g:
          case G:
          case oe:
          case j: {
            if (n.mode & rn)
              try {
                qf(), zc(Ji, n, n.return);
              } finally {
                Kf(n);
              }
            else
              zc(Ji, n, n.return);
            break;
          }
          case S: {
            Ng(n, n.return);
            var f = n.stateNode;
            typeof f.componentWillUnmount == "function" && $x(n, n.return, f);
            break;
          }
          case L: {
            Ng(n, n.return);
            break;
          }
          case ze: {
            var m = n.memoizedState !== null;
            if (m) {
              WI(e);
              continue;
            }
            break;
          }
        }
        l !== null ? (l.return = n, Mt = l) : WI(e);
      }
    }
    function WI(e) {
      for (; Mt !== null; ) {
        var n = Mt;
        if (n === e) {
          Mt = null;
          return;
        }
        var l = n.sibling;
        if (l !== null) {
          l.return = n.return, Mt = l;
          return;
        }
        Mt = n.return;
      }
    }
    function WD(e) {
      for (; Mt !== null; ) {
        var n = Mt, l = n.child;
        if (n.tag === ze) {
          var f = n.memoizedState !== null;
          if (f) {
            XI(e);
            continue;
          }
        }
        l !== null ? (l.return = n, Mt = l) : XI(e);
      }
    }
    function XI(e) {
      for (; Mt !== null; ) {
        var n = Mt;
        gr(n);
        try {
          MD(n);
        } catch (f) {
          ua(n, n.return, f);
        }
        if (da(), n === e) {
          Mt = null;
          return;
        }
        var l = n.sibling;
        if (l !== null) {
          l.return = n.return, Mt = l;
          return;
        }
        Mt = n.return;
      }
    }
    function XD(e, n, l, f) {
      Mt = n, YD(n, e, l, f);
    }
    function YD(e, n, l, f) {
      for (; Mt !== null; ) {
        var m = Mt, E = m.child;
        (m.subtreeFlags & al) !== zt && E !== null ? (E.return = m, Mt = E) : $D(e, n, l, f);
      }
    }
    function $D(e, n, l, f) {
      for (; Mt !== null; ) {
        var m = Mt;
        if ((m.flags & ea) !== zt) {
          gr(m);
          try {
            ZD(n, m, l, f);
          } catch (w) {
            ua(m, m.return, w);
          }
          da();
        }
        if (m === e) {
          Mt = null;
          return;
        }
        var E = m.sibling;
        if (E !== null) {
          E.return = m.return, Mt = E;
          return;
        }
        Mt = m.return;
      }
    }
    function ZD(e, n, l, f) {
      switch (n.tag) {
        case g:
        case G:
        case j: {
          if (n.mode & rn) {
            mx();
            try {
              Uh(ko | Zi, n);
            } finally {
              vx(n);
            }
          } else
            Uh(ko | Zi, n);
          break;
        }
      }
    }
    function JD(e) {
      Mt = e, QD();
    }
    function QD() {
      for (; Mt !== null; ) {
        var e = Mt, n = e.child;
        if ((Mt.flags & vr) !== zt) {
          var l = e.deletions;
          if (l !== null) {
            for (var f = 0; f < l.length; f++) {
              var m = l[f];
              Mt = m, e3(m, e);
            }
            {
              var E = e.alternate;
              if (E !== null) {
                var w = E.child;
                if (w !== null) {
                  E.child = null;
                  do {
                    var O = w.sibling;
                    w.sibling = null, w = O;
                  } while (w !== null);
                }
              }
            }
            Mt = e;
          }
        }
        (e.subtreeFlags & al) !== zt && n !== null ? (n.return = e, Mt = n) : KD();
      }
    }
    function KD() {
      for (; Mt !== null; ) {
        var e = Mt;
        (e.flags & ea) !== zt && (gr(e), qD(e), da());
        var n = e.sibling;
        if (n !== null) {
          n.return = e.return, Mt = n;
          return;
        }
        Mt = e.return;
      }
    }
    function qD(e) {
      switch (e.tag) {
        case g:
        case G:
        case j: {
          e.mode & rn ? (mx(), zc(ko | Zi, e, e.return), vx(e)) : zc(ko | Zi, e, e.return);
          break;
        }
      }
    }
    function e3(e, n) {
      for (; Mt !== null; ) {
        var l = Mt;
        gr(l), n3(l, n), da();
        var f = l.child;
        f !== null ? (f.return = l, Mt = f) : t3(e);
      }
    }
    function t3(e) {
      for (; Mt !== null; ) {
        var n = Mt, l = n.sibling, f = n.return;
        if (BI(n), n === e) {
          Mt = null;
          return;
        }
        if (l !== null) {
          l.return = f, Mt = l;
          return;
        }
        Mt = f;
      }
    }
    function n3(e, n) {
      switch (e.tag) {
        case g:
        case G:
        case j: {
          e.mode & rn ? (mx(), zc(ko, e, n), vx(e)) : zc(ko, e, n);
          break;
        }
      }
    }
    function r3(e) {
      switch (e.tag) {
        case g:
        case G:
        case j: {
          try {
            Uh(Ji | Zi, e);
          } catch (l) {
            ua(e, e.return, l);
          }
          break;
        }
        case S: {
          var n = e.stateNode;
          try {
            n.componentDidMount();
          } catch (l) {
            ua(e, e.return, l);
          }
          break;
        }
      }
    }
    function a3(e) {
      switch (e.tag) {
        case g:
        case G:
        case j: {
          try {
            Uh(ko | Zi, e);
          } catch (n) {
            ua(e, e.return, n);
          }
          break;
        }
      }
    }
    function i3(e) {
      switch (e.tag) {
        case g:
        case G:
        case j: {
          try {
            zc(Ji | Zi, e, e.return);
          } catch (l) {
            ua(e, e.return, l);
          }
          break;
        }
        case S: {
          var n = e.stateNode;
          typeof n.componentWillUnmount == "function" && $x(e, e.return, n);
          break;
        }
      }
    }
    function o3(e) {
      switch (e.tag) {
        case g:
        case G:
        case j:
          try {
            zc(ko | Zi, e, e.return);
          } catch (n) {
            ua(e, e.return, n);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var gy = Symbol.for;
      gy("selector.component"), gy("selector.has_pseudo_class"), gy("selector.role"), gy("selector.test_id"), gy("selector.text");
    }
    var l3 = [];
    function s3() {
      l3.forEach(function(e) {
        return e();
      });
    }
    var u3 = i.ReactCurrentActQueue;
    function c3(e) {
      {
        var n = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), l = typeof jest < "u";
        return l && n !== !1;
      }
    }
    function YI() {
      {
        var e = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !e && u3.current !== null && h("The current testing environment is not configured to support act(...)"), e;
      }
    }
    var f3 = Math.ceil, Kx = i.ReactCurrentDispatcher, qx = i.ReactCurrentOwner, Vo = i.ReactCurrentBatchConfig, Yc = i.ReactCurrentActQueue, qi = (
      /*             */
      0
    ), $I = (
      /*               */
      1
    ), Ho = (
      /*                */
      2
    ), Gu = (
      /*                */
      4
    ), mp = 0, by = 1, rm = 2, N1 = 3, yy = 4, ZI = 5, eR = 6, or = qi, kl = null, Ja = null, eo = je, td = je, tR = go(je), to = mp, Cy = null, _1 = je, Ey = je, O1 = je, Sy = null, vs = null, nR = 0, JI = 500, QI = 1 / 0, d3 = 500, gp = null;
    function xy() {
      QI = kr() + d3;
    }
    function KI() {
      return QI;
    }
    var L1 = !1, rR = null, _g = null, am = !1, Hh = null, Ry = je, aR = [], iR = null, p3 = 50, Ty = 0, oR = null, lR = !1, D1 = !1, h3 = 50, Og = 0, M1 = null, wy = Rr, P1 = je, qI = !1;
    function k1() {
      return kl;
    }
    function Fl() {
      return (or & (Ho | Gu)) !== qi ? kr() : (wy !== Rr || (wy = kr()), wy);
    }
    function jh(e) {
      var n = e.mode;
      if ((n & Ut) === Ft)
        return Ht;
      if ((or & Ho) !== qi && eo !== je)
        return _f(eo);
      var l = uL() !== sL;
      if (l) {
        if (Vo.transition !== null) {
          var f = Vo.transition;
          f._updatedFibers || (f._updatedFibers = /* @__PURE__ */ new Set()), f._updatedFibers.add(e);
        }
        return P1 === Ia && (P1 = jd()), P1;
      }
      var m = Lo();
      if (m !== Ia)
        return m;
      var E = NE();
      return E;
    }
    function v3(e) {
      var n = e.mode;
      return (n & Ut) === Ft ? Ht : zi();
    }
    function no(e, n, l, f) {
      U3(), qI && h("useInsertionEffect must not schedule updates."), lR && (D1 = !0), Vs(e, l, f), (or & Ho) !== je && e === kl ? j3(n) : (za && Lf(e, n, l), G3(n), e === kl && ((or & Ho) === qi && (Ey = yn(Ey, l)), to === yy && Gh(e, eo)), ms(e, f), l === Ht && or === qi && (n.mode & Ut) === Ft && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Yc.isBatchingLegacy && (xy(), q2()));
    }
    function m3(e, n, l) {
      var f = e.current;
      f.lanes = n, Vs(e, n, l), ms(e, l);
    }
    function g3(e) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (or & Ho) !== qi
      );
    }
    function ms(e, n) {
      var l = e.callbackNode;
      Nf(e, n);
      var f = Rc(e, e === kl ? eo : je);
      if (f === je) {
        l !== null && vA(l), e.callbackNode = null, e.callbackPriority = Ia;
        return;
      }
      var m = aa(f), E = e.callbackPriority;
      if (E === m && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Yc.current !== null && l !== hR)) {
        l == null && E !== Ht && h("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      l != null && vA(l);
      var w;
      if (m === Ht)
        e.tag === Oh ? (Yc.isBatchingLegacy !== null && (Yc.didScheduleLegacyUpdate = !0), W4(nA.bind(null, e))) : K2(nA.bind(null, e)), Yc.current !== null ? Yc.current.push(Lh) : OE(function() {
          (or & (Ho | Gu)) === qi && Lh();
        }), w = null;
      else {
        var O;
        switch (Zr(f)) {
          case ia:
            O = _d;
            break;
          case ls:
            O = mc;
            break;
          case $r:
            O = Oo;
            break;
          case Df:
            O = Od;
            break;
          default:
            O = Oo;
            break;
        }
        w = vR(O, eA.bind(null, e));
      }
      e.callbackPriority = m, e.callbackNode = w;
    }
    function eA(e, n) {
      if (PL(), wy = Rr, P1 = je, (or & (Ho | Gu)) !== qi)
        throw new Error("Should not already be working.");
      var l = e.callbackNode, f = yp();
      if (f && e.callbackNode !== l)
        return null;
      var m = Rc(e, e === kl ? eo : je);
      if (m === je)
        return null;
      var E = !Au(e, m) && !Bm(e, m) && !n, w = E ? I3(e, m) : B1(e, m);
      if (w !== mp) {
        if (w === rm) {
          var O = Bs(e);
          O !== je && (m = O, w = sR(e, O));
        }
        if (w === by) {
          var D = Cy;
          throw im(e, je), Gh(e, m), ms(e, kr()), D;
        }
        if (w === eR)
          Gh(e, m);
        else {
          var X = !Au(e, m), Z = e.current.alternate;
          if (X && !y3(Z)) {
            if (w = B1(e, m), w === rm) {
              var ue = Bs(e);
              ue !== je && (m = ue, w = sR(e, ue));
            }
            if (w === by) {
              var se = Cy;
              throw im(e, je), Gh(e, m), ms(e, kr()), se;
            }
          }
          e.finishedWork = Z, e.finishedLanes = m, b3(e, w, m);
        }
      }
      return ms(e, kr()), e.callbackNode === l ? eA.bind(null, e) : null;
    }
    function sR(e, n) {
      var l = Sy;
      if (oi(e)) {
        var f = im(e, n);
        f.flags |= pa, fS(e.containerInfo);
      }
      var m = B1(e, n);
      if (m !== rm) {
        var E = vs;
        vs = l, E !== null && tA(E);
      }
      return m;
    }
    function tA(e) {
      vs === null ? vs = e : vs.push.apply(vs, e);
    }
    function b3(e, n, l) {
      switch (n) {
        case mp:
        case by:
          throw new Error("Root did not complete. This is a bug in React.");
        case rm: {
          om(e, vs, gp);
          break;
        }
        case N1: {
          if (Gh(e, l), Cv(l) && // do not delay if we're inside an act() scope
          !mA()) {
            var f = nR + JI - kr();
            if (f > 10) {
              var m = Rc(e, je);
              if (m !== je)
                break;
              var E = e.suspendedLanes;
              if (!Nu(E, l)) {
                Fl(), Ic(e, E);
                break;
              }
              e.timeoutHandle = kb(om.bind(null, e, vs, gp), f);
              break;
            }
          }
          om(e, vs, gp);
          break;
        }
        case yy: {
          if (Gh(e, l), rh(l))
            break;
          if (!mA()) {
            var w = bv(e, l), O = w, D = kr() - O, X = B3(D) - D;
            if (X > 10) {
              e.timeoutHandle = kb(om.bind(null, e, vs, gp), X);
              break;
            }
          }
          om(e, vs, gp);
          break;
        }
        case ZI: {
          om(e, vs, gp);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function y3(e) {
      for (var n = e; ; ) {
        if (n.flags & Id) {
          var l = n.updateQueue;
          if (l !== null) {
            var f = l.stores;
            if (f !== null)
              for (var m = 0; m < f.length; m++) {
                var E = f[m], w = E.getSnapshot, O = E.value;
                try {
                  if (!Nt(w(), O))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var D = n.child;
        if (n.subtreeFlags & Id && D !== null) {
          D.return = n, n = D;
          continue;
        }
        if (n === e)
          return !0;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === e)
            return !0;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
      return !0;
    }
    function Gh(e, n) {
      n = Of(n, O1), n = Of(n, Ey), oh(e, n);
    }
    function nA(e) {
      if (kL(), (or & (Ho | Gu)) !== qi)
        throw new Error("Should not already be working.");
      yp();
      var n = Rc(e, je);
      if (!Wi(n, Ht))
        return ms(e, kr()), null;
      var l = B1(e, n);
      if (e.tag !== Oh && l === rm) {
        var f = Bs(e);
        f !== je && (n = f, l = sR(e, f));
      }
      if (l === by) {
        var m = Cy;
        throw im(e, je), Gh(e, n), ms(e, kr()), m;
      }
      if (l === eR)
        throw new Error("Root did not complete. This is a bug in React.");
      var E = e.current.alternate;
      return e.finishedWork = E, e.finishedLanes = n, om(e, vs, gp), ms(e, kr()), null;
    }
    function C3(e, n) {
      n !== je && (Yt(e, yn(n, Ht)), ms(e, kr()), (or & (Ho | Gu)) === qi && (xy(), Lh()));
    }
    function uR(e, n) {
      var l = or;
      or |= $I;
      try {
        return e(n);
      } finally {
        or = l, or === qi && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Yc.isBatchingLegacy && (xy(), q2());
      }
    }
    function E3(e, n, l, f, m) {
      var E = Lo(), w = Vo.transition;
      try {
        return Vo.transition = null, ma(ia), e(n, l, f, m);
      } finally {
        ma(E), Vo.transition = w, or === qi && xy();
      }
    }
    function bp(e) {
      Hh !== null && Hh.tag === Oh && (or & (Ho | Gu)) === qi && yp();
      var n = or;
      or |= $I;
      var l = Vo.transition, f = Lo();
      try {
        return Vo.transition = null, ma(ia), e ? e() : void 0;
      } finally {
        ma(f), Vo.transition = l, or = n, (or & (Ho | Gu)) === qi && Lh();
      }
    }
    function rA() {
      return (or & (Ho | Gu)) !== qi;
    }
    function F1(e, n) {
      bl(tR, td, e), td = yn(td, n);
    }
    function cR(e) {
      td = tR.current, $i(tR, e);
    }
    function im(e, n) {
      e.finishedWork = null, e.finishedLanes = je;
      var l = e.timeoutHandle;
      if (l !== Fb && (e.timeoutHandle = Fb, _E(l)), Ja !== null)
        for (var f = Ja.return; f !== null; ) {
          var m = f.alternate;
          LI(m, f), f = f.return;
        }
      kl = e;
      var E = lm(e.current, null);
      return Ja = E, eo = td = n, to = mp, Cy = null, _1 = je, Ey = je, O1 = je, Sy = null, vs = null, mL(), Uc.discardPendingWarnings(), E;
    }
    function aA(e, n) {
      do {
        var l = Ja;
        try {
          if (Y0(), Aw(), da(), qx.current = null, l === null || l.return === null) {
            to = by, Cy = n, Ja = null;
            return;
          }
          if (nt && l.mode & rn && S1(l, !0), ot)
            if (ho(), n !== null && typeof n == "object" && typeof n.then == "function") {
              var f = n;
              Ps(l, f, eo);
            } else
              xf(l, n, eo);
          WL(e, l.return, l, n, eo), sA(l);
        } catch (m) {
          n = m, Ja === l && l !== null ? (l = l.return, Ja = l) : l = Ja;
          continue;
        }
        return;
      } while (!0);
    }
    function iA() {
      var e = Kx.current;
      return Kx.current = g1, e === null ? g1 : e;
    }
    function oA(e) {
      Kx.current = e;
    }
    function S3() {
      nR = kr();
    }
    function Iy(e) {
      _1 = yn(e, _1);
    }
    function x3() {
      to === mp && (to = N1);
    }
    function fR() {
      (to === mp || to === N1 || to === rm) && (to = yy), kl !== null && (Iu(_1) || Iu(Ey)) && Gh(kl, eo);
    }
    function R3(e) {
      to !== yy && (to = rm), Sy === null ? Sy = [e] : Sy.push(e);
    }
    function T3() {
      return to === mp;
    }
    function B1(e, n) {
      var l = or;
      or |= Ho;
      var f = iA();
      if (kl !== e || eo !== n) {
        if (za) {
          var m = e.memoizedUpdaters;
          m.size > 0 && (Ay(e, eo), m.clear()), js(e, n);
        }
        gp = zd(), im(e, n);
      }
      Yr(n);
      do
        try {
          w3();
          break;
        } catch (E) {
          aA(e, E);
        }
      while (!0);
      if (Y0(), or = l, oA(f), Ja !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Zp(), kl = null, eo = je, to;
    }
    function w3() {
      for (; Ja !== null; )
        lA(Ja);
    }
    function I3(e, n) {
      var l = or;
      or |= Ho;
      var f = iA();
      if (kl !== e || eo !== n) {
        if (za) {
          var m = e.memoizedUpdaters;
          m.size > 0 && (Ay(e, eo), m.clear()), js(e, n);
        }
        gp = zd(), xy(), im(e, n);
      }
      Yr(n);
      do
        try {
          A3();
          break;
        } catch (E) {
          aA(e, E);
        }
      while (!0);
      return Y0(), oA(f), or = l, Ja !== null ? (bc(), mp) : (Zp(), kl = null, eo = je, to);
    }
    function A3() {
      for (; Ja !== null && !Nd(); )
        lA(Ja);
    }
    function lA(e) {
      var n = e.alternate;
      gr(e);
      var l;
      (e.mode & rn) !== Ft ? (hx(e), l = dR(n, e, td), S1(e, !0)) : l = dR(n, e, td), da(), e.memoizedProps = e.pendingProps, l === null ? sA(e) : Ja = l, qx.current = null;
    }
    function sA(e) {
      var n = e;
      do {
        var l = n.alternate, f = n.return;
        if ((n.flags & No) === zt) {
          gr(n);
          var m = void 0;
          if ((n.mode & rn) === Ft ? m = OI(l, n, td) : (hx(n), m = OI(l, n, td), S1(n, !1)), da(), m !== null) {
            Ja = m;
            return;
          }
        } else {
          var E = xD(l, n);
          if (E !== null) {
            E.flags &= Dm, Ja = E;
            return;
          }
          if ((n.mode & rn) !== Ft) {
            S1(n, !1);
            for (var w = n.actualDuration, O = n.child; O !== null; )
              w += O.actualDuration, O = O.sibling;
            n.actualDuration = w;
          }
          if (f !== null)
            f.flags |= No, f.subtreeFlags = zt, f.deletions = null;
          else {
            to = eR, Ja = null;
            return;
          }
        }
        var D = n.sibling;
        if (D !== null) {
          Ja = D;
          return;
        }
        n = f, Ja = n;
      } while (n !== null);
      to === mp && (to = ZI);
    }
    function om(e, n, l) {
      var f = Lo(), m = Vo.transition;
      try {
        Vo.transition = null, ma(ia), N3(e, n, l, f);
      } finally {
        Vo.transition = m, ma(f);
      }
      return null;
    }
    function N3(e, n, l, f) {
      do
        yp();
      while (Hh !== null);
      if (V3(), (or & (Ho | Gu)) !== qi)
        throw new Error("Should not already be working.");
      var m = e.finishedWork, E = e.finishedLanes;
      if (ll(E), m === null)
        return Ld(), null;
      if (E === je && h("root.finishedLanes should not be empty during a commit. This is a bug in React."), e.finishedWork = null, e.finishedLanes = je, m === e.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      e.callbackNode = null, e.callbackPriority = Ia;
      var w = yn(m.lanes, m.childLanes);
      Hs(e, w), e === kl && (kl = null, Ja = null, eo = je), ((m.subtreeFlags & al) !== zt || (m.flags & al) !== zt) && (am || (am = !0, iR = l, vR(Oo, function() {
        return yp(), null;
      })));
      var O = (m.subtreeFlags & (bf | fo | Ri | al)) !== zt, D = (m.flags & (bf | fo | Ri | al)) !== zt;
      if (O || D) {
        var X = Vo.transition;
        Vo.transition = null;
        var Z = Lo();
        ma(ia);
        var ue = or;
        or |= Gu, qx.current = null, AD(e, m), qw(), jD(e, m, E), xE(e.containerInfo), e.current = m, mv(E), GD(m, e, E), Cu(), hv(), or = ue, ma(Z), Vo.transition = X;
      } else
        e.current = m, qw();
      var se = am;
      if (am ? (am = !1, Hh = e, Ry = E) : (Og = 0, M1 = null), w = e.pendingLanes, w === je && (_g = null), se || dA(e.current, !1), yu(m.stateNode, f), za && e.memoizedUpdaters.clear(), s3(), ms(e, kr()), n !== null)
        for (var Ie = e.onRecoverableError, Ae = 0; Ae < n.length; Ae++) {
          var Me = n[Ae], gt = Me.stack, Kt = Me.digest;
          Ie(Me.value, {
            componentStack: gt,
            digest: Kt
          });
        }
      if (L1) {
        L1 = !1;
        var jt = rR;
        throw rR = null, jt;
      }
      return Wi(Ry, Ht) && e.tag !== Oh && yp(), w = e.pendingLanes, Wi(w, Ht) ? (ML(), e === oR ? Ty++ : (Ty = 0, oR = e)) : Ty = 0, Lh(), Ld(), null;
    }
    function yp() {
      if (Hh !== null) {
        var e = Zr(Ry), n = cb($r, e), l = Vo.transition, f = Lo();
        try {
          return Vo.transition = null, ma(n), O3();
        } finally {
          ma(f), Vo.transition = l;
        }
      }
      return !1;
    }
    function _3(e) {
      aR.push(e), am || (am = !0, vR(Oo, function() {
        return yp(), null;
      }));
    }
    function O3() {
      if (Hh === null)
        return !1;
      var e = iR;
      iR = null;
      var n = Hh, l = Ry;
      if (Hh = null, Ry = je, (or & (Ho | Gu)) !== qi)
        throw new Error("Cannot flush passive effects while already rendering.");
      lR = !0, D1 = !1, gv(l);
      var f = or;
      or |= Gu, JD(n.current), XD(n, n.current, l, e);
      {
        var m = aR;
        aR = [];
        for (var E = 0; E < m.length; E++) {
          var w = m[E];
          LD(n, w);
        }
      }
      $p(), dA(n.current, !0), or = f, Lh(), D1 ? n === M1 ? Og++ : (Og = 0, M1 = n) : Og = 0, lR = !1, D1 = !1, ol(n);
      {
        var O = n.current.stateNode;
        O.effectDuration = 0, O.passiveEffectDuration = 0;
      }
      return !0;
    }
    function uA(e) {
      return _g !== null && _g.has(e);
    }
    function L3(e) {
      _g === null ? _g = /* @__PURE__ */ new Set([e]) : _g.add(e);
    }
    function D3(e) {
      L1 || (L1 = !0, rR = e);
    }
    var M3 = D3;
    function cA(e, n, l) {
      var f = tm(l, n), m = lI(e, f, Ht), E = Mh(e, m, Ht), w = Fl();
      E !== null && (Vs(E, Ht, w), ms(E, w));
    }
    function ua(e, n, l) {
      if (TD(l), Ny(!1), e.tag === T) {
        cA(e, e, l);
        return;
      }
      var f = null;
      for (f = n; f !== null; ) {
        if (f.tag === T) {
          cA(f, e, l);
          return;
        } else if (f.tag === S) {
          var m = f.type, E = f.stateNode;
          if (typeof m.getDerivedStateFromError == "function" || typeof E.componentDidCatch == "function" && !uA(E)) {
            var w = tm(l, e), O = Lx(f, w, Ht), D = Mh(f, O, Ht), X = Fl();
            D !== null && (Vs(D, Ht, X), ms(D, X));
            return;
          }
        }
        f = f.return;
      }
      h(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, l);
    }
    function P3(e, n, l) {
      var f = e.pingCache;
      f !== null && f.delete(n);
      var m = Fl();
      Ic(e, l), z3(e), kl === e && Nu(eo, l) && (to === yy || to === N1 && Cv(eo) && kr() - nR < JI ? im(e, je) : O1 = yn(O1, l)), ms(e, m);
    }
    function fA(e, n) {
      n === Ia && (n = v3(e));
      var l = Fl(), f = ps(e, n);
      f !== null && (Vs(f, n, l), ms(f, l));
    }
    function k3(e) {
      var n = e.memoizedState, l = Ia;
      n !== null && (l = n.retryLane), fA(e, l);
    }
    function F3(e, n) {
      var l = Ia, f;
      switch (e.tag) {
        case W:
          f = e.stateNode;
          var m = e.memoizedState;
          m !== null && (l = m.retryLane);
          break;
        case Ne:
          f = e.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      f !== null && f.delete(n), fA(e, l);
    }
    function B3(e) {
      return e < 120 ? 120 : e < 480 ? 480 : e < 1080 ? 1080 : e < 1920 ? 1920 : e < 3e3 ? 3e3 : e < 4320 ? 4320 : f3(e / 1960) * 1960;
    }
    function U3() {
      if (Ty > p3)
        throw Ty = 0, oR = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Og > h3 && (Og = 0, M1 = null, h("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function V3() {
      Uc.flushLegacyContextWarning(), Uc.flushPendingUnsafeLifecycleWarnings();
    }
    function dA(e, n) {
      gr(e), U1(e, ta, i3), n && U1(e, hc, o3), U1(e, ta, r3), n && U1(e, hc, a3), da();
    }
    function U1(e, n, l) {
      for (var f = e, m = null; f !== null; ) {
        var E = f.subtreeFlags & n;
        f !== m && f.child !== null && E !== zt ? f = f.child : ((f.flags & n) !== zt && l(f), f.sibling !== null ? f = f.sibling : f = m = f.return);
      }
    }
    var V1 = null;
    function pA(e) {
      {
        if ((or & Ho) !== qi || !(e.mode & Ut))
          return;
        var n = e.tag;
        if (n !== x && n !== T && n !== S && n !== g && n !== G && n !== oe && n !== j)
          return;
        var l = dn(e) || "ReactComponent";
        if (V1 !== null) {
          if (V1.has(l))
            return;
          V1.add(l);
        } else
          V1 = /* @__PURE__ */ new Set([l]);
        var f = ra;
        try {
          gr(e), h("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          f ? gr(e) : da();
        }
      }
    }
    var dR;
    {
      var H3 = null;
      dR = function(e, n, l) {
        var f = EA(H3, n);
        try {
          return wI(e, n, l);
        } catch (E) {
          if (q4() || E !== null && typeof E == "object" && typeof E.then == "function")
            throw E;
          if (Y0(), Aw(), LI(e, n), EA(n, f), n.mode & rn && hx(n), es(null, wI, null, e, n, l), z()) {
            var m = vu();
            typeof m == "object" && m !== null && m._suppressLogging && typeof E == "object" && E !== null && !E._suppressLogging && (E._suppressLogging = !0);
          }
          throw E;
        }
      };
    }
    var hA = !1, pR;
    pR = /* @__PURE__ */ new Set();
    function j3(e) {
      if (oo && !OL())
        switch (e.tag) {
          case g:
          case G:
          case j: {
            var n = Ja && dn(Ja) || "Unknown", l = n;
            if (!pR.has(l)) {
              pR.add(l);
              var f = dn(e) || "Unknown";
              h("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", f, n, n);
            }
            break;
          }
          case S: {
            hA || (h("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), hA = !0);
            break;
          }
        }
    }
    function Ay(e, n) {
      if (za) {
        var l = e.memoizedUpdaters;
        l.forEach(function(f) {
          Lf(e, f, n);
        });
      }
    }
    var hR = {};
    function vR(e, n) {
      {
        var l = Yc.current;
        return l !== null ? (l.push(n), hR) : Ui(e, n);
      }
    }
    function vA(e) {
      if (e !== hR)
        return Mm(e);
    }
    function mA() {
      return Yc.current !== null;
    }
    function G3(e) {
      {
        if (e.mode & Ut) {
          if (!YI())
            return;
        } else if (!c3() || or !== qi || e.tag !== g && e.tag !== G && e.tag !== j)
          return;
        if (Yc.current === null) {
          var n = ra;
          try {
            gr(e), h(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, dn(e));
          } finally {
            n ? gr(e) : da();
          }
        }
      }
    }
    function z3(e) {
      e.tag !== Oh && YI() && Yc.current === null && h(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function Ny(e) {
      qI = e;
    }
    var zu = null, Lg = null, W3 = function(e) {
      zu = e;
    };
    function Dg(e) {
      {
        if (zu === null)
          return e;
        var n = zu(e);
        return n === void 0 ? e : n.current;
      }
    }
    function mR(e) {
      return Dg(e);
    }
    function gR(e) {
      {
        if (zu === null)
          return e;
        var n = zu(e);
        if (n === void 0) {
          if (e != null && typeof e.render == "function") {
            var l = Dg(e.render);
            if (e.render !== l) {
              var f = {
                $$typeof: be,
                render: l
              };
              return e.displayName !== void 0 && (f.displayName = e.displayName), f;
            }
          }
          return e;
        }
        return n.current;
      }
    }
    function gA(e, n) {
      {
        if (zu === null)
          return !1;
        var l = e.elementType, f = n.type, m = !1, E = typeof f == "object" && f !== null ? f.$$typeof : null;
        switch (e.tag) {
          case S: {
            typeof f == "function" && (m = !0);
            break;
          }
          case g: {
            (typeof f == "function" || E === Et) && (m = !0);
            break;
          }
          case G: {
            (E === be || E === Et) && (m = !0);
            break;
          }
          case oe:
          case j: {
            (E === bt || E === Et) && (m = !0);
            break;
          }
          default:
            return !1;
        }
        if (m) {
          var w = zu(l);
          if (w !== void 0 && w === zu(f))
            return !0;
        }
        return !1;
      }
    }
    function bA(e) {
      {
        if (zu === null || typeof WeakSet != "function")
          return;
        Lg === null && (Lg = /* @__PURE__ */ new WeakSet()), Lg.add(e);
      }
    }
    var X3 = function(e, n) {
      {
        if (zu === null)
          return;
        var l = n.staleFamilies, f = n.updatedFamilies;
        yp(), bp(function() {
          bR(e.current, f, l);
        });
      }
    }, Y3 = function(e, n) {
      {
        if (e.context !== Ys)
          return;
        yp(), bp(function() {
          _y(n, e, null, null);
        });
      }
    };
    function bR(e, n, l) {
      {
        var f = e.alternate, m = e.child, E = e.sibling, w = e.tag, O = e.type, D = null;
        switch (w) {
          case g:
          case j:
          case S:
            D = O;
            break;
          case G:
            D = O.render;
            break;
        }
        if (zu === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var X = !1, Z = !1;
        if (D !== null) {
          var ue = zu(D);
          ue !== void 0 && (l.has(ue) ? Z = !0 : n.has(ue) && (w === S ? Z = !0 : X = !0));
        }
        if (Lg !== null && (Lg.has(e) || f !== null && Lg.has(f)) && (Z = !0), Z && (e._debugNeedsRemount = !0), Z || X) {
          var se = ps(e, Ht);
          se !== null && no(se, e, Ht, Rr);
        }
        m !== null && !Z && bR(m, n, l), E !== null && bR(E, n, l);
      }
    }
    var $3 = function(e, n) {
      {
        var l = /* @__PURE__ */ new Set(), f = new Set(n.map(function(m) {
          return m.current;
        }));
        return yR(e.current, f, l), l;
      }
    };
    function yR(e, n, l) {
      {
        var f = e.child, m = e.sibling, E = e.tag, w = e.type, O = null;
        switch (E) {
          case g:
          case j:
          case S:
            O = w;
            break;
          case G:
            O = w.render;
            break;
        }
        var D = !1;
        O !== null && n.has(O) && (D = !0), D ? Z3(e, l) : f !== null && yR(f, n, l), m !== null && yR(m, n, l);
      }
    }
    function Z3(e, n) {
      {
        var l = J3(e, n);
        if (l)
          return;
        for (var f = e; ; ) {
          switch (f.tag) {
            case L:
              n.add(f.stateNode);
              return;
            case _:
              n.add(f.stateNode.containerInfo);
              return;
            case T:
              n.add(f.stateNode.containerInfo);
              return;
          }
          if (f.return === null)
            throw new Error("Expected to reach root first.");
          f = f.return;
        }
      }
    }
    function J3(e, n) {
      for (var l = e, f = !1; ; ) {
        if (l.tag === L)
          f = !0, n.add(l.stateNode);
        else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === e)
          return f;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === e)
            return f;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
      return !1;
    }
    var CR;
    {
      CR = !1;
      try {
        var yA = Object.preventExtensions({});
      } catch {
        CR = !0;
      }
    }
    function Q3(e, n, l, f) {
      this.tag = e, this.key = l, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = n, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = f, this.flags = zt, this.subtreeFlags = zt, this.deletions = null, this.lanes = je, this.childLanes = je, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !CR && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var $s = function(e, n, l, f) {
      return new Q3(e, n, l, f);
    };
    function ER(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function K3(e) {
      return typeof e == "function" && !ER(e) && e.defaultProps === void 0;
    }
    function q3(e) {
      if (typeof e == "function")
        return ER(e) ? S : g;
      if (e != null) {
        var n = e.$$typeof;
        if (n === be)
          return G;
        if (n === bt)
          return oe;
      }
      return x;
    }
    function lm(e, n) {
      var l = e.alternate;
      l === null ? (l = $s(e.tag, n, e.key, e.mode), l.elementType = e.elementType, l.type = e.type, l.stateNode = e.stateNode, l._debugSource = e._debugSource, l._debugOwner = e._debugOwner, l._debugHookTypes = e._debugHookTypes, l.alternate = e, e.alternate = l) : (l.pendingProps = n, l.type = e.type, l.flags = zt, l.subtreeFlags = zt, l.deletions = null, l.actualDuration = 0, l.actualStartTime = -1), l.flags = e.flags & ii, l.childLanes = e.childLanes, l.lanes = e.lanes, l.child = e.child, l.memoizedProps = e.memoizedProps, l.memoizedState = e.memoizedState, l.updateQueue = e.updateQueue;
      var f = e.dependencies;
      switch (l.dependencies = f === null ? null : {
        lanes: f.lanes,
        firstContext: f.firstContext
      }, l.sibling = e.sibling, l.index = e.index, l.ref = e.ref, l.selfBaseDuration = e.selfBaseDuration, l.treeBaseDuration = e.treeBaseDuration, l._debugNeedsRemount = e._debugNeedsRemount, l.tag) {
        case x:
        case g:
        case j:
          l.type = Dg(e.type);
          break;
        case S:
          l.type = mR(e.type);
          break;
        case G:
          l.type = gR(e.type);
          break;
      }
      return l;
    }
    function e5(e, n) {
      e.flags &= ii | Xr;
      var l = e.alternate;
      if (l === null)
        e.childLanes = je, e.lanes = n, e.child = null, e.subtreeFlags = zt, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0;
      else {
        e.childLanes = l.childLanes, e.lanes = l.lanes, e.child = l.child, e.subtreeFlags = zt, e.deletions = null, e.memoizedProps = l.memoizedProps, e.memoizedState = l.memoizedState, e.updateQueue = l.updateQueue, e.type = l.type;
        var f = l.dependencies;
        e.dependencies = f === null ? null : {
          lanes: f.lanes,
          firstContext: f.firstContext
        }, e.selfBaseDuration = l.selfBaseDuration, e.treeBaseDuration = l.treeBaseDuration;
      }
      return e;
    }
    function t5(e, n, l) {
      var f;
      return e === F0 ? (f = Ut, n === !0 && (f |= _n, f |= Hi)) : f = Ft, za && (f |= rn), $s(T, null, null, f);
    }
    function SR(e, n, l, f, m, E) {
      var w = x, O = e;
      if (typeof e == "function")
        ER(e) ? (w = S, O = mR(O)) : O = Dg(O);
      else if (typeof e == "string")
        w = L;
      else
        e:
          switch (e) {
            case rt:
              return zh(l.children, m, E, n);
            case _t:
              w = B, m |= _n, (m & Ut) !== Ft && (m |= Hi);
              break;
            case Vt:
              return n5(l, m, E, n);
            case Fe:
              return r5(l, m, E, n);
            case ut:
              return a5(l, m, E, n);
            case nn:
              return CA(l, m, E, n);
            case sr:
            case Tt:
            case Wr:
            case Ma:
            case Zt:
            default: {
              if (typeof e == "object" && e !== null)
                switch (e.$$typeof) {
                  case J:
                    w = Y;
                    break e;
                  case ve:
                    w = H;
                    break e;
                  case be:
                    w = G, O = gR(O);
                    break e;
                  case bt:
                    w = oe;
                    break e;
                  case Et:
                    w = re, O = null;
                    break e;
                }
              var D = "";
              {
                (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (D += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var X = f ? dn(f) : null;
                X && (D += `

Check the render method of \`` + X + "`.");
              }
              throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (e == null ? e : typeof e) + "." + D));
            }
          }
      var Z = $s(w, l, n, m);
      return Z.elementType = e, Z.type = O, Z.lanes = E, Z._debugOwner = f, Z;
    }
    function xR(e, n, l) {
      var f = null;
      f = e._owner;
      var m = e.type, E = e.key, w = e.props, O = SR(m, E, w, f, n, l);
      return O._debugSource = e._source, O._debugOwner = e._owner, O;
    }
    function zh(e, n, l, f) {
      var m = $s(U, e, f, n);
      return m.lanes = l, m;
    }
    function n5(e, n, l, f) {
      typeof e.id != "string" && h('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof e.id);
      var m = $s(Q, e, f, n | rn);
      return m.elementType = Vt, m.lanes = l, m.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, m;
    }
    function r5(e, n, l, f) {
      var m = $s(W, e, f, n);
      return m.elementType = Fe, m.lanes = l, m;
    }
    function a5(e, n, l, f) {
      var m = $s(Ne, e, f, n);
      return m.elementType = ut, m.lanes = l, m;
    }
    function CA(e, n, l, f) {
      var m = $s(ze, e, f, n);
      m.elementType = nn, m.lanes = l;
      var E = {
        isHidden: !1
      };
      return m.stateNode = E, m;
    }
    function RR(e, n, l) {
      var f = $s(M, e, null, n);
      return f.lanes = l, f;
    }
    function i5() {
      var e = $s(L, null, null, Ft);
      return e.elementType = "DELETED", e;
    }
    function o5(e) {
      var n = $s(Se, null, null, Ft);
      return n.stateNode = e, n;
    }
    function TR(e, n, l) {
      var f = e.children !== null ? e.children : [], m = $s(_, f, e.key, n);
      return m.lanes = l, m.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: e.implementation
      }, m;
    }
    function EA(e, n) {
      return e === null && (e = $s(x, null, null, Ft)), e.tag = n.tag, e.key = n.key, e.elementType = n.elementType, e.type = n.type, e.stateNode = n.stateNode, e.return = n.return, e.child = n.child, e.sibling = n.sibling, e.index = n.index, e.ref = n.ref, e.pendingProps = n.pendingProps, e.memoizedProps = n.memoizedProps, e.updateQueue = n.updateQueue, e.memoizedState = n.memoizedState, e.dependencies = n.dependencies, e.mode = n.mode, e.flags = n.flags, e.subtreeFlags = n.subtreeFlags, e.deletions = n.deletions, e.lanes = n.lanes, e.childLanes = n.childLanes, e.alternate = n.alternate, e.actualDuration = n.actualDuration, e.actualStartTime = n.actualStartTime, e.selfBaseDuration = n.selfBaseDuration, e.treeBaseDuration = n.treeBaseDuration, e._debugSource = n._debugSource, e._debugOwner = n._debugOwner, e._debugNeedsRemount = n._debugNeedsRemount, e._debugHookTypes = n._debugHookTypes, e;
    }
    function l5(e, n, l, f, m) {
      this.tag = n, this.containerInfo = e, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = Fb, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Ia, this.eventTimes = wc(je), this.expirationTimes = wc(Rr), this.pendingLanes = je, this.suspendedLanes = je, this.pingedLanes = je, this.expiredLanes = je, this.mutableReadLanes = je, this.finishedLanes = je, this.entangledLanes = je, this.entanglements = wc(je), this.identifierPrefix = f, this.onRecoverableError = m, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var E = this.pendingUpdatersLaneMap = [], w = 0; w < kd; w++)
          E.push(/* @__PURE__ */ new Set());
      }
      switch (n) {
        case F0:
          this._debugRootType = l ? "hydrateRoot()" : "createRoot()";
          break;
        case Oh:
          this._debugRootType = l ? "hydrate()" : "render()";
          break;
      }
    }
    function SA(e, n, l, f, m, E, w, O, D, X) {
      var Z = new l5(e, n, l, O, D), ue = t5(n, E);
      Z.current = ue, ue.stateNode = Z;
      {
        var se = {
          element: f,
          isDehydrated: l,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        ue.memoizedState = se;
      }
      return BS(ue), Z;
    }
    var wR = "18.3.1";
    function s5(e, n, l) {
      var f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return ja(f), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: Ue,
        key: f == null ? null : "" + f,
        children: e,
        containerInfo: n,
        implementation: l
      };
    }
    var IR, AR;
    IR = !1, AR = {};
    function xA(e) {
      if (!e)
        return Ys;
      var n = Bi(e), l = z4(n);
      if (n.tag === S) {
        var f = n.type;
        if ($f(f))
          return J2(n, f, l);
      }
      return l;
    }
    function u5(e, n) {
      {
        var l = Bi(e);
        if (l === void 0) {
          if (typeof e.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var f = Object.keys(e).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + f);
        }
        var m = il(l);
        if (m === null)
          return null;
        if (m.mode & _n) {
          var E = dn(l) || "Component";
          if (!AR[E]) {
            AR[E] = !0;
            var w = ra;
            try {
              gr(m), l.mode & _n ? h("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", n, n, E) : h("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", n, n, E);
            } finally {
              w ? gr(w) : da();
            }
          }
        }
        return m.stateNode;
      }
    }
    function RA(e, n, l, f, m, E, w, O) {
      var D = !1, X = null;
      return SA(e, n, D, X, l, f, m, E, w);
    }
    function TA(e, n, l, f, m, E, w, O, D, X) {
      var Z = !0, ue = SA(l, f, Z, e, m, E, w, O, D);
      ue.context = xA(null);
      var se = ue.current, Ie = Fl(), Ae = jh(se), Me = hp(Ie, Ae);
      return Me.callback = n ?? null, Mh(se, Me, Ae), m3(ue, Ae, Ie), ue;
    }
    function _y(e, n, l, f) {
      di(n, e);
      var m = n.current, E = Fl(), w = jh(m);
      Jp(w);
      var O = xA(l);
      n.context === null ? n.context = O : n.pendingContext = O, oo && ra !== null && !IR && (IR = !0, h(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, dn(ra) || "Unknown"));
      var D = hp(E, w);
      D.payload = {
        element: e
      }, f = f === void 0 ? null : f, f !== null && (typeof f != "function" && h("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", f), D.callback = f);
      var X = Mh(m, D, w);
      return X !== null && (no(X, m, w, E), K0(X, m, w)), w;
    }
    function H1(e) {
      var n = e.current;
      if (!n.child)
        return null;
      switch (n.child.tag) {
        case L:
          return n.child.stateNode;
        default:
          return n.child.stateNode;
      }
    }
    function c5(e) {
      switch (e.tag) {
        case T: {
          var n = e.stateNode;
          if (oi(n)) {
            var l = yv(n);
            C3(n, l);
          }
          break;
        }
        case W: {
          bp(function() {
            var m = ps(e, Ht);
            if (m !== null) {
              var E = Fl();
              no(m, e, Ht, E);
            }
          });
          var f = Ht;
          NR(e, f);
          break;
        }
      }
    }
    function wA(e, n) {
      var l = e.memoizedState;
      l !== null && l.dehydrated !== null && (l.retryLane = os(l.retryLane, n));
    }
    function NR(e, n) {
      wA(e, n);
      var l = e.alternate;
      l && wA(l, n);
    }
    function f5(e) {
      if (e.tag === W) {
        var n = Af, l = ps(e, n);
        if (l !== null) {
          var f = Fl();
          no(l, e, n, f);
        }
        NR(e, n);
      }
    }
    function d5(e) {
      if (e.tag === W) {
        var n = jh(e), l = ps(e, n);
        if (l !== null) {
          var f = Fl();
          no(l, e, n, f);
        }
        NR(e, n);
      }
    }
    function IA(e) {
      var n = Gp(e);
      return n === null ? null : n.stateNode;
    }
    var AA = function(e) {
      return null;
    };
    function p5(e) {
      return AA(e);
    }
    var NA = function(e) {
      return !1;
    };
    function h5(e) {
      return NA(e);
    }
    var _A = null, OA = null, LA = null, DA = null, MA = null, PA = null, kA = null, FA = null, BA = null;
    {
      var UA = function(e, n, l) {
        var f = n[l], m = Hn(e) ? e.slice() : on({}, e);
        return l + 1 === n.length ? (Hn(m) ? m.splice(f, 1) : delete m[f], m) : (m[f] = UA(e[f], n, l + 1), m);
      }, VA = function(e, n) {
        return UA(e, n, 0);
      }, HA = function(e, n, l, f) {
        var m = n[f], E = Hn(e) ? e.slice() : on({}, e);
        if (f + 1 === n.length) {
          var w = l[f];
          E[w] = E[m], Hn(E) ? E.splice(m, 1) : delete E[m];
        } else
          E[m] = HA(
            // $FlowFixMe number or string is fine here
            e[m],
            n,
            l,
            f + 1
          );
        return E;
      }, jA = function(e, n, l) {
        if (n.length !== l.length) {
          v("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var f = 0; f < l.length - 1; f++)
            if (n[f] !== l[f]) {
              v("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return HA(e, n, l, 0);
      }, GA = function(e, n, l, f) {
        if (l >= n.length)
          return f;
        var m = n[l], E = Hn(e) ? e.slice() : on({}, e);
        return E[m] = GA(e[m], n, l + 1, f), E;
      }, zA = function(e, n, l) {
        return GA(e, n, 0, l);
      }, _R = function(e, n) {
        for (var l = e.memoizedState; l !== null && n > 0; )
          l = l.next, n--;
        return l;
      };
      _A = function(e, n, l, f) {
        var m = _R(e, n);
        if (m !== null) {
          var E = zA(m.memoizedState, l, f);
          m.memoizedState = E, m.baseState = E, e.memoizedProps = on({}, e.memoizedProps);
          var w = ps(e, Ht);
          w !== null && no(w, e, Ht, Rr);
        }
      }, OA = function(e, n, l) {
        var f = _R(e, n);
        if (f !== null) {
          var m = VA(f.memoizedState, l);
          f.memoizedState = m, f.baseState = m, e.memoizedProps = on({}, e.memoizedProps);
          var E = ps(e, Ht);
          E !== null && no(E, e, Ht, Rr);
        }
      }, LA = function(e, n, l, f) {
        var m = _R(e, n);
        if (m !== null) {
          var E = jA(m.memoizedState, l, f);
          m.memoizedState = E, m.baseState = E, e.memoizedProps = on({}, e.memoizedProps);
          var w = ps(e, Ht);
          w !== null && no(w, e, Ht, Rr);
        }
      }, DA = function(e, n, l) {
        e.pendingProps = zA(e.memoizedProps, n, l), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var f = ps(e, Ht);
        f !== null && no(f, e, Ht, Rr);
      }, MA = function(e, n) {
        e.pendingProps = VA(e.memoizedProps, n), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var l = ps(e, Ht);
        l !== null && no(l, e, Ht, Rr);
      }, PA = function(e, n, l) {
        e.pendingProps = jA(e.memoizedProps, n, l), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var f = ps(e, Ht);
        f !== null && no(f, e, Ht, Rr);
      }, kA = function(e) {
        var n = ps(e, Ht);
        n !== null && no(n, e, Ht, Rr);
      }, FA = function(e) {
        AA = e;
      }, BA = function(e) {
        NA = e;
      };
    }
    function v5(e) {
      var n = il(e);
      return n === null ? null : n.stateNode;
    }
    function m5(e) {
      return null;
    }
    function g5() {
      return ra;
    }
    function b5(e) {
      var n = e.findFiberByHostInstance, l = i.ReactCurrentDispatcher;
      return Wp({
        bundleType: e.bundleType,
        version: e.version,
        rendererPackageName: e.rendererPackageName,
        rendererConfig: e.rendererConfig,
        overrideHookState: _A,
        overrideHookStateDeletePath: OA,
        overrideHookStateRenamePath: LA,
        overrideProps: DA,
        overridePropsDeletePath: MA,
        overridePropsRenamePath: PA,
        setErrorHandler: FA,
        setSuspenseHandler: BA,
        scheduleUpdate: kA,
        currentDispatcherRef: l,
        findHostInstanceByFiber: v5,
        findFiberByHostInstance: n || m5,
        // React Refresh
        findHostInstancesForRefresh: $3,
        scheduleRefresh: X3,
        scheduleRoot: Y3,
        setRefreshHandler: W3,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: g5,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: wR
      });
    }
    var WA = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(e) {
      console.error(e);
    };
    function OR(e) {
      this._internalRoot = e;
    }
    j1.prototype.render = OR.prototype.render = function(e) {
      var n = this._internalRoot;
      if (n === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? h("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : G1(arguments[1]) ? h("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && h("You passed a second argument to root.render(...) but it only accepts one argument.");
        var l = n.containerInfo;
        if (l.nodeType !== ur) {
          var f = IA(n.current);
          f && f.parentNode !== l && h("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      _y(e, n, null, null);
    }, j1.prototype.unmount = OR.prototype.unmount = function() {
      typeof arguments[0] == "function" && h("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var e = this._internalRoot;
      if (e !== null) {
        this._internalRoot = null;
        var n = e.containerInfo;
        rA() && h("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), bp(function() {
          _y(null, e, null, null);
        }), He(n);
      }
    };
    function y5(e, n) {
      if (!G1(e))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      XA(e);
      var l = !1, f = !1, m = "", E = WA;
      n != null && (n.hydrate ? v("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof n == "object" && n !== null && n.$$typeof === xe && h(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), n.unstable_strictMode === !0 && (l = !0), n.identifierPrefix !== void 0 && (m = n.identifierPrefix), n.onRecoverableError !== void 0 && (E = n.onRecoverableError), n.transitionCallbacks !== void 0 && n.transitionCallbacks);
      var w = RA(e, F0, null, l, f, m, E);
      de(w.current, e);
      var O = e.nodeType === ur ? e.parentNode : e;
      return Fv(O), new OR(w);
    }
    function j1(e) {
      this._internalRoot = e;
    }
    function C5(e) {
      e && Hm(e);
    }
    j1.prototype.unstable_scheduleHydration = C5;
    function E5(e, n, l) {
      if (!G1(e))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      XA(e), n === void 0 && h("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var f = l ?? null, m = l != null && l.hydratedSources || null, E = !1, w = !1, O = "", D = WA;
      l != null && (l.unstable_strictMode === !0 && (E = !0), l.identifierPrefix !== void 0 && (O = l.identifierPrefix), l.onRecoverableError !== void 0 && (D = l.onRecoverableError));
      var X = TA(n, null, e, F0, f, E, w, O, D);
      if (de(X.current, e), Fv(e), m)
        for (var Z = 0; Z < m.length; Z++) {
          var ue = m[Z];
          TL(X, ue);
        }
      return new j1(X);
    }
    function G1(e) {
      return !!(e && (e.nodeType === so || e.nodeType === To || e.nodeType === Tl || !pe));
    }
    function Oy(e) {
      return !!(e && (e.nodeType === so || e.nodeType === To || e.nodeType === Tl || e.nodeType === ur && e.nodeValue === " react-mount-point-unstable "));
    }
    function XA(e) {
      e.nodeType === so && e.tagName && e.tagName.toUpperCase() === "BODY" && h("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), Be(e) && (e._reactRootContainer ? h("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : h("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var S5 = i.ReactCurrentOwner, YA;
    YA = function(e) {
      if (e._reactRootContainer && e.nodeType !== ur) {
        var n = IA(e._reactRootContainer.current);
        n && n.parentNode !== e && h("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var l = !!e._reactRootContainer, f = LR(e), m = !!(f && ft(f));
      m && !l && h("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), e.nodeType === so && e.tagName && e.tagName.toUpperCase() === "BODY" && h("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function LR(e) {
      return e ? e.nodeType === To ? e.documentElement : e.firstChild : null;
    }
    function $A() {
    }
    function x5(e, n, l, f, m) {
      if (m) {
        if (typeof f == "function") {
          var E = f;
          f = function() {
            var se = H1(w);
            E.call(se);
          };
        }
        var w = TA(
          n,
          f,
          e,
          Oh,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          $A
        );
        e._reactRootContainer = w, de(w.current, e);
        var O = e.nodeType === ur ? e.parentNode : e;
        return Fv(O), bp(), w;
      } else {
        for (var D; D = e.lastChild; )
          e.removeChild(D);
        if (typeof f == "function") {
          var X = f;
          f = function() {
            var se = H1(Z);
            X.call(se);
          };
        }
        var Z = RA(
          e,
          Oh,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          $A
        );
        e._reactRootContainer = Z, de(Z.current, e);
        var ue = e.nodeType === ur ? e.parentNode : e;
        return Fv(ue), bp(function() {
          _y(n, Z, l, f);
        }), Z;
      }
    }
    function R5(e, n) {
      e !== null && typeof e != "function" && h("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", n, e);
    }
    function z1(e, n, l, f, m) {
      YA(l), R5(m === void 0 ? null : m, "render");
      var E = l._reactRootContainer, w;
      if (!E)
        w = x5(l, n, e, m, f);
      else {
        if (w = E, typeof m == "function") {
          var O = m;
          m = function() {
            var D = H1(w);
            O.call(D);
          };
        }
        _y(n, w, e, m);
      }
      return H1(w);
    }
    var ZA = !1;
    function T5(e) {
      {
        ZA || (ZA = !0, h("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var n = S5.current;
        if (n !== null && n.stateNode !== null) {
          var l = n.stateNode._warnedAboutRefsInRender;
          l || h("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Un(n.type) || "A component"), n.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return e == null ? null : e.nodeType === so ? e : u5(e, "findDOMNode");
    }
    function w5(e, n, l) {
      if (h("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Oy(n))
        throw new Error("Target container is not a DOM element.");
      {
        var f = Be(n) && n._reactRootContainer === void 0;
        f && h("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return z1(null, e, n, !0, l);
    }
    function I5(e, n, l) {
      if (h("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Oy(n))
        throw new Error("Target container is not a DOM element.");
      {
        var f = Be(n) && n._reactRootContainer === void 0;
        f && h("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return z1(null, e, n, !1, l);
    }
    function A5(e, n, l, f) {
      if (h("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Oy(l))
        throw new Error("Target container is not a DOM element.");
      if (e == null || !xi(e))
        throw new Error("parentComponent must be a valid React Component");
      return z1(e, n, l, !1, f);
    }
    var JA = !1;
    function N5(e) {
      if (JA || (JA = !0, h("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !Oy(e))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var n = Be(e) && e._reactRootContainer === void 0;
        n && h("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (e._reactRootContainer) {
        {
          var l = LR(e), f = l && !ft(l);
          f && h("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return bp(function() {
          z1(null, null, e, !1, function() {
            e._reactRootContainer = null, He(e);
          });
        }), !0;
      } else {
        {
          var m = LR(e), E = !!(m && ft(m)), w = e.nodeType === so && Oy(e.parentNode) && !!e.parentNode._reactRootContainer;
          E && h("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", w ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    kf(c5), fb(f5), Xd(d5), Um(Lo), Vm(vi), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && h("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Up(w0), Rd(uR, E3, bp);
    function _5(e, n) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!G1(n))
        throw new Error("Target container is not a DOM element.");
      return s5(e, n, null, l);
    }
    function O5(e, n, l, f) {
      return A5(e, n, l, f);
    }
    var DR = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [ft, Dt, en, Vp, xd, uR]
    };
    function L5(e, n) {
      return DR.usingClientEntryPoint || h('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), y5(e, n);
    }
    function D5(e, n, l) {
      return DR.usingClientEntryPoint || h('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), E5(e, n, l);
    }
    function M5(e) {
      return rA() && h("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), bp(e);
    }
    var P5 = b5({
      findFiberByHostInstance: Xe,
      bundleType: 1,
      version: wR,
      rendererPackageName: "react-dom"
    });
    if (!P5 && mn && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var QA = window.location.protocol;
      /^(https?|file):$/.test(QA) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (QA === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    bs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = DR, bs.createPortal = _5, bs.createRoot = L5, bs.findDOMNode = T5, bs.flushSync = M5, bs.hydrate = w5, bs.hydrateRoot = D5, bs.render = I5, bs.unmountComponentAtNode = N5, bs.unstable_batchedUpdates = uR, bs.unstable_renderSubtreeIntoContainer = O5, bs.version = wR, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), bs;
}
function t9() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t9);
    } catch (t) {
      console.error(t);
    }
  }
}
process.env.NODE_ENV === "production" ? (t9(), cT.exports = X5()) : cT.exports = Y5();
var Jg = cT.exports;
const $5 = /* @__PURE__ */ KT(Jg), Z5 = /* @__PURE__ */ q_({
  __proto__: null,
  default: $5
}, [Jg]);
var ky = Jg;
if (process.env.NODE_ENV === "production")
  Gy.createRoot = ky.createRoot, Gy.hydrateRoot = ky.hydrateRoot;
else {
  var X1 = ky.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  Gy.createRoot = function(t, r) {
    X1.usingClientEntryPoint = !0;
    try {
      return ky.createRoot(t, r);
    } finally {
      X1.usingClientEntryPoint = !1;
    }
  }, Gy.hydrateRoot = function(t, r, i) {
    X1.usingClientEntryPoint = !0;
    try {
      return ky.hydrateRoot(t, r, i);
    } finally {
      X1.usingClientEntryPoint = !1;
    }
  };
}
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Ua() {
  return Ua = Object.assign ? Object.assign.bind() : function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var i = arguments[r];
      for (var u in i)
        Object.prototype.hasOwnProperty.call(i, u) && (t[u] = i[u]);
    }
    return t;
  }, Ua.apply(this, arguments);
}
var Ci;
(function(t) {
  t.Pop = "POP", t.Push = "PUSH", t.Replace = "REPLACE";
})(Ci || (Ci = {}));
const lN = "popstate";
function J5(t) {
  t === void 0 && (t = {});
  function r(u, c) {
    let {
      pathname: v,
      search: h,
      hash: y
    } = u.location;
    return Ky(
      "",
      {
        pathname: v,
        search: h,
        hash: y
      },
      // state defaults to `null` because `window.history.state` does
      c.state && c.state.usr || null,
      c.state && c.state.key || "default"
    );
  }
  function i(u, c) {
    return typeof c == "string" ? c : Zh(c);
  }
  return K5(r, i, null, t);
}
function qt(t, r) {
  if (t === !1 || t === null || typeof t > "u")
    throw new Error(r);
}
function Di(t, r) {
  if (!t) {
    typeof console < "u" && console.warn(r);
    try {
      throw new Error(r);
    } catch {
    }
  }
}
function Q5() {
  return Math.random().toString(36).substr(2, 8);
}
function sN(t, r) {
  return {
    usr: t.state,
    key: t.key,
    idx: r
  };
}
function Ky(t, r, i, u) {
  return i === void 0 && (i = null), Ua({
    pathname: typeof t == "string" ? t : t.pathname,
    search: "",
    hash: ""
  }, typeof r == "string" ? xp(r) : r, {
    state: i,
    // TODO: This could be cleaned up.  push/replace should probably just take
    // full Locations now and avoid the need to run through this flow at all
    // But that's a pretty big refactor to the current test suite so going to
    // keep as is for the time being and just let any incoming keys take precedence
    key: r && r.key || u || Q5()
  });
}
function Zh(t) {
  let {
    pathname: r = "/",
    search: i = "",
    hash: u = ""
  } = t;
  return i && i !== "?" && (r += i.charAt(0) === "?" ? i : "?" + i), u && u !== "#" && (r += u.charAt(0) === "#" ? u : "#" + u), r;
}
function xp(t) {
  let r = {};
  if (t) {
    let i = t.indexOf("#");
    i >= 0 && (r.hash = t.substr(i), t = t.substr(0, i));
    let u = t.indexOf("?");
    u >= 0 && (r.search = t.substr(u), t = t.substr(0, u)), t && (r.pathname = t);
  }
  return r;
}
function K5(t, r, i, u) {
  u === void 0 && (u = {});
  let {
    window: c = document.defaultView,
    v5Compat: v = !1
  } = u, h = c.history, y = Ci.Pop, g = null, S = x();
  S == null && (S = 0, h.replaceState(Ua({}, h.state, {
    idx: S
  }), ""));
  function x() {
    return (h.state || {
      idx: null
    }).idx;
  }
  function T() {
    y = Ci.Pop;
    let B = x(), H = B == null ? null : B - S;
    S = B, g && g({
      action: y,
      location: U.location,
      delta: H
    });
  }
  function _(B, H) {
    y = Ci.Push;
    let Y = Ky(U.location, B, H);
    i && i(Y, B), S = x() + 1;
    let G = sN(Y, S), Q = U.createHref(Y);
    try {
      h.pushState(G, "", Q);
    } catch (W) {
      if (W instanceof DOMException && W.name === "DataCloneError")
        throw W;
      c.location.assign(Q);
    }
    v && g && g({
      action: y,
      location: U.location,
      delta: 1
    });
  }
  function L(B, H) {
    y = Ci.Replace;
    let Y = Ky(U.location, B, H);
    i && i(Y, B), S = x();
    let G = sN(Y, S), Q = U.createHref(Y);
    h.replaceState(G, "", Q), v && g && g({
      action: y,
      location: U.location,
      delta: 0
    });
  }
  function M(B) {
    let H = c.location.origin !== "null" ? c.location.origin : c.location.href, Y = typeof B == "string" ? B : Zh(B);
    return Y = Y.replace(/ $/, "%20"), qt(H, "No window.location.(origin|href) available to create URL for href: " + Y), new URL(Y, H);
  }
  let U = {
    get action() {
      return y;
    },
    get location() {
      return t(c, h);
    },
    listen(B) {
      if (g)
        throw new Error("A history only accepts one active listener");
      return c.addEventListener(lN, T), g = B, () => {
        c.removeEventListener(lN, T), g = null;
      };
    },
    createHref(B) {
      return r(c, B);
    },
    createURL: M,
    encodeLocation(B) {
      let H = M(B);
      return {
        pathname: H.pathname,
        search: H.search,
        hash: H.hash
      };
    },
    push: _,
    replace: L,
    go(B) {
      return h.go(B);
    }
  };
  return U;
}
var Kr;
(function(t) {
  t.data = "data", t.deferred = "deferred", t.redirect = "redirect", t.error = "error";
})(Kr || (Kr = {}));
const q5 = /* @__PURE__ */ new Set(["lazy", "caseSensitive", "path", "id", "index", "children"]);
function eM(t) {
  return t.index === !0;
}
function vC(t, r, i, u) {
  return i === void 0 && (i = []), u === void 0 && (u = {}), t.map((c, v) => {
    let h = [...i, String(v)], y = typeof c.id == "string" ? c.id : h.join("-");
    if (qt(c.index !== !0 || !c.children, "Cannot specify children on an index route"), qt(!u[y], 'Found a route id collision on id "' + y + `".  Route id's must be globally unique within Data Router usages`), eM(c)) {
      let g = Ua({}, c, r(c), {
        id: y
      });
      return u[y] = g, g;
    } else {
      let g = Ua({}, c, r(c), {
        id: y,
        children: void 0
      });
      return u[y] = g, c.children && (g.children = vC(c.children, r, h, u)), g;
    }
  });
}
function cm(t, r, i) {
  return i === void 0 && (i = "/"), iC(t, r, i, !1);
}
function iC(t, r, i, u) {
  let c = typeof r == "string" ? xp(r) : r, v = Ks(c.pathname || "/", i);
  if (v == null)
    return null;
  let h = n9(t);
  nM(h);
  let y = null;
  for (let g = 0; y == null && g < h.length; ++g) {
    let S = pM(v);
    y = fM(h[g], S, u);
  }
  return y;
}
function tM(t, r) {
  let {
    route: i,
    pathname: u,
    params: c
  } = t;
  return {
    id: i.id,
    pathname: u,
    params: c,
    data: r[i.id],
    handle: i.handle
  };
}
function n9(t, r, i, u) {
  r === void 0 && (r = []), i === void 0 && (i = []), u === void 0 && (u = "");
  let c = (v, h, y) => {
    let g = {
      relativePath: y === void 0 ? v.path || "" : y,
      caseSensitive: v.caseSensitive === !0,
      childrenIndex: h,
      route: v
    };
    g.relativePath.startsWith("/") && (qt(g.relativePath.startsWith(u), 'Absolute route path "' + g.relativePath + '" nested under path ' + ('"' + u + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes."), g.relativePath = g.relativePath.slice(u.length));
    let S = id([u, g.relativePath]), x = i.concat(g);
    v.children && v.children.length > 0 && (qt(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      v.index !== !0,
      "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + S + '".')
    ), n9(v.children, r, x, S)), !(v.path == null && !v.index) && r.push({
      path: S,
      score: uM(S, v.index),
      routesMeta: x
    });
  };
  return t.forEach((v, h) => {
    var y;
    if (v.path === "" || !((y = v.path) != null && y.includes("?")))
      c(v, h);
    else
      for (let g of r9(v.path))
        c(v, h, g);
  }), r;
}
function r9(t) {
  let r = t.split("/");
  if (r.length === 0)
    return [];
  let [i, ...u] = r, c = i.endsWith("?"), v = i.replace(/\?$/, "");
  if (u.length === 0)
    return c ? [v, ""] : [v];
  let h = r9(u.join("/")), y = [];
  return y.push(...h.map((g) => g === "" ? v : [v, g].join("/"))), c && y.push(...h), y.map((g) => t.startsWith("/") && g === "" ? "/" : g);
}
function nM(t) {
  t.sort((r, i) => r.score !== i.score ? i.score - r.score : cM(r.routesMeta.map((u) => u.childrenIndex), i.routesMeta.map((u) => u.childrenIndex)));
}
const rM = /^:[\w-]+$/, aM = 3, iM = 2, oM = 1, lM = 10, sM = -2, uN = (t) => t === "*";
function uM(t, r) {
  let i = t.split("/"), u = i.length;
  return i.some(uN) && (u += sM), r && (u += iM), i.filter((c) => !uN(c)).reduce((c, v) => c + (rM.test(v) ? aM : v === "" ? oM : lM), u);
}
function cM(t, r) {
  return t.length === r.length && t.slice(0, -1).every((u, c) => u === r[c]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    t[t.length - 1] - r[r.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function fM(t, r, i) {
  i === void 0 && (i = !1);
  let {
    routesMeta: u
  } = t, c = {}, v = "/", h = [];
  for (let y = 0; y < u.length; ++y) {
    let g = u[y], S = y === u.length - 1, x = v === "/" ? r : r.slice(v.length) || "/", T = pm({
      path: g.relativePath,
      caseSensitive: g.caseSensitive,
      end: S
    }, x), _ = g.route;
    if (!T && S && i && !u[u.length - 1].route.index && (T = pm({
      path: g.relativePath,
      caseSensitive: g.caseSensitive,
      end: !1
    }, x)), !T)
      return null;
    Object.assign(c, T.params), h.push({
      // TODO: Can this as be avoided?
      params: c,
      pathname: id([v, T.pathname]),
      pathnameBase: mM(id([v, T.pathnameBase])),
      route: _
    }), T.pathnameBase !== "/" && (v = id([v, T.pathnameBase]));
  }
  return h;
}
function pm(t, r) {
  typeof t == "string" && (t = {
    path: t,
    caseSensitive: !1,
    end: !0
  });
  let [i, u] = dM(t.path, t.caseSensitive, t.end), c = r.match(i);
  if (!c)
    return null;
  let v = c[0], h = v.replace(/(.)\/+$/, "$1"), y = c.slice(1);
  return {
    params: u.reduce((S, x, T) => {
      let {
        paramName: _,
        isOptional: L
      } = x;
      if (_ === "*") {
        let U = y[T] || "";
        h = v.slice(0, v.length - U.length).replace(/(.)\/+$/, "$1");
      }
      const M = y[T];
      return L && !M ? S[_] = void 0 : S[_] = (M || "").replace(/%2F/g, "/"), S;
    }, {}),
    pathname: v,
    pathnameBase: h,
    pattern: t
  };
}
function dM(t, r, i) {
  r === void 0 && (r = !1), i === void 0 && (i = !0), Di(t === "*" || !t.endsWith("*") || t.endsWith("/*"), 'Route path "' + t + '" will be treated as if it were ' + ('"' + t.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + t.replace(/\*$/, "/*") + '".'));
  let u = [], c = "^" + t.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (h, y, g) => (u.push({
    paramName: y,
    isOptional: g != null
  }), g ? "/?([^\\/]+)?" : "/([^\\/]+)"));
  return t.endsWith("*") ? (u.push({
    paramName: "*"
  }), c += t === "*" || t === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : i ? c += "\\/*$" : t !== "" && t !== "/" && (c += "(?:(?=\\/|$))"), [new RegExp(c, r ? void 0 : "i"), u];
}
function pM(t) {
  try {
    return t.split("/").map((r) => decodeURIComponent(r).replace(/\//g, "%2F")).join("/");
  } catch (r) {
    return Di(!1, 'The URL path "' + t + '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent ' + ("encoding (" + r + ").")), t;
  }
}
function Ks(t, r) {
  if (r === "/")
    return t;
  if (!t.toLowerCase().startsWith(r.toLowerCase()))
    return null;
  let i = r.endsWith("/") ? r.length - 1 : r.length, u = t.charAt(i);
  return u && u !== "/" ? null : t.slice(i) || "/";
}
function hM(t, r) {
  r === void 0 && (r = "/");
  let {
    pathname: i,
    search: u = "",
    hash: c = ""
  } = typeof t == "string" ? xp(t) : t;
  return {
    pathname: i ? i.startsWith("/") ? i : vM(i, r) : r,
    search: gM(u),
    hash: bM(c)
  };
}
function vM(t, r) {
  let i = r.replace(/\/+$/, "").split("/");
  return t.split("/").forEach((c) => {
    c === ".." ? i.length > 1 && i.pop() : c !== "." && i.push(c);
  }), i.length > 1 ? i.join("/") : "/";
}
function kR(t, r, i, u) {
  return "Cannot include a '" + t + "' character in a manually specified " + ("`to." + r + "` field [" + JSON.stringify(u) + "].  Please separate it out to the ") + ("`to." + i + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function a9(t) {
  return t.filter((r, i) => i === 0 || r.route.path && r.route.path.length > 0);
}
function OC(t, r) {
  let i = a9(t);
  return r ? i.map((u, c) => c === i.length - 1 ? u.pathname : u.pathnameBase) : i.map((u) => u.pathnameBase);
}
function LC(t, r, i, u) {
  u === void 0 && (u = !1);
  let c;
  typeof t == "string" ? c = xp(t) : (c = Ua({}, t), qt(!c.pathname || !c.pathname.includes("?"), kR("?", "pathname", "search", c)), qt(!c.pathname || !c.pathname.includes("#"), kR("#", "pathname", "hash", c)), qt(!c.search || !c.search.includes("#"), kR("#", "search", "hash", c)));
  let v = t === "" || c.pathname === "", h = v ? "/" : c.pathname, y;
  if (h == null)
    y = i;
  else {
    let T = r.length - 1;
    if (!u && h.startsWith("..")) {
      let _ = h.split("/");
      for (; _[0] === ".."; )
        _.shift(), T -= 1;
      c.pathname = _.join("/");
    }
    y = T >= 0 ? r[T] : "/";
  }
  let g = hM(c, y), S = h && h !== "/" && h.endsWith("/"), x = (v || h === ".") && i.endsWith("/");
  return !g.pathname.endsWith("/") && (S || x) && (g.pathname += "/"), g;
}
const id = (t) => t.join("/").replace(/\/\/+/g, "/"), mM = (t) => t.replace(/\/+$/, "").replace(/^\/*/, "/"), gM = (t) => !t || t === "?" ? "" : t.startsWith("?") ? t : "?" + t, bM = (t) => !t || t === "#" ? "" : t.startsWith("#") ? t : "#" + t;
class mC {
  constructor(r, i, u, c) {
    c === void 0 && (c = !1), this.status = r, this.statusText = i || "", this.internal = c, u instanceof Error ? (this.data = u.toString(), this.error = u) : this.data = u;
  }
}
function qy(t) {
  return t != null && typeof t.status == "number" && typeof t.statusText == "string" && typeof t.internal == "boolean" && "data" in t;
}
const i9 = ["post", "put", "patch", "delete"], yM = new Set(i9), CM = ["get", ...i9], EM = new Set(CM), SM = /* @__PURE__ */ new Set([301, 302, 303, 307, 308]), xM = /* @__PURE__ */ new Set([307, 308]), FR = {
  state: "idle",
  location: void 0,
  formMethod: void 0,
  formAction: void 0,
  formEncType: void 0,
  formData: void 0,
  json: void 0,
  text: void 0
}, RM = {
  state: "idle",
  data: void 0,
  formMethod: void 0,
  formAction: void 0,
  formEncType: void 0,
  formData: void 0,
  json: void 0,
  text: void 0
}, Ug = {
  state: "unblocked",
  proceed: void 0,
  reset: void 0,
  location: void 0
}, qT = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, TM = (t) => ({
  hasErrorBoundary: !!t.hasErrorBoundary
}), o9 = "remix-router-transitions";
function wM(t) {
  const r = t.window ? t.window : typeof window < "u" ? window : void 0, i = typeof r < "u" && typeof r.document < "u" && typeof r.document.createElement < "u", u = !i;
  qt(t.routes.length > 0, "You must provide a non-empty routes array to createRouter");
  let c;
  if (t.mapRouteProperties)
    c = t.mapRouteProperties;
  else if (t.detectErrorBoundary) {
    let ne = t.detectErrorBoundary;
    c = (ce) => ({
      hasErrorBoundary: ne(ce)
    });
  } else
    c = TM;
  let v = {}, h = vC(t.routes, c, void 0, v), y, g = t.basename || "/", S = t.dataStrategy || _M, x = t.patchRoutesOnNavigation, T = Ua({
    v7_fetcherPersist: !1,
    v7_normalizeFormMethod: !1,
    v7_partialHydration: !1,
    v7_prependBasename: !1,
    v7_relativeSplatPath: !1,
    v7_skipActionErrorRevalidation: !1
  }, t.future), _ = null, L = /* @__PURE__ */ new Set(), M = null, U = null, B = null, H = t.hydrationData != null, Y = cm(h, t.history.location, g), G = !1, Q = null;
  if (Y == null && !x) {
    let ne = ys(404, {
      pathname: t.history.location.pathname
    }), {
      matches: ce,
      route: xe
    } = CN(h);
    Y = ce, Q = {
      [xe.id]: ne
    };
  }
  Y && !t.hydrationData && Xo(Y, h, t.history.location.pathname).active && (Y = null);
  let W;
  if (Y)
    if (Y.some((ne) => ne.route.lazy))
      W = !1;
    else if (!Y.some((ne) => ne.route.loader))
      W = !0;
    else if (T.v7_partialHydration) {
      let ne = t.hydrationData ? t.hydrationData.loaderData : null, ce = t.hydrationData ? t.hydrationData.errors : null;
      if (ce) {
        let xe = Y.findIndex((Ue) => ce[Ue.route.id] !== void 0);
        W = Y.slice(0, xe + 1).every((Ue) => !dT(Ue.route, ne, ce));
      } else
        W = Y.every((xe) => !dT(xe.route, ne, ce));
    } else
      W = t.hydrationData != null;
  else if (W = !1, Y = [], T.v7_partialHydration) {
    let ne = Xo(null, h, t.history.location.pathname);
    ne.active && ne.matches && (G = !0, Y = ne.matches);
  }
  let oe, j = {
    historyAction: t.history.action,
    location: t.history.location,
    matches: Y,
    initialized: W,
    navigation: FR,
    // Don't restore on initial updateState() if we were SSR'd
    restoreScrollPosition: t.hydrationData != null ? !1 : null,
    preventScrollReset: !1,
    revalidation: "idle",
    loaderData: t.hydrationData && t.hydrationData.loaderData || {},
    actionData: t.hydrationData && t.hydrationData.actionData || null,
    errors: t.hydrationData && t.hydrationData.errors || Q,
    fetchers: /* @__PURE__ */ new Map(),
    blockers: /* @__PURE__ */ new Map()
  }, re = Ci.Pop, me = !1, Se, Ne = !1, Ge = /* @__PURE__ */ new Map(), ze = null, qe = !1, at = !1, st = [], We = /* @__PURE__ */ new Set(), he = /* @__PURE__ */ new Map(), ke = 0, _e = -1, q = /* @__PURE__ */ new Map(), pe = /* @__PURE__ */ new Set(), $e = /* @__PURE__ */ new Map(), lt = /* @__PURE__ */ new Map(), ot = /* @__PURE__ */ new Set(), nt = /* @__PURE__ */ new Map(), Rt = /* @__PURE__ */ new Map(), ht;
  function dt() {
    if (_ = t.history.listen((ne) => {
      let {
        action: ce,
        location: xe,
        delta: Ue
      } = ne;
      if (ht) {
        ht(), ht = void 0;
        return;
      }
      Di(Rt.size === 0 || Ue != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
      let rt = qa({
        currentLocation: j.location,
        nextLocation: xe,
        historyAction: ce
      });
      if (rt && Ue != null) {
        let _t = new Promise((Vt) => {
          ht = Vt;
        });
        t.history.go(Ue * -1), Qn(rt, {
          state: "blocked",
          location: xe,
          proceed() {
            Qn(rt, {
              state: "proceeding",
              proceed: void 0,
              reset: void 0,
              location: xe
            }), _t.then(() => t.history.go(Ue));
          },
          reset() {
            let Vt = new Map(j.blockers);
            Vt.set(rt, Ug), Ze({
              blockers: Vt
            });
          }
        });
        return;
      }
      return ar(ce, xe);
    }), i) {
      zM(r, Ge);
      let ne = () => WM(r, Ge);
      r.addEventListener("pagehide", ne), ze = () => r.removeEventListener("pagehide", ne);
    }
    return j.initialized || ar(Ci.Pop, j.location, {
      initialHydration: !0
    }), oe;
  }
  function sn() {
    _ && _(), ze && ze(), L.clear(), Se && Se.abort(), j.fetchers.forEach((ne, ce) => it(ce)), j.blockers.forEach((ne, ce) => Ga(ce));
  }
  function bn(ne) {
    return L.add(ne), () => L.delete(ne);
  }
  function Ze(ne, ce) {
    ce === void 0 && (ce = {}), j = Ua({}, j, ne);
    let xe = [], Ue = [];
    T.v7_fetcherPersist && j.fetchers.forEach((rt, _t) => {
      rt.state === "idle" && (ot.has(_t) ? Ue.push(_t) : xe.push(_t));
    }), ot.forEach((rt) => {
      !j.fetchers.has(rt) && !he.has(rt) && Ue.push(rt);
    }), [...L].forEach((rt) => rt(j, {
      deletedFetchers: Ue,
      viewTransitionOpts: ce.viewTransitionOpts,
      flushSync: ce.flushSync === !0
    })), T.v7_fetcherPersist ? (xe.forEach((rt) => j.fetchers.delete(rt)), Ue.forEach((rt) => it(rt))) : Ue.forEach((rt) => ot.delete(rt));
  }
  function mn(ne, ce, xe) {
    var Ue, rt;
    let {
      flushSync: _t
    } = xe === void 0 ? {} : xe, Vt = j.actionData != null && j.navigation.formMethod != null && Zc(j.navigation.formMethod) && j.navigation.state === "loading" && ((Ue = ne.state) == null ? void 0 : Ue._isRedirect) !== !0, J;
    ce.actionData ? Object.keys(ce.actionData).length > 0 ? J = ce.actionData : J = null : Vt ? J = j.actionData : J = null;
    let ve = ce.loaderData ? bN(j.loaderData, ce.loaderData, ce.matches || [], ce.errors) : j.loaderData, be = j.blockers;
    be.size > 0 && (be = new Map(be), be.forEach((bt, Et) => be.set(Et, Ug)));
    let Fe = me === !0 || j.navigation.formMethod != null && Zc(j.navigation.formMethod) && ((rt = ne.state) == null ? void 0 : rt._isRedirect) !== !0;
    y && (h = y, y = void 0), qe || re === Ci.Pop || (re === Ci.Push ? t.history.push(ne, ne.state) : re === Ci.Replace && t.history.replace(ne, ne.state));
    let ut;
    if (re === Ci.Pop) {
      let bt = Ge.get(j.location.pathname);
      bt && bt.has(ne.pathname) ? ut = {
        currentLocation: j.location,
        nextLocation: ne
      } : Ge.has(ne.pathname) && (ut = {
        currentLocation: ne,
        nextLocation: j.location
      });
    } else if (Ne) {
      let bt = Ge.get(j.location.pathname);
      bt ? bt.add(ne.pathname) : (bt = /* @__PURE__ */ new Set([ne.pathname]), Ge.set(j.location.pathname, bt)), ut = {
        currentLocation: j.location,
        nextLocation: ne
      };
    }
    Ze(Ua({}, ce, {
      actionData: J,
      loaderData: ve,
      historyAction: re,
      location: ne,
      initialized: !0,
      navigation: FR,
      revalidation: "idle",
      restoreScrollPosition: Xl(ne, ce.matches || j.matches),
      preventScrollReset: Fe,
      blockers: be
    }), {
      viewTransitionOpts: ut,
      flushSync: _t === !0
    }), re = Ci.Pop, me = !1, Ne = !1, qe = !1, at = !1, st = [];
  }
  async function fn(ne, ce) {
    if (typeof ne == "number") {
      t.history.go(ne);
      return;
    }
    let xe = fT(j.location, j.matches, g, T.v7_prependBasename, ne, T.v7_relativeSplatPath, ce == null ? void 0 : ce.fromRouteId, ce == null ? void 0 : ce.relative), {
      path: Ue,
      submission: rt,
      error: _t
    } = cN(T.v7_normalizeFormMethod, !1, xe, ce), Vt = j.location, J = Ky(j.location, Ue, ce && ce.state);
    J = Ua({}, J, t.history.encodeLocation(J));
    let ve = ce && ce.replace != null ? ce.replace : void 0, be = Ci.Push;
    ve === !0 ? be = Ci.Replace : ve === !1 || rt != null && Zc(rt.formMethod) && rt.formAction === j.location.pathname + j.location.search && (be = Ci.Replace);
    let Fe = ce && "preventScrollReset" in ce ? ce.preventScrollReset === !0 : void 0, ut = (ce && ce.flushSync) === !0, bt = qa({
      currentLocation: Vt,
      nextLocation: J,
      historyAction: be
    });
    if (bt) {
      Qn(bt, {
        state: "blocked",
        location: J,
        proceed() {
          Qn(bt, {
            state: "proceeding",
            proceed: void 0,
            reset: void 0,
            location: J
          }), fn(ne, ce);
        },
        reset() {
          let Et = new Map(j.blockers);
          Et.set(bt, Ug), Ze({
            blockers: Et
          });
        }
      });
      return;
    }
    return await ar(be, J, {
      submission: rt,
      // Send through the formData serialization error if we have one so we can
      // render at the right error boundary after we match routes
      pendingError: _t,
      preventScrollReset: Fe,
      replace: ce && ce.replace,
      enableViewTransition: ce && ce.viewTransition,
      flushSync: ut
    });
  }
  function Gn() {
    if (pr(), Ze({
      revalidation: "loading"
    }), j.navigation.state !== "submitting") {
      if (j.navigation.state === "idle") {
        ar(j.historyAction, j.location, {
          startUninterruptedRevalidation: !0
        });
        return;
      }
      ar(re || j.historyAction, j.navigation.location, {
        overrideNavigation: j.navigation,
        // Proxy through any rending view transition
        enableViewTransition: Ne === !0
      });
    }
  }
  async function ar(ne, ce, xe) {
    Se && Se.abort(), Se = null, re = ne, qe = (xe && xe.startUninterruptedRevalidation) === !0, Wl(j.location, j.matches), me = (xe && xe.preventScrollReset) === !0, Ne = (xe && xe.enableViewTransition) === !0;
    let Ue = y || h, rt = xe && xe.overrideNavigation, _t = xe != null && xe.initialHydration && j.matches && j.matches.length > 0 && !G ? (
      // `matchRoutes()` has already been called if we're in here via `router.initialize()`
      j.matches
    ) : cm(Ue, ce, g), Vt = (xe && xe.flushSync) === !0;
    if (_t && j.initialized && !at && kM(j.location, ce) && !(xe && xe.submission && Zc(xe.submission.formMethod))) {
      mn(ce, {
        matches: _t
      }, {
        flushSync: Vt
      });
      return;
    }
    let J = Xo(_t, Ue, ce.pathname);
    if (J.active && J.matches && (_t = J.matches), !_t) {
      let {
        error: Tt,
        notFoundMatches: Zt,
        route: nn
      } = Wn(ce.pathname);
      mn(ce, {
        matches: Zt,
        loaderData: {},
        errors: {
          [nn.id]: Tt
        }
      }, {
        flushSync: Vt
      });
      return;
    }
    Se = new AbortController();
    let ve = Pg(t.history, ce, Se.signal, xe && xe.submission), be;
    if (xe && xe.pendingError)
      be = [fm(_t).route.id, {
        type: Kr.error,
        error: xe.pendingError
      }];
    else if (xe && xe.submission && Zc(xe.submission.formMethod)) {
      let Tt = await Jn(ve, ce, xe.submission, _t, J.active, {
        replace: xe.replace,
        flushSync: Vt
      });
      if (Tt.shortCircuited)
        return;
      if (Tt.pendingActionResult) {
        let [Zt, nn] = Tt.pendingActionResult;
        if (Js(nn) && qy(nn.error) && nn.error.status === 404) {
          Se = null, mn(ce, {
            matches: Tt.matches,
            loaderData: {},
            errors: {
              [Zt]: nn.error
            }
          });
          return;
        }
      }
      _t = Tt.matches || _t, be = Tt.pendingActionResult, rt = BR(ce, xe.submission), Vt = !1, J.active = !1, ve = Pg(t.history, ve.url, ve.signal);
    }
    let {
      shortCircuited: Fe,
      matches: ut,
      loaderData: bt,
      errors: Et
    } = await Ha(ve, ce, _t, J.active, rt, xe && xe.submission, xe && xe.fetcherSubmission, xe && xe.replace, xe && xe.initialHydration === !0, Vt, be);
    Fe || (Se = null, mn(ce, Ua({
      matches: ut || _t
    }, yN(be), {
      loaderData: bt,
      errors: Et
    })));
  }
  async function Jn(ne, ce, xe, Ue, rt, _t) {
    _t === void 0 && (_t = {}), pr();
    let Vt = jM(ce, xe);
    if (Ze({
      navigation: Vt
    }, {
      flushSync: _t.flushSync === !0
    }), rt) {
      let be = await ao(Ue, ce.pathname, ne.signal);
      if (be.type === "aborted")
        return {
          shortCircuited: !0
        };
      if (be.type === "error") {
        let Fe = fm(be.partialMatches).route.id;
        return {
          matches: be.partialMatches,
          pendingActionResult: [Fe, {
            type: Kr.error,
            error: be.error
          }]
        };
      } else if (be.matches)
        Ue = be.matches;
      else {
        let {
          notFoundMatches: Fe,
          error: ut,
          route: bt
        } = Wn(ce.pathname);
        return {
          matches: Fe,
          pendingActionResult: [bt.id, {
            type: Kr.error,
            error: ut
          }]
        };
      }
    }
    let J, ve = zy(Ue, ce);
    if (!ve.route.action && !ve.route.lazy)
      J = {
        type: Kr.error,
        error: ys(405, {
          method: ne.method,
          pathname: ce.pathname,
          routeId: ve.route.id
        })
      };
    else if (J = (await Or("action", j, ne, [ve], Ue, null))[ve.route.id], ne.signal.aborted)
      return {
        shortCircuited: !0
      };
    if (dm(J)) {
      let be;
      return _t && _t.replace != null ? be = _t.replace : be = vN(J.response.headers.get("Location"), new URL(ne.url), g) === j.location.pathname + j.location.search, await xa(ne, J, !0, {
        submission: xe,
        replace: be
      }), {
        shortCircuited: !0
      };
    }
    if ($h(J))
      throw ys(400, {
        type: "defer-action"
      });
    if (Js(J)) {
      let be = fm(Ue, ve.route.id);
      return (_t && _t.replace) !== !0 && (re = Ci.Push), {
        matches: Ue,
        pendingActionResult: [be.route.id, J]
      };
    }
    return {
      matches: Ue,
      pendingActionResult: [ve.route.id, J]
    };
  }
  async function Ha(ne, ce, xe, Ue, rt, _t, Vt, J, ve, be, Fe) {
    let ut = rt || BR(ce, _t), bt = _t || Vt || SN(ut), Et = !qe && (!T.v7_partialHydration || !ve);
    if (Ue) {
      if (Et) {
        let hr = ja(Fe);
        Ze(Ua({
          navigation: ut
        }, hr !== void 0 ? {
          actionData: hr
        } : {}), {
          flushSync: be
        });
      }
      let An = await ao(xe, ce.pathname, ne.signal);
      if (An.type === "aborted")
        return {
          shortCircuited: !0
        };
      if (An.type === "error") {
        let hr = fm(An.partialMatches).route.id;
        return {
          matches: An.partialMatches,
          loaderData: {},
          errors: {
            [hr]: An.error
          }
        };
      } else if (An.matches)
        xe = An.matches;
      else {
        let {
          error: hr,
          notFoundMatches: Ta,
          route: xl
        } = Wn(ce.pathname);
        return {
          matches: Ta,
          loaderData: {},
          errors: {
            [xl.id]: hr
          }
        };
      }
    }
    let Tt = y || h, [Zt, nn] = dN(t.history, j, xe, bt, ce, T.v7_partialHydration && ve === !0, T.v7_skipActionErrorRevalidation, at, st, We, ot, $e, pe, Tt, g, Fe);
    if (Xn((An) => !(xe && xe.some((hr) => hr.route.id === An)) || Zt && Zt.some((hr) => hr.route.id === An)), _e = ++ke, Zt.length === 0 && nn.length === 0) {
      let An = zn();
      return mn(ce, Ua({
        matches: xe,
        loaderData: {},
        // Commit pending error if we're short circuiting
        errors: Fe && Js(Fe[1]) ? {
          [Fe[0]]: Fe[1].error
        } : null
      }, yN(Fe), An ? {
        fetchers: new Map(j.fetchers)
      } : {}), {
        flushSync: be
      }), {
        shortCircuited: !0
      };
    }
    if (Et) {
      let An = {};
      if (!Ue) {
        An.navigation = ut;
        let hr = ja(Fe);
        hr !== void 0 && (An.actionData = hr);
      }
      nn.length > 0 && (An.fetchers = qr(nn)), Ze(An, {
        flushSync: be
      });
    }
    nn.forEach((An) => {
      $t(An.key), An.controller && he.set(An.key, An.controller);
    });
    let sr = () => nn.forEach((An) => $t(An.key));
    Se && Se.signal.addEventListener("abort", sr);
    let {
      loaderResults: Wr,
      fetcherResults: Ma
    } = await fi(j, xe, Zt, nn, ne);
    if (ne.signal.aborted)
      return {
        shortCircuited: !0
      };
    Se && Se.signal.removeEventListener("abort", sr), nn.forEach((An) => he.delete(An.key));
    let hn = Y1(Wr);
    if (hn)
      return await xa(ne, hn.result, !0, {
        replace: J
      }), {
        shortCircuited: !0
      };
    if (hn = Y1(Ma), hn)
      return pe.add(hn.key), await xa(ne, hn.result, !0, {
        replace: J
      }), {
        shortCircuited: !0
      };
    let {
      loaderData: fa,
      errors: Ra
    } = gN(j, xe, Wr, Fe, nn, Ma, nt);
    nt.forEach((An, hr) => {
      An.subscribe((Ta) => {
        (Ta || An.done) && nt.delete(hr);
      });
    }), T.v7_partialHydration && ve && j.errors && (Ra = Ua({}, j.errors, Ra));
    let on = zn(), ei = Ur(_e), io = on || ei || nn.length > 0;
    return Ua({
      matches: xe,
      loaderData: fa,
      errors: Ra
    }, io ? {
      fetchers: new Map(j.fetchers)
    } : {});
  }
  function ja(ne) {
    if (ne && !Js(ne[1]))
      return {
        [ne[0]]: ne[1].data
      };
    if (j.actionData)
      return Object.keys(j.actionData).length === 0 ? null : j.actionData;
  }
  function qr(ne) {
    return ne.forEach((ce) => {
      let xe = j.fetchers.get(ce.key), Ue = Fy(void 0, xe ? xe.data : void 0);
      j.fetchers.set(ce.key, Ue);
    }), new Map(j.fetchers);
  }
  function wr(ne, ce, xe, Ue) {
    if (u)
      throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
    $t(ne);
    let rt = (Ue && Ue.flushSync) === !0, _t = y || h, Vt = fT(j.location, j.matches, g, T.v7_prependBasename, xe, T.v7_relativeSplatPath, ce, Ue == null ? void 0 : Ue.relative), J = cm(_t, Vt, g), ve = Xo(J, _t, Vt);
    if (ve.active && ve.matches && (J = ve.matches), !J) {
      ca(ne, ce, ys(404, {
        pathname: Vt
      }), {
        flushSync: rt
      });
      return;
    }
    let {
      path: be,
      submission: Fe,
      error: ut
    } = cN(T.v7_normalizeFormMethod, !0, Vt, Ue);
    if (ut) {
      ca(ne, ce, ut, {
        flushSync: rt
      });
      return;
    }
    let bt = zy(J, be), Et = (Ue && Ue.preventScrollReset) === !0;
    if (Fe && Zc(Fe.formMethod)) {
      Da(ne, ce, be, bt, J, ve.active, rt, Et, Fe);
      return;
    }
    $e.set(ne, {
      routeId: ce,
      path: be
    }), Sa(ne, ce, be, bt, J, ve.active, rt, Et, Fe);
  }
  async function Da(ne, ce, xe, Ue, rt, _t, Vt, J, ve) {
    pr(), $e.delete(ne);
    function be(Bn) {
      if (!Bn.route.action && !Bn.route.lazy) {
        let xo = ys(405, {
          method: ve.formMethod,
          pathname: xe,
          routeId: ce
        });
        return ca(ne, ce, xo, {
          flushSync: Vt
        }), !0;
      }
      return !1;
    }
    if (!_t && be(Ue))
      return;
    let Fe = j.fetchers.get(ne);
    xr(ne, GM(ve, Fe), {
      flushSync: Vt
    });
    let ut = new AbortController(), bt = Pg(t.history, xe, ut.signal, ve);
    if (_t) {
      let Bn = await ao(rt, new URL(bt.url).pathname, bt.signal, ne);
      if (Bn.type === "aborted")
        return;
      if (Bn.type === "error") {
        ca(ne, ce, Bn.error, {
          flushSync: Vt
        });
        return;
      } else if (Bn.matches) {
        if (rt = Bn.matches, Ue = zy(rt, xe), be(Ue))
          return;
      } else {
        ca(ne, ce, ys(404, {
          pathname: xe
        }), {
          flushSync: Vt
        });
        return;
      }
    }
    he.set(ne, ut);
    let Et = ke, Zt = (await Or("action", j, bt, [Ue], rt, ne))[Ue.route.id];
    if (bt.signal.aborted) {
      he.get(ne) === ut && he.delete(ne);
      return;
    }
    if (T.v7_fetcherPersist && ot.has(ne)) {
      if (dm(Zt) || Js(Zt)) {
        xr(ne, Wh(void 0));
        return;
      }
    } else {
      if (dm(Zt))
        if (he.delete(ne), _e > Et) {
          xr(ne, Wh(void 0));
          return;
        } else
          return pe.add(ne), xr(ne, Fy(ve)), xa(bt, Zt, !1, {
            fetcherSubmission: ve,
            preventScrollReset: J
          });
      if (Js(Zt)) {
        ca(ne, ce, Zt.error);
        return;
      }
    }
    if ($h(Zt))
      throw ys(400, {
        type: "defer-action"
      });
    let nn = j.navigation.location || j.location, sr = Pg(t.history, nn, ut.signal), Wr = y || h, Ma = j.navigation.state !== "idle" ? cm(Wr, j.navigation.location, g) : j.matches;
    qt(Ma, "Didn't find any matches after fetcher action");
    let hn = ++ke;
    q.set(ne, hn);
    let fa = Fy(ve, Zt.data);
    j.fetchers.set(ne, fa);
    let [Ra, on] = dN(t.history, j, Ma, ve, nn, !1, T.v7_skipActionErrorRevalidation, at, st, We, ot, $e, pe, Wr, g, [Ue.route.id, Zt]);
    on.filter((Bn) => Bn.key !== ne).forEach((Bn) => {
      let xo = Bn.key, Ss = j.fetchers.get(xo), ec = Fy(void 0, Ss ? Ss.data : void 0);
      j.fetchers.set(xo, ec), $t(xo), Bn.controller && he.set(xo, Bn.controller);
    }), Ze({
      fetchers: new Map(j.fetchers)
    });
    let ei = () => on.forEach((Bn) => $t(Bn.key));
    ut.signal.addEventListener("abort", ei);
    let {
      loaderResults: io,
      fetcherResults: An
    } = await fi(j, Ma, Ra, on, sr);
    if (ut.signal.aborted)
      return;
    ut.signal.removeEventListener("abort", ei), q.delete(ne), he.delete(ne), on.forEach((Bn) => he.delete(Bn.key));
    let hr = Y1(io);
    if (hr)
      return xa(sr, hr.result, !1, {
        preventScrollReset: J
      });
    if (hr = Y1(An), hr)
      return pe.add(hr.key), xa(sr, hr.result, !1, {
        preventScrollReset: J
      });
    let {
      loaderData: Ta,
      errors: xl
    } = gN(j, Ma, io, void 0, on, An, nt);
    if (j.fetchers.has(ne)) {
      let Bn = Wh(Zt.data);
      j.fetchers.set(ne, Bn);
    }
    Ur(hn), j.navigation.state === "loading" && hn > _e ? (qt(re, "Expected pending action"), Se && Se.abort(), mn(j.navigation.location, {
      matches: Ma,
      loaderData: Ta,
      errors: xl,
      fetchers: new Map(j.fetchers)
    })) : (Ze({
      errors: xl,
      loaderData: bN(j.loaderData, Ta, Ma, xl),
      fetchers: new Map(j.fetchers)
    }), at = !1);
  }
  async function Sa(ne, ce, xe, Ue, rt, _t, Vt, J, ve) {
    let be = j.fetchers.get(ne);
    xr(ne, Fy(ve, be ? be.data : void 0), {
      flushSync: Vt
    });
    let Fe = new AbortController(), ut = Pg(t.history, xe, Fe.signal);
    if (_t) {
      let Zt = await ao(rt, new URL(ut.url).pathname, ut.signal, ne);
      if (Zt.type === "aborted")
        return;
      if (Zt.type === "error") {
        ca(ne, ce, Zt.error, {
          flushSync: Vt
        });
        return;
      } else if (Zt.matches)
        rt = Zt.matches, Ue = zy(rt, xe);
      else {
        ca(ne, ce, ys(404, {
          pathname: xe
        }), {
          flushSync: Vt
        });
        return;
      }
    }
    he.set(ne, Fe);
    let bt = ke, Tt = (await Or("loader", j, ut, [Ue], rt, ne))[Ue.route.id];
    if ($h(Tt) && (Tt = await e2(Tt, ut.signal, !0) || Tt), he.get(ne) === Fe && he.delete(ne), !ut.signal.aborted) {
      if (ot.has(ne)) {
        xr(ne, Wh(void 0));
        return;
      }
      if (dm(Tt))
        if (_e > bt) {
          xr(ne, Wh(void 0));
          return;
        } else {
          pe.add(ne), await xa(ut, Tt, !1, {
            preventScrollReset: J
          });
          return;
        }
      if (Js(Tt)) {
        ca(ne, ce, Tt.error);
        return;
      }
      qt(!$h(Tt), "Unhandled fetcher deferred data"), xr(ne, Wh(Tt.data));
    }
  }
  async function xa(ne, ce, xe, Ue) {
    let {
      submission: rt,
      fetcherSubmission: _t,
      preventScrollReset: Vt,
      replace: J
    } = Ue === void 0 ? {} : Ue;
    ce.response.headers.has("X-Remix-Revalidate") && (at = !0);
    let ve = ce.response.headers.get("Location");
    qt(ve, "Expected a Location header on the redirect Response"), ve = vN(ve, new URL(ne.url), g);
    let be = Ky(j.location, ve, {
      _isRedirect: !0
    });
    if (i) {
      let Zt = !1;
      if (ce.response.headers.has("X-Remix-Reload-Document"))
        Zt = !0;
      else if (qT.test(ve)) {
        const nn = t.history.createURL(ve);
        Zt = // Hard reload if it's an absolute URL to a new origin
        nn.origin !== r.location.origin || // Hard reload if it's an absolute URL that does not match our basename
        Ks(nn.pathname, g) == null;
      }
      if (Zt) {
        J ? r.location.replace(ve) : r.location.assign(ve);
        return;
      }
    }
    Se = null;
    let Fe = J === !0 || ce.response.headers.has("X-Remix-Replace") ? Ci.Replace : Ci.Push, {
      formMethod: ut,
      formAction: bt,
      formEncType: Et
    } = j.navigation;
    !rt && !_t && ut && bt && Et && (rt = SN(j.navigation));
    let Tt = rt || _t;
    if (xM.has(ce.response.status) && Tt && Zc(Tt.formMethod))
      await ar(Fe, be, {
        submission: Ua({}, Tt, {
          formAction: ve
        }),
        // Preserve these flags across redirects
        preventScrollReset: Vt || me,
        enableViewTransition: xe ? Ne : void 0
      });
    else {
      let Zt = BR(be, rt);
      await ar(Fe, be, {
        overrideNavigation: Zt,
        // Send fetcher submissions through for shouldRevalidate
        fetcherSubmission: _t,
        // Preserve these flags across redirects
        preventScrollReset: Vt || me,
        enableViewTransition: xe ? Ne : void 0
      });
    }
  }
  async function Or(ne, ce, xe, Ue, rt, _t) {
    let Vt, J = {};
    try {
      Vt = await OM(S, ne, ce, xe, Ue, rt, _t, v, c);
    } catch (ve) {
      return Ue.forEach((be) => {
        J[be.route.id] = {
          type: Kr.error,
          error: ve
        };
      }), J;
    }
    for (let [ve, be] of Object.entries(Vt))
      if (FM(be)) {
        let Fe = be.result;
        J[ve] = {
          type: Kr.redirect,
          response: MM(Fe, xe, ve, rt, g, T.v7_relativeSplatPath)
        };
      } else
        J[ve] = await DM(be);
    return J;
  }
  async function fi(ne, ce, xe, Ue, rt) {
    let _t = ne.matches, Vt = Or("loader", ne, rt, xe, ce, null), J = Promise.all(Ue.map(async (Fe) => {
      if (Fe.matches && Fe.match && Fe.controller) {
        let bt = (await Or("loader", ne, Pg(t.history, Fe.path, Fe.controller.signal), [Fe.match], Fe.matches, Fe.key))[Fe.match.route.id];
        return {
          [Fe.key]: bt
        };
      } else
        return Promise.resolve({
          [Fe.key]: {
            type: Kr.error,
            error: ys(404, {
              pathname: Fe.path
            })
          }
        });
    })), ve = await Vt, be = (await J).reduce((Fe, ut) => Object.assign(Fe, ut), {});
    return await Promise.all([VM(ce, ve, rt.signal, _t, ne.loaderData), HM(ce, be, Ue)]), {
      loaderResults: ve,
      fetcherResults: be
    };
  }
  function pr() {
    at = !0, st.push(...Xn()), $e.forEach((ne, ce) => {
      he.has(ce) && We.add(ce), $t(ce);
    });
  }
  function xr(ne, ce, xe) {
    xe === void 0 && (xe = {}), j.fetchers.set(ne, ce), Ze({
      fetchers: new Map(j.fetchers)
    }, {
      flushSync: (xe && xe.flushSync) === !0
    });
  }
  function ca(ne, ce, xe, Ue) {
    Ue === void 0 && (Ue = {});
    let rt = fm(j.matches, ce);
    it(ne), Ze({
      errors: {
        [rt.route.id]: xe
      },
      fetchers: new Map(j.fetchers)
    }, {
      flushSync: (Ue && Ue.flushSync) === !0
    });
  }
  function Ka(ne) {
    return lt.set(ne, (lt.get(ne) || 0) + 1), ot.has(ne) && ot.delete(ne), j.fetchers.get(ne) || RM;
  }
  function it(ne) {
    let ce = j.fetchers.get(ne);
    he.has(ne) && !(ce && ce.state === "loading" && q.has(ne)) && $t(ne), $e.delete(ne), q.delete(ne), pe.delete(ne), T.v7_fetcherPersist && ot.delete(ne), We.delete(ne), j.fetchers.delete(ne);
  }
  function kt(ne) {
    let ce = (lt.get(ne) || 0) - 1;
    ce <= 0 ? (lt.delete(ne), ot.add(ne), T.v7_fetcherPersist || it(ne)) : lt.set(ne, ce), Ze({
      fetchers: new Map(j.fetchers)
    });
  }
  function $t(ne) {
    let ce = he.get(ne);
    ce && (ce.abort(), he.delete(ne));
  }
  function Fn(ne) {
    for (let ce of ne) {
      let xe = Ka(ce), Ue = Wh(xe.data);
      j.fetchers.set(ce, Ue);
    }
  }
  function zn() {
    let ne = [], ce = !1;
    for (let xe of pe) {
      let Ue = j.fetchers.get(xe);
      qt(Ue, "Expected fetcher: " + xe), Ue.state === "loading" && (pe.delete(xe), ne.push(xe), ce = !0);
    }
    return Fn(ne), ce;
  }
  function Ur(ne) {
    let ce = [];
    for (let [xe, Ue] of q)
      if (Ue < ne) {
        let rt = j.fetchers.get(xe);
        qt(rt, "Expected fetcher: " + xe), rt.state === "loading" && ($t(xe), q.delete(xe), ce.push(xe));
      }
    return Fn(ce), ce.length > 0;
  }
  function Lr(ne, ce) {
    let xe = j.blockers.get(ne) || Ug;
    return Rt.get(ne) !== ce && Rt.set(ne, ce), xe;
  }
  function Ga(ne) {
    j.blockers.delete(ne), Rt.delete(ne);
  }
  function Qn(ne, ce) {
    let xe = j.blockers.get(ne) || Ug;
    qt(xe.state === "unblocked" && ce.state === "blocked" || xe.state === "blocked" && ce.state === "blocked" || xe.state === "blocked" && ce.state === "proceeding" || xe.state === "blocked" && ce.state === "unblocked" || xe.state === "proceeding" && ce.state === "unblocked", "Invalid blocker state transition: " + xe.state + " -> " + ce.state);
    let Ue = new Map(j.blockers);
    Ue.set(ne, ce), Ze({
      blockers: Ue
    });
  }
  function qa(ne) {
    let {
      currentLocation: ce,
      nextLocation: xe,
      historyAction: Ue
    } = ne;
    if (Rt.size === 0)
      return;
    Rt.size > 1 && Di(!1, "A router only supports one blocker at a time");
    let rt = Array.from(Rt.entries()), [_t, Vt] = rt[rt.length - 1], J = j.blockers.get(_t);
    if (!(J && J.state === "proceeding") && Vt({
      currentLocation: ce,
      nextLocation: xe,
      historyAction: Ue
    }))
      return _t;
  }
  function Wn(ne) {
    let ce = ys(404, {
      pathname: ne
    }), xe = y || h, {
      matches: Ue,
      route: rt
    } = CN(xe);
    return Xn(), {
      notFoundMatches: Ue,
      route: rt,
      error: ce
    };
  }
  function Xn(ne) {
    let ce = [];
    return nt.forEach((xe, Ue) => {
      (!ne || ne(Ue)) && (xe.cancel(), ce.push(Ue), nt.delete(Ue));
    }), ce;
  }
  function So(ne, ce, xe) {
    if (M = ne, B = ce, U = xe || null, !H && j.navigation === FR) {
      H = !0;
      let Ue = Xl(j.location, j.matches);
      Ue != null && Ze({
        restoreScrollPosition: Ue
      });
    }
    return () => {
      M = null, B = null, U = null;
    };
  }
  function Pi(ne, ce) {
    return U && U(ne, ce.map((Ue) => tM(Ue, j.loaderData))) || ne.key;
  }
  function Wl(ne, ce) {
    if (M && B) {
      let xe = Pi(ne, ce);
      M[xe] = B();
    }
  }
  function Xl(ne, ce) {
    if (M) {
      let xe = Pi(ne, ce), Ue = M[xe];
      if (typeof Ue == "number")
        return Ue;
    }
    return null;
  }
  function Xo(ne, ce, xe) {
    if (x)
      if (ne) {
        if (Object.keys(ne[0].params).length > 0)
          return {
            active: !0,
            matches: iC(ce, xe, g, !0)
          };
      } else
        return {
          active: !0,
          matches: iC(ce, xe, g, !0) || []
        };
    return {
      active: !1,
      matches: null
    };
  }
  async function ao(ne, ce, xe, Ue) {
    if (!x)
      return {
        type: "success",
        matches: ne
      };
    let rt = ne;
    for (; ; ) {
      let _t = y == null, Vt = y || h, J = v;
      try {
        await x({
          signal: xe,
          path: ce,
          matches: rt,
          fetcherKey: Ue,
          patch: (Fe, ut) => {
            xe.aborted || hN(Fe, ut, Vt, J, c);
          }
        });
      } catch (Fe) {
        return {
          type: "error",
          error: Fe,
          partialMatches: rt
        };
      } finally {
        _t && !xe.aborted && (h = [...h]);
      }
      if (xe.aborted)
        return {
          type: "aborted"
        };
      let ve = cm(Vt, ce, g);
      if (ve)
        return {
          type: "success",
          matches: ve
        };
      let be = iC(Vt, ce, g, !0);
      if (!be || rt.length === be.length && rt.every((Fe, ut) => Fe.route.id === be[ut].route.id))
        return {
          type: "success",
          matches: null
        };
      rt = be;
    }
  }
  function Yl(ne) {
    v = {}, y = vC(ne, c, void 0, v);
  }
  function ki(ne, ce) {
    let xe = y == null;
    hN(ne, ce, y || h, v, c), xe && (h = [...h], Ze({}));
  }
  return oe = {
    get basename() {
      return g;
    },
    get future() {
      return T;
    },
    get state() {
      return j;
    },
    get routes() {
      return h;
    },
    get window() {
      return r;
    },
    initialize: dt,
    subscribe: bn,
    enableScrollRestoration: So,
    navigate: fn,
    fetch: wr,
    revalidate: Gn,
    // Passthrough to history-aware createHref used by useHref so we get proper
    // hash-aware URLs in DOM paths
    createHref: (ne) => t.history.createHref(ne),
    encodeLocation: (ne) => t.history.encodeLocation(ne),
    getFetcher: Ka,
    deleteFetcher: kt,
    dispose: sn,
    getBlocker: Lr,
    deleteBlocker: Ga,
    patchRoutes: ki,
    _internalFetchControllers: he,
    _internalActiveDeferreds: nt,
    // TODO: Remove setRoutes, it's temporary to avoid dealing with
    // updating the tree while validating the update algorithm.
    _internalSetRoutes: Yl
  }, oe;
}
function IM(t) {
  return t != null && ("formData" in t && t.formData != null || "body" in t && t.body !== void 0);
}
function fT(t, r, i, u, c, v, h, y) {
  let g, S;
  if (h) {
    g = [];
    for (let T of r)
      if (g.push(T), T.route.id === h) {
        S = T;
        break;
      }
  } else
    g = r, S = r[r.length - 1];
  let x = LC(c || ".", OC(g, v), Ks(t.pathname, i) || t.pathname, y === "path");
  if (c == null && (x.search = t.search, x.hash = t.hash), (c == null || c === "" || c === ".") && S) {
    let T = t2(x.search);
    if (S.route.index && !T)
      x.search = x.search ? x.search.replace(/^\?/, "?index&") : "?index";
    else if (!S.route.index && T) {
      let _ = new URLSearchParams(x.search), L = _.getAll("index");
      _.delete("index"), L.filter((U) => U).forEach((U) => _.append("index", U));
      let M = _.toString();
      x.search = M ? "?" + M : "";
    }
  }
  return u && i !== "/" && (x.pathname = x.pathname === "/" ? i : id([i, x.pathname])), Zh(x);
}
function cN(t, r, i, u) {
  if (!u || !IM(u))
    return {
      path: i
    };
  if (u.formMethod && !UM(u.formMethod))
    return {
      path: i,
      error: ys(405, {
        method: u.formMethod
      })
    };
  let c = () => ({
    path: i,
    error: ys(400, {
      type: "invalid-body"
    })
  }), v = u.formMethod || "get", h = t ? v.toUpperCase() : v.toLowerCase(), y = u9(i);
  if (u.body !== void 0) {
    if (u.formEncType === "text/plain") {
      if (!Zc(h))
        return c();
      let _ = typeof u.body == "string" ? u.body : u.body instanceof FormData || u.body instanceof URLSearchParams ? (
        // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
        Array.from(u.body.entries()).reduce((L, M) => {
          let [U, B] = M;
          return "" + L + U + "=" + B + `
`;
        }, "")
      ) : String(u.body);
      return {
        path: i,
        submission: {
          formMethod: h,
          formAction: y,
          formEncType: u.formEncType,
          formData: void 0,
          json: void 0,
          text: _
        }
      };
    } else if (u.formEncType === "application/json") {
      if (!Zc(h))
        return c();
      try {
        let _ = typeof u.body == "string" ? JSON.parse(u.body) : u.body;
        return {
          path: i,
          submission: {
            formMethod: h,
            formAction: y,
            formEncType: u.formEncType,
            formData: void 0,
            json: _,
            text: void 0
          }
        };
      } catch {
        return c();
      }
    }
  }
  qt(typeof FormData == "function", "FormData is not available in this environment");
  let g, S;
  if (u.formData)
    g = pT(u.formData), S = u.formData;
  else if (u.body instanceof FormData)
    g = pT(u.body), S = u.body;
  else if (u.body instanceof URLSearchParams)
    g = u.body, S = mN(g);
  else if (u.body == null)
    g = new URLSearchParams(), S = new FormData();
  else
    try {
      g = new URLSearchParams(u.body), S = mN(g);
    } catch {
      return c();
    }
  let x = {
    formMethod: h,
    formAction: y,
    formEncType: u && u.formEncType || "application/x-www-form-urlencoded",
    formData: S,
    json: void 0,
    text: void 0
  };
  if (Zc(x.formMethod))
    return {
      path: i,
      submission: x
    };
  let T = xp(i);
  return r && T.search && t2(T.search) && g.append("index", ""), T.search = "?" + g, {
    path: Zh(T),
    submission: x
  };
}
function fN(t, r, i) {
  i === void 0 && (i = !1);
  let u = t.findIndex((c) => c.route.id === r);
  return u >= 0 ? t.slice(0, i ? u + 1 : u) : t;
}
function dN(t, r, i, u, c, v, h, y, g, S, x, T, _, L, M, U) {
  let B = U ? Js(U[1]) ? U[1].error : U[1].data : void 0, H = t.createURL(r.location), Y = t.createURL(c), G = i;
  v && r.errors ? G = fN(i, Object.keys(r.errors)[0], !0) : U && Js(U[1]) && (G = fN(i, U[0]));
  let Q = U ? U[1].statusCode : void 0, W = h && Q && Q >= 400, oe = G.filter((re, me) => {
    let {
      route: Se
    } = re;
    if (Se.lazy)
      return !0;
    if (Se.loader == null)
      return !1;
    if (v)
      return dT(Se, r.loaderData, r.errors);
    if (AM(r.loaderData, r.matches[me], re) || g.some((ze) => ze === re.route.id))
      return !0;
    let Ne = r.matches[me], Ge = re;
    return pN(re, Ua({
      currentUrl: H,
      currentParams: Ne.params,
      nextUrl: Y,
      nextParams: Ge.params
    }, u, {
      actionResult: B,
      actionStatus: Q,
      defaultShouldRevalidate: W ? !1 : (
        // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        y || H.pathname + H.search === Y.pathname + Y.search || // Search params affect all loaders
        H.search !== Y.search || l9(Ne, Ge)
      )
    }));
  }), j = [];
  return T.forEach((re, me) => {
    if (v || !i.some((qe) => qe.route.id === re.routeId) || x.has(me))
      return;
    let Se = cm(L, re.path, M);
    if (!Se) {
      j.push({
        key: me,
        routeId: re.routeId,
        path: re.path,
        matches: null,
        match: null,
        controller: null
      });
      return;
    }
    let Ne = r.fetchers.get(me), Ge = zy(Se, re.path), ze = !1;
    _.has(me) ? ze = !1 : S.has(me) ? (S.delete(me), ze = !0) : Ne && Ne.state !== "idle" && Ne.data === void 0 ? ze = y : ze = pN(Ge, Ua({
      currentUrl: H,
      currentParams: r.matches[r.matches.length - 1].params,
      nextUrl: Y,
      nextParams: i[i.length - 1].params
    }, u, {
      actionResult: B,
      actionStatus: Q,
      defaultShouldRevalidate: W ? !1 : y
    })), ze && j.push({
      key: me,
      routeId: re.routeId,
      path: re.path,
      matches: Se,
      match: Ge,
      controller: new AbortController()
    });
  }), [oe, j];
}
function dT(t, r, i) {
  if (t.lazy)
    return !0;
  if (!t.loader)
    return !1;
  let u = r != null && r[t.id] !== void 0, c = i != null && i[t.id] !== void 0;
  return !u && c ? !1 : typeof t.loader == "function" && t.loader.hydrate === !0 ? !0 : !u && !c;
}
function AM(t, r, i) {
  let u = (
    // [a] -> [a, b]
    !r || // [a, b] -> [a, c]
    i.route.id !== r.route.id
  ), c = t[i.route.id] === void 0;
  return u || c;
}
function l9(t, r) {
  let i = t.route.path;
  return (
    // param change for this match, /users/123 -> /users/456
    t.pathname !== r.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    i != null && i.endsWith("*") && t.params["*"] !== r.params["*"]
  );
}
function pN(t, r) {
  if (t.route.shouldRevalidate) {
    let i = t.route.shouldRevalidate(r);
    if (typeof i == "boolean")
      return i;
  }
  return r.defaultShouldRevalidate;
}
function hN(t, r, i, u, c) {
  var v;
  let h;
  if (t) {
    let S = u[t];
    qt(S, "No route found to patch children into: routeId = " + t), S.children || (S.children = []), h = S.children;
  } else
    h = i;
  let y = r.filter((S) => !h.some((x) => s9(S, x))), g = vC(y, c, [t || "_", "patch", String(((v = h) == null ? void 0 : v.length) || "0")], u);
  h.push(...g);
}
function s9(t, r) {
  return "id" in t && "id" in r && t.id === r.id ? !0 : t.index === r.index && t.path === r.path && t.caseSensitive === r.caseSensitive ? (!t.children || t.children.length === 0) && (!r.children || r.children.length === 0) ? !0 : t.children.every((i, u) => {
    var c;
    return (c = r.children) == null ? void 0 : c.some((v) => s9(i, v));
  }) : !1;
}
async function NM(t, r, i) {
  if (!t.lazy)
    return;
  let u = await t.lazy();
  if (!t.lazy)
    return;
  let c = i[t.id];
  qt(c, "No route found in manifest");
  let v = {};
  for (let h in u) {
    let g = c[h] !== void 0 && // This property isn't static since it should always be updated based
    // on the route updates
    h !== "hasErrorBoundary";
    Di(!g, 'Route "' + c.id + '" has a static property "' + h + '" defined but its lazy function is also returning a value for this property. ' + ('The lazy route property "' + h + '" will be ignored.')), !g && !q5.has(h) && (v[h] = u[h]);
  }
  Object.assign(c, v), Object.assign(c, Ua({}, r(c), {
    lazy: void 0
  }));
}
async function _M(t) {
  let {
    matches: r
  } = t, i = r.filter((c) => c.shouldLoad);
  return (await Promise.all(i.map((c) => c.resolve()))).reduce((c, v, h) => Object.assign(c, {
    [i[h].route.id]: v
  }), {});
}
async function OM(t, r, i, u, c, v, h, y, g, S) {
  let x = v.map((L) => L.route.lazy ? NM(L.route, g, y) : void 0), T = v.map((L, M) => {
    let U = x[M], B = c.some((Y) => Y.route.id === L.route.id);
    return Ua({}, L, {
      shouldLoad: B,
      resolve: async (Y) => (Y && u.method === "GET" && (L.route.lazy || L.route.loader) && (B = !0), B ? LM(r, u, L, U, Y, S) : Promise.resolve({
        type: Kr.data,
        result: void 0
      }))
    });
  }), _ = await t({
    matches: T,
    request: u,
    params: v[0].params,
    fetcherKey: h,
    context: S
  });
  try {
    await Promise.all(x);
  } catch {
  }
  return _;
}
async function LM(t, r, i, u, c, v) {
  let h, y, g = (S) => {
    let x, T = new Promise((M, U) => x = U);
    y = () => x(), r.signal.addEventListener("abort", y);
    let _ = (M) => typeof S != "function" ? Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + t + '" [routeId: ' + i.route.id + "]"))) : S({
      request: r,
      params: i.params,
      context: v
    }, ...M !== void 0 ? [M] : []), L = (async () => {
      try {
        return {
          type: "data",
          result: await (c ? c((U) => _(U)) : _())
        };
      } catch (M) {
        return {
          type: "error",
          result: M
        };
      }
    })();
    return Promise.race([L, T]);
  };
  try {
    let S = i.route[t];
    if (u)
      if (S) {
        let x, [T] = await Promise.all([
          // If the handler throws, don't let it immediately bubble out,
          // since we need to let the lazy() execution finish so we know if this
          // route has a boundary that can handle the error
          g(S).catch((_) => {
            x = _;
          }),
          u
        ]);
        if (x !== void 0)
          throw x;
        h = T;
      } else if (await u, S = i.route[t], S)
        h = await g(S);
      else if (t === "action") {
        let x = new URL(r.url), T = x.pathname + x.search;
        throw ys(405, {
          method: r.method,
          pathname: T,
          routeId: i.route.id
        });
      } else
        return {
          type: Kr.data,
          result: void 0
        };
    else if (S)
      h = await g(S);
    else {
      let x = new URL(r.url), T = x.pathname + x.search;
      throw ys(404, {
        pathname: T
      });
    }
    qt(h.result !== void 0, "You defined " + (t === "action" ? "an action" : "a loader") + " for route " + ('"' + i.route.id + "\" but didn't return anything from your `" + t + "` ") + "function. Please return a value or `null`.");
  } catch (S) {
    return {
      type: Kr.error,
      result: S
    };
  } finally {
    y && r.signal.removeEventListener("abort", y);
  }
  return h;
}
async function DM(t) {
  let {
    result: r,
    type: i
  } = t;
  if (c9(r)) {
    let T;
    try {
      let _ = r.headers.get("Content-Type");
      _ && /\bapplication\/json\b/.test(_) ? r.body == null ? T = null : T = await r.json() : T = await r.text();
    } catch (_) {
      return {
        type: Kr.error,
        error: _
      };
    }
    return i === Kr.error ? {
      type: Kr.error,
      error: new mC(r.status, r.statusText, T),
      statusCode: r.status,
      headers: r.headers
    } : {
      type: Kr.data,
      data: T,
      statusCode: r.status,
      headers: r.headers
    };
  }
  if (i === Kr.error) {
    if (EN(r)) {
      var u, c;
      if (r.data instanceof Error) {
        var v, h;
        return {
          type: Kr.error,
          error: r.data,
          statusCode: (v = r.init) == null ? void 0 : v.status,
          headers: (h = r.init) != null && h.headers ? new Headers(r.init.headers) : void 0
        };
      }
      return {
        type: Kr.error,
        error: new mC(((u = r.init) == null ? void 0 : u.status) || 500, void 0, r.data),
        statusCode: qy(r) ? r.status : void 0,
        headers: (c = r.init) != null && c.headers ? new Headers(r.init.headers) : void 0
      };
    }
    return {
      type: Kr.error,
      error: r,
      statusCode: qy(r) ? r.status : void 0
    };
  }
  if (BM(r)) {
    var y, g;
    return {
      type: Kr.deferred,
      deferredData: r,
      statusCode: (y = r.init) == null ? void 0 : y.status,
      headers: ((g = r.init) == null ? void 0 : g.headers) && new Headers(r.init.headers)
    };
  }
  if (EN(r)) {
    var S, x;
    return {
      type: Kr.data,
      data: r.data,
      statusCode: (S = r.init) == null ? void 0 : S.status,
      headers: (x = r.init) != null && x.headers ? new Headers(r.init.headers) : void 0
    };
  }
  return {
    type: Kr.data,
    data: r
  };
}
function MM(t, r, i, u, c, v) {
  let h = t.headers.get("Location");
  if (qt(h, "Redirects returned/thrown from loaders/actions must have a Location header"), !qT.test(h)) {
    let y = u.slice(0, u.findIndex((g) => g.route.id === i) + 1);
    h = fT(new URL(r.url), y, c, !0, h, v), t.headers.set("Location", h);
  }
  return t;
}
function vN(t, r, i) {
  if (qT.test(t)) {
    let u = t, c = u.startsWith("//") ? new URL(r.protocol + u) : new URL(u), v = Ks(c.pathname, i) != null;
    if (c.origin === r.origin && v)
      return c.pathname + c.search + c.hash;
  }
  return t;
}
function Pg(t, r, i, u) {
  let c = t.createURL(u9(r)).toString(), v = {
    signal: i
  };
  if (u && Zc(u.formMethod)) {
    let {
      formMethod: h,
      formEncType: y
    } = u;
    v.method = h.toUpperCase(), y === "application/json" ? (v.headers = new Headers({
      "Content-Type": y
    }), v.body = JSON.stringify(u.json)) : y === "text/plain" ? v.body = u.text : y === "application/x-www-form-urlencoded" && u.formData ? v.body = pT(u.formData) : v.body = u.formData;
  }
  return new Request(c, v);
}
function pT(t) {
  let r = new URLSearchParams();
  for (let [i, u] of t.entries())
    r.append(i, typeof u == "string" ? u : u.name);
  return r;
}
function mN(t) {
  let r = new FormData();
  for (let [i, u] of t.entries())
    r.append(i, u);
  return r;
}
function PM(t, r, i, u, c) {
  let v = {}, h = null, y, g = !1, S = {}, x = i && Js(i[1]) ? i[1].error : void 0;
  return t.forEach((T) => {
    if (!(T.route.id in r))
      return;
    let _ = T.route.id, L = r[_];
    if (qt(!dm(L), "Cannot handle redirect results in processLoaderData"), Js(L)) {
      let M = L.error;
      if (x !== void 0 && (M = x, x = void 0), h = h || {}, c)
        h[_] = M;
      else {
        let U = fm(t, _);
        h[U.route.id] == null && (h[U.route.id] = M);
      }
      v[_] = void 0, g || (g = !0, y = qy(L.error) ? L.error.status : 500), L.headers && (S[_] = L.headers);
    } else
      $h(L) ? (u.set(_, L.deferredData), v[_] = L.deferredData.data, L.statusCode != null && L.statusCode !== 200 && !g && (y = L.statusCode), L.headers && (S[_] = L.headers)) : (v[_] = L.data, L.statusCode && L.statusCode !== 200 && !g && (y = L.statusCode), L.headers && (S[_] = L.headers));
  }), x !== void 0 && i && (h = {
    [i[0]]: x
  }, v[i[0]] = void 0), {
    loaderData: v,
    errors: h,
    statusCode: y || 200,
    loaderHeaders: S
  };
}
function gN(t, r, i, u, c, v, h) {
  let {
    loaderData: y,
    errors: g
  } = PM(
    r,
    i,
    u,
    h,
    !1
    // This method is only called client side so we always want to bubble
  );
  return c.forEach((S) => {
    let {
      key: x,
      match: T,
      controller: _
    } = S, L = v[x];
    if (qt(L, "Did not find corresponding fetcher result"), !(_ && _.signal.aborted))
      if (Js(L)) {
        let M = fm(t.matches, T == null ? void 0 : T.route.id);
        g && g[M.route.id] || (g = Ua({}, g, {
          [M.route.id]: L.error
        })), t.fetchers.delete(x);
      } else if (dm(L))
        qt(!1, "Unhandled fetcher revalidation redirect");
      else if ($h(L))
        qt(!1, "Unhandled fetcher deferred data");
      else {
        let M = Wh(L.data);
        t.fetchers.set(x, M);
      }
  }), {
    loaderData: y,
    errors: g
  };
}
function bN(t, r, i, u) {
  let c = Ua({}, r);
  for (let v of i) {
    let h = v.route.id;
    if (r.hasOwnProperty(h) ? r[h] !== void 0 && (c[h] = r[h]) : t[h] !== void 0 && v.route.loader && (c[h] = t[h]), u && u.hasOwnProperty(h))
      break;
  }
  return c;
}
function yN(t) {
  return t ? Js(t[1]) ? {
    // Clear out prior actionData on errors
    actionData: {}
  } : {
    actionData: {
      [t[0]]: t[1].data
    }
  } : {};
}
function fm(t, r) {
  return (r ? t.slice(0, t.findIndex((u) => u.route.id === r) + 1) : [...t]).reverse().find((u) => u.route.hasErrorBoundary === !0) || t[0];
}
function CN(t) {
  let r = t.length === 1 ? t[0] : t.find((i) => i.index || !i.path || i.path === "/") || {
    id: "__shim-error-route__"
  };
  return {
    matches: [{
      params: {},
      pathname: "",
      pathnameBase: "",
      route: r
    }],
    route: r
  };
}
function ys(t, r) {
  let {
    pathname: i,
    routeId: u,
    method: c,
    type: v,
    message: h
  } = r === void 0 ? {} : r, y = "Unknown Server Error", g = "Unknown @remix-run/router error";
  return t === 400 ? (y = "Bad Request", c && i && u ? g = "You made a " + c + ' request to "' + i + '" but ' + ('did not provide a `loader` for route "' + u + '", ') + "so there is no way to handle the request." : v === "defer-action" ? g = "defer() is not supported in actions" : v === "invalid-body" && (g = "Unable to encode submission body")) : t === 403 ? (y = "Forbidden", g = 'Route "' + u + '" does not match URL "' + i + '"') : t === 404 ? (y = "Not Found", g = 'No route matches URL "' + i + '"') : t === 405 && (y = "Method Not Allowed", c && i && u ? g = "You made a " + c.toUpperCase() + ' request to "' + i + '" but ' + ('did not provide an `action` for route "' + u + '", ') + "so there is no way to handle the request." : c && (g = 'Invalid request method "' + c.toUpperCase() + '"')), new mC(t || 500, y, new Error(g), !0);
}
function Y1(t) {
  let r = Object.entries(t);
  for (let i = r.length - 1; i >= 0; i--) {
    let [u, c] = r[i];
    if (dm(c))
      return {
        key: u,
        result: c
      };
  }
}
function u9(t) {
  let r = typeof t == "string" ? xp(t) : t;
  return Zh(Ua({}, r, {
    hash: ""
  }));
}
function kM(t, r) {
  return t.pathname !== r.pathname || t.search !== r.search ? !1 : t.hash === "" ? r.hash !== "" : t.hash === r.hash ? !0 : r.hash !== "";
}
function FM(t) {
  return c9(t.result) && SM.has(t.result.status);
}
function $h(t) {
  return t.type === Kr.deferred;
}
function Js(t) {
  return t.type === Kr.error;
}
function dm(t) {
  return (t && t.type) === Kr.redirect;
}
function EN(t) {
  return typeof t == "object" && t != null && "type" in t && "data" in t && "init" in t && t.type === "DataWithResponseInit";
}
function BM(t) {
  let r = t;
  return r && typeof r == "object" && typeof r.data == "object" && typeof r.subscribe == "function" && typeof r.cancel == "function" && typeof r.resolveData == "function";
}
function c9(t) {
  return t != null && typeof t.status == "number" && typeof t.statusText == "string" && typeof t.headers == "object" && typeof t.body < "u";
}
function UM(t) {
  return EM.has(t.toLowerCase());
}
function Zc(t) {
  return yM.has(t.toLowerCase());
}
async function VM(t, r, i, u, c) {
  let v = Object.entries(r);
  for (let h = 0; h < v.length; h++) {
    let [y, g] = v[h], S = t.find((_) => (_ == null ? void 0 : _.route.id) === y);
    if (!S)
      continue;
    let x = u.find((_) => _.route.id === S.route.id), T = x != null && !l9(x, S) && (c && c[S.route.id]) !== void 0;
    $h(g) && T && await e2(g, i, !1).then((_) => {
      _ && (r[y] = _);
    });
  }
}
async function HM(t, r, i) {
  for (let u = 0; u < i.length; u++) {
    let {
      key: c,
      routeId: v,
      controller: h
    } = i[u], y = r[c];
    t.find((S) => (S == null ? void 0 : S.route.id) === v) && $h(y) && (qt(h, "Expected an AbortController for revalidating fetcher deferred result"), await e2(y, h.signal, !0).then((S) => {
      S && (r[c] = S);
    }));
  }
}
async function e2(t, r, i) {
  if (i === void 0 && (i = !1), !await t.deferredData.resolveData(r)) {
    if (i)
      try {
        return {
          type: Kr.data,
          data: t.deferredData.unwrappedData
        };
      } catch (c) {
        return {
          type: Kr.error,
          error: c
        };
      }
    return {
      type: Kr.data,
      data: t.deferredData.data
    };
  }
}
function t2(t) {
  return new URLSearchParams(t).getAll("index").some((r) => r === "");
}
function zy(t, r) {
  let i = typeof r == "string" ? xp(r).search : r.search;
  if (t[t.length - 1].route.index && t2(i || ""))
    return t[t.length - 1];
  let u = a9(t);
  return u[u.length - 1];
}
function SN(t) {
  let {
    formMethod: r,
    formAction: i,
    formEncType: u,
    text: c,
    formData: v,
    json: h
  } = t;
  if (!(!r || !i || !u)) {
    if (c != null)
      return {
        formMethod: r,
        formAction: i,
        formEncType: u,
        formData: void 0,
        json: void 0,
        text: c
      };
    if (v != null)
      return {
        formMethod: r,
        formAction: i,
        formEncType: u,
        formData: v,
        json: void 0,
        text: void 0
      };
    if (h !== void 0)
      return {
        formMethod: r,
        formAction: i,
        formEncType: u,
        formData: void 0,
        json: h,
        text: void 0
      };
  }
}
function BR(t, r) {
  return r ? {
    state: "loading",
    location: t,
    formMethod: r.formMethod,
    formAction: r.formAction,
    formEncType: r.formEncType,
    formData: r.formData,
    json: r.json,
    text: r.text
  } : {
    state: "loading",
    location: t,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
  };
}
function jM(t, r) {
  return {
    state: "submitting",
    location: t,
    formMethod: r.formMethod,
    formAction: r.formAction,
    formEncType: r.formEncType,
    formData: r.formData,
    json: r.json,
    text: r.text
  };
}
function Fy(t, r) {
  return t ? {
    state: "loading",
    formMethod: t.formMethod,
    formAction: t.formAction,
    formEncType: t.formEncType,
    formData: t.formData,
    json: t.json,
    text: t.text,
    data: r
  } : {
    state: "loading",
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0,
    data: r
  };
}
function GM(t, r) {
  return {
    state: "submitting",
    formMethod: t.formMethod,
    formAction: t.formAction,
    formEncType: t.formEncType,
    formData: t.formData,
    json: t.json,
    text: t.text,
    data: r ? r.data : void 0
  };
}
function Wh(t) {
  return {
    state: "idle",
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0,
    data: t
  };
}
function zM(t, r) {
  try {
    let i = t.sessionStorage.getItem(o9);
    if (i) {
      let u = JSON.parse(i);
      for (let [c, v] of Object.entries(u || {}))
        v && Array.isArray(v) && r.set(c, new Set(v || []));
    }
  } catch {
  }
}
function WM(t, r) {
  if (r.size > 0) {
    let i = {};
    for (let [u, c] of r)
      i[u] = [...c];
    try {
      t.sessionStorage.setItem(o9, JSON.stringify(i));
    } catch (u) {
      Di(!1, "Failed to save applied view transitions in sessionStorage (" + u + ").");
    }
  }
}
/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function hm() {
  return hm = Object.assign ? Object.assign.bind() : function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var i = arguments[r];
      for (var u in i)
        Object.prototype.hasOwnProperty.call(i, u) && (t[u] = i[u]);
    }
    return t;
  }, hm.apply(this, arguments);
}
const Qg = /* @__PURE__ */ k.createContext(null);
process.env.NODE_ENV !== "production" && (Qg.displayName = "DataRouter");
const DC = /* @__PURE__ */ k.createContext(null);
process.env.NODE_ENV !== "production" && (DC.displayName = "DataRouterState");
const XM = /* @__PURE__ */ k.createContext(null);
process.env.NODE_ENV !== "production" && (XM.displayName = "Await");
const $u = /* @__PURE__ */ k.createContext(null);
process.env.NODE_ENV !== "production" && ($u.displayName = "Navigation");
const r0 = /* @__PURE__ */ k.createContext(null);
process.env.NODE_ENV !== "production" && (r0.displayName = "Location");
const Zu = /* @__PURE__ */ k.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
process.env.NODE_ENV !== "production" && (Zu.displayName = "Route");
const n2 = /* @__PURE__ */ k.createContext(null);
process.env.NODE_ENV !== "production" && (n2.displayName = "RouteError");
function YM(t, r) {
  let {
    relative: i
  } = r === void 0 ? {} : r;
  Kg() || (process.env.NODE_ENV !== "production" ? qt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  ) : qt(!1));
  let {
    basename: u,
    navigator: c
  } = k.useContext($u), {
    hash: v,
    pathname: h,
    search: y
  } = a0(t, {
    relative: i
  }), g = h;
  return u !== "/" && (g = h === "/" ? u : id([u, h])), c.createHref({
    pathname: g,
    search: y,
    hash: v
  });
}
function Kg() {
  return k.useContext(r0) != null;
}
function Ju() {
  return Kg() || (process.env.NODE_ENV !== "production" ? qt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : qt(!1)), k.useContext(r0).location;
}
const f9 = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function d9(t) {
  k.useContext($u).static || k.useLayoutEffect(t);
}
function ym() {
  let {
    isDataRoute: t
  } = k.useContext(Zu);
  return t ? sP() : $M();
}
function $M() {
  Kg() || (process.env.NODE_ENV !== "production" ? qt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : qt(!1));
  let t = k.useContext(Qg), {
    basename: r,
    future: i,
    navigator: u
  } = k.useContext($u), {
    matches: c
  } = k.useContext(Zu), {
    pathname: v
  } = Ju(), h = JSON.stringify(OC(c, i.v7_relativeSplatPath)), y = k.useRef(!1);
  return d9(() => {
    y.current = !0;
  }), k.useCallback(function(S, x) {
    if (x === void 0 && (x = {}), process.env.NODE_ENV !== "production" && Di(y.current, f9), !y.current)
      return;
    if (typeof S == "number") {
      u.go(S);
      return;
    }
    let T = LC(S, JSON.parse(h), v, x.relative === "path");
    t == null && r !== "/" && (T.pathname = T.pathname === "/" ? r : id([r, T.pathname])), (x.replace ? u.replace : u.push)(T, x.state, x);
  }, [r, u, h, v, t]);
}
const ZM = /* @__PURE__ */ k.createContext(null);
function JM(t) {
  let r = k.useContext(Zu).outlet;
  return r && /* @__PURE__ */ k.createElement(ZM.Provider, {
    value: t
  }, r);
}
function Cm() {
  let {
    matches: t
  } = k.useContext(Zu), r = t[t.length - 1];
  return r ? r.params : {};
}
function a0(t, r) {
  let {
    relative: i
  } = r === void 0 ? {} : r, {
    future: u
  } = k.useContext($u), {
    matches: c
  } = k.useContext(Zu), {
    pathname: v
  } = Ju(), h = JSON.stringify(OC(c, u.v7_relativeSplatPath));
  return k.useMemo(() => LC(t, JSON.parse(h), v, i === "path"), [t, h, v, i]);
}
function QM(t, r, i, u) {
  Kg() || (process.env.NODE_ENV !== "production" ? qt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  ) : qt(!1));
  let {
    navigator: c,
    static: v
  } = k.useContext($u), {
    matches: h
  } = k.useContext(Zu), y = h[h.length - 1], g = y ? y.params : {}, S = y ? y.pathname : "/", x = y ? y.pathnameBase : "/", T = y && y.route;
  if (process.env.NODE_ENV !== "production") {
    let G = T && T.path || "";
    v9(S, !T || G.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + S + '" (under <Route path="' + G + '">) but the ') + `parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

` + ('Please change the parent <Route path="' + G + '"> to <Route ') + ('path="' + (G === "/" ? "*" : G + "/*") + '">.'));
  }
  let _ = Ju(), L;
  if (r) {
    var M;
    let G = typeof r == "string" ? xp(r) : r;
    x === "/" || (M = G.pathname) != null && M.startsWith(x) || (process.env.NODE_ENV !== "production" ? qt(!1, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + x + '" ') + ('but pathname "' + G.pathname + '" was given in the `location` prop.')) : qt(!1)), L = G;
  } else
    L = _;
  let U = L.pathname || "/", B = U;
  if (x !== "/") {
    let G = x.replace(/^\//, "").split("/");
    B = "/" + U.replace(/^\//, "").split("/").slice(G.length).join("/");
  }
  let H = !v && i && i.matches && i.matches.length > 0 ? i.matches : cm(t, {
    pathname: B
  });
  process.env.NODE_ENV !== "production" && (process.env.NODE_ENV !== "production" && Di(T || H != null, 'No routes matched location "' + L.pathname + L.search + L.hash + '" '), process.env.NODE_ENV !== "production" && Di(H == null || H[H.length - 1].route.element !== void 0 || H[H.length - 1].route.Component !== void 0 || H[H.length - 1].route.lazy !== void 0, 'Matched leaf route at location "' + L.pathname + L.search + L.hash + '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'));
  let Y = nP(H && H.map((G) => Object.assign({}, G, {
    params: Object.assign({}, g, G.params),
    pathname: id([
      x,
      // Re-encode pathnames that were decoded inside matchRoutes
      c.encodeLocation ? c.encodeLocation(G.pathname).pathname : G.pathname
    ]),
    pathnameBase: G.pathnameBase === "/" ? x : id([
      x,
      // Re-encode pathnames that were decoded inside matchRoutes
      c.encodeLocation ? c.encodeLocation(G.pathnameBase).pathname : G.pathnameBase
    ])
  })), h, i, u);
  return r && Y ? /* @__PURE__ */ k.createElement(r0.Provider, {
    value: {
      location: hm({
        pathname: "/",
        search: "",
        hash: "",
        state: null,
        key: "default"
      }, L),
      navigationType: Ci.Pop
    }
  }, Y) : Y;
}
function KM() {
  let t = iP(), r = qy(t) ? t.status + " " + t.statusText : t instanceof Error ? t.message : JSON.stringify(t), i = t instanceof Error ? t.stack : null, u = "rgba(200,200,200, 0.5)", c = {
    padding: "0.5rem",
    backgroundColor: u
  }, v = {
    padding: "2px 4px",
    backgroundColor: u
  }, h = null;
  return process.env.NODE_ENV !== "production" && (console.error("Error handled by React Router default ErrorBoundary:", t), h = /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ k.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ k.createElement("code", {
    style: v
  }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ k.createElement("code", {
    style: v
  }, "errorElement"), " prop on your route."))), /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ k.createElement("h3", {
    style: {
      fontStyle: "italic"
    }
  }, r), i ? /* @__PURE__ */ k.createElement("pre", {
    style: c
  }, i) : null, h);
}
const qM = /* @__PURE__ */ k.createElement(KM, null);
class eP extends k.Component {
  constructor(r) {
    super(r), this.state = {
      location: r.location,
      revalidation: r.revalidation,
      error: r.error
    };
  }
  static getDerivedStateFromError(r) {
    return {
      error: r
    };
  }
  static getDerivedStateFromProps(r, i) {
    return i.location !== r.location || i.revalidation !== "idle" && r.revalidation === "idle" ? {
      error: r.error,
      location: r.location,
      revalidation: r.revalidation
    } : {
      error: r.error !== void 0 ? r.error : i.error,
      location: i.location,
      revalidation: r.revalidation || i.revalidation
    };
  }
  componentDidCatch(r, i) {
    console.error("React Router caught the following error during render", r, i);
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ k.createElement(Zu.Provider, {
      value: this.props.routeContext
    }, /* @__PURE__ */ k.createElement(n2.Provider, {
      value: this.state.error,
      children: this.props.component
    })) : this.props.children;
  }
}
function tP(t) {
  let {
    routeContext: r,
    match: i,
    children: u
  } = t, c = k.useContext(Qg);
  return c && c.static && c.staticContext && (i.route.errorElement || i.route.ErrorBoundary) && (c.staticContext._deepestRenderedBoundaryId = i.route.id), /* @__PURE__ */ k.createElement(Zu.Provider, {
    value: r
  }, u);
}
function nP(t, r, i, u) {
  var c;
  if (r === void 0 && (r = []), i === void 0 && (i = null), u === void 0 && (u = null), t == null) {
    var v;
    if (!i)
      return null;
    if (i.errors)
      t = i.matches;
    else if ((v = u) != null && v.v7_partialHydration && r.length === 0 && !i.initialized && i.matches.length > 0)
      t = i.matches;
    else
      return null;
  }
  let h = t, y = (c = i) == null ? void 0 : c.errors;
  if (y != null) {
    let x = h.findIndex((T) => T.route.id && (y == null ? void 0 : y[T.route.id]) !== void 0);
    x >= 0 || (process.env.NODE_ENV !== "production" ? qt(!1, "Could not find a matching route for errors on route IDs: " + Object.keys(y).join(",")) : qt(!1)), h = h.slice(0, Math.min(h.length, x + 1));
  }
  let g = !1, S = -1;
  if (i && u && u.v7_partialHydration)
    for (let x = 0; x < h.length; x++) {
      let T = h[x];
      if ((T.route.HydrateFallback || T.route.hydrateFallbackElement) && (S = x), T.route.id) {
        let {
          loaderData: _,
          errors: L
        } = i, M = T.route.loader && _[T.route.id] === void 0 && (!L || L[T.route.id] === void 0);
        if (T.route.lazy || M) {
          g = !0, S >= 0 ? h = h.slice(0, S + 1) : h = [h[0]];
          break;
        }
      }
    }
  return h.reduceRight((x, T, _) => {
    let L, M = !1, U = null, B = null;
    i && (L = y && T.route.id ? y[T.route.id] : void 0, U = T.route.errorElement || qM, g && (S < 0 && _ === 0 ? (v9("route-fallback", !1, "No `HydrateFallback` element provided to render during initial hydration"), M = !0, B = null) : S === _ && (M = !0, B = T.route.hydrateFallbackElement || null)));
    let H = r.concat(h.slice(0, _ + 1)), Y = () => {
      let G;
      return L ? G = U : M ? G = B : T.route.Component ? G = /* @__PURE__ */ k.createElement(T.route.Component, null) : T.route.element ? G = T.route.element : G = x, /* @__PURE__ */ k.createElement(tP, {
        match: T,
        routeContext: {
          outlet: x,
          matches: H,
          isDataRoute: i != null
        },
        children: G
      });
    };
    return i && (T.route.ErrorBoundary || T.route.errorElement || _ === 0) ? /* @__PURE__ */ k.createElement(eP, {
      location: i.location,
      revalidation: i.revalidation,
      component: U,
      error: L,
      children: Y(),
      routeContext: {
        outlet: null,
        matches: H,
        isDataRoute: !0
      }
    }) : Y();
  }, null);
}
var r2 = /* @__PURE__ */ function(t) {
  return t.UseBlocker = "useBlocker", t.UseRevalidator = "useRevalidator", t.UseNavigateStable = "useNavigate", t;
}(r2 || {}), zg = /* @__PURE__ */ function(t) {
  return t.UseBlocker = "useBlocker", t.UseLoaderData = "useLoaderData", t.UseActionData = "useActionData", t.UseRouteError = "useRouteError", t.UseNavigation = "useNavigation", t.UseRouteLoaderData = "useRouteLoaderData", t.UseMatches = "useMatches", t.UseRevalidator = "useRevalidator", t.UseNavigateStable = "useNavigate", t.UseRouteId = "useRouteId", t;
}(zg || {});
function a2(t) {
  return t + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function p9(t) {
  let r = k.useContext(Qg);
  return r || (process.env.NODE_ENV !== "production" ? qt(!1, a2(t)) : qt(!1)), r;
}
function h9(t) {
  let r = k.useContext(DC);
  return r || (process.env.NODE_ENV !== "production" ? qt(!1, a2(t)) : qt(!1)), r;
}
function rP(t) {
  let r = k.useContext(Zu);
  return r || (process.env.NODE_ENV !== "production" ? qt(!1, a2(t)) : qt(!1)), r;
}
function i2(t) {
  let r = rP(t), i = r.matches[r.matches.length - 1];
  return i.route.id || (process.env.NODE_ENV !== "production" ? qt(!1, t + ' can only be used on routes that contain a unique "id"') : qt(!1)), i.route.id;
}
function aP() {
  return i2(zg.UseRouteId);
}
function iP() {
  var t;
  let r = k.useContext(n2), i = h9(zg.UseRouteError), u = i2(zg.UseRouteError);
  return r !== void 0 ? r : (t = i.errors) == null ? void 0 : t[u];
}
let oP = 0;
function lP(t) {
  let {
    router: r,
    basename: i
  } = p9(r2.UseBlocker), u = h9(zg.UseBlocker), [c, v] = k.useState(""), h = k.useCallback((y) => {
    if (typeof t != "function")
      return !!t;
    if (i === "/")
      return t(y);
    let {
      currentLocation: g,
      nextLocation: S,
      historyAction: x
    } = y;
    return t({
      currentLocation: hm({}, g, {
        pathname: Ks(g.pathname, i) || g.pathname
      }),
      nextLocation: hm({}, S, {
        pathname: Ks(S.pathname, i) || S.pathname
      }),
      historyAction: x
    });
  }, [i, t]);
  return k.useEffect(() => {
    let y = String(++oP);
    return v(y), () => r.deleteBlocker(y);
  }, [r]), k.useEffect(() => {
    c !== "" && r.getBlocker(c, h);
  }, [r, c, h]), c && u.blockers.has(c) ? u.blockers.get(c) : Ug;
}
function sP() {
  let {
    router: t
  } = p9(r2.UseNavigateStable), r = i2(zg.UseNavigateStable), i = k.useRef(!1);
  return d9(() => {
    i.current = !0;
  }), k.useCallback(function(c, v) {
    v === void 0 && (v = {}), process.env.NODE_ENV !== "production" && Di(i.current, f9), i.current && (typeof c == "number" ? t.navigate(c) : t.navigate(c, hm({
      fromRouteId: r
    }, v)));
  }, [t, r]);
}
const xN = {};
function v9(t, r, i) {
  !r && !xN[t] && (xN[t] = !0, process.env.NODE_ENV !== "production" && Di(!1, i));
}
const RN = {};
function uP(t, r) {
  process.env.NODE_ENV !== "production" && !RN[r] && (RN[r] = !0, console.warn(r));
}
const kg = (t, r, i) => uP(t, "⚠️ React Router Future Flag Warning: " + r + ". " + ("You can use the `" + t + "` future flag to opt-in early. ") + ("For more information, see " + i + "."));
function cP(t, r) {
  (t == null ? void 0 : t.v7_startTransition) === void 0 && kg("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition"), (t == null ? void 0 : t.v7_relativeSplatPath) === void 0 && (!r || !r.v7_relativeSplatPath) && kg("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath"), r && (r.v7_fetcherPersist === void 0 && kg("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist"), r.v7_normalizeFormMethod === void 0 && kg("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod"), r.v7_partialHydration === void 0 && kg("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration"), r.v7_skipActionErrorRevalidation === void 0 && kg("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation"));
}
function TN(t) {
  let {
    to: r,
    replace: i,
    state: u,
    relative: c
  } = t;
  Kg() || (process.env.NODE_ENV !== "production" ? qt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component."
  ) : qt(!1));
  let {
    future: v,
    static: h
  } = k.useContext($u);
  process.env.NODE_ENV !== "production" && Di(!h, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
  let {
    matches: y
  } = k.useContext(Zu), {
    pathname: g
  } = Ju(), S = ym(), x = LC(r, OC(y, v.v7_relativeSplatPath), g, c === "path"), T = JSON.stringify(x);
  return k.useEffect(() => S(JSON.parse(T), {
    replace: i,
    state: u,
    relative: c
  }), [S, T, c, i, u]), null;
}
function fP(t) {
  return JM(t.context);
}
function dP(t) {
  let {
    basename: r = "/",
    children: i = null,
    location: u,
    navigationType: c = Ci.Pop,
    navigator: v,
    static: h = !1,
    future: y
  } = t;
  Kg() && (process.env.NODE_ENV !== "production" ? qt(!1, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.") : qt(!1));
  let g = r.replace(/^\/*/, "/"), S = k.useMemo(() => ({
    basename: g,
    navigator: v,
    static: h,
    future: hm({
      v7_relativeSplatPath: !1
    }, y)
  }), [g, y, v, h]);
  typeof u == "string" && (u = xp(u));
  let {
    pathname: x = "/",
    search: T = "",
    hash: _ = "",
    state: L = null,
    key: M = "default"
  } = u, U = k.useMemo(() => {
    let B = Ks(x, g);
    return B == null ? null : {
      location: {
        pathname: B,
        search: T,
        hash: _,
        state: L,
        key: M
      },
      navigationType: c
    };
  }, [g, x, T, _, L, M, c]);
  return process.env.NODE_ENV !== "production" && Di(U != null, '<Router basename="' + g + '"> is not able to match the URL ' + ('"' + x + T + _ + '" because it does not start with the ') + "basename, so the <Router> won't render anything."), U == null ? null : /* @__PURE__ */ k.createElement($u.Provider, {
    value: S
  }, /* @__PURE__ */ k.createElement(r0.Provider, {
    children: i,
    value: U
  }));
}
new Promise(() => {
});
function pP(t) {
  let r = {
    // Note: this check also occurs in createRoutesFromChildren so update
    // there if you change this -- please and thank you!
    hasErrorBoundary: t.ErrorBoundary != null || t.errorElement != null
  };
  return t.Component && (process.env.NODE_ENV !== "production" && t.element && process.env.NODE_ENV !== "production" && Di(!1, "You should not include both `Component` and `element` on your route - `Component` will be used."), Object.assign(r, {
    element: /* @__PURE__ */ k.createElement(t.Component),
    Component: void 0
  })), t.HydrateFallback && (process.env.NODE_ENV !== "production" && t.hydrateFallbackElement && process.env.NODE_ENV !== "production" && Di(!1, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used."), Object.assign(r, {
    hydrateFallbackElement: /* @__PURE__ */ k.createElement(t.HydrateFallback),
    HydrateFallback: void 0
  })), t.ErrorBoundary && (process.env.NODE_ENV !== "production" && t.errorElement && process.env.NODE_ENV !== "production" && Di(!1, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used."), Object.assign(r, {
    errorElement: /* @__PURE__ */ k.createElement(t.ErrorBoundary),
    ErrorBoundary: void 0
  })), r;
}
/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Jh() {
  return Jh = Object.assign ? Object.assign.bind() : function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var i = arguments[r];
      for (var u in i)
        Object.prototype.hasOwnProperty.call(i, u) && (t[u] = i[u]);
    }
    return t;
  }, Jh.apply(this, arguments);
}
function o2(t, r) {
  if (t == null)
    return {};
  var i = {}, u = Object.keys(t), c, v;
  for (v = 0; v < u.length; v++)
    c = u[v], !(r.indexOf(c) >= 0) && (i[c] = t[c]);
  return i;
}
const oC = "get", lC = "application/x-www-form-urlencoded";
function MC(t) {
  return t != null && typeof t.tagName == "string";
}
function hP(t) {
  return MC(t) && t.tagName.toLowerCase() === "button";
}
function vP(t) {
  return MC(t) && t.tagName.toLowerCase() === "form";
}
function mP(t) {
  return MC(t) && t.tagName.toLowerCase() === "input";
}
function gP(t) {
  return !!(t.metaKey || t.altKey || t.ctrlKey || t.shiftKey);
}
function bP(t, r) {
  return t.button === 0 && // Ignore everything but left clicks
  (!r || r === "_self") && // Let browser handle "target=_blank" etc.
  !gP(t);
}
function hT(t) {
  return t === void 0 && (t = ""), new URLSearchParams(typeof t == "string" || Array.isArray(t) || t instanceof URLSearchParams ? t : Object.keys(t).reduce((r, i) => {
    let u = t[i];
    return r.concat(Array.isArray(u) ? u.map((c) => [i, c]) : [[i, u]]);
  }, []));
}
function yP(t, r) {
  let i = hT(t);
  return r && r.forEach((u, c) => {
    i.has(c) || r.getAll(c).forEach((v) => {
      i.append(c, v);
    });
  }), i;
}
let $1 = null;
function CP() {
  if ($1 === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), $1 = !1;
    } catch {
      $1 = !0;
    }
  return $1;
}
const EP = /* @__PURE__ */ new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function UR(t) {
  return t != null && !EP.has(t) ? (process.env.NODE_ENV !== "production" && Di(!1, '"' + t + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + lC + '"')), null) : t;
}
function SP(t, r) {
  let i, u, c, v, h;
  if (vP(t)) {
    let y = t.getAttribute("action");
    u = y ? Ks(y, r) : null, i = t.getAttribute("method") || oC, c = UR(t.getAttribute("enctype")) || lC, v = new FormData(t);
  } else if (hP(t) || mP(t) && (t.type === "submit" || t.type === "image")) {
    let y = t.form;
    if (y == null)
      throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
    let g = t.getAttribute("formaction") || y.getAttribute("action");
    if (u = g ? Ks(g, r) : null, i = t.getAttribute("formmethod") || y.getAttribute("method") || oC, c = UR(t.getAttribute("formenctype")) || UR(y.getAttribute("enctype")) || lC, v = new FormData(y, t), !CP()) {
      let {
        name: S,
        type: x,
        value: T
      } = t;
      if (x === "image") {
        let _ = S ? S + "." : "";
        v.append(_ + "x", "0"), v.append(_ + "y", "0");
      } else
        S && v.append(S, T);
    }
  } else {
    if (MC(t))
      throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    i = oC, u = null, c = lC, h = t;
  }
  return v && c === "text/plain" && (h = v, v = void 0), {
    action: u,
    method: i.toLowerCase(),
    encType: c,
    formData: v,
    body: h
  };
}
const xP = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "viewTransition"], RP = ["aria-current", "caseSensitive", "className", "end", "style", "to", "viewTransition", "children"], TP = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "viewTransition"], wP = "6";
try {
  window.__reactRouterVersion = wP;
} catch {
}
function IP(t, r) {
  return wM({
    basename: r == null ? void 0 : r.basename,
    future: Jh({}, r == null ? void 0 : r.future, {
      v7_prependBasename: !0
    }),
    history: J5({
      window: r == null ? void 0 : r.window
    }),
    hydrationData: (r == null ? void 0 : r.hydrationData) || AP(),
    routes: t,
    mapRouteProperties: pP,
    dataStrategy: r == null ? void 0 : r.dataStrategy,
    patchRoutesOnNavigation: r == null ? void 0 : r.patchRoutesOnNavigation,
    window: r == null ? void 0 : r.window
  }).initialize();
}
function AP() {
  var t;
  let r = (t = window) == null ? void 0 : t.__staticRouterHydrationData;
  return r && r.errors && (r = Jh({}, r, {
    errors: NP(r.errors)
  })), r;
}
function NP(t) {
  if (!t)
    return null;
  let r = Object.entries(t), i = {};
  for (let [u, c] of r)
    if (c && c.__type === "RouteErrorResponse")
      i[u] = new mC(c.status, c.statusText, c.data, c.internal === !0);
    else if (c && c.__type === "Error") {
      if (c.__subType) {
        let v = window[c.__subType];
        if (typeof v == "function")
          try {
            let h = new v(c.message);
            h.stack = "", i[u] = h;
          } catch {
          }
      }
      if (i[u] == null) {
        let v = new Error(c.message);
        v.stack = "", i[u] = v;
      }
    } else
      i[u] = c;
  return i;
}
const l2 = /* @__PURE__ */ k.createContext({
  isTransitioning: !1
});
process.env.NODE_ENV !== "production" && (l2.displayName = "ViewTransition");
const m9 = /* @__PURE__ */ k.createContext(/* @__PURE__ */ new Map());
process.env.NODE_ENV !== "production" && (m9.displayName = "Fetchers");
const _P = "startTransition", wN = uT[_P], OP = "flushSync", IN = Z5[OP];
function LP(t) {
  wN ? wN(t) : t();
}
function By(t) {
  IN ? IN(t) : t();
}
class DP {
  constructor() {
    this.status = "pending", this.promise = new Promise((r, i) => {
      this.resolve = (u) => {
        this.status === "pending" && (this.status = "resolved", r(u));
      }, this.reject = (u) => {
        this.status === "pending" && (this.status = "rejected", i(u));
      };
    });
  }
}
function MP(t) {
  let {
    fallbackElement: r,
    router: i,
    future: u
  } = t, [c, v] = k.useState(i.state), [h, y] = k.useState(), [g, S] = k.useState({
    isTransitioning: !1
  }), [x, T] = k.useState(), [_, L] = k.useState(), [M, U] = k.useState(), B = k.useRef(/* @__PURE__ */ new Map()), {
    v7_startTransition: H
  } = u || {}, Y = k.useCallback((re) => {
    H ? LP(re) : re();
  }, [H]), G = k.useCallback((re, me) => {
    let {
      deletedFetchers: Se,
      flushSync: Ne,
      viewTransitionOpts: Ge
    } = me;
    re.fetchers.forEach((qe, at) => {
      qe.data !== void 0 && B.current.set(at, qe.data);
    }), Se.forEach((qe) => B.current.delete(qe));
    let ze = i.window == null || i.window.document == null || typeof i.window.document.startViewTransition != "function";
    if (!Ge || ze) {
      Ne ? By(() => v(re)) : Y(() => v(re));
      return;
    }
    if (Ne) {
      By(() => {
        _ && (x && x.resolve(), _.skipTransition()), S({
          isTransitioning: !0,
          flushSync: !0,
          currentLocation: Ge.currentLocation,
          nextLocation: Ge.nextLocation
        });
      });
      let qe = i.window.document.startViewTransition(() => {
        By(() => v(re));
      });
      qe.finished.finally(() => {
        By(() => {
          T(void 0), L(void 0), y(void 0), S({
            isTransitioning: !1
          });
        });
      }), By(() => L(qe));
      return;
    }
    _ ? (x && x.resolve(), _.skipTransition(), U({
      state: re,
      currentLocation: Ge.currentLocation,
      nextLocation: Ge.nextLocation
    })) : (y(re), S({
      isTransitioning: !0,
      flushSync: !1,
      currentLocation: Ge.currentLocation,
      nextLocation: Ge.nextLocation
    }));
  }, [i.window, _, x, B, Y]);
  k.useLayoutEffect(() => i.subscribe(G), [i, G]), k.useEffect(() => {
    g.isTransitioning && !g.flushSync && T(new DP());
  }, [g]), k.useEffect(() => {
    if (x && h && i.window) {
      let re = h, me = x.promise, Se = i.window.document.startViewTransition(async () => {
        Y(() => v(re)), await me;
      });
      Se.finished.finally(() => {
        T(void 0), L(void 0), y(void 0), S({
          isTransitioning: !1
        });
      }), L(Se);
    }
  }, [Y, h, x, i.window]), k.useEffect(() => {
    x && h && c.location.key === h.location.key && x.resolve();
  }, [x, _, c.location, h]), k.useEffect(() => {
    !g.isTransitioning && M && (y(M.state), S({
      isTransitioning: !0,
      flushSync: !1,
      currentLocation: M.currentLocation,
      nextLocation: M.nextLocation
    }), U(void 0));
  }, [g.isTransitioning, M]), k.useEffect(() => {
    process.env.NODE_ENV !== "production" && Di(r == null || !i.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
  }, []);
  let Q = k.useMemo(() => ({
    createHref: i.createHref,
    encodeLocation: i.encodeLocation,
    go: (re) => i.navigate(re),
    push: (re, me, Se) => i.navigate(re, {
      state: me,
      preventScrollReset: Se == null ? void 0 : Se.preventScrollReset
    }),
    replace: (re, me, Se) => i.navigate(re, {
      replace: !0,
      state: me,
      preventScrollReset: Se == null ? void 0 : Se.preventScrollReset
    })
  }), [i]), W = i.basename || "/", oe = k.useMemo(() => ({
    router: i,
    navigator: Q,
    static: !1,
    basename: W
  }), [i, Q, W]), j = k.useMemo(() => ({
    v7_relativeSplatPath: i.future.v7_relativeSplatPath
  }), [i.future.v7_relativeSplatPath]);
  return k.useEffect(() => cP(u, i.future), [u, i.future]), /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(Qg.Provider, {
    value: oe
  }, /* @__PURE__ */ k.createElement(DC.Provider, {
    value: c
  }, /* @__PURE__ */ k.createElement(m9.Provider, {
    value: B.current
  }, /* @__PURE__ */ k.createElement(l2.Provider, {
    value: g
  }, /* @__PURE__ */ k.createElement(dP, {
    basename: W,
    location: c.location,
    navigationType: c.historyAction,
    navigator: Q,
    future: j
  }, c.initialized || i.future.v7_partialHydration ? /* @__PURE__ */ k.createElement(PP, {
    routes: i.routes,
    future: i.future,
    state: c
  }) : r))))), null);
}
const PP = /* @__PURE__ */ k.memo(kP);
function kP(t) {
  let {
    routes: r,
    future: i,
    state: u
  } = t;
  return QM(r, void 0, u, i);
}
process.env.NODE_ENV;
const FP = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", BP = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, s2 = /* @__PURE__ */ k.forwardRef(function(r, i) {
  let {
    onClick: u,
    relative: c,
    reloadDocument: v,
    replace: h,
    state: y,
    target: g,
    to: S,
    preventScrollReset: x,
    viewTransition: T
  } = r, _ = o2(r, xP), {
    basename: L
  } = k.useContext($u), M, U = !1;
  if (typeof S == "string" && BP.test(S) && (M = S, FP))
    try {
      let G = new URL(window.location.href), Q = S.startsWith("//") ? new URL(G.protocol + S) : new URL(S), W = Ks(Q.pathname, L);
      Q.origin === G.origin && W != null ? S = W + Q.search + Q.hash : U = !0;
    } catch {
      process.env.NODE_ENV !== "production" && Di(!1, '<Link to="' + S + '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.');
    }
  let B = YM(S, {
    relative: c
  }), H = jP(S, {
    replace: h,
    state: y,
    target: g,
    preventScrollReset: x,
    relative: c,
    viewTransition: T
  });
  function Y(G) {
    u && u(G), G.defaultPrevented || H(G);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ k.createElement("a", Jh({}, _, {
      href: M || B,
      onClick: U || v ? u : Y,
      ref: i,
      target: g
    }))
  );
});
process.env.NODE_ENV !== "production" && (s2.displayName = "Link");
const UP = /* @__PURE__ */ k.forwardRef(function(r, i) {
  let {
    "aria-current": u = "page",
    caseSensitive: c = !1,
    className: v = "",
    end: h = !1,
    style: y,
    to: g,
    viewTransition: S,
    children: x
  } = r, T = o2(r, RP), _ = a0(g, {
    relative: T.relative
  }), L = Ju(), M = k.useContext(DC), {
    navigator: U,
    basename: B
  } = k.useContext($u), H = M != null && // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  $P(_) && S === !0, Y = U.encodeLocation ? U.encodeLocation(_).pathname : _.pathname, G = L.pathname, Q = M && M.navigation && M.navigation.location ? M.navigation.location.pathname : null;
  c || (G = G.toLowerCase(), Q = Q ? Q.toLowerCase() : null, Y = Y.toLowerCase()), Q && B && (Q = Ks(Q, B) || Q);
  const W = Y !== "/" && Y.endsWith("/") ? Y.length - 1 : Y.length;
  let oe = G === Y || !h && G.startsWith(Y) && G.charAt(W) === "/", j = Q != null && (Q === Y || !h && Q.startsWith(Y) && Q.charAt(Y.length) === "/"), re = {
    isActive: oe,
    isPending: j,
    isTransitioning: H
  }, me = oe ? u : void 0, Se;
  typeof v == "function" ? Se = v(re) : Se = [v, oe ? "active" : null, j ? "pending" : null, H ? "transitioning" : null].filter(Boolean).join(" ");
  let Ne = typeof y == "function" ? y(re) : y;
  return /* @__PURE__ */ k.createElement(s2, Jh({}, T, {
    "aria-current": me,
    className: Se,
    ref: i,
    style: Ne,
    to: g,
    viewTransition: S
  }), typeof x == "function" ? x(re) : x);
});
process.env.NODE_ENV !== "production" && (UP.displayName = "NavLink");
const VP = /* @__PURE__ */ k.forwardRef((t, r) => {
  let {
    fetcherKey: i,
    navigate: u,
    reloadDocument: c,
    replace: v,
    state: h,
    method: y = oC,
    action: g,
    onSubmit: S,
    relative: x,
    preventScrollReset: T,
    viewTransition: _
  } = t, L = o2(t, TP), M = XP(), U = YP(g, {
    relative: x
  }), B = y.toLowerCase() === "get" ? "get" : "post", H = (Y) => {
    if (S && S(Y), Y.defaultPrevented)
      return;
    Y.preventDefault();
    let G = Y.nativeEvent.submitter, Q = (G == null ? void 0 : G.getAttribute("formmethod")) || y;
    M(G || Y.currentTarget, {
      fetcherKey: i,
      method: Q,
      navigate: u,
      replace: v,
      state: h,
      relative: x,
      preventScrollReset: T,
      viewTransition: _
    });
  };
  return /* @__PURE__ */ k.createElement("form", Jh({
    ref: r,
    method: B,
    action: U,
    onSubmit: c ? S : H
  }, L));
});
process.env.NODE_ENV !== "production" && (VP.displayName = "Form");
process.env.NODE_ENV;
var gC;
(function(t) {
  t.UseScrollRestoration = "useScrollRestoration", t.UseSubmit = "useSubmit", t.UseSubmitFetcher = "useSubmitFetcher", t.UseFetcher = "useFetcher", t.useViewTransitionState = "useViewTransitionState";
})(gC || (gC = {}));
var AN;
(function(t) {
  t.UseFetcher = "useFetcher", t.UseFetchers = "useFetchers", t.UseScrollRestoration = "useScrollRestoration";
})(AN || (AN = {}));
function HP(t) {
  return t + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function g9(t) {
  let r = k.useContext(Qg);
  return r || (process.env.NODE_ENV !== "production" ? qt(!1, HP(t)) : qt(!1)), r;
}
function jP(t, r) {
  let {
    target: i,
    replace: u,
    state: c,
    preventScrollReset: v,
    relative: h,
    viewTransition: y
  } = r === void 0 ? {} : r, g = ym(), S = Ju(), x = a0(t, {
    relative: h
  });
  return k.useCallback((T) => {
    if (bP(T, i)) {
      T.preventDefault();
      let _ = u !== void 0 ? u : Zh(S) === Zh(x);
      g(t, {
        replace: _,
        state: c,
        preventScrollReset: v,
        relative: h,
        viewTransition: y
      });
    }
  }, [S, g, x, u, c, i, t, v, h, y]);
}
function qc(t) {
  process.env.NODE_ENV !== "production" && Di(typeof URLSearchParams < "u", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
  let r = k.useRef(hT(t)), i = k.useRef(!1), u = Ju(), c = k.useMemo(() => (
    // Only merge in the defaults if we haven't yet called setSearchParams.
    // Once we call that we want those to take precedence, otherwise you can't
    // remove a param with setSearchParams({}) if it has an initial value
    yP(u.search, i.current ? null : r.current)
  ), [u.search]), v = ym(), h = k.useCallback((y, g) => {
    const S = hT(typeof y == "function" ? y(c) : y);
    i.current = !0, v("?" + S, g);
  }, [v, c]);
  return [c, h];
}
function GP() {
  if (typeof document > "u")
    throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let zP = 0, WP = () => "__" + String(++zP) + "__";
function XP() {
  let {
    router: t
  } = g9(gC.UseSubmit), {
    basename: r
  } = k.useContext($u), i = aP();
  return k.useCallback(function(u, c) {
    c === void 0 && (c = {}), GP();
    let {
      action: v,
      method: h,
      encType: y,
      formData: g,
      body: S
    } = SP(u, r);
    if (c.navigate === !1) {
      let x = c.fetcherKey || WP();
      t.fetch(x, i, c.action || v, {
        preventScrollReset: c.preventScrollReset,
        formData: g,
        body: S,
        formMethod: c.method || h,
        formEncType: c.encType || y,
        flushSync: c.flushSync
      });
    } else
      t.navigate(c.action || v, {
        preventScrollReset: c.preventScrollReset,
        formData: g,
        body: S,
        formMethod: c.method || h,
        formEncType: c.encType || y,
        replace: c.replace,
        state: c.state,
        fromRouteId: i,
        flushSync: c.flushSync,
        viewTransition: c.viewTransition
      });
  }, [t, r, i]);
}
function YP(t, r) {
  let {
    relative: i
  } = r === void 0 ? {} : r, {
    basename: u
  } = k.useContext($u), c = k.useContext(Zu);
  c || (process.env.NODE_ENV !== "production" ? qt(!1, "useFormAction must be used inside a RouteContext") : qt(!1));
  let [v] = c.matches.slice(-1), h = Jh({}, a0(t || ".", {
    relative: i
  })), y = Ju();
  if (t == null) {
    h.search = y.search;
    let g = new URLSearchParams(h.search), S = g.getAll("index");
    if (S.some((T) => T === "")) {
      g.delete("index"), S.filter((_) => _).forEach((_) => g.append("index", _));
      let T = g.toString();
      h.search = T ? "?" + T : "";
    }
  }
  return (!t || t === ".") && v.route.index && (h.search = h.search ? h.search.replace(/^\?/, "?index&") : "?index"), u !== "/" && (h.pathname = h.pathname === "/" ? u : id([u, h.pathname])), Zh(h);
}
function $P(t, r) {
  r === void 0 && (r = {});
  let i = k.useContext(l2);
  i == null && (process.env.NODE_ENV !== "production" ? qt(!1, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?") : qt(!1));
  let {
    basename: u
  } = g9(gC.useViewTransitionState), c = a0(t, {
    relative: r.relative
  });
  if (!i.isTransitioning)
    return !1;
  let v = Ks(i.currentLocation.pathname, u) || i.currentLocation.pathname, h = Ks(i.nextLocation.pathname, u) || i.nextLocation.pathname;
  return pm(c.pathname, h) != null || pm(c.pathname, v) != null;
}
var vT = function(t, r) {
  return vT = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, u) {
    i.__proto__ = u;
  } || function(i, u) {
    for (var c in u)
      Object.prototype.hasOwnProperty.call(u, c) && (i[c] = u[c]);
  }, vT(t, r);
};
function Qu(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  vT(t, r);
  function i() {
    this.constructor = t;
  }
  t.prototype = r === null ? Object.create(r) : (i.prototype = r.prototype, new i());
}
var Gt = function() {
  return Gt = Object.assign || function(r) {
    for (var i, u = 1, c = arguments.length; u < c; u++) {
      i = arguments[u];
      for (var v in i)
        Object.prototype.hasOwnProperty.call(i, v) && (r[v] = i[v]);
    }
    return r;
  }, Gt.apply(this, arguments);
};
function Wg(t, r) {
  var i = {};
  for (var u in t)
    Object.prototype.hasOwnProperty.call(t, u) && r.indexOf(u) < 0 && (i[u] = t[u]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var c = 0, u = Object.getOwnPropertySymbols(t); c < u.length; c++)
      r.indexOf(u[c]) < 0 && Object.prototype.propertyIsEnumerable.call(t, u[c]) && (i[u[c]] = t[u[c]]);
  return i;
}
function Gl(t, r, i) {
  if (i || arguments.length === 2)
    for (var u = 0, c = r.length, v; u < c; u++)
      (v || !(u in r)) && (v || (v = Array.prototype.slice.call(r, 0, u)), v[u] = r[u]);
  return t.concat(v || Array.prototype.slice.call(r));
}
function Hl(t, r) {
  var i = r && r.cache ? r.cache : ek, u = r && r.serializer ? r.serializer : qP, c = r && r.strategy ? r.strategy : JP;
  return c(t, {
    cache: i,
    serializer: u
  });
}
function ZP(t) {
  return t == null || typeof t == "number" || typeof t == "boolean";
}
function b9(t, r, i, u) {
  var c = ZP(u) ? u : i(u), v = r.get(c);
  return typeof v > "u" && (v = t.call(this, u), r.set(c, v)), v;
}
function y9(t, r, i) {
  var u = Array.prototype.slice.call(arguments, 3), c = i(u), v = r.get(c);
  return typeof v > "u" && (v = t.apply(this, u), r.set(c, v)), v;
}
function u2(t, r, i, u, c) {
  return i.bind(r, t, u, c);
}
function JP(t, r) {
  var i = t.length === 1 ? b9 : y9;
  return u2(t, this, i, r.cache.create(), r.serializer);
}
function QP(t, r) {
  return u2(t, this, y9, r.cache.create(), r.serializer);
}
function KP(t, r) {
  return u2(t, this, b9, r.cache.create(), r.serializer);
}
var qP = function() {
  return JSON.stringify(arguments);
};
function c2() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
c2.prototype.get = function(t) {
  return this.cache[t];
};
c2.prototype.set = function(t, r) {
  this.cache[t] = r;
};
var ek = {
  create: function() {
    return new c2();
  }
}, jl = {
  variadic: QP,
  monadic: KP
};
function C9(t, r, i) {
  if (i === void 0 && (i = Error), !t)
    throw new i(r);
}
Hl(function() {
  for (var t, r = [], i = 0; i < arguments.length; i++)
    r[i] = arguments[i];
  return new ((t = Intl.NumberFormat).bind.apply(t, Gl([void 0], r, !1)))();
}, {
  strategy: jl.variadic
});
Hl(function() {
  for (var t, r = [], i = 0; i < arguments.length; i++)
    r[i] = arguments[i];
  return new ((t = Intl.DateTimeFormat).bind.apply(t, Gl([void 0], r, !1)))();
}, {
  strategy: jl.variadic
});
Hl(function() {
  for (var t, r = [], i = 0; i < arguments.length; i++)
    r[i] = arguments[i];
  return new ((t = Intl.PluralRules).bind.apply(t, Gl([void 0], r, !1)))();
}, {
  strategy: jl.variadic
});
Hl(function() {
  for (var t, r = [], i = 0; i < arguments.length; i++)
    r[i] = arguments[i];
  return new ((t = Intl.Locale).bind.apply(t, Gl([void 0], r, !1)))();
}, {
  strategy: jl.variadic
});
Hl(function() {
  for (var t, r = [], i = 0; i < arguments.length; i++)
    r[i] = arguments[i];
  return new ((t = Intl.ListFormat).bind.apply(t, Gl([void 0], r, !1)))();
}, {
  strategy: jl.variadic
});
var mr;
(function(t) {
  t[t.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", t[t.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", t[t.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", t[t.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", t[t.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", t[t.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", t[t.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", t[t.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", t[t.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", t[t.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", t[t.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", t[t.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", t[t.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", t[t.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", t[t.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", t[t.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", t[t.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", t[t.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", t[t.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", t[t.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", t[t.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", t[t.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", t[t.INVALID_TAG = 23] = "INVALID_TAG", t[t.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", t[t.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", t[t.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(mr || (mr = {}));
var Oa;
(function(t) {
  t[t.literal = 0] = "literal", t[t.argument = 1] = "argument", t[t.number = 2] = "number", t[t.date = 3] = "date", t[t.time = 4] = "time", t[t.select = 5] = "select", t[t.plural = 6] = "plural", t[t.pound = 7] = "pound", t[t.tag = 8] = "tag";
})(Oa || (Oa = {}));
var Xg;
(function(t) {
  t[t.number = 0] = "number", t[t.dateTime = 1] = "dateTime";
})(Xg || (Xg = {}));
function NN(t) {
  return t.type === Oa.literal;
}
function tk(t) {
  return t.type === Oa.argument;
}
function E9(t) {
  return t.type === Oa.number;
}
function S9(t) {
  return t.type === Oa.date;
}
function x9(t) {
  return t.type === Oa.time;
}
function R9(t) {
  return t.type === Oa.select;
}
function T9(t) {
  return t.type === Oa.plural;
}
function nk(t) {
  return t.type === Oa.pound;
}
function w9(t) {
  return t.type === Oa.tag;
}
function I9(t) {
  return !!(t && typeof t == "object" && t.type === Xg.number);
}
function mT(t) {
  return !!(t && typeof t == "object" && t.type === Xg.dateTime);
}
var A9 = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, rk = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function ak(t) {
  var r = {};
  return t.replace(rk, function(i) {
    var u = i.length;
    switch (i[0]) {
      case "G":
        r.era = u === 4 ? "long" : u === 5 ? "narrow" : "short";
        break;
      case "y":
        r.year = u === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        r.month = ["numeric", "2-digit", "short", "long", "narrow"][u - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        r.day = ["numeric", "2-digit"][u - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        r.weekday = u === 4 ? "long" : u === 5 ? "narrow" : "short";
        break;
      case "e":
        if (u < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        r.weekday = ["short", "long", "narrow", "short"][u - 4];
        break;
      case "c":
        if (u < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        r.weekday = ["short", "long", "narrow", "short"][u - 4];
        break;
      case "a":
        r.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        r.hourCycle = "h12", r.hour = ["numeric", "2-digit"][u - 1];
        break;
      case "H":
        r.hourCycle = "h23", r.hour = ["numeric", "2-digit"][u - 1];
        break;
      case "K":
        r.hourCycle = "h11", r.hour = ["numeric", "2-digit"][u - 1];
        break;
      case "k":
        r.hourCycle = "h24", r.hour = ["numeric", "2-digit"][u - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        r.minute = ["numeric", "2-digit"][u - 1];
        break;
      case "s":
        r.second = ["numeric", "2-digit"][u - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        r.timeZoneName = u < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), r;
}
var ik = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function ok(t) {
  if (t.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var r = t.split(ik).filter(function(_) {
    return _.length > 0;
  }), i = [], u = 0, c = r; u < c.length; u++) {
    var v = c[u], h = v.split("/");
    if (h.length === 0)
      throw new Error("Invalid number skeleton");
    for (var y = h[0], g = h.slice(1), S = 0, x = g; S < x.length; S++) {
      var T = x[S];
      if (T.length === 0)
        throw new Error("Invalid number skeleton");
    }
    i.push({ stem: y, options: g });
  }
  return i;
}
function lk(t) {
  return t.replace(/^(.*?)-/, "");
}
var _N = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, N9 = /^(@+)?(\+|#+)?[rs]?$/g, sk = /(\*)(0+)|(#+)(0+)|(0+)/g, _9 = /^(0+)$/;
function ON(t) {
  var r = {};
  return t[t.length - 1] === "r" ? r.roundingPriority = "morePrecision" : t[t.length - 1] === "s" && (r.roundingPriority = "lessPrecision"), t.replace(N9, function(i, u, c) {
    return typeof c != "string" ? (r.minimumSignificantDigits = u.length, r.maximumSignificantDigits = u.length) : c === "+" ? r.minimumSignificantDigits = u.length : u[0] === "#" ? r.maximumSignificantDigits = u.length : (r.minimumSignificantDigits = u.length, r.maximumSignificantDigits = u.length + (typeof c == "string" ? c.length : 0)), "";
  }), r;
}
function O9(t) {
  switch (t) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function uk(t) {
  var r;
  if (t[0] === "E" && t[1] === "E" ? (r = {
    notation: "engineering"
  }, t = t.slice(2)) : t[0] === "E" && (r = {
    notation: "scientific"
  }, t = t.slice(1)), r) {
    var i = t.slice(0, 2);
    if (i === "+!" ? (r.signDisplay = "always", t = t.slice(2)) : i === "+?" && (r.signDisplay = "exceptZero", t = t.slice(2)), !_9.test(t))
      throw new Error("Malformed concise eng/scientific notation");
    r.minimumIntegerDigits = t.length;
  }
  return r;
}
function LN(t) {
  var r = {}, i = O9(t);
  return i || r;
}
function ck(t) {
  for (var r = {}, i = 0, u = t; i < u.length; i++) {
    var c = u[i];
    switch (c.stem) {
      case "percent":
      case "%":
        r.style = "percent";
        continue;
      case "%x100":
        r.style = "percent", r.scale = 100;
        continue;
      case "currency":
        r.style = "currency", r.currency = c.options[0];
        continue;
      case "group-off":
      case ",_":
        r.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        r.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        r.style = "unit", r.unit = lk(c.options[0]);
        continue;
      case "compact-short":
      case "K":
        r.notation = "compact", r.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        r.notation = "compact", r.compactDisplay = "long";
        continue;
      case "scientific":
        r = Gt(Gt(Gt({}, r), { notation: "scientific" }), c.options.reduce(function(g, S) {
          return Gt(Gt({}, g), LN(S));
        }, {}));
        continue;
      case "engineering":
        r = Gt(Gt(Gt({}, r), { notation: "engineering" }), c.options.reduce(function(g, S) {
          return Gt(Gt({}, g), LN(S));
        }, {}));
        continue;
      case "notation-simple":
        r.notation = "standard";
        continue;
      case "unit-width-narrow":
        r.currencyDisplay = "narrowSymbol", r.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        r.currencyDisplay = "code", r.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        r.currencyDisplay = "name", r.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        r.currencyDisplay = "symbol";
        continue;
      case "scale":
        r.scale = parseFloat(c.options[0]);
        continue;
      case "rounding-mode-floor":
        r.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        r.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        r.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        r.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        r.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        r.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        r.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (c.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        c.options[0].replace(sk, function(g, S, x, T, _, L) {
          if (S)
            r.minimumIntegerDigits = x.length;
          else {
            if (T && _)
              throw new Error("We currently do not support maximum integer digits");
            if (L)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (_9.test(c.stem)) {
      r.minimumIntegerDigits = c.stem.length;
      continue;
    }
    if (_N.test(c.stem)) {
      if (c.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      c.stem.replace(_N, function(g, S, x, T, _, L) {
        return x === "*" ? r.minimumFractionDigits = S.length : T && T[0] === "#" ? r.maximumFractionDigits = T.length : _ && L ? (r.minimumFractionDigits = _.length, r.maximumFractionDigits = _.length + L.length) : (r.minimumFractionDigits = S.length, r.maximumFractionDigits = S.length), "";
      });
      var v = c.options[0];
      v === "w" ? r = Gt(Gt({}, r), { trailingZeroDisplay: "stripIfInteger" }) : v && (r = Gt(Gt({}, r), ON(v)));
      continue;
    }
    if (N9.test(c.stem)) {
      r = Gt(Gt({}, r), ON(c.stem));
      continue;
    }
    var h = O9(c.stem);
    h && (r = Gt(Gt({}, r), h));
    var y = uk(c.stem);
    y && (r = Gt(Gt({}, r), y));
  }
  return r;
}
var Z1 = {
  "001": [
    "H",
    "h"
  ],
  419: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CU: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-HK": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-IL": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "en-MY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function fk(t, r) {
  for (var i = "", u = 0; u < t.length; u++) {
    var c = t.charAt(u);
    if (c === "j") {
      for (var v = 0; u + 1 < t.length && t.charAt(u + 1) === c; )
        v++, u++;
      var h = 1 + (v & 1), y = v < 2 ? 1 : 3 + (v >> 1), g = "a", S = dk(r);
      for ((S == "H" || S == "k") && (y = 0); y-- > 0; )
        i += g;
      for (; h-- > 0; )
        i = S + i;
    } else
      c === "J" ? i += "H" : i += c;
  }
  return i;
}
function dk(t) {
  var r = t.hourCycle;
  if (r === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  t.hourCycles && // @ts-ignore
  t.hourCycles.length && (r = t.hourCycles[0]), r)
    switch (r) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var i = t.language, u;
  i !== "root" && (u = t.maximize().region);
  var c = Z1[u || ""] || Z1[i || ""] || Z1["".concat(i, "-001")] || Z1["001"];
  return c[0];
}
var VR, pk = new RegExp("^".concat(A9.source, "*")), hk = new RegExp("".concat(A9.source, "*$"));
function Sr(t, r) {
  return { start: t, end: r };
}
var vk = !!String.prototype.startsWith && "_a".startsWith("a", 1), mk = !!String.fromCodePoint, gk = !!Object.fromEntries, bk = !!String.prototype.codePointAt, yk = !!String.prototype.trimStart, Ck = !!String.prototype.trimEnd, Ek = !!Number.isSafeInteger, Sk = Ek ? Number.isSafeInteger : function(t) {
  return typeof t == "number" && isFinite(t) && Math.floor(t) === t && Math.abs(t) <= 9007199254740991;
}, gT = !0;
try {
  var xk = D9("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  gT = ((VR = xk.exec("a")) === null || VR === void 0 ? void 0 : VR[0]) === "a";
} catch {
  gT = !1;
}
var DN = vk ? (
  // Native
  function(r, i, u) {
    return r.startsWith(i, u);
  }
) : (
  // For IE11
  function(r, i, u) {
    return r.slice(u, u + i.length) === i;
  }
), bT = mk ? String.fromCodePoint : (
  // IE11
  function() {
    for (var r = [], i = 0; i < arguments.length; i++)
      r[i] = arguments[i];
    for (var u = "", c = r.length, v = 0, h; c > v; ) {
      if (h = r[v++], h > 1114111)
        throw RangeError(h + " is not a valid code point");
      u += h < 65536 ? String.fromCharCode(h) : String.fromCharCode(((h -= 65536) >> 10) + 55296, h % 1024 + 56320);
    }
    return u;
  }
), MN = (
  // native
  gk ? Object.fromEntries : (
    // Ponyfill
    function(r) {
      for (var i = {}, u = 0, c = r; u < c.length; u++) {
        var v = c[u], h = v[0], y = v[1];
        i[h] = y;
      }
      return i;
    }
  )
), L9 = bk ? (
  // Native
  function(r, i) {
    return r.codePointAt(i);
  }
) : (
  // IE 11
  function(r, i) {
    var u = r.length;
    if (!(i < 0 || i >= u)) {
      var c = r.charCodeAt(i), v;
      return c < 55296 || c > 56319 || i + 1 === u || (v = r.charCodeAt(i + 1)) < 56320 || v > 57343 ? c : (c - 55296 << 10) + (v - 56320) + 65536;
    }
  }
), Rk = yk ? (
  // Native
  function(r) {
    return r.trimStart();
  }
) : (
  // Ponyfill
  function(r) {
    return r.replace(pk, "");
  }
), Tk = Ck ? (
  // Native
  function(r) {
    return r.trimEnd();
  }
) : (
  // Ponyfill
  function(r) {
    return r.replace(hk, "");
  }
);
function D9(t, r) {
  return new RegExp(t, r);
}
var yT;
if (gT) {
  var PN = D9("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  yT = function(r, i) {
    var u;
    PN.lastIndex = i;
    var c = PN.exec(r);
    return (u = c[1]) !== null && u !== void 0 ? u : "";
  };
} else
  yT = function(r, i) {
    for (var u = []; ; ) {
      var c = L9(r, i);
      if (c === void 0 || M9(c) || Nk(c))
        break;
      u.push(c), i += c >= 65536 ? 2 : 1;
    }
    return bT.apply(void 0, u);
  };
var wk = (
  /** @class */
  function() {
    function t(r, i) {
      i === void 0 && (i = {}), this.message = r, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!i.ignoreTag, this.locale = i.locale, this.requiresOtherClause = !!i.requiresOtherClause, this.shouldParseSkeletons = !!i.shouldParseSkeletons;
    }
    return t.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, t.prototype.parseMessage = function(r, i, u) {
      for (var c = []; !this.isEOF(); ) {
        var v = this.char();
        if (v === 123) {
          var h = this.parseArgument(r, u);
          if (h.err)
            return h;
          c.push(h.val);
        } else {
          if (v === 125 && r > 0)
            break;
          if (v === 35 && (i === "plural" || i === "selectordinal")) {
            var y = this.clonePosition();
            this.bump(), c.push({
              type: Oa.pound,
              location: Sr(y, this.clonePosition())
            });
          } else if (v === 60 && !this.ignoreTag && this.peek() === 47) {
            if (u)
              break;
            return this.error(mr.UNMATCHED_CLOSING_TAG, Sr(this.clonePosition(), this.clonePosition()));
          } else if (v === 60 && !this.ignoreTag && CT(this.peek() || 0)) {
            var h = this.parseTag(r, i);
            if (h.err)
              return h;
            c.push(h.val);
          } else {
            var h = this.parseLiteral(r, i);
            if (h.err)
              return h;
            c.push(h.val);
          }
        }
      }
      return { val: c, err: null };
    }, t.prototype.parseTag = function(r, i) {
      var u = this.clonePosition();
      this.bump();
      var c = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: Oa.literal,
            value: "<".concat(c, "/>"),
            location: Sr(u, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var v = this.parseMessage(r + 1, i, !0);
        if (v.err)
          return v;
        var h = v.val, y = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !CT(this.char()))
            return this.error(mr.INVALID_TAG, Sr(y, this.clonePosition()));
          var g = this.clonePosition(), S = this.parseTagName();
          return c !== S ? this.error(mr.UNMATCHED_CLOSING_TAG, Sr(g, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: Oa.tag,
              value: c,
              children: h,
              location: Sr(u, this.clonePosition())
            },
            err: null
          } : this.error(mr.INVALID_TAG, Sr(y, this.clonePosition())));
        } else
          return this.error(mr.UNCLOSED_TAG, Sr(u, this.clonePosition()));
      } else
        return this.error(mr.INVALID_TAG, Sr(u, this.clonePosition()));
    }, t.prototype.parseTagName = function() {
      var r = this.offset();
      for (this.bump(); !this.isEOF() && Ak(this.char()); )
        this.bump();
      return this.message.slice(r, this.offset());
    }, t.prototype.parseLiteral = function(r, i) {
      for (var u = this.clonePosition(), c = ""; ; ) {
        var v = this.tryParseQuote(i);
        if (v) {
          c += v;
          continue;
        }
        var h = this.tryParseUnquoted(r, i);
        if (h) {
          c += h;
          continue;
        }
        var y = this.tryParseLeftAngleBracket();
        if (y) {
          c += y;
          continue;
        }
        break;
      }
      var g = Sr(u, this.clonePosition());
      return {
        val: { type: Oa.literal, value: c, location: g },
        err: null
      };
    }, t.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !Ik(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, t.prototype.tryParseQuote = function(r) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (r === "plural" || r === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var i = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var u = this.char();
        if (u === 39)
          if (this.peek() === 39)
            i.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          i.push(u);
        this.bump();
      }
      return bT.apply(void 0, i);
    }, t.prototype.tryParseUnquoted = function(r, i) {
      if (this.isEOF())
        return null;
      var u = this.char();
      return u === 60 || u === 123 || u === 35 && (i === "plural" || i === "selectordinal") || u === 125 && r > 0 ? null : (this.bump(), bT(u));
    }, t.prototype.parseArgument = function(r, i) {
      var u = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(mr.EXPECT_ARGUMENT_CLOSING_BRACE, Sr(u, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(mr.EMPTY_ARGUMENT, Sr(u, this.clonePosition()));
      var c = this.parseIdentifierIfPossible().value;
      if (!c)
        return this.error(mr.MALFORMED_ARGUMENT, Sr(u, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(mr.EXPECT_ARGUMENT_CLOSING_BRACE, Sr(u, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), {
            val: {
              type: Oa.argument,
              // value does not include the opening and closing braces.
              value: c,
              location: Sr(u, this.clonePosition())
            },
            err: null
          };
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(mr.EXPECT_ARGUMENT_CLOSING_BRACE, Sr(u, this.clonePosition())) : this.parseArgumentOptions(r, i, c, u);
        default:
          return this.error(mr.MALFORMED_ARGUMENT, Sr(u, this.clonePosition()));
      }
    }, t.prototype.parseIdentifierIfPossible = function() {
      var r = this.clonePosition(), i = this.offset(), u = yT(this.message, i), c = i + u.length;
      this.bumpTo(c);
      var v = this.clonePosition(), h = Sr(r, v);
      return { value: u, location: h };
    }, t.prototype.parseArgumentOptions = function(r, i, u, c) {
      var v, h = this.clonePosition(), y = this.parseIdentifierIfPossible().value, g = this.clonePosition();
      switch (y) {
        case "":
          return this.error(mr.EXPECT_ARGUMENT_TYPE, Sr(h, g));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var S = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var x = this.clonePosition(), T = this.parseSimpleArgStyleIfPossible();
            if (T.err)
              return T;
            var _ = Tk(T.val);
            if (_.length === 0)
              return this.error(mr.EXPECT_ARGUMENT_STYLE, Sr(this.clonePosition(), this.clonePosition()));
            var L = Sr(x, this.clonePosition());
            S = { style: _, styleLocation: L };
          }
          var M = this.tryParseArgumentClose(c);
          if (M.err)
            return M;
          var U = Sr(c, this.clonePosition());
          if (S && DN(S == null ? void 0 : S.style, "::", 0)) {
            var B = Rk(S.style.slice(2));
            if (y === "number") {
              var T = this.parseNumberSkeletonFromString(B, S.styleLocation);
              return T.err ? T : {
                val: { type: Oa.number, value: u, location: U, style: T.val },
                err: null
              };
            } else {
              if (B.length === 0)
                return this.error(mr.EXPECT_DATE_TIME_SKELETON, U);
              var H = B;
              this.locale && (H = fk(B, this.locale));
              var _ = {
                type: Xg.dateTime,
                pattern: H,
                location: S.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? ak(H) : {}
              }, Y = y === "date" ? Oa.date : Oa.time;
              return {
                val: { type: Y, value: u, location: U, style: _ },
                err: null
              };
            }
          }
          return {
            val: {
              type: y === "number" ? Oa.number : y === "date" ? Oa.date : Oa.time,
              value: u,
              location: U,
              style: (v = S == null ? void 0 : S.style) !== null && v !== void 0 ? v : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var G = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(mr.EXPECT_SELECT_ARGUMENT_OPTIONS, Sr(G, Gt({}, G)));
          this.bumpSpace();
          var Q = this.parseIdentifierIfPossible(), W = 0;
          if (y !== "select" && Q.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(mr.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, Sr(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var T = this.tryParseDecimalInteger(mr.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, mr.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (T.err)
              return T;
            this.bumpSpace(), Q = this.parseIdentifierIfPossible(), W = T.val;
          }
          var oe = this.tryParsePluralOrSelectOptions(r, y, i, Q);
          if (oe.err)
            return oe;
          var M = this.tryParseArgumentClose(c);
          if (M.err)
            return M;
          var j = Sr(c, this.clonePosition());
          return y === "select" ? {
            val: {
              type: Oa.select,
              value: u,
              options: MN(oe.val),
              location: j
            },
            err: null
          } : {
            val: {
              type: Oa.plural,
              value: u,
              options: MN(oe.val),
              offset: W,
              pluralType: y === "plural" ? "cardinal" : "ordinal",
              location: j
            },
            err: null
          };
        }
        default:
          return this.error(mr.INVALID_ARGUMENT_TYPE, Sr(h, g));
      }
    }, t.prototype.tryParseArgumentClose = function(r) {
      return this.isEOF() || this.char() !== 125 ? this.error(mr.EXPECT_ARGUMENT_CLOSING_BRACE, Sr(r, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, t.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var r = 0, i = this.clonePosition(); !this.isEOF(); ) {
        var u = this.char();
        switch (u) {
          case 39: {
            this.bump();
            var c = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(mr.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, Sr(c, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            r += 1, this.bump();
            break;
          }
          case 125: {
            if (r > 0)
              r -= 1;
            else
              return {
                val: this.message.slice(i.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(i.offset, this.offset()),
        err: null
      };
    }, t.prototype.parseNumberSkeletonFromString = function(r, i) {
      var u = [];
      try {
        u = ok(r);
      } catch {
        return this.error(mr.INVALID_NUMBER_SKELETON, i);
      }
      return {
        val: {
          type: Xg.number,
          tokens: u,
          location: i,
          parsedOptions: this.shouldParseSkeletons ? ck(u) : {}
        },
        err: null
      };
    }, t.prototype.tryParsePluralOrSelectOptions = function(r, i, u, c) {
      for (var v, h = !1, y = [], g = /* @__PURE__ */ new Set(), S = c.value, x = c.location; ; ) {
        if (S.length === 0) {
          var T = this.clonePosition();
          if (i !== "select" && this.bumpIf("=")) {
            var _ = this.tryParseDecimalInteger(mr.EXPECT_PLURAL_ARGUMENT_SELECTOR, mr.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (_.err)
              return _;
            x = Sr(T, this.clonePosition()), S = this.message.slice(T.offset, this.offset());
          } else
            break;
        }
        if (g.has(S))
          return this.error(i === "select" ? mr.DUPLICATE_SELECT_ARGUMENT_SELECTOR : mr.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, x);
        S === "other" && (h = !0), this.bumpSpace();
        var L = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(i === "select" ? mr.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : mr.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, Sr(this.clonePosition(), this.clonePosition()));
        var M = this.parseMessage(r + 1, i, u);
        if (M.err)
          return M;
        var U = this.tryParseArgumentClose(L);
        if (U.err)
          return U;
        y.push([
          S,
          {
            value: M.val,
            location: Sr(L, this.clonePosition())
          }
        ]), g.add(S), this.bumpSpace(), v = this.parseIdentifierIfPossible(), S = v.value, x = v.location;
      }
      return y.length === 0 ? this.error(i === "select" ? mr.EXPECT_SELECT_ARGUMENT_SELECTOR : mr.EXPECT_PLURAL_ARGUMENT_SELECTOR, Sr(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !h ? this.error(mr.MISSING_OTHER_CLAUSE, Sr(this.clonePosition(), this.clonePosition())) : { val: y, err: null };
    }, t.prototype.tryParseDecimalInteger = function(r, i) {
      var u = 1, c = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (u = -1);
      for (var v = !1, h = 0; !this.isEOF(); ) {
        var y = this.char();
        if (y >= 48 && y <= 57)
          v = !0, h = h * 10 + (y - 48), this.bump();
        else
          break;
      }
      var g = Sr(c, this.clonePosition());
      return v ? (h *= u, Sk(h) ? { val: h, err: null } : this.error(i, g)) : this.error(r, g);
    }, t.prototype.offset = function() {
      return this.position.offset;
    }, t.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, t.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, t.prototype.char = function() {
      var r = this.position.offset;
      if (r >= this.message.length)
        throw Error("out of bound");
      var i = L9(this.message, r);
      if (i === void 0)
        throw Error("Offset ".concat(r, " is at invalid UTF-16 code unit boundary"));
      return i;
    }, t.prototype.error = function(r, i) {
      return {
        val: null,
        err: {
          kind: r,
          message: this.message,
          location: i
        }
      };
    }, t.prototype.bump = function() {
      if (!this.isEOF()) {
        var r = this.char();
        r === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += r < 65536 ? 1 : 2);
      }
    }, t.prototype.bumpIf = function(r) {
      if (DN(this.message, r, this.offset())) {
        for (var i = 0; i < r.length; i++)
          this.bump();
        return !0;
      }
      return !1;
    }, t.prototype.bumpUntil = function(r) {
      var i = this.offset(), u = this.message.indexOf(r, i);
      return u >= 0 ? (this.bumpTo(u), !0) : (this.bumpTo(this.message.length), !1);
    }, t.prototype.bumpTo = function(r) {
      if (this.offset() > r)
        throw Error("targetOffset ".concat(r, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (r = Math.min(r, this.message.length); ; ) {
        var i = this.offset();
        if (i === r)
          break;
        if (i > r)
          throw Error("targetOffset ".concat(r, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, t.prototype.bumpSpace = function() {
      for (; !this.isEOF() && M9(this.char()); )
        this.bump();
    }, t.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var r = this.char(), i = this.offset(), u = this.message.charCodeAt(i + (r >= 65536 ? 2 : 1));
      return u ?? null;
    }, t;
  }()
);
function CT(t) {
  return t >= 97 && t <= 122 || t >= 65 && t <= 90;
}
function Ik(t) {
  return CT(t) || t === 47;
}
function Ak(t) {
  return t === 45 || t === 46 || t >= 48 && t <= 57 || t === 95 || t >= 97 && t <= 122 || t >= 65 && t <= 90 || t == 183 || t >= 192 && t <= 214 || t >= 216 && t <= 246 || t >= 248 && t <= 893 || t >= 895 && t <= 8191 || t >= 8204 && t <= 8205 || t >= 8255 && t <= 8256 || t >= 8304 && t <= 8591 || t >= 11264 && t <= 12271 || t >= 12289 && t <= 55295 || t >= 63744 && t <= 64975 || t >= 65008 && t <= 65533 || t >= 65536 && t <= 983039;
}
function M9(t) {
  return t >= 9 && t <= 13 || t === 32 || t === 133 || t >= 8206 && t <= 8207 || t === 8232 || t === 8233;
}
function Nk(t) {
  return t >= 33 && t <= 35 || t === 36 || t >= 37 && t <= 39 || t === 40 || t === 41 || t === 42 || t === 43 || t === 44 || t === 45 || t >= 46 && t <= 47 || t >= 58 && t <= 59 || t >= 60 && t <= 62 || t >= 63 && t <= 64 || t === 91 || t === 92 || t === 93 || t === 94 || t === 96 || t === 123 || t === 124 || t === 125 || t === 126 || t === 161 || t >= 162 && t <= 165 || t === 166 || t === 167 || t === 169 || t === 171 || t === 172 || t === 174 || t === 176 || t === 177 || t === 182 || t === 187 || t === 191 || t === 215 || t === 247 || t >= 8208 && t <= 8213 || t >= 8214 && t <= 8215 || t === 8216 || t === 8217 || t === 8218 || t >= 8219 && t <= 8220 || t === 8221 || t === 8222 || t === 8223 || t >= 8224 && t <= 8231 || t >= 8240 && t <= 8248 || t === 8249 || t === 8250 || t >= 8251 && t <= 8254 || t >= 8257 && t <= 8259 || t === 8260 || t === 8261 || t === 8262 || t >= 8263 && t <= 8273 || t === 8274 || t === 8275 || t >= 8277 && t <= 8286 || t >= 8592 && t <= 8596 || t >= 8597 && t <= 8601 || t >= 8602 && t <= 8603 || t >= 8604 && t <= 8607 || t === 8608 || t >= 8609 && t <= 8610 || t === 8611 || t >= 8612 && t <= 8613 || t === 8614 || t >= 8615 && t <= 8621 || t === 8622 || t >= 8623 && t <= 8653 || t >= 8654 && t <= 8655 || t >= 8656 && t <= 8657 || t === 8658 || t === 8659 || t === 8660 || t >= 8661 && t <= 8691 || t >= 8692 && t <= 8959 || t >= 8960 && t <= 8967 || t === 8968 || t === 8969 || t === 8970 || t === 8971 || t >= 8972 && t <= 8991 || t >= 8992 && t <= 8993 || t >= 8994 && t <= 9e3 || t === 9001 || t === 9002 || t >= 9003 && t <= 9083 || t === 9084 || t >= 9085 && t <= 9114 || t >= 9115 && t <= 9139 || t >= 9140 && t <= 9179 || t >= 9180 && t <= 9185 || t >= 9186 && t <= 9254 || t >= 9255 && t <= 9279 || t >= 9280 && t <= 9290 || t >= 9291 && t <= 9311 || t >= 9472 && t <= 9654 || t === 9655 || t >= 9656 && t <= 9664 || t === 9665 || t >= 9666 && t <= 9719 || t >= 9720 && t <= 9727 || t >= 9728 && t <= 9838 || t === 9839 || t >= 9840 && t <= 10087 || t === 10088 || t === 10089 || t === 10090 || t === 10091 || t === 10092 || t === 10093 || t === 10094 || t === 10095 || t === 10096 || t === 10097 || t === 10098 || t === 10099 || t === 10100 || t === 10101 || t >= 10132 && t <= 10175 || t >= 10176 && t <= 10180 || t === 10181 || t === 10182 || t >= 10183 && t <= 10213 || t === 10214 || t === 10215 || t === 10216 || t === 10217 || t === 10218 || t === 10219 || t === 10220 || t === 10221 || t === 10222 || t === 10223 || t >= 10224 && t <= 10239 || t >= 10240 && t <= 10495 || t >= 10496 && t <= 10626 || t === 10627 || t === 10628 || t === 10629 || t === 10630 || t === 10631 || t === 10632 || t === 10633 || t === 10634 || t === 10635 || t === 10636 || t === 10637 || t === 10638 || t === 10639 || t === 10640 || t === 10641 || t === 10642 || t === 10643 || t === 10644 || t === 10645 || t === 10646 || t === 10647 || t === 10648 || t >= 10649 && t <= 10711 || t === 10712 || t === 10713 || t === 10714 || t === 10715 || t >= 10716 && t <= 10747 || t === 10748 || t === 10749 || t >= 10750 && t <= 11007 || t >= 11008 && t <= 11055 || t >= 11056 && t <= 11076 || t >= 11077 && t <= 11078 || t >= 11079 && t <= 11084 || t >= 11085 && t <= 11123 || t >= 11124 && t <= 11125 || t >= 11126 && t <= 11157 || t === 11158 || t >= 11159 && t <= 11263 || t >= 11776 && t <= 11777 || t === 11778 || t === 11779 || t === 11780 || t === 11781 || t >= 11782 && t <= 11784 || t === 11785 || t === 11786 || t === 11787 || t === 11788 || t === 11789 || t >= 11790 && t <= 11798 || t === 11799 || t >= 11800 && t <= 11801 || t === 11802 || t === 11803 || t === 11804 || t === 11805 || t >= 11806 && t <= 11807 || t === 11808 || t === 11809 || t === 11810 || t === 11811 || t === 11812 || t === 11813 || t === 11814 || t === 11815 || t === 11816 || t === 11817 || t >= 11818 && t <= 11822 || t === 11823 || t >= 11824 && t <= 11833 || t >= 11834 && t <= 11835 || t >= 11836 && t <= 11839 || t === 11840 || t === 11841 || t === 11842 || t >= 11843 && t <= 11855 || t >= 11856 && t <= 11857 || t === 11858 || t >= 11859 && t <= 11903 || t >= 12289 && t <= 12291 || t === 12296 || t === 12297 || t === 12298 || t === 12299 || t === 12300 || t === 12301 || t === 12302 || t === 12303 || t === 12304 || t === 12305 || t >= 12306 && t <= 12307 || t === 12308 || t === 12309 || t === 12310 || t === 12311 || t === 12312 || t === 12313 || t === 12314 || t === 12315 || t === 12316 || t === 12317 || t >= 12318 && t <= 12319 || t === 12320 || t === 12336 || t === 64830 || t === 64831 || t >= 65093 && t <= 65094;
}
function ET(t) {
  t.forEach(function(r) {
    if (delete r.location, R9(r) || T9(r))
      for (var i in r.options)
        delete r.options[i].location, ET(r.options[i].value);
    else
      E9(r) && I9(r.style) || (S9(r) || x9(r)) && mT(r.style) ? delete r.style.location : w9(r) && ET(r.children);
  });
}
function _k(t, r) {
  r === void 0 && (r = {}), r = Gt({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, r);
  var i = new wk(t, r).parse();
  if (i.err) {
    var u = SyntaxError(mr[i.err.kind]);
    throw u.location = i.err.location, u.originalMessage = i.err.message, u;
  }
  return r != null && r.captureLocation || ET(i.val), i.val;
}
var sd;
(function(t) {
  t.MISSING_VALUE = "MISSING_VALUE", t.INVALID_VALUE = "INVALID_VALUE", t.MISSING_INTL_API = "MISSING_INTL_API";
})(sd || (sd = {}));
var qh = (
  /** @class */
  function(t) {
    Qu(r, t);
    function r(i, u, c) {
      var v = t.call(this, i) || this;
      return v.code = u, v.originalMessage = c, v;
    }
    return r.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, r;
  }(Error)
), kN = (
  /** @class */
  function(t) {
    Qu(r, t);
    function r(i, u, c, v) {
      return t.call(this, 'Invalid values for "'.concat(i, '": "').concat(u, '". Options are "').concat(Object.keys(c).join('", "'), '"'), sd.INVALID_VALUE, v) || this;
    }
    return r;
  }(qh)
), Ok = (
  /** @class */
  function(t) {
    Qu(r, t);
    function r(i, u, c) {
      return t.call(this, 'Value for "'.concat(i, '" must be of type ').concat(u), sd.INVALID_VALUE, c) || this;
    }
    return r;
  }(qh)
), Lk = (
  /** @class */
  function(t) {
    Qu(r, t);
    function r(i, u) {
      return t.call(this, 'The intl string context variable "'.concat(i, '" was not provided to the string "').concat(u, '"'), sd.MISSING_VALUE, u) || this;
    }
    return r;
  }(qh)
), Vl;
(function(t) {
  t[t.literal = 0] = "literal", t[t.object = 1] = "object";
})(Vl || (Vl = {}));
function Dk(t) {
  return t.length < 2 ? t : t.reduce(function(r, i) {
    var u = r[r.length - 1];
    return !u || u.type !== Vl.literal || i.type !== Vl.literal ? r.push(i) : u.value += i.value, r;
  }, []);
}
function P9(t) {
  return typeof t == "function";
}
function sC(t, r, i, u, c, v, h) {
  if (t.length === 1 && NN(t[0]))
    return [
      {
        type: Vl.literal,
        value: t[0].value
      }
    ];
  for (var y = [], g = 0, S = t; g < S.length; g++) {
    var x = S[g];
    if (NN(x)) {
      y.push({
        type: Vl.literal,
        value: x.value
      });
      continue;
    }
    if (nk(x)) {
      typeof v == "number" && y.push({
        type: Vl.literal,
        value: i.getNumberFormat(r).format(v)
      });
      continue;
    }
    var T = x.value;
    if (!(c && T in c))
      throw new Lk(T, h);
    var _ = c[T];
    if (tk(x)) {
      (!_ || typeof _ == "string" || typeof _ == "number") && (_ = typeof _ == "string" || typeof _ == "number" ? String(_) : ""), y.push({
        type: typeof _ == "string" ? Vl.literal : Vl.object,
        value: _
      });
      continue;
    }
    if (S9(x)) {
      var L = typeof x.style == "string" ? u.date[x.style] : mT(x.style) ? x.style.parsedOptions : void 0;
      y.push({
        type: Vl.literal,
        value: i.getDateTimeFormat(r, L).format(_)
      });
      continue;
    }
    if (x9(x)) {
      var L = typeof x.style == "string" ? u.time[x.style] : mT(x.style) ? x.style.parsedOptions : u.time.medium;
      y.push({
        type: Vl.literal,
        value: i.getDateTimeFormat(r, L).format(_)
      });
      continue;
    }
    if (E9(x)) {
      var L = typeof x.style == "string" ? u.number[x.style] : I9(x.style) ? x.style.parsedOptions : void 0;
      L && L.scale && (_ = _ * (L.scale || 1)), y.push({
        type: Vl.literal,
        value: i.getNumberFormat(r, L).format(_)
      });
      continue;
    }
    if (w9(x)) {
      var M = x.children, U = x.value, B = c[U];
      if (!P9(B))
        throw new Ok(U, "function", h);
      var H = sC(M, r, i, u, c, v), Y = B(H.map(function(W) {
        return W.value;
      }));
      Array.isArray(Y) || (Y = [Y]), y.push.apply(y, Y.map(function(W) {
        return {
          type: typeof W == "string" ? Vl.literal : Vl.object,
          value: W
        };
      }));
    }
    if (R9(x)) {
      var G = x.options[_] || x.options.other;
      if (!G)
        throw new kN(x.value, _, Object.keys(x.options), h);
      y.push.apply(y, sC(G.value, r, i, u, c));
      continue;
    }
    if (T9(x)) {
      var G = x.options["=".concat(_)];
      if (!G) {
        if (!Intl.PluralRules)
          throw new qh(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, sd.MISSING_INTL_API, h);
        var Q = i.getPluralRules(r, { type: x.pluralType }).select(_ - (x.offset || 0));
        G = x.options[Q] || x.options.other;
      }
      if (!G)
        throw new kN(x.value, _, Object.keys(x.options), h);
      y.push.apply(y, sC(G.value, r, i, u, c, _ - (x.offset || 0)));
      continue;
    }
  }
  return Dk(y);
}
function Mk(t, r) {
  return r ? Gt(Gt(Gt({}, t || {}), r || {}), Object.keys(t).reduce(function(i, u) {
    return i[u] = Gt(Gt({}, t[u]), r[u] || {}), i;
  }, {})) : t;
}
function Pk(t, r) {
  return r ? Object.keys(t).reduce(function(i, u) {
    return i[u] = Mk(t[u], r[u]), i;
  }, Gt({}, t)) : t;
}
function HR(t) {
  return {
    create: function() {
      return {
        get: function(r) {
          return t[r];
        },
        set: function(r, i) {
          t[r] = i;
        }
      };
    }
  };
}
function kk(t) {
  return t === void 0 && (t = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: Hl(function() {
      for (var r, i = [], u = 0; u < arguments.length; u++)
        i[u] = arguments[u];
      return new ((r = Intl.NumberFormat).bind.apply(r, Gl([void 0], i, !1)))();
    }, {
      cache: HR(t.number),
      strategy: jl.variadic
    }),
    getDateTimeFormat: Hl(function() {
      for (var r, i = [], u = 0; u < arguments.length; u++)
        i[u] = arguments[u];
      return new ((r = Intl.DateTimeFormat).bind.apply(r, Gl([void 0], i, !1)))();
    }, {
      cache: HR(t.dateTime),
      strategy: jl.variadic
    }),
    getPluralRules: Hl(function() {
      for (var r, i = [], u = 0; u < arguments.length; u++)
        i[u] = arguments[u];
      return new ((r = Intl.PluralRules).bind.apply(r, Gl([void 0], i, !1)))();
    }, {
      cache: HR(t.pluralRules),
      strategy: jl.variadic
    })
  };
}
var k9 = (
  /** @class */
  function() {
    function t(r, i, u, c) {
      i === void 0 && (i = t.defaultLocale);
      var v = this;
      if (this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(g) {
        var S = v.formatToParts(g);
        if (S.length === 1)
          return S[0].value;
        var x = S.reduce(function(T, _) {
          return !T.length || _.type !== Vl.literal || typeof T[T.length - 1] != "string" ? T.push(_.value) : T[T.length - 1] += _.value, T;
        }, []);
        return x.length <= 1 ? x[0] || "" : x;
      }, this.formatToParts = function(g) {
        return sC(v.ast, v.locales, v.formatters, v.formats, g, void 0, v.message);
      }, this.resolvedOptions = function() {
        var g;
        return {
          locale: ((g = v.resolvedLocale) === null || g === void 0 ? void 0 : g.toString()) || Intl.NumberFormat.supportedLocalesOf(v.locales)[0]
        };
      }, this.getAst = function() {
        return v.ast;
      }, this.locales = i, this.resolvedLocale = t.resolveLocale(i), typeof r == "string") {
        if (this.message = r, !t.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var h = c || {};
        h.formatters;
        var y = Wg(h, ["formatters"]);
        this.ast = t.__parse(r, Gt(Gt({}, y), { locale: this.resolvedLocale }));
      } else
        this.ast = r;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = Pk(t.formats, u), this.formatters = c && c.formatters || kk(this.formatterCache);
    }
    return Object.defineProperty(t, "defaultLocale", {
      get: function() {
        return t.memoizedDefaultLocale || (t.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), t.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), t.memoizedDefaultLocale = null, t.resolveLocale = function(r) {
      if (!(typeof Intl.Locale > "u")) {
        var i = Intl.NumberFormat.supportedLocalesOf(r);
        return i.length > 0 ? new Intl.Locale(i[0]) : new Intl.Locale(typeof r == "string" ? r : r[0]);
      }
    }, t.__parse = _k, t.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, t;
  }()
), vm;
(function(t) {
  t.FORMAT_ERROR = "FORMAT_ERROR", t.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", t.INVALID_CONFIG = "INVALID_CONFIG", t.MISSING_DATA = "MISSING_DATA", t.MISSING_TRANSLATION = "MISSING_TRANSLATION";
})(vm || (vm = {}));
var i0 = (
  /** @class */
  function(t) {
    Qu(r, t);
    function r(i, u, c) {
      var v = this, h = c ? c instanceof Error ? c : new Error(String(c)) : void 0;
      return v = t.call(this, "[@formatjs/intl Error ".concat(i, "] ").concat(u, `
`).concat(h ? `
`.concat(h.message, `
`).concat(h.stack) : "")) || this, v.code = i, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(v, r), v;
    }
    return r;
  }(Error)
), Fk = (
  /** @class */
  function(t) {
    Qu(r, t);
    function r(i, u) {
      return t.call(this, vm.UNSUPPORTED_FORMATTER, i, u) || this;
    }
    return r;
  }(i0)
), Bk = (
  /** @class */
  function(t) {
    Qu(r, t);
    function r(i, u) {
      return t.call(this, vm.INVALID_CONFIG, i, u) || this;
    }
    return r;
  }(i0)
), FN = (
  /** @class */
  function(t) {
    Qu(r, t);
    function r(i, u) {
      return t.call(this, vm.MISSING_DATA, i, u) || this;
    }
    return r;
  }(i0)
), Ku = (
  /** @class */
  function(t) {
    Qu(r, t);
    function r(i, u, c) {
      var v = t.call(this, vm.FORMAT_ERROR, "".concat(i, `
Locale: `).concat(u, `
`), c) || this;
      return v.locale = u, v;
    }
    return r;
  }(i0)
), jR = (
  /** @class */
  function(t) {
    Qu(r, t);
    function r(i, u, c, v) {
      var h = t.call(this, "".concat(i, `
MessageID: `).concat(c == null ? void 0 : c.id, `
Default Message: `).concat(c == null ? void 0 : c.defaultMessage, `
Description: `).concat(c == null ? void 0 : c.description, `
`), u, v) || this;
      return h.descriptor = c, h.locale = u, h;
    }
    return r;
  }(Ku)
), Uk = (
  /** @class */
  function(t) {
    Qu(r, t);
    function r(i, u) {
      var c = t.call(this, vm.MISSING_TRANSLATION, 'Missing message: "'.concat(i.id, '" for locale "').concat(u, '", using ').concat(i.defaultMessage ? "default message (".concat(typeof i.defaultMessage == "string" ? i.defaultMessage : i.defaultMessage.map(function(v) {
        var h;
        return (h = v.value) !== null && h !== void 0 ? h : JSON.stringify(v);
      }).join(), ")") : "id", " as fallback.")) || this;
      return c.descriptor = i, c;
    }
    return r;
  }(i0)
);
function Em(t, r, i) {
  return i === void 0 && (i = {}), r.reduce(function(u, c) {
    return c in t ? u[c] = t[c] : c in i && (u[c] = i[c]), u;
  }, {});
}
var Vk = function(t) {
  process.env.NODE_ENV !== "production" && console.error(t);
}, Hk = function(t) {
  process.env.NODE_ENV !== "production" && console.warn(t);
}, F9 = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: !0,
  onError: Vk,
  onWarn: Hk
};
function B9() {
  return {
    dateTime: {},
    number: {},
    message: {},
    relativeTime: {},
    pluralRules: {},
    list: {},
    displayNames: {}
  };
}
function sm(t) {
  return {
    create: function() {
      return {
        get: function(r) {
          return t[r];
        },
        set: function(r, i) {
          t[r] = i;
        }
      };
    }
  };
}
function jk(t) {
  t === void 0 && (t = B9());
  var r = Intl.RelativeTimeFormat, i = Intl.ListFormat, u = Intl.DisplayNames, c = Hl(function() {
    for (var y, g = [], S = 0; S < arguments.length; S++)
      g[S] = arguments[S];
    return new ((y = Intl.DateTimeFormat).bind.apply(y, Gl([void 0], g, !1)))();
  }, {
    cache: sm(t.dateTime),
    strategy: jl.variadic
  }), v = Hl(function() {
    for (var y, g = [], S = 0; S < arguments.length; S++)
      g[S] = arguments[S];
    return new ((y = Intl.NumberFormat).bind.apply(y, Gl([void 0], g, !1)))();
  }, {
    cache: sm(t.number),
    strategy: jl.variadic
  }), h = Hl(function() {
    for (var y, g = [], S = 0; S < arguments.length; S++)
      g[S] = arguments[S];
    return new ((y = Intl.PluralRules).bind.apply(y, Gl([void 0], g, !1)))();
  }, {
    cache: sm(t.pluralRules),
    strategy: jl.variadic
  });
  return {
    getDateTimeFormat: c,
    getNumberFormat: v,
    getMessageFormat: Hl(function(y, g, S, x) {
      return new k9(y, g, S, Gt({ formatters: {
        getNumberFormat: v,
        getDateTimeFormat: c,
        getPluralRules: h
      } }, x || {}));
    }, {
      cache: sm(t.message),
      strategy: jl.variadic
    }),
    getRelativeTimeFormat: Hl(function() {
      for (var y = [], g = 0; g < arguments.length; g++)
        y[g] = arguments[g];
      return new (r.bind.apply(r, Gl([void 0], y, !1)))();
    }, {
      cache: sm(t.relativeTime),
      strategy: jl.variadic
    }),
    getPluralRules: h,
    getListFormat: Hl(function() {
      for (var y = [], g = 0; g < arguments.length; g++)
        y[g] = arguments[g];
      return new (i.bind.apply(i, Gl([void 0], y, !1)))();
    }, {
      cache: sm(t.list),
      strategy: jl.variadic
    }),
    getDisplayNames: Hl(function() {
      for (var y = [], g = 0; g < arguments.length; g++)
        y[g] = arguments[g];
      return new (u.bind.apply(u, Gl([void 0], y, !1)))();
    }, {
      cache: sm(t.displayNames),
      strategy: jl.variadic
    })
  };
}
function f2(t, r, i, u) {
  var c = t && t[r], v;
  if (c && (v = c[i]), v)
    return v;
  u(new Fk("No ".concat(r, " format named: ").concat(i)));
}
function J1(t, r) {
  return Object.keys(t).reduce(function(i, u) {
    return i[u] = Gt({ timeZone: r }, t[u]), i;
  }, {});
}
function BN(t, r) {
  var i = Object.keys(Gt(Gt({}, t), r));
  return i.reduce(function(u, c) {
    return u[c] = Gt(Gt({}, t[c] || {}), r[c] || {}), u;
  }, {});
}
function UN(t, r) {
  if (!r)
    return t;
  var i = k9.formats;
  return Gt(Gt(Gt({}, i), t), { date: BN(J1(i.date, r), J1(t.date || {}, r)), time: BN(J1(i.time, r), J1(t.time || {}, r)) });
}
var ST = function(t, r, i, u, c) {
  var v = t.locale, h = t.formats, y = t.messages, g = t.defaultLocale, S = t.defaultFormats, x = t.fallbackOnEmptyString, T = t.onError, _ = t.timeZone, L = t.defaultRichTextElements;
  i === void 0 && (i = { id: "" });
  var M = i.id, U = i.defaultMessage;
  C9(!!M, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
  var B = String(M), H = (
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    y && Object.prototype.hasOwnProperty.call(y, B) && y[B]
  );
  if (Array.isArray(H) && H.length === 1 && H[0].type === Oa.literal)
    return H[0].value;
  if (!u && H && typeof H == "string" && !L)
    return H.replace(/'\{(.*?)\}'/gi, "{$1}");
  if (u = Gt(Gt({}, L), u || {}), h = UN(h, _), S = UN(S, _), !H) {
    if (x === !1 && H === "")
      return H;
    if ((!U || v && v.toLowerCase() !== g.toLowerCase()) && T(new Uk(i, v)), U)
      try {
        var Y = r.getMessageFormat(U, g, S, c);
        return Y.format(u);
      } catch (G) {
        return T(new jR('Error formatting default message for: "'.concat(B, '", rendering default message verbatim'), v, i, G)), typeof U == "string" ? U : B;
      }
    return B;
  }
  try {
    var Y = r.getMessageFormat(H, v, h, Gt({ formatters: r }, c || {}));
    return Y.format(u);
  } catch (G) {
    T(new jR('Error formatting message: "'.concat(B, '", using ').concat(U ? "default message" : "id", " as fallback."), v, i, G));
  }
  if (U)
    try {
      var Y = r.getMessageFormat(U, g, S, c);
      return Y.format(u);
    } catch (G) {
      T(new jR('Error formatting the default message for: "'.concat(B, '", rendering message verbatim'), v, i, G));
    }
  return typeof H == "string" ? H : typeof U == "string" ? U : B;
}, U9 = [
  "formatMatcher",
  "timeZone",
  "hour12",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "hourCycle",
  "dateStyle",
  "timeStyle",
  "calendar",
  // 'dayPeriod',
  "numberingSystem",
  "fractionalSecondDigits"
];
function PC(t, r, i, u) {
  var c = t.locale, v = t.formats, h = t.onError, y = t.timeZone;
  u === void 0 && (u = {});
  var g = u.format, S = Gt(Gt({}, y && { timeZone: y }), g && f2(v, r, g, h)), x = Em(u, U9, S);
  return r === "time" && !x.hour && !x.minute && !x.second && !x.timeStyle && !x.dateStyle && (x = Gt(Gt({}, x), { hour: "numeric", minute: "numeric" })), i(c, x);
}
function Gk(t, r) {
  for (var i = [], u = 2; u < arguments.length; u++)
    i[u - 2] = arguments[u];
  var c = i[0], v = i[1], h = v === void 0 ? {} : v, y = typeof c == "string" ? new Date(c || 0) : c;
  try {
    return PC(t, "date", r, h).format(y);
  } catch (g) {
    t.onError(new Ku("Error formatting date.", t.locale, g));
  }
  return String(y);
}
function zk(t, r) {
  for (var i = [], u = 2; u < arguments.length; u++)
    i[u - 2] = arguments[u];
  var c = i[0], v = i[1], h = v === void 0 ? {} : v, y = typeof c == "string" ? new Date(c || 0) : c;
  try {
    return PC(t, "time", r, h).format(y);
  } catch (g) {
    t.onError(new Ku("Error formatting time.", t.locale, g));
  }
  return String(y);
}
function Wk(t, r) {
  for (var i = [], u = 2; u < arguments.length; u++)
    i[u - 2] = arguments[u];
  var c = i[0], v = i[1], h = i[2], y = h === void 0 ? {} : h, g = t.timeZone, S = t.locale, x = t.onError, T = Em(y, U9, g ? { timeZone: g } : {});
  try {
    return r(S, T).formatRange(c, v);
  } catch (_) {
    x(new Ku("Error formatting date time range.", t.locale, _));
  }
  return String(c);
}
function Xk(t, r) {
  for (var i = [], u = 2; u < arguments.length; u++)
    i[u - 2] = arguments[u];
  var c = i[0], v = i[1], h = v === void 0 ? {} : v, y = typeof c == "string" ? new Date(c || 0) : c;
  try {
    return PC(t, "date", r, h).formatToParts(y);
  } catch (g) {
    t.onError(new Ku("Error formatting date.", t.locale, g));
  }
  return [];
}
function Yk(t, r) {
  for (var i = [], u = 2; u < arguments.length; u++)
    i[u - 2] = arguments[u];
  var c = i[0], v = i[1], h = v === void 0 ? {} : v, y = typeof c == "string" ? new Date(c || 0) : c;
  try {
    return PC(t, "time", r, h).formatToParts(y);
  } catch (g) {
    t.onError(new Ku("Error formatting time.", t.locale, g));
  }
  return [];
}
var $k = [
  "style",
  "type",
  "fallback",
  "languageDisplay"
];
function Zk(t, r, i, u) {
  var c = t.locale, v = t.onError, h = Intl.DisplayNames;
  h || v(new qh(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, sd.MISSING_INTL_API));
  var y = Em(u, $k);
  try {
    return r(c, y).of(i);
  } catch (g) {
    v(new Ku("Error formatting display name.", c, g));
  }
}
var Jk = [
  "type",
  "style"
], VN = Date.now();
function Qk(t) {
  return "".concat(VN, "_").concat(t, "_").concat(VN);
}
function Kk(t, r, i, u) {
  u === void 0 && (u = {});
  var c = V9(t, r, i, u).reduce(function(v, h) {
    var y = h.value;
    return typeof y != "string" ? v.push(y) : typeof v[v.length - 1] == "string" ? v[v.length - 1] += y : v.push(y), v;
  }, []);
  return c.length === 1 ? c[0] : c.length === 0 ? "" : c;
}
function V9(t, r, i, u) {
  var c = t.locale, v = t.onError;
  u === void 0 && (u = {});
  var h = Intl.ListFormat;
  h || v(new qh(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, sd.MISSING_INTL_API));
  var y = Em(u, Jk);
  try {
    var g = {}, S = i.map(function(x, T) {
      if (typeof x == "object") {
        var _ = Qk(T);
        return g[_] = x, _;
      }
      return String(x);
    });
    return r(c, y).formatToParts(S).map(function(x) {
      return x.type === "literal" ? x : Gt(Gt({}, x), { value: g[x.value] || x.value });
    });
  } catch (x) {
    v(new Ku("Error formatting list.", c, x));
  }
  return i;
}
var qk = ["type"];
function eF(t, r, i, u) {
  var c = t.locale, v = t.onError;
  u === void 0 && (u = {}), Intl.PluralRules || v(new qh(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, sd.MISSING_INTL_API));
  var h = Em(u, qk);
  try {
    return r(c, h).select(i);
  } catch (y) {
    v(new Ku("Error formatting plural.", c, y));
  }
  return "other";
}
var tF = ["numeric", "style"];
function nF(t, r, i) {
  var u = t.locale, c = t.formats, v = t.onError;
  i === void 0 && (i = {});
  var h = i.format, y = !!h && f2(c, "relative", h, v) || {}, g = Em(i, tF, y);
  return r(u, g);
}
function rF(t, r, i, u, c) {
  c === void 0 && (c = {}), u || (u = "second");
  var v = Intl.RelativeTimeFormat;
  v || t.onError(new qh(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, sd.MISSING_INTL_API));
  try {
    return nF(t, r, c).format(i, u);
  } catch (h) {
    t.onError(new Ku("Error formatting relative time.", t.locale, h));
  }
  return String(i);
}
var aF = [
  "style",
  "currency",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  // ES2020 NumberFormat
  "compactDisplay",
  "currencyDisplay",
  "currencySign",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "numberingSystem",
  // ES2023 NumberFormat
  "trailingZeroDisplay",
  "roundingPriority",
  "roundingIncrement",
  "roundingMode"
];
function H9(t, r, i) {
  var u = t.locale, c = t.formats, v = t.onError;
  i === void 0 && (i = {});
  var h = i.format, y = h && f2(c, "number", h, v) || {}, g = Em(i, aF, y);
  return r(u, g);
}
function iF(t, r, i, u) {
  u === void 0 && (u = {});
  try {
    return H9(t, r, u).format(i);
  } catch (c) {
    t.onError(new Ku("Error formatting number.", t.locale, c));
  }
  return String(i);
}
function oF(t, r, i, u) {
  u === void 0 && (u = {});
  try {
    return H9(t, r, u).formatToParts(i);
  } catch (c) {
    t.onError(new Ku("Error formatting number.", t.locale, c));
  }
  return [];
}
function lF(t) {
  var r = t ? t[Object.keys(t)[0]] : void 0;
  return typeof r == "string";
}
function sF(t) {
  t.onWarn && t.defaultRichTextElements && lF(t.messages || {}) && t.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.io/docs/getting-started/message-distribution`);
}
function uF(t, r) {
  var i = jk(r), u = Gt(Gt({}, F9), t), c = u.locale, v = u.defaultLocale, h = u.onError;
  return c ? !Intl.NumberFormat.supportedLocalesOf(c).length && h ? h(new FN('Missing locale data for locale: "'.concat(c, '" in Intl.NumberFormat. Using default locale: "').concat(v, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : !Intl.DateTimeFormat.supportedLocalesOf(c).length && h && h(new FN('Missing locale data for locale: "'.concat(c, '" in Intl.DateTimeFormat. Using default locale: "').concat(v, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : (h && h(new Bk('"locale" was not configured, using "'.concat(v, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details'))), u.locale = u.defaultLocale || "en"), sF(u), Gt(Gt({}, u), {
    formatters: i,
    formatNumber: iF.bind(null, u, i.getNumberFormat),
    formatNumberToParts: oF.bind(null, u, i.getNumberFormat),
    formatRelativeTime: rF.bind(null, u, i.getRelativeTimeFormat),
    formatDate: Gk.bind(null, u, i.getDateTimeFormat),
    formatDateToParts: Xk.bind(null, u, i.getDateTimeFormat),
    formatTime: zk.bind(null, u, i.getDateTimeFormat),
    formatDateTimeRange: Wk.bind(null, u, i.getDateTimeFormat),
    formatTimeToParts: Yk.bind(null, u, i.getDateTimeFormat),
    formatPlural: eF.bind(null, u, i.getPluralRules),
    // @ts-expect-error TODO: will get to this later
    formatMessage: ST.bind(null, u, i),
    // @ts-expect-error TODO: will get to this later
    $t: ST.bind(null, u, i),
    formatList: Kk.bind(null, u, i.getListFormat),
    formatListToParts: V9.bind(null, u, i.getListFormat),
    formatDisplayName: Zk.bind(null, u, i.getDisplayNames)
  });
}
function j9(t) {
  C9(t, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var G9 = Gt(Gt({}, F9), { textComponent: k.Fragment });
function cF(t) {
  return function(r) {
    return t(k.Children.toArray(r));
  };
}
function xT(t, r) {
  if (t === r)
    return !0;
  if (!t || !r)
    return !1;
  var i = Object.keys(t), u = Object.keys(r), c = i.length;
  if (u.length !== c)
    return !1;
  for (var v = 0; v < c; v++) {
    var h = i[v];
    if (t[h] !== r[h] || !Object.prototype.hasOwnProperty.call(r, h))
      return !1;
  }
  return !0;
}
var RT = { exports: {} }, Gr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var HN;
function fF() {
  if (HN)
    return Gr;
  HN = 1;
  var t = typeof Symbol == "function" && Symbol.for, r = t ? Symbol.for("react.element") : 60103, i = t ? Symbol.for("react.portal") : 60106, u = t ? Symbol.for("react.fragment") : 60107, c = t ? Symbol.for("react.strict_mode") : 60108, v = t ? Symbol.for("react.profiler") : 60114, h = t ? Symbol.for("react.provider") : 60109, y = t ? Symbol.for("react.context") : 60110, g = t ? Symbol.for("react.async_mode") : 60111, S = t ? Symbol.for("react.concurrent_mode") : 60111, x = t ? Symbol.for("react.forward_ref") : 60112, T = t ? Symbol.for("react.suspense") : 60113, _ = t ? Symbol.for("react.suspense_list") : 60120, L = t ? Symbol.for("react.memo") : 60115, M = t ? Symbol.for("react.lazy") : 60116, U = t ? Symbol.for("react.block") : 60121, B = t ? Symbol.for("react.fundamental") : 60117, H = t ? Symbol.for("react.responder") : 60118, Y = t ? Symbol.for("react.scope") : 60119;
  function G(W) {
    if (typeof W == "object" && W !== null) {
      var oe = W.$$typeof;
      switch (oe) {
        case r:
          switch (W = W.type, W) {
            case g:
            case S:
            case u:
            case v:
            case c:
            case T:
              return W;
            default:
              switch (W = W && W.$$typeof, W) {
                case y:
                case x:
                case M:
                case L:
                case h:
                  return W;
                default:
                  return oe;
              }
          }
        case i:
          return oe;
      }
    }
  }
  function Q(W) {
    return G(W) === S;
  }
  return Gr.AsyncMode = g, Gr.ConcurrentMode = S, Gr.ContextConsumer = y, Gr.ContextProvider = h, Gr.Element = r, Gr.ForwardRef = x, Gr.Fragment = u, Gr.Lazy = M, Gr.Memo = L, Gr.Portal = i, Gr.Profiler = v, Gr.StrictMode = c, Gr.Suspense = T, Gr.isAsyncMode = function(W) {
    return Q(W) || G(W) === g;
  }, Gr.isConcurrentMode = Q, Gr.isContextConsumer = function(W) {
    return G(W) === y;
  }, Gr.isContextProvider = function(W) {
    return G(W) === h;
  }, Gr.isElement = function(W) {
    return typeof W == "object" && W !== null && W.$$typeof === r;
  }, Gr.isForwardRef = function(W) {
    return G(W) === x;
  }, Gr.isFragment = function(W) {
    return G(W) === u;
  }, Gr.isLazy = function(W) {
    return G(W) === M;
  }, Gr.isMemo = function(W) {
    return G(W) === L;
  }, Gr.isPortal = function(W) {
    return G(W) === i;
  }, Gr.isProfiler = function(W) {
    return G(W) === v;
  }, Gr.isStrictMode = function(W) {
    return G(W) === c;
  }, Gr.isSuspense = function(W) {
    return G(W) === T;
  }, Gr.isValidElementType = function(W) {
    return typeof W == "string" || typeof W == "function" || W === u || W === S || W === v || W === c || W === T || W === _ || typeof W == "object" && W !== null && (W.$$typeof === M || W.$$typeof === L || W.$$typeof === h || W.$$typeof === y || W.$$typeof === x || W.$$typeof === B || W.$$typeof === H || W.$$typeof === Y || W.$$typeof === U);
  }, Gr.typeOf = G, Gr;
}
var zr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jN;
function dF() {
  return jN || (jN = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, r = t ? Symbol.for("react.element") : 60103, i = t ? Symbol.for("react.portal") : 60106, u = t ? Symbol.for("react.fragment") : 60107, c = t ? Symbol.for("react.strict_mode") : 60108, v = t ? Symbol.for("react.profiler") : 60114, h = t ? Symbol.for("react.provider") : 60109, y = t ? Symbol.for("react.context") : 60110, g = t ? Symbol.for("react.async_mode") : 60111, S = t ? Symbol.for("react.concurrent_mode") : 60111, x = t ? Symbol.for("react.forward_ref") : 60112, T = t ? Symbol.for("react.suspense") : 60113, _ = t ? Symbol.for("react.suspense_list") : 60120, L = t ? Symbol.for("react.memo") : 60115, M = t ? Symbol.for("react.lazy") : 60116, U = t ? Symbol.for("react.block") : 60121, B = t ? Symbol.for("react.fundamental") : 60117, H = t ? Symbol.for("react.responder") : 60118, Y = t ? Symbol.for("react.scope") : 60119;
    function G(Ze) {
      return typeof Ze == "string" || typeof Ze == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Ze === u || Ze === S || Ze === v || Ze === c || Ze === T || Ze === _ || typeof Ze == "object" && Ze !== null && (Ze.$$typeof === M || Ze.$$typeof === L || Ze.$$typeof === h || Ze.$$typeof === y || Ze.$$typeof === x || Ze.$$typeof === B || Ze.$$typeof === H || Ze.$$typeof === Y || Ze.$$typeof === U);
    }
    function Q(Ze) {
      if (typeof Ze == "object" && Ze !== null) {
        var mn = Ze.$$typeof;
        switch (mn) {
          case r:
            var fn = Ze.type;
            switch (fn) {
              case g:
              case S:
              case u:
              case v:
              case c:
              case T:
                return fn;
              default:
                var Gn = fn && fn.$$typeof;
                switch (Gn) {
                  case y:
                  case x:
                  case M:
                  case L:
                  case h:
                    return Gn;
                  default:
                    return mn;
                }
            }
          case i:
            return mn;
        }
      }
    }
    var W = g, oe = S, j = y, re = h, me = r, Se = x, Ne = u, Ge = M, ze = L, qe = i, at = v, st = c, We = T, he = !1;
    function ke(Ze) {
      return he || (he = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), _e(Ze) || Q(Ze) === g;
    }
    function _e(Ze) {
      return Q(Ze) === S;
    }
    function q(Ze) {
      return Q(Ze) === y;
    }
    function pe(Ze) {
      return Q(Ze) === h;
    }
    function $e(Ze) {
      return typeof Ze == "object" && Ze !== null && Ze.$$typeof === r;
    }
    function lt(Ze) {
      return Q(Ze) === x;
    }
    function ot(Ze) {
      return Q(Ze) === u;
    }
    function nt(Ze) {
      return Q(Ze) === M;
    }
    function Rt(Ze) {
      return Q(Ze) === L;
    }
    function ht(Ze) {
      return Q(Ze) === i;
    }
    function dt(Ze) {
      return Q(Ze) === v;
    }
    function sn(Ze) {
      return Q(Ze) === c;
    }
    function bn(Ze) {
      return Q(Ze) === T;
    }
    zr.AsyncMode = W, zr.ConcurrentMode = oe, zr.ContextConsumer = j, zr.ContextProvider = re, zr.Element = me, zr.ForwardRef = Se, zr.Fragment = Ne, zr.Lazy = Ge, zr.Memo = ze, zr.Portal = qe, zr.Profiler = at, zr.StrictMode = st, zr.Suspense = We, zr.isAsyncMode = ke, zr.isConcurrentMode = _e, zr.isContextConsumer = q, zr.isContextProvider = pe, zr.isElement = $e, zr.isForwardRef = lt, zr.isFragment = ot, zr.isLazy = nt, zr.isMemo = Rt, zr.isPortal = ht, zr.isProfiler = dt, zr.isStrictMode = sn, zr.isSuspense = bn, zr.isValidElementType = G, zr.typeOf = Q;
  }()), zr;
}
process.env.NODE_ENV === "production" ? RT.exports = fF() : RT.exports = dF();
var pF = RT.exports, z9 = pF, hF = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, vF = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, W9 = {};
W9[z9.ForwardRef] = hF;
W9[z9.Memo] = vF;
var d2 = typeof window < "u" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = k.createContext(null)) : k.createContext(null);
d2.Consumer;
var mF = d2.Provider, gF = mF, bF = d2;
function La() {
  var t = k.useContext(bF);
  return j9(t), t;
}
var TT;
(function(t) {
  t.formatDate = "FormattedDate", t.formatTime = "FormattedTime", t.formatNumber = "FormattedNumber", t.formatList = "FormattedList", t.formatDisplayName = "FormattedDisplayName";
})(TT || (TT = {}));
var wT;
(function(t) {
  t.formatDate = "FormattedDateParts", t.formatTime = "FormattedTimeParts", t.formatNumber = "FormattedNumberParts", t.formatList = "FormattedListParts";
})(wT || (wT = {}));
function X9(t) {
  var r = function(i) {
    var u = La(), c = i.value, v = i.children, h = Wg(i, ["value", "children"]), y = typeof c == "string" ? new Date(c || 0) : c, g = t === "formatDate" ? u.formatDateToParts(y, h) : u.formatTimeToParts(y, h);
    return v(g);
  };
  return r.displayName = wT[t], r;
}
function o0(t) {
  var r = function(i) {
    var u = La(), c = i.value, v = i.children, h = Wg(
      i,
      ["value", "children"]
    ), y = u[t](c, h);
    if (typeof v == "function")
      return v(y);
    var g = u.textComponent || k.Fragment;
    return k.createElement(g, null, y);
  };
  return r.displayName = TT[t], r;
}
function Y9(t) {
  return t && Object.keys(t).reduce(function(r, i) {
    var u = t[i];
    return r[i] = P9(u) ? cF(u) : u, r;
  }, {});
}
var GN = function(t, r, i, u) {
  for (var c = [], v = 4; v < arguments.length; v++)
    c[v - 4] = arguments[v];
  var h = Y9(u), y = ST.apply(void 0, Gl([
    t,
    r,
    i,
    h
  ], c, !1));
  return Array.isArray(y) ? k.Children.toArray(y) : y;
}, zN = function(t, r) {
  var i = t.defaultRichTextElements, u = Wg(t, ["defaultRichTextElements"]), c = Y9(i), v = uF(Gt(Gt(Gt({}, G9), u), { defaultRichTextElements: c }), r), h = {
    locale: v.locale,
    timeZone: v.timeZone,
    fallbackOnEmptyString: v.fallbackOnEmptyString,
    formats: v.formats,
    defaultLocale: v.defaultLocale,
    defaultFormats: v.defaultFormats,
    messages: v.messages,
    onError: v.onError,
    defaultRichTextElements: c
  };
  return Gt(Gt({}, v), {
    formatMessage: GN.bind(
      null,
      h,
      // @ts-expect-error fix this
      v.formatters
    ),
    // @ts-expect-error fix this
    $t: GN.bind(null, h, v.formatters)
  });
};
function GR(t) {
  return {
    locale: t.locale,
    timeZone: t.timeZone,
    fallbackOnEmptyString: t.fallbackOnEmptyString,
    formats: t.formats,
    textComponent: t.textComponent,
    messages: t.messages,
    defaultLocale: t.defaultLocale,
    defaultFormats: t.defaultFormats,
    onError: t.onError,
    onWarn: t.onWarn,
    wrapRichTextChunksInFragment: t.wrapRichTextChunksInFragment,
    defaultRichTextElements: t.defaultRichTextElements
  };
}
var yF = (
  /** @class */
  function(t) {
    Qu(r, t);
    function r() {
      var i = t !== null && t.apply(this, arguments) || this;
      return i.cache = B9(), i.state = {
        cache: i.cache,
        intl: zN(GR(i.props), i.cache),
        prevConfig: GR(i.props)
      }, i;
    }
    return r.getDerivedStateFromProps = function(i, u) {
      var c = u.prevConfig, v = u.cache, h = GR(i);
      return xT(c, h) ? null : {
        intl: zN(h, v),
        prevConfig: h
      };
    }, r.prototype.render = function() {
      return j9(this.state.intl), k.createElement(gF, { value: this.state.intl }, this.props.children);
    }, r.displayName = "IntlProvider", r.defaultProps = G9, r;
  }(k.PureComponent)
);
const CF = yF;
function EF(t, r) {
  var i = t.values, u = Wg(t, ["values"]), c = r.values, v = Wg(r, ["values"]);
  return xT(c, i) && xT(u, v);
}
function $9(t) {
  var r = La(), i = r.formatMessage, u = r.textComponent, c = u === void 0 ? k.Fragment : u, v = t.id, h = t.description, y = t.defaultMessage, g = t.values, S = t.children, x = t.tagName, T = x === void 0 ? c : x, _ = t.ignoreTag, L = { id: v, description: h, defaultMessage: y }, M = i(L, g, {
    ignoreTag: _
  });
  return typeof S == "function" ? S(Array.isArray(M) ? M : [M]) : T ? k.createElement(T, null, k.Children.toArray(M)) : k.createElement(k.Fragment, null, M);
}
$9.displayName = "FormattedMessage";
var Z9 = k.memo($9, EF);
Z9.displayName = "MemoizedFormattedMessage";
const mt = Z9;
var SF = o0("formatDate");
o0("formatTime");
var xF = o0("formatNumber");
o0("formatList");
o0("formatDisplayName");
X9("formatDate");
X9("formatTime");
class RF extends k.Component {
  constructor() {
    super(...arguments);
    wn(this, "state", {
      hasError: !1
    });
  }
  static getDerivedStateFromError() {
    return {
      hasError: !0
    };
  }
  componentDidCatch(i, u) {
    console.error("Error:", i, u);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ N.jsx("div", { "data-testid": "errorBoundary", children: /* @__PURE__ */ N.jsx("h1", { children: /* @__PURE__ */ N.jsx(mt, { id: "ld.appFail" }) }) }) : this.props.children;
  }
}
const J9 = ({ hasLabel: t = !0, "data-testid": r }) => /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
  /* @__PURE__ */ N.jsx("div", { className: "loader-overlay" }),
  /* @__PURE__ */ N.jsxs("div", { className: "loader", "data-testid": r, children: [
    /* @__PURE__ */ N.jsxs("div", { className: "spinner", children: [
      /* @__PURE__ */ N.jsx("div", { className: "bounce1" }),
      /* @__PURE__ */ N.jsx("div", { className: "bounce2" }),
      /* @__PURE__ */ N.jsx("div", { className: "bounce3" })
    ] }),
    t && /* @__PURE__ */ N.jsx("span", { className: "loading-label", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.loading" }) })
  ] })
] }), Yh = {
  RESOURCES: "resources",
  CREATE: "create",
  EDIT: "edit"
}, Va = {
  MAIN: {
    uri: "/",
    name: "ld.main"
  },
  SEARCH: {
    uri: "/search",
    name: "ld.searchResource"
  },
  RESOURCE_CREATE: {
    uri: `/${Yh.RESOURCES}/${Yh.CREATE}`,
    name: "ld.create"
  },
  RESOURCE_EDIT: {
    uri: `/${Yh.RESOURCES}/:resourceId/${Yh.EDIT}`,
    name: "ld.editResource"
  },
  EXTERNAL_RESOURCE_PREVIEW: {
    uri: `/${Yh.RESOURCES}/external/:externalId/preview`,
    name: "ld.externalResourcePreview"
  }
}, Q9 = [Va.EXTERNAL_RESOURCE_PREVIEW.uri], K9 = [Va.RESOURCE_EDIT.uri, Va.RESOURCE_CREATE.uri], q9 = [Va.RESOURCE_CREATE.uri], TF = [Va.SEARCH.uri];
var Mi = /* @__PURE__ */ ((t) => (t.Type = "type", t.Ref = "ref", t.CloneOf = "cloneOf", t))(Mi || {}), Wo = /* @__PURE__ */ ((t) => (t.Query = "query", t.SearchBy = "searchBy", t.Offset = "offset", t))(Wo || {}), Vg = /* @__PURE__ */ ((t) => (t.EditPage = "editPage", t.CreatePage = "createPage", t.CreatePageAsClone = "createPageAsClone", t))(Vg || {});
const IT = "en", p2 = "okapi_config", wF = "EDITOR_API_BASE_PATH", h2 = "/linked-data/resource", eO = "/linked-data/inventory-instance", IF = "/linked-data/profile", AF = "/search/linked-data", NF = `${AF}/works`, tO = "/linked-data/authority-assignment-check", _F = {
  totalElements: 0,
  totalPages: 0
};
var nO = /* @__PURE__ */ ((t) => (t.AlreadyExists = "already_exists", t.RequiredPrimaryMainTitle = "required_primary_main_title", t.LccnDoesNotMatchPattern = "lccn_does_not_match_pattern", t.LccnNotUnique = "lccn_not_unique", t.FailedDependency = "failed_dependency", t.NotFound = "not_found", t.Mapping = "mapping", t.GenericBadRequest = "generic_bad_request", t.Server = "server", t))(nO || {}), v2 = /* @__PURE__ */ ((t) => (t.Inventory = "inventory", t))(v2 || {});
const OF = {
  inventory: `${eO}/:recordId/preview`
};
class LF {
  constructor(r) {
    this.storage = r;
  }
  serialize(r, i) {
    const u = typeof i == "string" ? i : JSON.stringify(i);
    this.storage.setItem(r, u);
  }
  deserialize(r) {
    const i = this.storage.getItem(r);
    if (!i)
      return null;
    try {
      return JSON.parse(i);
    } catch (u) {
      return console.error("Cannot parse JSON:", u), i;
    }
  }
  delete(r) {
    this.storage.removeItem(r);
  }
}
class DF extends LF {
  constructor() {
    super(localStorage);
  }
}
const m2 = new DF();
var rO = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var r = {}.hasOwnProperty;
    function i() {
      for (var v = "", h = 0; h < arguments.length; h++) {
        var y = arguments[h];
        y && (v = c(v, u(y)));
      }
      return v;
    }
    function u(v) {
      if (typeof v == "string" || typeof v == "number")
        return v;
      if (typeof v != "object")
        return "";
      if (Array.isArray(v))
        return i.apply(null, v);
      if (v.toString !== Object.prototype.toString && !v.toString.toString().includes("[native code]"))
        return v.toString();
      var h = "";
      for (var y in v)
        r.call(v, y) && v[y] && (h = c(h, y));
      return h;
    }
    function c(v, h) {
      return h ? v ? v + " " + h : v + h : v;
    }
    t.exports ? (i.default = i, t.exports = i) : window.classNames = i;
  })();
})(rO);
var MF = rO.exports;
const In = /* @__PURE__ */ KT(MF), aO = "modal-container", PF = "ModuleContainer", iO = "edit-section", kF = "-30%", oO = {
  "BIBFRAME Instance": "Instance components",
  "BIBFRAME Work": "Work components"
}, FF = {
  "BIBFRAME Work": "Work",
  "BIBFRAME Instance": "Instance"
};
var Wu = /* @__PURE__ */ ((t) => (t.basic = "basic", t.customComponent = "customComponent", t))(Wu || {}), Qh = /* @__PURE__ */ ((t) => (t.Basic = "basic", t.Comparison = "comparison", t))(Qh || {}), g2 = /* @__PURE__ */ ((t) => (t.Basic = "Basic", t.AdvancedSearch = "Advanced search", t))(g2 || {});
const BF = 30, mm = (t) => {
  const { pathname: r } = Ju();
  return t.find((i) => pm(i, r));
};
var Tr = /* @__PURE__ */ ((t) => (t.success = "success", t.error = "error", t.info = "info", t.warning = "warning", t))(Tr || {});
var Mn = /* @__PURE__ */ ((t) => (t.Highlighted = "highlighted", t.Secondary = "secondary", t.Text = "text", t.Link = "link", t.Primary = "primary", t.Passive = "passive", t.Ghost = "ghost", t.Icon = "icon", t))(Mn || {});
const Dn = ({
  id: t,
  prefix: r,
  label: i,
  children: u,
  onClick: c,
  className: v = "",
  type: h = "passive",
  disabled: y,
  "data-testid": g,
  role: S,
  ariaLabel: x
}) => /* @__PURE__ */ N.jsxs(
  "button",
  {
    id: t,
    "data-testid": g,
    disabled: y,
    onClick: c,
    role: S,
    "aria-label": x,
    className: In("button", {
      [`button-${h}`]: h,
      [v]: v
    }),
    children: [
      r,
      u || i
    ]
  }
), WN = (t) => t.charAt(0).toUpperCase() + t.slice(1), UF = (t, r) => {
  if (Array.isArray(t))
    return [...t, r];
  if (t instanceof Map) {
    const i = new Map(t);
    return r instanceof Map ? r.forEach((u, c) => i.set(c, u)) : typeof r == "object" && r !== null && Object.entries(r).forEach(([u, c]) => i.set(u, c)), i;
  } else {
    if (t instanceof Set)
      return /* @__PURE__ */ new Set([...t, r]);
    if (typeof t == "object" && t !== null)
      return typeof r == "object" && r !== null ? { ...t, ...r } : r;
    if (typeof t == "string")
      return `${t}${r}`;
  }
  return r;
}, VF = (t, r, i = !1) => (u) => {
  const c = WN(t.basic), v = {
    [t.basic]: r,
    [`set${c}`]: (h) => u(
      (y) => ({
        [t.basic]: typeof h == "function" ? h(y[t.basic]) : h
      }),
      !1,
      `set${c}`
    ),
    [`reset${c}`]: () => u({ [t.basic]: r }, !1, `reset${c}`)
  };
  return i && (v[`add${WN(t.basic)}Item`] = (h) => u(
    (y) => {
      const g = y[t.basic];
      return { [t.basic]: UF(g, h) };
    },
    !1,
    `add${c}Item`
  )), v;
}, XN = (t) => {
  let r;
  const i = /* @__PURE__ */ new Set(), u = (S, x) => {
    const T = typeof S == "function" ? S(r) : S;
    if (!Object.is(T, r)) {
      const _ = r;
      r = x ?? (typeof T != "object" || T === null) ? T : Object.assign({}, r, T), i.forEach((L) => L(r, _));
    }
  }, c = () => r, y = { setState: u, getState: c, getInitialState: () => g, subscribe: (S) => (i.add(S), () => i.delete(S)) }, g = r = t(u, c, y);
  return y;
}, HF = (t) => t ? XN(t) : XN, jF = (t) => t;
function GF(t, r = jF) {
  const i = hC.useSyncExternalStore(
    t.subscribe,
    () => r(t.getState()),
    () => r(t.getInitialState())
  );
  return hC.useDebugValue(i), i;
}
const YN = (t) => {
  const r = HF(t), i = (u) => GF(r, u);
  return Object.assign(i, r), i;
}, zF = (t) => t ? YN(t) : YN, AT = /* @__PURE__ */ new Map(), Q1 = (t) => {
  const r = AT.get(t);
  return r ? Object.fromEntries(
    Object.entries(r.stores).map(([i, u]) => [i, u.getState()])
  ) : {};
}, WF = (t, r, i) => {
  if (t === void 0)
    return {
      type: "untracked",
      connection: r.connect(i)
    };
  const u = AT.get(i.name);
  if (u)
    return { type: "tracked", store: t, ...u };
  const c = {
    connection: r.connect(i),
    stores: {}
  };
  return AT.set(i.name, c), { type: "tracked", store: t, ...c };
}, XF = (t, r = {}) => (i, u, c) => {
  const { enabled: v, anonymousActionType: h, store: y, ...g } = r;
  let S;
  try {
    S = (v ?? !1) && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!S)
    return t(i, u, c);
  const { connection: x, ...T } = WF(y, S, g);
  let _ = !0;
  c.setState = (U, B, H) => {
    const Y = i(U, B);
    if (!_)
      return Y;
    const G = H === void 0 ? { type: h || "anonymous" } : typeof H == "string" ? { type: H } : H;
    return y === void 0 ? (x == null || x.send(G, u()), Y) : (x == null || x.send(
      {
        ...G,
        type: `${y}/${G.type}`
      },
      {
        ...Q1(g.name),
        [y]: c.getState()
      }
    ), Y);
  };
  const L = (...U) => {
    const B = _;
    _ = !1, i(...U), _ = B;
  }, M = t(c.setState, u, c);
  if (T.type === "untracked" ? x == null || x.init(M) : (T.stores[T.store] = c, x == null || x.init(
    Object.fromEntries(
      Object.entries(T.stores).map(([U, B]) => [
        U,
        U === T.store ? M : B.getState()
      ])
    )
  )), c.dispatchFromDevtools && typeof c.dispatch == "function") {
    let U = !1;
    const B = c.dispatch;
    c.dispatch = (...H) => {
      B(...H);
    };
  }
  return x.subscribe((U) => {
    var B;
    switch (U.type) {
      case "ACTION":
        if (typeof U.payload != "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return zR(
          U.payload,
          (H) => {
            if (H.type === "__setState") {
              if (y === void 0) {
                L(H.state);
                return;
              }
              Object.keys(H.state).length !== 1 && console.error(
                `
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `
              );
              const Y = H.state[y];
              if (Y == null)
                return;
              JSON.stringify(c.getState()) !== JSON.stringify(Y) && L(Y);
              return;
            }
            c.dispatchFromDevtools && typeof c.dispatch == "function" && c.dispatch(H);
          }
        );
      case "DISPATCH":
        switch (U.payload.type) {
          case "RESET":
            return L(M), y === void 0 ? x == null ? void 0 : x.init(c.getState()) : x == null ? void 0 : x.init(Q1(g.name));
          case "COMMIT":
            if (y === void 0) {
              x == null || x.init(c.getState());
              return;
            }
            return x == null ? void 0 : x.init(Q1(g.name));
          case "ROLLBACK":
            return zR(U.state, (H) => {
              if (y === void 0) {
                L(H), x == null || x.init(c.getState());
                return;
              }
              L(H[y]), x == null || x.init(Q1(g.name));
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return zR(U.state, (H) => {
              if (y === void 0) {
                L(H);
                return;
              }
              JSON.stringify(c.getState()) !== JSON.stringify(H[y]) && L(H[y]);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState: H } = U.payload, Y = (B = H.computedStates.slice(-1)[0]) == null ? void 0 : B.state;
            if (!Y)
              return;
            L(y === void 0 ? Y : Y[y]), x == null || x.send(
              null,
              // FIXME no-any
              H
            );
            return;
          }
          case "PAUSE_RECORDING":
            return _ = !_;
        }
        return;
    }
  }), M;
}, YF = XF, zR = (t, r) => {
  let i;
  try {
    i = JSON.parse(t);
  } catch (u) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      u
    );
  }
  i !== void 0 && r(i);
}, $F = !0, ZF = "Linked Data Editor", JF = (t, r) => zF()(YF(t, { name: ZF, store: r, enabled: !$F }));
function Rp(t, r) {
  return JF((u, c, v) => Object.entries(t).reduce(
    (h, [y, { initialValue: g, singleItem: S }]) => ({
      ...h,
      ...VF(
        {
          basic: y
        },
        g,
        !!S
      )(u, c, v)
    }),
    {}
  ), r);
}
const QF = "Status", KF = {
  lastSavedRecordId: {
    initialValue: null
  },
  isRecordEdited: {
    initialValue: !1
  },
  recordStatus: {
    initialValue: { type: void 0 }
  },
  statusMessages: {
    initialValue: [],
    singleItem: { type: {} }
  }
}, qF = Rp(KF, QF), eB = "Loading", tB = {
  isLoading: {
    initialValue: !1
  }
}, nB = Rp(tB, eB), rB = "MarcPreview", aB = {
  basicValue: {
    initialValue: null
  },
  complexValue: {
    initialValue: null
  },
  metadata: {
    initialValue: null
  }
}, iB = Rp(aB, rB), oB = "Profile", lB = {
  profiles: {
    initialValue: []
  },
  selectedProfile: {
    initialValue: null
  },
  preparedFields: {
    initialValue: null
  },
  initialSchemaKey: {
    initialValue: null
  },
  schema: {
    initialValue: /* @__PURE__ */ new Map()
  }
}, sB = Rp(lB, oB), uB = "Inputs", cB = {
  userValues: {
    initialValue: {},
    singleItem: { type: {} }
  },
  previewContent: {
    initialValue: []
  },
  record: {
    initialValue: null
  },
  selectedRecordBlocks: {
    initialValue: void 0
  },
  selectedEntries: {
    initialValue: []
  }
}, fB = Rp(cB, uB), dB = {
  ARABIC: "ar",
  CZECH: "cs-CZ",
  DANISH: "da-DK",
  GERMAN: "de-DE",
  ENGLISH_GB: "en-GB",
  ENGLISH_SE: "en-SE",
  ENGLISH_US: "en-US",
  SPANISH_LA: "es-419",
  SPANISH_EUR: "es-ES",
  SPANISH: "es",
  FRENCH: "fr-FR",
  HEBREW: "he",
  HINDI: "hi-IN",
  HUGARIAN: "hu-HU",
  ITALIAN: "it-IT",
  JAPANESE: "ja",
  KOREAN: "ko",
  NORWEGIAN_BO: "nb",
  DUTCH: "nl",
  NORWEGIAN_NY: "nn",
  POLISH: "pl",
  PORTUGUESE_BR: "pt-BR",
  PORTUGUESE_PT: "pt-PT",
  RUSSIAN: "ru",
  SWEDISH: "sv",
  URDU: "ur",
  CHINESE_CH: "zh-CN",
  CHINESE_TW: "zh-TW"
}, pB = "Config";
var K_;
const hB = {
  locale: {
    initialValue: ((K_ = m2.deserialize(p2)) == null ? void 0 : K_.locale) || dB.ENGLISH_US
  },
  customEvents: {
    initialValue: null
  },
  hasNavigationOrigin: {
    initialValue: !1
  }
}, vB = Rp(hB, pB), mB = "UI", gB = {
  isAdvancedSearchOpen: {
    initialValue: !1
  },
  isSearchPaneCollapsed: {
    initialValue: !1
  },
  fullDisplayComponentType: {
    initialValue: Qh.Basic
  },
  isMarcPreviewOpen: {
    initialValue: !1
  },
  isDuplicateImportedResourceModalOpen: {
    initialValue: !1
  },
  collapsedEntries: {
    initialValue: /* @__PURE__ */ new Set()
  },
  collapsibleEntries: {
    initialValue: /* @__PURE__ */ new Set()
  },
  currentlyEditedEntityBfid: {
    initialValue: /* @__PURE__ */ new Set()
  },
  currentlyPreviewedEntityBfid: {
    initialValue: /* @__PURE__ */ new Set()
  },
  hasShownAuthorityWarning: {
    initialValue: !1
  }
}, bB = Rp(gB, mB);
var Yg = /* @__PURE__ */ ((t) => (t.TITLE = "title", t.CONTRIBUTOR = "contributor", t.ISBN = "isbn", t.LCCN = "lccn", t))(Yg || {}), Ep = /* @__PURE__ */ ((t) => (t.PublishDate = "publishDate", t.Format = "format", t.Suppressed = "suppressed", t))(Ep || {}), Xh = /* @__PURE__ */ ((t) => (t.AuthoritySource = "sourceFileId", t.References = "authRefType", t.Thesaurus = "subjectHeadings", t.TypeOfHeading = "headingType", t.DateCreated = "metadata.createdDate", t.DateUpdated = "metadata.updatedDate", t))(Xh || {}), Wy = /* @__PURE__ */ ((t) => (t.AllTime = "allTime", t.TwelveMonths = "12mos", t.FiveYears = "5yrs", t.TenYears = "10yrs", t))(Wy || {}), NT = /* @__PURE__ */ ((t) => (t.Volume = "volume", t.Ebook = "ebook", t))(NT || {}), _T = /* @__PURE__ */ ((t) => (t.All = "all", t.Suppressed = "suppressed", t.NotSuppressed = "notSuppressed", t))(_T || {}), OT = /* @__PURE__ */ ((t) => (t.Main = "Main", t.Sub = "Sub", t))(OT || {}), LT = /* @__PURE__ */ ((t) => (t.DDC = "ddc", t.LC = "lc", t))(LT || {}), lO = /* @__PURE__ */ ((t) => (t.AND = "and", t.NOT = "not", t))(lO || {}), bC = /* @__PURE__ */ ((t) => (t.containsAll = "containsAll", t.startsWith = "startsWith", t.exactPhrase = "exactPhrase", t))(bC || {});
const yB = {
  publishDate: "allTime",
  format: [],
  suppressed: "all"
  /* All */
}, l0 = 10, CB = 2, EB = Object.values(Yg), SB = Object.values(lO), xB = Object.values(bC), sO = "title", RB = {
  operator: "and",
  qualifier: "containsAll",
  index: "title"
  /* TITLE */
}, $N = new Array(6).fill(RB).map((t, r) => ({ ...t, rowIndex: r, operator: r === 0 ? void 0 : t.operator }));
var zl = /* @__PURE__ */ ((t) => (t.Single = "single", t.Multi = "multi", t.Lookup = "lookup", t.DateRange = "dateRange", t))(zl || {}), $c = /* @__PURE__ */ ((t) => (t.Checkbox = "checkbox", t.Radio = "radio", t))($c || {}), bo = /* @__PURE__ */ ((t) => (t.Search = "search", t.Browse = "browse", t))(bo || {});
const ZN = {
  query: "",
  searchBy: "",
  facets: {}
}, uO = {
  search: ZN,
  browse: ZN
};
var DT = /* @__PURE__ */ ((t) => (t.ExcludeSeeFrom = "Auth/Ref", t.ExcludeSeeFromAlso = "Reference", t))(DT || {}), b2 = /* @__PURE__ */ ((t) => (t.Authorized = "Authorized", t.Reference = "Reference", t.AuthRef = "Auth/Ref", t))(b2 || {});
const Pt = ":value", TB = "Search", wB = {
  query: {
    initialValue: ""
  },
  message: {
    initialValue: ""
  },
  searchBy: {
    initialValue: sO
  },
  data: {
    initialValue: null
  },
  facets: {
    initialValue: yB
  },
  navigationState: {
    initialValue: {}
  },
  forceRefresh: {
    initialValue: !1
  },
  pageMetadata: {
    initialValue: { totalElements: 0, totalPages: 0 }
  },
  facetsBySegments: {
    initialValue: uO
  },
  sourceData: {
    initialValue: null
  },
  selectedFacetsGroups: {
    initialValue: []
  },
  facetsData: {
    initialValue: {}
  },
  selectedInstances: {
    initialValue: []
  }
}, IB = Rp(wB, TB), AB = "ComplexLookup", NB = {
  authorityAssignmentCheckFailedIds: {
    initialValue: [],
    singleItem: { type: "" }
  }
}, _B = Rp(NB, AB), Si = qF, qu = nB, ud = iB, cd = sB, Ea = fB, y2 = vB, Qa = bB, Eo = IB, OB = _B, qs = (t) => /* @__PURE__ */ k.createElement("svg", { width: 16, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M9.6973 8.00025L14.8255 2.87209L15.883 1.81456C16.039 1.65855 16.039 1.40504 15.883 1.24904L14.7515 0.117504C14.5955 -0.0385011 14.3419 -0.0385011 14.1859 0.117504L8.00025 6.3032L1.81456 0.117004C1.65855 -0.0390012 1.40504 -0.0390012 1.24904 0.117004L0.117004 1.24854C-0.0390012 1.40454 -0.0390012 1.65805 0.117004 1.81406L6.3032 8.00025L0.117004 14.1859C-0.0390012 14.3419 -0.0390012 14.5955 0.117004 14.7515L1.24854 15.883C1.40454 16.039 1.65805 16.039 1.81406 15.883L8.00025 9.6973L13.1284 14.8255L14.1859 15.883C14.3419 16.039 14.5955 16.039 14.7515 15.883L15.883 14.7515C16.039 14.5955 16.039 14.3419 15.883 14.1859L9.6973 8.00025Z", fill: "#55585D" })), LB = (t) => /* @__PURE__ */ k.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M16.5 8.8999C16.5 13.3182 12.9183 16.8999 8.5 16.8999C4.08171 16.8999 0.5 13.3182 0.5 8.8999C0.5 4.48161 4.08171 0.899902 8.5 0.899902C12.9183 0.899902 16.5 4.48161 16.5 8.8999ZM7.57464 13.1358L13.5101 7.20035C13.7117 6.99881 13.7117 6.672 13.5101 6.47045L12.7802 5.74055C12.5787 5.53897 12.2519 5.53897 12.0503 5.74055L7.20968 10.5811L4.94971 8.32116C4.74816 8.11961 4.42135 8.11961 4.21977 8.32116L3.48987 9.05106C3.28832 9.25261 3.28832 9.57942 3.48987 9.78097L6.84471 13.1358C7.04629 13.3374 7.37306 13.3374 7.57464 13.1358Z", fill: "black" })), cO = (t) => /* @__PURE__ */ k.createElement("svg", { width: 11, height: 11, viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M10.8762 9.01435C11.2287 9.62535 10.7862 10.3891 10.0822 10.3891H0.917703C0.212309 10.3891 -0.228111 9.62416 0.123698 9.01435L4.706 1.06937C5.05867 0.458092 5.94197 0.4592 6.29401 1.06937L10.8762 9.01435ZM5.5 7.37174C5.01484 7.37174 4.62153 7.76505 4.62153 8.25021C4.62153 8.73538 5.01484 9.12869 5.5 9.12869C5.98517 9.12869 6.37848 8.73538 6.37848 8.25021C6.37848 7.76505 5.98517 7.37174 5.5 7.37174ZM4.66597 4.21409L4.80763 6.81132C4.81426 6.93285 4.91475 7.02799 5.03646 7.02799H5.96355C6.08526 7.02799 6.18575 6.93285 6.19237 6.81132L6.33404 4.21409C6.3412 4.08282 6.23668 3.97244 6.10521 3.97244H4.89477C4.76331 3.97244 4.65881 4.08282 4.66597 4.21409Z", fill: "#55585D" })), DB = (t) => /* @__PURE__ */ k.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M16.5 8.39999C16.5 12.8193 12.918 16.4 8.5 16.4C4.08203 16.4 0.5 12.8193 0.5 8.39999C0.5 3.98332 4.08203 0.399994 8.5 0.399994C12.918 0.399994 16.5 3.98332 16.5 8.39999ZM8.5 10.0129C7.68048 10.0129 7.01613 10.6773 7.01613 11.4968C7.01613 12.3163 7.68048 12.9806 8.5 12.9806C9.31952 12.9806 9.98387 12.3163 9.98387 11.4968C9.98387 10.6773 9.31952 10.0129 8.5 10.0129ZM7.09119 4.67916L7.33048 9.06625C7.34168 9.27154 7.51142 9.43225 7.717 9.43225H9.283C9.48858 9.43225 9.65832 9.27154 9.66952 9.06625L9.90881 4.67916C9.9209 4.45741 9.74436 4.27096 9.52229 4.27096H7.47768C7.25561 4.27096 7.0791 4.45741 7.09119 4.67916Z", fill: "#990000" }));
const MB = 1e4, PB = () => {
  const { statusMessages: t, setStatusMessages: r } = Si(), i = (v) => {
    r((h) => h.filter(({ id: y }) => y !== v));
  }, u = () => i(t[0].id);
  k.useEffect(() => {
    t.length && setTimeout(u, MB);
  }, [t]);
  const c = (v) => {
    switch (v) {
      case Tr.success:
        return /* @__PURE__ */ N.jsx(LB, { className: "status-message-icon" });
      case Tr.warning:
        return /* @__PURE__ */ N.jsx(cO, { className: "status-message-icon" });
      case Tr.error:
        return /* @__PURE__ */ N.jsx(DB, { className: "status-message-icon" });
      default:
        return null;
    }
  };
  return t != null && t.length ? /* @__PURE__ */ N.jsx("div", { className: "common-status", "data-testid": "common-status", children: t.map(({ id: v, type: h, message: y }) => /* @__PURE__ */ N.jsxs("div", { className: In(["status-message", h]), role: "status", children: [
    c(h),
    /* @__PURE__ */ N.jsx("span", { className: "status-message-text", children: /* @__PURE__ */ N.jsx(mt, { id: y, defaultMessage: y }) }),
    /* @__PURE__ */ N.jsx(Dn, { className: "status-message-close", type: Mn.Text, onClick: () => i(v), children: /* @__PURE__ */ N.jsx(qs, {}) })
  ] }, v)) }) : null;
}, Hg = {
  classNames: {
    nav: "nav",
    fullDisplayContainer: "full-display-container",
    itemSearchContent: "item-search-content",
    itemSearchContentContainer: "item-search-content-container",
    itemSearchMessage: "item-search-content-message",
    table: "table",
    tableFlex: "table-flex",
    tableHead: "table-head",
    tableHeadCell: "table-head-cell",
    tableRow: "table-row",
    tableBodyContainer: "table-body-container",
    tableBody: "table-body"
  }
}, fO = (t) => /* @__PURE__ */ k.createElement("svg", { width: 8, height: 5, viewBox: "0 0 8 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M0.538289 0.0999756H7.46171C7.94067 0.0999756 8.18015 0.711894 7.84111 1.07051L4.38075 4.73348C4.17087 4.95548 3.82913 4.95548 3.61925 4.73348L0.158886 1.07051C-0.180154 0.711894 0.0593268 0.0999756 0.538289 0.0999756Z", fill: "white" }));
const C2 = ({
  labelId: t,
  items: r,
  buttonTestId: i,
  className: u,
  hideLabelIdWithinDropdownList: c
}) => {
  const v = k.useRef(null), h = k.useRef(null), y = k.useRef(null), g = k.useRef([]), [S, x] = k.useState(!1), T = () => x(!0), _ = () => {
    var B;
    x(!1), (B = h.current) == null || B.focus();
  }, L = () => x((B) => !B), M = (B) => {
    var H, Y, G;
    switch (B.preventDefault(), (H = h.current) == null || H.blur(), B.key) {
      case "ArrowDown":
        T(), y.current && ((Y = y.current.childNodes[0]) == null || Y.focus());
        break;
      case "ArrowUp":
        if (T(), y.current) {
          const Q = y.current.childNodes.length - 1;
          (G = y.current.childNodes[Q]) == null || G.focus();
        }
        break;
      case "Enter":
      case " ":
        L();
        break;
    }
  }, U = (B, H) => {
    var j, re, me, Se;
    B.preventDefault();
    const { key: Y, currentTarget: G } = B, { nextSibling: Q, previousSibling: W, parentNode: oe } = G;
    switch (Y) {
      case "ArrowDown":
        if (Q) {
          Q == null || Q.focus();
          break;
        }
        Q || (j = oe == null ? void 0 : oe.childNodes[0]) == null || j.focus();
        break;
      case "ArrowUp":
        if (W) {
          W == null || W.focus();
          break;
        }
        if (!W && oe) {
          const Ne = ((re = oe.childNodes) == null ? void 0 : re.length) - 1;
          (me = oe.childNodes[Ne]) == null || me.focus();
        }
        break;
      case " ":
        (Se = g.current[H]) == null || Se.click(), _();
        break;
      case "Enter":
      case "Escape":
        _();
        break;
    }
  };
  return k.useEffect(() => {
    var B;
    S && y.current && ((B = y.current.childNodes[0]) == null || B.focus());
  }, [S]), k.useEffect(() => {
    const B = (H) => {
      v.current && !v.current.contains(H.target) && x(!1);
    };
    return document.addEventListener("mousedown", B), () => document.removeEventListener("mousedown", B);
  }, []), /* @__PURE__ */ N.jsxs("div", { ref: v, className: In("dropdown", u), children: [
    /* @__PURE__ */ N.jsxs(
      "button",
      {
        type: "button",
        className: In(["dropdown-button", S ? "expanded" : "collapsed", "button-highlighted"]),
        ref: h,
        onClick: L,
        onKeyDown: M,
        "aria-expanded": S,
        "data-testid": i,
        children: [
          /* @__PURE__ */ N.jsx("span", { className: "dropdown-button-label", children: /* @__PURE__ */ N.jsx(mt, { id: t }) }),
          /* @__PURE__ */ N.jsx(fO, { className: "dropdown-icon" })
        ]
      }
    ),
    /* @__PURE__ */ N.jsx("div", { className: In(["dropdown-options", S ? "expanded" : "collapsed"]), children: r == null ? void 0 : r.map(({ id: B, labelId: H, data: Y }) => /* @__PURE__ */ N.jsxs("div", { className: "dropdown-options-group", children: [
      H && !c && /* @__PURE__ */ N.jsx("div", { className: "dropdown-options-group-label", children: /* @__PURE__ */ N.jsx("span", { children: /* @__PURE__ */ N.jsx(mt, { id: H }) }) }),
      Y.length > 0 && /* @__PURE__ */ N.jsx("div", { ref: y, role: "menu", className: "dropdown-options-group-container", children: Y == null ? void 0 : Y.map(({ id: G, type: Q, icon: W, labelId: oe, renderComponent: j, isDisabled: re, hidden: me, action: Se }, Ne) => {
        if (!me)
          switch (Q) {
            case Wu.basic:
              return /* @__PURE__ */ N.jsxs(
                "button",
                {
                  type: "button",
                  ref: (Ge) => {
                    g.current[Ne] = Ge;
                  },
                  role: "menuitem",
                  disabled: re,
                  "aria-disabled": re,
                  tabIndex: S ? 0 : -1,
                  onClick: () => {
                    Se == null || Se(), L();
                  },
                  onKeyDown: (Ge) => U(Ge, Ne),
                  className: "dropdown-options-button",
                  "data-testid": `${i}__option-${oe}`,
                  children: [
                    W && /* @__PURE__ */ N.jsx("span", { className: "dropdown-options-button-icon", children: W }),
                    /* @__PURE__ */ N.jsx("span", { className: "dropdown-options-button-label", children: /* @__PURE__ */ N.jsx(mt, { id: oe }) })
                  ]
                },
                G
              );
            case Wu.customComponent:
              return j == null ? void 0 : j(G);
            default:
              return null;
          }
      }) })
    ] }, B)) })
  ] });
};
var Co = /* @__PURE__ */ ((t) => (t.work = "work", t.instance = "instance", t))(Co || {}), od = /* @__PURE__ */ ((t) => (t.saveAndClose = "saveAndClose", t.saveAndKeepEditing = "saveAndKeepEditing", t.open = "open", t.close = "close", t))(od || {}), uC = /* @__PURE__ */ ((t) => (t.Edit = "edit", t.New = "new", t.Duplicate = "duplicate", t))(uC || {});
const Le = {
  INSTANCE: "http://bibfra.me/vocab/lite/Instance",
  WORK: "http://bibfra.me/vocab/lite/Work",
  NAME: "http://bibfra.me/vocab/lite/name",
  LABEL: "http://bibfra.me/vocab/lite/label",
  LINK: "http://bibfra.me/vocab/lite/link",
  CODE: "http://bibfra.me/vocab/marc/code",
  TERM: "http://bibfra.me/vocab/marc/term",
  SOURCE: "http://bibfra.me/vocab/marc/source",
  EDITION: "http://bibfra.me/vocab/marc/edition",
  EDITION_TYPE: "http://bibfra.me/vocab/marc/editionType",
  TABLE_OF_CONTENTS: "http://bibfra.me/vocab/marc/tableOfContents",
  SUMMARY: "http://bibfra.me/vocab/marc/summary",
  INSTANTIATES: "http://bibfra.me/vocab/lite/instantiates",
  EXTENT_TEMP: "BFLITE_URI_TEMP_EXTENT",
  // TODO: set the value when the API contract for Extent field is updated
  EXTENT: "http://bibfra.me/vocab/lite/extent",
  APPLIES_TO_TEMP: "APPLIES_TO_TEMP",
  NOTE: "http://bibfra.me/vocab/lite/note",
  CREATOR: "http://bibfra.me/vocab/lite/creator",
  CONTRIBUTOR: "http://bibfra.me/vocab/lite/contributor",
  PROVIDER_PLACE: "http://bibfra.me/vocab/lite/providerPlace",
  CLASSIFICATION: "http://bibfra.me/vocab/lite/classification",
  PROVISION_ACTIVITY: "https://bibfra.me/vocab/marc/provisionActivity",
  TITLE: "http://bibfra.me/vocab/marc/title",
  TITLE_CONTAINER: "http://bibfra.me/vocab/marc/Title",
  MAIN_TITLE: "http://bibfra.me/vocab/marc/mainTitle",
  PRODUCTION: "http://bibfra.me/vocab/marc/production",
  PUBLICATION: "http://bibfra.me/vocab/marc/publication",
  DISTRIBUTION: "http://bibfra.me/vocab/marc/distribution",
  MANUFACTURE: "http://bibfra.me/vocab/marc/manufacture",
  COPYRIGHT: "http://bibfra.me/vocab/marc/copyright",
  ISSUANCE: "http://bibfra.me/vocab/marc/issuance",
  LANGUAGE: "http://bibfra.me/vocab/lite/language",
  DATE: "http://bibfra.me/vocab/lite/date"
}, yo = {
  NOTE: "http://id.loc.gov/ontologies/bibframe/note",
  NOTE_TYPE: "http://id.loc.gov/ontologies/bibframe/noteType",
  CONTRIBUTION: "http://id.loc.gov/ontologies/bibframe/contribution",
  CREATOR_NAME: "http://www.w3.org/2002/07/owl#sameAs",
  ROLE: "http://id.loc.gov/ontologies/bibframe/role",
  INTENDED_AUDIENCE: "http://id.loc.gov/ontologies/bibframe/intendedAudience"
}, WR = {
  "http://id.loc.gov/ontologies/bibframe/Instance": Le.INSTANCE,
  "http://id.loc.gov/ontologies/bibframe/Work": Le.WORK,
  "http://id.loc.gov/ontologies/bibframe/title": "http://bibfra.me/vocab/marc/title",
  "http://id.loc.gov/ontologies/bibframe/Title": "http://bibfra.me/vocab/marc/Title",
  "http://id.loc.gov/ontologies/bflc/nonSortNum": "http://bibfra.me/vocab/bflc/nonSortNum",
  "http://id.loc.gov/ontologies/bibframe/mainTitle": "http://bibfra.me/vocab/marc/mainTitle",
  "http://id.loc.gov/ontologies/bibframe/partNumber": "http://bibfra.me/vocab/marc/partNumber",
  "http://id.loc.gov/ontologies/bibframe/partName": "http://bibfra.me/vocab/marc/partName",
  "http://id.loc.gov/ontologies/bibframe/subtitle": "http://bibfra.me/vocab/marc/subTitle",
  "http://id.loc.gov/ontologies/bibframe/VariantTitle": "http://bibfra.me/vocab/marc/VariantTitle",
  "http://id.loc.gov/ontologies/bibframe/variantType": "http://bibfra.me/vocab/marc/variantType",
  "http://id.loc.gov/ontologies/bibframe/ParallelTitle": "http://bibfra.me/vocab/marc/ParallelTitle",
  "http://id.loc.gov/ontologies/bibframe/note": "http://bibfra.me/vocab/lite/note",
  "http://id.loc.gov/ontologies/bibframe/responsibilityStatement": "http://bibfra.me/vocab/marc/statementOfResponsibility",
  "http://id.loc.gov/ontologies/bibframe/editionStatement": "http://bibfra.me/vocab/marc/edition",
  "http://id.loc.gov/ontologies/bibframe/provisionActivity": "https://bibfra.me/vocab/marc/provisionActivity",
  "http://id.loc.gov/ontologies/bibframe/Publication": "http://bibfra.me/vocab/marc/publication",
  "http://id.loc.gov/ontologies/bibframe/place": "http://bibfra.me/vocab/lite/providerPlace",
  "http://id.loc.gov/ontologies/bibframe/content": "http://bibfra.me/vocab/marc/content",
  "http://id.loc.gov/ontologies/bflc/simplePlace": "http://bibfra.me/vocab/lite/place",
  "http://id.loc.gov/ontologies/bflc/simpleAgent": "http://bibfra.me/vocab/lite/name",
  "http://id.loc.gov/ontologies/bflc/simpleDate": "http://bibfra.me/vocab/lite/date",
  "http://id.loc.gov/ontologies/bibframe/Distribution": "http://bibfra.me/vocab/marc/distribution",
  "http://id.loc.gov/ontologies/bibframe/Manufacture": "http://bibfra.me/vocab/marc/manufacture",
  "http://id.loc.gov/ontologies/bibframe/Production": "http://bibfra.me/vocab/marc/production",
  "http://id.loc.gov/ontologies/bibframe/identifiedBy": "http://library.link/vocab/map",
  "http://id.loc.gov/ontologies/bibframe/Lccn": "http://library.link/identifier/LCCN",
  "http://id.loc.gov/ontologies/bibframe/Isbn": "http://library.link/identifier/ISBN",
  "http://id.loc.gov/ontologies/bibframe/Identifier": "http://library.link/identifier/UNKNOWN",
  // TODO: update when defined
  "http://id.loc.gov/ontologies/bibframe/Local": "http://bibfra.me/vocab/lite/LocalId",
  "http://id.loc.gov/ontologies/bibframe/Ean": "http://bibfra.me/vocab/identifier/Ean",
  "http://id.loc.gov/ontologies/bibframe/qualifier": "http://bibfra.me/vocab/marc/qualifier",
  "http://id.loc.gov/ontologies/bibframe/electronicLocator": "http://bibfra.me/vocab/marc/accessLocation",
  "http://id.loc.gov/ontologies/bibframe/media": "http://bibfra.me/vocab/marc/media",
  "http://id.loc.gov/ontologies/bibframe/carrier": "http://bibfra.me/vocab/marc/carrier",
  "http://id.loc.gov/ontologies/bibframe/dimensions": "http://bibfra.me/vocab/marc/dimensions",
  "http://id.loc.gov/ontologies/bflc/projectedProvisionDate": "http://bibfra.me/vocab/bflc/projectedProvisionDate",
  "http://id.loc.gov/ontologies/bibframe/copyrightDate": "http://bibfra.me/vocab/marc/copyright",
  "http://id.loc.gov/ontologies/bibframe/issuance": "http://bibfra.me/vocab/marc/issuance",
  "http://id.loc.gov/ontologies/bibframe/status": "http://bibfra.me/vocab/marc/status",
  "http://id.loc.gov/ontologies/bibframe/classification": "http://bibfra.me/vocab/lite/classification",
  "http://id.loc.gov/ontologies/bibframe/ClassificationDdc": "ddc",
  "http://id.loc.gov/ontologies/bibframe/ClassificationLcc": "lc",
  "http://id.loc.gov/ontologies/bibframe/classificationPortion": Le.CODE,
  "http://id.loc.gov/ontologies/bibframe/itemPortion": "http://bibfra.me/vocab/marc/itemNumber",
  "http://id.loc.gov/ontologies/bibframe/source": Le.EDITION,
  "http://id.loc.gov/ontologies/bibframe/subject": "http://bibfra.me/vocab/lite/subject",
  "http://id.loc.gov/ontologies/bibframe/edition": Le.EDITION,
  "http://id.loc.gov/ontologies/bibframe/code": "http://bibfra.me/vocab/marc/editionNumber",
  "http://id.loc.gov/ontologies/bibframe/Person": "http://bibfra.me/vocab/lite/Person",
  "http://id.loc.gov/ontologies/bibframe/Family": "http://bibfra.me/vocab/lite/Family",
  "http://id.loc.gov/ontologies/bibframe/Organization": "http://bibfra.me/vocab/lite/Organization",
  "http://id.loc.gov/ontologies/bibframe/Meeting": "http://bibfra.me/vocab/lite/Meeting",
  "http://id.loc.gov/ontologies/bibframe/Jurisdiction": "http://bibfra.me/vocab/lite/Jurisdiction",
  "http://id.loc.gov/ontologies/bibframe/summary": Le.SUMMARY,
  "http://id.loc.gov/ontologies/bibframe/language": "http://bibfra.me/vocab/lite/language",
  "http://id.loc.gov/ontologies/bibframe/Contribution": "http://bibfra.me/vocab/lite/contributor",
  "http://id.loc.gov/ontologies/bflc/PrimaryContribution": "http://bibfra.me/vocab/lite/creator",
  "http://id.loc.gov/ontologies/bibframe/extent": "",
  // TODO: set the value when the API contract for the Extent field is updated
  "http://id.loc.gov/ontologies/bibframe/Extent": Le.EXTENT_TEMP,
  "http://id.loc.gov/ontologies/bibframe/supplementaryContent": {
    "http://id.loc.gov/ontologies/bibframe/Instance": "http://bibfra.me/vocab/marc/supplementaryContent"
  },
  "http://id.loc.gov/ontologies/bibframe/assigner": {
    "http://id.loc.gov/ontologies/bibframe/classification": "_assigningSourceReference"
  },
  "http://www.w3.org/2000/01/rdf-schema#label": {
    "http://id.loc.gov/ontologies/bibframe/note": "http://bibfra.me/vocab/lite/note",
    "http://id.loc.gov/ontologies/bibframe/electronicLocator": "http://bibfra.me/vocab/lite/note",
    "http://id.loc.gov/ontologies/bibframe/summary": Le.SUMMARY,
    "http://id.loc.gov/ontologies/bibframe/TableOfContents": Le.TABLE_OF_CONTENTS,
    "http://id.loc.gov/ontologies/bibframe/extent": Le.EXTENT,
    "http://id.loc.gov/ontologies/bflc/AppliesTo": Le.APPLIES_TO_TEMP,
    // TODO: set the value when the API contract for the Extent field is updated
    "http://id.loc.gov/ontologies/bibframe/supplementaryContent": "http://bibfra.me/vocab/lite/name"
  },
  "http://www.w3.org/1999/02/22-rdf-syntax-ns#value": {
    "http://id.loc.gov/ontologies/bibframe/Lccn": "http://bibfra.me/vocab/lite/name",
    "http://id.loc.gov/ontologies/bibframe/Isbn": "http://bibfra.me/vocab/lite/name",
    "http://id.loc.gov/ontologies/bibframe/Identifier": "http://bibfra.me/vocab/lite/name",
    "http://id.loc.gov/ontologies/bibframe/Local": "http://bibfra.me/vocab/marc/localId",
    "http://id.loc.gov/ontologies/bibframe/Ean": "http://bibfra.me/vocab/marc/ean",
    "http://id.loc.gov/ontologies/bibframe/supplementaryContent": "http://bibfra.me/vocab/lite/link",
    "http://id.loc.gov/ontologies/bibframe/electronicLocator": "http://bibfra.me/vocab/lite/link"
  },
  "http://id.loc.gov/ontologies/bibframe/date": {
    "http://id.loc.gov/ontologies/bibframe/title": "http://bibfra.me/vocab/lite/date",
    "http://id.loc.gov/ontologies/bibframe/provisionActivity": "http://bibfra.me/vocab/lite/providerDate"
  },
  "http://www.w3.org/2002/07/owl#sameAs": {
    "http://id.loc.gov/ontologies/bibframe/language": "http://bibfra.me/vocab/lite/language",
    "http://id.loc.gov/ontologies/bibframe/Person": Le.NAME,
    "http://id.loc.gov/ontologies/bibframe/Family": Le.NAME,
    "http://id.loc.gov/ontologies/bibframe/Organization": Le.NAME,
    "http://id.loc.gov/ontologies/bibframe/Meeting": Le.NAME,
    "http://id.loc.gov/ontologies/bibframe/Jurisdiction": Le.NAME,
    "http://id.loc.gov/ontologies/bibframe/geographicCoverage": "_geographicCoverageReference"
  },
  "http://id.loc.gov/ontologies/bflc/governmentPubType": "http://bibfra.me/vocab/marc/governmentPublication",
  "http://id.loc.gov/ontologies/bibframe/originDate": "http://bibfra.me/vocab/lite/dateStart",
  "http://id.loc.gov/ontologies/bibframe/originPlace": "http://bibfra.me/vocab/marc/originPlace",
  "http://id.loc.gov/ontologies/bibframe/intendedAudience": "http://bibfra.me/vocab/marc/targetAudience"
}, Yu = {
  [Le.NOTE]: { container: "_notes" },
  [Le.CONTRIBUTOR]: { container: "roles" },
  [Le.CREATOR]: { container: "roles" }
}, JN = {
  [Le.CREATOR]: { container: "_creatorReference" },
  [Le.CONTRIBUTOR]: { container: "_contributorReference" }
}, QN = {
  [yo.NOTE]: {
    container: { key: Yu[Le.NOTE].container },
    "http://www.w3.org/2000/01/rdf-schema#label": { key: "value" },
    "http://www.w3.org/1999/02/22-rdf-syntax-ns#type": { key: "type" },
    "http://id.loc.gov/ontologies/bibframe/noteType": { key: "type" }
  },
  [yo.CONTRIBUTION]: {
    container: {
      altKeys: {
        "http://id.loc.gov/ontologies/bflc/PrimaryContribution": Le.CREATOR,
        "http://id.loc.gov/ontologies/bibframe/Contribution": Le.CONTRIBUTOR
      }
    },
    options: {
      "http://id.loc.gov/ontologies/bibframe/Person": { key: "http://bibfra.me/vocab/lite/Person" },
      "http://id.loc.gov/ontologies/bibframe/Family": { key: "http://bibfra.me/vocab/lite/Family" },
      "http://id.loc.gov/ontologies/bibframe/Organization": { key: "http://bibfra.me/vocab/lite/Organization" },
      "http://id.loc.gov/ontologies/bibframe/Meeting": { key: "http://bibfra.me/vocab/lite/Meeting" },
      "http://id.loc.gov/ontologies/bibframe/Jurisdiction": { key: "http://bibfra.me/vocab/lite/Jurisdiction" }
    },
    "http://id.loc.gov/ontologies/bibframe/role": { key: Yu[Le.CONTRIBUTOR].container }
  }
}, kB = {
  "http://bibfra.me/vocab/lite/providerPlace": Le.LABEL,
  "http://bibfra.me/vocab/marc/status": Le.LABEL,
  "http://bibfra.me/vocab/marc/media": Le.TERM,
  "http://bibfra.me/vocab/marc/carrier": Le.TERM,
  "http://bibfra.me/vocab/marc/content": Le.TERM,
  "http://bibfra.me/vocab/lite/classification": Le.SOURCE,
  "http://bibfra.me/vocab/lite/Person": Le.NAME,
  "http://bibfra.me/vocab/lite/Family": Le.NAME,
  "http://bibfra.me/vocab/lite/Organization": Le.NAME,
  "http://bibfra.me/vocab/lite/Meeting": Le.NAME,
  "http://bibfra.me/vocab/lite/Jurisdiction": Le.NAME,
  "http://bibfra.me/vocab/marc/governmentPublication": Le.TERM,
  "http://bibfra.me/vocab/marc/targetAudience": Le.TERM,
  "http://bibfra.me/vocab/marc/originPlace": Le.NAME,
  "http://bibfra.me/vocab/lite/language": Le.TERM
}, FB = {
  "http://bibfra.me/vocab/marc/copyright": {
    valueUri: "http://bibfra.me/vocab/lite/date"
  }
}, MT = "_instanceReference", PT = "_workReference", Ca = {
  INSTANCE: {
    uri: Le.INSTANCE,
    referenceKey: MT,
    resourceType: Co.instance,
    reference: {
      key: PT,
      uri: Le.WORK,
      name: Co.work
    }
  },
  WORK: {
    uri: Le.WORK,
    referenceKey: PT,
    resourceType: Co.work,
    reference: {
      key: MT,
      uri: Le.INSTANCE,
      name: Co.instance
    }
  }
}, BB = {
  [MT]: Co.instance,
  [PT]: Co.work
}, um = {
  [yo.NOTE]: {
    field: {
      uri: "http://id.loc.gov/ontologies/bibframe/noteType"
    },
    data: {
      [Le.NOTE]: {
        uri: yo.NOTE
      },
      "http://bibfra.me/vocab/marc/withNote": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/with",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/typeOfReport": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/report",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/issuanceNote": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/issuance",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/computerDataNote": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/computer",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/additionalPhysicalForm": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/addphys",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/reproductionNote": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/repro",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/originalVersionNote": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/orig",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/fundingInformation": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/fundinfo",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/relatedParts": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/related",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/issuingBody": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/issuing",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/locationOfOtherArchivalMaterial": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/finding",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/exhibitionsNote": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/exhibit",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/descriptionSourceNote": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/descsource",
        parentBlock: { bfLiteUri: Ca.INSTANCE.uri }
      },
      "http://bibfra.me/vocab/marc/bibliographyNote": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/biblio",
        parentBlock: { bfLiteUri: Ca.WORK.uri }
      },
      "http://bibfra.me/vocab/marc/languageNote": {
        uri: "http://id.loc.gov/vocabulary/mnotetype/lang",
        parentBlock: { bfLiteUri: Ca.WORK.uri }
      }
    }
  },
  [yo.CONTRIBUTION]: {
    field: {
      uri: "http://id.loc.gov/ontologies/bibframe/role"
    },
    data: {
      "http://bibfra.me/vocab/relation/abridger": { uri: "http://id.loc.gov/vocabulary/relators/abr" },
      "http://bibfra.me/vocab/relation/acp": { uri: "http://id.loc.gov/vocabulary/relators/acp" },
      "http://bibfra.me/vocab/relation/actor": { uri: "http://id.loc.gov/vocabulary/relators/act" },
      "http://bibfra.me/vocab/relation/adapter": { uri: "http://id.loc.gov/vocabulary/relators/adp" },
      "http://bibfra.me/vocab/relation/addressee": { uri: "http://id.loc.gov/vocabulary/relators/rcp" },
      "http://bibfra.me/vocab/relation/analyst": { uri: "http://id.loc.gov/vocabulary/relators/anl" },
      "http://bibfra.me/vocab/relation/animator": { uri: "http://id.loc.gov/vocabulary/relators/anm" },
      "http://bibfra.me/vocab/relation/annotator": { uri: "http://id.loc.gov/vocabulary/relators/ann" },
      "http://bibfra.me/vocab/relation/appellant": { uri: "http://id.loc.gov/vocabulary/relators/apl" },
      "http://bibfra.me/vocab/relation/appellee": { uri: "http://id.loc.gov/vocabulary/relators/ape" },
      "http://bibfra.me/vocab/relation/applicant": { uri: "http://id.loc.gov/vocabulary/relators/app" },
      "http://bibfra.me/vocab/relation/architect": { uri: "http://id.loc.gov/vocabulary/relators/arc" },
      "http://bibfra.me/vocab/relation/arranger": { uri: "http://id.loc.gov/vocabulary/relators/arr" },
      "http://bibfra.me/vocab/relation/artisticdirector": { uri: "http://id.loc.gov/vocabulary/relators/adi" },
      "http://bibfra.me/vocab/relation/artist": { uri: "http://id.loc.gov/vocabulary/relators/art" },
      "http://bibfra.me/vocab/relation/artdirector": { uri: "http://id.loc.gov/vocabulary/relators/ard" },
      "http://bibfra.me/vocab/relation/assignee": { uri: "http://id.loc.gov/vocabulary/relators/asg" },
      "http://bibfra.me/vocab/relation/associatedname": { uri: "http://id.loc.gov/vocabulary/relators/asn" },
      "http://bibfra.me/vocab/relation/attributedname": { uri: "http://id.loc.gov/vocabulary/relators/att" },
      "http://bibfra.me/vocab/relation/auctioneer": { uri: "http://id.loc.gov/vocabulary/relators/auc" },
      "http://bibfra.me/vocab/relation/author": { uri: "http://id.loc.gov/vocabulary/relators/aut" },
      "http://bibfra.me/vocab/relation/authorinquotationsortextabstracts": {
        uri: "http://id.loc.gov/vocabulary/relators/aqt"
      },
      "http://bibfra.me/vocab/relation/authorofafterwordcolophonetc": {
        uri: "http://id.loc.gov/vocabulary/relators/aft"
      },
      "http://bibfra.me/vocab/relation/authorofdialog": { uri: "http://id.loc.gov/vocabulary/relators/aud" },
      "http://bibfra.me/vocab/relation/authorofintroductionetc": { uri: "http://id.loc.gov/vocabulary/relators/aui" },
      "http://bibfra.me/vocab/relation/autographer": { uri: "http://id.loc.gov/vocabulary/relators/ato" },
      "http://bibfra.me/vocab/relation/bibliographicantecedent": { uri: "http://id.loc.gov/vocabulary/relators/ant" },
      "http://bibfra.me/vocab/relation/bindingdesigner": { uri: "http://id.loc.gov/vocabulary/relators/bdd" },
      "http://bibfra.me/vocab/relation/binder": { uri: "http://id.loc.gov/vocabulary/relators/bnd" },
      "http://bibfra.me/vocab/relation/blurbwriter": { uri: "http://id.loc.gov/vocabulary/relators/blw" },
      "http://bibfra.me/vocab/relation/bookdesigner": { uri: "http://id.loc.gov/vocabulary/relators/bkd" },
      "http://bibfra.me/vocab/relation/bookproducer": { uri: "http://id.loc.gov/vocabulary/relators/bkp" },
      "http://bibfra.me/vocab/relation/bookjacketdesigner": { uri: "http://id.loc.gov/vocabulary/relators/bjd" },
      "http://bibfra.me/vocab/relation/bookplatedesigner": { uri: "http://id.loc.gov/vocabulary/relators/bpd" },
      "http://bibfra.me/vocab/relation/bookseller": { uri: "http://id.loc.gov/vocabulary/relators/bsl" },
      "http://bibfra.me/vocab/relation/brailleembosser": { uri: "http://id.loc.gov/vocabulary/relators/brl" },
      "http://bibfra.me/vocab/relation/broadcaster": { uri: "http://id.loc.gov/vocabulary/relators/brd" },
      "http://bibfra.me/vocab/relation/calligrapher": { uri: "http://id.loc.gov/vocabulary/relators/cll" },
      "http://bibfra.me/vocab/relation/cartographer": { uri: "http://id.loc.gov/vocabulary/relators/ctg" },
      "http://bibfra.me/vocab/relation/caster": { uri: "http://id.loc.gov/vocabulary/relators/cas" },
      "http://bibfra.me/vocab/relation/censor": { uri: "http://id.loc.gov/vocabulary/relators/cns" },
      "http://bibfra.me/vocab/relation/choreographer": { uri: "http://id.loc.gov/vocabulary/relators/chr" },
      "http://bibfra.me/vocab/relation/cinematographer": { uri: "http://id.loc.gov/vocabulary/relators/cng" },
      "http://bibfra.me/vocab/relation/client": { uri: "http://id.loc.gov/vocabulary/relators/cli" },
      "http://bibfra.me/vocab/relation/collectionregistrar": { uri: "http://id.loc.gov/vocabulary/relators/cor" },
      "http://bibfra.me/vocab/relation/collector": { uri: "http://id.loc.gov/vocabulary/relators/col" },
      "http://bibfra.me/vocab/relation/collotyper": { uri: "http://id.loc.gov/vocabulary/relators/clt" },
      "http://bibfra.me/vocab/relation/colorist": { uri: "http://id.loc.gov/vocabulary/relators/clr" },
      "http://bibfra.me/vocab/relation/commentator": { uri: "http://id.loc.gov/vocabulary/relators/cmm" },
      "http://bibfra.me/vocab/relation/commentatorforwrittentext": { uri: "http://id.loc.gov/vocabulary/relators/cwt" },
      "http://bibfra.me/vocab/relation/compiler": { uri: "http://id.loc.gov/vocabulary/relators/com" },
      "http://bibfra.me/vocab/relation/complainant": { uri: "http://id.loc.gov/vocabulary/relators/cpl" },
      "http://bibfra.me/vocab/relation/complainant-appellant": { uri: "http://id.loc.gov/vocabulary/relators/cpt" },
      "http://bibfra.me/vocab/relation/complainant-appellee": { uri: "http://id.loc.gov/vocabulary/relators/cpe" },
      "http://bibfra.me/vocab/relation/composer": { uri: "http://id.loc.gov/vocabulary/relators/cmp" },
      "http://bibfra.me/vocab/relation/compositor": { uri: "http://id.loc.gov/vocabulary/relators/cmt" },
      "http://bibfra.me/vocab/relation/conceptor": { uri: "http://id.loc.gov/vocabulary/relators/ccp" },
      "http://bibfra.me/vocab/relation/conductor": { uri: "http://id.loc.gov/vocabulary/relators/cnd" },
      "http://bibfra.me/vocab/relation/conservator": { uri: "http://id.loc.gov/vocabulary/relators/con" },
      "http://bibfra.me/vocab/relation/consultant": { uri: "http://id.loc.gov/vocabulary/relators/csl" },
      "http://bibfra.me/vocab/relation/consultanttoaproject": { uri: "http://id.loc.gov/vocabulary/relators/csp" },
      "http://bibfra.me/vocab/relation/contestant": { uri: "http://id.loc.gov/vocabulary/relators/cos" },
      "http://bibfra.me/vocab/relation/contestant-appellant": { uri: "http://id.loc.gov/vocabulary/relators/cot" },
      "http://bibfra.me/vocab/relation/contestant-appellee": { uri: "http://id.loc.gov/vocabulary/relators/cte" },
      // 'http://bibfra.me/vocab/relation/contestant-appellee': { uri: 'http://id.loc.gov/vocabulary/relators/coe' }, // TODO: update the mapping
      "http://bibfra.me/vocab/relation/contestee": { uri: "http://id.loc.gov/vocabulary/relators/cts" },
      "http://bibfra.me/vocab/relation/curator": { uri: "http://id.loc.gov/vocabulary/relators/cur" },
      "http://bibfra.me/vocab/relation/contestee-appellant": { uri: "http://id.loc.gov/vocabulary/relators/ctt" },
      "http://bibfra.me/vocab/relation/contractor": { uri: "http://id.loc.gov/vocabulary/relators/ctr" },
      "http://bibfra.me/vocab/relation/costumedesigner": { uri: "http://id.loc.gov/vocabulary/relators/cst" },
      "http://bibfra.me/vocab/relation/courtreporter": { uri: "http://id.loc.gov/vocabulary/relators/crt" },
      "http://bibfra.me/vocab/relation/coverdesigner": { uri: "http://id.loc.gov/vocabulary/relators/cov" },
      "http://bibfra.me/vocab/relation/corrector": { uri: "http://id.loc.gov/vocabulary/relators/crr" },
      "http://bibfra.me/vocab/relation/correspondent": { uri: "http://id.loc.gov/vocabulary/relators/crp" },
      "http://bibfra.me/vocab/relation/courtgoverned": { uri: "http://id.loc.gov/vocabulary/relators/cou" },
      "http://bibfra.me/vocab/relation/copyrightholder": { uri: "http://id.loc.gov/vocabulary/relators/cph" },
      "http://bibfra.me/vocab/relation/copyrightclaimant": { uri: "http://id.loc.gov/vocabulary/relators/cpc" },
      "http://bibfra.me/vocab/relation/distributionplace": { uri: "http://id.loc.gov/vocabulary/relators/dbp" },
      "http://bibfra.me/vocab/relation/defendant": { uri: "http://id.loc.gov/vocabulary/relators/dfd" },
      "http://bibfra.me/vocab/relation/defendant-appellee": { uri: "http://id.loc.gov/vocabulary/relators/dfe" },
      "http://bibfra.me/vocab/relation/defendant-appellant": { uri: "http://id.loc.gov/vocabulary/relators/dft" },
      "http://bibfra.me/vocab/relation/degreegrantinginstitution": { uri: "http://id.loc.gov/vocabulary/relators/dgg" },
      "http://bibfra.me/vocab/relation/degreecommitteemember": { uri: "http://id.loc.gov/vocabulary/relators/dgc" },
      "http://bibfra.me/vocab/relation/degreesupervisor": { uri: "http://id.loc.gov/vocabulary/relators/dgs" },
      "http://bibfra.me/vocab/relation/dissertant": { uri: "http://id.loc.gov/vocabulary/relators/dis" },
      "http://bibfra.me/vocab/relation/delineator": { uri: "http://id.loc.gov/vocabulary/relators/dln" },
      "http://bibfra.me/vocab/relation/dancer": { uri: "http://id.loc.gov/vocabulary/relators/dnc" },
      "http://bibfra.me/vocab/relation/donor": { uri: "http://id.loc.gov/vocabulary/relators/dnr" },
      "http://bibfra.me/vocab/relation/depicted": { uri: "http://id.loc.gov/vocabulary/relators/dpc" },
      "http://bibfra.me/vocab/relation/dpt": { uri: "http://id.loc.gov/vocabulary/relators/dpt" },
      "http://bibfra.me/vocab/relation/draftsman": { uri: "http://id.loc.gov/vocabulary/relators/drm" },
      "http://bibfra.me/vocab/relation/director": { uri: "http://id.loc.gov/vocabulary/relators/drt" },
      "http://bibfra.me/vocab/relation/designer": { uri: "http://id.loc.gov/vocabulary/relators/dsr" },
      "http://bibfra.me/vocab/relation/distributor": { uri: "http://id.loc.gov/vocabulary/relators/dst" },
      "http://bibfra.me/vocab/relation/datacontributor": { uri: "http://id.loc.gov/vocabulary/relators/dtc" },
      "http://bibfra.me/vocab/relation/dedicatee": { uri: "http://id.loc.gov/vocabulary/relators/dte" },
      "http://bibfra.me/vocab/relation/datamanager": { uri: "http://id.loc.gov/vocabulary/relators/dtm" },
      "http://bibfra.me/vocab/relation/dedicator": { uri: "http://id.loc.gov/vocabulary/relators/dto" },
      "http://bibfra.me/vocab/relation/dubiousauthor": { uri: "http://id.loc.gov/vocabulary/relators/dub" },
      "http://bibfra.me/vocab/relation/editorofcompilation": { uri: "http://id.loc.gov/vocabulary/relators/edc" },
      "http://bibfra.me/vocab/relation/editorofmovingimagework": { uri: "http://id.loc.gov/vocabulary/relators/edm" },
      "http://bibfra.me/vocab/relation/editor": { uri: "http://id.loc.gov/vocabulary/relators/edt" },
      "http://bibfra.me/vocab/relation/engraver": { uri: "http://id.loc.gov/vocabulary/relators/egr" },
      "http://bibfra.me/vocab/relation/electrician": { uri: "http://id.loc.gov/vocabulary/relators/elg" },
      "http://bibfra.me/vocab/relation/engineer": { uri: "http://id.loc.gov/vocabulary/relators/eng" },
      "http://bibfra.me/vocab/relation/electrotyper": { uri: "http://id.loc.gov/vocabulary/relators/elt" },
      "http://bibfra.me/vocab/relation/enactingjurisdiction": { uri: "http://id.loc.gov/vocabulary/relators/enj" },
      "http://bibfra.me/vocab/relation/etcher": { uri: "http://id.loc.gov/vocabulary/relators/etr" },
      "http://bibfra.me/vocab/relation/eventplace": { uri: "http://id.loc.gov/vocabulary/relators/evp" },
      "http://bibfra.me/vocab/relation/expert": { uri: "http://id.loc.gov/vocabulary/relators/exp" },
      "http://bibfra.me/vocab/relation/facsimilist": { uri: "http://id.loc.gov/vocabulary/relators/fac" },
      "http://bibfra.me/vocab/relation/filmdistributor": { uri: "http://id.loc.gov/vocabulary/relators/fds" },
      "http://bibfra.me/vocab/relation/fielddirector": { uri: "http://id.loc.gov/vocabulary/relators/fld" },
      "http://bibfra.me/vocab/relation/filmeditor": { uri: "http://id.loc.gov/vocabulary/relators/flm" },
      "http://bibfra.me/vocab/relation/filmdirector": { uri: "http://id.loc.gov/vocabulary/relators/fmd" },
      "http://bibfra.me/vocab/relation/filmmaker": { uri: "http://id.loc.gov/vocabulary/relators/fmk" },
      "http://bibfra.me/vocab/relation/formerowner": { uri: "http://id.loc.gov/vocabulary/relators/fmo" },
      "http://bibfra.me/vocab/relation/filmproducer": { uri: "http://id.loc.gov/vocabulary/relators/fmp" },
      "http://bibfra.me/vocab/relation/funder": { uri: "http://id.loc.gov/vocabulary/relators/fnd" },
      "http://bibfra.me/vocab/relation/firstparty": { uri: "http://id.loc.gov/vocabulary/relators/fpy" },
      "http://bibfra.me/vocab/relation/forger": { uri: "http://id.loc.gov/vocabulary/relators/frg" },
      "http://bibfra.me/vocab/relation/geographicinformationspecialist": {
        uri: "http://id.loc.gov/vocabulary/relators/gis"
      },
      "http://bibfra.me/vocab/relation/graphictechnician": { uri: "http://id.loc.gov/vocabulary/relators/grt" },
      "http://bibfra.me/vocab/relation/hostinstitution": { uri: "http://id.loc.gov/vocabulary/relators/his" },
      "http://bibfra.me/vocab/relation/host": { uri: "http://id.loc.gov/vocabulary/relators/hst" },
      "http://bibfra.me/vocab/relation/honoree": { uri: "http://id.loc.gov/vocabulary/relators/hnr" },
      "http://bibfra.me/vocab/relation/illustrator": { uri: "http://id.loc.gov/vocabulary/relators/ill" },
      "http://bibfra.me/vocab/relation/illuminator": { uri: "http://id.loc.gov/vocabulary/relators/ilu" },
      "http://bibfra.me/vocab/relation/inscriber": { uri: "http://id.loc.gov/vocabulary/relators/ins" },
      "http://bibfra.me/vocab/relation/inventor": { uri: "http://id.loc.gov/vocabulary/relators/inv" },
      "http://bibfra.me/vocab/relation/issuingbody": { uri: "http://id.loc.gov/vocabulary/relators/isb" },
      "http://bibfra.me/vocab/relation/instrumentalist": { uri: "http://id.loc.gov/vocabulary/relators/itr" },
      "http://bibfra.me/vocab/relation/interviewee": { uri: "http://id.loc.gov/vocabulary/relators/ive" },
      "http://bibfra.me/vocab/relation/interviewer": { uri: "http://id.loc.gov/vocabulary/relators/ivr" },
      "http://bibfra.me/vocab/relation/judge": { uri: "http://id.loc.gov/vocabulary/relators/jud" },
      "http://bibfra.me/vocab/relation/jurisdictiongoverned": { uri: "http://id.loc.gov/vocabulary/relators/jug" },
      "http://bibfra.me/vocab/relation/laboratory": { uri: "http://id.loc.gov/vocabulary/relators/lbr" },
      "http://bibfra.me/vocab/relation/librettist": { uri: "http://id.loc.gov/vocabulary/relators/lbt" },
      "http://bibfra.me/vocab/relation/labdirector": { uri: "http://id.loc.gov/vocabulary/relators/ldr" },
      "http://bibfra.me/vocab/relation/lead": { uri: "http://id.loc.gov/vocabulary/relators/led" },
      "http://bibfra.me/vocab/relation/libelant-appellee": { uri: "http://id.loc.gov/vocabulary/relators/lee" },
      "http://bibfra.me/vocab/relation/libelee": { uri: "http://id.loc.gov/vocabulary/relators/lel" },
      "http://bibfra.me/vocab/relation/lender": { uri: "http://id.loc.gov/vocabulary/relators/len" },
      "http://bibfra.me/vocab/relation/libelant-appellant": { uri: "http://id.loc.gov/vocabulary/relators/let" },
      "http://bibfra.me/vocab/relation/lightingdesigner": { uri: "http://id.loc.gov/vocabulary/relators/lgd" },
      "http://bibfra.me/vocab/relation/libelee-appellee": { uri: "http://id.loc.gov/vocabulary/relators/lie" },
      "http://bibfra.me/vocab/relation/libelant": { uri: "http://id.loc.gov/vocabulary/relators/lil" },
      "http://bibfra.me/vocab/relation/libelee-appellant": { uri: "http://id.loc.gov/vocabulary/relators/lit" },
      "http://bibfra.me/vocab/relation/landscapearchitect": { uri: "http://id.loc.gov/vocabulary/relators/lsa" },
      "http://bibfra.me/vocab/relation/licensee": { uri: "http://id.loc.gov/vocabulary/relators/lse" },
      "http://bibfra.me/vocab/relation/licensor": { uri: "http://id.loc.gov/vocabulary/relators/lso" },
      "http://bibfra.me/vocab/relation/lithographer": { uri: "http://id.loc.gov/vocabulary/relators/ltg" },
      "http://bibfra.me/vocab/relation/lyricist": { uri: "http://id.loc.gov/vocabulary/relators/lyr" },
      "http://bibfra.me/vocab/relation/musiccopyist": { uri: "http://id.loc.gov/vocabulary/relators/mcp" },
      "http://bibfra.me/vocab/relation/metadatacontact": { uri: "http://id.loc.gov/vocabulary/relators/mdc" },
      "http://bibfra.me/vocab/relation/manufactureplace": { uri: "http://id.loc.gov/vocabulary/relators/mfp" },
      "http://bibfra.me/vocab/relation/medium": { uri: "http://id.loc.gov/vocabulary/relators/med" },
      "http://bibfra.me/vocab/relation/manufacturer": { uri: "http://id.loc.gov/vocabulary/relators/mfr" },
      "http://bibfra.me/vocab/relation/moderator": { uri: "http://id.loc.gov/vocabulary/relators/mod" },
      "http://bibfra.me/vocab/relation/marbler": { uri: "http://id.loc.gov/vocabulary/relators/mrb" },
      "http://bibfra.me/vocab/relation/markupeditor": { uri: "http://id.loc.gov/vocabulary/relators/mrk" },
      "http://bibfra.me/vocab/relation/musicaldirector": { uri: "http://id.loc.gov/vocabulary/relators/msd" },
      "http://bibfra.me/vocab/relation/monitor": { uri: "http://id.loc.gov/vocabulary/relators/mon" },
      "http://bibfra.me/vocab/relation/metal-engraver": { uri: "http://id.loc.gov/vocabulary/relators/mte" },
      "http://bibfra.me/vocab/relation/minutetaker": { uri: "http://id.loc.gov/vocabulary/relators/mtk" },
      "http://bibfra.me/vocab/relation/musician": { uri: "http://id.loc.gov/vocabulary/relators/mus" },
      "http://bibfra.me/vocab/relation/narrator": { uri: "http://id.loc.gov/vocabulary/relators/nrt" },
      "http://bibfra.me/vocab/relation/opponent": { uri: "http://id.loc.gov/vocabulary/relators/opn" },
      "http://bibfra.me/vocab/relation/originator": { uri: "http://id.loc.gov/vocabulary/relators/org" },
      "http://bibfra.me/vocab/relation/organizer": { uri: "http://id.loc.gov/vocabulary/relators/orm" },
      "http://bibfra.me/vocab/relation/onscreenpresenter": { uri: "http://id.loc.gov/vocabulary/relators/osp" },
      "http://bibfra.me/vocab/relation/other": { uri: "http://id.loc.gov/vocabulary/relators/oth" },
      "http://bibfra.me/vocab/relation/owner": { uri: "http://id.loc.gov/vocabulary/relators/own" },
      "http://bibfra.me/vocab/relation/panelist": { uri: "http://id.loc.gov/vocabulary/relators/pan" },
      "http://bibfra.me/vocab/relation/patron": { uri: "http://id.loc.gov/vocabulary/relators/pat" },
      "http://bibfra.me/vocab/relation/publishingdirector": { uri: "http://id.loc.gov/vocabulary/relators/pbd" },
      "http://bibfra.me/vocab/relation/publisher": { uri: "http://id.loc.gov/vocabulary/relators/pbl" },
      "http://bibfra.me/vocab/relation/projectdirector": { uri: "http://id.loc.gov/vocabulary/relators/pdr" },
      "http://bibfra.me/vocab/relation/platemaker": { uri: "http://id.loc.gov/vocabulary/relators/plt" },
      "http://bibfra.me/vocab/relation/permittingagency": { uri: "http://id.loc.gov/vocabulary/relators/pma" },
      "http://bibfra.me/vocab/relation/proofreader": { uri: "http://id.loc.gov/vocabulary/relators/pfr" },
      "http://bibfra.me/vocab/relation/photographer": { uri: "http://id.loc.gov/vocabulary/relators/pht" },
      "http://bibfra.me/vocab/relation/productionmanager": { uri: "http://id.loc.gov/vocabulary/relators/pmn" },
      "http://bibfra.me/vocab/relation/printerofplates": { uri: "http://id.loc.gov/vocabulary/relators/pop" },
      "http://bibfra.me/vocab/relation/papermaker": { uri: "http://id.loc.gov/vocabulary/relators/ppm" },
      "http://bibfra.me/vocab/relation/puppeteer": { uri: "http://id.loc.gov/vocabulary/relators/ppt" },
      "http://bibfra.me/vocab/relation/printmaker": { uri: "http://id.loc.gov/vocabulary/relators/prm" },
      "http://bibfra.me/vocab/relation/praeses": { uri: "http://id.loc.gov/vocabulary/relators/pra" },
      "http://bibfra.me/vocab/relation/processcontact": { uri: "http://id.loc.gov/vocabulary/relators/prc" },
      "http://bibfra.me/vocab/relation/productionpersonnel": { uri: "http://id.loc.gov/vocabulary/relators/prd" },
      "http://bibfra.me/vocab/relation/presenter": { uri: "http://id.loc.gov/vocabulary/relators/pre" },
      "http://bibfra.me/vocab/relation/performer": { uri: "http://id.loc.gov/vocabulary/relators/prf" },
      "http://bibfra.me/vocab/relation/programmer": { uri: "http://id.loc.gov/vocabulary/relators/prg" },
      "http://bibfra.me/vocab/relation/productioncompany": { uri: "http://id.loc.gov/vocabulary/relators/prn" },
      "http://bibfra.me/vocab/relation/producer": { uri: "http://id.loc.gov/vocabulary/relators/pro" },
      "http://bibfra.me/vocab/relation/productionplace": { uri: "http://id.loc.gov/vocabulary/relators/prp" },
      "http://bibfra.me/vocab/relation/productiondesigner": { uri: "http://id.loc.gov/vocabulary/relators/prs" },
      "http://bibfra.me/vocab/relation/printer": { uri: "http://id.loc.gov/vocabulary/relators/prt" },
      "http://bibfra.me/vocab/relation/provider": { uri: "http://id.loc.gov/vocabulary/relators/prv" },
      "http://bibfra.me/vocab/relation/patentapplicant": { uri: "http://id.loc.gov/vocabulary/relators/pta" },
      "http://bibfra.me/vocab/relation/plaintiff-appellee": { uri: "http://id.loc.gov/vocabulary/relators/pte" },
      "http://bibfra.me/vocab/relation/plaintiff": { uri: "http://id.loc.gov/vocabulary/relators/ptf" },
      "http://bibfra.me/vocab/relation/patentholder": { uri: "http://id.loc.gov/vocabulary/relators/pth" },
      "http://bibfra.me/vocab/relation/plaintiff-appellant": { uri: "http://id.loc.gov/vocabulary/relators/ptt" },
      "http://bibfra.me/vocab/relation/publicationplace": { uri: "http://id.loc.gov/vocabulary/relators/pup" },
      "http://bibfra.me/vocab/relation/rubricator": { uri: "http://id.loc.gov/vocabulary/relators/rbr" },
      "http://bibfra.me/vocab/relation/recordist": { uri: "http://id.loc.gov/vocabulary/relators/rcd" },
      "http://bibfra.me/vocab/relation/recordingengineer": { uri: "http://id.loc.gov/vocabulary/relators/rce" },
      "http://bibfra.me/vocab/relation/radiodirector": { uri: "http://id.loc.gov/vocabulary/relators/rdd" },
      "http://bibfra.me/vocab/relation/redaktor": { uri: "http://id.loc.gov/vocabulary/relators/red" },
      "http://bibfra.me/vocab/relation/renderer": { uri: "http://id.loc.gov/vocabulary/relators/ren" },
      "http://bibfra.me/vocab/relation/researcher": { uri: "http://id.loc.gov/vocabulary/relators/res" },
      "http://bibfra.me/vocab/relation/reviewer": { uri: "http://id.loc.gov/vocabulary/relators/rev" },
      "http://bibfra.me/vocab/relation/radioproducer": { uri: "http://id.loc.gov/vocabulary/relators/rpc" },
      "http://bibfra.me/vocab/relation/repository": { uri: "http://id.loc.gov/vocabulary/relators/rps" },
      "http://bibfra.me/vocab/relation/reporter": { uri: "http://id.loc.gov/vocabulary/relators/rpt" },
      "http://bibfra.me/vocab/relation/responsibleparty": { uri: "http://id.loc.gov/vocabulary/relators/rpy" },
      "http://bibfra.me/vocab/relation/respondent-appellee": { uri: "http://id.loc.gov/vocabulary/relators/rse" },
      "http://bibfra.me/vocab/relation/restager": { uri: "http://id.loc.gov/vocabulary/relators/rsg" },
      "http://bibfra.me/vocab/relation/respondent": { uri: "http://id.loc.gov/vocabulary/relators/rsp" },
      "http://bibfra.me/vocab/relation/restorationist": { uri: "http://id.loc.gov/vocabulary/relators/rsr" },
      "http://bibfra.me/vocab/relation/respondent-appellant": { uri: "http://id.loc.gov/vocabulary/relators/rst" },
      "http://bibfra.me/vocab/relation/researchteamhead": { uri: "http://id.loc.gov/vocabulary/relators/rth" },
      "http://bibfra.me/vocab/relation/researchteammember": { uri: "http://id.loc.gov/vocabulary/relators/rtm" },
      "http://bibfra.me/vocab/relation/scientificadvisor": { uri: "http://id.loc.gov/vocabulary/relators/sad" },
      "http://bibfra.me/vocab/relation/scenarist": { uri: "http://id.loc.gov/vocabulary/relators/sce" },
      "http://bibfra.me/vocab/relation/sculptor": { uri: "http://id.loc.gov/vocabulary/relators/scl" },
      "http://bibfra.me/vocab/relation/scribe": { uri: "http://id.loc.gov/vocabulary/relators/scr" },
      "http://bibfra.me/vocab/relation/sounddesigner": { uri: "http://id.loc.gov/vocabulary/relators/sds" },
      "http://bibfra.me/vocab/relation/secretary": { uri: "http://id.loc.gov/vocabulary/relators/sec" },
      "http://bibfra.me/vocab/relation/stagedirector": { uri: "http://id.loc.gov/vocabulary/relators/sgd" },
      "http://bibfra.me/vocab/relation/signer": { uri: "http://id.loc.gov/vocabulary/relators/sgn" },
      "http://bibfra.me/vocab/relation/supportinghost": { uri: "http://id.loc.gov/vocabulary/relators/sht" },
      "http://bibfra.me/vocab/relation/screenwriter": { uri: "http://id.loc.gov/vocabulary/relators/aus" },
      "http://bibfra.me/vocab/relation/seller": { uri: "http://id.loc.gov/vocabulary/relators/sll" },
      "http://bibfra.me/vocab/relation/singer": { uri: "http://id.loc.gov/vocabulary/relators/sng" },
      "http://bibfra.me/vocab/relation/speaker": { uri: "http://id.loc.gov/vocabulary/relators/spk" },
      "http://bibfra.me/vocab/relation/sponsor": { uri: "http://id.loc.gov/vocabulary/relators/spn" },
      "http://bibfra.me/vocab/relation/secondparty": { uri: "http://id.loc.gov/vocabulary/relators/spy" },
      "http://bibfra.me/vocab/relation/surveyor": { uri: "http://id.loc.gov/vocabulary/relators/srv" },
      "http://bibfra.me/vocab/relation/setdesigner": { uri: "http://id.loc.gov/vocabulary/relators/std" },
      "http://bibfra.me/vocab/relation/setting": { uri: "http://id.loc.gov/vocabulary/relators/stg" },
      "http://bibfra.me/vocab/relation/storyteller": { uri: "http://id.loc.gov/vocabulary/relators/stl" },
      "http://bibfra.me/vocab/relation/stagemanager": { uri: "http://id.loc.gov/vocabulary/relators/stm" },
      "http://bibfra.me/vocab/relation/standardsbody": { uri: "http://id.loc.gov/vocabulary/relators/stn" },
      "http://bibfra.me/vocab/relation/stereotyper": { uri: "http://id.loc.gov/vocabulary/relators/str" },
      "http://bibfra.me/vocab/relation/technicaldirector": { uri: "http://id.loc.gov/vocabulary/relators/tcd" },
      "http://bibfra.me/vocab/relation/teacher": { uri: "http://id.loc.gov/vocabulary/relators/tch" },
      "http://bibfra.me/vocab/relation/thesisadvisor": { uri: "http://id.loc.gov/vocabulary/relators/ths" },
      "http://bibfra.me/vocab/relation/televisiondirector": { uri: "http://id.loc.gov/vocabulary/relators/tld" },
      "http://bibfra.me/vocab/relation/televisionproducer": { uri: "http://id.loc.gov/vocabulary/relators/tlp" },
      "http://bibfra.me/vocab/relation/transcriber": { uri: "http://id.loc.gov/vocabulary/relators/trc" },
      "http://bibfra.me/vocab/relation/translator": { uri: "http://id.loc.gov/vocabulary/relators/trl" },
      "http://bibfra.me/vocab/relation/typedesigner": { uri: "http://id.loc.gov/vocabulary/relators/tyd" },
      "http://bibfra.me/vocab/relation/typographer": { uri: "http://id.loc.gov/vocabulary/relators/tyg" },
      "http://bibfra.me/vocab/relation/universityplace": { uri: "http://id.loc.gov/vocabulary/relators/uvp" },
      "http://bibfra.me/vocab/relation/voiceactor": { uri: "http://id.loc.gov/vocabulary/relators/vac" },
      "http://bibfra.me/vocab/relation/videographer": { uri: "http://id.loc.gov/vocabulary/relators/vdg" },
      "http://bibfra.me/vocab/relation/vocalist": { uri: "http://id.loc.gov/vocabulary/relators/voc" },
      "http://bibfra.me/vocab/relation/writerofaddedcommentary": { uri: "http://id.loc.gov/vocabulary/relators/wac" },
      "http://bibfra.me/vocab/relation/writerofaddedlyrics": { uri: "http://id.loc.gov/vocabulary/relators/wal" },
      "http://bibfra.me/vocab/relation/writerofaccompanyingmaterial": {
        uri: "http://id.loc.gov/vocabulary/relators/wam"
      },
      "http://bibfra.me/vocab/relation/writerofaddedtext": { uri: "http://id.loc.gov/vocabulary/relators/wat" },
      "http://bibfra.me/vocab/relation/woodcutter": { uri: "http://id.loc.gov/vocabulary/relators/wdc" },
      "http://bibfra.me/vocab/relation/woodengraver": { uri: "http://id.loc.gov/vocabulary/relators/wde" },
      "http://bibfra.me/vocab/relation/writerofintroduction": { uri: "http://id.loc.gov/vocabulary/relators/win" },
      "http://bibfra.me/vocab/relation/witness": { uri: "http://id.loc.gov/vocabulary/relators/wit" },
      "http://bibfra.me/vocab/relation/writerofpreface": { uri: "http://id.loc.gov/vocabulary/relators/wpr" },
      "http://bibfra.me/vocab/relation/writerofsupplementarytextualcontent": {
        uri: "http://id.loc.gov/vocabulary/relators/wst"
      }
    }
  }
}, Xy = {
  [Le.INSTANCE]: {
    [Le.INSTANCE]: {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Instance" }
    },
    "http://bibfra.me/vocab/marc/title": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/title" },
      options: {
        "http://bibfra.me/vocab/marc/Title": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Title" },
        "http://bibfra.me/vocab/marc/VariantTitle": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/VariantTitle" },
        "http://bibfra.me/vocab/marc/ParallelTitle": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/ParallelTitle" }
      },
      fields: {
        "http://bibfra.me/vocab/bflc/nonSortNum": { bf2Uri: "http://id.loc.gov/ontologies/bflc/nonSortNum" },
        "http://bibfra.me/vocab/marc/mainTitle": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/mainTitle" },
        "http://bibfra.me/vocab/marc/partNumber": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/partNumber" },
        "http://bibfra.me/vocab/marc/partName": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/partName" },
        "http://bibfra.me/vocab/marc/subTitle": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/subtitle" },
        "http://bibfra.me/vocab/marc/variantType": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/variantType" },
        "http://bibfra.me/vocab/lite/note": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/note" }
      }
    },
    "http://bibfra.me/vocab/marc/statementOfResponsibility": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/responsibilityStatement" }
    },
    "http://bibfra.me/vocab/marc/edition": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/editionStatement" }
    },
    "https://bibfra.me/vocab/marc/provisionActivity": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/provisionActivity" },
      options: {
        "http://bibfra.me/vocab/marc/production": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Production" },
        "http://bibfra.me/vocab/marc/publication": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Publication" },
        "http://bibfra.me/vocab/marc/distribution": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Distribution" },
        "http://bibfra.me/vocab/marc/manufacture": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Manufacture" }
      },
      fields: {
        "http://bibfra.me/vocab/lite/providerDate": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/date" },
        "http://bibfra.me/vocab/lite/providerPlace": {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/place",
          label: Le.LABEL
        },
        "http://bibfra.me/vocab/lite/place": { bf2Uri: "http://id.loc.gov/ontologies/bflc/simplePlace" },
        "http://bibfra.me/vocab/lite/name": { bf2Uri: "http://id.loc.gov/ontologies/bflc/simpleAgent" },
        "http://bibfra.me/vocab/lite/date": { bf2Uri: "http://id.loc.gov/ontologies/bflc/simpleDate" }
      }
    },
    "http://bibfra.me/vocab/marc/issuance": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/issuance" },
      fields: {
        "http://bibfra.me/vocab/marc/issuance": {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/issuance",
          label: Le.LABEL
        }
      }
    },
    "http://bibfra.me/vocab/marc/copyright": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/copyrightDate" }
    },
    "http://library.link/vocab/map": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/identifiedBy" },
      options: {
        "http://library.link/identifier/LCCN": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Lccn" },
        "http://library.link/identifier/ISBN": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Isbn" },
        "http://library.link/identifier/UNKNOWN": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Identifier" },
        "http://bibfra.me/vocab/lite/LocalId": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Local" },
        "http://bibfra.me/vocab/identifier/Ean": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Ean" }
      },
      fields: {
        "http://bibfra.me/vocab/lite/name": { bf2Uri: "http://www.w3.org/1999/02/22-rdf-syntax-ns#value" },
        "http://bibfra.me/vocab/marc/status": {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/status",
          label: Le.LABEL
        },
        "http://bibfra.me/vocab/marc/qualifier": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/qualifier" },
        "http://bibfra.me/vocab/marc/localId": { bf2Uri: "http://www.w3.org/1999/02/22-rdf-syntax-ns#value" },
        "http://bibfra.me/vocab/marc/localIdAssigningSource": {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/assigner"
        },
        "http://bibfra.me/vocab/marc/ean": { bf2Uri: "http://www.w3.org/1999/02/22-rdf-syntax-ns#value" }
      }
    },
    "http://bibfra.me/vocab/marc/supplementaryContent": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/supplementaryContent" },
      fields: {
        "http://bibfra.me/vocab/lite/name": { bf2Uri: "http://www.w3.org/2000/01/rdf-schema#label" },
        "http://www.w3.org/1999/02/22-rdf-syntax-ns#value": { bf2Uri: "http://bibfra.me/vocab/lite/link" }
      }
    },
    [Yu[Le.NOTE].container]: {
      container: { bf2Uri: yo.NOTE },
      fields: {
        value: { bf2Uri: "http://www.w3.org/2000/01/rdf-schema#label" },
        type: {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/noteType",
          label: Le.LABEL
        }
      }
    },
    "http://bibfra.me/vocab/marc/media": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/media" },
      fields: {
        "http://bibfra.me/vocab/marc/media": {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/dimensions",
          label: Le.TERM
        }
      }
    },
    "http://bibfra.me/vocab/marc/dimensions": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/dimensions" }
    },
    "http://bibfra.me/vocab/marc/carrier": {
      container: {
        bf2Uri: "http://id.loc.gov/ontologies/bibframe/carrier",
        label: Le.TERM
      },
      fields: {
        "http://bibfra.me/vocab/marc/carrier": {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/carrier",
          label: Le.TERM
        }
      }
    },
    "http://bibfra.me/vocab/marc/accessLocation": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/electronicLocator" },
      fields: {
        "http://bibfra.me/vocab/lite/link": { bf2Uri: "http://www.w3.org/1999/02/22-rdf-syntax-ns#value" },
        "http://bibfra.me/vocab/lite/note": { bf2Uri: "http://www.w3.org/2000/01/rdf-schema#label" }
      }
    },
    "http://bibfra.me/vocab/lite/extent": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/extent" },
      fields: {
        _extent: { bf2Uri: "http://www.w3.org/2000/01/rdf-schema#label" }
      }
    }
  },
  [Le.WORK]: {
    _creatorReference: {
      container: {
        bf2Uri: "http://id.loc.gov/ontologies/bibframe/contribution",
        dataTypeUri: "http://id.loc.gov/ontologies/bflc/PrimaryContribution"
      },
      options: {
        "http://bibfra.me/vocab/lite/Person": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Person" },
        "http://bibfra.me/vocab/lite/Family": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Family" },
        "http://bibfra.me/vocab/lite/Organization": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Organization" },
        "http://bibfra.me/vocab/lite/Meeting": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Meeting" },
        "http://bibfra.me/vocab/lite/Jurisdiction": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Jurisdiction" }
      },
      fields: {
        label: { bf2Uri: "http://www.w3.org/2002/07/owl#sameAs" },
        roles: {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/role",
          label: Le.LABEL
        }
      }
    },
    "http://bibfra.me/vocab/marc/title": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/title" },
      options: {
        "http://bibfra.me/vocab/marc/Title": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Title" },
        "http://bibfra.me/vocab/marc/VariantTitle": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/VariantTitle" },
        "http://bibfra.me/vocab/marc/ParallelTitle": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/ParallelTitle" }
      },
      fields: {
        "http://bibfra.me/vocab/bflc/nonSortNum": { bf2Uri: "http://id.loc.gov/ontologies/bflc/nonSortNum" },
        "http://bibfra.me/vocab/marc/mainTitle": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/mainTitle" },
        "http://bibfra.me/vocab/marc/partNumber": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/partNumber" },
        "http://bibfra.me/vocab/marc/partName": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/partName" },
        "http://bibfra.me/vocab/marc/subTitle": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/subtitle" },
        "http://bibfra.me/vocab/lite/date": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/date" },
        "http://bibfra.me/vocab/marc/variantType": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/variantType" },
        "http://bibfra.me/vocab/lite/note": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/note" }
      }
    },
    "http://bibfra.me/vocab/marc/governmentPublication": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bflc/governmentPubType", label: Le.TERM },
      fields: {
        "http://bibfra.me/vocab/marc/governmentPublication": {
          bf2Uri: "http://id.loc.gov/ontologies/bflc/governmentPubType",
          label: Le.TERM
        }
      }
    },
    "http://bibfra.me/vocab/lite/dateStart": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/originDate" },
      fields: {
        "http://bibfra.me/vocab/lite/dateStart": {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/originDate"
        }
      }
    },
    "http://bibfra.me/vocab/marc/originPlace": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/originPlace" },
      fields: {
        "http://bibfra.me/vocab/marc/originPlace": {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/originPlace",
          label: Le.NAME
        }
      }
    },
    _geographicCoverageReference: {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/geographicCoverage" },
      fields: {
        label: {
          bf2Uri: "http://www.w3.org/2002/07/owl#sameAs"
        }
      }
    },
    "http://bibfra.me/vocab/marc/targetAudience": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/intendedAudience" },
      fields: {
        "http://bibfra.me/vocab/marc/targetAudience": {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/intendedAudience",
          label: Le.TERM
        }
      }
    },
    _contributorReference: {
      container: {
        bf2Uri: "http://id.loc.gov/ontologies/bibframe/contribution",
        dataTypeUri: "http://id.loc.gov/ontologies/bibframe/Contribution"
      },
      options: {
        "http://bibfra.me/vocab/lite/Person": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Person" },
        "http://bibfra.me/vocab/lite/Family": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Family" },
        "http://bibfra.me/vocab/lite/Organization": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Organization" },
        "http://bibfra.me/vocab/lite/Meeting": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Meeting" },
        "http://bibfra.me/vocab/lite/Jurisdiction": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/Jurisdiction" }
      },
      fields: {
        label: { bf2Uri: "http://www.w3.org/2002/07/owl#sameAs" },
        roles: {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/role",
          label: Le.LABEL
        }
      }
    },
    [Yu[Le.NOTE].container]: {
      container: { bf2Uri: yo.NOTE },
      fields: {
        value: { bf2Uri: "http://www.w3.org/2000/01/rdf-schema#label" },
        type: {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/noteType",
          label: Le.LABEL
        }
      }
    },
    "http://bibfra.me/vocab/lite/language": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/language" },
      fields: {
        _language: {
          bf2Uri: "http://www.w3.org/2002/07/owl#sameAs",
          label: Le.TERM
        }
      }
    },
    "http://bibfra.me/vocab/marc/content": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/content" },
      fields: {
        "http://bibfra.me/vocab/marc/content": {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/content",
          label: Le.TERM
        }
      }
    },
    "http://bibfra.me/vocab/marc/summary": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/summary" },
      fields: {
        _notes: { bf2Uri: "http://www.w3.org/2000/01/rdf-schema#label" }
      }
    },
    "http://bibfra.me/vocab/marc/tableOfContents": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/tableOfContents" },
      fields: {
        _notes: { bf2Uri: "http://www.w3.org/2000/01/rdf-schema#label" }
      }
    },
    "http://bibfra.me/vocab/lite/subject": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/subject" },
      fields: {
        label: { bf2Uri: "http://www.loc.gov/mads/rdf/v1#Topic" }
      }
    },
    "http://bibfra.me/vocab/lite/classification": {
      container: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/classification" },
      options: {
        ddc: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/ClassificationDdc" },
        lc: { bf2Uri: "http://id.loc.gov/ontologies/bibframe/ClassificationLcc" }
      },
      fields: {
        "http://bibfra.me/vocab/marc/code": {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/classificationPortion"
        },
        "http://bibfra.me/vocab/marc/itemNumber": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/itemPortion" },
        "http://bibfra.me/vocab/marc/source": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/classification" },
        "http://bibfra.me/vocab/marc/edition": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/edition" },
        "http://bibfra.me/vocab/marc/editionNumber": { bf2Uri: "http://id.loc.gov/ontologies/bibframe/code" },
        "http://bibfra.me/vocab/marc/status": {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/status",
          label: Le.LABEL
        },
        _assigningSourceReference: {
          bf2Uri: "http://id.loc.gov/ontologies/bibframe/assigner"
        }
      }
    }
  }
}, E2 = {
  [Yu[Le.NOTE].container]: {
    field: um[yo.NOTE].field,
    data: um[yo.NOTE].data
  },
  _creatorReference: {
    field: "",
    data: {},
    fields: {
      [Yu[Le.CREATOR].container]: {
        field: um[yo.CONTRIBUTION].field,
        data: um[yo.CONTRIBUTION].data
      }
    }
  },
  _contributorReference: {
    field: "",
    data: {},
    fields: {
      [Yu[Le.CONTRIBUTOR].container]: {
        field: um[yo.CONTRIBUTION].field,
        data: um[yo.CONTRIBUTION].data
      }
    }
  }
}, UB = {
  [Yu[Le.NOTE].container]: { value: Le.NOTE }
}, S2 = {
  "lc:RT:bf2:Monograph:Work": "Work",
  "lc:RT:bf2:Monograph:Instance": "Instance"
}, VB = {
  MONOGRAPH: "BIBFRAME 2.0 Monograph"
}, Xu = {
  MONOGRAPH: "lc:profile:bf2:Monograph",
  WORK: "lc:RT:bf2:Monograph:Work",
  INSTANCE: "lc:RT:bf2:Monograph:Instance"
}, x2 = {
  INSTANCE: "http://bibfra.me/vocab/lite/Instance",
  WORK: "http://bibfra.me/vocab/lite/Work"
}, KN = {
  repeatable: !1,
  editable: !0,
  mandatory: !1,
  defaults: [],
  useValuesFrom: [],
  valueDataType: {
    dataTypeURI: ""
  }
}, gm = 2, HB = gm + 1, jB = 4, dO = 1, GB = [
  "http://bibfra.me/vocab/marc/Title",
  "http://bibfra.me/vocab/marc/ParralelTitle",
  "http://bibfra.me/vocab/marc/VariantTitle"
], zB = [
  "http://id.loc.gov/ontologies/bibframe/provisionActivity",
  "http://id.loc.gov/ontologies/bibframe/summary",
  "http://id.loc.gov/ontologies/bibframe/tableOfContents"
], WB = ["http://bibfra.me/vocab/marc/issuance"], XB = [
  "http://id.loc.gov/ontologies/bibframe/electronicLocator",
  "http://id.loc.gov/ontologies/bibframe/supplementaryContent"
], YB = [
  "http://id.loc.gov/ontologies/bibframe/Summary",
  "http://id.loc.gov/ontologies/bibframe/Language",
  "http://id.loc.gov/ontologies/bibframe/TableOfContents",
  "http://id.loc.gov/ontologies/bibframe/agent",
  "http://www.loc.gov/mads/rdf/v1#Topic"
], $B = ["http://bibfra.me/vocab/lite/subject"], ZB = {
  "http://www.loc.gov/mads/rdf/v1#Topic": "http://bibfra.me/vocab/lite/subject"
}, JB = ["http://id.loc.gov/ontologies/bibframe/agent"], qN = {
  "http://id.loc.gov/ontologies/bibframe/contribution": {
    "http://id.loc.gov/ontologies/bibframe/Contribution": "http://bibfra.me/vocab/lite/contributor",
    "http://id.loc.gov/ontologies/bflc/PrimaryContribution": "http://bibfra.me/vocab/lite/creator"
  }
}, pO = [
  "http://bibfra.me/vocab/lite/contributor",
  "http://bibfra.me/vocab/lite/creator"
], QB = [
  "http://bibfra.me/vocab/lite/Person",
  "http://bibfra.me/vocab/lite/Family",
  "http://bibfra.me/vocab/lite/Organization",
  "http://bibfra.me/vocab/lite/Meeting",
  "http://bibfra.me/vocab/lite/Jurisdiction"
], KB = {
  "http://id.loc.gov/ontologies/bibframe/ClassificationDdc": {
    field: Le.SOURCE,
    value: "ddc"
  },
  "http://id.loc.gov/ontologies/bibframe/ClassificationLcc": {
    field: Le.SOURCE,
    value: "lc"
  }
}, qB = "http://id.loc.gov/", hO = 2, e6 = 2, t6 = hO + 1, n6 = [
  "http://bibfra.me/vocab/marc/production",
  "http://bibfra.me/vocab/marc/publication",
  "http://bibfra.me/vocab/marc/distribution",
  "http://bibfra.me/vocab/marc/manufacture"
], XR = {
  HAS_INSTANCE: "http://id.loc.gov/ontologies/bibframe/hasInstance",
  INSTANCE_OF: "http://id.loc.gov/ontologies/bibframe/instanceOf",
  HAS_ITEM: "http://id.loc.gov/ontologies/bibframe/hasItem"
}, r6 = ":", a6 = "$$", i6 = "/", o6 = "__", l6 = "::", s6 = "--", u6 = "$$", vO = !0, c6 = !1, e_ = !0, mO = () => {
  const t = Ju(), [r, i] = k.useState(Va.SEARCH.uri), { SearchBy: u, Query: c, Offset: v } = Wo;
  return k.useEffect(() => {
    const { state: h } = t, y = h == null ? void 0 : h[u], g = h == null ? void 0 : h[c], S = h == null ? void 0 : h[v], x = Va.SEARCH.uri;
    if (!h || !g) {
      i(x);
      return;
    }
    const T = {
      [c]: g
    };
    y && (T[u] = y), S && (T[v] = S), i(`${x}?${new URLSearchParams(T)}`);
  }, [t]), r;
}, fd = () => {
  const t = ym(), { navigationState: r } = Eo();
  return {
    navigateToEditPage: (u, { ...c } = {}) => t(u, { state: { ...r, isNavigatedFromLDE: !0 }, ...c }),
    navigateAsDuplicate: (u) => {
      t(`${Va.RESOURCE_CREATE.uri}?${Mi.CloneOf}=${u}`, { state: r });
    }
  };
}, f6 = (t) => ({ EDITOR_API_BASE_PATH: "http://localhost:8080", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 })[t];
async function d6({ url: t, requestParams: r, headers: i }) {
  var u;
  try {
    const c = await fetch(t, {
      ...r,
      headers: {
        ...i,
        ...r.headers
      }
    });
    if (!c.ok)
      throw await c.json();
    return c;
  } catch (c) {
    const v = (u = c == null ? void 0 : c.errors) == null ? void 0 : u[0];
    throw v && console.error(`${v == null ? void 0 : v.type}: ${v == null ? void 0 : v.message}`), c;
  }
}
const gO = async ({ url: t, urlParams: r, requestParams: i = {}, sameOrigin: u = !0 }) => {
  const {
    basePath: c = f6(wF),
    tenant: v,
    token: h
  } = m2.deserialize(p2) || {}, y = v && u ? {
    "x-okapi-tenant": v,
    ...h && { "x-okapi-token": h }
  } : void 0, g = r ? `?${new URLSearchParams(r)}` : "";
  return await d6({
    url: `${u ? c : ""}${t}${g}`,
    requestParams: i,
    headers: y
  });
}, p6 = async ({
  url: t,
  urlParams: r,
  requestParams: i = {
    method: "GET"
  }
}) => {
  const u = await gO({ url: t, urlParams: r, requestParams: i });
  return u != null && u.ok ? await u.json() : u;
}, h6 = (t, r) => r ? t.replace(r.name, r.value.toString()) : t, ro = {
  request: gO,
  getJson: p6,
  generateUrl: h6
}, R2 = `${h2}/:recordId`, t_ = async ({ recordId: t, idType: r }) => {
  const i = (r && OF[r]) ?? R2, u = ro.generateUrl(i, { name: ":recordId", value: t });
  return ro.getJson({
    url: u
  });
}, v6 = `${eO}/:recordId/import`, m6 = async ({ recordId: t }) => {
  const r = ro.generateUrl(v6, { name: ":recordId", value: t }), i = await ro.request({
    url: r,
    requestParams: {
      method: "POST"
    }
  });
  return await (i == null ? void 0 : i.json());
}, g6 = `${h2}/:recordId/marc`, b6 = async ({ recordId: t, endpointUrl: r }) => {
  const i = ro.generateUrl(r ?? g6, {
    name: ":recordId",
    value: t
  });
  return ro.getJson({
    url: i
  });
}, y6 = async (t) => {
  const r = ro.generateUrl(h2);
  return ro.request({
    url: r,
    requestParams: {
      method: "POST",
      body: JSON.stringify(t),
      headers: {
        "content-type": "application/json"
      }
    }
  });
}, C6 = async (t, r) => {
  const i = ro.generateUrl(R2, { name: ":recordId", value: t });
  return ro.request({
    url: i,
    requestParams: {
      method: "PUT",
      body: JSON.stringify(r),
      headers: {
        "content-type": "application/json"
      }
    }
  });
}, E6 = async (t) => {
  const r = ro.generateUrl(R2, { name: ":recordId", value: t });
  return ro.request({
    url: r,
    requestParams: {
      method: "DELETE",
      headers: {
        "content-type": "application/json"
      }
    }
  });
};
let K1;
const S6 = new Uint8Array(16);
function x6() {
  if (!K1 && (K1 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !K1))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return K1(S6);
}
const Go = [];
for (let t = 0; t < 256; ++t)
  Go.push((t + 256).toString(16).slice(1));
function R6(t, r = 0) {
  return Go[t[r + 0]] + Go[t[r + 1]] + Go[t[r + 2]] + Go[t[r + 3]] + "-" + Go[t[r + 4]] + Go[t[r + 5]] + "-" + Go[t[r + 6]] + Go[t[r + 7]] + "-" + Go[t[r + 8]] + Go[t[r + 9]] + "-" + Go[t[r + 10]] + Go[t[r + 11]] + Go[t[r + 12]] + Go[t[r + 13]] + Go[t[r + 14]] + Go[t[r + 15]];
}
const T6 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), n_ = {
  randomUUID: T6
};
function Jc(t, r, i) {
  if (n_.randomUUID && !r && !t)
    return n_.randomUUID();
  t = t || {};
  const u = t.random || (t.rng || x6)();
  if (u[6] = u[6] & 15 | 64, u[8] = u[8] & 63 | 128, r) {
    i = i || 0;
    for (let c = 0; c < 16; ++c)
      r[i + c] = u[c];
    return r;
  }
  return R6(u);
}
class kC {
  constructor(r, i) {
    wn(this, "id");
    wn(this, "type");
    wn(this, "message");
    this.id = Jc(), this.type = r, this.message = i;
  }
}
class w6 extends kC {
  constructor(r) {
    super(Tr.success, r);
  }
}
class I6 extends kC {
  constructor(r) {
    super(Tr.error, r);
  }
}
class A6 extends kC {
  constructor(r) {
    super(Tr.info, r);
  }
}
class N6 extends kC {
  constructor(r) {
    super(Tr.warning, r);
  }
}
const _6 = {
  [Tr.success]: w6,
  [Tr.error]: I6,
  [Tr.info]: A6,
  [Tr.warning]: N6
};
class Ei {
  static createMessage(r, i) {
    return new _6[r](i);
  }
}
const T2 = (t) => {
  const { setIsLoading: r } = qu(), { addStatusMessagesItem: i } = Si();
  return { fetchMarcData: async (c, v) => {
    if (!c)
      return;
    let h;
    try {
      r(!0), h = await b6({ recordId: c, endpointUrl: v }), t(h);
    } catch {
      i == null || i(Ei.createMessage(Tr.error, "ld.cantLoadMarc"));
    } finally {
      r(!1);
    }
    return h;
  } };
}, O6 = (t, r, i) => {
  if (!t || !WR[t])
    return;
  const u = WR[t], c = typeof u;
  if (c === "string")
    return WR[t];
  if (c === "object") {
    let v;
    return i == null || i.forEach((h) => {
      const y = r == null ? void 0 : r.get(h);
      if (!(y != null && y.uri))
        return;
      const g = u, S = y.uri, x = g == null ? void 0 : g[S];
      x && (v = x);
    }), v;
  }
}, YR = ({ uri: t, dataTypeURI: r, schema: i, path: u }) => {
  if (Object.keys(qN).includes(t) && r) {
    const h = qN[t][r];
    return {
      uriBFLite: h,
      uriWithSelector: h
    };
  }
  const c = O6(t, i, u);
  return { uriBFLite: c, uriWithSelector: c ?? t };
}, L6 = (t, r) => t === Va.RESOURCE_CREATE.uri ? r != null && r.get(Mi.CloneOf) ? uC.Duplicate : uC.New : uC.Edit, r_ = (t) => /* @__PURE__ */ k.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M14.6011 9.8998C15.4011 8.7998 15.4011 7.2998 14.6011 6.1998C13.7011 4.8998 11.601 2.7998 8.00096 2.7998C4.40087 2.7998 2.30082 4.8998 1.4008 6.1998C0.600776 7.2998 0.600776 8.7998 1.4008 9.8998C2.30082 11.1998 4.40087 13.2998 8.00096 13.2998C11.601 13.1498 13.7011 11.0498 14.6011 9.8998ZM13.1011 8.7498C12.2011 9.9498 10.601 11.3498 8.00096 11.3498C5.40089 11.3498 3.70085 9.9998 2.90083 8.7998C2.60083 8.2998 2.60083 7.6998 2.90083 7.1998C3.70085 5.9998 5.30089 4.5998 8.00096 4.5998C10.701 4.5998 12.3011 5.9998 13.1011 7.1998C13.5011 7.6998 13.5011 8.2998 13.1011 8.7498Z", fill: "black" }), /* @__PURE__ */ k.createElement("path", { d: "M7.99966 9.89961C9.04902 9.89961 9.8997 9.04895 9.8997 7.99961C9.8997 6.95027 9.04902 6.09961 7.99966 6.09961C6.95029 6.09961 6.09961 6.95027 6.09961 7.99961C6.09961 9.04895 6.95029 9.89961 7.99966 9.89961Z", fill: "black" })), D6 = (t) => /* @__PURE__ */ k.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M13.2506 2H9.85051C9.25049 2 8.95048 2.4 8.95048 2.9C8.95048 3.4 9.35049 3.8 9.85051 3.8H11.0505L5.4504 9.3C5.05039 9.7 5.05039 10.2 5.4504 10.5C5.85041 10.9 6.35042 10.9 6.65043 10.5L12.1506 5V6.2C12.1506 6.7 12.5506 7.1 13.0506 7.1C13.5506 7.1 13.9506 6.7 13.9506 6.2V2.8C13.9506 2.1 13.5506 2 13.2506 2Z", fill: "black" }), /* @__PURE__ */ k.createElement("path", { d: "M11.9495 10.0002C11.4495 10.0002 11.0494 10.4002 11.0494 10.9002V12.3002H3.74926V5.0002H5.1493C5.74931 5.0002 6.04932 4.6002 6.04932 4.1002C6.04932 3.6002 5.74931 3.2002 5.2493 3.2002H2.84924C2.34923 3.2002 1.94922 3.6002 1.94922 4.1002V13.1002C1.94922 13.6002 2.34923 14.0002 2.84924 14.0002H11.8495C12.3495 14.0002 12.7495 13.6002 12.7495 13.1002V10.8002C12.8495 10.3002 12.4495 10.0002 11.9495 10.0002Z", fill: "black" })), bO = (t) => /* @__PURE__ */ k.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("g", { clipPath: "url(#clip0_6557_131186)" }, /* @__PURE__ */ k.createElement("path", { d: "M15.2992 14.3004V6.15039C15.2992 5.55039 14.8992 5.15039 14.2992 5.15039H6.19922C5.59922 5.15039 5.19922 5.55039 5.19922 6.15039V14.3504C5.19922 14.9504 5.59922 15.3504 6.19922 15.3504H14.3992C14.8992 15.2504 15.2992 14.9004 15.2992 14.3004ZM13.2992 13.3004H7.19922V7.15039H13.3992V13.2504L13.2992 13.3004Z", fill: "black" }), /* @__PURE__ */ k.createElement("path", { d: "M2.69922 2.7002H8.89922V3.2002H10.8992V1.7002C10.8992 1.1002 10.4992 0.700195 9.89922 0.700195H1.69922C1.09922 0.700195 0.699219 1.1002 0.699219 1.7002V9.9002C0.699219 10.5002 1.09922 10.9002 1.69922 10.9002H3.19922V8.9002H2.69922V2.7002Z", fill: "black" })), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", { id: "clip0_6557_131186" }, /* @__PURE__ */ k.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const M6 = () => {
  const t = mm(q9), { isLoading: r } = qu(), { currentlyEditedEntityBfid: i } = Qa(), { setRecordStatus: u } = Si(), { setBasicValue: c } = ud(), v = ym(), h = mO(), { resourceId: y } = Cm(), { navigateAsDuplicate: g } = fd(), [S] = qc(), { fetchMarcData: x } = T2(c), { formatMessage: T } = La(), _ = async () => x(y), L = () => y && g(y), M = [
    {
      id: "actions",
      labelId: "ld.actions",
      data: [
        {
          id: "duplicate",
          type: Wu.basic,
          labelId: "ld.duplicate",
          icon: /* @__PURE__ */ N.jsx(bO, {}),
          action: L
        },
        {
          id: "viewLinkedData",
          type: Wu.basic,
          labelId: "ld.viewLinkedData",
          icon: /* @__PURE__ */ N.jsx(r_, {}),
          isDisabled: e_,
          hidden: !0
        },
        {
          id: "viewMarc",
          type: Wu.basic,
          labelId: "ld.viewMarc",
          icon: /* @__PURE__ */ N.jsx(r_, {}),
          hidden: !i.has(Xu.INSTANCE),
          action: _
        },
        {
          id: "viewInInventory",
          type: Wu.basic,
          labelId: "ld.viewInInventory",
          icon: /* @__PURE__ */ N.jsx(D6, {}),
          isDisabled: e_,
          hidden: !0
        }
      ]
    }
  ];
  return /* @__PURE__ */ N.jsxs("div", { className: "nav-block nav-block-fixed-height", children: [
    /* @__PURE__ */ N.jsx("nav", { children: /* @__PURE__ */ N.jsx(
      Dn,
      {
        "data-testid": "nav-close-button",
        type: Mn.Icon,
        onClick: () => {
          u({ type: od.saveAndClose }), v(h);
        },
        className: "nav-close",
        ariaLabel: T({ id: "ld.aria.edit.close" }),
        children: /* @__PURE__ */ N.jsx(qs, {})
      }
    ) }),
    /* @__PURE__ */ N.jsx("div", { className: "heading", children: !r && Array.from(i).map((U) => /* @__PURE__ */ N.jsx(
      mt,
      {
        id: `ld.${L6(t, S)}${S2[U]}`
      },
      U
    )) }),
    t ? /* @__PURE__ */ N.jsx("span", { className: "empty-block" }) : /* @__PURE__ */ N.jsx(C2, { labelId: "ld.actions", items: M, buttonTestId: "edit-control-actions-toggle" })
  ] });
};
var yC = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
yC.exports;
(function(t, r) {
  (function() {
    var i, u = "4.17.21", c = 200, v = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", h = "Expected a function", y = "Invalid `variable` option passed into `_.template`", g = "__lodash_hash_undefined__", S = 500, x = "__lodash_placeholder__", T = 1, _ = 2, L = 4, M = 1, U = 2, B = 1, H = 2, Y = 4, G = 8, Q = 16, W = 32, oe = 64, j = 128, re = 256, me = 512, Se = 30, Ne = "...", Ge = 800, ze = 16, qe = 1, at = 2, st = 3, We = 1 / 0, he = 9007199254740991, ke = 17976931348623157e292, _e = 0 / 0, q = 4294967295, pe = q - 1, $e = q >>> 1, lt = [
      ["ary", j],
      ["bind", B],
      ["bindKey", H],
      ["curry", G],
      ["curryRight", Q],
      ["flip", me],
      ["partial", W],
      ["partialRight", oe],
      ["rearg", re]
    ], ot = "[object Arguments]", nt = "[object Array]", Rt = "[object AsyncFunction]", ht = "[object Boolean]", dt = "[object Date]", sn = "[object DOMException]", bn = "[object Error]", Ze = "[object Function]", mn = "[object GeneratorFunction]", fn = "[object Map]", Gn = "[object Number]", ar = "[object Null]", Jn = "[object Object]", Ha = "[object Promise]", ja = "[object Proxy]", qr = "[object RegExp]", wr = "[object Set]", Da = "[object String]", Sa = "[object Symbol]", xa = "[object Undefined]", Or = "[object WeakMap]", fi = "[object WeakSet]", pr = "[object ArrayBuffer]", xr = "[object DataView]", ca = "[object Float32Array]", Ka = "[object Float64Array]", it = "[object Int8Array]", kt = "[object Int16Array]", $t = "[object Int32Array]", Fn = "[object Uint8Array]", zn = "[object Uint8ClampedArray]", Ur = "[object Uint16Array]", Lr = "[object Uint32Array]", Ga = /\b__p \+= '';/g, Qn = /\b(__p \+=) '' \+/g, qa = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Wn = /&(?:amp|lt|gt|quot|#39);/g, Xn = /[&<>"']/g, So = RegExp(Wn.source), Pi = RegExp(Xn.source), Wl = /<%-([\s\S]+?)%>/g, Xl = /<%([\s\S]+?)%>/g, Xo = /<%=([\s\S]+?)%>/g, ao = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Yl = /^\w*$/, ki = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ne = /[\\^$.*+?()[\]{}|]/g, ce = RegExp(ne.source), xe = /^\s+/, Ue = /\s/, rt = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, _t = /\{\n\/\* \[wrapped with (.+)\] \*/, Vt = /,? & /, J = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ve = /[()=,{}\[\]\/\s]/, be = /\\(\\)?/g, Fe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ut = /\w*$/, bt = /^[-+]0x[0-9a-f]+$/i, Et = /^0b[01]+$/i, Tt = /^\[object .+?Constructor\]$/, Zt = /^0o[0-7]+$/i, nn = /^(?:0|[1-9]\d*)$/, sr = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Wr = /($^)/, Ma = /['\n\r\u2028\u2029\\]/g, hn = "\\ud800-\\udfff", fa = "\\u0300-\\u036f", Ra = "\\ufe20-\\ufe2f", on = "\\u20d0-\\u20ff", ei = fa + Ra + on, io = "\\u2700-\\u27bf", An = "a-z\\xdf-\\xf6\\xf8-\\xff", hr = "\\xac\\xb1\\xd7\\xf7", Ta = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", xl = "\\u2000-\\u206f", Bn = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", xo = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ss = "\\ufe0e\\ufe0f", ec = hr + Ta + xl + Bn, eu = "['’]", tu = "[" + hn + "]", Yo = "[" + ec + "]", ti = "[" + ei + "]", xs = "\\d+", nu = "[" + io + "]", Rs = "[" + An + "]", tc = "[^" + hn + ec + xs + io + An + xo + "]", ru = "\\ud83c[\\udffb-\\udfff]", Ts = "(?:" + ti + "|" + ru + ")", wp = "[^" + hn + "]", $o = "(?:\\ud83c[\\udde6-\\uddff]){2}", Kn = "[\\ud800-\\udbff][\\udc00-\\udfff]", Rl = "[" + xo + "]", au = "\\u200d", nc = "(?:" + Rs + "|" + tc + ")", Un = "(?:" + Rl + "|" + tc + ")", rc = "(?:" + eu + "(?:d|ll|m|re|s|t|ve))?", ac = "(?:" + eu + "(?:D|LL|M|RE|S|T|VE))?", dn = Ts + "?", iu = "[" + Ss + "]?", ra = "(?:" + au + "(?:" + [wp, $o, Kn].join("|") + ")" + iu + dn + ")*", oo = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Fi = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ws = iu + dn + ra, da = "(?:" + [nu, $o, Kn].join("|") + ")" + ws, gr = "(?:" + [wp + ti + "?", ti, $o, Kn, tu].join("|") + ")", Ip = RegExp(eu, "g"), lo = RegExp(ti, "g"), Pa = RegExp(ru + "(?=" + ru + ")|" + gr + ws, "g"), $l = RegExp([
      Rl + "?" + Rs + "+" + rc + "(?=" + [Yo, Rl, "$"].join("|") + ")",
      Un + "+" + ac + "(?=" + [Yo, Rl + nc, "$"].join("|") + ")",
      Rl + "?" + nc + "+" + rc,
      Rl + "+" + ac,
      Fi,
      oo,
      xs,
      da
    ].join("|"), "g"), Ap = RegExp("[" + au + hn + ei + Ss + "]"), Is = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ou = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Np = -1, Vn = {};
    Vn[ca] = Vn[Ka] = Vn[it] = Vn[kt] = Vn[$t] = Vn[Fn] = Vn[zn] = Vn[Ur] = Vn[Lr] = !0, Vn[ot] = Vn[nt] = Vn[pr] = Vn[ht] = Vn[xr] = Vn[dt] = Vn[bn] = Vn[Ze] = Vn[fn] = Vn[Gn] = Vn[Jn] = Vn[qr] = Vn[wr] = Vn[Da] = Vn[Or] = !1;
    var ir = {};
    ir[ot] = ir[nt] = ir[pr] = ir[xr] = ir[ht] = ir[dt] = ir[ca] = ir[Ka] = ir[it] = ir[kt] = ir[$t] = ir[fn] = ir[Gn] = ir[Jn] = ir[qr] = ir[wr] = ir[Da] = ir[Sa] = ir[Fn] = ir[zn] = ir[Ur] = ir[Lr] = !0, ir[bn] = ir[Ze] = ir[Or] = !1;
    var As = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Zo = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, ef = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, lu = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, su = parseFloat, ic = parseInt, oc = typeof Dy == "object" && Dy && Dy.Object === Object && Dy, hd = typeof self == "object" && self && self.Object === Object && self, Dr = oc || hd || Function("return this")(), P = r && !r.nodeType && r, te = P && !0 && t && !t.nodeType && t, Te = te && te.exports === P, Oe = Te && oc.process, Je = function() {
      try {
        var fe = te && te.require && te.require("util").types;
        return fe || Oe && Oe.binding && Oe.binding("util");
      } catch {
      }
    }(), Xt = Je && Je.isArrayBuffer, pt = Je && Je.isDate, Wt = Je && Je.isMap, Nn = Je && Je.isRegExp, Yn = Je && Je.isSet, Ir = Je && Je.isTypedArray;
    function xn(fe, De, Re) {
      switch (Re.length) {
        case 0:
          return fe.call(De);
        case 1:
          return fe.call(De, Re[0]);
        case 2:
          return fe.call(De, Re[0], Re[1]);
        case 3:
          return fe.call(De, Re[0], Re[1], Re[2]);
      }
      return fe.apply(De, Re);
    }
    function Mr(fe, De, Re, yt) {
      for (var gn = -1, cr = fe == null ? 0 : fe.length; ++gn < cr; ) {
        var ka = fe[gn];
        De(yt, ka, Re(ka), fe);
      }
      return yt;
    }
    function Pn(fe, De) {
      for (var Re = -1, yt = fe == null ? 0 : fe.length; ++Re < yt && De(fe[Re], Re, fe) !== !1; )
        ;
      return fe;
    }
    function Hn(fe, De) {
      for (var Re = fe == null ? 0 : fe.length; Re-- && De(fe[Re], Re, fe) !== !1; )
        ;
      return fe;
    }
    function Zl(fe, De) {
      for (var Re = -1, yt = fe == null ? 0 : fe.length; ++Re < yt; )
        if (!De(fe[Re], Re, fe))
          return !1;
      return !0;
    }
    function Ro(fe, De) {
      for (var Re = -1, yt = fe == null ? 0 : fe.length, gn = 0, cr = []; ++Re < yt; ) {
        var ka = fe[Re];
        De(ka, Re, fe) && (cr[gn++] = ka);
      }
      return cr;
    }
    function uu(fe, De) {
      var Re = fe == null ? 0 : fe.length;
      return !!Re && sc(fe, De, 0) > -1;
    }
    function vd(fe, De, Re) {
      for (var yt = -1, gn = fe == null ? 0 : fe.length; ++yt < gn; )
        if (Re(De, fe[yt]))
          return !0;
      return !1;
    }
    function qn(fe, De) {
      for (var Re = -1, yt = fe == null ? 0 : fe.length, gn = Array(yt); ++Re < yt; )
        gn[Re] = De(fe[Re], Re, fe);
      return gn;
    }
    function Jo(fe, De) {
      for (var Re = -1, yt = De.length, gn = fe.length; ++Re < yt; )
        fe[gn + Re] = De[Re];
      return fe;
    }
    function lc(fe, De, Re, yt) {
      var gn = -1, cr = fe == null ? 0 : fe.length;
      for (yt && cr && (Re = fe[++gn]); ++gn < cr; )
        Re = De(Re, fe[gn], gn, fe);
      return Re;
    }
    function ev(fe, De, Re, yt) {
      var gn = fe == null ? 0 : fe.length;
      for (yt && gn && (Re = fe[--gn]); gn--; )
        Re = De(Re, fe[gn], gn, fe);
      return Re;
    }
    function tv(fe, De) {
      for (var Re = -1, yt = fe == null ? 0 : fe.length; ++Re < yt; )
        if (De(fe[Re], Re, fe))
          return !0;
      return !1;
    }
    var tb = gd("length");
    function nv(fe) {
      return fe.split("");
    }
    function rv(fe) {
      return fe.match(J) || [];
    }
    function av(fe, De, Re) {
      var yt;
      return Re(fe, function(gn, cr, ka) {
        if (De(gn, cr, ka))
          return yt = cr, !1;
      }), yt;
    }
    function md(fe, De, Re, yt) {
      for (var gn = fe.length, cr = Re + (yt ? 1 : -1); yt ? cr-- : ++cr < gn; )
        if (De(fe[cr], cr, fe))
          return cr;
      return -1;
    }
    function sc(fe, De, Re) {
      return De === De ? sf(fe, De, Re) : md(fe, Jl, Re);
    }
    function iv(fe, De, Re, yt) {
      for (var gn = Re - 1, cr = fe.length; ++gn < cr; )
        if (yt(fe[gn], De))
          return gn;
      return -1;
    }
    function Jl(fe) {
      return fe !== fe;
    }
    function Rm(fe, De) {
      var Re = fe == null ? 0 : fe.length;
      return Re ? nf(fe, De) / Re : _e;
    }
    function gd(fe) {
      return function(De) {
        return De == null ? i : De[fe];
      };
    }
    function tf(fe) {
      return function(De) {
        return fe == null ? i : fe[De];
      };
    }
    function _p(fe, De, Re, yt, gn) {
      return gn(fe, function(cr, ka, br) {
        Re = yt ? (yt = !1, cr) : De(Re, cr, ka, br);
      }), Re;
    }
    function nb(fe, De) {
      var Re = fe.length;
      for (fe.sort(De); Re--; )
        fe[Re] = fe[Re].value;
      return fe;
    }
    function nf(fe, De) {
      for (var Re, yt = -1, gn = fe.length; ++yt < gn; ) {
        var cr = De(fe[yt]);
        cr !== i && (Re = Re === i ? cr : Re + cr);
      }
      return Re;
    }
    function Op(fe, De) {
      for (var Re = -1, yt = Array(fe); ++Re < fe; )
        yt[Re] = De(Re);
      return yt;
    }
    function so(fe, De) {
      return qn(De, function(Re) {
        return [Re, fe[Re]];
      });
    }
    function Ql(fe) {
      return fe && fe.slice(0, Mp(fe) + 1).replace(xe, "");
    }
    function ur(fe) {
      return function(De) {
        return fe(De);
      };
    }
    function To(fe, De) {
      return qn(De, function(Re) {
        return fe[Re];
      });
    }
    function Tl(fe, De) {
      return fe.has(De);
    }
    function bd(fe, De) {
      for (var Re = -1, yt = fe.length; ++Re < yt && sc(De, fe[Re], 0) > -1; )
        ;
      return Re;
    }
    function ov(fe, De) {
      for (var Re = fe.length; Re-- && sc(De, fe[Re], 0) > -1; )
        ;
      return Re;
    }
    function rf(fe, De) {
      for (var Re = fe.length, yt = 0; Re--; )
        fe[Re] === De && ++yt;
      return yt;
    }
    var Tm = tf(As), wm = tf(Zo);
    function Lp(fe) {
      return "\\" + lu[fe];
    }
    function af(fe, De) {
      return fe == null ? i : fe[De];
    }
    function of(fe) {
      return Ap.test(fe);
    }
    function rb(fe) {
      return Is.test(fe);
    }
    function Im(fe) {
      for (var De, Re = []; !(De = fe.next()).done; )
        Re.push(De.value);
      return Re;
    }
    function Dp(fe) {
      var De = -1, Re = Array(fe.size);
      return fe.forEach(function(yt, gn) {
        Re[++De] = [gn, yt];
      }), Re;
    }
    function lv(fe, De) {
      return function(Re) {
        return fe(De(Re));
      };
    }
    function Qo(fe, De) {
      for (var Re = -1, yt = fe.length, gn = 0, cr = []; ++Re < yt; ) {
        var ka = fe[Re];
        (ka === De || ka === x) && (fe[Re] = x, cr[gn++] = Re);
      }
      return cr;
    }
    function Ns(fe) {
      var De = -1, Re = Array(fe.size);
      return fe.forEach(function(yt) {
        Re[++De] = yt;
      }), Re;
    }
    function lf(fe) {
      var De = -1, Re = Array(fe.size);
      return fe.forEach(function(yt) {
        Re[++De] = [yt, yt];
      }), Re;
    }
    function sf(fe, De, Re) {
      for (var yt = Re - 1, gn = fe.length; ++yt < gn; )
        if (fe[yt] === De)
          return yt;
      return -1;
    }
    function Am(fe, De, Re) {
      for (var yt = Re + 1; yt--; )
        if (fe[yt] === De)
          return yt;
      return yt;
    }
    function cu(fe) {
      return of(fe) ? _m(fe) : tb(fe);
    }
    function wo(fe) {
      return of(fe) ? Om(fe) : nv(fe);
    }
    function Mp(fe) {
      for (var De = fe.length; De-- && Ue.test(fe.charAt(De)); )
        ;
      return De;
    }
    var Nm = tf(ef);
    function _m(fe) {
      for (var De = Pa.lastIndex = 0; Pa.test(fe); )
        ++De;
      return De;
    }
    function Om(fe) {
      return fe.match(Pa) || [];
    }
    function ab(fe) {
      return fe.match($l) || [];
    }
    var ib = function fe(De) {
      De = De == null ? Dr : uf.defaults(Dr.Object(), De, uf.pick(Dr, ou));
      var Re = De.Array, yt = De.Date, gn = De.Error, cr = De.Function, ka = De.Math, br = De.Object, wl = De.RegExp, Pp = De.String, Io = De.TypeError, uo = Re.prototype, sv = cr.prototype, Kl = br.prototype, cf = De["__core-js_shared__"], yd = sv.toString, fr = Kl.hasOwnProperty, uc = 0, kp = function() {
        var s = /[^.]+$/.exec(cf && cf.keys && cf.keys.IE_PROTO || "");
        return s ? "Symbol(src)_1." + s : "";
      }(), ff = Kl.toString, ni = yd.call(br), uv = Dr._, Lm = wl(
        "^" + yd.call(fr).replace(ne, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Cd = Te ? De.Buffer : i, _s = De.Symbol, Ed = De.Uint8Array, cv = Cd ? Cd.allocUnsafe : i, Ko = lv(br.getPrototypeOf, br), df = br.create, fu = Kl.propertyIsEnumerable, Fp = uo.splice, pf = _s ? _s.isConcatSpreadable : i, Os = _s ? _s.iterator : i, cc = _s ? _s.toStringTag : i, Sd = function() {
        try {
          var s = js(br, "defineProperty");
          return s({}, "", {}), s;
        } catch {
        }
      }(), Bp = De.clearTimeout !== Dr.clearTimeout && De.clearTimeout, Pr = yt && yt.now !== Dr.Date.now && yt.now, du = De.setTimeout !== Dr.setTimeout && De.setTimeout, qo = ka.ceil, Ls = ka.floor, Up = br.getOwnPropertySymbols, Vp = Cd ? Cd.isBuffer : i, hf = De.isFinite, xd = uo.join, fc = lv(br.keys, br), wa = ka.max, ri = ka.min, ob = yt.now, fv = De.parseInt, Rd = ka.random, Hp = uo.reverse, Td = js(De, "DataView"), Il = js(De, "Map"), dc = js(De, "Promise"), el = js(De, "Set"), vf = js(De, "WeakMap"), pc = js(br, "create"), mf = vf && new vf(), gf = {}, pu = _u(Td), Al = _u(Il), wd = _u(dc), hu = _u(el), ql = _u(vf), es = _s ? _s.prototype : i, Ao = es ? es.valueOf : i, jp = es ? es.toString : i;
      function z(s) {
        if (_a(s) && !Tn(s) && !(s instanceof Rn)) {
          if (s instanceof xi)
            return s;
          if (fr.call(s, "__wrapped__"))
            return Hm(s);
        }
        return new xi(s);
      }
      var vu = function() {
        function s() {
        }
        return function(d) {
          if (!ba(d))
            return {};
          if (df)
            return df(d);
          s.prototype = d;
          var C = new s();
          return s.prototype = i, C;
        };
      }();
      function Bi() {
      }
      function xi(s, d) {
        this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!d, this.__index__ = 0, this.__values__ = i;
      }
      z.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Wl,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Xl,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Xo,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: z
        }
      }, z.prototype = Bi.prototype, z.prototype.constructor = z, xi.prototype = vu(Bi.prototype), xi.prototype.constructor = xi;
      function Rn(s) {
        this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = q, this.__views__ = [];
      }
      function zt() {
        var s = new Rn(this.__wrapped__);
        return s.__actions__ = Wa(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = Wa(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = Wa(this.__views__), s;
      }
      function mu() {
        if (this.__filtered__) {
          var s = new Rn(this);
          s.__dir__ = -1, s.__filtered__ = !0;
        } else
          s = this.clone(), s.__dir__ *= -1;
        return s;
      }
      function Xr() {
        var s = this.__wrapped__.value(), d = this.__dir__, C = Tn(s), A = d < 0, F = C ? s.length : 0, $ = Df(0, F, this.__views__), ee = $.start, ae = $.end, de = ae - ee, He = A ? ae : ee - 1, Be = this.__iteratees__, Xe = Be.length, ft = 0, Dt = ri(de, this.__takeCount__);
        if (!C || !A && F == de && Dt == de)
          return xu(s, this.__actions__);
        var en = [];
        e:
          for (; de-- && ft < Dt; ) {
            He += d;
            for (var On = -1, cn = s[He]; ++On < Xe; ) {
              var jn = Be[On], er = jn.iteratee, mo = jn.type, sa = er(cn);
              if (mo == at)
                cn = sa;
              else if (!sa) {
                if (mo == qe)
                  continue e;
                break e;
              }
            }
            en[ft++] = cn;
          }
        return en;
      }
      Rn.prototype = vu(Bi.prototype), Rn.prototype.constructor = Rn;
      function ln(s) {
        var d = -1, C = s == null ? 0 : s.length;
        for (this.clear(); ++d < C; ) {
          var A = s[d];
          this.set(A[0], A[1]);
        }
      }
      function vr() {
        this.__data__ = pc ? pc(null) : {}, this.size = 0;
      }
      function yr(s) {
        var d = this.has(s) && delete this.__data__[s];
        return this.size -= d ? 1 : 0, d;
      }
      function ts(s) {
        var d = this.__data__;
        if (pc) {
          var C = d[s];
          return C === g ? i : C;
        }
        return fr.call(d, s) ? d[s] : i;
      }
      function un(s) {
        var d = this.__data__;
        return pc ? d[s] !== i : fr.call(d, s);
      }
      function pa(s, d) {
        var C = this.__data__;
        return this.size += this.has(s) ? 0 : 1, C[s] = pc && d === i ? g : d, this;
      }
      ln.prototype.clear = vr, ln.prototype.delete = yr, ln.prototype.get = ts, ln.prototype.has = un, ln.prototype.set = pa;
      function ha(s) {
        var d = -1, C = s == null ? 0 : s.length;
        for (this.clear(); ++d < C; ) {
          var A = s[d];
          this.set(A[0], A[1]);
        }
      }
      function tl() {
        this.__data__ = [], this.size = 0;
      }
      function ea(s) {
        var d = this.__data__, C = Ti(d, s);
        if (C < 0)
          return !1;
        var A = d.length - 1;
        return C == A ? d.pop() : Fp.call(d, C, 1), --this.size, !0;
      }
      function nl(s) {
        var d = this.__data__, C = Ti(d, s);
        return C < 0 ? i : d[C][1];
      }
      function gu(s) {
        return Ti(this.__data__, s) > -1;
      }
      function Id(s, d) {
        var C = this.__data__, A = Ti(C, s);
        return A < 0 ? (++this.size, C.push([s, d])) : C[A][1] = d, this;
      }
      ha.prototype.clear = tl, ha.prototype.delete = ea, ha.prototype.get = nl, ha.prototype.has = gu, ha.prototype.set = Id;
      function rl(s) {
        var d = -1, C = s == null ? 0 : s.length;
        for (this.clear(); ++d < C; ) {
          var A = s[d];
          this.set(A[0], A[1]);
        }
      }
      function Dm() {
        this.size = 0, this.__data__ = {
          hash: new ln(),
          map: new (Il || ha)(),
          string: new ln()
        };
      }
      function No(s) {
        var d = Gd(this, s).delete(s);
        return this.size -= d ? 1 : 0, d;
      }
      function ai(s) {
        return Gd(this, s).get(s);
      }
      function Ad(s) {
        return Gd(this, s).has(s);
      }
      function dv(s, d) {
        var C = Gd(this, s), A = C.size;
        return C.set(s, d), this.size += C.size == A ? 0 : 1, this;
      }
      rl.prototype.clear = Dm, rl.prototype.delete = No, rl.prototype.get = ai, rl.prototype.has = Ad, rl.prototype.set = dv;
      function Ds(s) {
        var d = -1, C = s == null ? 0 : s.length;
        for (this.__data__ = new rl(); ++d < C; )
          this.add(s[d]);
      }
      function co(s) {
        return this.__data__.set(s, g), this;
      }
      function bu(s) {
        return this.__data__.has(s);
      }
      Ds.prototype.add = Ds.prototype.push = co, Ds.prototype.has = bu;
      function ta(s) {
        var d = this.__data__ = new ha(s);
        this.size = d.size;
      }
      function hc() {
        this.__data__ = new ha(), this.size = 0;
      }
      function bf(s) {
        var d = this.__data__, C = d.delete(s);
        return this.size = d.size, C;
      }
      function fo(s) {
        return this.__data__.get(s);
      }
      function Ri(s) {
        return this.__data__.has(s);
      }
      function al(s, d) {
        var C = this.__data__;
        if (C instanceof ha) {
          var A = C.__data__;
          if (!Il || A.length < c - 1)
            return A.push([s, d]), this.size = ++C.size, this;
          C = this.__data__ = new rl(A);
        }
        return C.set(s, d), this.size = C.size, this;
      }
      ta.prototype.clear = hc, ta.prototype.delete = bf, ta.prototype.get = fo, ta.prototype.has = Ri, ta.prototype.set = al;
      function ii(s, d) {
        var C = Tn(s), A = !C && ap(s), F = !C && !A && ku(s), $ = !C && !A && !F && Wf(s), ee = C || A || F || $, ae = ee ? Op(s.length, Pp) : [], de = ae.length;
        for (var He in s)
          (d || fr.call(s, He)) && !(ee && // Safari 9 has enumerable `arguments.length` in strict mode.
          (He == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          F && (He == "offset" || He == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          $ && (He == "buffer" || He == "byteLength" || He == "byteOffset") || // Skip index properties.
          Zr(He, de))) && ae.push(He);
        return ae;
      }
      function ns(s) {
        var d = s.length;
        return d ? s[Hi(0, d - 1)] : i;
      }
      function _o(s, d) {
        return sh(Wa(s), rs(d, 0, s.length));
      }
      function pv(s) {
        return sh(Wa(s));
      }
      function yf(s, d, C) {
        (C !== i && !Xs(s[d], C) || C === i && !(d in s)) && Nl(s, d, C);
      }
      function vc(s, d, C) {
        var A = s[d];
        (!(fr.call(s, d) && Xs(A, C)) || C === i && !(d in s)) && Nl(s, d, C);
      }
      function Ti(s, d) {
        for (var C = s.length; C--; )
          if (Xs(s[C][0], d))
            return C;
        return -1;
      }
      function po(s, d, C, A) {
        return as(s, function(F, $, ee) {
          d(A, F, C(F), ee);
        }), A;
      }
      function Vr(s, d) {
        return s && hi(d, _i(d), s);
      }
      function il(s, d) {
        return s && hi(d, ml(d), s);
      }
      function Nl(s, d, C) {
        d == "__proto__" && Sd ? Sd(s, d, {
          configurable: !0,
          enumerable: !0,
          value: C,
          writable: !0
        }) : s[d] = C;
      }
      function Gp(s, d) {
        for (var C = -1, A = d.length, F = Re(A), $ = s == null; ++C < A; )
          F[C] = $ ? i : Nb(s, d[C]);
        return F;
      }
      function rs(s, d, C) {
        return s === s && (C !== i && (s = s <= C ? s : C), d !== i && (s = s >= d ? s : d)), s;
      }
      function Ui(s, d, C, A, F, $) {
        var ee, ae = d & T, de = d & _, He = d & L;
        if (C && (ee = F ? C(s, A, F, $) : C(s)), ee !== i)
          return ee;
        if (!ba(s))
          return s;
        var Be = Tn(s);
        if (Be) {
          if (ee = ma(s), !ae)
            return Wa(s, ee);
        } else {
          var Xe = $r(s), ft = Xe == Ze || Xe == mn;
          if (ku(s))
            return Ud(s, ae);
          if (Xe == Jn || Xe == ot || ft && !F) {
            if (ee = de || ft ? {} : vi(s), !ae)
              return de ? lb(s, il(ee, s)) : Ai(s, Vr(ee, s));
          } else {
            if (!ir[Xe])
              return F ? s : {};
            ee = ub(s, Xe, ae);
          }
        }
        $ || ($ = new ta());
        var Dt = $.get(s);
        if (Dt)
          return Dt;
        $.set(s, ee), Tb(s) ? s.forEach(function(cn) {
          ee.add(Ui(cn, d, C, cn, s, $));
        }) : Rb(s) && s.forEach(function(cn, jn) {
          ee.set(jn, Ui(cn, d, C, jn, s, $));
        });
        var en = He ? de ? Vs : wc : de ? ml : _i, On = Be ? i : en(s);
        return Pn(On || s, function(cn, jn) {
          On && (jn = cn, cn = s[jn]), vc(ee, jn, Ui(cn, d, C, jn, s, $));
        }), ee;
      }
      function Mm(s) {
        var d = _i(s);
        return function(C) {
          return Nd(C, s, d);
        };
      }
      function Nd(s, d, C) {
        var A = C.length;
        if (s == null)
          return !A;
        for (s = br(s); A--; ) {
          var F = C[A], $ = d[F], ee = s[F];
          if (ee === i && !(F in s) || !$(ee))
            return !1;
        }
        return !0;
      }
      function hv(s, d, C) {
        if (typeof s != "function")
          throw new Io(h);
        return us(function() {
          s.apply(i, C);
        }, d);
      }
      function kr(s, d, C, A) {
        var F = -1, $ = uu, ee = !0, ae = s.length, de = [], He = d.length;
        if (!ae)
          return de;
        C && (d = qn(d, ur(C))), A ? ($ = vd, ee = !1) : d.length >= c && ($ = Tl, ee = !1, d = new Ds(d));
        e:
          for (; ++F < ae; ) {
            var Be = s[F], Xe = C == null ? Be : C(Be);
            if (Be = A || Be !== 0 ? Be : 0, ee && Xe === Xe) {
              for (var ft = He; ft--; )
                if (d[ft] === Xe)
                  continue e;
              de.push(Be);
            } else
              $(d, Xe, A) || de.push(Be);
          }
        return de;
      }
      var as = Gi(Ar), _d = Gi(ct, !0);
      function mc(s, d) {
        var C = !0;
        return as(s, function(A, F, $) {
          return C = !!d(A, F, $), C;
        }), C;
      }
      function Oo(s, d, C) {
        for (var A = -1, F = s.length; ++A < F; ) {
          var $ = s[A], ee = d($);
          if (ee != null && (ae === i ? ee === ee && !$n(ee) : C(ee, ae)))
            var ae = ee, de = $;
        }
        return de;
      }
      function Pm(s, d, C, A) {
        var F = s.length;
        for (C = Sn(C), C < 0 && (C = -C > F ? 0 : F + C), A = A === i || A > F ? F : Sn(A), A < 0 && (A += F), A = C > A ? 0 : op(A); C < A; )
          s[C++] = d;
        return s;
      }
      function Od(s, d) {
        var C = [];
        return as(s, function(A, F, $) {
          d(A, F, $) && C.push(A);
        }), C;
      }
      function va(s, d, C, A, F) {
        var $ = -1, ee = s.length;
        for (C || (C = Pf), F || (F = []); ++$ < ee; ) {
          var ae = s[$];
          d > 0 && C(ae) ? d > 1 ? va(ae, d - 1, C, A, F) : Jo(F, ae) : A || (F[F.length] = ae);
        }
        return F;
      }
      var zp = wu(), is = wu(!0);
      function Ar(s, d) {
        return s && zp(s, d, _i);
      }
      function ct(s, d) {
        return s && is(s, d, _i);
      }
      function Vi(s, d) {
        return Ro(d, function(C) {
          return Fu(s[C]);
        });
      }
      function za(s, d) {
        d = ul(d, s);
        for (var C = 0, A = d.length; s != null && C < A; )
          s = s[Xi(d[C++])];
        return C && C == A ? s : i;
      }
      function Wp(s, d, C) {
        var A = d(s);
        return Tn(s) ? A : Jo(A, C(s));
      }
      function di(s) {
        return s == null ? s === i ? xa : ar : cc && cc in br(s) ? zd(s) : $d(s);
      }
      function yu(s, d) {
        return s > d;
      }
      function ol(s, d) {
        return s != null && fr.call(s, d);
      }
      function gc(s, d) {
        return s != null && d in br(s);
      }
      function Fa(s, d, C) {
        return s >= ri(d, C) && s < wa(d, C);
      }
      function Xp(s, d, C) {
        for (var A = C ? vd : uu, F = s[0].length, $ = s.length, ee = $, ae = Re($), de = 1 / 0, He = []; ee--; ) {
          var Be = s[ee];
          ee && d && (Be = qn(Be, ur(d))), de = ri(Be.length, de), ae[ee] = !C && (d || F >= 120 && Be.length >= 120) ? new Ds(ee && Be) : i;
        }
        Be = s[0];
        var Xe = -1, ft = ae[0];
        e:
          for (; ++Xe < F && He.length < de; ) {
            var Dt = Be[Xe], en = d ? d(Dt) : Dt;
            if (Dt = C || Dt !== 0 ? Dt : 0, !(ft ? Tl(ft, en) : A(He, en, C))) {
              for (ee = $; --ee; ) {
                var On = ae[ee];
                if (!(On ? Tl(On, en) : A(s[ee], en, C)))
                  continue e;
              }
              ft && ft.push(en), He.push(Dt);
            }
          }
        return He;
      }
      function Ms(s, d, C, A) {
        return Ar(s, function(F, $, ee) {
          d(A, C(F), $, ee);
        }), A;
      }
      function ll(s, d, C) {
        d = ul(d, s), s = Jr(s, d);
        var A = s == null ? s : s[Xi(Yi(d))];
        return A == null ? i : xn(A, s, C);
      }
      function Ld(s) {
        return _a(s) && di(s) == ot;
      }
      function Cf(s) {
        return _a(s) && di(s) == pr;
      }
      function ho(s) {
        return _a(s) && di(s) == dt;
      }
      function sl(s, d, C, A, F) {
        return s === d ? !0 : s == null || d == null || !_a(s) && !_a(d) ? s !== s && d !== d : Yp(s, d, C, A, sl, F);
      }
      function Yp(s, d, C, A, F, $) {
        var ee = Tn(s), ae = Tn(d), de = ee ? nt : $r(s), He = ae ? nt : $r(d);
        de = de == ot ? Jn : de, He = He == ot ? Jn : He;
        var Be = de == Jn, Xe = He == Jn, ft = de == He;
        if (ft && ku(s)) {
          if (!ku(d))
            return !1;
          ee = !0, Be = !1;
        }
        if (ft && !Be)
          return $ || ($ = new ta()), ee || Wf(s) ? Of(s, d, C, A, F, $) : ih(s, d, de, C, A, F, $);
        if (!(C & M)) {
          var Dt = Be && fr.call(s, "__wrapped__"), en = Xe && fr.call(d, "__wrapped__");
          if (Dt || en) {
            var On = Dt ? s.value() : s, cn = en ? d.value() : d;
            return $ || ($ = new ta()), F(On, cn, C, A, $);
          }
        }
        return ft ? ($ || ($ = new ta()), sb(s, d, C, A, F, $)) : !1;
      }
      function km(s) {
        return _a(s) && $r(s) == fn;
      }
      function Ef(s, d, C, A) {
        var F = C.length, $ = F, ee = !A;
        if (s == null)
          return !$;
        for (s = br(s); F--; ) {
          var ae = C[F];
          if (ee && ae[2] ? ae[1] !== s[ae[0]] : !(ae[0] in s))
            return !1;
        }
        for (; ++F < $; ) {
          ae = C[F];
          var de = ae[0], He = s[de], Be = ae[1];
          if (ee && ae[2]) {
            if (He === i && !(de in s))
              return !1;
          } else {
            var Xe = new ta();
            if (A)
              var ft = A(He, Be, de, s, d, Xe);
            if (!(ft === i ? sl(Be, He, M | U, A, Xe) : ft))
              return !1;
          }
        }
        return !0;
      }
      function vv(s) {
        if (!ba(s) || lh(s))
          return !1;
        var d = Fu(s) ? Lm : Tt;
        return d.test(_u(s));
      }
      function Dd(s) {
        return _a(s) && di(s) == qr;
      }
      function _l(s) {
        return _a(s) && $r(s) == wr;
      }
      function Sf(s) {
        return _a(s) && kv(s.length) && !!Vn[di(s)];
      }
      function xf(s) {
        return typeof s == "function" ? s : s == null ? gl : typeof s == "object" ? Tn(s) ? Yr(s[0], s[1]) : $p(s) : Wv(s);
      }
      function Ps(s) {
        if (!ss(s))
          return fc(s);
        var d = [];
        for (var C in br(s))
          fr.call(s, C) && C != "constructor" && d.push(C);
        return d;
      }
      function mv(s) {
        if (!ba(s))
          return Vm(s);
        var d = ss(s), C = [];
        for (var A in s)
          A == "constructor" && (d || !fr.call(s, A)) || C.push(A);
        return C;
      }
      function Cu(s, d) {
        return s < d;
      }
      function gv(s, d) {
        var C = -1, A = gi(s) ? Re(s.length) : [];
        return as(s, function(F, $, ee) {
          A[++C] = d(F, $, ee);
        }), A;
      }
      function $p(s) {
        var d = Lf(s);
        return d.length == 1 && d[0][2] ? Yd(d[0][0], d[0][1]) : function(C) {
          return C === s || Ef(C, s, d);
        };
      }
      function Yr(s, d) {
        return xt(s) && Xd(d) ? Yd(Xi(s), d) : function(C) {
          var A = Nb(C, s);
          return A === i && A === d ? Ah(C, s) : sl(d, A, M | U);
        };
      }
      function bc(s, d, C, A, F) {
        s !== d && zp(d, function($, ee) {
          if (F || (F = new ta()), ba($))
            Zp(s, d, ee, C, bc, A, F);
          else {
            var ae = A ? A(mi(s, ee), $, ee + "", s, d, F) : i;
            ae === i && (ae = $), yf(s, ee, ae);
          }
        }, ml);
      }
      function Zp(s, d, C, A, F, $, ee) {
        var ae = mi(s, C), de = mi(d, C), He = ee.get(de);
        if (He) {
          yf(s, C, He);
          return;
        }
        var Be = $ ? $(ae, de, C + "", s, d, ee) : i, Xe = Be === i;
        if (Xe) {
          var ft = Tn(de), Dt = !ft && ku(de), en = !ft && !Dt && Wf(de);
          Be = de, ft || Dt || en ? Tn(ae) ? Be = ae : Na(ae) ? Be = Wa(ae) : Dt ? (Xe = !1, Be = Ud(de, !0)) : en ? (Xe = !1, Be = eh(de, !0)) : Be = [] : ip(de) || ap(de) ? (Be = ae, ap(ae) ? Be = Ib(ae) : (!ba(ae) || Fu(ae)) && (Be = vi(de))) : Xe = !1;
        }
        Xe && (ee.set(de, Be), F(Be, de, A, $, ee), ee.delete(de)), yf(s, C, Be);
      }
      function Jp(s, d) {
        var C = s.length;
        if (C)
          return d += d < 0 ? C : 0, Zr(d, C) ? s[d] : i;
      }
      function Md(s, d, C) {
        d.length ? d = qn(d, function($) {
          return Tn($) ? function(ee) {
            return za(ee, $.length === 1 ? $[0] : $);
          } : $;
        }) : d = [gl];
        var A = -1;
        d = qn(d, ur(Yt()));
        var F = gv(s, function($, ee, ae) {
          var de = qn(d, function(He) {
            return He($);
          });
          return { criteria: de, index: ++A, value: $ };
        });
        return nb(F, function($, ee) {
          return Fm($, ee, C);
        });
      }
      function Pd(s, d) {
        return Ft(s, d, function(C, A) {
          return Ah(s, A);
        });
      }
      function Ft(s, d, C) {
        for (var A = -1, F = d.length, $ = {}; ++A < F; ) {
          var ee = d[A], ae = za(s, ee);
          C(ae, ee) && je($, ul(ee, s), ae);
        }
        return $;
      }
      function Ut(s) {
        return function(d) {
          return za(d, s);
        };
      }
      function rn(s, d, C, A) {
        var F = A ? iv : sc, $ = -1, ee = d.length, ae = s;
        for (s === d && (d = Wa(d)), C && (ae = qn(s, ur(C))); ++$ < ee; )
          for (var de = 0, He = d[$], Be = C ? C(He) : He; (de = F(ae, Be, de, A)) > -1; )
            ae !== s && Fp.call(ae, de, 1), Fp.call(s, de, 1);
        return s;
      }
      function _n(s, d) {
        for (var C = s ? d.length : 0, A = C - 1; C--; ) {
          var F = d[C];
          if (C == A || F !== $) {
            var $ = F;
            Zr(F) ? Fp.call(s, F, 1) : Tf(s, F);
          }
        }
        return s;
      }
      function Hi(s, d) {
        return s + Ls(Rd() * (d - s + 1));
      }
      function Rf(s, d, C, A) {
        for (var F = -1, $ = wa(qo((d - s) / (C || 1)), 0), ee = Re($); $--; )
          ee[A ? $ : ++F] = s, s += C;
        return ee;
      }
      function yc(s, d) {
        var C = "";
        if (!s || d < 1 || d > he)
          return C;
        do
          d % 2 && (C += s), d = Ls(d / 2), d && (s += s);
        while (d);
        return C;
      }
      function Ln(s, d) {
        return Ba(Ac(s, d, gl), s + "");
      }
      function wi(s) {
        return ns(Nh(s));
      }
      function kd(s, d) {
        var C = Nh(s);
        return sh(C, rs(d, 0, C.length));
      }
      function je(s, d, C, A) {
        if (!ba(s))
          return s;
        d = ul(d, s);
        for (var F = -1, $ = d.length, ee = $ - 1, ae = s; ae != null && ++F < $; ) {
          var de = Xi(d[F]), He = C;
          if (de === "__proto__" || de === "constructor" || de === "prototype")
            return s;
          if (F != ee) {
            var Be = ae[de];
            He = A ? A(Be, de, ae) : i, He === i && (He = ba(Be) ? Be : Zr(d[F + 1]) ? [] : {});
          }
          vc(ae, de, He), ae = ae[de];
        }
        return s;
      }
      var Ia = mf ? function(s, d) {
        return mf.set(s, d), s;
      } : gl, Ht = Sd ? function(s, d) {
        return Sd(s, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Vb(d),
          writable: !0
        });
      } : gl;
      function pi(s) {
        return sh(Nh(s));
      }
      function na(s, d, C) {
        var A = -1, F = s.length;
        d < 0 && (d = -d > F ? 0 : F + d), C = C > F ? F : C, C < 0 && (C += F), F = d > C ? 0 : C - d >>> 0, d >>>= 0;
        for (var $ = Re(F); ++A < F; )
          $[A] = s[A + d];
        return $;
      }
      function ks(s, d) {
        var C;
        return as(s, function(A, F, $) {
          return C = d(A, F, $), !C;
        }), !!C;
      }
      function ji(s, d, C) {
        var A = 0, F = s == null ? A : s.length;
        if (typeof d == "number" && d === d && F <= $e) {
          for (; A < F; ) {
            var $ = A + F >>> 1, ee = s[$];
            ee !== null && !$n(ee) && (C ? ee <= d : ee < d) ? A = $ + 1 : F = $;
          }
          return F;
        }
        return Eu(s, d, gl, C);
      }
      function Eu(s, d, C, A) {
        var F = 0, $ = s == null ? 0 : s.length;
        if ($ === 0)
          return 0;
        d = C(d);
        for (var ee = d !== d, ae = d === null, de = $n(d), He = d === i; F < $; ) {
          var Be = Ls((F + $) / 2), Xe = C(s[Be]), ft = Xe !== i, Dt = Xe === null, en = Xe === Xe, On = $n(Xe);
          if (ee)
            var cn = A || en;
          else
            He ? cn = en && (A || ft) : ae ? cn = en && ft && (A || !Dt) : de ? cn = en && ft && !Dt && (A || !On) : Dt || On ? cn = !1 : cn = A ? Xe <= d : Xe < d;
          cn ? F = Be + 1 : $ = Be;
        }
        return ri($, pe);
      }
      function Su(s, d) {
        for (var C = -1, A = s.length, F = 0, $ = []; ++C < A; ) {
          var ee = s[C], ae = d ? d(ee) : ee;
          if (!C || !Xs(ae, de)) {
            var de = ae;
            $[F++] = ee === 0 ? 0 : ee;
          }
        }
        return $;
      }
      function Cc(s) {
        return typeof s == "number" ? s : $n(s) ? _e : +s;
      }
      function Ii(s) {
        if (typeof s == "string")
          return s;
        if (Tn(s))
          return qn(s, Ii) + "";
        if ($n(s))
          return jp ? jp.call(s) : "";
        var d = s + "";
        return d == "0" && 1 / s == -We ? "-0" : d;
      }
      function Ol(s, d, C) {
        var A = -1, F = uu, $ = s.length, ee = !0, ae = [], de = ae;
        if (C)
          ee = !1, F = vd;
        else if ($ >= c) {
          var He = d ? null : _f(s);
          if (He)
            return Ns(He);
          ee = !1, F = Tl, de = new Ds();
        } else
          de = d ? [] : ae;
        e:
          for (; ++A < $; ) {
            var Be = s[A], Xe = d ? d(Be) : Be;
            if (Be = C || Be !== 0 ? Be : 0, ee && Xe === Xe) {
              for (var ft = de.length; ft--; )
                if (de[ft] === Xe)
                  continue e;
              d && de.push(Xe), ae.push(Be);
            } else
              F(de, Xe, C) || (de !== ae && de.push(Xe), ae.push(Be));
          }
        return ae;
      }
      function Tf(s, d) {
        return d = ul(d, s), s = Jr(s, d), s == null || delete s[Xi(Yi(d))];
      }
      function Fd(s, d, C, A) {
        return je(s, d, C(za(s, d)), A);
      }
      function Ec(s, d, C, A) {
        for (var F = s.length, $ = A ? F : -1; (A ? $-- : ++$ < F) && d(s[$], $, s); )
          ;
        return C ? na(s, A ? 0 : $, A ? $ + 1 : F) : na(s, A ? $ + 1 : 0, A ? F : $);
      }
      function xu(s, d) {
        var C = s;
        return C instanceof Rn && (C = C.value()), lc(d, function(A, F) {
          return F.func.apply(F.thisArg, Jo([A], F.args));
        }, C);
      }
      function wf(s, d, C) {
        var A = s.length;
        if (A < 2)
          return A ? Ol(s[0]) : [];
        for (var F = -1, $ = Re(A); ++F < A; )
          for (var ee = s[F], ae = -1; ++ae < A; )
            ae != F && ($[F] = kr($[F] || ee, s[ae], d, C));
        return Ol(va($, 1), d, C);
      }
      function Sc(s, d, C) {
        for (var A = -1, F = s.length, $ = d.length, ee = {}; ++A < F; ) {
          var ae = A < $ ? d[A] : i;
          C(ee, s[A], ae);
        }
        return ee;
      }
      function Ru(s) {
        return Na(s) ? s : [];
      }
      function If(s) {
        return typeof s == "function" ? s : gl;
      }
      function ul(s, d) {
        return Tn(s) ? s : xt(s, d) ? [s] : uh(Nr(s));
      }
      var Qp = Ln;
      function Ll(s, d, C) {
        var A = s.length;
        return C = C === i ? A : C, !d && C >= A ? s : na(s, d, C);
      }
      var Bd = Bp || function(s) {
        return Dr.clearTimeout(s);
      };
      function Ud(s, d) {
        if (d)
          return s.slice();
        var C = s.length, A = cv ? cv(C) : new s.constructor(C);
        return s.copy(A), A;
      }
      function Tu(s) {
        var d = new s.constructor(s.byteLength);
        return new Ed(d).set(new Ed(s)), d;
      }
      function xc(s, d) {
        var C = d ? Tu(s.buffer) : s.buffer;
        return new s.constructor(C, s.byteOffset, s.byteLength);
      }
      function Kp(s) {
        var d = new s.constructor(s.source, ut.exec(s));
        return d.lastIndex = s.lastIndex, d;
      }
      function qp(s) {
        return Ao ? br(Ao.call(s)) : {};
      }
      function eh(s, d) {
        var C = d ? Tu(s.buffer) : s.buffer;
        return new s.constructor(C, s.byteOffset, s.length);
      }
      function Vd(s, d) {
        if (s !== d) {
          var C = s !== i, A = s === null, F = s === s, $ = $n(s), ee = d !== i, ae = d === null, de = d === d, He = $n(d);
          if (!ae && !He && !$ && s > d || $ && ee && de && !ae && !He || A && ee && de || !C && de || !F)
            return 1;
          if (!A && !$ && !He && s < d || He && C && F && !A && !$ || ae && C && F || !ee && F || !de)
            return -1;
        }
        return 0;
      }
      function Fm(s, d, C) {
        for (var A = -1, F = s.criteria, $ = d.criteria, ee = F.length, ae = C.length; ++A < ee; ) {
          var de = Vd(F[A], $[A]);
          if (de) {
            if (A >= ae)
              return de;
            var He = C[A];
            return de * (He == "desc" ? -1 : 1);
          }
        }
        return s.index - d.index;
      }
      function Af(s, d, C, A) {
        for (var F = -1, $ = s.length, ee = C.length, ae = -1, de = d.length, He = wa($ - ee, 0), Be = Re(de + He), Xe = !A; ++ae < de; )
          Be[ae] = d[ae];
        for (; ++F < ee; )
          (Xe || F < $) && (Be[C[F]] = s[F]);
        for (; He--; )
          Be[ae++] = s[F++];
        return Be;
      }
      function th(s, d, C, A) {
        for (var F = -1, $ = s.length, ee = -1, ae = C.length, de = -1, He = d.length, Be = wa($ - ae, 0), Xe = Re(Be + He), ft = !A; ++F < Be; )
          Xe[F] = s[F];
        for (var Dt = F; ++de < He; )
          Xe[Dt + de] = d[de];
        for (; ++ee < ae; )
          (ft || F < $) && (Xe[Dt + C[ee]] = s[F++]);
        return Xe;
      }
      function Wa(s, d) {
        var C = -1, A = s.length;
        for (d || (d = Re(A)); ++C < A; )
          d[C] = s[C];
        return d;
      }
      function hi(s, d, C, A) {
        var F = !C;
        C || (C = {});
        for (var $ = -1, ee = d.length; ++$ < ee; ) {
          var ae = d[$], de = A ? A(C[ae], s[ae], ae, C, s) : i;
          de === i && (de = s[ae]), F ? Nl(C, ae, de) : vc(C, ae, de);
        }
        return C;
      }
      function Ai(s, d) {
        return hi(s, ia(s), d);
      }
      function lb(s, d) {
        return hi(s, ls(s), d);
      }
      function Rr(s, d) {
        return function(C, A) {
          var F = Tn(C) ? Mr : po, $ = d ? d() : {};
          return F(C, s, Yt(A, 2), $);
        };
      }
      function Fs(s) {
        return Ln(function(d, C) {
          var A = -1, F = C.length, $ = F > 1 ? C[F - 1] : i, ee = F > 2 ? C[2] : i;
          for ($ = s.length > 3 && typeof $ == "function" ? (F--, $) : i, ee && oi(C[0], C[1], ee) && ($ = F < 3 ? i : $, F = 1), d = br(d); ++A < F; ) {
            var ae = C[A];
            ae && s(d, ae, A, $);
          }
          return d;
        });
      }
      function Gi(s, d) {
        return function(C, A) {
          if (C == null)
            return C;
          if (!gi(C))
            return s(C, A);
          for (var F = C.length, $ = d ? F : -1, ee = br(C); (d ? $-- : ++$ < F) && A(ee[$], $, ee) !== !1; )
            ;
          return C;
        };
      }
      function wu(s) {
        return function(d, C, A) {
          for (var F = -1, $ = br(d), ee = A(d), ae = ee.length; ae--; ) {
            var de = ee[s ? ae : ++F];
            if (C($[de], de, $) === !1)
              break;
          }
          return d;
        };
      }
      function Rc(s, d, C) {
        var A = d & B, F = Nf(s);
        function $() {
          var ee = this && this !== Dr && this instanceof $ ? F : s;
          return ee.apply(A ? C : this, arguments);
        }
        return $;
      }
      function bv(s) {
        return function(d) {
          d = Nr(d);
          var C = of(d) ? wo(d) : i, A = C ? C[0] : d.charAt(0), F = C ? Ll(C, 1).join("") : d.slice(1);
          return A[s]() + F;
        };
      }
      function Tc(s) {
        return function(d) {
          return lc(Ub(jv(d).replace(Ip, "")), s, "");
        };
      }
      function Nf(s) {
        return function() {
          var d = arguments;
          switch (d.length) {
            case 0:
              return new s();
            case 1:
              return new s(d[0]);
            case 2:
              return new s(d[0], d[1]);
            case 3:
              return new s(d[0], d[1], d[2]);
            case 4:
              return new s(d[0], d[1], d[2], d[3]);
            case 5:
              return new s(d[0], d[1], d[2], d[3], d[4]);
            case 6:
              return new s(d[0], d[1], d[2], d[3], d[4], d[5]);
            case 7:
              return new s(d[0], d[1], d[2], d[3], d[4], d[5], d[6]);
          }
          var C = vu(s.prototype), A = s.apply(C, d);
          return ba(A) ? A : C;
        };
      }
      function yv(s, d, C) {
        var A = Nf(s);
        function F() {
          for (var $ = arguments.length, ee = Re($), ae = $, de = Hs(F); ae--; )
            ee[ae] = arguments[ae];
          var He = $ < 3 && ee[0] !== de && ee[$ - 1] !== de ? [] : Qo(ee, de);
          if ($ -= He.length, $ < C)
            return zi(
              s,
              d,
              Iu,
              F.placeholder,
              i,
              ee,
              He,
              i,
              i,
              C - $
            );
          var Be = this && this !== Dr && this instanceof F ? A : s;
          return xn(Be, this, ee);
        }
        return F;
      }
      function Bs(s) {
        return function(d, C, A) {
          var F = br(d);
          if (!gi(d)) {
            var $ = Yt(C, 3);
            d = _i(d), C = function(ae) {
              return $(F[ae], ae, F);
            };
          }
          var ee = s(d, C, A);
          return ee > -1 ? F[$ ? d[ee] : ee] : i;
        };
      }
      function nh(s) {
        return os(function(d) {
          var C = d.length, A = C, F = xi.prototype.thru;
          for (s && d.reverse(); A--; ) {
            var $ = d[A];
            if (typeof $ != "function")
              throw new Io(h);
            if (F && !ee && Ic($) == "wrapper")
              var ee = new xi([], !0);
          }
          for (A = ee ? A : C; ++A < C; ) {
            $ = d[A];
            var ae = Ic($), de = ae == "wrapper" ? oh($) : i;
            de && Wd(de[0]) && de[1] == (j | G | W | re) && !de[4].length && de[9] == 1 ? ee = ee[Ic(de[0])].apply(ee, de[3]) : ee = $.length == 1 && Wd($) ? ee[ae]() : ee.thru($);
          }
          return function() {
            var He = arguments, Be = He[0];
            if (ee && He.length == 1 && Tn(Be))
              return ee.plant(Be).value();
            for (var Xe = 0, ft = C ? d[Xe].apply(this, He) : Be; ++Xe < C; )
              ft = d[Xe].call(this, ft);
            return ft;
          };
        });
      }
      function Iu(s, d, C, A, F, $, ee, ae, de, He) {
        var Be = d & j, Xe = d & B, ft = d & H, Dt = d & (G | Q), en = d & me, On = ft ? i : Nf(s);
        function cn() {
          for (var jn = arguments.length, er = Re(jn), mo = jn; mo--; )
            er[mo] = arguments[mo];
          if (Dt)
            var sa = Hs(cn), Do = rf(er, sa);
          if (A && (er = Af(er, A, F, Dt)), $ && (er = th(er, $, ee, Dt)), jn -= Do, Dt && jn < He) {
            var ya = Qo(er, sa);
            return zi(
              s,
              d,
              Iu,
              cn.placeholder,
              C,
              er,
              ya,
              ae,
              de,
              He - jn
            );
          }
          var bi = Xe ? C : this, go = ft ? bi[s] : s;
          return jn = er.length, ae ? er = li(er, ae) : en && jn > 1 && er.reverse(), Be && de < jn && (er.length = de), this && this !== Dr && this instanceof cn && (go = On || Nf(go)), go.apply(bi, er);
        }
        return cn;
      }
      function Cv(s, d) {
        return function(C, A) {
          return Ms(C, s, d(A), {});
        };
      }
      function Hd(s, d) {
        return function(C, A) {
          var F;
          if (C === i && A === i)
            return d;
          if (C !== i && (F = C), A !== i) {
            if (F === i)
              return A;
            typeof C == "string" || typeof A == "string" ? (C = Ii(C), A = Ii(A)) : (C = Cc(C), A = Cc(A)), F = s(C, A);
          }
          return F;
        };
      }
      function rh(s) {
        return os(function(d) {
          return d = qn(d, ur(Yt())), Ln(function(C) {
            var A = this;
            return s(d, function(F) {
              return xn(F, A, C);
            });
          });
        });
      }
      function Au(s, d) {
        d = d === i ? " " : Ii(d);
        var C = d.length;
        if (C < 2)
          return C ? yc(d, s) : d;
        var A = yc(d, qo(s / cu(d)));
        return of(d) ? Ll(wo(A), 0, s).join("") : A.slice(0, s);
      }
      function Bm(s, d, C, A) {
        var F = d & B, $ = Nf(s);
        function ee() {
          for (var ae = -1, de = arguments.length, He = -1, Be = A.length, Xe = Re(Be + de), ft = this && this !== Dr && this instanceof ee ? $ : s; ++He < Be; )
            Xe[He] = A[He];
          for (; de--; )
            Xe[He++] = arguments[++ae];
          return xn(ft, F ? C : this, Xe);
        }
        return ee;
      }
      function ah(s) {
        return function(d, C, A) {
          return A && typeof A != "number" && oi(d, C, A) && (C = A = i), d = Fc(d), C === i ? (C = d, d = 0) : C = Fc(C), A = A === i ? d < C ? 1 : -1 : Fc(A), Rf(d, C, A, s);
        };
      }
      function jd(s) {
        return function(d, C) {
          return typeof d == "string" && typeof C == "string" || (d = ds(d), C = ds(C)), s(d, C);
        };
      }
      function zi(s, d, C, A, F, $, ee, ae, de, He) {
        var Be = d & G, Xe = Be ? ee : i, ft = Be ? i : ee, Dt = Be ? $ : i, en = Be ? i : $;
        d |= Be ? W : oe, d &= ~(Be ? oe : W), d & Y || (d &= ~(B | H));
        var On = [
          s,
          d,
          F,
          Dt,
          Xe,
          en,
          ft,
          ae,
          de,
          He
        ], cn = C.apply(i, On);
        return Wd(s) && Nc(cn, On), cn.placeholder = A, Sv(cn, s, d);
      }
      function aa(s) {
        var d = ka[s];
        return function(C, A) {
          if (C = ds(C), A = A == null ? 0 : ri(Sn(A), 292), A && hf(C)) {
            var F = (Nr(C) + "e").split("e"), $ = d(F[0] + "e" + (+F[1] + A));
            return F = (Nr($) + "e").split("e"), +(F[0] + "e" + (+F[1] - A));
          }
          return d(C);
        };
      }
      var _f = el && 1 / Ns(new el([, -0]))[1] == We ? function(s) {
        return new el(s);
      } : zb;
      function Us(s) {
        return function(d) {
          var C = $r(d);
          return C == fn ? Dp(d) : C == wr ? lf(d) : so(d, s(d));
        };
      }
      function cl(s, d, C, A, F, $, ee, ae) {
        var de = d & H;
        if (!de && typeof s != "function")
          throw new Io(h);
        var He = A ? A.length : 0;
        if (He || (d &= ~(W | oe), A = F = i), ee = ee === i ? ee : wa(Sn(ee), 0), ae = ae === i ? ae : Sn(ae), He -= F ? F.length : 0, d & oe) {
          var Be = A, Xe = F;
          A = F = i;
        }
        var ft = de ? i : oh(s), Dt = [
          s,
          d,
          C,
          A,
          F,
          Be,
          Xe,
          $,
          ee,
          ae
        ];
        if (ft && Ev(Dt, ft), s = Dt[0], d = Dt[1], C = Dt[2], A = Dt[3], F = Dt[4], ae = Dt[9] = Dt[9] === i ? de ? 0 : s.length : wa(Dt[9] - He, 0), !ae && d & (G | Q) && (d &= ~(G | Q)), !d || d == B)
          var en = Rc(s, d, C);
        else
          d == G || d == Q ? en = yv(s, d, ae) : (d == W || d == (B | W)) && !F.length ? en = Bm(s, d, C, A) : en = Iu.apply(i, Dt);
        var On = ft ? Ia : Nc;
        return Sv(On(en, Dt), s, d);
      }
      function Wi(s, d, C, A) {
        return s === i || Xs(s, Kl[C]) && !fr.call(A, C) ? d : s;
      }
      function Nu(s, d, C, A, F, $) {
        return ba(s) && ba(d) && ($.set(d, s), bc(s, d, i, Nu, $), $.delete(d)), s;
      }
      function yn(s) {
        return ip(s) ? i : s;
      }
      function Of(s, d, C, A, F, $) {
        var ee = C & M, ae = s.length, de = d.length;
        if (ae != de && !(ee && de > ae))
          return !1;
        var He = $.get(s), Be = $.get(d);
        if (He && Be)
          return He == d && Be == s;
        var Xe = -1, ft = !0, Dt = C & U ? new Ds() : i;
        for ($.set(s, d), $.set(d, s); ++Xe < ae; ) {
          var en = s[Xe], On = d[Xe];
          if (A)
            var cn = ee ? A(On, en, Xe, d, s, $) : A(en, On, Xe, s, d, $);
          if (cn !== i) {
            if (cn)
              continue;
            ft = !1;
            break;
          }
          if (Dt) {
            if (!tv(d, function(jn, er) {
              if (!Tl(Dt, er) && (en === jn || F(en, jn, C, A, $)))
                return Dt.push(er);
            })) {
              ft = !1;
              break;
            }
          } else if (!(en === On || F(en, On, C, A, $))) {
            ft = !1;
            break;
          }
        }
        return $.delete(s), $.delete(d), ft;
      }
      function ih(s, d, C, A, F, $, ee) {
        switch (C) {
          case xr:
            if (s.byteLength != d.byteLength || s.byteOffset != d.byteOffset)
              return !1;
            s = s.buffer, d = d.buffer;
          case pr:
            return !(s.byteLength != d.byteLength || !$(new Ed(s), new Ed(d)));
          case ht:
          case dt:
          case Gn:
            return Xs(+s, +d);
          case bn:
            return s.name == d.name && s.message == d.message;
          case qr:
          case Da:
            return s == d + "";
          case fn:
            var ae = Dp;
          case wr:
            var de = A & M;
            if (ae || (ae = Ns), s.size != d.size && !de)
              return !1;
            var He = ee.get(s);
            if (He)
              return He == d;
            A |= U, ee.set(s, d);
            var Be = Of(ae(s), ae(d), A, F, $, ee);
            return ee.delete(s), Be;
          case Sa:
            if (Ao)
              return Ao.call(s) == Ao.call(d);
        }
        return !1;
      }
      function sb(s, d, C, A, F, $) {
        var ee = C & M, ae = wc(s), de = ae.length, He = wc(d), Be = He.length;
        if (de != Be && !ee)
          return !1;
        for (var Xe = de; Xe--; ) {
          var ft = ae[Xe];
          if (!(ee ? ft in d : fr.call(d, ft)))
            return !1;
        }
        var Dt = $.get(s), en = $.get(d);
        if (Dt && en)
          return Dt == d && en == s;
        var On = !0;
        $.set(s, d), $.set(d, s);
        for (var cn = ee; ++Xe < de; ) {
          ft = ae[Xe];
          var jn = s[ft], er = d[ft];
          if (A)
            var mo = ee ? A(er, jn, ft, d, s, $) : A(jn, er, ft, s, d, $);
          if (!(mo === i ? jn === er || F(jn, er, C, A, $) : mo)) {
            On = !1;
            break;
          }
          cn || (cn = ft == "constructor");
        }
        if (On && !cn) {
          var sa = s.constructor, Do = d.constructor;
          sa != Do && "constructor" in s && "constructor" in d && !(typeof sa == "function" && sa instanceof sa && typeof Do == "function" && Do instanceof Do) && (On = !1);
        }
        return $.delete(s), $.delete(d), On;
      }
      function os(s) {
        return Ba(Ac(s, i, fh), s + "");
      }
      function wc(s) {
        return Wp(s, _i, ia);
      }
      function Vs(s) {
        return Wp(s, ml, ls);
      }
      var oh = mf ? function(s) {
        return mf.get(s);
      } : zb;
      function Ic(s) {
        for (var d = s.name + "", C = gf[d], A = fr.call(gf, d) ? C.length : 0; A--; ) {
          var F = C[A], $ = F.func;
          if ($ == null || $ == s)
            return F.name;
        }
        return d;
      }
      function Hs(s) {
        var d = fr.call(z, "placeholder") ? z : s;
        return d.placeholder;
      }
      function Yt() {
        var s = z.iteratee || jb;
        return s = s === jb ? xf : s, arguments.length ? s(arguments[0], arguments[1]) : s;
      }
      function Gd(s, d) {
        var C = s.__data__;
        return kf(d) ? C[typeof d == "string" ? "string" : "hash"] : C.map;
      }
      function Lf(s) {
        for (var d = _i(s), C = d.length; C--; ) {
          var A = d[C], F = s[A];
          d[C] = [A, F, Xd(F)];
        }
        return d;
      }
      function js(s, d) {
        var C = af(s, d);
        return vv(C) ? C : i;
      }
      function zd(s) {
        var d = fr.call(s, cc), C = s[cc];
        try {
          s[cc] = i;
          var A = !0;
        } catch {
        }
        var F = ff.call(s);
        return A && (d ? s[cc] = C : delete s[cc]), F;
      }
      var ia = Up ? function(s) {
        return s == null ? [] : (s = br(s), Ro(Up(s), function(d) {
          return fu.call(s, d);
        }));
      } : Xb, ls = Up ? function(s) {
        for (var d = []; s; )
          Jo(d, ia(s)), s = Ko(s);
        return d;
      } : Xb, $r = di;
      (Td && $r(new Td(new ArrayBuffer(1))) != xr || Il && $r(new Il()) != fn || dc && $r(dc.resolve()) != Ha || el && $r(new el()) != wr || vf && $r(new vf()) != Or) && ($r = function(s) {
        var d = di(s), C = d == Jn ? s.constructor : i, A = C ? _u(C) : "";
        if (A)
          switch (A) {
            case pu:
              return xr;
            case Al:
              return fn;
            case wd:
              return Ha;
            case hu:
              return wr;
            case ql:
              return Or;
          }
        return d;
      });
      function Df(s, d, C) {
        for (var A = -1, F = C.length; ++A < F; ) {
          var $ = C[A], ee = $.size;
          switch ($.type) {
            case "drop":
              s += ee;
              break;
            case "dropRight":
              d -= ee;
              break;
            case "take":
              d = ri(d, s + ee);
              break;
            case "takeRight":
              s = wa(s, d - ee);
              break;
          }
        }
        return { start: s, end: d };
      }
      function Mf(s) {
        var d = s.match(_t);
        return d ? d[1].split(Vt) : [];
      }
      function Lo(s, d, C) {
        d = ul(d, s);
        for (var A = -1, F = d.length, $ = !1; ++A < F; ) {
          var ee = Xi(d[A]);
          if (!($ = s != null && C(s, ee)))
            break;
          s = s[ee];
        }
        return $ || ++A != F ? $ : (F = s == null ? 0 : s.length, !!F && kv(F) && Zr(ee, F) && (Tn(s) || ap(s)));
      }
      function ma(s) {
        var d = s.length, C = new s.constructor(d);
        return d && typeof s[0] == "string" && fr.call(s, "index") && (C.index = s.index, C.input = s.input), C;
      }
      function vi(s) {
        return typeof s.constructor == "function" && !ss(s) ? vu(Ko(s)) : {};
      }
      function ub(s, d, C) {
        var A = s.constructor;
        switch (d) {
          case pr:
            return Tu(s);
          case ht:
          case dt:
            return new A(+s);
          case xr:
            return xc(s, C);
          case ca:
          case Ka:
          case it:
          case kt:
          case $t:
          case Fn:
          case zn:
          case Ur:
          case Lr:
            return eh(s, C);
          case fn:
            return new A();
          case Gn:
          case Da:
            return new A(s);
          case qr:
            return Kp(s);
          case wr:
            return new A();
          case Sa:
            return qp(s);
        }
      }
      function cb(s, d) {
        var C = d.length;
        if (!C)
          return s;
        var A = C - 1;
        return d[A] = (C > 1 ? "& " : "") + d[A], d = d.join(C > 2 ? ", " : " "), s.replace(rt, `{
/* [wrapped with ` + d + `] */
`);
      }
      function Pf(s) {
        return Tn(s) || ap(s) || !!(pf && s && s[pf]);
      }
      function Zr(s, d) {
        var C = typeof s;
        return d = d ?? he, !!d && (C == "number" || C != "symbol" && nn.test(s)) && s > -1 && s % 1 == 0 && s < d;
      }
      function oi(s, d, C) {
        if (!ba(C))
          return !1;
        var A = typeof d;
        return (A == "number" ? gi(C) && Zr(d, C.length) : A == "string" && d in C) ? Xs(C[d], s) : !1;
      }
      function xt(s, d) {
        if (Tn(s))
          return !1;
        var C = typeof s;
        return C == "number" || C == "symbol" || C == "boolean" || s == null || $n(s) ? !0 : Yl.test(s) || !ao.test(s) || d != null && s in br(d);
      }
      function kf(s) {
        var d = typeof s;
        return d == "string" || d == "number" || d == "symbol" || d == "boolean" ? s !== "__proto__" : s === null;
      }
      function Wd(s) {
        var d = Ic(s), C = z[d];
        if (typeof C != "function" || !(d in Rn.prototype))
          return !1;
        if (s === C)
          return !0;
        var A = oh(C);
        return !!A && s === A[0];
      }
      function lh(s) {
        return !!kp && kp in s;
      }
      var fb = cf ? Fu : Yb;
      function ss(s) {
        var d = s && s.constructor, C = typeof d == "function" && d.prototype || Kl;
        return s === C;
      }
      function Xd(s) {
        return s === s && !ba(s);
      }
      function Yd(s, d) {
        return function(C) {
          return C == null ? !1 : C[s] === d && (d !== i || s in br(C));
        };
      }
      function Um(s) {
        var d = ye(s, function(A) {
          return C.size === S && C.clear(), A;
        }), C = d.cache;
        return d;
      }
      function Ev(s, d) {
        var C = s[1], A = d[1], F = C | A, $ = F < (B | H | j), ee = A == j && C == G || A == j && C == re && s[7].length <= d[8] || A == (j | re) && d[7].length <= d[8] && C == G;
        if (!($ || ee))
          return s;
        A & B && (s[2] = d[2], F |= C & B ? 0 : Y);
        var ae = d[3];
        if (ae) {
          var de = s[3];
          s[3] = de ? Af(de, ae, d[4]) : ae, s[4] = de ? Qo(s[3], x) : d[4];
        }
        return ae = d[5], ae && (de = s[5], s[5] = de ? th(de, ae, d[6]) : ae, s[6] = de ? Qo(s[5], x) : d[6]), ae = d[7], ae && (s[7] = ae), A & j && (s[8] = s[8] == null ? d[8] : ri(s[8], d[8])), s[9] == null && (s[9] = d[9]), s[0] = d[0], s[1] = F, s;
      }
      function Vm(s) {
        var d = [];
        if (s != null)
          for (var C in br(s))
            d.push(C);
        return d;
      }
      function $d(s) {
        return ff.call(s);
      }
      function Ac(s, d, C) {
        return d = wa(d === i ? s.length - 1 : d, 0), function() {
          for (var A = arguments, F = -1, $ = wa(A.length - d, 0), ee = Re($); ++F < $; )
            ee[F] = A[d + F];
          F = -1;
          for (var ae = Re(d + 1); ++F < d; )
            ae[F] = A[F];
          return ae[d] = C(ee), xn(s, this, ae);
        };
      }
      function Jr(s, d) {
        return d.length < 2 ? s : za(s, na(d, 0, -1));
      }
      function li(s, d) {
        for (var C = s.length, A = ri(d.length, C), F = Wa(s); A--; ) {
          var $ = d[A];
          s[A] = Zr($, C) ? F[$] : i;
        }
        return s;
      }
      function mi(s, d) {
        if (!(d === "constructor" && typeof s[d] == "function") && d != "__proto__")
          return s[d];
      }
      var Nc = Dl(Ia), us = du || function(s, d) {
        return Dr.setTimeout(s, d);
      }, Ba = Dl(Ht);
      function Sv(s, d, C) {
        var A = d + "";
        return Ba(s, cb(A, xv(Mf(A), C)));
      }
      function Dl(s) {
        var d = 0, C = 0;
        return function() {
          var A = ob(), F = ze - (A - C);
          if (C = A, F > 0) {
            if (++d >= Ge)
              return arguments[0];
          } else
            d = 0;
          return s.apply(i, arguments);
        };
      }
      function sh(s, d) {
        var C = -1, A = s.length, F = A - 1;
        for (d = d === i ? A : d; ++C < d; ) {
          var $ = Hi(C, F), ee = s[$];
          s[$] = s[C], s[C] = ee;
        }
        return s.length = d, s;
      }
      var uh = Um(function(s) {
        var d = [];
        return s.charCodeAt(0) === 46 && d.push(""), s.replace(ki, function(C, A, F, $) {
          d.push(F ? $.replace(be, "$1") : A || C);
        }), d;
      });
      function Xi(s) {
        if (typeof s == "string" || $n(s))
          return s;
        var d = s + "";
        return d == "0" && 1 / s == -We ? "-0" : d;
      }
      function _u(s) {
        if (s != null) {
          try {
            return yd.call(s);
          } catch {
          }
          try {
            return s + "";
          } catch {
          }
        }
        return "";
      }
      function xv(s, d) {
        return Pn(lt, function(C) {
          var A = "_." + C[0];
          d & C[1] && !uu(s, A) && s.push(A);
        }), s.sort();
      }
      function Hm(s) {
        if (s instanceof Rn)
          return s.clone();
        var d = new xi(s.__wrapped__, s.__chain__);
        return d.__actions__ = Wa(s.__actions__), d.__index__ = s.__index__, d.__values__ = s.__values__, d;
      }
      function _c(s, d, C) {
        (C ? oi(s, d, C) : d === i) ? d = 1 : d = wa(Sn(d), 0);
        var A = s == null ? 0 : s.length;
        if (!A || d < 1)
          return [];
        for (var F = 0, $ = 0, ee = Re(qo(A / d)); F < A; )
          ee[$++] = na(s, F, F += d);
        return ee;
      }
      function ch(s) {
        for (var d = -1, C = s == null ? 0 : s.length, A = 0, F = []; ++d < C; ) {
          var $ = s[d];
          $ && (F[A++] = $);
        }
        return F;
      }
      function fl() {
        var s = arguments.length;
        if (!s)
          return [];
        for (var d = Re(s - 1), C = arguments[0], A = s; A--; )
          d[A - 1] = arguments[A];
        return Jo(Tn(C) ? Wa(C) : [C], va(d, 1));
      }
      var kn = Ln(function(s, d) {
        return Na(s) ? kr(s, va(d, 1, Na, !0)) : [];
      }), ga = Ln(function(s, d) {
        var C = Yi(d);
        return Na(C) && (C = i), Na(s) ? kr(s, va(d, 1, Na, !0), Yt(C, 2)) : [];
      }), Qr = Ln(function(s, d) {
        var C = Yi(d);
        return Na(C) && (C = i), Na(s) ? kr(s, va(d, 1, Na, !0), i, C) : [];
      });
      function Xa(s, d, C) {
        var A = s == null ? 0 : s.length;
        return A ? (d = C || d === i ? 1 : Sn(d), na(s, d < 0 ? 0 : d, A)) : [];
      }
      function vo(s, d, C) {
        var A = s == null ? 0 : s.length;
        return A ? (d = C || d === i ? 1 : Sn(d), d = A - d, na(s, 0, d < 0 ? 0 : d)) : [];
      }
      function Ff(s, d) {
        return s && s.length ? Ec(s, Yt(d, 3), !0, !0) : [];
      }
      function Ya(s, d) {
        return s && s.length ? Ec(s, Yt(d, 3), !0) : [];
      }
      function Zd(s, d, C, A) {
        var F = s == null ? 0 : s.length;
        return F ? (C && typeof C != "number" && oi(s, d, C) && (C = 0, A = F), Pm(s, d, C, A)) : [];
      }
      function Ou(s, d, C) {
        var A = s == null ? 0 : s.length;
        if (!A)
          return -1;
        var F = C == null ? 0 : Sn(C);
        return F < 0 && (F = wa(A + F, 0)), md(s, Yt(d, 3), F);
      }
      function Oc(s, d, C) {
        var A = s == null ? 0 : s.length;
        if (!A)
          return -1;
        var F = A - 1;
        return C !== i && (F = Sn(C), F = C < 0 ? wa(A + F, 0) : ri(F, A - 1)), md(s, Yt(d, 3), F, !0);
      }
      function fh(s) {
        var d = s == null ? 0 : s.length;
        return d ? va(s, 1) : [];
      }
      function Lu(s) {
        var d = s == null ? 0 : s.length;
        return d ? va(s, We) : [];
      }
      function Ni(s, d) {
        var C = s == null ? 0 : s.length;
        return C ? (d = d === i ? 1 : Sn(d), va(s, d)) : [];
      }
      function dh(s) {
        for (var d = -1, C = s == null ? 0 : s.length, A = {}; ++d < C; ) {
          var F = s[d];
          A[F[0]] = F[1];
        }
        return A;
      }
      function Lc(s) {
        return s && s.length ? s[0] : i;
      }
      function Gs(s, d, C) {
        var A = s == null ? 0 : s.length;
        if (!A)
          return -1;
        var F = C == null ? 0 : Sn(C);
        return F < 0 && (F = wa(A + F, 0)), sc(s, d, F);
      }
      function ph(s) {
        var d = s == null ? 0 : s.length;
        return d ? na(s, 0, -1) : [];
      }
      var Rv = Ln(function(s) {
        var d = qn(s, Ru);
        return d.length && d[0] === s[0] ? Xp(d) : [];
      }), dl = Ln(function(s) {
        var d = Yi(s), C = qn(s, Ru);
        return d === Yi(C) ? d = i : C.pop(), C.length && C[0] === s[0] ? Xp(C, Yt(d, 2)) : [];
      }), Bf = Ln(function(s) {
        var d = Yi(s), C = qn(s, Ru);
        return d = typeof d == "function" ? d : i, d && C.pop(), C.length && C[0] === s[0] ? Xp(C, i, d) : [];
      });
      function pl(s, d) {
        return s == null ? "" : xd.call(s, d);
      }
      function Yi(s) {
        var d = s == null ? 0 : s.length;
        return d ? s[d - 1] : i;
      }
      function Jd(s, d, C) {
        var A = s == null ? 0 : s.length;
        if (!A)
          return -1;
        var F = A;
        return C !== i && (F = Sn(C), F = F < 0 ? wa(A + F, 0) : ri(F, A - 1)), d === d ? Am(s, d, F) : md(s, Jl, F, !0);
      }
      function hh(s, d) {
        return s && s.length ? Jp(s, Sn(d)) : i;
      }
      var Qd = Ln(Du);
      function Du(s, d) {
        return s && s.length && d && d.length ? rn(s, d) : s;
      }
      function si(s, d, C) {
        return s && s.length && d && d.length ? rn(s, d, Yt(C, 2)) : s;
      }
      function zs(s, d, C) {
        return s && s.length && d && d.length ? rn(s, d, i, C) : s;
      }
      var oa = os(function(s, d) {
        var C = s == null ? 0 : s.length, A = Gp(s, d);
        return _n(s, qn(d, function(F) {
          return Zr(F, C) ? +F : F;
        }).sort(Vd)), A;
      });
      function $a(s, d) {
        var C = [];
        if (!(s && s.length))
          return C;
        var A = -1, F = [], $ = s.length;
        for (d = Yt(d, 3); ++A < $; ) {
          var ee = s[A];
          d(ee, A, s) && (C.push(ee), F.push(A));
        }
        return _n(s, F), C;
      }
      function Uf(s) {
        return s == null ? s : Hp.call(s);
      }
      function Dc(s, d, C) {
        var A = s == null ? 0 : s.length;
        return A ? (C && typeof C != "number" && oi(s, d, C) ? (d = 0, C = A) : (d = d == null ? 0 : Sn(d), C = C === i ? A : Sn(C)), na(s, d, C)) : [];
      }
      function Tv(s, d) {
        return ji(s, d);
      }
      function wv(s, d, C) {
        return Eu(s, d, Yt(C, 2));
      }
      function cs(s, d) {
        var C = s == null ? 0 : s.length;
        if (C) {
          var A = ji(s, d);
          if (A < C && Xs(s[A], d))
            return A;
        }
        return -1;
      }
      function Vf(s, d) {
        return ji(s, d, !0);
      }
      function Iv(s, d, C) {
        return Eu(s, d, Yt(C, 2), !0);
      }
      function fs(s, d) {
        var C = s == null ? 0 : s.length;
        if (C) {
          var A = ji(s, d, !0) - 1;
          if (Xs(s[A], d))
            return A;
        }
        return -1;
      }
      function vh(s) {
        return s && s.length ? Su(s) : [];
      }
      function Mc(s, d) {
        return s && s.length ? Su(s, Yt(d, 2)) : [];
      }
      function jm(s) {
        var d = s == null ? 0 : s.length;
        return d ? na(s, 1, d) : [];
      }
      function Gm(s, d, C) {
        return s && s.length ? (d = C || d === i ? 1 : Sn(d), na(s, 0, d < 0 ? 0 : d)) : [];
      }
      function Kd(s, d, C) {
        var A = s == null ? 0 : s.length;
        return A ? (d = C || d === i ? 1 : Sn(d), d = A - d, na(s, d < 0 ? 0 : d, A)) : [];
      }
      function mh(s, d) {
        return s && s.length ? Ec(s, Yt(d, 3), !1, !0) : [];
      }
      function db(s, d) {
        return s && s.length ? Ec(s, Yt(d, 3)) : [];
      }
      var pb = Ln(function(s) {
        return Ol(va(s, 1, Na, !0));
      }), zm = Ln(function(s) {
        var d = Yi(s);
        return Na(d) && (d = i), Ol(va(s, 1, Na, !0), Yt(d, 2));
      }), Wm = Ln(function(s) {
        var d = Yi(s);
        return d = typeof d == "function" ? d : i, Ol(va(s, 1, Na, !0), i, d);
      });
      function Mu(s) {
        return s && s.length ? Ol(s) : [];
      }
      function hb(s, d) {
        return s && s.length ? Ol(s, Yt(d, 2)) : [];
      }
      function Hf(s, d) {
        return d = typeof d == "function" ? d : i, s && s.length ? Ol(s, i, d) : [];
      }
      function gh(s) {
        if (!(s && s.length))
          return [];
        var d = 0;
        return s = Ro(s, function(C) {
          if (Na(C))
            return d = wa(C.length, d), !0;
        }), Op(d, function(C) {
          return qn(s, gd(C));
        });
      }
      function la(s, d) {
        if (!(s && s.length))
          return [];
        var C = gh(s);
        return d == null ? C : qn(C, function(A) {
          return xn(d, i, A);
        });
      }
      var vb = Ln(function(s, d) {
        return Na(s) ? kr(s, d) : [];
      }), Xm = Ln(function(s) {
        return wf(Ro(s, Na));
      }), Av = Ln(function(s) {
        var d = Yi(s);
        return Na(d) && (d = i), wf(Ro(s, Na), Yt(d, 2));
      }), mb = Ln(function(s) {
        var d = Yi(s);
        return d = typeof d == "function" ? d : i, wf(Ro(s, Na), i, d);
      }), Ym = Ln(gh);
      function $m(s, d) {
        return Sc(s || [], d || [], vc);
      }
      function Zm(s, d) {
        return Sc(s || [], d || [], je);
      }
      var hl = Ln(function(s) {
        var d = s.length, C = d > 1 ? s[d - 1] : i;
        return C = typeof C == "function" ? (s.pop(), C) : i, la(s, C);
      });
      function bh(s) {
        var d = z(s);
        return d.__chain__ = !0, d;
      }
      function gb(s, d) {
        return d(s), s;
      }
      function Ml(s, d) {
        return d(s);
      }
      var yh = os(function(s) {
        var d = s.length, C = d ? s[0] : 0, A = this.__wrapped__, F = function($) {
          return Gp($, s);
        };
        return d > 1 || this.__actions__.length || !(A instanceof Rn) || !Zr(C) ? this.thru(F) : (A = A.slice(C, +C + (d ? 1 : 0)), A.__actions__.push({
          func: Ml,
          args: [F],
          thisArg: i
        }), new xi(A, this.__chain__).thru(function($) {
          return d && !$.length && $.push(i), $;
        }));
      });
      function Pc() {
        return bh(this);
      }
      function Ch() {
        return new xi(this.value(), this.__chain__);
      }
      function Eh() {
        this.__values__ === i && (this.__values__ = wh(this.value()));
        var s = this.__index__ >= this.__values__.length, d = s ? i : this.__values__[this.__index__++];
        return { done: s, value: d };
      }
      function qd() {
        return this;
      }
      function ep(s) {
        for (var d, C = this; C instanceof Bi; ) {
          var A = Hm(C);
          A.__index__ = 0, A.__values__ = i, d ? F.__wrapped__ = A : d = A;
          var F = A;
          C = C.__wrapped__;
        }
        return F.__wrapped__ = s, d;
      }
      function Nv() {
        var s = this.__wrapped__;
        if (s instanceof Rn) {
          var d = s;
          return this.__actions__.length && (d = new Rn(this)), d = d.reverse(), d.__actions__.push({
            func: Ml,
            args: [Uf],
            thisArg: i
          }), new xi(d, this.__chain__);
        }
        return this.thru(Uf);
      }
      function Jm() {
        return xu(this.__wrapped__, this.__actions__);
      }
      var _v = Rr(function(s, d, C) {
        fr.call(s, C) ? ++s[C] : Nl(s, C, 1);
      });
      function Ov(s, d, C) {
        var A = Tn(s) ? Zl : mc;
        return C && oi(s, d, C) && (d = i), A(s, Yt(d, 3));
      }
      function Sh(s, d) {
        var C = Tn(s) ? Ro : Od;
        return C(s, Yt(d, 3));
      }
      var tp = Bs(Ou), Qm = Bs(Oc);
      function Lv(s, d) {
        return va(kc(s, d), 1);
      }
      function bb(s, d) {
        return va(kc(s, d), We);
      }
      function Dv(s, d, C) {
        return C = C === i ? 1 : Sn(C), va(kc(s, d), C);
      }
      function np(s, d) {
        var C = Tn(s) ? Pn : as;
        return C(s, Yt(d, 3));
      }
      function jf(s, d) {
        var C = Tn(s) ? Hn : _d;
        return C(s, Yt(d, 3));
      }
      var Pu = Rr(function(s, d, C) {
        fr.call(s, C) ? s[C].push(d) : Nl(s, C, [d]);
      });
      function xh(s, d, C, A) {
        s = gi(s) ? s : Nh(s), C = C && !A ? Sn(C) : 0;
        var F = s.length;
        return C < 0 && (C = wa(F + C, 0)), ng(s) ? C <= F && s.indexOf(d, C) > -1 : !!F && sc(s, d, C) > -1;
      }
      var Km = Ln(function(s, d, C) {
        var A = -1, F = typeof d == "function", $ = gi(s) ? Re(s.length) : [];
        return as(s, function(ee) {
          $[++A] = F ? xn(d, ee, C) : ll(ee, d, C);
        }), $;
      }), yb = Rr(function(s, d, C) {
        Nl(s, C, d);
      });
      function kc(s, d) {
        var C = Tn(s) ? qn : gv;
        return C(s, Yt(d, 3));
      }
      function Cb(s, d, C, A) {
        return s == null ? [] : (Tn(d) || (d = d == null ? [] : [d]), C = A ? i : C, Tn(C) || (C = C == null ? [] : [C]), Md(s, d, C));
      }
      var rp = Rr(function(s, d, C) {
        s[C ? 0 : 1].push(d);
      }, function() {
        return [[], []];
      });
      function qm(s, d, C) {
        var A = Tn(s) ? lc : _p, F = arguments.length < 3;
        return A(s, Yt(d, 4), C, F, as);
      }
      function Rh(s, d, C) {
        var A = Tn(s) ? ev : _p, F = arguments.length < 3;
        return A(s, Yt(d, 4), C, F, _d);
      }
      function a(s, d) {
        var C = Tn(s) ? Ro : Od;
        return C(s, tt(Yt(d, 3)));
      }
      function o(s) {
        var d = Tn(s) ? ns : wi;
        return d(s);
      }
      function p(s, d, C) {
        (C ? oi(s, d, C) : d === i) ? d = 1 : d = Sn(d);
        var A = Tn(s) ? _o : kd;
        return A(s, d);
      }
      function b(s) {
        var d = Tn(s) ? pv : pi;
        return d(s);
      }
      function R(s) {
        if (s == null)
          return 0;
        if (gi(s))
          return ng(s) ? cu(s) : s.length;
        var d = $r(s);
        return d == fn || d == wr ? s.size : Ps(s).length;
      }
      function I(s, d, C) {
        var A = Tn(s) ? tv : ks;
        return C && oi(s, d, C) && (d = i), A(s, Yt(d, 3));
      }
      var V = Ln(function(s, d) {
        if (s == null)
          return [];
        var C = d.length;
        return C > 1 && oi(s, d[0], d[1]) ? d = [] : C > 2 && oi(d[0], d[1], d[2]) && (d = [d[0]]), Md(s, va(d, 1), []);
      }), K = Pr || function() {
        return Dr.Date.now();
      };
      function ie(s, d) {
        if (typeof d != "function")
          throw new Io(h);
        return s = Sn(s), function() {
          if (--s < 1)
            return d.apply(this, arguments);
        };
      }
      function we(s, d, C) {
        return d = C ? i : d, d = s && d == null ? s.length : d, cl(s, j, i, i, i, i, d);
      }
      function Qe(s, d) {
        var C;
        if (typeof d != "function")
          throw new Io(h);
        return s = Sn(s), function() {
          return --s > 0 && (C = d.apply(this, arguments)), s <= 1 && (d = i), C;
        };
      }
      var Ke = Ln(function(s, d, C) {
        var A = B;
        if (C.length) {
          var F = Qo(C, Hs(Ke));
          A |= W;
        }
        return cl(s, A, d, C, F);
      }), Ye = Ln(function(s, d, C) {
        var A = B | H;
        if (C.length) {
          var F = Qo(C, Hs(Ye));
          A |= W;
        }
        return cl(d, A, s, C, F);
      });
      function Ct(s, d, C) {
        d = C ? i : d;
        var A = cl(s, G, i, i, i, i, i, d);
        return A.placeholder = Ct.placeholder, A;
      }
      function Ot(s, d, C) {
        d = C ? i : d;
        var A = cl(s, Q, i, i, i, i, i, d);
        return A.placeholder = Ot.placeholder, A;
      }
      function Lt(s, d, C) {
        var A, F, $, ee, ae, de, He = 0, Be = !1, Xe = !1, ft = !0;
        if (typeof s != "function")
          throw new Io(h);
        d = ds(d) || 0, ba(C) && (Be = !!C.leading, Xe = "maxWait" in C, $ = Xe ? wa(ds(C.maxWait) || 0, d) : $, ft = "trailing" in C ? !!C.trailing : ft);
        function Dt(ya) {
          var bi = A, go = F;
          return A = F = i, He = ya, ee = s.apply(go, bi), ee;
        }
        function en(ya) {
          return He = ya, ae = us(jn, d), Be ? Dt(ya) : ee;
        }
        function On(ya) {
          var bi = ya - de, go = ya - He, $i = d - bi;
          return Xe ? ri($i, $ - go) : $i;
        }
        function cn(ya) {
          var bi = ya - de, go = ya - He;
          return de === i || bi >= d || bi < 0 || Xe && go >= $;
        }
        function jn() {
          var ya = K();
          if (cn(ya))
            return er(ya);
          ae = us(jn, On(ya));
        }
        function er(ya) {
          return ae = i, ft && A ? Dt(ya) : (A = F = i, ee);
        }
        function mo() {
          ae !== i && Bd(ae), He = 0, A = de = F = ae = i;
        }
        function sa() {
          return ae === i ? ee : er(K());
        }
        function Do() {
          var ya = K(), bi = cn(ya);
          if (A = arguments, F = this, de = ya, bi) {
            if (ae === i)
              return en(de);
            if (Xe)
              return Bd(ae), ae = us(jn, d), Dt(de);
          }
          return ae === i && (ae = us(jn, d)), ee;
        }
        return Do.cancel = mo, Do.flush = sa, Do;
      }
      var Aa = Ln(function(s, d) {
        return hv(s, 1, d);
      }), ge = Ln(function(s, d, C) {
        return hv(s, ds(d) || 0, C);
      });
      function le(s) {
        return cl(s, me);
      }
      function ye(s, d) {
        if (typeof s != "function" || d != null && typeof d != "function")
          throw new Io(h);
        var C = function() {
          var A = arguments, F = d ? d.apply(this, A) : A[0], $ = C.cache;
          if ($.has(F))
            return $.get(F);
          var ee = s.apply(this, A);
          return C.cache = $.set(F, ee) || $, ee;
        };
        return C.cache = new (ye.Cache || rl)(), C;
      }
      ye.Cache = rl;
      function tt(s) {
        if (typeof s != "function")
          throw new Io(h);
        return function() {
          var d = arguments;
          switch (d.length) {
            case 0:
              return !s.call(this);
            case 1:
              return !s.call(this, d[0]);
            case 2:
              return !s.call(this, d[0], d[1]);
            case 3:
              return !s.call(this, d[0], d[1], d[2]);
          }
          return !s.apply(this, d);
        };
      }
      function Bt(s) {
        return Qe(2, s);
      }
      var Jt = Qp(function(s, d) {
        d = d.length == 1 && Tn(d[0]) ? qn(d[0], ur(Yt())) : qn(va(d, 1), ur(Yt()));
        var C = d.length;
        return Ln(function(A) {
          for (var F = -1, $ = ri(A.length, C); ++F < $; )
            A[F] = d[F].call(this, A[F]);
          return xn(s, this, A);
        });
      }), Nt = Ln(function(s, d) {
        var C = Qo(d, Hs(Nt));
        return cl(s, W, i, d, C);
      }), Qt = Ln(function(s, d) {
        var C = Qo(d, Hs(Qt));
        return cl(s, oe, i, d, C);
      }), Za = os(function(s, d) {
        return cl(s, re, i, i, i, d);
      });
      function dr(s, d) {
        if (typeof s != "function")
          throw new Io(h);
        return d = d === i ? d : Sn(d), Ln(s, d);
      }
      function Ws(s, d) {
        if (typeof s != "function")
          throw new Io(h);
        return d = d == null ? 0 : wa(Sn(d), 0), Ln(function(C) {
          var A = C[d], F = Ll(C, 0, d);
          return A && Jo(F, A), xn(s, this, F);
        });
      }
      function Eb(s, d, C) {
        var A = !0, F = !0;
        if (typeof s != "function")
          throw new Io(h);
        return ba(C) && (A = "leading" in C ? !!C.leading : A, F = "trailing" in C ? !!C.trailing : F), Lt(s, d, {
          leading: A,
          maxWait: d,
          trailing: F
        });
      }
      function XC(s) {
        return we(s, 1);
      }
      function YC(s, d) {
        return Nt(If(d), s);
      }
      function f0() {
        if (!arguments.length)
          return [];
        var s = arguments[0];
        return Tn(s) ? s : [s];
      }
      function d0(s) {
        return Ui(s, L);
      }
      function $C(s, d) {
        return d = typeof d == "function" ? d : i, Ui(s, L, d);
      }
      function ZC(s) {
        return Ui(s, T | L);
      }
      function p0(s, d) {
        return d = typeof d == "function" ? d : i, Ui(s, T | L, d);
      }
      function Sb(s, d) {
        return d == null || Nd(s, d, _i(d));
      }
      function Xs(s, d) {
        return s === d || s !== s && d !== d;
      }
      var JC = jd(yu), QC = jd(function(s, d) {
        return s >= d;
      }), ap = Ld(function() {
        return arguments;
      }()) ? Ld : function(s) {
        return _a(s) && fr.call(s, "callee") && !fu.call(s, "callee");
      }, Tn = Re.isArray, KC = Xt ? ur(Xt) : Cf;
      function gi(s) {
        return s != null && kv(s.length) && !Fu(s);
      }
      function Na(s) {
        return _a(s) && gi(s);
      }
      function Mv(s) {
        return s === !0 || s === !1 || _a(s) && di(s) == ht;
      }
      var ku = Vp || Yb, qC = pt ? ur(pt) : ho;
      function eE(s) {
        return _a(s) && s.nodeType === 1 && !ip(s);
      }
      function h0(s) {
        if (s == null)
          return !0;
        if (gi(s) && (Tn(s) || typeof s == "string" || typeof s.splice == "function" || ku(s) || Wf(s) || ap(s)))
          return !s.length;
        var d = $r(s);
        if (d == fn || d == wr)
          return !s.size;
        if (ss(s))
          return !Ps(s).length;
        for (var C in s)
          if (fr.call(s, C))
            return !1;
        return !0;
      }
      function tE(s, d) {
        return sl(s, d);
      }
      function eg(s, d, C) {
        C = typeof C == "function" ? C : i;
        var A = C ? C(s, d) : i;
        return A === i ? sl(s, d, i, C) : !!A;
      }
      function Gf(s) {
        if (!_a(s))
          return !1;
        var d = di(s);
        return d == bn || d == sn || typeof s.message == "string" && typeof s.name == "string" && !ip(s);
      }
      function xb(s) {
        return typeof s == "number" && hf(s);
      }
      function Fu(s) {
        if (!ba(s))
          return !1;
        var d = di(s);
        return d == Ze || d == mn || d == Rt || d == ja;
      }
      function Pv(s) {
        return typeof s == "number" && s == Sn(s);
      }
      function kv(s) {
        return typeof s == "number" && s > -1 && s % 1 == 0 && s <= he;
      }
      function ba(s) {
        var d = typeof s;
        return s != null && (d == "object" || d == "function");
      }
      function _a(s) {
        return s != null && typeof s == "object";
      }
      var Rb = Wt ? ur(Wt) : km;
      function v0(s, d) {
        return s === d || Ef(s, d, Lf(d));
      }
      function m0(s, d, C) {
        return C = typeof C == "function" ? C : i, Ef(s, d, Lf(d), C);
      }
      function zf(s) {
        return Th(s) && s != +s;
      }
      function nE(s) {
        if (fb(s))
          throw new gn(v);
        return vv(s);
      }
      function rE(s) {
        return s === null;
      }
      function aE(s) {
        return s == null;
      }
      function Th(s) {
        return typeof s == "number" || _a(s) && di(s) == Gn;
      }
      function ip(s) {
        if (!_a(s) || di(s) != Jn)
          return !1;
        var d = Ko(s);
        if (d === null)
          return !0;
        var C = fr.call(d, "constructor") && d.constructor;
        return typeof C == "function" && C instanceof C && yd.call(C) == ni;
      }
      var tg = Nn ? ur(Nn) : Dd;
      function iE(s) {
        return Pv(s) && s >= -he && s <= he;
      }
      var Tb = Yn ? ur(Yn) : _l;
      function ng(s) {
        return typeof s == "string" || !Tn(s) && _a(s) && di(s) == Da;
      }
      function $n(s) {
        return typeof s == "symbol" || _a(s) && di(s) == Sa;
      }
      var Wf = Ir ? ur(Ir) : Sf;
      function rg(s) {
        return s === i;
      }
      function Fv(s) {
        return _a(s) && $r(s) == Or;
      }
      function g0(s) {
        return _a(s) && di(s) == fi;
      }
      var b0 = jd(Cu), wb = jd(function(s, d) {
        return s <= d;
      });
      function wh(s) {
        if (!s)
          return [];
        if (gi(s))
          return ng(s) ? wo(s) : Wa(s);
        if (Os && s[Os])
          return Im(s[Os]());
        var d = $r(s), C = d == fn ? Dp : d == wr ? Ns : Nh;
        return C(s);
      }
      function Fc(s) {
        if (!s)
          return s === 0 ? s : 0;
        if (s = ds(s), s === We || s === -We) {
          var d = s < 0 ? -1 : 1;
          return d * ke;
        }
        return s === s ? s : 0;
      }
      function Sn(s) {
        var d = Fc(s), C = d % 1;
        return d === d ? C ? d - C : d : 0;
      }
      function op(s) {
        return s ? rs(Sn(s), 0, q) : 0;
      }
      function ds(s) {
        if (typeof s == "number")
          return s;
        if ($n(s))
          return _e;
        if (ba(s)) {
          var d = typeof s.valueOf == "function" ? s.valueOf() : s;
          s = ba(d) ? d + "" : d;
        }
        if (typeof s != "string")
          return s === 0 ? s : +s;
        s = Ql(s);
        var C = Et.test(s);
        return C || Zt.test(s) ? ic(s.slice(2), C ? 2 : 8) : bt.test(s) ? _e : +s;
      }
      function Ib(s) {
        return hi(s, ml(s));
      }
      function oE(s) {
        return s ? rs(Sn(s), -he, he) : s === 0 ? s : 0;
      }
      function Nr(s) {
        return s == null ? "" : Ii(s);
      }
      var vl = Fs(function(s, d) {
        if (ss(d) || gi(d)) {
          hi(d, _i(d), s);
          return;
        }
        for (var C in d)
          fr.call(d, C) && vc(s, C, d[C]);
      }), Ih = Fs(function(s, d) {
        hi(d, ml(d), s);
      }), lp = Fs(function(s, d, C, A) {
        hi(d, ml(d), s, A);
      }), Xf = Fs(function(s, d, C, A) {
        hi(d, _i(d), s, A);
      }), y0 = os(Gp);
      function sp(s, d) {
        var C = vu(s);
        return d == null ? C : Vr(C, d);
      }
      var up = Ln(function(s, d) {
        s = br(s);
        var C = -1, A = d.length, F = A > 2 ? d[2] : i;
        for (F && oi(d[0], d[1], F) && (A = 1); ++C < A; )
          for (var $ = d[C], ee = ml($), ae = -1, de = ee.length; ++ae < de; ) {
            var He = ee[ae], Be = s[He];
            (Be === i || Xs(Be, Kl[He]) && !fr.call(s, He)) && (s[He] = $[He]);
          }
        return s;
      }), ag = Ln(function(s) {
        return s.push(i, Nu), xn(R0, i, s);
      });
      function Ab(s, d) {
        return av(s, Yt(d, 3), Ar);
      }
      function ig(s, d) {
        return av(s, Yt(d, 3), ct);
      }
      function Bv(s, d) {
        return s == null ? s : zp(s, Yt(d, 3), ml);
      }
      function C0(s, d) {
        return s == null ? s : is(s, Yt(d, 3), ml);
      }
      function og(s, d) {
        return s && Ar(s, Yt(d, 3));
      }
      function E0(s, d) {
        return s && ct(s, Yt(d, 3));
      }
      function S0(s) {
        return s == null ? [] : Vi(s, _i(s));
      }
      function lE(s) {
        return s == null ? [] : Vi(s, ml(s));
      }
      function Nb(s, d, C) {
        var A = s == null ? i : za(s, d);
        return A === i ? C : A;
      }
      function lg(s, d) {
        return s != null && Lo(s, d, ol);
      }
      function Ah(s, d) {
        return s != null && Lo(s, d, gc);
      }
      var x0 = Cv(function(s, d, C) {
        d != null && typeof d.toString != "function" && (d = ff.call(d)), s[d] = C;
      }, Vb(gl)), sE = Cv(function(s, d, C) {
        d != null && typeof d.toString != "function" && (d = ff.call(d)), fr.call(s, d) ? s[d].push(C) : s[d] = [C];
      }, Yt), sg = Ln(ll);
      function _i(s) {
        return gi(s) ? ii(s) : Ps(s);
      }
      function ml(s) {
        return gi(s) ? ii(s, !0) : mv(s);
      }
      function uE(s, d) {
        var C = {};
        return d = Yt(d, 3), Ar(s, function(A, F, $) {
          Nl(C, d(A, F, $), A);
        }), C;
      }
      function cE(s, d) {
        var C = {};
        return d = Yt(d, 3), Ar(s, function(A, F, $) {
          Nl(C, F, d(A, F, $));
        }), C;
      }
      var fE = Fs(function(s, d, C) {
        bc(s, d, C);
      }), R0 = Fs(function(s, d, C, A) {
        bc(s, d, C, A);
      }), dE = os(function(s, d) {
        var C = {};
        if (s == null)
          return C;
        var A = !1;
        d = qn(d, function($) {
          return $ = ul($, s), A || (A = $.length > 1), $;
        }), hi(s, Vs(s), C), A && (C = Ui(C, T | _ | L, yn));
        for (var F = d.length; F--; )
          Tf(C, d[F]);
        return C;
      });
      function pE(s, d) {
        return T0(s, tt(Yt(d)));
      }
      var hE = os(function(s, d) {
        return s == null ? {} : Pd(s, d);
      });
      function T0(s, d) {
        if (s == null)
          return {};
        var C = qn(Vs(s), function(A) {
          return [A];
        });
        return d = Yt(d), Ft(s, C, function(A, F) {
          return d(A, F[0]);
        });
      }
      function _b(s, d, C) {
        d = ul(d, s);
        var A = -1, F = d.length;
        for (F || (F = 1, s = i); ++A < F; ) {
          var $ = s == null ? i : s[Xi(d[A])];
          $ === i && (A = F, $ = C), s = Fu($) ? $.call(s) : $;
        }
        return s;
      }
      function Ob(s, d, C) {
        return s == null ? s : je(s, d, C);
      }
      function Lb(s, d, C, A) {
        return A = typeof A == "function" ? A : i, s == null ? s : je(s, d, C, A);
      }
      var ug = Us(_i), w0 = Us(ml);
      function Uv(s, d, C) {
        var A = Tn(s), F = A || ku(s) || Wf(s);
        if (d = Yt(d, 4), C == null) {
          var $ = s && s.constructor;
          F ? C = A ? new $() : [] : ba(s) ? C = Fu($) ? vu(Ko(s)) : {} : C = {};
        }
        return (F ? Pn : Ar)(s, function(ee, ae, de) {
          return d(C, ee, ae, de);
        }), C;
      }
      function Vv(s, d) {
        return s == null ? !0 : Tf(s, d);
      }
      function vE(s, d, C) {
        return s == null ? s : Fd(s, d, If(C));
      }
      function I0(s, d, C, A) {
        return A = typeof A == "function" ? A : i, s == null ? s : Fd(s, d, If(C), A);
      }
      function Nh(s) {
        return s == null ? [] : To(s, _i(s));
      }
      function mE(s) {
        return s == null ? [] : To(s, ml(s));
      }
      function A0(s, d, C) {
        return C === i && (C = d, d = i), C !== i && (C = ds(C), C = C === C ? C : 0), d !== i && (d = ds(d), d = d === d ? d : 0), rs(ds(s), d, C);
      }
      function gE(s, d, C) {
        return d = Fc(d), C === i ? (C = d, d = 0) : C = Fc(C), s = ds(s), Fa(s, d, C);
      }
      function bE(s, d, C) {
        if (C && typeof C != "boolean" && oi(s, d, C) && (d = C = i), C === i && (typeof d == "boolean" ? (C = d, d = i) : typeof s == "boolean" && (C = s, s = i)), s === i && d === i ? (s = 0, d = 1) : (s = Fc(s), d === i ? (d = s, s = 0) : d = Fc(d)), s > d) {
          var A = s;
          s = d, d = A;
        }
        if (C || s % 1 || d % 1) {
          var F = Rd();
          return ri(s + F * (d - s + su("1e-" + ((F + "").length - 1))), d);
        }
        return Hi(s, d);
      }
      var N0 = Tc(function(s, d, C) {
        return d = d.toLowerCase(), s + (C ? Hv(d) : d);
      });
      function Hv(s) {
        return Bb(Nr(s).toLowerCase());
      }
      function jv(s) {
        return s = Nr(s), s && s.replace(sr, Tm).replace(lo, "");
      }
      function cg(s, d, C) {
        s = Nr(s), d = Ii(d);
        var A = s.length;
        C = C === i ? A : rs(Sn(C), 0, A);
        var F = C;
        return C -= d.length, C >= 0 && s.slice(C, F) == d;
      }
      function Gv(s) {
        return s = Nr(s), s && Pi.test(s) ? s.replace(Xn, wm) : s;
      }
      function zv(s) {
        return s = Nr(s), s && ce.test(s) ? s.replace(ne, "\\$&") : s;
      }
      var yE = Tc(function(s, d, C) {
        return s + (C ? "-" : "") + d.toLowerCase();
      }), Db = Tc(function(s, d, C) {
        return s + (C ? " " : "") + d.toLowerCase();
      }), Mb = bv("toLowerCase");
      function CE(s, d, C) {
        s = Nr(s), d = Sn(d);
        var A = d ? cu(s) : 0;
        if (!d || A >= d)
          return s;
        var F = (d - A) / 2;
        return Au(Ls(F), C) + s + Au(qo(F), C);
      }
      function EE(s, d, C) {
        s = Nr(s), d = Sn(d);
        var A = d ? cu(s) : 0;
        return d && A < d ? s + Au(d - A, C) : s;
      }
      function Y2(s, d, C) {
        s = Nr(s), d = Sn(d);
        var A = d ? cu(s) : 0;
        return d && A < d ? Au(d - A, C) + s : s;
      }
      function SE(s, d, C) {
        return C || d == null ? d = 0 : d && (d = +d), fv(Nr(s).replace(xe, ""), d || 0);
      }
      function xE(s, d, C) {
        return (C ? oi(s, d, C) : d === i) ? d = 1 : d = Sn(d), yc(Nr(s), d);
      }
      function RE() {
        var s = arguments, d = Nr(s[0]);
        return s.length < 3 ? d : d.replace(s[1], s[2]);
      }
      var TE = Tc(function(s, d, C) {
        return s + (C ? "_" : "") + d.toLowerCase();
      });
      function wE(s, d, C) {
        return C && typeof C != "number" && oi(s, d, C) && (d = C = i), C = C === i ? q : C >>> 0, C ? (s = Nr(s), s && (typeof d == "string" || d != null && !tg(d)) && (d = Ii(d), !d && of(s)) ? Ll(wo(s), 0, C) : s.split(d, C)) : [];
      }
      var IE = Tc(function(s, d, C) {
        return s + (C ? " " : "") + Bb(d);
      });
      function Pb(s, d, C) {
        return s = Nr(s), C = C == null ? 0 : rs(Sn(C), 0, s.length), d = Ii(d), s.slice(C, C + d.length) == d;
      }
      function AE(s, d, C) {
        var A = z.templateSettings;
        C && oi(s, d, C) && (d = i), s = Nr(s), d = lp({}, d, A, Wi);
        var F = lp({}, d.imports, A.imports, Wi), $ = _i(F), ee = To(F, $), ae, de, He = 0, Be = d.interpolate || Wr, Xe = "__p += '", ft = wl(
          (d.escape || Wr).source + "|" + Be.source + "|" + (Be === Xo ? Fe : Wr).source + "|" + (d.evaluate || Wr).source + "|$",
          "g"
        ), Dt = "//# sourceURL=" + (fr.call(d, "sourceURL") ? (d.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Np + "]") + `
`;
        s.replace(ft, function(cn, jn, er, mo, sa, Do) {
          return er || (er = mo), Xe += s.slice(He, Do).replace(Ma, Lp), jn && (ae = !0, Xe += `' +
__e(` + jn + `) +
'`), sa && (de = !0, Xe += `';
` + sa + `;
__p += '`), er && (Xe += `' +
((__t = (` + er + `)) == null ? '' : __t) +
'`), He = Do + cn.length, cn;
        }), Xe += `';
`;
        var en = fr.call(d, "variable") && d.variable;
        if (!en)
          Xe = `with (obj) {
` + Xe + `
}
`;
        else if (ve.test(en))
          throw new gn(y);
        Xe = (de ? Xe.replace(Ga, "") : Xe).replace(Qn, "$1").replace(qa, "$1;"), Xe = "function(" + (en || "obj") + `) {
` + (en ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ae ? ", __e = _.escape" : "") + (de ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Xe + `return __p
}`;
        var On = O0(function() {
          return cr($, Dt + "return " + Xe).apply(i, ee);
        });
        if (On.source = Xe, Gf(On))
          throw On;
        return On;
      }
      function NE(s) {
        return Nr(s).toLowerCase();
      }
      function kb(s) {
        return Nr(s).toUpperCase();
      }
      function _E(s, d, C) {
        if (s = Nr(s), s && (C || d === i))
          return Ql(s);
        if (!s || !(d = Ii(d)))
          return s;
        var A = wo(s), F = wo(d), $ = bd(A, F), ee = ov(A, F) + 1;
        return Ll(A, $, ee).join("");
      }
      function Fb(s, d, C) {
        if (s = Nr(s), s && (C || d === i))
          return s.slice(0, Mp(s) + 1);
        if (!s || !(d = Ii(d)))
          return s;
        var A = wo(s), F = ov(A, wo(d)) + 1;
        return Ll(A, 0, F).join("");
      }
      function _0(s, d, C) {
        if (s = Nr(s), s && (C || d === i))
          return s.replace(xe, "");
        if (!s || !(d = Ii(d)))
          return s;
        var A = wo(s), F = bd(A, wo(d));
        return Ll(A, F).join("");
      }
      function OE(s, d) {
        var C = Se, A = Ne;
        if (ba(d)) {
          var F = "separator" in d ? d.separator : F;
          C = "length" in d ? Sn(d.length) : C, A = "omission" in d ? Ii(d.omission) : A;
        }
        s = Nr(s);
        var $ = s.length;
        if (of(s)) {
          var ee = wo(s);
          $ = ee.length;
        }
        if (C >= $)
          return s;
        var ae = C - cu(A);
        if (ae < 1)
          return A;
        var de = ee ? Ll(ee, 0, ae).join("") : s.slice(0, ae);
        if (F === i)
          return de + A;
        if (ee && (ae += de.length - ae), tg(F)) {
          if (s.slice(ae).search(F)) {
            var He, Be = de;
            for (F.global || (F = wl(F.source, Nr(ut.exec(F)) + "g")), F.lastIndex = 0; He = F.exec(Be); )
              var Xe = He.index;
            de = de.slice(0, Xe === i ? ae : Xe);
          }
        } else if (s.indexOf(Ii(F), ae) != ae) {
          var ft = de.lastIndexOf(F);
          ft > -1 && (de = de.slice(0, ft));
        }
        return de + A;
      }
      function LE(s) {
        return s = Nr(s), s && So.test(s) ? s.replace(Wn, Nm) : s;
      }
      var DE = Tc(function(s, d, C) {
        return s + (C ? " " : "") + d.toUpperCase();
      }), Bb = bv("toUpperCase");
      function Ub(s, d, C) {
        return s = Nr(s), d = C ? i : d, d === i ? rb(s) ? ab(s) : rv(s) : s.match(d) || [];
      }
      var O0 = Ln(function(s, d) {
        try {
          return xn(s, i, d);
        } catch (C) {
          return Gf(C) ? C : new gn(C);
        }
      }), ME = os(function(s, d) {
        return Pn(d, function(C) {
          C = Xi(C), Nl(s, C, Ke(s[C], s));
        }), s;
      });
      function PE(s) {
        var d = s == null ? 0 : s.length, C = Yt();
        return s = d ? qn(s, function(A) {
          if (typeof A[1] != "function")
            throw new Io(h);
          return [C(A[0]), A[1]];
        }) : [], Ln(function(A) {
          for (var F = -1; ++F < d; ) {
            var $ = s[F];
            if (xn($[0], this, A))
              return xn($[1], this, A);
          }
        });
      }
      function kE(s) {
        return Mm(Ui(s, T));
      }
      function Vb(s) {
        return function() {
          return s;
        };
      }
      function FE(s, d) {
        return s == null || s !== s ? d : s;
      }
      var BE = nh(), Hb = nh(!0);
      function gl(s) {
        return s;
      }
      function jb(s) {
        return xf(typeof s == "function" ? s : Ui(s, T));
      }
      function UE(s) {
        return $p(Ui(s, T));
      }
      function VE(s, d) {
        return Yr(s, Ui(d, T));
      }
      var HE = Ln(function(s, d) {
        return function(C) {
          return ll(C, s, d);
        };
      }), jE = Ln(function(s, d) {
        return function(C) {
          return ll(s, C, d);
        };
      });
      function Gb(s, d, C) {
        var A = _i(d), F = Vi(d, A);
        C == null && !(ba(d) && (F.length || !A.length)) && (C = d, d = s, s = this, F = Vi(d, _i(d)));
        var $ = !(ba(C) && "chain" in C) || !!C.chain, ee = Fu(s);
        return Pn(F, function(ae) {
          var de = d[ae];
          s[ae] = de, ee && (s.prototype[ae] = function() {
            var He = this.__chain__;
            if ($ || He) {
              var Be = s(this.__wrapped__), Xe = Be.__actions__ = Wa(this.__actions__);
              return Xe.push({ func: de, args: arguments, thisArg: s }), Be.__chain__ = He, Be;
            }
            return de.apply(s, Jo([this.value()], arguments));
          });
        }), s;
      }
      function GE() {
        return Dr._ === this && (Dr._ = uv), this;
      }
      function zb() {
      }
      function L0(s) {
        return s = Sn(s), Ln(function(d) {
          return Jp(d, s);
        });
      }
      var Wb = rh(qn), zE = rh(Zl), WE = rh(tv);
      function Wv(s) {
        return xt(s) ? gd(Xi(s)) : Ut(s);
      }
      function Xv(s) {
        return function(d) {
          return s == null ? i : za(s, d);
        };
      }
      var XE = ah(), YE = ah(!0);
      function Xb() {
        return [];
      }
      function Yb() {
        return !1;
      }
      function $E() {
        return {};
      }
      function ZE() {
        return "";
      }
      function JE() {
        return !0;
      }
      function D0(s, d) {
        if (s = Sn(s), s < 1 || s > he)
          return [];
        var C = q, A = ri(s, q);
        d = Yt(d), s -= q;
        for (var F = Op(A, d); ++C < s; )
          d(C);
        return F;
      }
      function QE(s) {
        return Tn(s) ? qn(s, Xi) : $n(s) ? [s] : Wa(uh(Nr(s)));
      }
      function KE(s) {
        var d = ++uc;
        return Nr(s) + d;
      }
      var qE = Hd(function(s, d) {
        return s + d;
      }, 0), eS = aa("ceil"), tS = Hd(function(s, d) {
        return s / d;
      }, 1), nS = aa("floor");
      function rS(s) {
        return s && s.length ? Oo(s, gl, yu) : i;
      }
      function aS(s, d) {
        return s && s.length ? Oo(s, Yt(d, 2), yu) : i;
      }
      function iS(s) {
        return Rm(s, gl);
      }
      function oS(s, d) {
        return Rm(s, Yt(d, 2));
      }
      function lS(s) {
        return s && s.length ? Oo(s, gl, Cu) : i;
      }
      function sS(s, d) {
        return s && s.length ? Oo(s, Yt(d, 2), Cu) : i;
      }
      var uS = Hd(function(s, d) {
        return s * d;
      }, 1), cS = aa("round"), fS = Hd(function(s, d) {
        return s - d;
      }, 0);
      function dS(s) {
        return s && s.length ? nf(s, gl) : 0;
      }
      function _h(s, d) {
        return s && s.length ? nf(s, Yt(d, 2)) : 0;
      }
      return z.after = ie, z.ary = we, z.assign = vl, z.assignIn = Ih, z.assignInWith = lp, z.assignWith = Xf, z.at = y0, z.before = Qe, z.bind = Ke, z.bindAll = ME, z.bindKey = Ye, z.castArray = f0, z.chain = bh, z.chunk = _c, z.compact = ch, z.concat = fl, z.cond = PE, z.conforms = kE, z.constant = Vb, z.countBy = _v, z.create = sp, z.curry = Ct, z.curryRight = Ot, z.debounce = Lt, z.defaults = up, z.defaultsDeep = ag, z.defer = Aa, z.delay = ge, z.difference = kn, z.differenceBy = ga, z.differenceWith = Qr, z.drop = Xa, z.dropRight = vo, z.dropRightWhile = Ff, z.dropWhile = Ya, z.fill = Zd, z.filter = Sh, z.flatMap = Lv, z.flatMapDeep = bb, z.flatMapDepth = Dv, z.flatten = fh, z.flattenDeep = Lu, z.flattenDepth = Ni, z.flip = le, z.flow = BE, z.flowRight = Hb, z.fromPairs = dh, z.functions = S0, z.functionsIn = lE, z.groupBy = Pu, z.initial = ph, z.intersection = Rv, z.intersectionBy = dl, z.intersectionWith = Bf, z.invert = x0, z.invertBy = sE, z.invokeMap = Km, z.iteratee = jb, z.keyBy = yb, z.keys = _i, z.keysIn = ml, z.map = kc, z.mapKeys = uE, z.mapValues = cE, z.matches = UE, z.matchesProperty = VE, z.memoize = ye, z.merge = fE, z.mergeWith = R0, z.method = HE, z.methodOf = jE, z.mixin = Gb, z.negate = tt, z.nthArg = L0, z.omit = dE, z.omitBy = pE, z.once = Bt, z.orderBy = Cb, z.over = Wb, z.overArgs = Jt, z.overEvery = zE, z.overSome = WE, z.partial = Nt, z.partialRight = Qt, z.partition = rp, z.pick = hE, z.pickBy = T0, z.property = Wv, z.propertyOf = Xv, z.pull = Qd, z.pullAll = Du, z.pullAllBy = si, z.pullAllWith = zs, z.pullAt = oa, z.range = XE, z.rangeRight = YE, z.rearg = Za, z.reject = a, z.remove = $a, z.rest = dr, z.reverse = Uf, z.sampleSize = p, z.set = Ob, z.setWith = Lb, z.shuffle = b, z.slice = Dc, z.sortBy = V, z.sortedUniq = vh, z.sortedUniqBy = Mc, z.split = wE, z.spread = Ws, z.tail = jm, z.take = Gm, z.takeRight = Kd, z.takeRightWhile = mh, z.takeWhile = db, z.tap = gb, z.throttle = Eb, z.thru = Ml, z.toArray = wh, z.toPairs = ug, z.toPairsIn = w0, z.toPath = QE, z.toPlainObject = Ib, z.transform = Uv, z.unary = XC, z.union = pb, z.unionBy = zm, z.unionWith = Wm, z.uniq = Mu, z.uniqBy = hb, z.uniqWith = Hf, z.unset = Vv, z.unzip = gh, z.unzipWith = la, z.update = vE, z.updateWith = I0, z.values = Nh, z.valuesIn = mE, z.without = vb, z.words = Ub, z.wrap = YC, z.xor = Xm, z.xorBy = Av, z.xorWith = mb, z.zip = Ym, z.zipObject = $m, z.zipObjectDeep = Zm, z.zipWith = hl, z.entries = ug, z.entriesIn = w0, z.extend = Ih, z.extendWith = lp, Gb(z, z), z.add = qE, z.attempt = O0, z.camelCase = N0, z.capitalize = Hv, z.ceil = eS, z.clamp = A0, z.clone = d0, z.cloneDeep = ZC, z.cloneDeepWith = p0, z.cloneWith = $C, z.conformsTo = Sb, z.deburr = jv, z.defaultTo = FE, z.divide = tS, z.endsWith = cg, z.eq = Xs, z.escape = Gv, z.escapeRegExp = zv, z.every = Ov, z.find = tp, z.findIndex = Ou, z.findKey = Ab, z.findLast = Qm, z.findLastIndex = Oc, z.findLastKey = ig, z.floor = nS, z.forEach = np, z.forEachRight = jf, z.forIn = Bv, z.forInRight = C0, z.forOwn = og, z.forOwnRight = E0, z.get = Nb, z.gt = JC, z.gte = QC, z.has = lg, z.hasIn = Ah, z.head = Lc, z.identity = gl, z.includes = xh, z.indexOf = Gs, z.inRange = gE, z.invoke = sg, z.isArguments = ap, z.isArray = Tn, z.isArrayBuffer = KC, z.isArrayLike = gi, z.isArrayLikeObject = Na, z.isBoolean = Mv, z.isBuffer = ku, z.isDate = qC, z.isElement = eE, z.isEmpty = h0, z.isEqual = tE, z.isEqualWith = eg, z.isError = Gf, z.isFinite = xb, z.isFunction = Fu, z.isInteger = Pv, z.isLength = kv, z.isMap = Rb, z.isMatch = v0, z.isMatchWith = m0, z.isNaN = zf, z.isNative = nE, z.isNil = aE, z.isNull = rE, z.isNumber = Th, z.isObject = ba, z.isObjectLike = _a, z.isPlainObject = ip, z.isRegExp = tg, z.isSafeInteger = iE, z.isSet = Tb, z.isString = ng, z.isSymbol = $n, z.isTypedArray = Wf, z.isUndefined = rg, z.isWeakMap = Fv, z.isWeakSet = g0, z.join = pl, z.kebabCase = yE, z.last = Yi, z.lastIndexOf = Jd, z.lowerCase = Db, z.lowerFirst = Mb, z.lt = b0, z.lte = wb, z.max = rS, z.maxBy = aS, z.mean = iS, z.meanBy = oS, z.min = lS, z.minBy = sS, z.stubArray = Xb, z.stubFalse = Yb, z.stubObject = $E, z.stubString = ZE, z.stubTrue = JE, z.multiply = uS, z.nth = hh, z.noConflict = GE, z.noop = zb, z.now = K, z.pad = CE, z.padEnd = EE, z.padStart = Y2, z.parseInt = SE, z.random = bE, z.reduce = qm, z.reduceRight = Rh, z.repeat = xE, z.replace = RE, z.result = _b, z.round = cS, z.runInContext = fe, z.sample = o, z.size = R, z.snakeCase = TE, z.some = I, z.sortedIndex = Tv, z.sortedIndexBy = wv, z.sortedIndexOf = cs, z.sortedLastIndex = Vf, z.sortedLastIndexBy = Iv, z.sortedLastIndexOf = fs, z.startCase = IE, z.startsWith = Pb, z.subtract = fS, z.sum = dS, z.sumBy = _h, z.template = AE, z.times = D0, z.toFinite = Fc, z.toInteger = Sn, z.toLength = op, z.toLower = NE, z.toNumber = ds, z.toSafeInteger = oE, z.toString = Nr, z.toUpper = kb, z.trim = _E, z.trimEnd = Fb, z.trimStart = _0, z.truncate = OE, z.unescape = LE, z.uniqueId = KE, z.upperCase = DE, z.upperFirst = Bb, z.each = np, z.eachRight = jf, z.first = Lc, Gb(z, function() {
        var s = {};
        return Ar(z, function(d, C) {
          fr.call(z.prototype, C) || (s[C] = d);
        }), s;
      }(), { chain: !1 }), z.VERSION = u, Pn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
        z[s].placeholder = z;
      }), Pn(["drop", "take"], function(s, d) {
        Rn.prototype[s] = function(C) {
          C = C === i ? 1 : wa(Sn(C), 0);
          var A = this.__filtered__ && !d ? new Rn(this) : this.clone();
          return A.__filtered__ ? A.__takeCount__ = ri(C, A.__takeCount__) : A.__views__.push({
            size: ri(C, q),
            type: s + (A.__dir__ < 0 ? "Right" : "")
          }), A;
        }, Rn.prototype[s + "Right"] = function(C) {
          return this.reverse()[s](C).reverse();
        };
      }), Pn(["filter", "map", "takeWhile"], function(s, d) {
        var C = d + 1, A = C == qe || C == st;
        Rn.prototype[s] = function(F) {
          var $ = this.clone();
          return $.__iteratees__.push({
            iteratee: Yt(F, 3),
            type: C
          }), $.__filtered__ = $.__filtered__ || A, $;
        };
      }), Pn(["head", "last"], function(s, d) {
        var C = "take" + (d ? "Right" : "");
        Rn.prototype[s] = function() {
          return this[C](1).value()[0];
        };
      }), Pn(["initial", "tail"], function(s, d) {
        var C = "drop" + (d ? "" : "Right");
        Rn.prototype[s] = function() {
          return this.__filtered__ ? new Rn(this) : this[C](1);
        };
      }), Rn.prototype.compact = function() {
        return this.filter(gl);
      }, Rn.prototype.find = function(s) {
        return this.filter(s).head();
      }, Rn.prototype.findLast = function(s) {
        return this.reverse().find(s);
      }, Rn.prototype.invokeMap = Ln(function(s, d) {
        return typeof s == "function" ? new Rn(this) : this.map(function(C) {
          return ll(C, s, d);
        });
      }), Rn.prototype.reject = function(s) {
        return this.filter(tt(Yt(s)));
      }, Rn.prototype.slice = function(s, d) {
        s = Sn(s);
        var C = this;
        return C.__filtered__ && (s > 0 || d < 0) ? new Rn(C) : (s < 0 ? C = C.takeRight(-s) : s && (C = C.drop(s)), d !== i && (d = Sn(d), C = d < 0 ? C.dropRight(-d) : C.take(d - s)), C);
      }, Rn.prototype.takeRightWhile = function(s) {
        return this.reverse().takeWhile(s).reverse();
      }, Rn.prototype.toArray = function() {
        return this.take(q);
      }, Ar(Rn.prototype, function(s, d) {
        var C = /^(?:filter|find|map|reject)|While$/.test(d), A = /^(?:head|last)$/.test(d), F = z[A ? "take" + (d == "last" ? "Right" : "") : d], $ = A || /^find/.test(d);
        F && (z.prototype[d] = function() {
          var ee = this.__wrapped__, ae = A ? [1] : arguments, de = ee instanceof Rn, He = ae[0], Be = de || Tn(ee), Xe = function(jn) {
            var er = F.apply(z, Jo([jn], ae));
            return A && ft ? er[0] : er;
          };
          Be && C && typeof He == "function" && He.length != 1 && (de = Be = !1);
          var ft = this.__chain__, Dt = !!this.__actions__.length, en = $ && !ft, On = de && !Dt;
          if (!$ && Be) {
            ee = On ? ee : new Rn(this);
            var cn = s.apply(ee, ae);
            return cn.__actions__.push({ func: Ml, args: [Xe], thisArg: i }), new xi(cn, ft);
          }
          return en && On ? s.apply(this, ae) : (cn = this.thru(Xe), en ? A ? cn.value()[0] : cn.value() : cn);
        });
      }), Pn(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
        var d = uo[s], C = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", A = /^(?:pop|shift)$/.test(s);
        z.prototype[s] = function() {
          var F = arguments;
          if (A && !this.__chain__) {
            var $ = this.value();
            return d.apply(Tn($) ? $ : [], F);
          }
          return this[C](function(ee) {
            return d.apply(Tn(ee) ? ee : [], F);
          });
        };
      }), Ar(Rn.prototype, function(s, d) {
        var C = z[d];
        if (C) {
          var A = C.name + "";
          fr.call(gf, A) || (gf[A] = []), gf[A].push({ name: d, func: C });
        }
      }), gf[Iu(i, H).name] = [{
        name: "wrapper",
        func: i
      }], Rn.prototype.clone = zt, Rn.prototype.reverse = mu, Rn.prototype.value = Xr, z.prototype.at = yh, z.prototype.chain = Pc, z.prototype.commit = Ch, z.prototype.next = Eh, z.prototype.plant = ep, z.prototype.reverse = Nv, z.prototype.toJSON = z.prototype.valueOf = z.prototype.value = Jm, z.prototype.first = z.prototype.head, Os && (z.prototype[Os] = qd), z;
    }, uf = ib();
    te ? ((te.exports = uf)._ = uf, P._ = uf) : Dr._ = uf;
  }).call(Dy);
})(yC, yC.exports);
var Qc = yC.exports, Cs = /* @__PURE__ */ ((t) => (t.META = "META", t.HIDE = "HIDE", t.REF = "REF", t.LITERAL = "LITERAL", t.SIMPLE = "SIMPLE", t.COMPLEX = "COMPLEX", t.UNKNOWN = "UNKNOWN", t))(Cs || {}), At = /* @__PURE__ */ ((t) => (t.profile = "profile", t.block = "block", t.group = "group", t.literal = "literal", t.simple = "simple", t.complex = "complex", t.groupComplex = "groupComplex", t.hidden = "hidden", t.dropdown = "dropdown", t.dropdownOption = "dropdownOption", t.__fallback = "__fallback", t))(At || {}), CC = /* @__PURE__ */ ((t) => (t.Duplicate = "addDuplicate", t.RemoveDuplicate = "removeDuplicate", t.ChangeComplexFieldValue = "changeComplexFieldValue", t))(CC || {});
const Jy = [
  "literal",
  "simple",
  "complex"
  /* complex */
], P6 = [
  "dropdown",
  "dropdownOption"
  /* dropdownOption */
], k6 = [
  "profile",
  "block",
  "hidden",
  "dropdownOption",
  "complex"
  /* complex */
], q1 = (t, r, i) => {
  var c, v, h, y, g, S;
  const u = r ?? x2.INSTANCE;
  return i ? (y = (h = (v = (c = t == null ? void 0 : t.resource) == null ? void 0 : c[u]) == null ? void 0 : v[i]) == null ? void 0 : h[0]) == null ? void 0 : y.id : (S = (g = t == null ? void 0 : t.resource) == null ? void 0 : g[u]) == null ? void 0 : S.id;
}, kT = (t, r = !0) => {
  const i = t == null ? void 0 : t.resource[x2.INSTANCE], u = r ? [Xu.WORK] : [Xu.INSTANCE], c = r ? [Xu.INSTANCE] : [Xu.WORK];
  return i ? c : u;
}, FC = (t) => {
  const r = Ca;
  let i, u;
  for (const c in r) {
    const v = r[c];
    t[v.uri] && (i = v.uri, u = v.reference);
  }
  return { block: i, reference: u };
}, F6 = (t) => {
  const r = (t == null ? void 0 : t.get(Mi.Type)) === Co.instance, i = r ? Ca.INSTANCE.uri : Ca.WORK.uri, u = r ? Ca.INSTANCE.reference : Ca.WORK.reference;
  return {
    block: i,
    reference: u
  };
}, w2 = (t) => {
  var c;
  const r = I2(t), { block: i } = FC(r);
  let u;
  return GB.every((v) => {
    var y, g;
    const h = (g = (y = r[i]) == null ? void 0 : y[Le.TITLE]) == null ? void 0 : g.find((S) => Object.hasOwn(S, v));
    return h && (u = h[v]), !h;
  }), (c = u == null ? void 0 : u[Le.MAIN_TITLE]) == null ? void 0 : c[0];
}, B6 = ({ record: t, block: r, reference: i, asClone: u }) => {
  const c = Qc.cloneDeep(t);
  return u && r === Le.WORK && (i != null && i.key) && delete c[r][i.key], {
    record: c
  };
}, I2 = (t) => t.resource ?? t, yO = (t) => ({ resource: t }), a_ = (t) => Array.isArray(t) ? t[0] : t, U6 = ({
  entry: t,
  level: r,
  userValues: i,
  uuid: u,
  schema: c,
  isOnBranchWithUserValue: v,
  altDisplayNames: h,
  hideEntities: y,
  isEntity: g,
  forceRenderAllTopLevelEntities: S
}) => {
  const { displayName: x = "", children: T, type: _, bfid: L = "", linkedEntry: M } = t, U = !k6.includes(_), B = r <= gm, H = T == null ? void 0 : T.length, Y = i[u], Q = !Y && !H, W = !!Y, oe = !(g && y) && U && B || _ === At.dropdown || W && _ !== At.complex || Q, j = H && !T.filter((st) => {
    var We;
    return ((We = c.get(st)) == null ? void 0 : We.type) !== At.dropdownOption;
  }).length, re = !H || j, me = U && B && !v || !v, Se = _ === At.dropdown && !!(M != null && M.controlledBy), Ne = (h == null ? void 0 : h[x]) ?? FF[x] ?? x, Ge = r === gm && oe, ze = r === HB, qe = L === Xu.INSTANCE;
  return {
    isGroupable: B,
    shouldRenderLabelOrPlaceholders: oe,
    shouldRenderValuesOrPlaceholders: re,
    shouldRenderPlaceholders: me,
    isDependentDropdown: Se,
    displayNameWithAltValue: Ne,
    isBlock: Ge,
    isBlockContents: ze,
    isInstance: qe,
    wrapEntities: S && g
  };
}, V6 = (t) => {
  if (!t)
    return;
  const r = I2(t), { block: i, reference: u } = FC(r);
  if (i && u)
    return {
      keys: u,
      type: BB[u.key],
      entries: r[i][u.key]
    };
}, H6 = () => {
  const { isLoading: t } = qu(), { resetBasicValue: r } = ud(), { record: i } = Ea(), { formatMessage: u } = La();
  return /* @__PURE__ */ N.jsxs("div", { className: "nav-block nav-block-fixed-height", "data-testid": "view-marc-control-pane", children: [
    /* @__PURE__ */ N.jsx("nav", { children: /* @__PURE__ */ N.jsx(
      Dn,
      {
        "data-testid": "nav-close-button",
        type: Mn.Icon,
        onClick: r,
        className: "nav-close",
        ariaLabel: u({ id: "ld.aria.marcPreview.close" }),
        children: /* @__PURE__ */ N.jsx(qs, {})
      }
    ) }),
    /* @__PURE__ */ N.jsx("div", { className: "heading", children: !t && /* @__PURE__ */ N.jsx(
      mt,
      {
        id: "ld.marcWithTitle",
        values: {
          title: /* @__PURE__ */ N.jsx("span", { "data-testid": "marc-title", children: ((i == null ? void 0 : i.resource) && w2(i.resource)) ?? /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
            "<",
            u({ id: "ld.noTitleInBrackets" }),
            ">"
          ] }) })
        }
      }
    ) }),
    /* @__PURE__ */ N.jsx("span", { className: "empty-block" })
  ] });
}, FT = "linked-data", BT = () => document.getElementsByTagName(FT)[0], Uy = (t) => {
  var r;
  return t && ((r = BT()) == null ? void 0 : r.dispatchEvent(new CustomEvent(t)));
}, Sm = ({ onTriggerModal: t, watchEditedState: r = !1 } = {}) => {
  const { hasNavigationOrigin: i, customEvents: u } = y2(), { isRecordEdited: c } = Si(), {
    BLOCK_NAVIGATION: v,
    UNBLOCK_NAVIGATION: h,
    TRIGGER_MODAL: y,
    PROCEED_NAVIGATION: g,
    NAVIGATE_TO_ORIGIN: S,
    DROP_NAVIGATE_TO_ORIGIN: x
  } = u ?? {}, T = ym(), _ = Ju();
  k.useEffect(() => {
    var Y;
    if (y && t)
      return (Y = BT()) == null || Y.addEventListener(y, t), () => {
        var G;
        return (G = BT()) == null ? void 0 : G.removeEventListener(y, t);
      };
  }, [y, t]), k.useEffect(() => {
    r && (c ? M() : L());
  }, [v, c, r]);
  const L = () => Uy(h), M = () => Uy(v);
  return {
    dispatchUnblockEvent: L,
    dispatchProceedNavigationEvent: () => Uy(g),
    dispatchBlockEvent: M,
    dispatchNavigateToOriginEventWithFallback: (Y) => {
      var G;
      i && !((G = _.state) != null && G.isNavigatedFromLDE) ? Uy(S) : T(Y ?? Va.SEARCH.uri);
    },
    dispatchDropNavigateToOriginEvent: () => Uy(x)
  };
}, j6 = () => {
  const { record: t } = Ea(), { dispatchNavigateToOriginEventWithFallback: r } = Sm(), { formatMessage: i } = La();
  return /* @__PURE__ */ N.jsxs("div", { className: "nav-block nav-block-fixed-height", children: [
    /* @__PURE__ */ N.jsx("nav", { children: /* @__PURE__ */ N.jsx(
      Dn,
      {
        "data-testid": "nav-close-button",
        type: Mn.Icon,
        onClick: () => r(),
        className: "nav-close",
        ariaLabel: i({ id: "ld.aria.externalResourcePreview.close" }),
        children: /* @__PURE__ */ N.jsx(qs, {})
      }
    ) }),
    /* @__PURE__ */ N.jsx("div", { className: "heading", children: t && w2(t) }),
    /* @__PURE__ */ N.jsx("span", { className: "empty-block" })
  ] });
};
const G6 = () => {
  const t = mm(K9), r = mm(Q9), { basicValue: i } = ud(), { record: u } = Ea();
  return (t || r && u) && /* @__PURE__ */ N.jsxs("div", { "data-testid": "nav", className: Hg.classNames.nav, children: [
    t && !i && /* @__PURE__ */ N.jsx(M6, {}),
    i && !r && /* @__PURE__ */ N.jsx(H6, {}),
    r && /* @__PURE__ */ N.jsx(j6, {})
  ] });
};
const z6 = ({
  isOpen: t,
  className: r,
  classNameHeader: i,
  title: u,
  submitButtonLabel: c,
  cancelButtonLabel: v,
  shouldCloseOnEsc: h = !0,
  onSubmit: y,
  onCancel: g,
  onClose: S,
  children: x,
  submitButtonDisabled: T,
  cancelButtonDisabled: _,
  showCloseIconButton: L = !0,
  showModalControls: M = !0,
  titleClassName: U,
  alignTitleCenter: B = !1,
  ariaModalKind: H = g2.Basic
}) => {
  const { formatMessage: Y } = La(), G = document.getElementById(aO);
  return k.useEffect(() => {
    function Q(W) {
      !h || W.key !== "Escape" || S();
    }
    return window.addEventListener("keydown", Q), () => window.removeEventListener("keydown", Q);
  }, []), t && G ? Jg.createPortal(
    /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
      /* @__PURE__ */ N.jsx("div", { className: "overlay", onClick: S, role: "presentation", "data-testid": "modal-overlay" }),
      /* @__PURE__ */ N.jsxs("div", { className: In(["modal", r]), role: "dialog", "data-testid": "modal", children: [
        /* @__PURE__ */ N.jsxs("div", { className: In(["modal-header", i]), children: [
          L && /* @__PURE__ */ N.jsx(
            "button",
            {
              onClick: S,
              className: "close-button",
              "aria-label": Y({ id: "ld.aria.modal.close" }, { modalKind: H }),
              children: /* @__PURE__ */ N.jsx(qs, {})
            }
          ),
          /* @__PURE__ */ N.jsx("h3", { className: In(["title", U]), children: u }),
          B && /* @__PURE__ */ N.jsx("span", { className: "empty-block" })
        ] }),
        !!x && x,
        M && /* @__PURE__ */ N.jsxs("div", { className: "modal-controls", children: [
          /* @__PURE__ */ N.jsx(
            Dn,
            {
              disabled: _,
              onClick: g,
              type: Mn.Primary,
              "data-testid": "modal-button-cancel",
              children: v
            }
          ),
          /* @__PURE__ */ N.jsx(
            Dn,
            {
              disabled: T,
              type: Mn.Highlighted,
              onClick: y,
              "data-testid": "modal-button-submit",
              children: c
            }
          )
        ] })
      ] })
    ] }),
    G
  ) : null;
}, qg = k.memo(z6);
const W6 = ({
  isOpen: t,
  onCancel: r,
  onSubmit: i,
  onClose: u
}) => {
  const { formatMessage: c } = La();
  return /* @__PURE__ */ N.jsx(
    qg,
    {
      isOpen: t,
      title: c({ id: "ld.modal.uncontrolledAuthoritiesWarning.title" }),
      submitButtonLabel: c({ id: "ld.continue" }),
      cancelButtonLabel: c({ id: "ld.cancel" }),
      onClose: u,
      onSubmit: i,
      onCancel: r,
      className: "modal-uncontrolled-authorities-warning",
      children: /* @__PURE__ */ N.jsx("div", { className: "uncontrolled-authorities-contents", "data-testid": "modal-uncontrolled-authorities-warning", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.modal.uncontrolledAuthoritiesWarning.body" }) })
    }
  );
}, X6 = (t) => Object.values(t).some(
  (r) => r.contents.some((i) => {
    var u, c;
    return ((u = i == null ? void 0 : i.meta) == null ? void 0 : u.isPreferred) !== void 0 && !((c = i == null ? void 0 : i.meta) != null && c.isPreferred);
  })
), Y6 = () => {
  const { hasShownAuthorityWarning: t, setHasShownAuthorityWarning: r } = Qa(), { userValues: i, selectedRecordBlocks: u } = Ea();
  return {
    shouldDisplayWarningMessage: (u == null ? void 0 : u.block) === x2.WORK && !t && X6(i),
    setHasShownAuthorityWarning: r
  };
}, $6 = () => {
  const { lastSavedRecordId: t } = Si(), { resourceId: r } = Cm();
  return {
    hasBeenSaved: r && r === t
  };
}, Z6 = () => ro.getJson({
  url: IF
}), J6 = {
  [Le.INSTANCE]: [
    {
      path: [
        Le.INSTANCE,
        "http://bibfra.me/vocab/marc/title",
        "http://bibfra.me/vocab/marc/Title",
        "http://bibfra.me/vocab/marc/mainTitle"
      ],
      template: {
        prefix: "ld.duplicateInstanceInBrackets"
      }
    }
  ],
  [Le.WORK]: [
    {
      path: [
        Le.WORK,
        "http://bibfra.me/vocab/marc/title",
        "http://bibfra.me/vocab/marc/Title",
        "http://bibfra.me/vocab/marc/mainTitle"
      ],
      template: {
        prefix: "ld.duplicateWorkInBrackets"
      }
    }
  ]
}, Q6 = ({
  parsedRecord: t,
  record: r,
  selectedRecordBlocks: i
}) => {
  const u = { resource: {} };
  if (!t || !i)
    return u;
  const { block: c, reference: v } = i;
  if (!c || !v)
    return u;
  const h = K6(t), y = r ? CO(r, c, v.key) : void 0, g = { ...h == null ? void 0 : h[c] };
  return y && (g[v.key] = y), {
    resource: {
      [c]: g
    }
  };
}, CO = (t, r, i) => {
  var c, v;
  const u = (v = (c = t.resource) == null ? void 0 : c[r]) == null ? void 0 : v[i];
  return u == null ? void 0 : u.map(({ id: h }) => ({ id: h }));
}, K6 = (t) => {
  let r = Qc.cloneDeep(t);
  return r = q6(r), r = t8(r), r = n8(r), r = r8(r), e8(r, pO);
}, q6 = (t) => {
  const r = t[Le.INSTANCE], i = t[Le.WORK];
  if (!r[Le.NOTE] && !i[Le.NOTE])
    return t;
  const u = Qc.cloneDeep(t), c = u[Le.INSTANCE], v = u[Le.WORK];
  return [c, v].forEach((y) => {
    const g = y[Le.NOTE];
    g && (y[Yu[Le.NOTE].container] = g == null ? void 0 : g.map((S) => ({
      type: S[yo.NOTE_TYPE] ?? [Le.NOTE],
      value: S[Le.NOTE]
    })), delete y[Le.NOTE]);
  }), u;
}, e8 = (t, r) => {
  const i = t == null ? void 0 : t[Le.WORK];
  return r.forEach((u) => {
    var h;
    const c = i == null ? void 0 : i[u];
    if (!c)
      return;
    const v = (h = Yu[u]) == null ? void 0 : h.container;
    c.forEach((y) => {
      var B, H, Y;
      const g = y[v] || y[yo.ROLE], S = (B = y[yo.CREATOR_NAME]) == null ? void 0 : B[0], x = S == null ? void 0 : S.id, T = S == null ? void 0 : S.srsId, _ = a_(x), L = a_(T);
      if (!_ && !L)
        return;
      const M = i[(H = JN[u]) == null ? void 0 : H.container], U = {};
      L ? U.srsId = L : U.id = _, g && (U.roles = g), i[(Y = JN[u]) == null ? void 0 : Y.container] = M ? [...M, U] : [U], delete i[u];
    });
  }), t;
}, t8 = (t) => {
  const r = t[Le.WORK];
  return r != null && r[yo.INTENDED_AUDIENCE] && delete r[yo.INTENDED_AUDIENCE], t;
}, n8 = (t) => {
  const r = t == null ? void 0 : t[Le.INSTANCE], i = Le.PROVIDER_PLACE;
  return n6.forEach((u) => {
    r[u] && r[u].forEach((c) => {
      var v;
      c != null && c[i] && (c[i] = (v = c == null ? void 0 : c[i]) == null ? void 0 : v.map((h) => ({
        ...h,
        [Le.NAME]: h[Le.LABEL]
      })));
    });
  }), t;
}, r8 = (t) => {
  const r = t == null ? void 0 : t[Le.WORK];
  if (!(r == null ? void 0 : r[Le.CLASSIFICATION]))
    return t;
  const u = Qc.cloneDeep(t), c = u == null ? void 0 : u[Le.WORK], v = c == null ? void 0 : c[Le.CLASSIFICATION];
  return c[Le.CLASSIFICATION] = v == null ? void 0 : v.map((h) => {
    let y = {};
    for (const g in h)
      y = { ...h[g], [Le.SOURCE]: [g] };
    return y;
  }), u;
}, a8 = ({
  templates: t,
  format: r
}) => t.map(({ template: i, ...u }) => ({
  ...u,
  template: Object.fromEntries(Object.entries(i).map(([c, v]) => [c, r({ id: v })]))
})), i8 = (t) => t.map(({ id: r, ...i }) => {
  var h, y, g, S, x;
  const u = (h = i == null ? void 0 : i[Le.PUBLICATION]) == null ? void 0 : h[0], c = i == null ? void 0 : i[Le.TITLE], v = c == null ? void 0 : c.find((T) => Object.hasOwn(T, Le.TITLE_CONTAINER));
  return {
    __meta: {
      id: r,
      key: r,
      ...i
    },
    title: {
      label: (g = (y = v == null ? void 0 : v[Le.TITLE_CONTAINER]) == null ? void 0 : y[Le.MAIN_TITLE]) == null ? void 0 : g[0],
      className: "title"
    },
    publisher: {
      label: (S = u == null ? void 0 : u[Le.NAME]) == null ? void 0 : S[0],
      className: "publisher"
    },
    pubDate: {
      label: (x = u == null ? void 0 : u[Le.DATE]) == null ? void 0 : x[0],
      className: "publication-date"
    }
  };
}), o8 = (t) => {
  if (!t)
    return;
  const r = I2(t), { block: i, reference: u } = FC(r);
  if (i && u)
    return CO(t, i, u == null ? void 0 : u.key);
}, EO = k.createContext({
  endpointUrl: "",
  primarySegments: {},
  searchFilter: "",
  hasSearchParams: !0,
  defaultSearchBy: Yg.LCCN,
  isSortedResults: !0,
  isVisibleFilters: !1,
  isVisibleFullDisplay: !0,
  isVisibleAdvancedSearch: !0,
  isVisibleSearchByControl: !0,
  isVisibleSegments: !1,
  hasMultilineSearchInput: !1,
  searchByControlOptions: {},
  searchableIndicesMap: {},
  labelEmptySearch: "",
  classNameEmptyPlaceholder: "",
  filters: [],
  renderResultsList: () => null,
  renderSearchControlPane: () => null,
  fetchSearchResults: void 0,
  navigationSegment: {
    value: void 0,
    set: () => null
  },
  hasMarcPreview: !1,
  renderMarcPreview: () => null
}), SO = k.createContext({
  selectedEntriesService: void 0,
  userValuesService: void 0,
  schemaWithDuplicatesService: void 0,
  lookupCacheService: void 0,
  recordNormalizingService: void 0,
  recordToSchemaMappingService: void 0,
  schemaCreatorService: void 0,
  recordGeneratorService: void 0
}), xm = () => k.useContext(SO), l8 = () => {
  const { addStatusMessagesItem: t } = Si(), { setRecord: r } = Ea(), { formatMessage: i } = La(), { userValuesService: u, schemaWithDuplicatesService: c, recordNormalizingService: v, recordToSchemaMappingService: h } = xm();
  return { getProcessedRecordAndSchema: k.useCallback(
    async ({ baseSchema: g, record: S, userValues: x, asClone: T = !1, noStateUpdate: _ }) => {
      let L = g, M = x, U;
      try {
        if (S && Object.keys(S).length) {
          const B = S, { block: H, reference: Y } = FC(B), { record: G } = B6({
            record: B,
            block: H,
            reference: Y,
            asClone: T
          }), Q = [H, Y == null ? void 0 : Y.uri], oe = T && H ? a8({
            templates: J6[H],
            format: i
          }) : void 0;
          !_ && r(yO(G)), U = { block: H, reference: Y }, c.set(g), v.init(G, H, Y);
          const j = v.get();
          await h.init({
            schema: g,
            record: j,
            recordBlocks: Q,
            templateMetadata: oe
          }), L = h.get(), M = u.getAllValues();
        }
      } catch (B) {
        console.error(B), t == null || t(Ei.createMessage(Tr.error, "ld.errorLoadingResource"));
      }
      return {
        updatedSchema: L,
        updatedUserValues: M,
        selectedRecordBlocks: U
      };
    },
    [
      i,
      v,
      h,
      c,
      r,
      t,
      u
    ]
  ) };
}, xO = () => {
  const { schemaCreatorService: t, userValuesService: r, selectedEntriesService: i } = xm(), {
    profiles: u,
    setProfiles: c,
    setSelectedProfile: v,
    preparedFields: h,
    setPreparedFields: y,
    setInitialSchemaKey: g,
    setSchema: S
  } = cd(), { setUserValues: x, setPreviewContent: T, setSelectedRecordBlocks: _, setSelectedEntries: L } = Ea(), { getProcessedRecordAndSchema: M } = l8(), U = k.useRef(!1), B = (G) => {
    const Q = G.reduce((W, oe) => {
      const j = oe.json.Profile.resourceTemplates.reduce(
        (re, me) => (re[me.id] = me, re),
        {}
      );
      return {
        ...W,
        ...j
      };
    }, {});
    return y(Q), Q;
  }, H = async ({ profile: G, templates: Q, record: W, asClone: oe = !1, noStateUpdate: j = !1 }) => {
    const re = Jc(), me = {};
    r.set(me), i.set([]), t.init(Q, G), t.generate(re);
    const { updatedSchema: Se, updatedUserValues: Ne, selectedRecordBlocks: Ge } = await M({
      baseSchema: t.get(),
      record: W,
      userValues: me,
      asClone: oe,
      noStateUpdate: j
    });
    return j || (x(Ne ?? me), g(re), L(i.get()), S(Se), _(Ge)), { updatedSchema: Se, initKey: re };
  };
  return { getProfiles: async ({ record: G, recordId: Q, previewParams: W, asClone: oe }) => {
    if (!(U.current && (G || Q)))
      try {
        U.current = !0;
        const j = u == null ? void 0 : u.length, re = j ? u : await Z6(), me = re.find(({ name: at }) => at === VB.MONOGRAPH), Se = h ?? B(re);
        j || c(re);
        const Ne = (G == null ? void 0 : G.resource) || {}, Ge = w2(Ne), ze = kT(G), qe = o8(G);
        if (me) {
          !(W != null && W.noStateUpdate) && v(me);
          const { updatedSchema: at, initKey: st } = await H({
            profile: me,
            templates: Se,
            record: Ne,
            asClone: oe,
            noStateUpdate: W == null ? void 0 : W.noStateUpdate
          });
          W && Q && T((We) => [
            ...W.singular ? [] : We.filter(({ id: he }) => he !== Q),
            {
              id: Q,
              base: at,
              userValues: r.getAllValues(),
              selectedEntries: i.get(),
              initKey: st,
              title: Ge,
              entities: ze,
              referenceIds: qe
            }
          ]);
        }
        return re;
      } finally {
        U.current = !1;
      }
  }, prepareFields: B };
}, Kh = (t) => `/resources/${t}/edit`, s8 = (t, r) => {
  const i = pm(Va.RESOURCE_CREATE.uri, t) && r;
  if (i && r.includes(Mi.CloneOf))
    return Vg.CreatePageAsClone;
  if (i)
    return Vg.CreatePage;
  if (pm(Va.RESOURCE_EDIT.uri, t))
    return Vg.EditPage;
}, u8 = () => {
  const { pathname: t } = window.location, r = t.split("/");
  if (!(r.includes(Yh.RESOURCES) && r.includes(Yh.EDIT)))
    return;
  const u = r.indexOf(Yh.RESOURCES);
  return r[u + 1];
}, c8 = async (t, r = !1) => {
  const i = await ro.request({
    url: t,
    sameOrigin: !1
  });
  return await (r ? i.text() : i.json());
}, RO = async (t) => {
  Array.isArray(t) || (t = [t]);
  for await (const r of t) {
    const i = r.includes(".json") ? r : `${r}.json`;
    return await f8(i);
  }
}, f8 = async (t) => (t.includes("id.loc.gov") && (t = t.replace("http://", "https://")), t = t.replace("memberOf=https://id.loc.gov/", "memberOf=http://id.loc.gov/"), await c8(t, t.includes(".rdf") || t.includes(".xml"))), i_ = (t) => {
  var u;
  const r = t;
  if (!((u = r.errors) != null && u.length))
    return "ld.cantSaveRd";
  const i = r.errors[0].code;
  return `ld.${nO[i] ?? i}`;
}, d8 = () => {
  const { recordGeneratorService: t } = xm(), { userValues: r, selectedEntries: i } = Ea(), { schema: u, initialSchemaKey: c } = cd();
  return { generateRecord: () => (t == null || t.init({
    schema: u,
    initKey: c,
    userValues: r,
    selectedEntries: i
  }), t == null ? void 0 : t.generate()) };
}, Tp = () => {
  const [t, r] = qc(), { setIsLoading: i } = qu(), { resetUserValues: u, selectedRecordBlocks: c, setSelectedRecordBlocks: v, record: h, setRecord: y } = Ea(), { setSelectedProfile: g } = cd(), { setCurrentlyEditedEntityBfid: S, setCurrentlyPreviewedEntityBfid: x } = Qa(), {
    setRecordStatus: T,
    setLastSavedRecordId: _,
    setIsRecordEdited: L,
    addStatusMessagesItem: M
  } = Si(), U = q1(h), { getProfiles: B } = xO(), H = ym(), Y = Ju(), G = mO(), { dispatchUnblockEvent: Q, dispatchNavigateToOriginEventWithFallback: W } = Sm(), [oe] = qc(), j = oe.get(Mi.CloneOf), { generateRecord: re } = d8(), me = async (he, ke) => {
    const _e = await at({ recordId: he });
    _e && (ke || (S(new Set(kT(_e))), y(_e)), x(new Set(kT(_e, !!ke))), await B({
      record: _e,
      recordId: he,
      previewParams: ke,
      asClone: !!j
    }), L(!1));
  }, Se = async ({
    asRefToNewRecord: he = !1,
    isNavigatingBack: ke = !0,
    shouldSetSearchParams: _e = !0
  } = {}) => {
    var pe, $e, lt, ot;
    const q = re();
    if (q) {
      i(!0);
      try {
        const nt = c || F6(t), Rt = Q6({
          parsedRecord: q,
          record: h,
          selectedRecordBlocks: nt
        }), ht = q1(h, c == null ? void 0 : c.block), bn = await (!ht || j ? await y6(Rt) : await C6(ht, Rt)).json();
        Q(), !he && y(bn), M == null || M(
          Ei.createMessage(Tr.success, ht ? "ld.rdUpdateSuccess" : "ld.rdSaveSuccess")
        ), Jg.flushSync(() => L(!1));
        const Ze = q1(bn, nt == null ? void 0 : nt.block);
        if (_(Ze), !ke) {
          H(Kh(Ze), {
            replace: !0,
            state: Y.state
          }), T({ type: od.saveAndKeepEditing });
          return;
        }
        if (T({ type: od.saveAndClose }), he) {
          const mn = (pe = t.get(Mi.Type) ?? Co.instance) == null ? void 0 : pe.toUpperCase(), fn = ($e = Ca[mn]) == null ? void 0 : $e.uri;
          return _e && r({
            type: (ot = (lt = Ca[mn]) == null ? void 0 : lt.reference) == null ? void 0 : ot.name,
            ref: String(q1(bn, fn))
          }), Ze;
        } else
          H(G);
      } catch (nt) {
        console.error("Cannot save the resource description", nt), M == null || M(Ei.createMessage(Tr.error, i_(nt)));
      } finally {
        i(!1);
      }
    }
  }, Ne = () => {
    u(), y(null), v(void 0), g(null), T({ type: od.close }), Q();
  }, Ge = (he = !0) => {
    he && Ne(), W(G);
  }, ze = async () => {
    try {
      if (!U)
        return;
      await E6(U), Ge(), M == null || M(Ei.createMessage(Tr.success, "ld.rdDeleted")), H(Va.SEARCH.uri);
    } catch (he) {
      console.error("Cannot delete the resource description", he), M == null || M(Ei.createMessage(Tr.error, "ld.cantDeleteRd"));
    }
  }, qe = async (he, ke) => {
    var _e, q, pe, $e, lt, ot, nt, Rt;
    try {
      const ht = await t_({ recordId: he }), dt = (q = (_e = Ca[ke]) == null ? void 0 : _e.reference) == null ? void 0 : q.uri, sn = (pe = ht == null ? void 0 : ht.resource) == null ? void 0 : pe[dt];
      if (!sn)
        return M == null || M(
          Ei.createMessage(Tr.error, "ld.cantSelectReferenceContents")
        ), H(Va.RESOURCE_CREATE.uri);
      const bn = {
        ...sn,
        [(lt = ($e = Ca[ke]) == null ? void 0 : $e.reference) == null ? void 0 : lt.key]: void 0
      };
      return {
        resource: {
          [(ot = Ca[ke]) == null ? void 0 : ot.uri]: {
            [(Rt = (nt = Ca[ke]) == null ? void 0 : nt.reference) == null ? void 0 : Rt.key]: [bn]
          }
        }
      };
    } catch (ht) {
      console.error("Error fetching record and selecting entity values: ", ht), M == null || M(Ei.createMessage(Tr.error, "ld.errorFetching"));
    }
  }, at = async ({
    recordId: he,
    cachedRecord: ke,
    idType: _e,
    previewParams: q,
    errorMessage: pe
  }) => {
    if (!(!he && !ke))
      try {
        const $e = ke ?? (he && await t_({ recordId: he, idType: _e }));
        return await B({
          record: $e,
          recordId: he,
          previewParams: q
        }), $e;
      } catch {
        M == null || M(
          Ei.createMessage(Tr.error, pe ?? "ld.errorFetching")
        );
      }
  };
  return {
    fetchRecord: me,
    saveRecord: Se,
    deleteRecord: ze,
    discardRecord: Ge,
    clearRecordState: Ne,
    fetchRecordAndSelectEntityValues: qe,
    fetchExternalRecordForPreview: async (he, ke = v2.Inventory) => {
      he && (i(!0), await at({
        recordId: he,
        idType: ke,
        errorMessage: "ld.errorFetchingExternalResourceForPreview"
      }), i(!1));
    },
    tryFetchExternalRecordForEdit: async (he) => {
      try {
        if (!he)
          return;
        i(!0);
        const { id: ke } = await m6({ recordId: he });
        ke && H(Kh(ke), { replace: !0 });
      } catch (ke) {
        M == null || M(Ei.createMessage(Tr.error, i_(ke)));
      } finally {
        i(!1);
      }
    },
    getRecordAndInitializeParsing: at
  };
}, EC = () => {
  const [t, r] = k.useState(!1);
  return { isModalOpen: t, setIsModalOpen: r, openModal: () => {
    !t && r(!0);
  }, closeModal: () => {
    t && r(!1);
  } };
}, p8 = (t) => {
  const { isRecordEdited: r } = Si(), { hasBeenSaved: i } = $6(), { saveRecord: u } = Tp(), { isModalOpen: c, openModal: v, closeModal: h } = EC(), [y] = qc();
  return {
    isButtonDisabled: !y.get(Mi.CloneOf) && !i && !r,
    isModalOpen: c,
    openModal: v,
    closeModal: h,
    saveRecord: () => u({ isNavigatingBack: t })
  };
}, h8 = ({ primary: t = !1 }) => {
  const { shouldDisplayWarningMessage: r, setHasShownAuthorityWarning: i } = Y6(), { isButtonDisabled: u, isModalOpen: c, openModal: v, closeModal: h, saveRecord: y } = p8(t), g = () => {
    r ? v() : S();
  }, S = () => {
    y(), x();
  }, x = () => {
    r && i(!0), h();
  };
  return /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
    /* @__PURE__ */ N.jsx(
      Dn,
      {
        "data-testid": `save-record${t ? "-and-close" : "-and-keep-editing"}`,
        type: t ? Mn.Primary : Mn.Highlighted,
        onClick: g,
        disabled: u,
        children: /* @__PURE__ */ N.jsx(mt, { id: t ? "ld.saveAndClose" : "ld.saveAndKeepEditing" })
      }
    ),
    /* @__PURE__ */ N.jsx(
      W6,
      {
        isOpen: c,
        onCancel: x,
        onSubmit: S,
        onClose: x
      }
    )
  ] });
}, o_ = k.memo(h8), v8 = () => {
  const { discardRecord: t } = Tp();
  return /* @__PURE__ */ N.jsx(Dn, { "data-testid": "close-record-button", type: Mn.Primary, onClick: () => t(!1), children: /* @__PURE__ */ N.jsx(mt, { id: "ld.cancel" }) });
}, m8 = k.memo(v8);
const g8 = k.memo(() => /* @__PURE__ */ N.jsxs("div", { className: "record-controls", children: [
  /* @__PURE__ */ N.jsx(m8, {}),
  /* @__PURE__ */ N.jsx(o_, { primary: !0 }),
  /* @__PURE__ */ N.jsx(o_, {})
] }));
const b8 = () => {
  const { tryFetchExternalRecordForEdit: t } = Tp(), { dispatchNavigateToOriginEventWithFallback: r } = Sm(), { externalId: i } = Cm();
  return /* @__PURE__ */ N.jsxs("div", { className: "preview-external-resource-controls", children: [
    /* @__PURE__ */ N.jsx(
      Dn,
      {
        "data-testid": "close-external-preview-button",
        type: Mn.Primary,
        onClick: () => r(),
        children: /* @__PURE__ */ N.jsx(mt, { id: "ld.cancel" })
      }
    ),
    /* @__PURE__ */ N.jsx(
      Dn,
      {
        "data-testid": "continue-external-preview-button",
        type: Mn.Highlighted,
        onClick: () => t(i),
        children: /* @__PURE__ */ N.jsx(mt, { id: "ld.continue" })
      }
    )
  ] });
};
const y8 = () => {
  const t = mm(K9), r = mm(Q9), { basicValue: i } = ud(), { record: u } = Ea();
  return (t || r && u) && !i && /* @__PURE__ */ N.jsxs("div", { className: "footer", children: [
    t && /* @__PURE__ */ N.jsx(g8, {}),
    r && /* @__PURE__ */ N.jsx(b8, {})
  ] });
}, C8 = () => {
  const t = mm(TF), { isLoading: r } = qu();
  return /* @__PURE__ */ N.jsxs("div", { "data-testid": "root", id: "app-root", children: [
    /* @__PURE__ */ N.jsx(G6, {}),
    /* @__PURE__ */ N.jsx(PB, {}),
    /* @__PURE__ */ N.jsx("div", { className: In("main-content", { "no-overflow": t }), children: /* @__PURE__ */ N.jsx(fP, {}) }),
    /* @__PURE__ */ N.jsx(y8, {}),
    /* @__PURE__ */ N.jsx("div", { id: aO }),
    r && /* @__PURE__ */ N.jsx(J9, {})
  ] });
}, E8 = (t) => t ? kB[t] || Le.LABEL : Le.TERM, S8 = (t) => {
  var i;
  return t ? (i = FB[t]) == null ? void 0 : i.valueUri : void 0;
}, x8 = ({
  advancedValueField: t,
  label: r
}) => t && r ? { [t]: [r] } : void 0, R8 = (t, r) => r ? r.reduce((i, u) => i || (i = !!t.get(u), i), !1) : !1, TO = (t) => {
  if (!(!t || !QN[t]))
    return QN[t];
}, wO = ({
  propertyURI: t,
  parentEntryType: r,
  type: i
}) => {
  const { block: u, groupComplex: c } = At;
  return !!TO(t) && r === u && i === c;
}, T8 = (t) => Array.isArray(t) ? t[0] : t, w8 = ({
  propertyURI: t,
  type: r,
  parentEntryType: i,
  selectedRecord: u
}) => {
  var S;
  const c = TO(t), v = wO({ propertyURI: t, parentEntryType: i, type: r }), h = T8(u);
  return { selectedNonBFRecord: v && ((S = c == null ? void 0 : c.container) != null && S.key) ? h == null ? void 0 : h[c.container.key] : void 0, nonBFMappedGroup: v ? {
    uri: t,
    data: c
  } : void 0 };
}, IO = ({
  schema: t,
  path: r,
  key: i,
  value: u
}) => r.reduce(
  (c, v) => {
    const h = t.get(v);
    return (h == null ? void 0 : h[i]) === u && (c = h), c;
  },
  null
), I8 = (t) => {
  if (!t)
    return;
  const r = { ...t };
  return t != null && t.readOnly && (r.readOnly = !!(t != null && t.readOnly)), t != null && t.isNew && (r.isNew = !!t.isNew), r;
}, $g = (t) => {
  const r = t.length - hO, i = r >= 0 ? r : 0;
  return t[i];
}, A8 = (t, r, i) => {
  let u;
  return r == null || r.forEach((c) => {
    if (u)
      return;
    const v = t.get(c);
    (v == null ? void 0 : v.bfid) === i && (u = v);
  }), u;
}, AO = ({
  schema: t,
  dependentEntry: r,
  parentEntryChildren: i,
  dependsOnId: u
}) => {
  const c = A8(t, i, u), v = { ...c }, h = { ...r };
  return c && (v.linkedEntry = { dependent: h.uuid }, h.linkedEntry = { controlledBy: v.uuid }), { controlledByEntry: v, dependentEntry: h };
}, N8 = ({ path: t = [] }, r) => t.reduce((i, u) => {
  const c = r.get(u);
  if (!c)
    return i;
  const { uriBFLite: v, uri: h, bfid: y, cloneIndex: g } = c, S = v ?? h, x = y == null ? void 0 : y.split(r6).at(-1);
  let T = S ? S.split(i6).at(-1) : x;
  return x && x !== T && (T += `${a6}${x}`), [...i, `${T}${l6}${g ?? 0}`];
}, []).join(o6), UT = (t, r = "") => `${r}${s6}${t}`, Yy = (t) => {
  const { uri: r, constraints: i } = t, { valueDataType: u } = i ?? {}, c = u != null && u.dataTypeURI ? `${u6}${u == null ? void 0 : u.dataTypeURI}` : "";
  return `${r}${c}`;
}, _8 = (t, r) => {
  var u;
  return !r || Jy.includes(r.type) ? !1 : ((u = r.children) == null ? void 0 : u.every((c) => !t.get(c))) ?? !1;
}, O8 = (t) => /* @__PURE__ */ k.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("g", { clipPath: "url(#clip0_5625_189837)" }, /* @__PURE__ */ k.createElement("path", { d: "M0.0903364 8.6577L0.599139 9.16712C0.719562 9.28768 0.914819 9.28768 1.03527 9.16712L5.69 4.51782L10.3448 9.16709C10.4652 9.28766 10.6604 9.28766 10.7809 9.16709L11.2897 8.65767C11.4101 8.5371 11.4101 8.34161 11.2897 8.22102L5.90805 2.83292C5.78763 2.71235 5.59237 2.71235 5.47192 2.83292L0.0903364 8.22104C-0.0301121 8.34164 -0.0301121 8.53713 0.0903364 8.6577Z", fill: "#55585D" })), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", { id: "clip0_5625_189837" }, /* @__PURE__ */ k.createElement("rect", { width: 11.38, height: 11.38, fill: "white", transform: "translate(0 0.309998)" })))), L8 = "_:", D8 = "http://www.loc.gov/mads/rdf/v1#authoritativeLabel", M8 = "http://www.w3.org/2000/01/rdf-schema#label", l_ = "@id", P8 = "@value", k8 = "/", F8 = {
  "http://id.loc.gov/authorities/childrensSubjects": {
    name: "childrensSubjects",
    type: "complex",
    modes: []
  },
  "http://id.loc.gov/authorities/demographicTerms": {
    name: "demographicTerms",
    type: "complex",
    modes: []
  },
  "http://id.loc.gov/authorities/genreForms": {
    name: "genreForms",
    type: "complex",
    processor: "lcAuthorities",
    modes: [
      {
        "LCGFT All": {
          url: "https://id.loc.gov/authorities/genreForms/suggest2/?q=<QUERY>&count=25",
          all: !0
        }
      }
    ]
  },
  "http://id.loc.gov/authorities/geographics": {
    name: "geographics",
    type: "complex",
    modes: []
  },
  "http://id.loc.gov/authorities/names": {
    name: "names",
    type: "complex",
    processor: "lcAuthorities",
    modes: [
      {
        "NAF All": {
          url: "https://id.loc.gov/authorities/names/suggest2/?q=<QUERY>&count=25",
          all: !0
        },
        "NAF Personal Names": {
          url: "https://id.loc.gov/authorities/names/suggest2/?q=<QUERY>&rdftype=PersonalName&count=25"
        },
        "NAF Corporate Name": {
          url: "https://id.loc.gov/authorities/names/suggest2/?q=<QUERY>&rdftype=CorporateName&count=25"
        },
        "NAF Name/Title": {
          url: "https://id.loc.gov/authorities/names/suggest2/?q=<QUERY>&rdftype=NameTitle&count=25"
        },
        "NAF Title": {
          url: "https://id.loc.gov/authorities/names/suggest2/?q=<QUERY>&rdftype=Title&count=25"
        },
        "NAF Geographic": {
          url: "https://id.loc.gov/authorities/names/suggest2/?q=<QUERY>&rdftype=Geographic&count=25"
        },
        "NAF Conference Name": {
          url: "https://id.loc.gov/authorities/names/suggest2/?q=<QUERY>&rdftype=ConferenceName&count=25"
        }
      }
    ]
  },
  "http://preprod.id.loc.gov/authorities/names": {
    name: "names",
    type: "complex",
    processor: "lcAuthorities",
    modes: [
      {
        "NAF All": {
          url: "http://preprod.id.loc.gov/authorities/names/suggest2/?q=<QUERY>&count=25",
          all: !0
        },
        "NAF Personal Names": {
          url: "http://preprod.id.loc.gov/authorities/names/suggest2/?q=<QUERY>&rdftype=PersonalName&count=25"
        },
        "NAF Corporate Name": {
          url: "http://preprod.id.loc.gov/authorities/names/suggest2/?q=<QUERY>&rdftype=CorporateName&count=25"
        },
        "NAF Name/Title": {
          url: "http://preprod.id.loc.gov/authorities/names/suggest2/?q=<QUERY>&rdftype=NameTitle&count=25"
        },
        "NAF Title": {
          url: "http://preprod.id.loc.gov/authorities/names/suggest2/?q=<QUERY>&rdftype=Title&count=25"
        },
        "NAF Geographic": {
          url: "http://preprod.id.loc.gov/authorities/names/suggest2/?q=<QUERY>&rdftype=Geographic&count=25"
        },
        "NAF Conference Name": {
          url: "http://preprod.id.loc.gov/authorities/names/suggest2/?q=<QUERY>&rdftype=ConferenceName&count=25"
        }
      }
    ]
  },
  "http://id.loc.gov/authorities/performanceMediums": {
    name: "Works",
    processor: "lcAuthorities",
    type: "complex",
    modes: [
      {
        All: {
          url: "http://id.loc.gov/authorities/performanceMediums/suggest2/?q=<QUERY>&count=25",
          all: !0
        }
      }
    ]
  },
  "http://id.loc.gov/authorities/subjects": {
    name: "subjects",
    type: "complex",
    processor: "lcAuthorities",
    modes: [
      {
        "LCSH All": {
          url: "https://id.loc.gov/authorities/subjects/suggest2/?q=<QUERY>&count=25",
          all: !0
        },
        "LCSH Topics": {
          url: "https://id.loc.gov/authorities/subjects/suggest2/?q=<QUERY>&rdftype=Topic&count=25"
        },
        "LCSH Geographic": {
          url: "https://id.loc.gov/authorities/subjects/suggest2/?q=<QUERY>&rdftype=Geographic&count=25"
        },
        "LCSH Name": {
          url: "https://id.loc.gov/authorities/subjects/suggest2/?q=<QUERY>&rdftype=Name&count=25"
        },
        "LCSH FamilyName": {
          url: "https://id.loc.gov/authorities/subjects/suggest2/?q=<QUERY>&rdftype=FamilyName&count=25"
        },
        "LCSH CorporateName": {
          url: "https://id.loc.gov/authorities/subjects/suggest2/?q=<QUERY>&rdftype=CorporateName&count=25"
        },
        "LCSH GenreForm": {
          url: "https://id.loc.gov/authorities/subjects/suggest2/?q=<QUERY>&rdftype=GenreForm&count=25"
        },
        "LCSH Simple Type": {
          url: "https://id.loc.gov/authorities/subjects/suggest2/?q=<QUERY>&rdftype=SimpleType&count=25"
        },
        "LCSH Complex Subject": {
          url: "https://id.loc.gov/authorities/subjects/suggest2/?q=<QUERY>&rdftype=ComplexSubject&count=25"
        },
        "LCSH Temporal": {
          url: "https://id.loc.gov/authorities/subjects/suggest2/?q=<QUERY>&rdftype=Temporal&count=25"
        }
      }
    ]
  },
  HierarchicalGeographic: {
    name: "names",
    type: "complex",
    processor: "lcAuthorities",
    modes: [
      {
        All: {
          url: "https://preprod-8288.id.loc.gov/authorities/names/suggest2/?q=<QUERY>&count=25&rdftype=HierarchicalGeographic",
          all: !0
        }
      }
    ]
  },
  "http://id.loc.gov/entities/providers": {
    name: "providers",
    type: "complex",
    modes: []
  },
  "http://id.loc.gov/entities/relationships": {
    name: "relationships",
    processor: "lcAuthorities",
    type: "complex",
    modes: [
      {
        All: {
          url: "https://id.loc.gov/entities/relationships/suggest2/?q=<QUERY>&count=25",
          all: !0
        }
      }
    ]
  },
  "http://id.loc.gov/vocabulary/geographicAreas": {
    name: "geographicAreas",
    processor: "lcAuthorities",
    type: "complex",
    minCharBeforeSearch: 2,
    modes: [
      {
        All: {
          url: "https://id.loc.gov/vocabulary/geographicAreas/suggest2/?q=<QUERY>&count=25",
          all: !0
        }
      }
    ]
  },
  "https://preprod-8230.id.loc.gov/resources/works": {
    name: "Works",
    processor: "lcAuthorities",
    type: "complex",
    modes: [
      {
        "Works - Keyword": {
          url: "https://preprod-8080.id.loc.gov/resources/works/suggest2/?q=?<QUERY>&count=25",
          all: !0
        },
        "Works - Left Anchored": {
          url: "https://preprod-8080.id.loc.gov/resources/works/suggest2/?q=<QUERY>&count=25"
        },
        "Hubs - Keyword": {
          url: "https://preprod-8080.id.loc.gov/resources/hubs/suggest2/?q=?<QUERY>&count=25"
        },
        "Hubs - Left Anchored": {
          url: "https://preprod-8080.id.loc.gov/resources/hubs/suggest2/?q=<QUERY>&count=25"
        }
      }
    ]
  },
  "https://preprod-8295.id.loc.gov/resources/works": {
    name: "Works",
    processor: "lcAuthorities",
    type: "complex",
    modes: [
      {
        "Works - Keyword": {
          url: "https://preprod-8295.id.loc.gov/resources/works/suggest2/?q=?<QUERY>&count=25",
          all: !0
        },
        "Works - Left Anchored": {
          url: "https://preprod-8295.id.loc.gov/resources/works/suggest2/?q=<QUERY>&count=25"
        },
        "Hubs - Keyword": {
          url: "https://preprod-8295.id.loc.gov/resources/hubs/suggest2/?q=?<QUERY>&count=25"
        },
        "Hubs - Left Anchored": {
          url: "https://preprod-8295.id.loc.gov/resources/hubs/suggest2/?q=<QUERY>&count=25"
        }
      }
    ]
  },
  "https://preprod-8210.id.loc.gov/resources/works/": {
    name: "Works",
    processor: "lcAuthorities",
    type: "complex",
    modes: [
      {
        "Works - Keyword": {
          url: "https://preprod-8295.id.loc.gov/resources/works/suggest2/?q=?<QUERY>&count=25",
          all: !0
        },
        "Works - Left Anchored": {
          url: "https://preprod-8295.id.loc.gov/resources/works/suggest2/?q=<QUERY>&count=25"
        },
        "Hubs - Keyword": {
          url: "https://preprod-8295.id.loc.gov/resources/hubs/suggest2/?q=?<QUERY>&count=25"
        },
        "Hubs - Left Anchored": {
          url: "https://preprod-8295.id.loc.gov/resources/hubs/suggest2/?q=<QUERY>&count=25"
        }
      }
    ]
  },
  "https://preprod-8295.id.loc.gov/resources/works/": {
    name: "Works",
    processor: "lcAuthorities",
    type: "complex",
    modes: [
      {
        "Works - Keyword": {
          url: "https://preprod-8295.id.loc.gov/resources/works/suggest2/?q=?<QUERY>&count=25",
          all: !0
        },
        "Works - Left Anchored": {
          url: "https://preprod-8295.id.loc.gov/resources/works/suggest2/?q=<QUERY>&count=25"
        },
        "Hubs - Keyword": {
          url: "https://preprod-8295.id.loc.gov/resources/hubs/suggest2/?q=?<QUERY>&count=25"
        },
        "Hubs - Left Anchored": {
          url: "https://preprod-8295.id.loc.gov/resources/hubs/suggest2/?q=<QUERY>&count=25"
        }
      }
    ]
  },
  "https://preprod-8080.id.loc.gov/resources/works": {
    name: "Works",
    processor: "lcAuthorities",
    type: "complex",
    modes: [
      {
        "Works - Keyword": {
          url: "https://preprod-8080.id.loc.gov/resources/works/suggest2/?q=?<QUERY>&count=25",
          all: !0
        },
        "Works - Left Anchored": {
          url: "https://preprod-8080.id.loc.gov/resources/works/suggest2/?q=<QUERY>&count=25"
        },
        "Hubs - Keyword": {
          url: "https://preprod-8080.id.loc.gov/resources/hubs/suggest2/?q=?<QUERY>&count=25"
        },
        "Hubs - Left Anchored": {
          url: "https://preprod-8080.id.loc.gov/resources/hubs/suggest2/?q=<QUERY>&count=25"
        }
      }
    ]
  },
  "https://preprod-8080.id.loc.gov/resources/works/": {
    name: "Works",
    processor: "lcAuthorities",
    type: "complex",
    modes: [
      {
        "Works - Keyword": {
          url: "https://preprod-8080.id.loc.gov/resources/works/suggest2/?q=?<QUERY>&count=25",
          all: !0
        },
        "Works - Left Anchored": {
          url: "https://preprod-8080.id.loc.gov/resources/works/suggest2/?q=<QUERY>&count=25"
        },
        "Hubs - Keyword": {
          url: "https://preprod-8080.id.loc.gov/resources/hubs/suggest2/?q=?<QUERY>&count=25"
        },
        "Hubs - Left Anchored": {
          url: "https://preprod-8080.id.loc.gov/resources/hubs/suggest2/?q=<QUERY>&count=25"
        }
      }
    ]
  },
  "https://id.loc.gov/resources/hubs": {
    name: "Works",
    processor: "lcAuthorities",
    type: "complex",
    modes: [
      {
        "Hubs - Keyword": {
          url: "https://preprod-8080.id.loc.gov/resources/hubs/suggest2/?q=?<QUERY>&count=25",
          all: !0
        },
        "Hubs - Left Anchored": {
          url: "https://preprod-8080.id.loc.gov/resources/hubs/suggest2/?q=<QUERY>&count=25"
        }
      }
    ]
  },
  "https://preprod-8080.id.loc.gov/resources/hubs": {
    name: "Hubs",
    processor: "lcAuthorities",
    type: "complex",
    modes: [
      {
        "Hubs - Keyword": {
          url: "https://preprod-8080.id.loc.gov/resources/hubs/suggest2/?q=?<QUERY>&count=25",
          all: !0
        },
        "Hubs - Left Anchored": {
          url: "https://preprod-8080.id.loc.gov/resources/hubs/suggest2/?q=<QUERY>&count=25"
        }
      }
    ]
  },
  "https://preprod-8080.id.loc.gov/resources/instances": {
    name: "Instances",
    processor: "lcAuthorities",
    type: "complex",
    modes: [
      {
        All: {
          url: "https://preprod-8080.id.loc.gov/resources/instances/suggest2/?q=<QUERY>&count=25",
          all: !0
        }
      }
    ]
  },
  "https://preprod-8230.id.loc.gov/resources/instances": {
    name: "Instances",
    processor: "lcAuthorities",
    type: "complex",
    modes: [
      {
        All: {
          url: "https://preprod-8080.id.loc.gov/resources/instances/suggest2/?q=<QUERY>&count=25",
          all: !0
        }
      }
    ]
  },
  "http://id.loc.gov/entities/roles": {
    name: "roles",
    type: "complex",
    modes: []
  },
  "http://id.loc.gov/resources/works": {
    name: "works",
    type: "complex",
    modes: []
  },
  "http://id.loc.gov/rwo/agents": {
    name: "agents",
    type: "complex",
    modes: []
  },
  "http://id.loc.gov/vocabulary/carriers": {
    name: "carriers",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/classSchemes": {
    name: "classSchemes",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/contentTypes": {
    name: "contentTypes",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/countries": {
    name: "countries",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/descriptionConventions": {
    name: "descriptionConventions",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/frequencies": {
    name: "frequencies",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/genreFormSchemes": {
    name: "genreFormSchemes",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/graphicMaterials": {
    name: "graphicMaterials",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/issuance": {
    name: "issuance",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/languages": {
    name: "languages",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/marcauthen": {
    name: "marcauthen",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/marcgt": {
    name: "marcgt",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/maspect": {
    name: "maspect",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/maudience": {
    name: "maudience",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mbroadstd": {
    name: "mbroadstd",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mcapturestorage": {
    name: "mcapturestorage",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mcolor": {
    name: "mcolor",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mediaTypes": {
    name: "mediaTypes",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/menclvl": {
    name: "menclvl",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mfiletype": {
    name: "mfiletype",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mgeneration": {
    name: "mgeneration",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mgroove": {
    name: "mgroove",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/millus": {
    name: "millus",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mlayout": {
    name: "mlayout",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mmaterial": {
    name: "mmaterial",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mmusicformat": {
    name: "mmusicformat",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mmusnotation": {
    name: "mmusnotation",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mplayback": {
    name: "mplayback",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mpolarity": {
    name: "mpolarity",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mpresformat": {
    name: "mpresformat",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mproduction": {
    name: "mproduction",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mrecmedium": {
    name: "mrecmedium",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mrectype": {
    name: "mrectype",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mregencoding": {
    name: "mregencoding",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mrelief": {
    name: "mrelief",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mscale": {
    name: "mscale",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mscript": {
    name: "mscript",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/msoundcontent": {
    name: "msoundcontent",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mspecplayback": {
    name: "mspecplayback",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mstatus": {
    name: "mstatus",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/msupplcont": {
    name: "msupplcont",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/mtechnique": {
    name: "mtechnique",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/organizations": {
    name: "organizations",
    type: "complex",
    modes: []
  },
  "http://id.loc.gov/vocabulary/relators": {
    name: "relators",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/resourceComponents": {
    name: "resourceComponents",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/resourceTypes": {
    name: "resourceTypes",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/vocabulary/subjectSchemes": {
    name: "subjectSchemes",
    type: "simple",
    modes: []
  },
  "http://mlvlp04.loc.gov:3000/verso/api/configs?filter[where][configType]=noteTypes&filter[fields][json]=true": {
    name: "true",
    type: "simple",
    modes: []
  },
  "http://mlvlp04.loc.gov:8080/authorities/classification/G": {
    name: "G",
    type: "simple",
    modes: []
  },
  "http://mlvlp04.loc.gov:8230/resources/instances": {
    name: "instances",
    type: "simple",
    modes: []
  },
  "http://mlvlp04.loc.gov:8230/resources/works": {
    name: "works",
    type: "simple",
    modes: []
  },
  "http://mlvlp06.loc.gov:8288/resources/hubs": {
    name: "hubs",
    type: "simple",
    modes: []
  },
  "http://mlvlp06.loc.gov:8288/resources/works": {
    name: "works",
    type: "simple",
    modes: []
  },
  "http://rdaregistry.info/termList/RDAContentType/": {
    name: "RDAContentType/",
    type: "simple",
    modes: []
  },
  "http://www.rdaregistry.info/termList/RDAColourContent/": {
    name: "RDAColourContent/",
    type: "simple",
    modes: []
  },
  "https://lookup.ld4l.org/authorities/search/linked_data/dbpedia_ld4l_cache": {
    name: "dbpedia_ld4l_cache",
    type: "simple",
    modes: []
  },
  "https://lookup.ld4l.org/authorities/search/linked_data/getty_aat_ld4l_cache": {
    name: "getty_aat_ld4l_cache",
    type: "simple",
    modes: []
  },
  "http://id.loc.gov/ontologies/bibframe": {
    name: "bibframe",
    type: "simple",
    modes: []
  },
  "https://www.wikidata.org/w/api.php": {
    name: "wikidata",
    type: "complex",
    processor: "wikidataAPI",
    modes: [
      {
        Wikidata: {
          url: "https://www.wikidata.org/w/api.php?action=wbsearchentities&search=<QUERY>&format=json&errorformat=plaintext&language=en&uselang=en&type=item&origin=*",
          all: !0
        }
      }
    ]
  }
}, NO = (t, r) => {
  var c, v;
  const i = (c = t.label) == null ? void 0 : c.toLocaleLowerCase(), u = (v = r.label) == null ? void 0 : v.toLocaleLowerCase();
  return !i || u && u > i ? -1 : !u || i > u ? 1 : 0;
}, B8 = ({
  type: t,
  propertyURI: r,
  valueConstraint: { valueTemplateRefs: i, useValuesFrom: u }
}) => {
  if (r === XR.HAS_INSTANCE || r === XR.INSTANCE_OF)
    return Cs.META;
  if (r === XR.HAS_ITEM)
    return Cs.HIDE;
  if (i.length > 0)
    return Cs.REF;
  if (t === At.literal)
    return Cs.LITERAL;
  if (u.length === 0)
    return Cs.UNKNOWN;
  let c = Cs.SIMPLE;
  return u.forEach((v) => {
    var h;
    ((h = F8[v]) == null ? void 0 : h.type.toLowerCase()) === At.complex && (c = Cs.COMPLEX);
  }), c;
}, U8 = (t) => {
  if ((t == null ? void 0 : t.configType) === At.profile)
    return At.profile;
  if (t != null && t.propertyTemplates || t != null && t.resourceURI)
    return At.block;
  if (t != null && t.propertyLabel || t != null && t.propertyURI)
    switch (B8(t)) {
      case Cs.LITERAL:
        return At.literal;
      case Cs.SIMPLE:
        return At.simple;
      case Cs.COMPLEX:
        return At.complex;
      case Cs.HIDE:
      case Cs.META:
        return At.group;
      case Cs.REF: {
        const {
          valueConstraint: { valueTemplateRefs: i }
        } = t;
        return i.length > 1 ? At.dropdown : At.groupComplex;
      }
      default:
        return At.__fallback;
    }
  return At.__fallback;
}, _O = (t, r) => {
  const i = /* @__PURE__ */ new Set([...t]);
  return r.forEach((u) => i.delete(u)), i;
};
const V8 = ({
  entry: { uuid: t },
  twins: r = [],
  generateComponent: i,
  groupClassName: u
}) => {
  const { collapsedEntries: c, setCollapsedEntries: v } = Qa(), h = r.length, y = r.filter((x) => !c.has(x)), g = y.length === 0, S = () => v((x) => {
    const T = /* @__PURE__ */ new Set([...r ?? [], ...x]);
    return T.size === x.size ? _O(x, r) : T;
  });
  return /* @__PURE__ */ N.jsxs("div", { className: In("duplicate-group-container", u), children: [
    i({ uuid: t, groupingDisabled: !0 }),
    !!h && /* @__PURE__ */ N.jsxs(Dn, { "data-testid": "expand-collapse-button", className: "expand-collapse-button", onClick: S, children: [
      /* @__PURE__ */ N.jsx(O8, { className: In({ "arrow-closed": g }) }),
      /* @__PURE__ */ N.jsx("span", { children: /* @__PURE__ */ N.jsx(
        mt,
        {
          id: g ? "ld.showAllWithCount" : "ld.hide",
          values: {
            amt: h ? /* @__PURE__ */ N.jsx("span", { "data-testid": "duplicate-group-clone-amount", children: h + 1 }) : void 0
          }
        }
      ) })
    ] }),
    y == null ? void 0 : y.map((x) => i({ uuid: x, groupingDisabled: !0 }))
  ] });
}, VT = k.memo(
  ({ condition: t, wrapper: r, children: i }) => t ? r == null ? void 0 : r({ children: i }) : i
), H8 = ({
  entry: { uuid: t },
  twins: r,
  generateComponent: i
}) => /* @__PURE__ */ N.jsxs(k.Fragment, { children: [
  i({ uuid: t, groupingDisabled: !0 }),
  r == null ? void 0 : r.map((u) => i({ uuid: u, groupingDisabled: !0 }))
] }, t), j8 = ({ groupClassName: t, isCompact: r }) => ({ children: i }) => /* @__PURE__ */ N.jsx("div", { className: In(t, { [`${t}-compact`]: r }), children: i }), HT = k.memo(
  ({
    uuid: t,
    drawComponent: r,
    groupByLevel: i = 2,
    level: u = 0,
    groupClassName: c = "",
    disabledFields: v,
    scrollToEnabled: h = !1,
    groupingDisabled: y = !1
  }) => {
    const { currentlyEditedEntityBfid: g } = Qa(), { schema: S } = cd(), { selectedEntries: x } = Ea(), T = t && (S == null ? void 0 : S.get(t));
    if (!T)
      return null;
    const { type: _, bfid: L = "", children: M, twinChildren: U } = T, B = _ === At.dropdownOption && x.includes(t), H = u === dO ? g == null ? void 0 : g.has(L) : !0, Y = B || _ !== At.dropdownOption, G = !(M != null && M.length) && u <= i, Q = !y && u === i;
    if (!H)
      return null;
    const W = ({ ...oe }) => /* @__PURE__ */ N.jsx(
      HT,
      {
        drawComponent: r,
        uuid: t,
        level: u + 1,
        disabledFields: v,
        scrollToEnabled: h,
        ...oe
      },
      oe.uuid
    );
    return /* @__PURE__ */ N.jsxs(VT, { condition: Q, wrapper: j8({ groupClassName: c, isCompact: G }), children: [
      r == null ? void 0 : r({
        schema: S,
        entry: T,
        level: u,
        disabledFields: v,
        isCompact: G
      }),
      Y && (M == null ? void 0 : M.map((oe) => {
        const j = S.get(oe);
        if (!j)
          return;
        const re = Yy(j), me = U == null ? void 0 : U[re];
        if ((me == null ? void 0 : me[0]) === oe) {
          const Ne = me.slice(1);
          return u === 1 ? /* @__PURE__ */ N.jsx(
            V8,
            {
              groupClassName: c,
              entry: j,
              generateComponent: W,
              twins: Ne
            },
            oe
          ) : /* @__PURE__ */ N.jsx(
            H8,
            {
              entry: j,
              twins: Ne,
              generateComponent: W
            },
            oe
          );
        }
        return me ? null : /* @__PURE__ */ N.jsx(
          HT,
          {
            drawComponent: r,
            uuid: oe,
            level: u + 1,
            groupClassName: c,
            disabledFields: v,
            scrollToEnabled: h
          },
          oe
        );
      }))
    ] });
  }
);
const G8 = k.memo(({ isOpen: t, onCancel: r, onSubmit: i, onClose: u }) => {
  const { formatMessage: c } = La();
  return /* @__PURE__ */ N.jsx(
    qg,
    {
      isOpen: t,
      title: c({ id: "ld.closeRd" }),
      submitButtonLabel: c({ id: "ld.no" }),
      cancelButtonLabel: c({ id: "ld.yes" }),
      onClose: u,
      onSubmit: i,
      onCancel: r,
      children: /* @__PURE__ */ N.jsx("div", { className: "close-record-contents", "data-testid": "modal-close-record-content", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.confirmCloseRd" }) })
    }
  );
});
const z8 = k.memo(({ isOpen: t, onCancel: r, onSubmit: i, onClose: u }) => {
  const { formatMessage: c } = La();
  return /* @__PURE__ */ N.jsx(
    qg,
    {
      isOpen: t,
      title: c({ id: "ld.unsavedChanges" }),
      submitButtonLabel: c({ id: "ld.saveAndContinue" }),
      cancelButtonLabel: c({ id: "ld.continueWithoutSaving" }),
      onClose: u,
      onSubmit: i,
      onCancel: r,
      className: "modal-switch-to-new-record",
      children: /* @__PURE__ */ N.jsx("div", { className: "close-record-contents", "data-testid": "modal-close-record-content", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.unsavedRecentEdits" }) })
    }
  );
});
const W8 = ({ when: t }) => {
  const { saveRecord: r } = Tp(), {
    isModalOpen: i,
    setIsModalOpen: u,
    openModal: c
  } = EC(), {
    isModalOpen: v,
    setIsModalOpen: h,
    openModal: y
  } = EC(), { setIsRecordEdited: g, setRecordStatus: S } = Si(), [x, T] = k.useState(null), { navigateToEditPage: _ } = fd(), { dispatchProceedNavigationEvent: L, dispatchUnblockEvent: M } = Sm({
    onTriggerModal: () => u(!0)
  }), U = () => {
    u(!1), h(!1);
  }, B = lP(({ currentLocation: W, nextLocation: { pathname: oe, search: j } }) => {
    if ((W == null ? void 0 : W.pathname) === oe)
      return !1;
    if (t) {
      const re = s8(oe, j);
      re ? (T({ pathname: oe, search: j, to: re }), y()) : c();
    }
    return t;
  }), H = () => {
    var W;
    U(), (W = B.reset) == null || W.call(B);
  }, Y = () => {
    var W;
    (W = B.proceed) == null || W.call(B), L(), U(), g(!1), S({ type: od.open });
  }, G = async () => {
    const W = await r({ asRefToNewRecord: !0, shouldSetSearchParams: !x });
    if (S({ type: od.saveAndClose }), !x)
      Y();
    else if (H(), M(), x.to === Vg.EditPage)
      _(x.pathname, { replace: !0 });
    else {
      const oe = new URLSearchParams(x == null ? void 0 : x.search), j = x.to === Vg.CreatePage ? Mi.Ref : Mi.CloneOf;
      oe.set(j, W), _(`${x.pathname}?${oe}`, { replace: !0 });
    }
  }, Q = () => Y();
  return /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
    /* @__PURE__ */ N.jsx(
      z8,
      {
        isOpen: v,
        onSubmit: G,
        onCancel: Q,
        onClose: H
      }
    ),
    /* @__PURE__ */ N.jsx(
      G8,
      {
        isOpen: i,
        onCancel: Y,
        onSubmit: H,
        onClose: H
      }
    )
  ] });
};
var s0 = /* @__PURE__ */ ((t) => (t.Authorities = "authorities", t))(s0 || {}), rr = /* @__PURE__ */ ((t) => (t.Keyword = "keyword", t.Identifier = "identifier", t.LCCN = "lccn", t.PersonalName = "personalName", t.CorporateConferenceName = "corporateConferenceName", t.GeographicName = "geographicName", t.NameTitle = "nameTitle", t.UniformTitle = "uniformTitle", t.Subject = "subject", t.ChildrenSubjectHeading = "childrenSubjectHeading", t.Genre = "genre", t))(rr || {}), nr = /* @__PURE__ */ ((t) => (t.Query = "query", t.Prev = "prev", t.Next = "next", t))(nr || {});
const $R = {
  subclass: {
    PERSON: {
      bf2Uri: "http://id.loc.gov/ontologies/bibframe/Person",
      labelId: "ld.person"
    },
    FAMILY: {
      bf2Uri: "http://id.loc.gov/ontologies/bibframe/Family",
      labelId: "ld.family"
    },
    ORGANIZATION: {
      bf2Uri: "http://id.loc.gov/ontologies/bibframe/Organization",
      labelId: "ld.organization"
    },
    MEETING: {
      bf2Uri: "http://id.loc.gov/ontologies/bibframe/Meeting",
      labelId: "ld.meeting"
    },
    JURISDICTION: {
      bf2Uri: "http://id.loc.gov/ontologies/bibframe/Jurisdiction",
      labelId: "ld.jurisdiction"
    }
  }
}, X8 = "empty", Y8 = " ,", $8 = "__MOCK_URI_CHANGE_WHEN_IMPLEMENTING";
var A2 = /* @__PURE__ */ ((t) => (t.Creator = "creator", t))(A2 || {}), N2 = /* @__PURE__ */ ((t) => (t.CreatorOfWork = "CREATOR_OF_WORK", t))(N2 || {});
const _2 = (t) => `${t}_${X8}`, Z8 = ({
  schema: t,
  linkedEntry: r
}) => r != null && r.dependent ? t.get(r.dependent) : void 0, J8 = ({
  schema: t,
  linkedField: r,
  linkedFieldValue: i,
  lookupConfig: u
}) => {
  var g, S, x;
  const c = u.linkedField, v = i, h = (S = (g = $R == null ? void 0 : $R[c]) == null ? void 0 : g[v]) == null ? void 0 : S.bf2Uri;
  let y;
  return (x = r == null ? void 0 : r.children) == null || x.forEach((T) => {
    if (y)
      return;
    const _ = t.get(T);
    (_ == null ? void 0 : _.type) === At.dropdownOption && _.uri === h && (y = _);
  }), y;
}, s_ = ({
  selectedEntries: t,
  selectedEntriesService: r,
  linkedFieldChildren: i,
  newValue: u
}) => !r || !i || !u ? t : (r.set(t), r.removeMultiple(i), r.addNew(void 0, u), r.get()), Q8 = (t, r = N2.CreatorOfWork) => {
  var c;
  return t ? {
    rawMarc: JSON.stringify((c = t == null ? void 0 : t.parsedRecord) == null ? void 0 : c.content, null, 2).replace(/\r/g, "\r").replace(/\n/g, `
`),
    target: r
  } : {};
};
function K8() {
  const { setIsLoading: t } = qu(), { addStatusMessagesItem: r } = Si(), [i, u] = k.useState({
    data: null
  }), c = k.useCallback(
    async ({ url: v, method: h = "GET", urlParams: y, urlParam: g, requestParams: S, body: x, errorMessageId: T }) => {
      t(!0);
      try {
        const _ = ro.generateUrl(v, g), L = await ro.getJson({
          url: _,
          urlParams: y,
          requestParams: {
            method: h,
            headers: { "content-type": "application/json" },
            ...S,
            ...typeof x == "object" && x !== null ? { body: JSON.stringify(x, null, 2) } : {}
          }
        });
        return u({ data: L }), L;
      } catch {
        r == null || r(
          Ei.createMessage(Tr.error, T ?? "ld.errorMakingApiRequest")
        );
      } finally {
        t(!1);
      }
    },
    []
  );
  return {
    ...i,
    makeRequest: c
  };
}
const O2 = () => {
  const {
    authorityAssignmentCheckFailedIds: t,
    addAuthorityAssignmentCheckFailedIdsItem: r,
    resetAuthorityAssignmentCheckFailedIds: i
  } = OB();
  return { addFailedEntryId: (h) => {
    r == null || r(h);
  }, clearFailedEntryIds: () => {
    i();
  }, checkFailedId: (h) => h ? t.includes(h) : !1 };
}, q8 = ({
  entry: t,
  value: r,
  lookupConfig: i,
  authority: u = A2.Creator,
  onChange: c
}) => {
  const { selectedEntriesService: v } = xm(), [h, y] = k.useState(r || []), { schema: g } = cd(), { selectedEntries: S, setSelectedEntries: x } = Ea(), {
    complexValue: T,
    setComplexValue: _,
    resetComplexValue: L,
    metadata: M,
    resetMetadata: U
  } = ud(), { resetIsMarcPreviewOpen: B } = Qa(), { isModalOpen: H, setIsModalOpen: Y, openModal: G } = EC(), { fetchMarcData: Q } = T2(_), { uuid: W, linkedEntry: oe } = t, j = Z8({ schema: g, linkedEntry: oe }), { makeRequest: re } = K8(), { addStatusMessagesItem: me } = Si(), { addFailedEntryId: Se, clearFailedEntryIds: Ne } = O2(), Ge = (ke) => {
    if (c(W, []), y((q) => q.filter(({ id: pe }) => pe !== ke)), !(j && v))
      return;
    const _e = s_({
      selectedEntriesService: v,
      selectedEntries: S,
      linkedFieldChildren: j.children,
      newValue: _2(j.uuid)
    });
    x(_e);
  }, ze = k.useCallback(() => {
    Ne(), Y(!1);
  }, []), qe = () => {
    L(), U(), B();
  }, at = (ke) => {
    const { endpoints: _e, validationTarget: q } = i.api;
    return re({
      url: _e.validation ?? tO,
      method: "POST",
      body: Q8(ke, q == null ? void 0 : q[u])
    });
  }, st = ({
    id: ke,
    title: _e,
    srsId: q,
    linkedFieldValue: pe
  }) => {
    const $e = {
      id: ke,
      label: _e,
      meta: {
        type: At.complex,
        srsId: q
      }
    };
    if (c(W, [$e]), y([$e]), oe != null && oe.dependent && pe) {
      const lt = J8({ schema: g, linkedField: j, linkedFieldValue: pe, lookupConfig: i }), ot = s_({
        selectedEntriesService: v,
        selectedEntries: S,
        linkedFieldChildren: j == null ? void 0 : j.children,
        newValue: lt == null ? void 0 : lt.uuid
      });
      x(ot);
    }
  };
  return {
    localValue: h,
    isModalOpen: H,
    openModal: G,
    closeModal: ze,
    handleDelete: Ge,
    handleAssign: async ({ id: ke, title: _e, linkedFieldValue: q }) => {
      let pe, $e = T;
      if ((M == null ? void 0 : M.baseId) === ke)
        pe = M.srsId;
      else {
        const nt = await Q(ke, i.api.endpoints.marcPreview);
        nt && ($e = nt, pe = $e == null ? void 0 : $e.matchedId);
      }
      const { validAssignment: lt, invalidAssignmentReason: ot } = await at($e);
      if (lt)
        st({ id: ke, title: _e, srsId: pe, linkedFieldValue: q }), Ne(), qe(), ze();
      else {
        Se(ke);
        let nt = "ld.errorAssigningAuthority";
        ot && (nt += `.${ot.toLowerCase()}`), me == null || me(
          Ei.createMessage(Tr.error, nt)
        );
      }
    },
    handleOnChangeBase: ({ target: { value: ke } }) => {
      const _e = {
        label: ke,
        meta: {
          uri: $8
        }
      };
      c(W, [_e]), y((q) => [...q, _e]);
    }
  };
}, eU = [], tU = {
  [s0.Authorities]: [
    {
      id: "authoritySource",
      labelId: "ld.authoritySource",
      type: zl.Lookup,
      facet: Xh.AuthoritySource,
      isOpen: !0,
      hasExternalDataSource: !0,
      hasMappedSourceData: !0,
      excludedOptions: eU
    },
    {
      id: "references",
      labelId: "ld.references",
      type: zl.Multi,
      children: [
        {
          id: DT.ExcludeSeeFrom,
          type: $c.Checkbox,
          name: Xh.References,
          labelId: "ld.excludeSeeFrom"
        },
        {
          id: DT.ExcludeSeeFromAlso,
          type: $c.Checkbox,
          name: Xh.References,
          labelId: "ld.excludeSeeFromAlso"
        }
      ]
    },
    {
      id: "thesaurus",
      labelId: "ld.thesaurus",
      type: zl.Lookup,
      facet: Xh.Thesaurus,
      hasExternalDataSource: !0
    },
    {
      id: "typeOfHeading",
      labelId: "ld.typeOfHeading",
      type: zl.Lookup,
      facet: Xh.TypeOfHeading,
      hasExternalDataSource: !0
    },
    {
      id: "dateCreated",
      labelId: "ld.dateCreated",
      type: zl.DateRange,
      facet: Xh.DateCreated
    },
    {
      id: "dateUpdated",
      labelId: "ld.dateUpdated",
      type: zl.DateRange,
      facet: Xh.DateUpdated
    }
  ]
}, nU = {
  [s0.Authorities]: {
    [bo.Search]: [
      {
        label: "keyword",
        value: rr.Keyword
      },
      {
        label: "identifierAll",
        value: rr.Identifier
      },
      {
        label: "lccn",
        value: rr.LCCN
      },
      {
        label: "personalName",
        value: rr.PersonalName
      },
      {
        label: "corporateName",
        value: rr.CorporateConferenceName
      },
      {
        label: "geographicName",
        value: rr.GeographicName
      },
      {
        label: "nameTitle",
        value: rr.NameTitle
      },
      {
        label: "uniformTitle",
        value: rr.UniformTitle
      },
      {
        label: "subject",
        value: rr.Subject
      },
      {
        label: "childrensSubjectHeading",
        value: rr.ChildrenSubjectHeading
      },
      {
        label: "genre",
        value: rr.Genre
      }
    ],
    [bo.Browse]: [
      {
        label: "selectBrowseOption",
        value: "",
        isDisabled: !0
      },
      {
        label: "personalName",
        value: rr.PersonalName
      },
      {
        label: "corporateName",
        value: rr.CorporateConferenceName
      },
      {
        label: "geographicName",
        value: rr.GeographicName
      },
      {
        label: "nameTitle",
        value: rr.NameTitle
      },
      {
        label: "uniformTitle",
        value: rr.UniformTitle
      },
      {
        label: "subject",
        value: rr.Subject
      },
      {
        label: "genre",
        value: rr.Genre
      }
    ]
  }
}, rU = {
  [bo.Search]: {
    [rr.Keyword]: {
      [nr.Query]: `(keyword=="${Pt}" or naturalId="${Pt}")`
    },
    [rr.Identifier]: {
      [nr.Query]: `((identifiers.value=="${Pt}" or naturalId="${Pt}") and authRefType=="Authorized")`
    },
    [rr.LCCN]: {
      [nr.Query]: `lccn=="${Pt}"`
    },
    [rr.PersonalName]: {
      [nr.Query]: `(personalName all "${Pt}" or sftPersonalName all "${Pt}" or saftPersonalName all "${Pt}")`
    },
    [rr.CorporateConferenceName]: {
      [nr.Query]: `(corporateName all "${Pt}" or sftCorporateName all "${Pt}" or saftCorporateName all "${Pt}" or meetingName all "${Pt}" or sftMeetingName all "${Pt}" or saftMeetingName all "${Pt}")`
    },
    [rr.GeographicName]: {
      [nr.Query]: `(geographicName all "${Pt}" or sftGeographicName all "${Pt}" or saftGeographicName all "${Pt}")`
    },
    [rr.NameTitle]: {
      [nr.Query]: `(personalNameTitle all "${Pt}" or sftPersonalNameTitle all "${Pt}" or saftPersonalNameTitle all "${Pt}" or corporateNameTitle all "${Pt}" or sftCorporateNameTitle all "${Pt}" or saftCorporateNameTitle all "${Pt}" or meetingNameTitle all "${Pt}" or sftMeetingNameTitle all "${Pt}" or saftMeetingNameTitle all "${Pt}")`
    },
    [rr.UniformTitle]: {
      [nr.Query]: `(uniformTitle all "${Pt}" or sftUniformTitle all "${Pt}" or saftUniformTitle all "${Pt}")`
    },
    [rr.Subject]: {
      [nr.Query]: `(topicalTerm all "${Pt}" or sftTopicalTerm all "${Pt}" or saftTopicalTerm all "${Pt}")`
    },
    [rr.ChildrenSubjectHeading]: {
      [nr.Query]: `((keyword all "${Pt}" or naturalId="${Pt}") and subjectHeadings=="b")`
    },
    [rr.Genre]: {
      [nr.Query]: `(genreTerm all "${Pt}" or sftGenreTerm all "${Pt}" or saftGenreTerm all "${Pt}")`
    }
  },
  [bo.Browse]: {
    [rr.PersonalName]: {
      [nr.Query]: `(headingRef>="${Pt}" or headingRef<"${Pt}") and isTitleHeadingRef==false and headingType==("Personal Name")`,
      [nr.Prev]: `headingRef<"${Pt}" and isTitleHeadingRef==false and headingType==("Personal Name")`,
      [nr.Next]: `headingRef>"${Pt}" and isTitleHeadingRef==false and headingType==("Personal Name")`
    },
    [rr.CorporateConferenceName]: {
      [nr.Query]: `(headingRef>="${Pt}" or headingRef<"${Pt}") and isTitleHeadingRef==false and headingType==("Conference Name" or "Corporate Name")`,
      [nr.Prev]: `headingRef<"${Pt}" and isTitleHeadingRef==false and headingType==("Conference Name" or "Corporate Name")`,
      [nr.Next]: `headingRef>"${Pt}" and isTitleHeadingRef==false and headingType==("Conference Name" or "Corporate Name")`
    },
    [rr.GeographicName]: {
      [nr.Query]: `(headingRef>="${Pt}" or headingRef<"${Pt}") and isTitleHeadingRef==false and headingType==("Geographic Name")`,
      [nr.Prev]: `headingRef<"${Pt}" and isTitleHeadingRef==false and headingType==("Geographic Name")`,
      [nr.Next]: `headingRef>"${Pt}" and isTitleHeadingRef==false and headingType==("Geographic Name")`
    },
    [rr.NameTitle]: {
      [nr.Query]: `(headingRef>="${Pt}" or headingRef<"${Pt}") and isTitleHeadingRef==true and headingType==("Conference Name" or "Corporate Name" or "Personal Name")`,
      [nr.Prev]: `headingRef<"${Pt}" and isTitleHeadingRef==true and headingType==("Conference Name" or "Corporate Name" or "Personal Name")`,
      [nr.Next]: `headingRef>"${Pt}" and isTitleHeadingRef==true and headingType==("Conference Name" or "Corporate Name" or "Personal Name")`
    },
    [rr.UniformTitle]: {
      [nr.Query]: `(headingRef>="${Pt}" or headingRef<"${Pt}") and isTitleHeadingRef==false and headingType==("Uniform Title")`,
      [nr.Prev]: `headingRef<"${Pt}" and isTitleHeadingRef==false and headingType==("Uniform Title")`,
      [nr.Next]: `headingRef>"${Pt}" and isTitleHeadingRef==false and headingType==("Uniform Title")`
    },
    [rr.Subject]: {
      [nr.Query]: `(headingRef>="${Pt}" or headingRef<"${Pt}") and isTitleHeadingRef==false and headingType==("Topical")`,
      [nr.Prev]: `headingRef<"${Pt}" and isTitleHeadingRef==false and headingType==("Topical")`,
      [nr.Next]: `headingRef>"${Pt}" and isTitleHeadingRef==false and headingType==("Topical")`
    },
    [rr.Genre]: {
      [nr.Query]: `(headingRef>="${Pt}" or headingRef<"${Pt}") and isTitleHeadingRef==false and headingType==("Genre")`,
      [nr.Prev]: `headingRef<"${Pt}" and isTitleHeadingRef==false and headingType==("Genre")`,
      [nr.Next]: `headingRef>"${Pt}" and isTitleHeadingRef==false and headingType==("Genre")`
    }
  }
}, OO = {
  [s0.Authorities]: {
    api: {
      endpoints: {
        base: "/search/authorities",
        source: "/authority-source-files",
        facets: "/search/authorities/facets",
        bySearchSegment: {
          [bo.Search]: "/search/authorities",
          [bo.Browse]: "/browse/authorities"
        },
        marcPreview: "/source-storage/records/:recordId/formatted?idType=AUTHORITY",
        validation: tO
      },
      validationTarget: {
        creator: N2.CreatorOfWork
      },
      sourceKey: "authoritySourceFiles",
      searchQuery: {
        limit: 100,
        precedingRecordsCount: 5
      },
      results: {
        containers: {
          [bo.Search]: "authorities",
          [bo.Browse]: "items"
        }
      }
    },
    labels: {
      button: {
        base: "ld.assignAuthority",
        change: "ld.change"
      },
      modal: {
        title: {
          creator: "ld.selectMarcAuthority",
          contributor: "ld.selectMarcAuthority"
        },
        searchResults: "ld.marcAuthority"
      }
    },
    // For displaying "Search" and "Browse" segments
    segments: {
      primary: {
        [bo.Search]: {
          type: bo.Search,
          labelId: "ld.search",
          isVisiblePaginationCount: !0,
          isVisibleSubLabel: !0,
          isLoopedPagination: !1
        },
        [bo.Browse]: {
          type: bo.Browse,
          labelId: "ld.browse",
          isVisiblePaginationCount: !1,
          isVisibleSubLabel: !1,
          isLoopedPagination: !0
        }
      },
      defaultValues: {
        segment: bo.Browse,
        searchBy: rr.PersonalName
      }
    },
    // For displaying "Search by" control and "Filters"
    searchBy: nU.authorities,
    searchableIndicesMap: rU,
    filters: tU.authorities,
    linkedField: "subclass"
  }
};
const BC = ({
  id: t,
  placeholder: r,
  value: i = "",
  disabled: u = !1,
  className: c,
  onChange: v,
  onPressEnter: h,
  type: y = "text",
  ariaLabel: g,
  ariaLabelledBy: S,
  role: x = "textbox",
  ...T
}) => /* @__PURE__ */ N.jsx(
  "input",
  {
    id: t,
    className: In("input", c),
    value: i,
    placeholder: r,
    onChange: v,
    disabled: u,
    onKeyDown: ({ key: _, target: L }) => {
      (_ === "Enter" || _ == "NumpadEnter") && h && (h(), L.blur());
    },
    type: y,
    "aria-label": g,
    "aria-labelledby": S,
    role: x,
    ...T
  }
), aU = async ({
  endpointUrl: t,
  searchFilter: r,
  isSortedResults: i = !0,
  searchBy: u,
  query: c,
  offset: v = "0",
  limit: h = l0.toString()
}) => {
  const y = i ? " sortby title" : "", g = r ? ` and ${r}` : "", S = {
    query: u ? `(${u} all "${c}")${y}${g}` : `${c}${y}${g}`,
    offset: v,
    limit: h
  };
  return await ro.getJson({ url: t, urlParams: S });
}, u_ = (t, r) => {
  if (t)
    return ro.getJson({ url: t, urlParams: r });
}, iU = async (t) => {
  const {
    endpointUrl: r,
    query: i,
    offset: u,
    limit: c = l0.toString(),
    resultsContainer: v,
    precedingRecordsCount: h
  } = t, y = {
    query: i,
    limit: c == null ? void 0 : c.toString()
  };
  u && (y.offset = u == null ? void 0 : u.toString()), h && (y.precedingRecordsCount = h.toString());
  const g = await ro.getJson({ url: r, urlParams: y });
  return {
    content: g.content ?? g[v],
    totalRecords: g.totalRecords,
    totalPages: g.totalPages ?? Math.ceil((g == null ? void 0 : g.totalRecords) / +c),
    prev: g.prev,
    next: g.next
  };
}, c_ = (t, r) => t == null ? void 0 : t.map((i) => {
  var T;
  const u = i.authority ?? i, { id: c = "", authRefType: v = "", headingRef: h = "", headingType: y = "", sourceFileId: g = "" } = u, S = ((T = r == null ? void 0 : r.find(({ id: _ }) => _ === g)) == null ? void 0 : T.name) ?? g, { isAnchor: x } = i;
  return {
    __meta: {
      id: c,
      key: Jc(),
      isAnchor: x
    },
    authorized: {
      label: v
    },
    title: {
      label: h,
      className: "title"
    },
    subclass: {
      label: y,
      className: "heading-type"
    },
    authoritySource: {
      label: S,
      className: "authority-source"
    }
  };
}), f_ = {
  default: c_,
  authorities: c_
}, d_ = ({
  map: t,
  selector: r = nr.Query,
  searchBy: i,
  value: u
}) => {
  var v;
  const c = t == null ? void 0 : t[i];
  return (v = c == null ? void 0 : c[r]) == null ? void 0 : v.replaceAll(Pt, u);
}, p_ = {
  default: d_,
  authorities: d_
}, oU = "50", lU = "id=*", sU = () => {
  const { selectedFacetsGroups: t, setSelectedFacetsGroups: r, resetSelectedFacetsGroups: i, setFacetsData: u, setSourceData: c } = Eo(), { addStatusMessagesItem: v } = Si();
  k.useEffect(() => i(), []);
  const h = (x, T = !0) => !x || T && (t != null && t.includes(x)) ? t : T ? t ? [...t, x] : [x] : t.filter((_) => _ !== x), y = async (x, T) => {
    if (x)
      try {
        const _ = await u_(x, { limit: oU }), L = T ? _[T] : _;
        c(L);
      } catch (_) {
        console.error(_), v == null || v(Ei.createMessage(Tr.error, "ld.errorFetching"));
      }
  }, g = async (x, T, _) => {
    if (!x || !T)
      return;
    const L = S(T, _);
    try {
      const M = L.join(","), B = await u_(x, { facet: M, query: lU });
      u(B.facets);
    } catch (M) {
      console.error(M), v == null || v(Ei.createMessage(Tr.error, "ld.errorFetching"));
    }
  }, S = (x, T) => {
    const _ = h(x, T);
    return r(_), _;
  };
  return { getSearchSourceData: y, getSearchFacetsData: g, onToggleFilterGroupState: S };
}, uU = (t, r) => {
  const { getSearchSourceData: i, getSearchFacetsData: u } = sU(), c = async (h, y) => {
    await u(t.endpoints.facets, h, y);
  };
  return {
    getFacetsData: c,
    getSourceData: async () => {
      await i(t.endpoints.source, t.sourceKey);
      const h = r.find(({ isOpen: y }) => y);
      await c(h == null ? void 0 : h.facet);
    }
  };
}, cU = ({ value: t, children: r }) => {
  const [i, u] = k.useState(t.defaultNavigationSegment), c = k.useMemo(
    () => ({
      ...t,
      navigationSegment: { value: i, set: u }
    }),
    [i, t]
  );
  return /* @__PURE__ */ N.jsx(EO.Provider, { value: c, children: r });
}, h_ = (t, r) => {
  var i;
  return (i = r == null ? void 0 : r.find(({ type: u }) => u === t.toUpperCase())) == null ? void 0 : i.value;
}, LO = (t) => {
  var u, c;
  const r = (u = t == null ? void 0 : t.find(({ type: v }) => v === OT.Main)) == null ? void 0 : u.value, i = (c = t == null ? void 0 : t.find(({ type: v }) => v === OT.Sub)) == null ? void 0 : c.value;
  return [r, i].filter((v) => !!v).join(" ");
}, fU = (t) => t.map(({ id: r, titles: i, identifiers: u, publications: c }) => {
  const v = c == null ? void 0 : c.find(({ name: h, date: y }) => h ?? y);
  return {
    __meta: {
      id: r,
      key: Jc()
    },
    title: {
      label: LO(i),
      className: "title"
    },
    isbn: {
      label: h_(Yg.ISBN, u),
      className: "identifier"
    },
    lccn: {
      label: h_(Yg.LCCN, u),
      className: "identifier"
    },
    publisher: {
      label: v == null ? void 0 : v.name,
      className: "publisher"
    },
    pubDate: {
      label: v == null ? void 0 : v.date,
      className: "publication-date"
    }
  };
}), dU = (t, r) => {
  const i = DO(t);
  return r === bC.containsAll ? ` all "${i}"` : r === bC.startsWith ? ` all "${i}*"` : `=="${i}"`;
}, pU = (t) => `(${t.reduce((i, { operator: u, query: c, qualifier: v, index: h, rowIndex: y }) => {
  if (!((u || y === 0) && c && v && h))
    return i;
  const S = dU(c, v), x = i.length, T = u && x ? ` ${u} ` : "";
  return i += T + h + S, i;
}, "")})`, L2 = (t, r, i = 0) => {
  const u = {
    [Wo.Query]: t,
    [Wo.Offset]: i
  };
  return r && (u[Wo.SearchBy] = r), u;
}, DO = (t) => t == null ? void 0 : t.replaceAll(/['"/\\]/g, "\\$&"), v_ = (t) => t ? t.replace(/\\"/g, '"').replace(/\\\\/g, "\\").replace(/([^\\])\\(?!\\)/g, "$1") : "", dd = () => k.useContext(EO), MO = () => {
  const {
    endpointUrl: t,
    searchFilter: r,
    isSortedResults: i,
    navigationSegment: u,
    endpointUrlsBySegments: c,
    searchResultsLimit: v,
    fetchSearchResults: h,
    searchResultsContainer: y,
    searchableIndicesMap: g,
    buildSearchQuery: S,
    precedingRecordsCount: x
  } = dd(), { setIsLoading: T } = qu(), { setMessage: _, resetMessage: L, data: M, setData: U, resetData: B, setPageMetadata: H } = Eo(), { addStatusMessagesItem: Y } = Si(), G = ({
    selectedSegment: j,
    endpointUrlsBySegments: re,
    endpointUrl: me
  }) => j ? re == null ? void 0 : re[j] : me, Q = ({
    searchBy: j,
    query: re,
    selectedSegment: me,
    searchableIndicesMap: Se,
    baseQuerySelector: Ne
  }) => {
    const Ge = me ? Se == null ? void 0 : Se[me] : Se;
    return (S == null ? void 0 : S({
      map: Ge,
      selector: Ne,
      searchBy: j,
      value: re
    })) ?? re;
  }, W = async ({
    endpointUrl: j,
    searchFilter: re,
    isSortedResults: me,
    searchBy: Se,
    query: Ne,
    offset: Ge,
    limit: ze,
    precedingRecordsCount: qe,
    resultsContainer: at
  }) => h ? await h({
    endpointUrl: j,
    searchFilter: re,
    isSortedResults: me,
    searchBy: Se,
    query: Ne,
    offset: Ge,
    limit: ze,
    precedingRecordsCount: qe,
    resultsContainer: at
  }) : await aU({
    endpointUrl: j,
    searchFilter: re,
    isSortedResults: me,
    searchBy: Se,
    query: Ne,
    offset: Ge,
    limit: ze
  });
  return { fetchData: k.useCallback(
    async ({
      query: j,
      searchBy: re,
      offset: me,
      selectedSegment: Se,
      baseQuerySelector: Ne = nr.Query
    }) => {
      const Ge = Se ?? (u == null ? void 0 : u.value);
      if (M && B(), !!j) {
        T(!0);
        try {
          const ze = G({
            selectedSegment: Ge,
            endpointUrlsBySegments: c,
            endpointUrl: t
          }), qe = Q({
            searchBy: re,
            query: j,
            selectedSegment: Ge,
            searchableIndicesMap: g,
            baseQuerySelector: Ne
          }), at = Ge === bo.Browse, st = await W({
            endpointUrl: ze ?? "",
            searchFilter: r,
            isSortedResults: i,
            searchBy: re,
            query: qe,
            offset: me == null ? void 0 : me.toString(),
            limit: v == null ? void 0 : v.toString(),
            precedingRecordsCount: at ? x : void 0,
            resultsContainer: y == null ? void 0 : y[Ge]
          }), { content: We, totalPages: he, totalRecords: ke, prev: _e, next: q } = st;
          if (!We.length)
            return _("ld.searchNoRdsMatch");
          U(We), H({ totalPages: he, totalElements: ke, prev: _e, next: q }), L();
        } catch {
          Y == null || Y(Ei.createMessage(Tr.error, "ld.errorFetching"));
        } finally {
          T(!1);
        }
      }
    },
    [M, t, h, u == null ? void 0 : u.value, r, i]
  ) };
};
const Qy = ({
  id: t,
  value: r,
  onChange: i,
  options: u,
  withIntl: c = !1,
  className: v,
  ariaLabel: h,
  ariaLabelledBy: y,
  ...g
}) => {
  const S = typeof r == "string" ? r : r == null ? void 0 : r.value;
  return /* @__PURE__ */ N.jsx(
    "select",
    {
      id: t,
      className: In("select-input", v, { placeholder: S === "" }),
      value: S,
      onChange: ({ target: { value: x } }) => {
        const T = u.find((_) => typeof _ == "string" ? _ === x : _.value === x);
        T && i(typeof T == "string" ? { value: T } : T);
      },
      role: "combobox",
      "aria-expanded": "false",
      "aria-label": h,
      "aria-labelledby": y,
      ...g,
      children: u.map((x) => {
        const [T, _, L] = typeof x == "string" ? [x, x] : [x.value, x.label, x.isDisabled];
        return /* @__PURE__ */ N.jsx("option", { value: T, "data-testid": T, disabled: L || !1, children: c ? /* @__PURE__ */ N.jsx(mt, { id: `ld.${_}` }) : _ }, T);
      })
    }
  );
};
const hU = k.memo(({ clearValues: t }) => {
  const [, r] = qc(), { formatMessage: i } = La(), { isAdvancedSearchOpen: u, setIsAdvancedSearchOpen: c } = Qa(), { setForceRefresh: v } = Eo(), { fetchData: h } = MO(), [y, g] = k.useState($N), S = () => {
    g($N), c(!1);
  }, x = !y.filter(
    ({ rowIndex: L, operator: M, index: U, qualifier: B, query: H }) => (L !== 0 ? M : !0) && U && B && H
  ).length, T = (L, M, U) => {
    g(
      y.map(
        (B) => B.rowIndex === U ? { ...B, [M]: L } : B
      )
    );
  }, _ = async () => {
    t();
    const L = pU(y);
    r(L2(L)), v(!0), await h({
      query: L,
      searchBy: void 0
    }), S();
  };
  return /* @__PURE__ */ N.jsx(
    qg,
    {
      isOpen: u,
      title: i({ id: "ld.advancedSearch" }),
      submitButtonLabel: i({ id: "ld.search" }),
      cancelButtonLabel: i({ id: "ld.cancel" }),
      onClose: S,
      onSubmit: _,
      onCancel: S,
      shouldCloseOnEsc: !0,
      submitButtonDisabled: x,
      ariaModalKind: g2.AdvancedSearch,
      children: /* @__PURE__ */ N.jsx("div", { className: "advanced-search-container", children: y.map(({ query: L, rowIndex: M, operator: U, qualifier: B, index: H }) => /* @__PURE__ */ N.jsxs("div", { className: "search-row", children: [
        M === 0 ? /* @__PURE__ */ N.jsx("div", { className: "cell-bold", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.searchFor" }) }) : /* @__PURE__ */ N.jsx(
          Qy,
          {
            withIntl: !0,
            value: U,
            options: SB,
            className: "cell-operator",
            onChange: ({ value: Y }) => T(Y, "operator", M),
            ariaLabel: i({ id: "ld.aria.advancedSearch.operator" }),
            "data-testid": `select-operators-${M}`
          }
        ),
        /* @__PURE__ */ N.jsx(
          BC,
          {
            className: "text-input cell-query",
            "data-testid": `text-input-${M}`,
            value: L ?? "",
            onChange: ({ target: { value: Y } }) => T(Y, "query", M),
            ariaLabel: i({ id: "ld.aria.advancedSearch.queryInput" })
          }
        ),
        /* @__PURE__ */ N.jsx(
          Qy,
          {
            withIntl: !0,
            value: B,
            options: xB,
            className: "cell-qualifier",
            onChange: ({ value: Y }) => T(Y, "qualifier", M),
            ariaLabel: i({ id: "ld.aria.advancedSearch.qualifier" }),
            "data-testid": `select-qualifiers-${M}`
          }
        ),
        "in",
        /* @__PURE__ */ N.jsx(
          Qy,
          {
            withIntl: !0,
            value: H,
            options: EB,
            className: "cell-identifier",
            onChange: ({ value: Y }) => T(Y, "index", M),
            ariaLabel: i({ id: "ld.aria.advancedSearch.identifier" }),
            "data-testid": `select-identifiers-${M}`
          }
        )
      ] }, M)) })
    }
  );
}), vU = () => {
  const { facets: t, setFacets: r } = Eo();
  return {
    facets: t,
    onChangeLimiters: ({ target: { id: v, name: h } }) => {
      r((y) => ({
        ...y,
        [h]: v
      }));
    },
    onChangeLimitersMulti: ({ target: { id: v, name: h } }) => {
      r((y) => {
        const g = y[h] || [];
        return {
          ...y,
          [h]: g != null && g.includes(v) ? g == null ? void 0 : g.filter((S) => S !== v) : [...g, v]
        };
      });
    },
    onChange: (v) => {
    }
  };
};
function vn() {
  return vn = Object.assign ? Object.assign.bind() : function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var i = arguments[r];
      for (var u in i)
        ({}).hasOwnProperty.call(i, u) && (t[u] = i[u]);
    }
    return t;
  }, vn.apply(null, arguments);
}
function bm(t) {
  "@babel/helpers - typeof";
  return bm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, bm(t);
}
function mU(t, r) {
  if (bm(t) != "object" || !t)
    return t;
  var i = t[Symbol.toPrimitive];
  if (i !== void 0) {
    var u = i.call(t, r || "default");
    if (bm(u) != "object")
      return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(t);
}
function PO(t) {
  var r = mU(t, "string");
  return bm(r) == "symbol" ? r : r + "";
}
function $y(t, r, i) {
  return (r = PO(r)) in t ? Object.defineProperty(t, r, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[r] = i, t;
}
function m_(t, r) {
  var i = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    r && (u = u.filter(function(c) {
      return Object.getOwnPropertyDescriptor(t, c).enumerable;
    })), i.push.apply(i, u);
  }
  return i;
}
function an(t) {
  for (var r = 1; r < arguments.length; r++) {
    var i = arguments[r] != null ? arguments[r] : {};
    r % 2 ? m_(Object(i), !0).forEach(function(u) {
      $y(t, u, i[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : m_(Object(i)).forEach(function(u) {
      Object.defineProperty(t, u, Object.getOwnPropertyDescriptor(i, u));
    });
  }
  return t;
}
function gU(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function g_(t, r) {
  for (var i = 0; i < r.length; i++) {
    var u = r[i];
    u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(t, PO(u.key), u);
  }
}
function bU(t, r, i) {
  return r && g_(t.prototype, r), i && g_(t, i), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function jT(t, r) {
  return jT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, u) {
    return i.__proto__ = u, i;
  }, jT(t, r);
}
function yU(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), r && jT(t, r);
}
function SC(t) {
  return SC = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, SC(t);
}
function kO() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (kO = function() {
    return !!t;
  })();
}
function CU(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function EU(t, r) {
  if (r && (bm(r) == "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return CU(t);
}
function SU(t) {
  var r = kO();
  return function() {
    var i, u = SC(t);
    if (r) {
      var c = SC(this).constructor;
      i = Reflect.construct(u, arguments, c);
    } else
      i = u.apply(this, arguments);
    return EU(this, i);
  };
}
function GT(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var i = 0, u = Array(r); i < r; i++)
    u[i] = t[i];
  return u;
}
function xU(t) {
  if (Array.isArray(t))
    return GT(t);
}
function RU(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function FO(t, r) {
  if (t) {
    if (typeof t == "string")
      return GT(t, r);
    var i = {}.toString.call(t).slice(8, -1);
    return i === "Object" && t.constructor && (i = t.constructor.name), i === "Map" || i === "Set" ? Array.from(t) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? GT(t, r) : void 0;
  }
}
function TU() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jg(t) {
  return xU(t) || RU(t) || FO(t) || TU();
}
var wU = !1;
function IU(t) {
  if (t.sheet)
    return t.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === t)
      return document.styleSheets[r];
}
function AU(t) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", t.key), t.nonce !== void 0 && r.setAttribute("nonce", t.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var NU = /* @__PURE__ */ function() {
  function t(i) {
    var u = this;
    this._insertTag = function(c) {
      var v;
      u.tags.length === 0 ? u.insertionPoint ? v = u.insertionPoint.nextSibling : u.prepend ? v = u.container.firstChild : v = u.before : v = u.tags[u.tags.length - 1].nextSibling, u.container.insertBefore(c, v), u.tags.push(c);
    }, this.isSpeedy = i.speedy === void 0 ? !wU : i.speedy, this.tags = [], this.ctr = 0, this.nonce = i.nonce, this.key = i.key, this.container = i.container, this.prepend = i.prepend, this.insertionPoint = i.insertionPoint, this.before = null;
  }
  var r = t.prototype;
  return r.hydrate = function(u) {
    u.forEach(this._insertTag);
  }, r.insert = function(u) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(AU(this));
    var c = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var v = IU(c);
      try {
        v.insertRule(u, v.cssRules.length);
      } catch {
      }
    } else
      c.appendChild(document.createTextNode(u));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(u) {
      var c;
      return (c = u.parentNode) == null ? void 0 : c.removeChild(u);
    }), this.tags = [], this.ctr = 0;
  }, t;
}(), Sl = "-ms-", xC = "-moz-", Fr = "-webkit-", BO = "comm", D2 = "rule", M2 = "decl", _U = "@import", UO = "@keyframes", OU = "@layer", LU = Math.abs, UC = String.fromCharCode, DU = Object.assign;
function MU(t, r) {
  return zo(t, 0) ^ 45 ? (((r << 2 ^ zo(t, 0)) << 2 ^ zo(t, 1)) << 2 ^ zo(t, 2)) << 2 ^ zo(t, 3) : 0;
}
function VO(t) {
  return t.trim();
}
function PU(t, r) {
  return (t = r.exec(t)) ? t[0] : t;
}
function Br(t, r, i) {
  return t.replace(r, i);
}
function zT(t, r) {
  return t.indexOf(r);
}
function zo(t, r) {
  return t.charCodeAt(r) | 0;
}
function e0(t, r, i) {
  return t.slice(r, i);
}
function rd(t) {
  return t.length;
}
function P2(t) {
  return t.length;
}
function eC(t, r) {
  return r.push(t), t;
}
function kU(t, r) {
  return t.map(r).join("");
}
var VC = 1, Zg = 1, HO = 0, Es = 0, Li = 0, eb = "";
function HC(t, r, i, u, c, v, h) {
  return { value: t, root: r, parent: i, type: u, props: c, children: v, line: VC, column: Zg, length: h, return: "" };
}
function Vy(t, r) {
  return DU(HC("", null, null, "", null, null, 0), t, { length: -t.length }, r);
}
function FU() {
  return Li;
}
function BU() {
  return Li = Es > 0 ? zo(eb, --Es) : 0, Zg--, Li === 10 && (Zg = 1, VC--), Li;
}
function Qs() {
  return Li = Es < HO ? zo(eb, Es++) : 0, Zg++, Li === 10 && (Zg = 1, VC++), Li;
}
function ld() {
  return zo(eb, Es);
}
function cC() {
  return Es;
}
function u0(t, r) {
  return e0(eb, t, r);
}
function t0(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function jO(t) {
  return VC = Zg = 1, HO = rd(eb = t), Es = 0, [];
}
function GO(t) {
  return eb = "", t;
}
function fC(t) {
  return VO(u0(Es - 1, WT(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function UU(t) {
  for (; (Li = ld()) && Li < 33; )
    Qs();
  return t0(t) > 2 || t0(Li) > 3 ? "" : " ";
}
function VU(t, r) {
  for (; --r && Qs() && !(Li < 48 || Li > 102 || Li > 57 && Li < 65 || Li > 70 && Li < 97); )
    ;
  return u0(t, cC() + (r < 6 && ld() == 32 && Qs() == 32));
}
function WT(t) {
  for (; Qs(); )
    switch (Li) {
      case t:
        return Es;
      case 34:
      case 39:
        t !== 34 && t !== 39 && WT(Li);
        break;
      case 40:
        t === 41 && WT(t);
        break;
      case 92:
        Qs();
        break;
    }
  return Es;
}
function HU(t, r) {
  for (; Qs() && t + Li !== 47 + 10; )
    if (t + Li === 42 + 42 && ld() === 47)
      break;
  return "/*" + u0(r, Es - 1) + "*" + UC(t === 47 ? t : Qs());
}
function jU(t) {
  for (; !t0(ld()); )
    Qs();
  return u0(t, Es);
}
function GU(t) {
  return GO(dC("", null, null, null, [""], t = jO(t), 0, [0], t));
}
function dC(t, r, i, u, c, v, h, y, g) {
  for (var S = 0, x = 0, T = h, _ = 0, L = 0, M = 0, U = 1, B = 1, H = 1, Y = 0, G = "", Q = c, W = v, oe = u, j = G; B; )
    switch (M = Y, Y = Qs()) {
      case 40:
        if (M != 108 && zo(j, T - 1) == 58) {
          zT(j += Br(fC(Y), "&", "&\f"), "&\f") != -1 && (H = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        j += fC(Y);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        j += UU(M);
        break;
      case 92:
        j += VU(cC() - 1, 7);
        continue;
      case 47:
        switch (ld()) {
          case 42:
          case 47:
            eC(zU(HU(Qs(), cC()), r, i), g);
            break;
          default:
            j += "/";
        }
        break;
      case 123 * U:
        y[S++] = rd(j) * H;
      case 125 * U:
      case 59:
      case 0:
        switch (Y) {
          case 0:
          case 125:
            B = 0;
          case 59 + x:
            H == -1 && (j = Br(j, /\f/g, "")), L > 0 && rd(j) - T && eC(L > 32 ? y_(j + ";", u, i, T - 1) : y_(Br(j, " ", "") + ";", u, i, T - 2), g);
            break;
          case 59:
            j += ";";
          default:
            if (eC(oe = b_(j, r, i, S, x, c, y, G, Q = [], W = [], T), v), Y === 123)
              if (x === 0)
                dC(j, r, oe, oe, Q, v, T, y, W);
              else
                switch (_ === 99 && zo(j, 3) === 110 ? 100 : _) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    dC(t, oe, oe, u && eC(b_(t, oe, oe, 0, 0, c, y, G, c, Q = [], T), W), c, W, T, y, u ? Q : W);
                    break;
                  default:
                    dC(j, oe, oe, oe, [""], W, 0, y, W);
                }
        }
        S = x = L = 0, U = H = 1, G = j = "", T = h;
        break;
      case 58:
        T = 1 + rd(j), L = M;
      default:
        if (U < 1) {
          if (Y == 123)
            --U;
          else if (Y == 125 && U++ == 0 && BU() == 125)
            continue;
        }
        switch (j += UC(Y), Y * U) {
          case 38:
            H = x > 0 ? 1 : (j += "\f", -1);
            break;
          case 44:
            y[S++] = (rd(j) - 1) * H, H = 1;
            break;
          case 64:
            ld() === 45 && (j += fC(Qs())), _ = ld(), x = T = rd(G = j += jU(cC())), Y++;
            break;
          case 45:
            M === 45 && rd(j) == 2 && (U = 0);
        }
    }
  return v;
}
function b_(t, r, i, u, c, v, h, y, g, S, x) {
  for (var T = c - 1, _ = c === 0 ? v : [""], L = P2(_), M = 0, U = 0, B = 0; M < u; ++M)
    for (var H = 0, Y = e0(t, T + 1, T = LU(U = h[M])), G = t; H < L; ++H)
      (G = VO(U > 0 ? _[H] + " " + Y : Br(Y, /&\f/g, _[H]))) && (g[B++] = G);
  return HC(t, r, i, c === 0 ? D2 : y, g, S, x);
}
function zU(t, r, i) {
  return HC(t, r, i, BO, UC(FU()), e0(t, 2, -2), 0);
}
function y_(t, r, i, u) {
  return HC(t, r, i, M2, e0(t, 0, u), e0(t, u + 1, -1), u);
}
function Gg(t, r) {
  for (var i = "", u = P2(t), c = 0; c < u; c++)
    i += r(t[c], c, t, r) || "";
  return i;
}
function WU(t, r, i, u) {
  switch (t.type) {
    case OU:
      if (t.children.length)
        break;
    case _U:
    case M2:
      return t.return = t.return || t.value;
    case BO:
      return "";
    case UO:
      return t.return = t.value + "{" + Gg(t.children, u) + "}";
    case D2:
      t.value = t.props.join(",");
  }
  return rd(i = Gg(t.children, u)) ? t.return = t.value + "{" + i + "}" : "";
}
function XU(t) {
  var r = P2(t);
  return function(i, u, c, v) {
    for (var h = "", y = 0; y < r; y++)
      h += t[y](i, u, c, v) || "";
    return h;
  };
}
function YU(t) {
  return function(r) {
    r.root || (r = r.return) && t(r);
  };
}
function $U(t) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(i) {
    return r[i] === void 0 && (r[i] = t(i)), r[i];
  };
}
var ZU = function(r, i, u) {
  for (var c = 0, v = 0; c = v, v = ld(), c === 38 && v === 12 && (i[u] = 1), !t0(v); )
    Qs();
  return u0(r, Es);
}, JU = function(r, i) {
  var u = -1, c = 44;
  do
    switch (t0(c)) {
      case 0:
        c === 38 && ld() === 12 && (i[u] = 1), r[u] += ZU(Es - 1, i, u);
        break;
      case 2:
        r[u] += fC(c);
        break;
      case 4:
        if (c === 44) {
          r[++u] = ld() === 58 ? "&\f" : "", i[u] = r[u].length;
          break;
        }
      default:
        r[u] += UC(c);
    }
  while (c = Qs());
  return r;
}, QU = function(r, i) {
  return GO(JU(jO(r), i));
}, C_ = /* @__PURE__ */ new WeakMap(), KU = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var i = r.value, u = r.parent, c = r.column === u.column && r.line === u.line; u.type !== "rule"; )
      if (u = u.parent, !u)
        return;
    if (!(r.props.length === 1 && i.charCodeAt(0) !== 58 && !C_.get(u)) && !c) {
      C_.set(r, !0);
      for (var v = [], h = QU(i, v), y = u.props, g = 0, S = 0; g < h.length; g++)
        for (var x = 0; x < y.length; x++, S++)
          r.props[S] = v[g] ? h[g].replace(/&\f/g, y[x]) : y[x] + " " + h[g];
    }
  }
}, qU = function(r) {
  if (r.type === "decl") {
    var i = r.value;
    // charcode for l
    i.charCodeAt(0) === 108 && // charcode for b
    i.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
};
function zO(t, r) {
  switch (MU(t, r)) {
    case 5103:
      return Fr + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Fr + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Fr + t + xC + t + Sl + t + t;
    case 6828:
    case 4268:
      return Fr + t + Sl + t + t;
    case 6165:
      return Fr + t + Sl + "flex-" + t + t;
    case 5187:
      return Fr + t + Br(t, /(\w+).+(:[^]+)/, Fr + "box-$1$2" + Sl + "flex-$1$2") + t;
    case 5443:
      return Fr + t + Sl + "flex-item-" + Br(t, /flex-|-self/, "") + t;
    case 4675:
      return Fr + t + Sl + "flex-line-pack" + Br(t, /align-content|flex-|-self/, "") + t;
    case 5548:
      return Fr + t + Sl + Br(t, "shrink", "negative") + t;
    case 5292:
      return Fr + t + Sl + Br(t, "basis", "preferred-size") + t;
    case 6060:
      return Fr + "box-" + Br(t, "-grow", "") + Fr + t + Sl + Br(t, "grow", "positive") + t;
    case 4554:
      return Fr + Br(t, /([^-])(transform)/g, "$1" + Fr + "$2") + t;
    case 6187:
      return Br(Br(Br(t, /(zoom-|grab)/, Fr + "$1"), /(image-set)/, Fr + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return Br(t, /(image-set\([^]*)/, Fr + "$1$`$1");
    case 4968:
      return Br(Br(t, /(.+:)(flex-)?(.*)/, Fr + "box-pack:$3" + Sl + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Fr + t + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Br(t, /(.+)-inline(.+)/, Fr + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (rd(t) - 1 - r > 6)
        switch (zo(t, r + 1)) {
          case 109:
            if (zo(t, r + 4) !== 45)
              break;
          case 102:
            return Br(t, /(.+:)(.+)-([^]+)/, "$1" + Fr + "$2-$3$1" + xC + (zo(t, r + 3) == 108 ? "$3" : "$2-$3")) + t;
          case 115:
            return ~zT(t, "stretch") ? zO(Br(t, "stretch", "fill-available"), r) + t : t;
        }
      break;
    case 4949:
      if (zo(t, r + 1) !== 115)
        break;
    case 6444:
      switch (zo(t, rd(t) - 3 - (~zT(t, "!important") && 10))) {
        case 107:
          return Br(t, ":", ":" + Fr) + t;
        case 101:
          return Br(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Fr + (zo(t, 14) === 45 ? "inline-" : "") + "box$3$1" + Fr + "$2$3$1" + Sl + "$2box$3") + t;
      }
      break;
    case 5936:
      switch (zo(t, r + 11)) {
        case 114:
          return Fr + t + Sl + Br(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return Fr + t + Sl + Br(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return Fr + t + Sl + Br(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return Fr + t + Sl + t + t;
  }
  return t;
}
var e7 = function(r, i, u, c) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case M2:
        r.return = zO(r.value, r.length);
        break;
      case UO:
        return Gg([Vy(r, {
          value: Br(r.value, "@", "@" + Fr)
        })], c);
      case D2:
        if (r.length)
          return kU(r.props, function(v) {
            switch (PU(v, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Gg([Vy(r, {
                  props: [Br(v, /:(read-\w+)/, ":" + xC + "$1")]
                })], c);
              case "::placeholder":
                return Gg([Vy(r, {
                  props: [Br(v, /:(plac\w+)/, ":" + Fr + "input-$1")]
                }), Vy(r, {
                  props: [Br(v, /:(plac\w+)/, ":" + xC + "$1")]
                }), Vy(r, {
                  props: [Br(v, /:(plac\w+)/, Sl + "input-$1")]
                })], c);
            }
            return "";
          });
    }
}, t7 = [e7], n7 = function(r) {
  var i = r.key;
  if (i === "css") {
    var u = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(u, function(U) {
      var B = U.getAttribute("data-emotion");
      B.indexOf(" ") !== -1 && (document.head.appendChild(U), U.setAttribute("data-s", ""));
    });
  }
  var c = r.stylisPlugins || t7, v = {}, h, y = [];
  h = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + i + ' "]'),
    function(U) {
      for (var B = U.getAttribute("data-emotion").split(" "), H = 1; H < B.length; H++)
        v[B[H]] = !0;
      y.push(U);
    }
  );
  var g, S = [KU, qU];
  {
    var x, T = [WU, YU(function(U) {
      x.insert(U);
    })], _ = XU(S.concat(c, T)), L = function(B) {
      return Gg(GU(B), _);
    };
    g = function(B, H, Y, G) {
      x = Y, L(B ? B + "{" + H.styles + "}" : H.styles), G && (M.inserted[H.name] = !0);
    };
  }
  var M = {
    key: i,
    sheet: new NU({
      key: i,
      container: h,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: v,
    registered: {},
    insert: g
  };
  return M.sheet.hydrate(y), M;
}, r7 = !0;
function a7(t, r, i) {
  var u = "";
  return i.split(" ").forEach(function(c) {
    t[c] !== void 0 ? r.push(t[c] + ";") : c && (u += c + " ");
  }), u;
}
var WO = function(r, i, u) {
  var c = r.key + "-" + i.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (u === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  r7 === !1) && r.registered[c] === void 0 && (r.registered[c] = i.styles);
}, i7 = function(r, i, u) {
  WO(r, i, u);
  var c = r.key + "-" + i.name;
  if (r.inserted[i.name] === void 0) {
    var v = i;
    do
      r.insert(i === v ? "." + c : "", v, r.sheet, !0), v = v.next;
    while (v !== void 0);
  }
};
function o7(t) {
  for (var r = 0, i, u = 0, c = t.length; c >= 4; ++u, c -= 4)
    i = t.charCodeAt(u) & 255 | (t.charCodeAt(++u) & 255) << 8 | (t.charCodeAt(++u) & 255) << 16 | (t.charCodeAt(++u) & 255) << 24, i = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16), i ^= /* k >>> r: */
    i >>> 24, r = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (c) {
    case 3:
      r ^= (t.charCodeAt(u + 2) & 255) << 16;
    case 2:
      r ^= (t.charCodeAt(u + 1) & 255) << 8;
    case 1:
      r ^= t.charCodeAt(u) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var l7 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, s7 = !1, u7 = /[A-Z]|^ms/g, c7 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, XO = function(r) {
  return r.charCodeAt(1) === 45;
}, E_ = function(r) {
  return r != null && typeof r != "boolean";
}, ZR = /* @__PURE__ */ $U(function(t) {
  return XO(t) ? t : t.replace(u7, "-$&").toLowerCase();
}), S_ = function(r, i) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof i == "string")
        return i.replace(c7, function(u, c, v) {
          return ad = {
            name: c,
            styles: v,
            next: ad
          }, c;
        });
  }
  return l7[r] !== 1 && !XO(r) && typeof i == "number" && i !== 0 ? i + "px" : i;
}, f7 = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function n0(t, r, i) {
  if (i == null)
    return "";
  var u = i;
  if (u.__emotion_styles !== void 0)
    return u;
  switch (typeof i) {
    case "boolean":
      return "";
    case "object": {
      var c = i;
      if (c.anim === 1)
        return ad = {
          name: c.name,
          styles: c.styles,
          next: ad
        }, c.name;
      var v = i;
      if (v.styles !== void 0) {
        var h = v.next;
        if (h !== void 0)
          for (; h !== void 0; )
            ad = {
              name: h.name,
              styles: h.styles,
              next: ad
            }, h = h.next;
        var y = v.styles + ";";
        return y;
      }
      return d7(t, r, i);
    }
    case "function": {
      if (t !== void 0) {
        var g = ad, S = i(t);
        return ad = g, n0(t, r, S);
      }
      break;
    }
  }
  var x = i;
  if (r == null)
    return x;
  var T = r[x];
  return T !== void 0 ? T : x;
}
function d7(t, r, i) {
  var u = "";
  if (Array.isArray(i))
    for (var c = 0; c < i.length; c++)
      u += n0(t, r, i[c]) + ";";
  else
    for (var v in i) {
      var h = i[v];
      if (typeof h != "object") {
        var y = h;
        r != null && r[y] !== void 0 ? u += v + "{" + r[y] + "}" : E_(y) && (u += ZR(v) + ":" + S_(v, y) + ";");
      } else {
        if (v === "NO_COMPONENT_SELECTOR" && s7)
          throw new Error(f7);
        if (Array.isArray(h) && typeof h[0] == "string" && (r == null || r[h[0]] === void 0))
          for (var g = 0; g < h.length; g++)
            E_(h[g]) && (u += ZR(v) + ":" + S_(v, h[g]) + ";");
        else {
          var S = n0(t, r, h);
          switch (v) {
            case "animation":
            case "animationName": {
              u += ZR(v) + ":" + S + ";";
              break;
            }
            default:
              u += v + "{" + S + "}";
          }
        }
      }
    }
  return u;
}
var x_ = /label:\s*([^\s;{]+)\s*(;|$)/g, ad;
function YO(t, r, i) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var u = !0, c = "";
  ad = void 0;
  var v = t[0];
  if (v == null || v.raw === void 0)
    u = !1, c += n0(i, r, v);
  else {
    var h = v;
    c += h[0];
  }
  for (var y = 1; y < t.length; y++)
    if (c += n0(i, r, t[y]), u) {
      var g = v;
      c += g[y];
    }
  x_.lastIndex = 0;
  for (var S = "", x; (x = x_.exec(c)) !== null; )
    S += "-" + x[1];
  var T = o7(c) + S;
  return {
    name: T,
    styles: c,
    next: ad
  };
}
var p7 = function(r) {
  return r();
}, h7 = uT["useInsertionEffect"] ? uT["useInsertionEffect"] : !1, v7 = h7 || p7, m7 = !1, $O = /* @__PURE__ */ k.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ n7({
    key: "css"
  }) : null
);
$O.Provider;
var g7 = function(r) {
  return /* @__PURE__ */ k.forwardRef(function(i, u) {
    var c = k.useContext($O);
    return r(i, c, u);
  });
}, b7 = /* @__PURE__ */ k.createContext({}), k2 = {}.hasOwnProperty, XT = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", y7 = function(r, i) {
  var u = {};
  for (var c in i)
    k2.call(i, c) && (u[c] = i[c]);
  return u[XT] = r, u;
}, C7 = function(r) {
  var i = r.cache, u = r.serialized, c = r.isStringTag;
  return WO(i, u, c), v7(function() {
    return i7(i, u, c);
  }), null;
}, E7 = /* @__PURE__ */ g7(function(t, r, i) {
  var u = t.css;
  typeof u == "string" && r.registered[u] !== void 0 && (u = r.registered[u]);
  var c = t[XT], v = [u], h = "";
  typeof t.className == "string" ? h = a7(r.registered, v, t.className) : t.className != null && (h = t.className + " ");
  var y = YO(v, void 0, k.useContext(b7));
  h += r.key + "-" + y.name;
  var g = {};
  for (var S in t)
    k2.call(t, S) && S !== "css" && S !== XT && !m7 && (g[S] = t[S]);
  return g.className = h, i && (g.ref = i), /* @__PURE__ */ k.createElement(k.Fragment, null, /* @__PURE__ */ k.createElement(C7, {
    cache: r,
    serialized: y,
    isStringTag: typeof c == "string"
  }), /* @__PURE__ */ k.createElement(c, g));
}), S7 = E7, tn = function(r, i) {
  var u = arguments;
  if (i == null || !k2.call(i, "css"))
    return k.createElement.apply(void 0, u);
  var c = u.length, v = new Array(c);
  v[0] = S7, v[1] = y7(r, i);
  for (var h = 2; h < c; h++)
    v[h] = u[h];
  return k.createElement.apply(null, v);
};
(function(t) {
  var r;
  r || (r = t.JSX || (t.JSX = {}));
})(tn || (tn = {}));
function F2() {
  for (var t = arguments.length, r = new Array(t), i = 0; i < t; i++)
    r[i] = arguments[i];
  return YO(r);
}
function x7() {
  var t = F2.apply(void 0, arguments), r = "animation-" + t.name;
  return {
    name: r,
    styles: "@keyframes " + r + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
function R7(t) {
  if (Array.isArray(t))
    return t;
}
function T7(t, r) {
  var i = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (i != null) {
    var u, c, v, h, y = [], g = !0, S = !1;
    try {
      if (v = (i = i.call(t)).next, r === 0) {
        if (Object(i) !== i)
          return;
        g = !1;
      } else
        for (; !(g = (u = v.call(i)).done) && (y.push(u.value), y.length !== r); g = !0)
          ;
    } catch (x) {
      S = !0, c = x;
    } finally {
      try {
        if (!g && i.return != null && (h = i.return(), Object(h) !== h))
          return;
      } finally {
        if (S)
          throw c;
      }
    }
    return y;
  }
}
function w7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sp(t, r) {
  return R7(t) || T7(t, r) || FO(t, r) || w7();
}
function I7(t, r) {
  if (t == null)
    return {};
  var i = {};
  for (var u in t)
    if ({}.hasOwnProperty.call(t, u)) {
      if (r.indexOf(u) !== -1)
        continue;
      i[u] = t[u];
    }
  return i;
}
function pd(t, r) {
  if (t == null)
    return {};
  var i, u, c = I7(t, r);
  if (Object.getOwnPropertySymbols) {
    var v = Object.getOwnPropertySymbols(t);
    for (u = 0; u < v.length; u++)
      i = v[u], r.indexOf(i) === -1 && {}.propertyIsEnumerable.call(t, i) && (c[i] = t[i]);
  }
  return c;
}
function A7(t, r) {
  return r || (r = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}
const N7 = Math.min, _7 = Math.max, RC = Math.round, tC = Math.floor, TC = (t) => ({
  x: t,
  y: t
});
function O7(t) {
  const {
    x: r,
    y: i,
    width: u,
    height: c
  } = t;
  return {
    width: u,
    height: c,
    top: i,
    left: r,
    right: r + u,
    bottom: i + c,
    x: r,
    y: i
  };
}
function jC() {
  return typeof window < "u";
}
function ZO(t) {
  return QO(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Kc(t) {
  var r;
  return (t == null || (r = t.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function JO(t) {
  var r;
  return (r = (QO(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : r.documentElement;
}
function QO(t) {
  return jC() ? t instanceof Node || t instanceof Kc(t).Node : !1;
}
function YT(t) {
  return jC() ? t instanceof Element || t instanceof Kc(t).Element : !1;
}
function B2(t) {
  return jC() ? t instanceof HTMLElement || t instanceof Kc(t).HTMLElement : !1;
}
function R_(t) {
  return !jC() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Kc(t).ShadowRoot;
}
function KO(t) {
  const {
    overflow: r,
    overflowX: i,
    overflowY: u,
    display: c
  } = U2(t);
  return /auto|scroll|overlay|hidden|clip/.test(r + u + i) && !["inline", "contents"].includes(c);
}
function L7() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function D7(t) {
  return ["html", "body", "#document"].includes(ZO(t));
}
function U2(t) {
  return Kc(t).getComputedStyle(t);
}
function M7(t) {
  if (ZO(t) === "html")
    return t;
  const r = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    R_(t) && t.host || // Fallback.
    JO(t)
  );
  return R_(r) ? r.host : r;
}
function qO(t) {
  const r = M7(t);
  return D7(r) ? t.ownerDocument ? t.ownerDocument.body : t.body : B2(r) && KO(r) ? r : qO(r);
}
function wC(t, r, i) {
  var u;
  r === void 0 && (r = []), i === void 0 && (i = !0);
  const c = qO(t), v = c === ((u = t.ownerDocument) == null ? void 0 : u.body), h = Kc(c);
  if (v) {
    const y = $T(h);
    return r.concat(h, h.visualViewport || [], KO(c) ? c : [], y && i ? wC(y) : []);
  }
  return r.concat(c, wC(c, [], i));
}
function $T(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function P7(t) {
  const r = U2(t);
  let i = parseFloat(r.width) || 0, u = parseFloat(r.height) || 0;
  const c = B2(t), v = c ? t.offsetWidth : i, h = c ? t.offsetHeight : u, y = RC(i) !== v || RC(u) !== h;
  return y && (i = v, u = h), {
    width: i,
    height: u,
    $: y
  };
}
function V2(t) {
  return YT(t) ? t : t.contextElement;
}
function JR(t) {
  const r = V2(t);
  if (!B2(r))
    return TC(1);
  const i = r.getBoundingClientRect(), {
    width: u,
    height: c,
    $: v
  } = P7(r);
  let h = (v ? RC(i.width) : i.width) / u, y = (v ? RC(i.height) : i.height) / c;
  return (!h || !Number.isFinite(h)) && (h = 1), (!y || !Number.isFinite(y)) && (y = 1), {
    x: h,
    y
  };
}
const k7 = /* @__PURE__ */ TC(0);
function F7(t) {
  const r = Kc(t);
  return !L7() || !r.visualViewport ? k7 : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function B7(t, r, i) {
  return r === void 0 && (r = !1), !i || r && i !== Kc(t) ? !1 : r;
}
function T_(t, r, i, u) {
  r === void 0 && (r = !1), i === void 0 && (i = !1);
  const c = t.getBoundingClientRect(), v = V2(t);
  let h = TC(1);
  r && (u ? YT(u) && (h = JR(u)) : h = JR(t));
  const y = B7(v, i, u) ? F7(v) : TC(0);
  let g = (c.left + y.x) / h.x, S = (c.top + y.y) / h.y, x = c.width / h.x, T = c.height / h.y;
  if (v) {
    const _ = Kc(v), L = u && YT(u) ? Kc(u) : u;
    let M = _, U = $T(M);
    for (; U && u && L !== M; ) {
      const B = JR(U), H = U.getBoundingClientRect(), Y = U2(U), G = H.left + (U.clientLeft + parseFloat(Y.paddingLeft)) * B.x, Q = H.top + (U.clientTop + parseFloat(Y.paddingTop)) * B.y;
      g *= B.x, S *= B.y, x *= B.x, T *= B.y, g += G, S += Q, M = Kc(U), U = $T(M);
    }
  }
  return O7({
    width: x,
    height: T,
    x: g,
    y: S
  });
}
function e4(t, r) {
  return t.x === r.x && t.y === r.y && t.width === r.width && t.height === r.height;
}
function U7(t, r) {
  let i = null, u;
  const c = JO(t);
  function v() {
    var y;
    clearTimeout(u), (y = i) == null || y.disconnect(), i = null;
  }
  function h(y, g) {
    y === void 0 && (y = !1), g === void 0 && (g = 1), v();
    const S = t.getBoundingClientRect(), {
      left: x,
      top: T,
      width: _,
      height: L
    } = S;
    if (y || r(), !_ || !L)
      return;
    const M = tC(T), U = tC(c.clientWidth - (x + _)), B = tC(c.clientHeight - (T + L)), H = tC(x), G = {
      rootMargin: -M + "px " + -U + "px " + -B + "px " + -H + "px",
      threshold: _7(0, N7(1, g)) || 1
    };
    let Q = !0;
    function W(oe) {
      const j = oe[0].intersectionRatio;
      if (j !== g) {
        if (!Q)
          return h();
        j ? h(!1, j) : u = setTimeout(() => {
          h(!1, 1e-7);
        }, 1e3);
      }
      j === 1 && !e4(S, t.getBoundingClientRect()) && h(), Q = !1;
    }
    try {
      i = new IntersectionObserver(W, {
        ...G,
        // Handle <iframe>s
        root: c.ownerDocument
      });
    } catch {
      i = new IntersectionObserver(W, G);
    }
    i.observe(t);
  }
  return h(!0), v;
}
function V7(t, r, i, u) {
  u === void 0 && (u = {});
  const {
    ancestorScroll: c = !0,
    ancestorResize: v = !0,
    elementResize: h = typeof ResizeObserver == "function",
    layoutShift: y = typeof IntersectionObserver == "function",
    animationFrame: g = !1
  } = u, S = V2(t), x = c || v ? [...S ? wC(S) : [], ...wC(r)] : [];
  x.forEach((H) => {
    c && H.addEventListener("scroll", i, {
      passive: !0
    }), v && H.addEventListener("resize", i);
  });
  const T = S && y ? U7(S, i) : null;
  let _ = -1, L = null;
  h && (L = new ResizeObserver((H) => {
    let [Y] = H;
    Y && Y.target === S && L && (L.unobserve(r), cancelAnimationFrame(_), _ = requestAnimationFrame(() => {
      var G;
      (G = L) == null || G.observe(r);
    })), i();
  }), S && !g && L.observe(S), L.observe(r));
  let M, U = g ? T_(t) : null;
  g && B();
  function B() {
    const H = T_(t);
    U && !e4(U, H) && i(), U = H, M = requestAnimationFrame(B);
  }
  return i(), () => {
    var H;
    x.forEach((Y) => {
      c && Y.removeEventListener("scroll", i), v && Y.removeEventListener("resize", i);
    }), T == null || T(), (H = L) == null || H.disconnect(), L = null, g && cancelAnimationFrame(M);
  };
}
var ZT = k.useLayoutEffect, H7 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], IC = function() {
};
function j7(t, r) {
  return r ? r[0] === "-" ? t + r : t + "__" + r : t;
}
function G7(t, r) {
  for (var i = arguments.length, u = new Array(i > 2 ? i - 2 : 0), c = 2; c < i; c++)
    u[c - 2] = arguments[c];
  var v = [].concat(u);
  if (r && t)
    for (var h in r)
      r.hasOwnProperty(h) && r[h] && v.push("".concat(j7(t, h)));
  return v.filter(function(y) {
    return y;
  }).map(function(y) {
    return String(y).trim();
  }).join(" ");
}
var AC = function(r) {
  return K7(r) ? r.filter(Boolean) : bm(r) === "object" && r !== null ? [r] : [];
}, t4 = function(r) {
  r.className, r.clearValue, r.cx, r.getStyles, r.getClassNames, r.getValue, r.hasValue, r.isMulti, r.isRtl, r.options, r.selectOption, r.selectProps, r.setValue, r.theme;
  var i = pd(r, H7);
  return an({}, i);
}, ci = function(r, i, u) {
  var c = r.cx, v = r.getStyles, h = r.getClassNames, y = r.className;
  return {
    css: v(i, r),
    className: c(u ?? {}, h(i, r), y)
  };
};
function GC(t) {
  return [document.documentElement, document.body, window].indexOf(t) > -1;
}
function z7(t) {
  return GC(t) ? window.innerHeight : t.clientHeight;
}
function n4(t) {
  return GC(t) ? window.pageYOffset : t.scrollTop;
}
function NC(t, r) {
  if (GC(t)) {
    window.scrollTo(0, r);
    return;
  }
  t.scrollTop = r;
}
function W7(t) {
  var r = getComputedStyle(t), i = r.position === "absolute", u = /(auto|scroll)/;
  if (r.position === "fixed")
    return document.documentElement;
  for (var c = t; c = c.parentElement; )
    if (r = getComputedStyle(c), !(i && r.position === "static") && u.test(r.overflow + r.overflowY + r.overflowX))
      return c;
  return document.documentElement;
}
function X7(t, r, i, u) {
  return i * ((t = t / u - 1) * t * t + 1) + r;
}
function nC(t, r) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : IC, c = n4(t), v = r - c, h = 10, y = 0;
  function g() {
    y += h;
    var S = X7(y, c, v, i);
    NC(t, S), y < i ? window.requestAnimationFrame(g) : u(t);
  }
  g();
}
function w_(t, r) {
  var i = t.getBoundingClientRect(), u = r.getBoundingClientRect(), c = r.offsetHeight / 3;
  u.bottom + c > i.bottom ? NC(t, Math.min(r.offsetTop + r.clientHeight - t.offsetHeight + c, t.scrollHeight)) : u.top - c < i.top && NC(t, Math.max(r.offsetTop - c, 0));
}
function Y7(t) {
  var r = t.getBoundingClientRect();
  return {
    bottom: r.bottom,
    height: r.height,
    left: r.left,
    right: r.right,
    top: r.top,
    width: r.width
  };
}
function I_() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function $7() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var r4 = !1, Z7 = {
  get passive() {
    return r4 = !0;
  }
}, rC = typeof window < "u" ? window : {};
rC.addEventListener && rC.removeEventListener && (rC.addEventListener("p", IC, Z7), rC.removeEventListener("p", IC, !1));
var J7 = r4;
function Q7(t) {
  return t != null;
}
function K7(t) {
  return Array.isArray(t);
}
function Zy(t, r, i) {
  return t ? r : i;
}
var q7 = function(r) {
  for (var i = arguments.length, u = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
    u[c - 1] = arguments[c];
  var v = Object.entries(r).filter(function(h) {
    var y = Sp(h, 1), g = y[0];
    return !u.includes(g);
  });
  return v.reduce(function(h, y) {
    var g = Sp(y, 2), S = g[0], x = g[1];
    return h[S] = x, h;
  }, {});
}, eV = ["children", "innerProps"], tV = ["children", "innerProps"];
function nV(t) {
  var r = t.maxHeight, i = t.menuEl, u = t.minHeight, c = t.placement, v = t.shouldScroll, h = t.isFixedPosition, y = t.controlHeight, g = W7(i), S = {
    placement: "bottom",
    maxHeight: r
  };
  if (!i || !i.offsetParent)
    return S;
  var x = g.getBoundingClientRect(), T = x.height, _ = i.getBoundingClientRect(), L = _.bottom, M = _.height, U = _.top, B = i.offsetParent.getBoundingClientRect(), H = B.top, Y = h ? window.innerHeight : z7(g), G = n4(g), Q = parseInt(getComputedStyle(i).marginBottom, 10), W = parseInt(getComputedStyle(i).marginTop, 10), oe = H - W, j = Y - U, re = oe + G, me = T - G - U, Se = L - Y + G + Q, Ne = G + U - W, Ge = 160;
  switch (c) {
    case "auto":
    case "bottom":
      if (j >= M)
        return {
          placement: "bottom",
          maxHeight: r
        };
      if (me >= M && !h)
        return v && nC(g, Se, Ge), {
          placement: "bottom",
          maxHeight: r
        };
      if (!h && me >= u || h && j >= u) {
        v && nC(g, Se, Ge);
        var ze = h ? j - Q : me - Q;
        return {
          placement: "bottom",
          maxHeight: ze
        };
      }
      if (c === "auto" || h) {
        var qe = r, at = h ? oe : re;
        return at >= u && (qe = Math.min(at - Q - y, r)), {
          placement: "top",
          maxHeight: qe
        };
      }
      if (c === "bottom")
        return v && NC(g, Se), {
          placement: "bottom",
          maxHeight: r
        };
      break;
    case "top":
      if (oe >= M)
        return {
          placement: "top",
          maxHeight: r
        };
      if (re >= M && !h)
        return v && nC(g, Ne, Ge), {
          placement: "top",
          maxHeight: r
        };
      if (!h && re >= u || h && oe >= u) {
        var st = r;
        return (!h && re >= u || h && oe >= u) && (st = h ? oe - W : re - W), v && nC(g, Ne, Ge), {
          placement: "top",
          maxHeight: st
        };
      }
      return {
        placement: "bottom",
        maxHeight: r
      };
    default:
      throw new Error('Invalid placement provided "'.concat(c, '".'));
  }
  return S;
}
function rV(t) {
  var r = {
    bottom: "top",
    top: "bottom"
  };
  return t ? r[t] : "bottom";
}
var a4 = function(r) {
  return r === "auto" ? "bottom" : r;
}, aV = function(r, i) {
  var u, c = r.placement, v = r.theme, h = v.borderRadius, y = v.spacing, g = v.colors;
  return an((u = {
    label: "menu"
  }, $y(u, rV(c), "100%"), $y(u, "position", "absolute"), $y(u, "width", "100%"), $y(u, "zIndex", 1), u), i ? {} : {
    backgroundColor: g.neutral0,
    borderRadius: h,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: y.menuGutter,
    marginTop: y.menuGutter
  });
}, i4 = /* @__PURE__ */ k.createContext(null), iV = function(r) {
  var i = r.children, u = r.minMenuHeight, c = r.maxMenuHeight, v = r.menuPlacement, h = r.menuPosition, y = r.menuShouldScrollIntoView, g = r.theme, S = k.useContext(i4) || {}, x = S.setPortalPlacement, T = k.useRef(null), _ = k.useState(c), L = Sp(_, 2), M = L[0], U = L[1], B = k.useState(null), H = Sp(B, 2), Y = H[0], G = H[1], Q = g.spacing.controlHeight;
  return ZT(function() {
    var W = T.current;
    if (W) {
      var oe = h === "fixed", j = y && !oe, re = nV({
        maxHeight: c,
        menuEl: W,
        minHeight: u,
        placement: v,
        shouldScroll: j,
        isFixedPosition: oe,
        controlHeight: Q
      });
      U(re.maxHeight), G(re.placement), x == null || x(re.placement);
    }
  }, [c, v, h, y, u, x, Q]), i({
    ref: T,
    placerProps: an(an({}, r), {}, {
      placement: Y || a4(v),
      maxHeight: M
    })
  });
}, oV = function(r) {
  var i = r.children, u = r.innerRef, c = r.innerProps;
  return tn("div", vn({}, ci(r, "menu", {
    menu: !0
  }), {
    ref: u
  }, c), i);
}, lV = oV, sV = function(r, i) {
  var u = r.maxHeight, c = r.theme.spacing.baseUnit;
  return an({
    maxHeight: u,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, i ? {} : {
    paddingBottom: c,
    paddingTop: c
  });
}, uV = function(r) {
  var i = r.children, u = r.innerProps, c = r.innerRef, v = r.isMulti;
  return tn("div", vn({}, ci(r, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": v
  }), {
    ref: c
  }, u), i);
}, o4 = function(r, i) {
  var u = r.theme, c = u.spacing.baseUnit, v = u.colors;
  return an({
    textAlign: "center"
  }, i ? {} : {
    color: v.neutral40,
    padding: "".concat(c * 2, "px ").concat(c * 3, "px")
  });
}, cV = o4, fV = o4, dV = function(r) {
  var i = r.children, u = i === void 0 ? "No options" : i, c = r.innerProps, v = pd(r, eV);
  return tn("div", vn({}, ci(an(an({}, v), {}, {
    children: u,
    innerProps: c
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), c), u);
}, pV = function(r) {
  var i = r.children, u = i === void 0 ? "Loading..." : i, c = r.innerProps, v = pd(r, tV);
  return tn("div", vn({}, ci(an(an({}, v), {}, {
    children: u,
    innerProps: c
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), c), u);
}, hV = function(r) {
  var i = r.rect, u = r.offset, c = r.position;
  return {
    left: i.left,
    position: c,
    top: u,
    width: i.width,
    zIndex: 1
  };
}, vV = function(r) {
  var i = r.appendTo, u = r.children, c = r.controlElement, v = r.innerProps, h = r.menuPlacement, y = r.menuPosition, g = k.useRef(null), S = k.useRef(null), x = k.useState(a4(h)), T = Sp(x, 2), _ = T[0], L = T[1], M = k.useMemo(function() {
    return {
      setPortalPlacement: L
    };
  }, []), U = k.useState(null), B = Sp(U, 2), H = B[0], Y = B[1], G = k.useCallback(function() {
    if (c) {
      var j = Y7(c), re = y === "fixed" ? 0 : window.pageYOffset, me = j[_] + re;
      (me !== (H == null ? void 0 : H.offset) || j.left !== (H == null ? void 0 : H.rect.left) || j.width !== (H == null ? void 0 : H.rect.width)) && Y({
        offset: me,
        rect: j
      });
    }
  }, [c, y, _, H == null ? void 0 : H.offset, H == null ? void 0 : H.rect.left, H == null ? void 0 : H.rect.width]);
  ZT(function() {
    G();
  }, [G]);
  var Q = k.useCallback(function() {
    typeof S.current == "function" && (S.current(), S.current = null), c && g.current && (S.current = V7(c, g.current, G, {
      elementResize: "ResizeObserver" in window
    }));
  }, [c, G]);
  ZT(function() {
    Q();
  }, [Q]);
  var W = k.useCallback(function(j) {
    g.current = j, Q();
  }, [Q]);
  if (!i && y !== "fixed" || !H)
    return null;
  var oe = tn("div", vn({
    ref: W
  }, ci(an(an({}, r), {}, {
    offset: H.offset,
    position: y,
    rect: H.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), v), u);
  return tn(i4.Provider, {
    value: M
  }, i ? /* @__PURE__ */ Jg.createPortal(oe, i) : oe);
}, mV = function(r) {
  var i = r.isDisabled, u = r.isRtl;
  return {
    label: "container",
    direction: u ? "rtl" : void 0,
    pointerEvents: i ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, gV = function(r) {
  var i = r.children, u = r.innerProps, c = r.isDisabled, v = r.isRtl;
  return tn("div", vn({}, ci(r, "container", {
    "--is-disabled": c,
    "--is-rtl": v
  }), u), i);
}, bV = function(r, i) {
  var u = r.theme.spacing, c = r.isMulti, v = r.hasValue, h = r.selectProps.controlShouldRenderValue;
  return an({
    alignItems: "center",
    display: c && v && h ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, i ? {} : {
    padding: "".concat(u.baseUnit / 2, "px ").concat(u.baseUnit * 2, "px")
  });
}, yV = function(r) {
  var i = r.children, u = r.innerProps, c = r.isMulti, v = r.hasValue;
  return tn("div", vn({}, ci(r, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": c,
    "value-container--has-value": v
  }), u), i);
}, CV = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, EV = function(r) {
  var i = r.children, u = r.innerProps;
  return tn("div", vn({}, ci(r, "indicatorsContainer", {
    indicators: !0
  }), u), i);
}, A_, SV = ["size"], xV = ["innerProps", "isRtl", "size"];
function RV() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var TV = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: RV
}, l4 = function(r) {
  var i = r.size, u = pd(r, SV);
  return tn("svg", vn({
    height: i,
    width: i,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: TV
  }, u));
}, H2 = function(r) {
  return tn(l4, vn({
    size: 20
  }, r), tn("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, s4 = function(r) {
  return tn(l4, vn({
    size: 20
  }, r), tn("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, u4 = function(r, i) {
  var u = r.isFocused, c = r.theme, v = c.spacing.baseUnit, h = c.colors;
  return an({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, i ? {} : {
    color: u ? h.neutral60 : h.neutral20,
    padding: v * 2,
    ":hover": {
      color: u ? h.neutral80 : h.neutral40
    }
  });
}, wV = u4, IV = function(r) {
  var i = r.children, u = r.innerProps;
  return tn("div", vn({}, ci(r, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), u), i || tn(s4, null));
}, AV = u4, NV = function(r) {
  var i = r.children, u = r.innerProps;
  return tn("div", vn({}, ci(r, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), u), i || tn(H2, null));
}, _V = function(r, i) {
  var u = r.isDisabled, c = r.theme, v = c.spacing.baseUnit, h = c.colors;
  return an({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, i ? {} : {
    backgroundColor: u ? h.neutral10 : h.neutral20,
    marginBottom: v * 2,
    marginTop: v * 2
  });
}, OV = function(r) {
  var i = r.innerProps;
  return tn("span", vn({}, i, ci(r, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, LV = x7(A_ || (A_ = A7([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), DV = function(r, i) {
  var u = r.isFocused, c = r.size, v = r.theme, h = v.colors, y = v.spacing.baseUnit;
  return an({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: c,
    lineHeight: 1,
    marginRight: c,
    textAlign: "center",
    verticalAlign: "middle"
  }, i ? {} : {
    color: u ? h.neutral60 : h.neutral20,
    padding: y * 2
  });
}, QR = function(r) {
  var i = r.delay, u = r.offset;
  return tn("span", {
    css: /* @__PURE__ */ F2({
      animation: "".concat(LV, " 1s ease-in-out ").concat(i, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: u ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, MV = function(r) {
  var i = r.innerProps, u = r.isRtl, c = r.size, v = c === void 0 ? 4 : c, h = pd(r, xV);
  return tn("div", vn({}, ci(an(an({}, h), {}, {
    innerProps: i,
    isRtl: u,
    size: v
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), i), tn(QR, {
    delay: 0,
    offset: u
  }), tn(QR, {
    delay: 160,
    offset: !0
  }), tn(QR, {
    delay: 320,
    offset: !u
  }));
}, PV = function(r, i) {
  var u = r.isDisabled, c = r.isFocused, v = r.theme, h = v.colors, y = v.borderRadius, g = v.spacing;
  return an({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: g.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, i ? {} : {
    backgroundColor: u ? h.neutral5 : h.neutral0,
    borderColor: u ? h.neutral10 : c ? h.primary : h.neutral20,
    borderRadius: y,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: c ? "0 0 0 1px ".concat(h.primary) : void 0,
    "&:hover": {
      borderColor: c ? h.primary : h.neutral30
    }
  });
}, kV = function(r) {
  var i = r.children, u = r.isDisabled, c = r.isFocused, v = r.innerRef, h = r.innerProps, y = r.menuIsOpen;
  return tn("div", vn({
    ref: v
  }, ci(r, "control", {
    control: !0,
    "control--is-disabled": u,
    "control--is-focused": c,
    "control--menu-is-open": y
  }), h, {
    "aria-disabled": u || void 0
  }), i);
}, FV = kV, BV = ["data"], UV = function(r, i) {
  var u = r.theme.spacing;
  return i ? {} : {
    paddingBottom: u.baseUnit * 2,
    paddingTop: u.baseUnit * 2
  };
}, VV = function(r) {
  var i = r.children, u = r.cx, c = r.getStyles, v = r.getClassNames, h = r.Heading, y = r.headingProps, g = r.innerProps, S = r.label, x = r.theme, T = r.selectProps;
  return tn("div", vn({}, ci(r, "group", {
    group: !0
  }), g), tn(h, vn({}, y, {
    selectProps: T,
    theme: x,
    getStyles: c,
    getClassNames: v,
    cx: u
  }), S), tn("div", null, i));
}, HV = function(r, i) {
  var u = r.theme, c = u.colors, v = u.spacing;
  return an({
    label: "group",
    cursor: "default",
    display: "block"
  }, i ? {} : {
    color: c.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: v.baseUnit * 3,
    paddingRight: v.baseUnit * 3,
    textTransform: "uppercase"
  });
}, jV = function(r) {
  var i = t4(r);
  i.data;
  var u = pd(i, BV);
  return tn("div", vn({}, ci(r, "groupHeading", {
    "group-heading": !0
  }), u));
}, GV = VV, zV = ["innerRef", "isDisabled", "isHidden", "inputClassName"], WV = function(r, i) {
  var u = r.isDisabled, c = r.value, v = r.theme, h = v.spacing, y = v.colors;
  return an(an({
    visibility: u ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: c ? "translateZ(0)" : ""
  }, XV), i ? {} : {
    margin: h.baseUnit / 2,
    paddingBottom: h.baseUnit / 2,
    paddingTop: h.baseUnit / 2,
    color: y.neutral80
  });
}, c4 = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, XV = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": an({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, c4)
}, YV = function(r) {
  return an({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: r ? 0 : 1,
    width: "100%"
  }, c4);
}, $V = function(r) {
  var i = r.cx, u = r.value, c = t4(r), v = c.innerRef, h = c.isDisabled, y = c.isHidden, g = c.inputClassName, S = pd(c, zV);
  return tn("div", vn({}, ci(r, "input", {
    "input-container": !0
  }), {
    "data-value": u || ""
  }), tn("input", vn({
    className: i({
      input: !0
    }, g),
    ref: v,
    style: YV(y),
    disabled: h
  }, S)));
}, ZV = $V, JV = function(r, i) {
  var u = r.theme, c = u.spacing, v = u.borderRadius, h = u.colors;
  return an({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, i ? {} : {
    backgroundColor: h.neutral10,
    borderRadius: v / 2,
    margin: c.baseUnit / 2
  });
}, QV = function(r, i) {
  var u = r.theme, c = u.borderRadius, v = u.colors, h = r.cropWithEllipsis;
  return an({
    overflow: "hidden",
    textOverflow: h || h === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, i ? {} : {
    borderRadius: c / 2,
    color: v.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, KV = function(r, i) {
  var u = r.theme, c = u.spacing, v = u.borderRadius, h = u.colors, y = r.isFocused;
  return an({
    alignItems: "center",
    display: "flex"
  }, i ? {} : {
    borderRadius: v / 2,
    backgroundColor: y ? h.dangerLight : void 0,
    paddingLeft: c.baseUnit,
    paddingRight: c.baseUnit,
    ":hover": {
      backgroundColor: h.dangerLight,
      color: h.danger
    }
  });
}, f4 = function(r) {
  var i = r.children, u = r.innerProps;
  return tn("div", u, i);
}, qV = f4, eH = f4;
function tH(t) {
  var r = t.children, i = t.innerProps;
  return tn("div", vn({
    role: "button"
  }, i), r || tn(H2, {
    size: 14
  }));
}
var nH = function(r) {
  var i = r.children, u = r.components, c = r.data, v = r.innerProps, h = r.isDisabled, y = r.removeProps, g = r.selectProps, S = u.Container, x = u.Label, T = u.Remove;
  return tn(S, {
    data: c,
    innerProps: an(an({}, ci(r, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": h
    })), v),
    selectProps: g
  }, tn(x, {
    data: c,
    innerProps: an({}, ci(r, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: g
  }, i), tn(T, {
    data: c,
    innerProps: an(an({}, ci(r, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(i || "option")
    }, y),
    selectProps: g
  }));
}, rH = nH, aH = function(r, i) {
  var u = r.isDisabled, c = r.isFocused, v = r.isSelected, h = r.theme, y = h.spacing, g = h.colors;
  return an({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, i ? {} : {
    backgroundColor: v ? g.primary : c ? g.primary25 : "transparent",
    color: u ? g.neutral20 : v ? g.neutral0 : "inherit",
    padding: "".concat(y.baseUnit * 2, "px ").concat(y.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: u ? void 0 : v ? g.primary : g.primary50
    }
  });
}, iH = function(r) {
  var i = r.children, u = r.isDisabled, c = r.isFocused, v = r.isSelected, h = r.innerRef, y = r.innerProps;
  return tn("div", vn({}, ci(r, "option", {
    option: !0,
    "option--is-disabled": u,
    "option--is-focused": c,
    "option--is-selected": v
  }), {
    ref: h,
    "aria-disabled": u
  }, y), i);
}, oH = iH, lH = function(r, i) {
  var u = r.theme, c = u.spacing, v = u.colors;
  return an({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, i ? {} : {
    color: v.neutral50,
    marginLeft: c.baseUnit / 2,
    marginRight: c.baseUnit / 2
  });
}, sH = function(r) {
  var i = r.children, u = r.innerProps;
  return tn("div", vn({}, ci(r, "placeholder", {
    placeholder: !0
  }), u), i);
}, uH = sH, cH = function(r, i) {
  var u = r.isDisabled, c = r.theme, v = c.spacing, h = c.colors;
  return an({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, i ? {} : {
    color: u ? h.neutral40 : h.neutral80,
    marginLeft: v.baseUnit / 2,
    marginRight: v.baseUnit / 2
  });
}, fH = function(r) {
  var i = r.children, u = r.isDisabled, c = r.innerProps;
  return tn("div", vn({}, ci(r, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": u
  }), c), i);
}, dH = fH, c0 = {
  ClearIndicator: NV,
  Control: FV,
  DropdownIndicator: IV,
  DownChevron: s4,
  CrossIcon: H2,
  Group: GV,
  GroupHeading: jV,
  IndicatorsContainer: EV,
  IndicatorSeparator: OV,
  Input: ZV,
  LoadingIndicator: MV,
  Menu: lV,
  MenuList: uV,
  MenuPortal: vV,
  LoadingMessage: pV,
  NoOptionsMessage: dV,
  MultiValue: rH,
  MultiValueContainer: qV,
  MultiValueLabel: eH,
  MultiValueRemove: tH,
  Option: oH,
  Placeholder: uH,
  SelectContainer: gV,
  SingleValue: dH,
  ValueContainer: yV
}, pH = function(r) {
  return an(an({}, c0), r.components);
}, N_ = Number.isNaN || function(r) {
  return typeof r == "number" && r !== r;
};
function hH(t, r) {
  return !!(t === r || N_(t) && N_(r));
}
function vH(t, r) {
  if (t.length !== r.length)
    return !1;
  for (var i = 0; i < t.length; i++)
    if (!hH(t[i], r[i]))
      return !1;
  return !0;
}
function mH(t, r) {
  r === void 0 && (r = vH);
  var i = null;
  function u() {
    for (var c = [], v = 0; v < arguments.length; v++)
      c[v] = arguments[v];
    if (i && i.lastThis === this && r(c, i.lastArgs))
      return i.lastResult;
    var h = t.apply(this, c);
    return i = {
      lastResult: h,
      lastArgs: c,
      lastThis: this
    }, h;
  }
  return u.clear = function() {
    i = null;
  }, u;
}
function gH() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var bH = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IEpTWCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: gH
}, yH = function(r) {
  return tn("span", vn({
    css: bH
  }, r));
}, __ = yH, CH = {
  guidance: function(r) {
    var i = r.isSearchable, u = r.isMulti, c = r.tabSelectsValue, v = r.context, h = r.isInitialFocus;
    switch (v) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(c ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return h ? "".concat(r["aria-label"] || "Select", " is focused ").concat(i ? ",type to refine list" : "", ", press Down to open the menu, ").concat(u ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(r) {
    var i = r.action, u = r.label, c = u === void 0 ? "" : u, v = r.labels, h = r.isDisabled;
    switch (i) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(c, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(v.length > 1 ? "s" : "", " ").concat(v.join(","), ", selected.");
      case "select-option":
        return h ? "option ".concat(c, " is disabled. Select another option.") : "option ".concat(c, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(r) {
    var i = r.context, u = r.focused, c = r.options, v = r.label, h = v === void 0 ? "" : v, y = r.selectValue, g = r.isDisabled, S = r.isSelected, x = r.isAppleDevice, T = function(U, B) {
      return U && U.length ? "".concat(U.indexOf(B) + 1, " of ").concat(U.length) : "";
    };
    if (i === "value" && y)
      return "value ".concat(h, " focused, ").concat(T(y, u), ".");
    if (i === "menu" && x) {
      var _ = g ? " disabled" : "", L = "".concat(S ? " selected" : "").concat(_);
      return "".concat(h).concat(L, ", ").concat(T(c, u), ".");
    }
    return "";
  },
  onFilter: function(r) {
    var i = r.inputValue, u = r.resultsMessage;
    return "".concat(u).concat(i ? " for search term " + i : "", ".");
  }
}, EH = function(r) {
  var i = r.ariaSelection, u = r.focusedOption, c = r.focusedValue, v = r.focusableOptions, h = r.isFocused, y = r.selectValue, g = r.selectProps, S = r.id, x = r.isAppleDevice, T = g.ariaLiveMessages, _ = g.getOptionLabel, L = g.inputValue, M = g.isMulti, U = g.isOptionDisabled, B = g.isSearchable, H = g.menuIsOpen, Y = g.options, G = g.screenReaderStatus, Q = g.tabSelectsValue, W = g.isLoading, oe = g["aria-label"], j = g["aria-live"], re = k.useMemo(function() {
    return an(an({}, CH), T || {});
  }, [T]), me = k.useMemo(function() {
    var at = "";
    if (i && re.onChange) {
      var st = i.option, We = i.options, he = i.removedValue, ke = i.removedValues, _e = i.value, q = function(ht) {
        return Array.isArray(ht) ? null : ht;
      }, pe = he || st || q(_e), $e = pe ? _(pe) : "", lt = We || ke || void 0, ot = lt ? lt.map(_) : [], nt = an({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: pe && U(pe, y),
        label: $e,
        labels: ot
      }, i);
      at = re.onChange(nt);
    }
    return at;
  }, [i, re, U, y, _]), Se = k.useMemo(function() {
    var at = "", st = u || c, We = !!(u && y && y.includes(u));
    if (st && re.onFocus) {
      var he = {
        focused: st,
        label: _(st),
        isDisabled: U(st, y),
        isSelected: We,
        options: v,
        context: st === u ? "menu" : "value",
        selectValue: y,
        isAppleDevice: x
      };
      at = re.onFocus(he);
    }
    return at;
  }, [u, c, _, U, re, v, y, x]), Ne = k.useMemo(function() {
    var at = "";
    if (H && Y.length && !W && re.onFilter) {
      var st = G({
        count: v.length
      });
      at = re.onFilter({
        inputValue: L,
        resultsMessage: st
      });
    }
    return at;
  }, [v, L, H, re, Y, G, W]), Ge = (i == null ? void 0 : i.action) === "initial-input-focus", ze = k.useMemo(function() {
    var at = "";
    if (re.guidance) {
      var st = c ? "value" : H ? "menu" : "input";
      at = re.guidance({
        "aria-label": oe,
        context: st,
        isDisabled: u && U(u, y),
        isMulti: M,
        isSearchable: B,
        tabSelectsValue: Q,
        isInitialFocus: Ge
      });
    }
    return at;
  }, [oe, u, c, M, U, B, H, re, y, Q, Ge]), qe = tn(k.Fragment, null, tn("span", {
    id: "aria-selection"
  }, me), tn("span", {
    id: "aria-focused"
  }, Se), tn("span", {
    id: "aria-results"
  }, Ne), tn("span", {
    id: "aria-guidance"
  }, ze));
  return tn(k.Fragment, null, tn(__, {
    id: S
  }, Ge && qe), tn(__, {
    "aria-live": j,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, h && !Ge && qe));
}, SH = EH, JT = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], xH = new RegExp("[" + JT.map(function(t) {
  return t.letters;
}).join("") + "]", "g"), d4 = {};
for (var KR = 0; KR < JT.length; KR++)
  for (var qR = JT[KR], eT = 0; eT < qR.letters.length; eT++)
    d4[qR.letters[eT]] = qR.base;
var p4 = function(r) {
  return r.replace(xH, function(i) {
    return d4[i];
  });
}, RH = mH(p4), O_ = function(r) {
  return r.replace(/^\s+|\s+$/g, "");
}, TH = function(r) {
  return "".concat(r.label, " ").concat(r.value);
}, j2 = function(r) {
  return function(i, u) {
    if (i.data.__isNew__)
      return !0;
    var c = an({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: TH,
      trim: !0,
      matchFrom: "any"
    }, r), v = c.ignoreCase, h = c.ignoreAccents, y = c.stringify, g = c.trim, S = c.matchFrom, x = g ? O_(u) : u, T = g ? O_(y(i)) : y(i);
    return v && (x = x.toLowerCase(), T = T.toLowerCase()), h && (x = RH(x), T = p4(T)), S === "start" ? T.substr(0, x.length) === x : T.indexOf(x) > -1;
  };
}, wH = ["innerRef"];
function IH(t) {
  var r = t.innerRef, i = pd(t, wH), u = q7(i, "onExited", "in", "enter", "exit", "appear");
  return tn("input", vn({
    ref: r
  }, u, {
    css: /* @__PURE__ */ F2({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyByZW1vdmVQcm9wcyB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGlubmVyUmVmLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydpbnB1dCddICYge1xuICByZWFkb25seSBpbm5lclJlZjogUmVmPEhUTUxJbnB1dEVsZW1lbnQ+O1xufSkge1xuICAvLyBSZW1vdmUgYW5pbWF0aW9uIHByb3BzIG5vdCBtZWFudCBmb3IgSFRNTCBlbGVtZW50c1xuICBjb25zdCBmaWx0ZXJlZFByb3BzID0gcmVtb3ZlUHJvcHMoXG4gICAgcHJvcHMsXG4gICAgJ29uRXhpdGVkJyxcbiAgICAnaW4nLFxuICAgICdlbnRlcicsXG4gICAgJ2V4aXQnLFxuICAgICdhcHBlYXInXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4uZmlsdGVyZWRQcm9wc31cbiAgICAgIGNzcz17e1xuICAgICAgICBsYWJlbDogJ2R1bW15SW5wdXQnLFxuICAgICAgICAvLyBnZXQgcmlkIG9mIGFueSBkZWZhdWx0IHN0eWxlc1xuICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICBib3JkZXI6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgdGhpcyBoaWRlcyB0aGUgZmxhc2hpbmcgY3Vyc29yXG4gICAgICAgIGNhcmV0Q29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgICAgIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gICAgICAgIGdyaWRBcmVhOiAnMSAvIDEgLyAyIC8gMycsXG4gICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgd2l0aG91dCBgd2lkdGhgIGJyb3dzZXJzIHdvbid0IGFsbG93IGZvY3VzXG4gICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gZGVza3RvcFxuICAgICAgICBjb2xvcjogJ3RyYW5zcGFyZW50JyxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgIGxlZnQ6IC0xMDAsXG4gICAgICAgIG9wYWNpdHk6IDAsXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB0cmFuc2Zvcm06ICdzY2FsZSguMDEpJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}
var AH = function(r) {
  r.cancelable && r.preventDefault(), r.stopPropagation();
};
function NH(t) {
  var r = t.isEnabled, i = t.onBottomArrive, u = t.onBottomLeave, c = t.onTopArrive, v = t.onTopLeave, h = k.useRef(!1), y = k.useRef(!1), g = k.useRef(0), S = k.useRef(null), x = k.useCallback(function(B, H) {
    if (S.current !== null) {
      var Y = S.current, G = Y.scrollTop, Q = Y.scrollHeight, W = Y.clientHeight, oe = S.current, j = H > 0, re = Q - W - G, me = !1;
      re > H && h.current && (u && u(B), h.current = !1), j && y.current && (v && v(B), y.current = !1), j && H > re ? (i && !h.current && i(B), oe.scrollTop = Q, me = !0, h.current = !0) : !j && -H > G && (c && !y.current && c(B), oe.scrollTop = 0, me = !0, y.current = !0), me && AH(B);
    }
  }, [i, u, c, v]), T = k.useCallback(function(B) {
    x(B, B.deltaY);
  }, [x]), _ = k.useCallback(function(B) {
    g.current = B.changedTouches[0].clientY;
  }, []), L = k.useCallback(function(B) {
    var H = g.current - B.changedTouches[0].clientY;
    x(B, H);
  }, [x]), M = k.useCallback(function(B) {
    if (B) {
      var H = J7 ? {
        passive: !1
      } : !1;
      B.addEventListener("wheel", T, H), B.addEventListener("touchstart", _, H), B.addEventListener("touchmove", L, H);
    }
  }, [L, _, T]), U = k.useCallback(function(B) {
    B && (B.removeEventListener("wheel", T, !1), B.removeEventListener("touchstart", _, !1), B.removeEventListener("touchmove", L, !1));
  }, [L, _, T]);
  return k.useEffect(function() {
    if (r) {
      var B = S.current;
      return M(B), function() {
        U(B);
      };
    }
  }, [r, M, U]), function(B) {
    S.current = B;
  };
}
var L_ = ["boxSizing", "height", "overflow", "paddingRight", "position"], D_ = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function M_(t) {
  t.cancelable && t.preventDefault();
}
function P_(t) {
  t.stopPropagation();
}
function k_() {
  var t = this.scrollTop, r = this.scrollHeight, i = t + this.offsetHeight;
  t === 0 ? this.scrollTop = 1 : i === r && (this.scrollTop = t - 1);
}
function F_() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var B_ = !!(typeof window < "u" && window.document && window.document.createElement), Hy = 0, Fg = {
  capture: !1,
  passive: !1
};
function _H(t) {
  var r = t.isEnabled, i = t.accountForScrollbars, u = i === void 0 ? !0 : i, c = k.useRef({}), v = k.useRef(null), h = k.useCallback(function(g) {
    if (B_) {
      var S = document.body, x = S && S.style;
      if (u && L_.forEach(function(M) {
        var U = x && x[M];
        c.current[M] = U;
      }), u && Hy < 1) {
        var T = parseInt(c.current.paddingRight, 10) || 0, _ = document.body ? document.body.clientWidth : 0, L = window.innerWidth - _ + T || 0;
        Object.keys(D_).forEach(function(M) {
          var U = D_[M];
          x && (x[M] = U);
        }), x && (x.paddingRight = "".concat(L, "px"));
      }
      S && F_() && (S.addEventListener("touchmove", M_, Fg), g && (g.addEventListener("touchstart", k_, Fg), g.addEventListener("touchmove", P_, Fg))), Hy += 1;
    }
  }, [u]), y = k.useCallback(function(g) {
    if (B_) {
      var S = document.body, x = S && S.style;
      Hy = Math.max(Hy - 1, 0), u && Hy < 1 && L_.forEach(function(T) {
        var _ = c.current[T];
        x && (x[T] = _);
      }), S && F_() && (S.removeEventListener("touchmove", M_, Fg), g && (g.removeEventListener("touchstart", k_, Fg), g.removeEventListener("touchmove", P_, Fg)));
    }
  }, [u]);
  return k.useEffect(function() {
    if (r) {
      var g = v.current;
      return h(g), function() {
        y(g);
      };
    }
  }, [r, h, y]), function(g) {
    v.current = g;
  };
}
function OH() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var LH = function(r) {
  var i = r.target;
  return i.ownerDocument.activeElement && i.ownerDocument.activeElement.blur();
}, DH = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: OH
};
function MH(t) {
  var r = t.children, i = t.lockEnabled, u = t.captureEnabled, c = u === void 0 ? !0 : u, v = t.onBottomArrive, h = t.onBottomLeave, y = t.onTopArrive, g = t.onTopLeave, S = NH({
    isEnabled: c,
    onBottomArrive: v,
    onBottomLeave: h,
    onTopArrive: y,
    onTopLeave: g
  }), x = _H({
    isEnabled: i
  }), T = function(L) {
    S(L), x(L);
  };
  return tn(k.Fragment, null, i && tn("div", {
    onClick: LH,
    css: DH
  }), r(T));
}
function PH() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var kH = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: PH
}, FH = function(r) {
  var i = r.name, u = r.onFocus;
  return tn("input", {
    required: !0,
    name: i,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: u,
    css: kH,
    value: "",
    onChange: function() {
    }
  });
}, BH = FH;
function G2(t) {
  var r;
  return typeof window < "u" && window.navigator != null ? t.test(((r = window.navigator.userAgentData) === null || r === void 0 ? void 0 : r.platform) || window.navigator.platform) : !1;
}
function UH() {
  return G2(/^iPhone/i);
}
function h4() {
  return G2(/^Mac/i);
}
function VH() {
  return G2(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  h4() && navigator.maxTouchPoints > 1;
}
function HH() {
  return UH() || VH();
}
function jH() {
  return h4() || HH();
}
var GH = function(r) {
  return r.label;
}, v4 = function(r) {
  return r.label;
}, m4 = function(r) {
  return r.value;
}, zH = function(r) {
  return !!r.isDisabled;
}, WH = {
  clearIndicator: AV,
  container: mV,
  control: PV,
  dropdownIndicator: wV,
  group: UV,
  groupHeading: HV,
  indicatorsContainer: CV,
  indicatorSeparator: _V,
  input: WV,
  loadingIndicator: DV,
  loadingMessage: fV,
  menu: aV,
  menuList: sV,
  menuPortal: hV,
  multiValue: JV,
  multiValueLabel: QV,
  multiValueRemove: KV,
  noOptionsMessage: cV,
  option: aH,
  placeholder: lH,
  singleValue: cH,
  valueContainer: bV
}, XH = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, YH = 4, g4 = 4, $H = 38, ZH = g4 * 2, JH = {
  baseUnit: g4,
  controlHeight: $H,
  menuGutter: ZH
}, tT = {
  borderRadius: YH,
  colors: XH,
  spacing: JH
}, QH = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: I_(),
  captureMenuScroll: !I_(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: j2(),
  formatGroupLabel: GH,
  getOptionLabel: v4,
  getOptionValue: m4,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: zH,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !$7(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(r) {
    var i = r.count;
    return "".concat(i, " result").concat(i !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function U_(t, r, i, u) {
  var c = C4(t, r, i), v = E4(t, r, i), h = y4(t, r), y = _C(t, r);
  return {
    type: "option",
    data: r,
    isDisabled: c,
    isSelected: v,
    label: h,
    value: y,
    index: u
  };
}
function pC(t, r) {
  return t.options.map(function(i, u) {
    if ("options" in i) {
      var c = i.options.map(function(h, y) {
        return U_(t, h, r, y);
      }).filter(function(h) {
        return H_(t, h);
      });
      return c.length > 0 ? {
        type: "group",
        data: i,
        options: c,
        index: u
      } : void 0;
    }
    var v = U_(t, i, r, u);
    return H_(t, v) ? v : void 0;
  }).filter(Q7);
}
function b4(t) {
  return t.reduce(function(r, i) {
    return i.type === "group" ? r.push.apply(r, jg(i.options.map(function(u) {
      return u.data;
    }))) : r.push(i.data), r;
  }, []);
}
function V_(t, r) {
  return t.reduce(function(i, u) {
    return u.type === "group" ? i.push.apply(i, jg(u.options.map(function(c) {
      return {
        data: c.data,
        id: "".concat(r, "-").concat(u.index, "-").concat(c.index)
      };
    }))) : i.push({
      data: u.data,
      id: "".concat(r, "-").concat(u.index)
    }), i;
  }, []);
}
function KH(t, r) {
  return b4(pC(t, r));
}
function H_(t, r) {
  var i = t.inputValue, u = i === void 0 ? "" : i, c = r.data, v = r.isSelected, h = r.label, y = r.value;
  return (!x4(t) || !v) && S4(t, {
    label: h,
    value: y,
    data: c
  }, u);
}
function qH(t, r) {
  var i = t.focusedValue, u = t.selectValue, c = u.indexOf(i);
  if (c > -1) {
    var v = r.indexOf(i);
    if (v > -1)
      return i;
    if (c < r.length)
      return r[c];
  }
  return null;
}
function ej(t, r) {
  var i = t.focusedOption;
  return i && r.indexOf(i) > -1 ? i : r[0];
}
var nT = function(r, i) {
  var u, c = (u = r.find(function(v) {
    return v.data === i;
  })) === null || u === void 0 ? void 0 : u.id;
  return c || null;
}, y4 = function(r, i) {
  return r.getOptionLabel(i);
}, _C = function(r, i) {
  return r.getOptionValue(i);
};
function C4(t, r, i) {
  return typeof t.isOptionDisabled == "function" ? t.isOptionDisabled(r, i) : !1;
}
function E4(t, r, i) {
  if (i.indexOf(r) > -1)
    return !0;
  if (typeof t.isOptionSelected == "function")
    return t.isOptionSelected(r, i);
  var u = _C(t, r);
  return i.some(function(c) {
    return _C(t, c) === u;
  });
}
function S4(t, r, i) {
  return t.filterOption ? t.filterOption(r, i) : !0;
}
var x4 = function(r) {
  var i = r.hideSelectedOptions, u = r.isMulti;
  return i === void 0 ? u : i;
}, tj = 1, R4 = /* @__PURE__ */ function(t) {
  yU(i, t);
  var r = SU(i);
  function i(u) {
    var c;
    if (gU(this, i), c = r.call(this, u), c.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, c.blockOptionHover = !1, c.isComposing = !1, c.commonProps = void 0, c.initialTouchX = 0, c.initialTouchY = 0, c.openAfterFocus = !1, c.scrollToFocusedOptionOnUpdate = !1, c.userIsDragging = void 0, c.isAppleDevice = jH(), c.controlRef = null, c.getControlRef = function(g) {
      c.controlRef = g;
    }, c.focusedOptionRef = null, c.getFocusedOptionRef = function(g) {
      c.focusedOptionRef = g;
    }, c.menuListRef = null, c.getMenuListRef = function(g) {
      c.menuListRef = g;
    }, c.inputRef = null, c.getInputRef = function(g) {
      c.inputRef = g;
    }, c.focus = c.focusInput, c.blur = c.blurInput, c.onChange = function(g, S) {
      var x = c.props, T = x.onChange, _ = x.name;
      S.name = _, c.ariaOnChange(g, S), T(g, S);
    }, c.setValue = function(g, S, x) {
      var T = c.props, _ = T.closeMenuOnSelect, L = T.isMulti, M = T.inputValue;
      c.onInputChange("", {
        action: "set-value",
        prevInputValue: M
      }), _ && (c.setState({
        inputIsHiddenAfterUpdate: !L
      }), c.onMenuClose()), c.setState({
        clearFocusValueOnUpdate: !0
      }), c.onChange(g, {
        action: S,
        option: x
      });
    }, c.selectOption = function(g) {
      var S = c.props, x = S.blurInputOnSelect, T = S.isMulti, _ = S.name, L = c.state.selectValue, M = T && c.isOptionSelected(g, L), U = c.isOptionDisabled(g, L);
      if (M) {
        var B = c.getOptionValue(g);
        c.setValue(L.filter(function(H) {
          return c.getOptionValue(H) !== B;
        }), "deselect-option", g);
      } else if (!U)
        T ? c.setValue([].concat(jg(L), [g]), "select-option", g) : c.setValue(g, "select-option");
      else {
        c.ariaOnChange(g, {
          action: "select-option",
          option: g,
          name: _
        });
        return;
      }
      x && c.blurInput();
    }, c.removeValue = function(g) {
      var S = c.props.isMulti, x = c.state.selectValue, T = c.getOptionValue(g), _ = x.filter(function(M) {
        return c.getOptionValue(M) !== T;
      }), L = Zy(S, _, _[0] || null);
      c.onChange(L, {
        action: "remove-value",
        removedValue: g
      }), c.focusInput();
    }, c.clearValue = function() {
      var g = c.state.selectValue;
      c.onChange(Zy(c.props.isMulti, [], null), {
        action: "clear",
        removedValues: g
      });
    }, c.popValue = function() {
      var g = c.props.isMulti, S = c.state.selectValue, x = S[S.length - 1], T = S.slice(0, S.length - 1), _ = Zy(g, T, T[0] || null);
      x && c.onChange(_, {
        action: "pop-value",
        removedValue: x
      });
    }, c.getFocusedOptionId = function(g) {
      return nT(c.state.focusableOptionsWithIds, g);
    }, c.getFocusableOptionsWithIds = function() {
      return V_(pC(c.props, c.state.selectValue), c.getElementId("option"));
    }, c.getValue = function() {
      return c.state.selectValue;
    }, c.cx = function() {
      for (var g = arguments.length, S = new Array(g), x = 0; x < g; x++)
        S[x] = arguments[x];
      return G7.apply(void 0, [c.props.classNamePrefix].concat(S));
    }, c.getOptionLabel = function(g) {
      return y4(c.props, g);
    }, c.getOptionValue = function(g) {
      return _C(c.props, g);
    }, c.getStyles = function(g, S) {
      var x = c.props.unstyled, T = WH[g](S, x);
      T.boxSizing = "border-box";
      var _ = c.props.styles[g];
      return _ ? _(T, S) : T;
    }, c.getClassNames = function(g, S) {
      var x, T;
      return (x = (T = c.props.classNames)[g]) === null || x === void 0 ? void 0 : x.call(T, S);
    }, c.getElementId = function(g) {
      return "".concat(c.state.instancePrefix, "-").concat(g);
    }, c.getComponents = function() {
      return pH(c.props);
    }, c.buildCategorizedOptions = function() {
      return pC(c.props, c.state.selectValue);
    }, c.getCategorizedOptions = function() {
      return c.props.menuIsOpen ? c.buildCategorizedOptions() : [];
    }, c.buildFocusableOptions = function() {
      return b4(c.buildCategorizedOptions());
    }, c.getFocusableOptions = function() {
      return c.props.menuIsOpen ? c.buildFocusableOptions() : [];
    }, c.ariaOnChange = function(g, S) {
      c.setState({
        ariaSelection: an({
          value: g
        }, S)
      });
    }, c.onMenuMouseDown = function(g) {
      g.button === 0 && (g.stopPropagation(), g.preventDefault(), c.focusInput());
    }, c.onMenuMouseMove = function(g) {
      c.blockOptionHover = !1;
    }, c.onControlMouseDown = function(g) {
      if (!g.defaultPrevented) {
        var S = c.props.openMenuOnClick;
        c.state.isFocused ? c.props.menuIsOpen ? g.target.tagName !== "INPUT" && g.target.tagName !== "TEXTAREA" && c.onMenuClose() : S && c.openMenu("first") : (S && (c.openAfterFocus = !0), c.focusInput()), g.target.tagName !== "INPUT" && g.target.tagName !== "TEXTAREA" && g.preventDefault();
      }
    }, c.onDropdownIndicatorMouseDown = function(g) {
      if (!(g && g.type === "mousedown" && g.button !== 0) && !c.props.isDisabled) {
        var S = c.props, x = S.isMulti, T = S.menuIsOpen;
        c.focusInput(), T ? (c.setState({
          inputIsHiddenAfterUpdate: !x
        }), c.onMenuClose()) : c.openMenu("first"), g.preventDefault();
      }
    }, c.onClearIndicatorMouseDown = function(g) {
      g && g.type === "mousedown" && g.button !== 0 || (c.clearValue(), g.preventDefault(), c.openAfterFocus = !1, g.type === "touchend" ? c.focusInput() : setTimeout(function() {
        return c.focusInput();
      }));
    }, c.onScroll = function(g) {
      typeof c.props.closeMenuOnScroll == "boolean" ? g.target instanceof HTMLElement && GC(g.target) && c.props.onMenuClose() : typeof c.props.closeMenuOnScroll == "function" && c.props.closeMenuOnScroll(g) && c.props.onMenuClose();
    }, c.onCompositionStart = function() {
      c.isComposing = !0;
    }, c.onCompositionEnd = function() {
      c.isComposing = !1;
    }, c.onTouchStart = function(g) {
      var S = g.touches, x = S && S.item(0);
      x && (c.initialTouchX = x.clientX, c.initialTouchY = x.clientY, c.userIsDragging = !1);
    }, c.onTouchMove = function(g) {
      var S = g.touches, x = S && S.item(0);
      if (x) {
        var T = Math.abs(x.clientX - c.initialTouchX), _ = Math.abs(x.clientY - c.initialTouchY), L = 5;
        c.userIsDragging = T > L || _ > L;
      }
    }, c.onTouchEnd = function(g) {
      c.userIsDragging || (c.controlRef && !c.controlRef.contains(g.target) && c.menuListRef && !c.menuListRef.contains(g.target) && c.blurInput(), c.initialTouchX = 0, c.initialTouchY = 0);
    }, c.onControlTouchEnd = function(g) {
      c.userIsDragging || c.onControlMouseDown(g);
    }, c.onClearIndicatorTouchEnd = function(g) {
      c.userIsDragging || c.onClearIndicatorMouseDown(g);
    }, c.onDropdownIndicatorTouchEnd = function(g) {
      c.userIsDragging || c.onDropdownIndicatorMouseDown(g);
    }, c.handleInputChange = function(g) {
      var S = c.props.inputValue, x = g.currentTarget.value;
      c.setState({
        inputIsHiddenAfterUpdate: !1
      }), c.onInputChange(x, {
        action: "input-change",
        prevInputValue: S
      }), c.props.menuIsOpen || c.onMenuOpen();
    }, c.onInputFocus = function(g) {
      c.props.onFocus && c.props.onFocus(g), c.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (c.openAfterFocus || c.props.openMenuOnFocus) && c.openMenu("first"), c.openAfterFocus = !1;
    }, c.onInputBlur = function(g) {
      var S = c.props.inputValue;
      if (c.menuListRef && c.menuListRef.contains(document.activeElement)) {
        c.inputRef.focus();
        return;
      }
      c.props.onBlur && c.props.onBlur(g), c.onInputChange("", {
        action: "input-blur",
        prevInputValue: S
      }), c.onMenuClose(), c.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, c.onOptionHover = function(g) {
      if (!(c.blockOptionHover || c.state.focusedOption === g)) {
        var S = c.getFocusableOptions(), x = S.indexOf(g);
        c.setState({
          focusedOption: g,
          focusedOptionId: x > -1 ? c.getFocusedOptionId(g) : null
        });
      }
    }, c.shouldHideSelectedOptions = function() {
      return x4(c.props);
    }, c.onValueInputFocus = function(g) {
      g.preventDefault(), g.stopPropagation(), c.focus();
    }, c.onKeyDown = function(g) {
      var S = c.props, x = S.isMulti, T = S.backspaceRemovesValue, _ = S.escapeClearsValue, L = S.inputValue, M = S.isClearable, U = S.isDisabled, B = S.menuIsOpen, H = S.onKeyDown, Y = S.tabSelectsValue, G = S.openMenuOnFocus, Q = c.state, W = Q.focusedOption, oe = Q.focusedValue, j = Q.selectValue;
      if (!U && !(typeof H == "function" && (H(g), g.defaultPrevented))) {
        switch (c.blockOptionHover = !0, g.key) {
          case "ArrowLeft":
            if (!x || L)
              return;
            c.focusValue("previous");
            break;
          case "ArrowRight":
            if (!x || L)
              return;
            c.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (L)
              return;
            if (oe)
              c.removeValue(oe);
            else {
              if (!T)
                return;
              x ? c.popValue() : M && c.clearValue();
            }
            break;
          case "Tab":
            if (c.isComposing || g.shiftKey || !B || !Y || !W || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            G && c.isOptionSelected(W, j))
              return;
            c.selectOption(W);
            break;
          case "Enter":
            if (g.keyCode === 229)
              break;
            if (B) {
              if (!W || c.isComposing)
                return;
              c.selectOption(W);
              break;
            }
            return;
          case "Escape":
            B ? (c.setState({
              inputIsHiddenAfterUpdate: !1
            }), c.onInputChange("", {
              action: "menu-close",
              prevInputValue: L
            }), c.onMenuClose()) : M && _ && c.clearValue();
            break;
          case " ":
            if (L)
              return;
            if (!B) {
              c.openMenu("first");
              break;
            }
            if (!W)
              return;
            c.selectOption(W);
            break;
          case "ArrowUp":
            B ? c.focusOption("up") : c.openMenu("last");
            break;
          case "ArrowDown":
            B ? c.focusOption("down") : c.openMenu("first");
            break;
          case "PageUp":
            if (!B)
              return;
            c.focusOption("pageup");
            break;
          case "PageDown":
            if (!B)
              return;
            c.focusOption("pagedown");
            break;
          case "Home":
            if (!B)
              return;
            c.focusOption("first");
            break;
          case "End":
            if (!B)
              return;
            c.focusOption("last");
            break;
          default:
            return;
        }
        g.preventDefault();
      }
    }, c.state.instancePrefix = "react-select-" + (c.props.instanceId || ++tj), c.state.selectValue = AC(u.value), u.menuIsOpen && c.state.selectValue.length) {
      var v = c.getFocusableOptionsWithIds(), h = c.buildFocusableOptions(), y = h.indexOf(c.state.selectValue[0]);
      c.state.focusableOptionsWithIds = v, c.state.focusedOption = h[y], c.state.focusedOptionId = nT(v, h[y]);
    }
    return c;
  }
  return bU(i, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && w_(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(c) {
      var v = this.props, h = v.isDisabled, y = v.menuIsOpen, g = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (g && !h && c.isDisabled || // ensure focus is on the Input when the menu opens
      g && y && !c.menuIsOpen) && this.focusInput(), g && h && !c.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !g && !h && c.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (w_(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(c, v) {
      this.props.onInputChange(c, v);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(c) {
      var v = this, h = this.state, y = h.selectValue, g = h.isFocused, S = this.buildFocusableOptions(), x = c === "first" ? 0 : S.length - 1;
      if (!this.props.isMulti) {
        var T = S.indexOf(y[0]);
        T > -1 && (x = T);
      }
      this.scrollToFocusedOptionOnUpdate = !(g && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: S[x],
        focusedOptionId: this.getFocusedOptionId(S[x])
      }, function() {
        return v.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(c) {
      var v = this.state, h = v.selectValue, y = v.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var g = h.indexOf(y);
        y || (g = -1);
        var S = h.length - 1, x = -1;
        if (h.length) {
          switch (c) {
            case "previous":
              g === 0 ? x = 0 : g === -1 ? x = S : x = g - 1;
              break;
            case "next":
              g > -1 && g < S && (x = g + 1);
              break;
          }
          this.setState({
            inputIsHidden: x !== -1,
            focusedValue: h[x]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", v = this.props.pageSize, h = this.state.focusedOption, y = this.getFocusableOptions();
      if (y.length) {
        var g = 0, S = y.indexOf(h);
        h || (S = -1), c === "up" ? g = S > 0 ? S - 1 : y.length - 1 : c === "down" ? g = (S + 1) % y.length : c === "pageup" ? (g = S - v, g < 0 && (g = 0)) : c === "pagedown" ? (g = S + v, g > y.length - 1 && (g = y.length - 1)) : c === "last" && (g = y.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: y[g],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(y[g])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(tT) : an(an({}, tT), this.props.theme) : tT;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var c = this.clearValue, v = this.cx, h = this.getStyles, y = this.getClassNames, g = this.getValue, S = this.selectOption, x = this.setValue, T = this.props, _ = T.isMulti, L = T.isRtl, M = T.options, U = this.hasValue();
      return {
        clearValue: c,
        cx: v,
        getStyles: h,
        getClassNames: y,
        getValue: g,
        hasValue: U,
        isMulti: _,
        isRtl: L,
        options: M,
        selectOption: S,
        selectProps: T,
        setValue: x,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var c = this.state.selectValue;
      return c.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var c = this.props, v = c.isClearable, h = c.isMulti;
      return v === void 0 ? h : v;
    }
  }, {
    key: "isOptionDisabled",
    value: function(c, v) {
      return C4(this.props, c, v);
    }
  }, {
    key: "isOptionSelected",
    value: function(c, v) {
      return E4(this.props, c, v);
    }
  }, {
    key: "filterOption",
    value: function(c, v) {
      return S4(this.props, c, v);
    }
  }, {
    key: "formatOptionLabel",
    value: function(c, v) {
      if (typeof this.props.formatOptionLabel == "function") {
        var h = this.props.inputValue, y = this.state.selectValue;
        return this.props.formatOptionLabel(c, {
          context: v,
          inputValue: h,
          selectValue: y
        });
      } else
        return this.getOptionLabel(c);
    }
  }, {
    key: "formatGroupLabel",
    value: function(c) {
      return this.props.formatGroupLabel(c);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var c = this.props, v = c.isDisabled, h = c.isSearchable, y = c.inputId, g = c.inputValue, S = c.tabIndex, x = c.form, T = c.menuIsOpen, _ = c.required, L = this.getComponents(), M = L.Input, U = this.state, B = U.inputIsHidden, H = U.ariaSelection, Y = this.commonProps, G = y || this.getElementId("input"), Q = an(an(an({
          "aria-autocomplete": "list",
          "aria-expanded": T,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": _,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, T && {
          "aria-controls": this.getElementId("listbox")
        }), !h && {
          "aria-readonly": !0
        }), this.hasValue() ? (H == null ? void 0 : H.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return h ? /* @__PURE__ */ k.createElement(M, vn({}, Y, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: G,
          innerRef: this.getInputRef,
          isDisabled: v,
          isHidden: B,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: S,
          form: x,
          type: "text",
          value: g
        }, Q)) : /* @__PURE__ */ k.createElement(IH, vn({
          id: G,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: IC,
          onFocus: this.onInputFocus,
          disabled: v,
          tabIndex: S,
          inputMode: "none",
          form: x,
          value: ""
        }, Q));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var c = this, v = this.getComponents(), h = v.MultiValue, y = v.MultiValueContainer, g = v.MultiValueLabel, S = v.MultiValueRemove, x = v.SingleValue, T = v.Placeholder, _ = this.commonProps, L = this.props, M = L.controlShouldRenderValue, U = L.isDisabled, B = L.isMulti, H = L.inputValue, Y = L.placeholder, G = this.state, Q = G.selectValue, W = G.focusedValue, oe = G.isFocused;
      if (!this.hasValue() || !M)
        return H ? null : /* @__PURE__ */ k.createElement(T, vn({}, _, {
          key: "placeholder",
          isDisabled: U,
          isFocused: oe,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), Y);
      if (B)
        return Q.map(function(re, me) {
          var Se = re === W, Ne = "".concat(c.getOptionLabel(re), "-").concat(c.getOptionValue(re));
          return /* @__PURE__ */ k.createElement(h, vn({}, _, {
            components: {
              Container: y,
              Label: g,
              Remove: S
            },
            isFocused: Se,
            isDisabled: U,
            key: Ne,
            index: me,
            removeProps: {
              onClick: function() {
                return c.removeValue(re);
              },
              onTouchEnd: function() {
                return c.removeValue(re);
              },
              onMouseDown: function(ze) {
                ze.preventDefault();
              }
            },
            data: re
          }), c.formatOptionLabel(re, "value"));
        });
      if (H)
        return null;
      var j = Q[0];
      return /* @__PURE__ */ k.createElement(x, vn({}, _, {
        data: j,
        isDisabled: U
      }), this.formatOptionLabel(j, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var c = this.getComponents(), v = c.ClearIndicator, h = this.commonProps, y = this.props, g = y.isDisabled, S = y.isLoading, x = this.state.isFocused;
      if (!this.isClearable() || !v || g || !this.hasValue() || S)
        return null;
      var T = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ k.createElement(v, vn({}, h, {
        innerProps: T,
        isFocused: x
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var c = this.getComponents(), v = c.LoadingIndicator, h = this.commonProps, y = this.props, g = y.isDisabled, S = y.isLoading, x = this.state.isFocused;
      if (!v || !S)
        return null;
      var T = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ k.createElement(v, vn({}, h, {
        innerProps: T,
        isDisabled: g,
        isFocused: x
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var c = this.getComponents(), v = c.DropdownIndicator, h = c.IndicatorSeparator;
      if (!v || !h)
        return null;
      var y = this.commonProps, g = this.props.isDisabled, S = this.state.isFocused;
      return /* @__PURE__ */ k.createElement(h, vn({}, y, {
        isDisabled: g,
        isFocused: S
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var c = this.getComponents(), v = c.DropdownIndicator;
      if (!v)
        return null;
      var h = this.commonProps, y = this.props.isDisabled, g = this.state.isFocused, S = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ k.createElement(v, vn({}, h, {
        innerProps: S,
        isDisabled: y,
        isFocused: g
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var c = this, v = this.getComponents(), h = v.Group, y = v.GroupHeading, g = v.Menu, S = v.MenuList, x = v.MenuPortal, T = v.LoadingMessage, _ = v.NoOptionsMessage, L = v.Option, M = this.commonProps, U = this.state.focusedOption, B = this.props, H = B.captureMenuScroll, Y = B.inputValue, G = B.isLoading, Q = B.loadingMessage, W = B.minMenuHeight, oe = B.maxMenuHeight, j = B.menuIsOpen, re = B.menuPlacement, me = B.menuPosition, Se = B.menuPortalTarget, Ne = B.menuShouldBlockScroll, Ge = B.menuShouldScrollIntoView, ze = B.noOptionsMessage, qe = B.onMenuScrollToTop, at = B.onMenuScrollToBottom;
      if (!j)
        return null;
      var st = function($e, lt) {
        var ot = $e.type, nt = $e.data, Rt = $e.isDisabled, ht = $e.isSelected, dt = $e.label, sn = $e.value, bn = U === nt, Ze = Rt ? void 0 : function() {
          return c.onOptionHover(nt);
        }, mn = Rt ? void 0 : function() {
          return c.selectOption(nt);
        }, fn = "".concat(c.getElementId("option"), "-").concat(lt), Gn = {
          id: fn,
          onClick: mn,
          onMouseMove: Ze,
          onMouseOver: Ze,
          tabIndex: -1,
          role: "option",
          "aria-selected": c.isAppleDevice ? void 0 : ht
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ k.createElement(L, vn({}, M, {
          innerProps: Gn,
          data: nt,
          isDisabled: Rt,
          isSelected: ht,
          key: fn,
          label: dt,
          type: ot,
          value: sn,
          isFocused: bn,
          innerRef: bn ? c.getFocusedOptionRef : void 0
        }), c.formatOptionLabel($e.data, "menu"));
      }, We;
      if (this.hasOptions())
        We = this.getCategorizedOptions().map(function(pe) {
          if (pe.type === "group") {
            var $e = pe.data, lt = pe.options, ot = pe.index, nt = "".concat(c.getElementId("group"), "-").concat(ot), Rt = "".concat(nt, "-heading");
            return /* @__PURE__ */ k.createElement(h, vn({}, M, {
              key: nt,
              data: $e,
              options: lt,
              Heading: y,
              headingProps: {
                id: Rt,
                data: pe.data
              },
              label: c.formatGroupLabel(pe.data)
            }), pe.options.map(function(ht) {
              return st(ht, "".concat(ot, "-").concat(ht.index));
            }));
          } else if (pe.type === "option")
            return st(pe, "".concat(pe.index));
        });
      else if (G) {
        var he = Q({
          inputValue: Y
        });
        if (he === null)
          return null;
        We = /* @__PURE__ */ k.createElement(T, M, he);
      } else {
        var ke = ze({
          inputValue: Y
        });
        if (ke === null)
          return null;
        We = /* @__PURE__ */ k.createElement(_, M, ke);
      }
      var _e = {
        minMenuHeight: W,
        maxMenuHeight: oe,
        menuPlacement: re,
        menuPosition: me,
        menuShouldScrollIntoView: Ge
      }, q = /* @__PURE__ */ k.createElement(iV, vn({}, M, _e), function(pe) {
        var $e = pe.ref, lt = pe.placerProps, ot = lt.placement, nt = lt.maxHeight;
        return /* @__PURE__ */ k.createElement(g, vn({}, M, _e, {
          innerRef: $e,
          innerProps: {
            onMouseDown: c.onMenuMouseDown,
            onMouseMove: c.onMenuMouseMove
          },
          isLoading: G,
          placement: ot
        }), /* @__PURE__ */ k.createElement(MH, {
          captureEnabled: H,
          onTopArrive: qe,
          onBottomArrive: at,
          lockEnabled: Ne
        }, function(Rt) {
          return /* @__PURE__ */ k.createElement(S, vn({}, M, {
            innerRef: function(dt) {
              c.getMenuListRef(dt), Rt(dt);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": M.isMulti,
              id: c.getElementId("listbox")
            },
            isLoading: G,
            maxHeight: nt,
            focusedOption: U
          }), We);
        }));
      });
      return Se || me === "fixed" ? /* @__PURE__ */ k.createElement(x, vn({}, M, {
        appendTo: Se,
        controlElement: this.controlRef,
        menuPlacement: re,
        menuPosition: me
      }), q) : q;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var c = this, v = this.props, h = v.delimiter, y = v.isDisabled, g = v.isMulti, S = v.name, x = v.required, T = this.state.selectValue;
      if (x && !this.hasValue() && !y)
        return /* @__PURE__ */ k.createElement(BH, {
          name: S,
          onFocus: this.onValueInputFocus
        });
      if (!(!S || y))
        if (g)
          if (h) {
            var _ = T.map(function(U) {
              return c.getOptionValue(U);
            }).join(h);
            return /* @__PURE__ */ k.createElement("input", {
              name: S,
              type: "hidden",
              value: _
            });
          } else {
            var L = T.length > 0 ? T.map(function(U, B) {
              return /* @__PURE__ */ k.createElement("input", {
                key: "i-".concat(B),
                name: S,
                type: "hidden",
                value: c.getOptionValue(U)
              });
            }) : /* @__PURE__ */ k.createElement("input", {
              name: S,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ k.createElement("div", null, L);
          }
        else {
          var M = T[0] ? this.getOptionValue(T[0]) : "";
          return /* @__PURE__ */ k.createElement("input", {
            name: S,
            type: "hidden",
            value: M
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var c = this.commonProps, v = this.state, h = v.ariaSelection, y = v.focusedOption, g = v.focusedValue, S = v.isFocused, x = v.selectValue, T = this.getFocusableOptions();
      return /* @__PURE__ */ k.createElement(SH, vn({}, c, {
        id: this.getElementId("live-region"),
        ariaSelection: h,
        focusedOption: y,
        focusedValue: g,
        isFocused: S,
        selectValue: x,
        focusableOptions: T,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var c = this.getComponents(), v = c.Control, h = c.IndicatorsContainer, y = c.SelectContainer, g = c.ValueContainer, S = this.props, x = S.className, T = S.id, _ = S.isDisabled, L = S.menuIsOpen, M = this.state.isFocused, U = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ k.createElement(y, vn({}, U, {
        className: x,
        innerProps: {
          id: T,
          onKeyDown: this.onKeyDown
        },
        isDisabled: _,
        isFocused: M
      }), this.renderLiveRegion(), /* @__PURE__ */ k.createElement(v, vn({}, U, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: _,
        isFocused: M,
        menuIsOpen: L
      }), /* @__PURE__ */ k.createElement(g, vn({}, U, {
        isDisabled: _
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ k.createElement(h, vn({}, U, {
        isDisabled: _
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(c, v) {
      var h = v.prevProps, y = v.clearFocusValueOnUpdate, g = v.inputIsHiddenAfterUpdate, S = v.ariaSelection, x = v.isFocused, T = v.prevWasFocused, _ = v.instancePrefix, L = c.options, M = c.value, U = c.menuIsOpen, B = c.inputValue, H = c.isMulti, Y = AC(M), G = {};
      if (h && (M !== h.value || L !== h.options || U !== h.menuIsOpen || B !== h.inputValue)) {
        var Q = U ? KH(c, Y) : [], W = U ? V_(pC(c, Y), "".concat(_, "-option")) : [], oe = y ? qH(v, Y) : null, j = ej(v, Q), re = nT(W, j);
        G = {
          selectValue: Y,
          focusedOption: j,
          focusedOptionId: re,
          focusableOptionsWithIds: W,
          focusedValue: oe,
          clearFocusValueOnUpdate: !1
        };
      }
      var me = g != null && c !== h ? {
        inputIsHidden: g,
        inputIsHiddenAfterUpdate: void 0
      } : {}, Se = S, Ne = x && T;
      return x && !Ne && (Se = {
        value: Zy(H, Y, Y[0] || null),
        options: Y,
        action: "initial-input-focus"
      }, Ne = !T), (S == null ? void 0 : S.action) === "initial-input-focus" && (Se = null), an(an(an({}, G), me), {}, {
        prevProps: c,
        ariaSelection: Se,
        prevWasFocused: Ne
      });
    }
  }]), i;
}(k.Component);
R4.defaultProps = QH;
var nj = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function rj(t) {
  var r = t.defaultInputValue, i = r === void 0 ? "" : r, u = t.defaultMenuIsOpen, c = u === void 0 ? !1 : u, v = t.defaultValue, h = v === void 0 ? null : v, y = t.inputValue, g = t.menuIsOpen, S = t.onChange, x = t.onInputChange, T = t.onMenuClose, _ = t.onMenuOpen, L = t.value, M = pd(t, nj), U = k.useState(y !== void 0 ? y : i), B = Sp(U, 2), H = B[0], Y = B[1], G = k.useState(g !== void 0 ? g : c), Q = Sp(G, 2), W = Q[0], oe = Q[1], j = k.useState(L !== void 0 ? L : h), re = Sp(j, 2), me = re[0], Se = re[1], Ne = k.useCallback(function(he, ke) {
    typeof S == "function" && S(he, ke), Se(he);
  }, [S]), Ge = k.useCallback(function(he, ke) {
    var _e;
    typeof x == "function" && (_e = x(he, ke)), Y(_e !== void 0 ? _e : he);
  }, [x]), ze = k.useCallback(function() {
    typeof _ == "function" && _(), oe(!0);
  }, [_]), qe = k.useCallback(function() {
    typeof T == "function" && T(), oe(!1);
  }, [T]), at = y !== void 0 ? y : H, st = g !== void 0 ? g : W, We = L !== void 0 ? L : me;
  return an(an({}, M), {}, {
    inputValue: at,
    menuIsOpen: st,
    onChange: Ne,
    onInputChange: Ge,
    onMenuClose: qe,
    onMenuOpen: ze,
    value: We
  });
}
var aj = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"], j_ = function() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 ? arguments[1] : void 0, u = arguments.length > 2 ? arguments[2] : void 0, c = String(r).toLowerCase(), v = String(u.getOptionValue(i)).toLowerCase(), h = String(u.getOptionLabel(i)).toLowerCase();
  return v === c || h === c;
}, rT = {
  formatCreateLabel: function(r) {
    return 'Create "'.concat(r, '"');
  },
  isValidNewOption: function(r, i, u, c) {
    return !(!r || i.some(function(v) {
      return j_(r, v, c);
    }) || u.some(function(v) {
      return j_(r, v, c);
    }));
  },
  getNewOptionData: function(r, i) {
    return {
      label: i,
      value: r,
      __isNew__: !0
    };
  }
};
function ij(t) {
  var r = t.allowCreateWhileLoading, i = r === void 0 ? !1 : r, u = t.createOptionPosition, c = u === void 0 ? "last" : u, v = t.formatCreateLabel, h = v === void 0 ? rT.formatCreateLabel : v, y = t.isValidNewOption, g = y === void 0 ? rT.isValidNewOption : y, S = t.getNewOptionData, x = S === void 0 ? rT.getNewOptionData : S, T = t.onCreateOption, _ = t.options, L = _ === void 0 ? [] : _, M = t.onChange, U = pd(t, aj), B = U.getOptionValue, H = B === void 0 ? m4 : B, Y = U.getOptionLabel, G = Y === void 0 ? v4 : Y, Q = U.inputValue, W = U.isLoading, oe = U.isMulti, j = U.value, re = U.name, me = k.useMemo(function() {
    return g(Q, AC(j), L, {
      getOptionValue: H,
      getOptionLabel: G
    }) ? x(Q, h(Q)) : void 0;
  }, [h, x, G, H, Q, g, L, j]), Se = k.useMemo(function() {
    return (i || !W) && me ? c === "first" ? [me].concat(jg(L)) : [].concat(jg(L), [me]) : L;
  }, [i, c, W, me, L]), Ne = k.useCallback(function(Ge, ze) {
    if (ze.action !== "select-option")
      return M(Ge, ze);
    var qe = Array.isArray(Ge) ? Ge : [Ge];
    if (qe[qe.length - 1] === me) {
      if (T)
        T(Q);
      else {
        var at = x(Q, Q), st = {
          action: "create-option",
          name: re,
          option: at
        };
        M(Zy(oe, [].concat(jg(AC(j)), [at]), at), st);
      }
      return;
    }
    M(Ge, ze);
  }, [x, Q, oe, re, me, T, M, j]);
  return an(an({}, U), {}, {
    options: Se,
    onChange: Ne
  });
}
var oj = /* @__PURE__ */ k.forwardRef(function(t, r) {
  var i = rj(t), u = ij(i);
  return /* @__PURE__ */ k.createElement(R4, vn({
    ref: r
  }, u));
}), T4 = oj;
const lj = (t, r) => {
  const i = r.split(k8), u = i.length > 1 ? i.pop() : void 0, c = u ? ` (${u})` : "";
  return `${t}${c}`;
}, w4 = (t = [], r) => t.filter((i) => {
  const u = i[l_];
  return u !== r && !(u != null && u.includes(L8));
}).map((i) => {
  var y;
  const u = i[l_], c = i[D8] ?? i[M8], v = ((y = c == null ? void 0 : c[0]) == null ? void 0 : y[P8]) ?? "", h = lj(v, u);
  return {
    value: {
      label: v,
      // used as a basic unformatted label in Preview and similar components
      uri: u
    },
    label: h,
    // used for displaying a label with a code in Simple Lookups
    __isNew__: !1
  };
}), I4 = (t, r) => Object.values(t).find(({ field: i }) => i.uri === r), A4 = (t, r) => {
  if (!r)
    return t;
  let i = t;
  const c = I4(E2, r);
  if (c) {
    const v = Object.values(c.data).map(({ uri: h }) => h);
    i = t.filter(({ value: h }) => v.includes(h.uri));
  }
  return i;
}, sj = (t, r, i) => {
  if (!t)
    return;
  if (!i || !r)
    return t;
  let u = t;
  const v = I4(E2, r);
  if (v) {
    const h = Object.values(v.data);
    u = t.filter(
      ({ value: y }) => h.find((g) => {
        const S = g.parentBlock, x = g.uri === y.uri;
        return S ? S.bfLiteUri === i && x : x;
      })
    );
  }
  return u;
}, uj = () => {
  const { lookupCacheService: t } = xm();
  return { getLookupData: t.getAll, loadLookupData: async (u, c) => {
    var v;
    try {
      const h = await RO(u);
      if (!h)
        return null;
      const y = w4(h, u), g = A4(y, c), S = g == null ? void 0 : g.toSorted(NO);
      return (v = t.save) == null || v.call(t, u, S), S;
    } catch (h) {
      const y = h instanceof Error ? h.message : String(h);
      throw new Error(y);
    }
  } };
}, N4 = () => {
  const t = k.useRef(null), [r, i] = k.useState(!1), u = new IntersectionObserver(
    ([c]) => {
      var v;
      i(!c.isIntersecting && ((v = c == null ? void 0 : c.boundingClientRect) == null ? void 0 : v.bottom) > window.innerHeight);
    },
    { root: document.getElementById(iO), rootMargin: kF }
  );
  return k.useEffect(() => {
    var v;
    const c = (v = t == null ? void 0 : t.current) == null ? void 0 : v.inputRef;
    return c && u.observe(c), () => {
      u.disconnect();
    };
  }, [t]), { simpleLookupRef: t, forceDisplayOptionsAtTheTop: r };
}, _4 = (t) => /* @__PURE__ */ N.jsx(c0.DropdownIndicator, { ...t, children: /* @__PURE__ */ N.jsx(fO, { className: "simple-lookup__dropdown-indicator__icon" }) });
const O4 = (t) => /* @__PURE__ */ N.jsx(c0.MultiValueRemove, { ...t, children: /* @__PURE__ */ N.jsx(qs, { height: "12", width: "12", className: "simple-lookup__multi-value__remove__icon" }) }), L4 = (t) => /* @__PURE__ */ N.jsx(c0.ClearIndicator, { ...t, children: /* @__PURE__ */ N.jsx(qs, { height: "12", width: "12", className: "simple-lookup__clear-indicator__icon" }) }), D4 = {
  container: (t, r) => ({
    ...t,
    width: "100%",
    backgroundColor: r.isDisabled ? "#ebebe4" : "transparent"
  }),
  control: (t, r) => ({
    ...t,
    minHeight: "1.5rem",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: r.isFocused ? "#3e75cf" : "rgba(0, 0, 0, 0.42)",
    borderRadius: 0,
    boxShadow: r.isFocused ? "0 0 0 1px #3e75cf, 0 0 0 1px #3e75cf, 0 0 0 4px #d8e3f5" : "none"
  }),
  placeholder: (t) => ({
    ...t,
    paddingLeft: "7px",
    color: "#6E7277"
  }),
  valueContainer: (t) => ({
    ...t,
    display: "flex",
    alignItems: "center",
    padding: "0",
    lineHeight: "auto"
  }),
  multiValue: (t) => ({
    ...t,
    alignItems: "center",
    margin: "1px 2px",
    border: "1px solid rgba(0, 0, 0, 0.2)",
    borderRadius: 0,
    backgroundColor: "#efefef"
  }),
  multiValueLabel: (t) => ({
    ...t,
    paddingTop: 0,
    paddingBottom: 0,
    lineHeight: "1.125rem",
    fontSize: "1rem"
  }),
  multiValueRemove: (t) => ({
    ...t,
    padding: "0.25rem",
    borderRadius: 0
  }),
  indicatorSeparator: (t) => ({
    ...t,
    width: 0
  }),
  clearIndicator: (t) => ({
    ...t,
    padding: 0
  }),
  dropdownIndicator: (t) => ({
    ...t,
    padding: "0 0.5rem"
  }),
  input: (t) => ({
    ...t,
    display: "flex",
    gridArea: "auto",
    width: 0,
    margin: 0,
    padding: "0 0 0 3px"
  }),
  indicatorsContainer: (t) => ({
    ...t,
    padding: 0
  }),
  menu: (t) => ({
    ...t,
    marginTop: "7px",
    border: "1px solid #ccc",
    borderRadius: 0,
    boxShadow: "0 4px 32px rgba(0, 0, 0, 0.3)"
  }),
  menuList: (t) => ({
    ...t,
    padding: "7px"
  }),
  option: (t, r) => ({
    ...t,
    backgroundColor: r.isFocused ? "rgba(37, 118, 195, 0.2)" : "transparent"
  })
}, cj = () => /* @__PURE__ */ N.jsx(mt, { id: "ld.loading" }), fj = ({
  uri: t,
  uuid: r,
  id: i,
  value: u,
  htmlId: c,
  onChange: v,
  parentUri: h,
  isDisabled: y = !1,
  propertyUri: g,
  parentBlockUri: S
}) => {
  var j;
  const { getLookupData: x, loadLookupData: T } = uj(), _ = ((j = x()) == null ? void 0 : j[t]) || [], L = sj(_, g, S), { addStatusMessagesItem: M } = Si(), { simpleLookupRef: U, forceDisplayOptionsAtTheTop: B } = N4(), [H, Y] = k.useState(
    (u == null ? void 0 : u.map(({ label: re = "", meta: { uri: me, basicLabel: Se } = {} }) => ({
      value: { label: Se ?? re, uri: me },
      label: re,
      __isNew__: !1
    }))) || []
  ), [G, Q] = k.useState(!1), W = async () => {
    if (!(L != null && L.length)) {
      Q(!0);
      try {
        await T(t, g);
      } catch (re) {
        console.error("Cannot load data for the Lookup:", re), M == null || M(Ei.createMessage(Tr.error, "ld.cantLoadSimpleLookupData"));
      } finally {
        Q(!1);
      }
    }
  }, oe = (re) => {
    const me = re.map(({ label: Se, value: Ne }) => ({
      label: Se,
      meta: {
        uri: Ne == null ? void 0 : Ne.uri,
        parentUri: h,
        basicLabel: Ne.label
      }
    }));
    v(r, me), Y([...re]);
  };
  return /* @__PURE__ */ N.jsx(
    T4,
    {
      id: i,
      "aria-labelledby": c,
      ref: U,
      className: "edit-section-field-input simple-lookup",
      classNamePrefix: "simple-lookup",
      "data-testid": "simple-lookup",
      isSearchable: !0,
      isClearable: !0,
      openMenuOnFocus: !0,
      isLoading: G,
      isMulti: !0,
      menuPlacement: B ? "top" : "auto",
      components: { DropdownIndicator: _4, MultiValueRemove: O4, ClearIndicator: L4 },
      isDisabled: y || !vO,
      options: L,
      onMenuOpen: W,
      isValidNewOption: () => !1,
      onChange: oe,
      value: H,
      placeholder: /* @__PURE__ */ N.jsx(mt, { id: "ld.select" }),
      loadingMessage: cj,
      inputId: "creatable-select-input",
      styles: D4,
      filterOption: j2({
        ignoreCase: !0,
        ignoreAccents: !0,
        matchFrom: "any",
        trim: !0,
        stringify: ({ label: re }) => re
      })
    }
  );
}, dj = ({
  facet: t,
  hasMappedSourceData: r
}) => {
  var y;
  const { sourceData: i, facetsData: u } = Eo(), { formatMessage: c } = La(), v = t && u ? (y = u == null ? void 0 : u[t]) == null ? void 0 : y.values : void 0;
  let h = [];
  return v && (h = v.reduce((g, { id: S, totalRecords: x }) => {
    const T = i == null ? void 0 : i.find(({ id: M }) => M === S), _ = r ? T == null ? void 0 : T.name : S, L = (_ == null ? void 0 : _.trim()) ?? c({ id: "ld.notSpecified" });
    return g.push({
      label: L,
      subLabel: `(${x})`,
      value: {
        id: S || ""
      }
    }), g;
  }, [])), { options: h };
}, pj = (t) => {
  const { label: r, subLabel: i } = t.data;
  return /* @__PURE__ */ N.jsxs(c0.Option, { ...t, children: [
    /* @__PURE__ */ N.jsx("div", { className: "select-option-label", children: r }),
    /* @__PURE__ */ N.jsx("div", { className: "select-option-sebLabel", children: i })
  ] });
}, hj = ({
  facet: t,
  onChange: r,
  hasMappedSourceData: i,
  isDisabled: u = !1,
  excludedOptions: c
}) => {
  const [v, h] = k.useState(), { simpleLookupRef: y, forceDisplayOptionsAtTheTop: g } = N4(), { options: S } = dj({ facet: t, hasMappedSourceData: i, excludedOptions: c }), x = (T) => {
    const _ = T.map(() => ({}));
    r(t, _), h([...T]);
  };
  return /* @__PURE__ */ N.jsx(
    T4,
    {
      id: `fiter-simple-lookup-${t}`,
      ref: y,
      className: "filter-section-field-input simple-lookup",
      classNamePrefix: "simple-lookup",
      isSearchable: !0,
      isClearable: !0,
      openMenuOnFocus: !0,
      isMulti: !0,
      menuPlacement: g ? "top" : "auto",
      components: { DropdownIndicator: _4, MultiValueRemove: O4, ClearIndicator: L4, Option: pj },
      isDisabled: u || !vO,
      options: S,
      onChange: x,
      value: v,
      placeholder: /* @__PURE__ */ N.jsx(mt, { id: "ld.select" }),
      inputId: "creatable-select-input",
      styles: D4,
      filterOption: j2({
        ignoreCase: !0,
        ignoreAccents: !0,
        matchFrom: "any",
        trim: !0,
        stringify: ({ label: T }) => T
      })
    }
  );
}, zC = (t) => /* @__PURE__ */ k.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M14.7 9.4L4.9 19c-.8.8-.8 2 0 2.8s2 .8 2.8 0l8.4-8.2 8.2 8.2c.8.8 2 .8 2.8 0s.8-2 0-2.8l-9.6-9.6c-.9-.8-2.1-.8-2.8 0z" }));
const vj = ({ id: t, title: r, groupId: i, defaultState: u = !1, onToggle: c, children: v }) => {
  const [h, y] = k.useState(u), g = t ?? i, S = g ? `accordion-toggle-${g}` : "", x = g ? `accordion-contents-${g}` : "", T = () => {
    const _ = !h;
    y(_), c == null || c(i, _);
  };
  return /* @__PURE__ */ N.jsxs("section", { className: "accordion", children: [
    /* @__PURE__ */ N.jsx("div", { className: "accordion-toggle", "data-testid": `accordion-toggle ${S}`, children: /* @__PURE__ */ N.jsx(
      Dn,
      {
        type: Mn.Text,
        "aria-expanded": h,
        onClick: T,
        className: "accordion-toggle-button",
        "data-testid": "accordion-toggle-button",
        children: /* @__PURE__ */ N.jsxs("div", { className: "accordion-toggle-container", children: [
          /* @__PURE__ */ N.jsx(zC, { className: In({ icon: !0, "icon-collapsed": !h }) }),
          /* @__PURE__ */ N.jsx("div", { children: r })
        ] })
      }
    ) }),
    /* @__PURE__ */ N.jsx("div", { "data-testid": `accordion-contents ${x}`, hidden: !h, children: v })
  ] });
};
const G_ = ({
  id: t,
  value: r,
  onChange: i,
  name: u,
  placeholder: c,
  "data-testid": v
}) => {
  const h = (y) => {
    i == null || i(y.target.value);
  };
  return /* @__PURE__ */ N.jsx("div", { className: "date-picker", children: /* @__PURE__ */ N.jsx(
    "input",
    {
      id: t,
      "data-testid": v ?? `date-picker-input-${t}`,
      type: "date",
      className: "date-picker-input",
      value: r,
      onChange: h,
      name: u,
      placeholder: c
    }
  ) });
};
const z_ = "YYYY-MM-DD", mj = ({ facet: t, onSubmit: r }) => {
  const [i, u] = k.useState(""), [c, v] = k.useState(""), h = () => {
    t && (r == null || r(t, { dateStart: i, dateEnd: c }));
  }, y = `${t}-start`, g = `${t}-end`;
  return /* @__PURE__ */ N.jsxs("div", { className: "date-range", children: [
    /* @__PURE__ */ N.jsxs("div", { className: "date-range-group", children: [
      /* @__PURE__ */ N.jsx("p", { className: "date-range-label", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.from" }) }),
      /* @__PURE__ */ N.jsx(
        G_,
        {
          id: y,
          "data-testid": y,
          placeholder: z_,
          name: "dateStart",
          value: i,
          onChange: u
        }
      )
    ] }),
    /* @__PURE__ */ N.jsxs("div", { className: "date-range-group", children: [
      /* @__PURE__ */ N.jsx("p", { className: "date-range-label", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.to" }) }),
      /* @__PURE__ */ N.jsx(
        G_,
        {
          id: g,
          "data-testid": g,
          placeholder: z_,
          name: "dateEnd",
          value: c,
          onChange: v
        }
      )
    ] }),
    /* @__PURE__ */ N.jsx(Dn, { "data-testid": `${t}-apply`, type: Mn.Primary, onClick: h, children: /* @__PURE__ */ N.jsx(mt, { id: "ld.apply" }) })
  ] });
}, gj = () => {
  const { filters: t, getSearchFacetsData: r } = dd(), { facets: i, onChangeLimiters: u, onChangeLimitersMulti: c, onChange: v } = vU(), h = t.length - 1;
  return /* @__PURE__ */ N.jsx("div", { className: "controls", children: t.map(
    ({ id: y, type: g, labelId: S, children: x, facet: T, isOpen: _, hasExternalDataSource: L, hasMappedSourceData: M, excludedOptions: U }, B) => {
      const H = g === zl.Single, Y = g === zl.Single || g === zl.Multi;
      return /* @__PURE__ */ N.jsxs(k.Fragment, { children: [
        /* @__PURE__ */ N.jsxs(
          vj,
          {
            id: y,
            title: /* @__PURE__ */ N.jsx(mt, { id: S }),
            defaultState: _,
            onToggle: L ? r : void 0,
            groupId: T ?? S,
            children: [
              Y && /* @__PURE__ */ N.jsx("div", { onChange: H ? u : c, children: x == null ? void 0 : x.map(({ id: G, name: Q, type: W, labelId: oe }) => {
                var j;
                return /* @__PURE__ */ N.jsxs("label", { htmlFor: G, children: [
                  /* @__PURE__ */ N.jsx(
                    "input",
                    {
                      checked: H ? i[Q] === G : (j = i[Q]) == null ? void 0 : j.includes(G),
                      name: Q,
                      id: G,
                      type: W,
                      onChange: v
                    }
                  ),
                  /* @__PURE__ */ N.jsx(mt, { id: oe })
                ] }, G);
              }) }),
              g === zl.Lookup && /* @__PURE__ */ N.jsx(
                hj,
                {
                  facet: T,
                  onChange: () => {
                  },
                  hasMappedSourceData: M,
                  excludedOptions: U
                }
              ),
              g === zl.DateRange && /* @__PURE__ */ N.jsx(mj, { facet: T, onSubmit: () => {
              } })
            ]
          }
        ),
        B !== h && /* @__PURE__ */ N.jsx("hr", {})
      ] }, S);
    }
  ) });
};
const bj = ({
  value: t,
  onChange: r,
  rows: i = 1,
  name: u = "",
  ariaLabel: c,
  id: v,
  className: h,
  "data-testid": y,
  fullWidth: g,
  role: S
}) => /* @__PURE__ */ N.jsx(
  "textarea",
  {
    id: v,
    rows: i,
    name: u,
    "aria-label": c,
    role: S,
    value: t,
    onChange: r,
    className: In("textarea", { "textarea-full-width": g }, h),
    "data-testid": y
  }
), yj = ({ message: t, onClear: r, clearAfter: i = 1e3 }) => {
  const [u, c] = k.useState(t);
  return k.useEffect(() => {
    c(t);
    let v;
    return i > 0 && (v = setTimeout(() => {
      c(""), r == null || r();
    }, i)), () => {
      v && clearTimeout(v);
    };
  }, [t, i]), /* @__PURE__ */ N.jsx(
    "div",
    {
      role: "status",
      "aria-live": "polite",
      "aria-atomic": "true",
      style: { position: "absolute", left: "-9999px" },
      children: u
    }
  );
};
const Cj = ({ className: t, fullWidth: r, children: i }) => /* @__PURE__ */ N.jsx("div", { role: "tablist", className: In("button-group", { "full-width": r }, t), children: i });
const Ej = ({ onChangeSegment: t }) => {
  var h;
  const { primarySegments: r, navigationSegment: i } = dd(), { value: u, set: c } = i, v = (y) => {
    y !== u && (c(y), t == null || t(y));
  };
  return /* @__PURE__ */ N.jsx(Cj, { className: "search-segments", fullWidth: !0, children: r && ((h = Object.entries(r)) == null ? void 0 : h.map(([y, { labelId: g }]) => {
    const S = u === y;
    return /* @__PURE__ */ N.jsx(
      Dn,
      {
        type: S ? Mn.Highlighted : Mn.Primary,
        "aria-selected": S,
        role: "tab",
        className: "search-segment-button",
        onClick: () => v(y),
        "data-testid": `id-search-segment-button-${y}`,
        children: /* @__PURE__ */ N.jsx(mt, { id: g })
      },
      `${y}-${g}`
    );
  })) });
}, Sj = (t) => /* @__PURE__ */ k.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("g", { clipPath: "url(#clip0_2944_109491)" }, /* @__PURE__ */ k.createElement("path", { d: "M6 0C2.68548 0 0 2.68548 0 6C0 9.31452 2.68548 12 6 12C9.31452 12 12 9.31452 12 6C12 2.68548 9.31452 0 6 0ZM8.94194 7.575C9.05565 7.68871 9.05565 7.87258 8.94194 7.98629L7.98387 8.94194C7.87016 9.05565 7.68629 9.05565 7.57258 8.94194L6 7.35484L4.425 8.94194C4.31129 9.05565 4.12742 9.05565 4.01371 8.94194L3.05806 7.98387C2.94435 7.87016 2.94435 7.68629 3.05806 7.57258L4.64516 6L3.05806 4.425C2.94435 4.31129 2.94435 4.12742 3.05806 4.01371L4.01613 3.05565C4.12984 2.94194 4.31371 2.94194 4.42742 3.05565L6 4.64516L7.575 3.05806C7.68871 2.94435 7.87258 2.94435 7.98629 3.05806L8.94435 4.01613C9.05806 4.12984 9.05806 4.31371 8.94435 4.42742L7.35484 6L8.94194 7.575Z", fill: "black" })), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", { id: "clip0_2944_109491" }, /* @__PURE__ */ k.createElement("rect", { width: 12, height: 12, fill: "white" }))));
const xj = ({ submitSearch: t, changeSegment: r, clearValues: i }) => {
  const { formatMessage: u } = La(), {
    isVisibleSearchByControl: c,
    isVisibleAdvancedSearch: v,
    isVisibleFilters: h,
    isVisibleSegments: y,
    hasMultilineSearchInput: g,
    searchByControlOptions: S,
    hasSearchParams: x,
    defaultSearchBy: T,
    navigationSegment: _
  } = dd(), {
    searchBy: L,
    setSearchBy: M,
    query: U,
    setQuery: B,
    setMessage: H,
    setNavigationState: Y,
    resetFacets: G,
    setFacetsBySegments: Q,
    resetSelectedInstances: W
  } = Eo(), { isSearchPaneCollapsed: oe, setIsSearchPaneCollapsed: j, setIsAdvancedSearchOpen: re, resetFullDisplayComponentType: me } = Qa(), { resetPreviewContent: Se } = Ea(), [Ne, Ge] = qc(), [ze, qe] = k.useState(""), at = Ne.get(Wo.Query), st = !U && !at, We = S && (_ != null && _.value) ? S[_.value] : Object.values(Yg), he = ({ target: { value: q } }) => {
    H(""), B(q);
  }, ke = () => {
    i(), G(), M(T);
  }, _e = () => {
    ke(), Se(), me(), W(), x && Ge({}), x && Y({}), qe(u({ id: "ld.aria.filters.reset.announce" }));
  };
  return k.useEffect(() => {
    ke(), Q(uO);
  }, []), k.useEffect(() => () => j(!1), []), !oe && /* @__PURE__ */ N.jsxs("div", { className: "search-pane", role: "region", "aria-labelledby": "search-pane-header-title", children: [
    /* @__PURE__ */ N.jsxs("div", { className: "search-pane-header", children: [
      /* @__PURE__ */ N.jsx("h2", { id: "search-pane-header-title", className: "search-pane-header-title", children: /* @__PURE__ */ N.jsx(mt, { id: h ? "ld.searchAndFilter" : "ld.search" }) }),
      /* @__PURE__ */ N.jsx(
        Dn,
        {
          className: "close-ctl",
          onClick: () => j(!0),
          ariaLabel: u({ id: "ld.aria.searchPane.close" }),
          children: /* @__PURE__ */ N.jsx(zC, {})
        }
      )
    ] }),
    /* @__PURE__ */ N.jsxs("div", { className: "search-pane-content", children: [
      y && /* @__PURE__ */ N.jsx(Ej, { onChangeSegment: r }),
      /* @__PURE__ */ N.jsxs("div", { className: "inputs", children: [
        c && /* @__PURE__ */ N.jsx(
          Qy,
          {
            withIntl: !0,
            id: "id-search-select",
            "data-testid": "id-search-select",
            className: "select-input",
            value: L,
            options: We,
            onChange: ({ value: q }) => M(q),
            ariaLabel: u({ id: "ld.aria.filters.select" })
          }
        ),
        g ? /* @__PURE__ */ N.jsx(
          bj,
          {
            id: "id-search-textarea",
            className: "select-textarea",
            value: U,
            onChange: he,
            "data-testid": "id-search-textarea",
            fullWidth: !0,
            ariaLabel: u({ id: "ld.aria.filters.textbox" })
          }
        ) : /* @__PURE__ */ N.jsx(
          BC,
          {
            id: "id-search-input",
            type: "text",
            value: U,
            onChange: he,
            className: "text-input",
            onPressEnter: t,
            "data-testid": "id-search-input",
            ariaLabel: u({ id: "ld.aria.filters.textbox" })
          }
        )
      ] }),
      /* @__PURE__ */ N.jsx(
        Dn,
        {
          "data-testid": "id-search-button",
          type: Mn.Highlighted,
          className: "search-button primary-search",
          onClick: t,
          disabled: !U,
          children: /* @__PURE__ */ N.jsx(mt, { id: "ld.search" })
        }
      ),
      /* @__PURE__ */ N.jsxs("div", { className: In(["meta-controls", !v && "meta-controls-centered"]), children: [
        /* @__PURE__ */ N.jsx(
          Dn,
          {
            type: Mn.Text,
            className: "search-button",
            onClick: _e,
            prefix: /* @__PURE__ */ N.jsx(Sj, {}),
            disabled: st,
            "data-testid": "id-search-reset-button",
            ariaLabel: u({ id: "ld.aria.filters.reset" }),
            children: /* @__PURE__ */ N.jsx(mt, { id: "ld.reset" })
          }
        ),
        /* @__PURE__ */ N.jsx(yj, { message: ze, onClear: () => qe("") }),
        v && /* @__PURE__ */ N.jsx(
          Dn,
          {
            type: Mn.Link,
            className: "search-button",
            onClick: () => re((q) => !q),
            children: /* @__PURE__ */ N.jsx(mt, { id: "ld.advanced" })
          }
        )
      ] }),
      h && /* @__PURE__ */ N.jsx(gj, {})
    ] })
  ] });
}, M4 = (t) => /* @__PURE__ */ k.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("g", { clipPath: "url(#clip0_4828_8436)" }, /* @__PURE__ */ k.createElement("path", { d: "M6.0015 12.9586C6.00184 13.1158 6.04844 13.2693 6.1355 13.4001L6.563 14.0424C6.69375 14.2401 6.99225 14.3994 7.229 14.3994H8.7715C9.00825 14.3994 9.30675 14.2401 9.4375 14.0424L9.86475 13.4001C9.94597 13.2665 9.99246 13.1148 10 12.9586V12.0001H6L6.0015 12.9586ZM7.98625 1.60012C5.436 1.60787 3.6 3.67512 3.6 6.00012C3.59851 7.06536 3.98572 8.09454 4.689 8.89462C5.102 9.36587 5.748 10.3501 5.99425 11.1806C5.99425 11.1876 5.996 11.1939 5.997 11.2001H10.003C10.003 11.1939 10.0048 11.1876 10.0058 11.1806C10.252 10.3501 10.898 9.36587 11.311 8.89462C12.0143 8.09454 12.4015 7.06536 12.4 6.00012C12.4 3.56587 10.4228 1.59237 7.98625 1.60012ZM8 4.00012C7.46975 4.00072 6.96139 4.21162 6.58644 4.58656C6.2115 4.96151 6.0006 5.46987 6 6.00012C6 6.10621 5.95786 6.20795 5.88284 6.28296C5.80783 6.35798 5.70609 6.40012 5.6 6.40012C5.49391 6.40012 5.39217 6.35798 5.31716 6.28296C5.24214 6.20795 5.2 6.10621 5.2 6.00012C5.20079 5.25776 5.49605 4.54603 6.02098 4.0211C6.54591 3.49617 7.25764 3.20091 8 3.20012C8.10609 3.20012 8.20783 3.24226 8.28284 3.31728C8.35786 3.39229 8.4 3.49403 8.4 3.60012C8.4 3.70621 8.35786 3.80795 8.28284 3.88296C8.20783 3.95798 8.10609 4.00012 8 4.00012ZM2.8 6.40012C2.8 6.24099 2.73679 6.08838 2.62426 5.97586C2.51174 5.86333 2.35913 5.80012 2.2 5.80012H0.6C0.44087 5.80012 0.288258 5.86333 0.175736 5.97586C0.0632141 6.08838 0 6.24099 0 6.40012C0 6.55925 0.0632141 6.71186 0.175736 6.82438C0.288258 6.93691 0.44087 7.00012 0.6 7.00012H2.2C2.35913 7.00012 2.51174 6.93691 2.62426 6.82438C2.73679 6.71186 2.8 6.55925 2.8 6.40012ZM15.4 5.80012H13.8C13.6409 5.80012 13.4883 5.86333 13.3757 5.97586C13.2632 6.08838 13.2 6.24099 13.2 6.40012C13.2 6.55925 13.2632 6.71186 13.3757 6.82438C13.4883 6.93691 13.6409 7.00012 13.8 7.00012H15.4C15.5591 7.00012 15.7117 6.93691 15.8243 6.82438C15.9368 6.71186 16 6.55925 16 6.40012C16 6.24099 15.9368 6.08838 15.8243 5.97586C15.7117 5.86333 15.5591 5.80012 15.4 5.80012ZM3.277 2.98062L1.8915 2.18062C1.82321 2.1395 1.74741 2.11241 1.66853 2.10092C1.58965 2.08942 1.50926 2.09376 1.43208 2.11369C1.35489 2.13361 1.28245 2.16871 1.21899 2.21694C1.15552 2.26517 1.1023 2.32557 1.06244 2.3946C1.02257 2.46363 0.996865 2.53991 0.986813 2.61899C0.976761 2.69807 0.982568 2.77835 1.00389 2.85516C1.02522 2.93197 1.06164 3.00376 1.11102 3.06634C1.1604 3.12891 1.22175 3.18102 1.2915 3.21962L2.677 4.01962C2.74529 4.06074 2.82109 4.08783 2.89997 4.09932C2.97885 4.11082 3.05924 4.10648 3.13642 4.08655C3.2136 4.06663 3.28605 4.03153 3.34951 3.9833C3.41298 3.93507 3.4662 3.87467 3.50606 3.80564C3.54593 3.73661 3.57164 3.66033 3.58169 3.58125C3.59174 3.50217 3.58593 3.42189 3.56461 3.34508C3.54328 3.26827 3.50686 3.19648 3.45748 3.1339C3.4081 3.07133 3.34675 3.01922 3.277 2.98062ZM14.7085 9.58062L13.323 8.78062C13.2547 8.7395 13.1789 8.71241 13.1 8.70092C13.0211 8.68942 12.9408 8.69376 12.8636 8.71369C12.7864 8.73361 12.714 8.76871 12.6505 8.81694C12.587 8.86517 12.5338 8.92557 12.4939 8.9946C12.4541 9.06363 12.4284 9.13991 12.4183 9.21899C12.4083 9.29807 12.4141 9.37835 12.4354 9.45516C12.4567 9.53197 12.4931 9.60376 12.5425 9.66634C12.5919 9.72891 12.6533 9.78102 12.723 9.81962L14.1085 10.6196C14.2461 10.6958 14.408 10.7148 14.5595 10.6728C14.711 10.6307 14.84 10.5309 14.9186 10.3947C14.9972 10.2585 15.0193 10.0969 14.98 9.9447C14.9407 9.79246 14.8432 9.66172 14.7085 9.58062ZM2.677 8.78062L1.2915 9.58062C1.22175 9.61922 1.1604 9.67133 1.11102 9.7339C1.06164 9.79648 1.02522 9.86827 1.00389 9.94508C0.982568 10.0219 0.976761 10.1022 0.986813 10.1813C0.996865 10.2603 1.02257 10.3366 1.06244 10.4056C1.1023 10.4747 1.15552 10.5351 1.21899 10.5833C1.28245 10.6315 1.35489 10.6666 1.43208 10.6866C1.50926 10.7065 1.58965 10.7108 1.66853 10.6993C1.74741 10.6878 1.82321 10.6607 1.8915 10.6196L3.277 9.81962C3.41171 9.73852 3.50919 9.60778 3.54849 9.45554C3.58778 9.30329 3.56574 9.1417 3.48711 9.00554C3.40848 8.86938 3.27954 8.76953 3.12804 8.72746C2.97653 8.6854 2.81457 8.70449 2.677 8.78062ZM13.0235 4.10012C13.1289 4.10032 13.2324 4.07254 13.3235 4.01962L14.709 3.21962C14.8437 3.13852 14.9412 3.00778 14.9805 2.85554C15.0198 2.70329 14.9977 2.5417 14.9191 2.40554C14.8405 2.26938 14.7115 2.16953 14.56 2.12746C14.4085 2.0854 14.2466 2.10449 14.109 2.18062L12.7235 2.98062C12.6092 3.04669 12.5198 3.14862 12.4693 3.27062C12.4188 3.39263 12.41 3.52788 12.4441 3.65543C12.4783 3.78297 12.5536 3.89568 12.6584 3.97608C12.7631 4.05648 12.8915 4.10008 13.0235 4.10012Z", fill: "black" })), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", { id: "clip0_4828_8436" }, /* @__PURE__ */ k.createElement("rect", { width: 16, height: 16, fill: "white" })))), Rj = ({
  isEntity: t,
  isBlock: r,
  isGroupable: i,
  isInstance: u,
  altDisplayNames: c,
  displayNameWithAltValue: v
}) => /* @__PURE__ */ N.jsxs(
  "strong",
  {
    className: In({
      "sub-heading": r,
      "value-heading": !i
    }),
    children: [
      t && !u && !c && /* @__PURE__ */ N.jsx(M4, {}),
      v
    ]
  }
), Tj = ({
  userValues: t,
  uuid: r,
  shouldRenderPlaceholders: i,
  isDependentDropdown: u,
  htmlId: c
}) => {
  var v, h;
  return t[r] ? (h = (v = t[r]) == null ? void 0 : v.contents) == null ? void 0 : h.map(({ label: y, meta: { uri: g, parentUri: S, basicLabel: x } = {} } = {}) => {
    if (!y && !x)
      return;
    const T = x ?? y;
    return T && /* @__PURE__ */ N.jsx("div", { children: g || S ? /* @__PURE__ */ N.jsx("a", { className: "preview-value-link", target: "blank", href: g ?? S, children: T }) : /* @__PURE__ */ N.jsx(N.Fragment, { children: T }) }, `${T}${g}`);
  }) : i && !u && /* @__PURE__ */ N.jsx("div", { id: c, className: "value-group-wrapper", children: "-" });
}, wj = (t, r = {}) => {
  const { children: i, type: u } = r;
  return (!(i != null && i.length) || u === At.dropdown) && t !== gm;
}, Ij = ({
  isBlock: t,
  wrapEntities: r,
  isBlockContents: i
}) => ({ children: u }) => /* @__PURE__ */ N.jsx(
  "div",
  {
    className: In({
      "preview-block": t,
      "preview-entity": r,
      "preview-block-contents": i
    }),
    "data-testid": "preview-fields",
    children: u
  }
), Aj = ({ schemaEntry: t }) => ({ children: r }) => r ? /* @__PURE__ */ N.jsx("div", { id: t == null ? void 0 : t.htmlId, className: "value-group-wrapper", children: r }) : null, P4 = ({
  base: t,
  uuid: r,
  paths: i,
  level: u = 0,
  altSchema: c,
  altUserValues: v,
  altSelectedEntries: h,
  altDisplayNames: y,
  hideEntities: g,
  forceRenderAllTopLevelEntities: S
}) => {
  var $e, lt, ot, nt;
  const { userValues: x, selectedEntries: T } = Ea(), { schema: _ } = cd(), { currentlyPreviewedEntityBfid: L } = Qa(), M = v || x, U = c || _, B = h || T, H = t.get(r), Y = i.includes(r), G = u === dO, Q = _8(t, H), W = (H == null ? void 0 : H.type) === At.dropdownOption && !!((lt = ($e = U.get($g(H == null ? void 0 : H.path))) == null ? void 0 : $e.linkedEntry) != null && lt.controlledBy), oe = (nt = (ot = U.get($g((H == null ? void 0 : H.path) || []))) == null ? void 0 : ot.linkedEntry) == null ? void 0 : nt.controlledBy, j = oe ? M[oe] : void 0, re = W && j && B.includes(r) ? /* @__PURE__ */ N.jsx("div", { children: H == null ? void 0 : H.displayName }) : null;
  if (re)
    return re;
  if (!H || Q)
    return null;
  const { children: me, type: Se, bfid: Ne = "", htmlId: Ge } = H;
  if (Se === At.dropdownOption && !Y || G && !L.has(Ne) && !S)
    return null;
  const {
    isGroupable: ze,
    shouldRenderLabelOrPlaceholders: qe,
    shouldRenderValuesOrPlaceholders: at,
    shouldRenderPlaceholders: st,
    isDependentDropdown: We,
    displayNameWithAltValue: he,
    isBlock: ke,
    isBlockContents: _e,
    isInstance: q,
    wrapEntities: pe
  } = U6({
    entry: H,
    level: u,
    userValues: M,
    uuid: r,
    schema: U,
    isOnBranchWithUserValue: Y,
    altDisplayNames: y,
    hideEntities: g,
    isEntity: G,
    forceRenderAllTopLevelEntities: S
  });
  return /* @__PURE__ */ N.jsxs(
    VT,
    {
      condition: ke || _e || pe,
      wrapper: Ij({ isBlock: ke, isBlockContents: _e, wrapEntities: pe }),
      children: [
        qe && /* @__PURE__ */ N.jsx(
          Rj,
          {
            isEntity: G,
            isBlock: ke,
            isGroupable: ze,
            isInstance: q,
            altDisplayNames: y,
            displayNameWithAltValue: he
          }
        ),
        at && /* @__PURE__ */ N.jsx(
          Tj,
          {
            userValues: M,
            uuid: r,
            shouldRenderPlaceholders: st,
            isDependentDropdown: We,
            htmlId: Ge
          }
        ),
        me == null ? void 0 : me.map((Rt) => {
          const ht = U.get(Rt);
          return /* @__PURE__ */ N.jsx(
            VT,
            {
              condition: !ze && wj(u, ht),
              wrapper: Aj({ schemaEntry: ht }),
              children: /* @__PURE__ */ N.jsx(
                P4,
                {
                  uuid: Rt,
                  base: t,
                  paths: i,
                  level: u + 1,
                  altSchema: c,
                  altUserValues: v,
                  altSelectedEntries: h,
                  altDisplayNames: y,
                  hideEntities: g,
                  forceRenderAllTopLevelEntities: S
                },
                Rt
              )
            },
            Rt
          );
        })
      ]
    }
  );
};
const WC = ({
  altSchema: t,
  altUserValues: r,
  altSelectedEntries: i,
  altInitKey: u,
  altDisplayNames: c,
  hideEntities: v,
  forceRenderAllTopLevelEntities: h,
  entityRowDisplay: y
}) => {
  const { userValues: g } = Ea(), { schema: S, initialSchemaKey: x } = cd(), T = r ?? g, _ = t ?? S, L = u ?? x;
  return /* @__PURE__ */ N.jsx(
    "div",
    {
      className: In("preview-panel", { "preview-panel-row": y }),
      "data-testid": "preview-fields",
      children: L && /* @__PURE__ */ N.jsx(
        P4,
        {
          base: _,
          uuid: L,
          paths: Object.keys(T).map((M) => {
            var U;
            return ((U = _.get(M)) == null ? void 0 : U.path) ?? "";
          }).flat(),
          altSchema: t,
          altUserValues: r,
          altSelectedEntries: i,
          altDisplayNames: c,
          hideEntities: v,
          forceRenderAllTopLevelEntities: h
        }
      )
    }
  );
};
const Nj = () => {
  const { previewContent: t, setPreviewContent: r } = Ea(), { formatMessage: i } = La(), { navigateToEditPage: u } = fd();
  return t.map(({ id: c, base: v, userValues: h, initKey: y, title: g, entities: S }) => {
    var _;
    const x = (_ = S == null ? void 0 : S.map((L) => S2[L])) == null ? void 0 : _[0], T = () => r(t.filter((L) => L.id !== c));
    return /* @__PURE__ */ N.jsxs("section", { className: Hg.classNames.fullDisplayContainer, children: [
      /* @__PURE__ */ N.jsxs("div", { className: "full-display-control-panel", children: [
        /* @__PURE__ */ N.jsx(
          Dn,
          {
            className: "close",
            "data-testid": "preview-remove",
            onClick: T,
            ariaLabel: i({ id: "ld.aria.sections.closeResourcePreview" }),
            children: /* @__PURE__ */ N.jsx(qs, {})
          }
        ),
        /* @__PURE__ */ N.jsx("div", { className: "info", children: /* @__PURE__ */ N.jsx("span", { className: "title", children: g }) }),
        /* @__PURE__ */ N.jsx(
          Dn,
          {
            "data-testid": "preview-fetch",
            onClick: () => u(Kh(c)),
            type: Mn.Highlighted,
            children: /* @__PURE__ */ N.jsx(mt, { id: `ld.edit${x}`, defaultMessage: "Edit" })
          }
        )
      ] }),
      Object.keys(h).length ? /* @__PURE__ */ N.jsx("div", { "data-testid": "preview-contents-container", className: "preview-contents-container", children: /* @__PURE__ */ N.jsx(WC, { altSchema: v, altUserValues: h, altInitKey: y }) }) : /* @__PURE__ */ N.jsx("div", { children: /* @__PURE__ */ N.jsx(mt, { id: "ld.resourceWithIdIsEmpty", values: { id: c } }) })
    ] }, c);
  });
}, _j = (t) => /* @__PURE__ */ k.createElement("svg", { width: 8, height: 12, viewBox: "0 0 8 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M0.555401 5.53353L5.89053 0.193114C6.14775 -0.0643713 6.565 -0.0643713 6.82222 0.193114L7.44454 0.81608C7.70148 1.07329 7.70176 1.48988 7.44564 1.74764L3.21734 5.99986L7.44536 10.2524C7.70176 10.5101 7.70121 10.9267 7.44427 11.1839L6.82195 11.8069C6.56473 12.0644 6.14747 12.0644 5.89026 11.8069L0.555401 6.46619C0.298183 6.20871 0.298183 5.79102 0.555401 5.53353Z", fill: "#8D9095" })), Oj = (t) => /* @__PURE__ */ k.createElement("svg", { width: 8, height: 12, viewBox: "0 0 8 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M7.44453 6.46634L2.10945 11.8068C1.85214 12.0644 1.43499 12.0644 1.17771 11.8068L0.55546 11.1839C0.298594 10.9268 0.2981 10.5101 0.554362 10.2524L4.78251 5.99999L0.554362 1.74765C0.2981 1.48991 0.298594 1.07318 0.55546 0.816057L1.17771 0.193175C1.43501 -0.0643917 1.85217 -0.0643917 2.10945 0.193175L7.4445 5.53366C7.70181 5.7912 7.70181 6.20878 7.44453 6.46634Z", fill: "#255096" }));
const k4 = k.memo(
  ({
    currentPage: t = 0,
    totalPages: r = 1,
    pageSize: i = 1,
    totalResultsCount: u = 1,
    showCount: c = !0,
    onPrevPageClick: v,
    onNextPageClick: h,
    isLooped: y = !1,
    useSlidingWindow: g = !1
  }) => {
    const S = t === 0, x = t + 1;
    let T, _, L;
    if (g)
      T = t + 1, _ = Math.min(T + i - 1, u), L = _ >= u;
    else {
      const M = r ? r - 1 : 0;
      L = t >= M, T = S ? 1 : t * i + 1, r === 1 ? _ = u : x === r ? _ = T - 1 + u - t * i : _ = x * i;
    }
    return /* @__PURE__ */ N.jsxs("div", { className: "pagination", "data-testid": "pagination", children: [
      /* @__PURE__ */ N.jsxs(
        Dn,
        {
          type: Mn.Text,
          onClick: v,
          disabled: !y && S,
          className: "pagination-button",
          "data-testid": "backward-button",
          children: [
            /* @__PURE__ */ N.jsx(_j, {}),
            /* @__PURE__ */ N.jsx(mt, { id: "ld.previous" })
          ]
        }
      ),
      c && /* @__PURE__ */ N.jsx("div", { className: "pagination-count", children: /* @__PURE__ */ N.jsx(
        mt,
        {
          id: "ld.paginationCount",
          values: {
            startCount: /* @__PURE__ */ N.jsx("span", { "data-testid": "pagination-start-count", children: T }),
            endCount: /* @__PURE__ */ N.jsx("span", { "data-testid": "pagination-end-count", children: _ }),
            totalResultsCount: /* @__PURE__ */ N.jsx("span", { "data-testid": "pagination-total-count", children: u })
          }
        }
      ) }),
      /* @__PURE__ */ N.jsxs(
        Dn,
        {
          type: Mn.Text,
          onClick: h,
          disabled: !y && L,
          className: "pagination-button",
          "data-testid": "forward-button",
          children: [
            /* @__PURE__ */ N.jsx(mt, { id: "ld.next" }),
            /* @__PURE__ */ N.jsx(Oj, {})
          ]
        }
      )
    ] });
  }
), Lj = (t) => /* @__PURE__ */ k.createElement("svg", { width: 12, height: 13, viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M6 0.5C2.68548 0.5 0 3.18548 0 6.5C0 9.81452 2.68548 12.5 6 12.5C9.31452 12.5 12 9.81452 12 6.5C12 3.18548 9.31452 0.5 6 0.5ZM8.94194 8.075C9.05564 8.18871 9.05564 8.37258 8.94194 8.48629L7.98387 9.44194C7.87016 9.55564 7.68629 9.55564 7.57258 9.44194L6 7.85484L4.425 9.44194C4.31129 9.55564 4.12742 9.55564 4.01371 9.44194L3.05806 8.48387C2.94435 8.37016 2.94435 8.18629 3.05806 8.07258L4.64516 6.5L3.05806 4.925C2.94435 4.81129 2.94435 4.62742 3.05806 4.51371L4.01613 3.55565C4.12984 3.44194 4.31371 3.44194 4.42742 3.55565L6 5.14516L7.575 3.55806C7.68871 3.44435 7.87258 3.44435 7.98629 3.55806L8.94436 4.51613C9.05806 4.62984 9.05806 4.81371 8.94436 4.92742L7.35484 6.5L8.94194 8.075Z", fill: "black" })), F4 = (t) => /* @__PURE__ */ k.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M8.05005 8.80078C8.60233 8.80078 9.05005 8.35307 9.05005 7.80078C9.05005 7.2485 8.60233 6.80078 8.05005 6.80078C7.49776 6.80078 7.05005 7.2485 7.05005 7.80078C7.05005 8.35307 7.49776 8.80078 8.05005 8.80078Z", fill: "black" }), /* @__PURE__ */ k.createElement("path", { d: "M2.3999 8.00039L5.8499 4.55039C6.1999 4.20039 6.1999 3.70039 5.8499 3.35039C5.4999 3.00039 4.9999 3.00039 4.6499 3.35039L0.599902 7.40039C0.499902 7.55039 0.399902 7.80039 0.399902 8.00039C0.399902 8.20039 0.499902 8.45039 0.649902 8.60039L4.6999 12.6504C4.8499 12.8004 5.0999 12.9004 5.2999 12.9004C5.4999 12.9004 5.7499 12.8004 5.8999 12.6504C6.0499 12.5004 6.1499 12.3004 6.1499 12.0504C6.1499 11.8504 6.0499 11.6004 5.8999 11.4504L2.3999 8.00039Z", fill: "black" }), /* @__PURE__ */ k.createElement("path", { d: "M5.3999 8.80078C5.95219 8.80078 6.3999 8.35307 6.3999 7.80078C6.3999 7.2485 5.95219 6.80078 5.3999 6.80078C4.84762 6.80078 4.3999 7.2485 4.3999 7.80078C4.3999 8.35307 4.84762 8.80078 5.3999 8.80078Z", fill: "black" }), /* @__PURE__ */ k.createElement("path", { d: "M10.75 8.80078C11.3023 8.80078 11.75 8.35307 11.75 7.80078C11.75 7.2485 11.3023 6.80078 10.75 6.80078C10.1977 6.80078 9.75 7.2485 9.75 7.80078C9.75 8.35307 10.1977 8.80078 10.75 8.80078Z", fill: "black" }), /* @__PURE__ */ k.createElement("path", { d: "M15.3499 7.39961L11.2999 3.34961C11.1499 3.19961 10.8999 3.09961 10.6999 3.09961C10.4999 3.09961 10.2499 3.19961 10.0999 3.34961C9.9499 3.49961 9.8499 3.69961 9.8499 3.94961C9.8499 4.14961 9.9499 4.39961 10.0999 4.54961L13.5499 7.99961L10.0999 11.4496C9.7499 11.7996 9.7499 12.2996 10.0999 12.6496C10.2499 12.7996 10.4499 12.8996 10.6999 12.8996C10.8999 12.8996 11.1499 12.7996 11.2999 12.6496L15.3499 8.59961C15.4999 8.44961 15.5999 8.24961 15.5999 7.99961C15.5999 7.79961 15.4999 7.54961 15.3499 7.39961Z", fill: "black" })), B4 = (t) => /* @__PURE__ */ k.createElement("svg", { width: 80, height: 80, viewBox: "0 0 80 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("g", { clipPath: "url(#clip0_2944_109882)" }, /* @__PURE__ */ k.createElement("path", { d: "M79.4531 73.2656L60.4844 54.2969C60.125 53.9375 59.6563 53.75 59.1563 53.75H57.0937C62.0156 48.0469 65 40.625 65 32.5C65 14.5469 50.4531 0 32.5 0C14.5469 0 0 14.5469 0 32.5C0 50.4531 14.5469 65 32.5 65C40.625 65 48.0469 62.0156 53.75 57.0937V59.1563C53.75 59.6563 53.9531 60.125 54.2969 60.4844L73.2656 79.4531C74 80.1875 75.1875 80.1875 75.9219 79.4531L79.4531 75.9219C80.1875 75.1875 80.1875 74 79.4531 73.2656ZM32.5 57.5C18.6875 57.5 7.5 46.3125 7.5 32.5C7.5 18.6875 18.6875 7.5 32.5 7.5C46.3125 7.5 57.5 18.6875 57.5 32.5C57.5 46.3125 46.3125 57.5 32.5 57.5Z", fill: "#8F8F8F" })), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", { id: "clip0_2944_109882" }, /* @__PURE__ */ k.createElement("rect", { width: 80, height: 80, fill: "white" })))), Dj = (t) => /* @__PURE__ */ k.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { d: "M15.3628 2.30078L13.6796 0.618308C12.8553 -0.206035 11.521 -0.20616 10.6965 0.618277L0.778433 10.4715L0.0102775 15.1276C-0.0733162 15.6344 0.365527 16.0733 0.87237 15.9897L5.52846 15.2215L15.3824 5.30349C16.2052 4.48065 16.213 3.15102 15.3628 2.30078ZM3.77012 9.43749L9.09071 4.1514L11.8485 6.90924L6.56249 12.2298V10.9375H5.06249V9.43749H3.77012ZM2.56662 14.3166L1.6834 13.4334L2.06278 11.1338L2.63777 10.5625H3.93749V12.0625H5.43749V13.3622L4.86618 13.9372L2.56662 14.3166ZM14.4099 4.33121L14.4083 4.3328L14.4067 4.3344L12.9058 5.84515L10.1548 3.09421L11.6656 1.59328L11.6671 1.59171L11.6687 1.59015C11.9545 1.30434 12.418 1.30081 12.7073 1.59012L14.3903 3.27306C14.699 3.58171 14.7009 4.04021 14.4099 4.33121Z", fill: "black" })), z2 = (t) => /* @__PURE__ */ k.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.54348 1.54348C9.54348 0.967181 9.0763 0.5 8.5 0.5C7.9237 0.5 7.45652 0.967181 7.45652 1.54348V7.45652L1.54348 7.45652C0.967181 7.45652 0.5 7.9237 0.5 8.5C0.5 9.0763 0.967181 9.54348 1.54348 9.54348H7.45652V15.4565C7.45652 16.0328 7.9237 16.5 8.5 16.5C9.0763 16.5 9.54348 16.0328 9.54348 15.4565V9.54348H15.4565C16.0328 9.54348 16.5 9.0763 16.5 8.5C16.5 7.9237 16.0328 7.45652 15.4565 7.45652L9.54348 7.45652V1.54348Z", fill: "black", fillOpacity: 0.62 })), U4 = ({ referenceId: t, ownId: r, entityType: i, handleNavigateToEditPage: u }) => {
  const { navigateToEditPage: c, navigateAsDuplicate: v } = fd(), h = () => r && v(r), y = [
    {
      id: "actions",
      labelId: "ld.actions",
      data: [
        {
          id: "edit",
          type: Wu.basic,
          labelId: "ld.edit",
          icon: /* @__PURE__ */ N.jsx(Dj, {}),
          action: u
        },
        {
          id: "duplicate",
          type: Wu.basic,
          labelId: "ld.duplicate",
          icon: /* @__PURE__ */ N.jsx(bO, {}),
          action: h
        },
        {
          id: "newInstance",
          type: Wu.basic,
          labelId: "ld.newInstance",
          icon: /* @__PURE__ */ N.jsx(z2, {}),
          action: () => i && t && c(
            `${Va.RESOURCE_CREATE.uri}?${Mi.Type}=${i}&${Mi.Ref}=${t}`
          )
        }
      ]
    }
  ];
  return /* @__PURE__ */ N.jsx(
    C2,
    {
      labelId: "ld.actions",
      className: "toggle-entity-edit",
      items: y,
      hideLabelIdWithinDropdownList: !0,
      buttonTestId: "preview-actions-dropdown"
    }
  );
};
const Mj = 2, Pj = () => {
  const { formatMessage: t } = La(), { previewContent: r, setPreviewContent: i, resetPreviewContent: u } = Ea(), { setSelectedInstances: c, resetSelectedInstances: v, selectedInstances: h } = Eo(), { resetFullDisplayComponentType: y } = Qa(), { navigateToEditPage: g } = fd(), [S, x] = k.useState(0), T = () => {
    u(), y(), v();
  }, _ = (B) => {
    S === M - 1 && x((H) => {
      const Y = H - 1;
      return Y >= 0 ? Y : 0;
    }), i((H) => {
      const Y = H.filter(({ id: G }) => G !== B);
      return Y.length || y(), Y;
    }), c((H) => H.filter((Y) => Y !== B));
  }, L = (B) => g(Kh(B)), M = (r.length > 1 ? r.length : 2) - 1, U = r.findIndex(({ id: B }) => B);
  return /* @__PURE__ */ N.jsxs("section", { className: "comparison", children: [
    /* @__PURE__ */ N.jsxs("header", { children: [
      /* @__PURE__ */ N.jsxs("div", { className: "heading", children: [
        /* @__PURE__ */ N.jsx(
          Dn,
          {
            "data-testid": "close-comparison-section",
            type: Mn.Icon,
            onClick: T,
            className: "nav-close",
            ariaLabel: t({ id: "ld.aria.comparison.close" }),
            children: /* @__PURE__ */ N.jsx(qs, {})
          }
        ),
        /* @__PURE__ */ N.jsxs("h2", { children: [
          /* @__PURE__ */ N.jsx(F4, {}),
          /* @__PURE__ */ N.jsx(mt, { id: "ld.compareResources" })
        ] }),
        /* @__PURE__ */ N.jsx("span", { className: "empty-block" })
      ] }),
      /* @__PURE__ */ N.jsxs("div", { className: "subheading", children: [
        /* @__PURE__ */ N.jsx("span", { children: /* @__PURE__ */ N.jsx(mt, { id: "ld.nResourcesSelected", values: { n: r.length } }) }),
        /* @__PURE__ */ N.jsxs(
          Dn,
          {
            "data-testid": "clear-comparison-selections",
            type: Mn.Icon,
            onClick: T,
            disabled: !r.length,
            className: "nav-close",
            children: [
              /* @__PURE__ */ N.jsx(Lj, {}),
              /* @__PURE__ */ N.jsx(mt, { id: "ld.clearSelections" })
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ N.jsxs("div", { className: "comparison-contents", children: [
      r.sort((B, H) => h.indexOf(B.id) - h.indexOf(H.id)).slice(S, S + 2).map(({ initKey: B, base: H, userValues: Y, id: G, title: Q, referenceIds: W, selectedEntries: oe }, j) => {
        var re;
        return /* @__PURE__ */ N.jsxs("section", { className: "entry", children: [
          /* @__PURE__ */ N.jsxs("div", { className: "entry-header", children: [
            /* @__PURE__ */ N.jsxs("div", { className: "entry-header-controls", children: [
              /* @__PURE__ */ N.jsx(
                Dn,
                {
                  "data-testid": `remove-comparison-entry-${G}`,
                  type: Mn.Icon,
                  onClick: () => _(G),
                  className: "nav-close",
                  ariaLabel: t({ id: "ld.aria.comparison.removeEntry" }),
                  children: /* @__PURE__ */ N.jsx(qs, {})
                }
              ),
              /* @__PURE__ */ N.jsx(
                U4,
                {
                  ownId: G,
                  referenceId: (re = W == null ? void 0 : W[0]) == null ? void 0 : re.id,
                  entityType: Co.instance,
                  handleNavigateToEditPage: () => L(G)
                }
              )
            ] }),
            /* @__PURE__ */ N.jsxs("h3", { children: [
              /* @__PURE__ */ N.jsx("span", { className: "comparison-index", children: U + S + j + 1 }),
              /* @__PURE__ */ N.jsx("span", { children: Q })
            ] })
          ] }),
          /* @__PURE__ */ N.jsx(
            WC,
            {
              altInitKey: B,
              altSchema: H,
              altUserValues: Y,
              altSelectedEntries: oe,
              forceRenderAllTopLevelEntities: !0
            }
          )
        ] }, G);
      }),
      r.length <= 1 && /* @__PURE__ */ N.jsxs("div", { className: "insufficient-resource-amt", "data-testid": "insufficient-resource-amt", children: [
        /* @__PURE__ */ N.jsx(B4, {}),
        /* @__PURE__ */ N.jsx(
          mt,
          {
            id: r.length ? "ld.chooseOneResourceCompare" : "ld.chooseTwoResourcesCompare"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ N.jsx("nav", { "aria-label": t({ id: "ld.selectedResources" }), children: /* @__PURE__ */ N.jsx(
      k4,
      {
        currentPage: S,
        onNextPageClick: () => x((B) => B + 1),
        onPrevPageClick: () => x((B) => B - 1),
        totalPages: M,
        totalResultsCount: r.length,
        useSlidingWindow: !0,
        pageSize: Mj,
        showCount: !0
      }
    ) })
  ] });
}, kj = () => {
  const { previewContent: t } = Ea(), { fullDisplayComponentType: r } = Qa(), i = {
    [Qh.Basic]: !!t.length && /* @__PURE__ */ N.jsx(Nj, {}),
    [Qh.Comparison]: /* @__PURE__ */ N.jsx(Pj, {})
  };
  return i == null ? void 0 : i[r];
}, Fj = (t = !0, r = 0, i = !1) => {
  const [u, c] = qc(), v = u.get(Wo.Offset), { pageMetadata: h } = Eo(), [y, g] = k.useState(
    v ? parseInt(v) : r
  );
  return k.useEffect(() => {
    v != null && g(parseInt(v));
  }, [v]), {
    getCurrentPageNumber: () => y,
    setCurrentPageNumber: g,
    onPrevPageClick: () => {
      const _ = y - 1;
      return !i && _ < 0 || (g(_), t && c((L) => (L.set(Wo.Offset, _.toString()), L))), _;
    },
    onNextPageClick: () => {
      const _ = y + 1;
      return !i && _ > h.totalPages - 1 || (g(_), t && c((L) => (L.set(Wo.Offset, _.toString()), L))), _;
    }
  };
}, Bj = () => {
  const {
    hasSearchParams: t,
    defaultSearchBy: r,
    defaultQuery: i,
    navigationSegment: u,
    hasCustomPagination: c,
    searchByControlOptions: v,
    getSearchSourceData: h
  } = dd(), { setIsLoading: y } = qu(), { resetPreviewContent: g } = Ea(), {
    searchBy: S,
    setSearchBy: x,
    query: T,
    setQuery: _,
    facets: L,
    setFacets: M,
    message: U,
    setMessage: B,
    data: H,
    setData: Y,
    pageMetadata: G,
    setPageMetadata: Q,
    setForceRefresh: W,
    facetsBySegments: oe,
    setFacetsBySegments: j,
    resetFacetsBySegments: re
  } = Eo(), { fullDisplayComponentType: me } = Qa(), { fetchData: Se } = MO(), {
    getCurrentPageNumber: Ne,
    setCurrentPageNumber: Ge,
    onPrevPageClick: ze,
    onNextPageClick: qe
  } = Fj(t, 0, c), at = Ne(), [st, We] = qc(), he = u == null ? void 0 : u.value, ke = he === bo.Browse, _e = (dt, sn, bn) => {
    he && j((Ze) => ({
      ...Ze,
      [he]: {
        query: dt,
        searchBy: sn,
        facets: bn
      }
    }));
  }, q = k.useCallback(() => {
    Q(_F), Ge(0);
  }, []), pe = k.useCallback(() => {
    const dt = DO(T) ?? "";
    q(), me !== Qh.Comparison && g(), _e(dt, S, L), t && We(L2(dt, S)), Se({ query: dt, searchBy: S, offset: 0 }), W(!0);
  }, [Se, t, T, S, he, L]), $e = k.useCallback(() => {
    q(), Y(null), x(r), _(""), B(""), me !== Qh.Comparison && g(), _e("", r, {});
  }, [r]), lt = async (dt) => {
    var Gn;
    const sn = oe[dt];
    let bn;
    if (sn.searchBy)
      bn = sn.searchBy;
    else {
      const ar = v;
      (Gn = ar[dt]) != null && Gn[0] && (bn = ar[dt][0].value);
    }
    const Ze = bn, mn = sn.query ?? "", fn = sn.facets ?? {};
    x(Ze), _(mn), M(fn), y(!0), q(), await (h == null ? void 0 : h()), await Se({
      query: mn,
      searchBy: Ze,
      selectedSegment: dt
    }), y(!1);
  }, ot = async ({
    pageNumber: dt,
    query: sn,
    pageMetadata: bn,
    isBrowseSearch: Ze,
    searchBy: mn,
    navigationSegment: fn,
    baseQuerySelectorType: Gn,
    pageMetadataSelectorType: ar
  }) => {
    const Jn = dt === 0, Ha = (Jn ? sn : bn == null ? void 0 : bn[ar]) ?? sn, ja = Ze && !Jn ? Gn : nr.Query;
    await Se({
      query: Ha,
      searchBy: mn,
      offset: dt,
      selectedSegment: fn == null ? void 0 : fn.value,
      baseQuerySelector: ja
    });
  }, nt = async (dt, sn, bn) => {
    if (c)
      await ot({
        pageNumber: dt,
        query: T,
        pageMetadata: G,
        isBrowseSearch: ke,
        searchBy: S,
        navigationSegment: u,
        baseQuerySelectorType: sn,
        pageMetadataSelectorType: bn
      });
    else {
      const Ze = st.get(Wo.Query) ?? "";
      await Se({
        query: Ze,
        searchBy: st.get(Wo.SearchBy),
        offset: dt * l0
      });
    }
  }, Rt = async () => {
    const dt = ze();
    await nt(dt, nr.Prev, "prev");
  }, ht = async () => {
    const dt = qe();
    await nt(dt, nr.Next, "next");
  };
  return k.useEffect(() => {
    x(r), i && _(i), _e(i ?? T, r, L);
  }, [x, _, r, i]), k.useEffect(() => re, [re]), {
    submitSearch: pe,
    clearValues: $e,
    onPrevPageClick: Rt,
    onNextPageClick: ht,
    currentPageNumber: at,
    pageMetadata: G,
    message: U,
    data: H,
    fetchData: Se,
    onChangeSegment: lt,
    handlePageChange: nt
  };
}, Uj = (t) => {
  const { hasSearchParams: r, defaultSearchBy: i, defaultQuery: u, getSearchSourceData: c, getSearchFacetsData: v } = dd(), { setIsLoading: h } = qu(), { setQuery: y, setData: g, setSearchBy: S, forceRefresh: x, setForceRefresh: T, resetFacetsData: _ } = Eo(), L = new URLSearchParams(window.location.search), M = L.get(Wo.Query), U = L.get(Wo.SearchBy), B = L.get(Wo.Offset), H = k.useRef({
    query: null,
    searchBy: null,
    offset: null
  });
  k.useEffect(() => {
    if (!r)
      return;
    async function Y() {
      const { query: G, searchBy: Q, offset: W } = H.current;
      if (!(G === M && Q === U && W === B && !x)) {
        if (U && Q !== U && S(U), !M) {
          g(null);
          return;
        }
        U && G !== M && y(v_(M)), T(!1), H.current = { query: M, searchBy: U, offset: B };
      }
    }
    Y();
  }, [r, M, U, B, x]), k.useEffect(() => {
    async function Y() {
      h(!0), await (c == null ? void 0 : c()), await (v == null ? void 0 : v());
      const G = r ? M : u, Q = r ? U : i, W = B ? parseInt(B) * l0 : 0;
      U && S(U), U && M && y(v_(M)), G && await t({ query: G, searchBy: Q, offset: W }), h(!1);
    }
    return Y(), _;
  }, []);
};
const Vj = ({ labelId: t = "", className: r }) => /* @__PURE__ */ N.jsxs("div", { className: In(["empty-placeholder", r]), children: [
  /* @__PURE__ */ N.jsx(B4, {}),
  /* @__PURE__ */ N.jsx(mt, { id: t })
] });
const Hj = () => {
  const {
    labelEmptySearch: t,
    classNameEmptyPlaceholder: r,
    isVisibleFullDisplay: i,
    isVisibleAdvancedSearch: u,
    renderResultsList: c,
    renderSearchControlPane: v,
    isVisibleSegments: h,
    primarySegments: y,
    navigationSegment: g,
    searchResultsLimit: S,
    hasMarcPreview: x,
    renderMarcPreview: T
  } = dd(), {
    submitSearch: _,
    clearValues: L,
    onPrevPageClick: M,
    onNextPageClick: U,
    currentPageNumber: B,
    pageMetadata: H,
    message: Y,
    data: G,
    fetchData: Q,
    onChangeSegment: W
  } = Bj(), { isMarcPreviewOpen: oe } = Qa();
  Uj(Q);
  const j = h ? !!(g != null && g.value) && (y == null ? void 0 : y[g == null ? void 0 : g.value]) : void 0, re = j ? j.isVisiblePaginationCount : !0, me = j ? j.isLoopedPagination : !1;
  return /* @__PURE__ */ N.jsxs("div", { "data-testid": "id-search", className: "item-search", children: [
    /* @__PURE__ */ N.jsx(xj, { submitSearch: _, clearValues: L, changeSegment: W }),
    !(x && oe) && /* @__PURE__ */ N.jsxs("div", { className: Hg.classNames.itemSearchContent, children: [
      v(),
      /* @__PURE__ */ N.jsxs("div", { className: Hg.classNames.itemSearchContentContainer, children: [
        Y && /* @__PURE__ */ N.jsx("div", { className: Hg.classNames.itemSearchMessage, children: /* @__PURE__ */ N.jsx(mt, { id: Y }) }),
        G && /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
          c(),
          H.totalElements > 0 && /* @__PURE__ */ N.jsx(
            k4,
            {
              currentPage: B,
              totalPages: H.totalPages,
              pageSize: S ?? l0,
              totalResultsCount: H.totalElements,
              showCount: re,
              onPrevPageClick: M,
              onNextPageClick: U,
              isLooped: me
            }
          )
        ] }),
        !G && !Y && /* @__PURE__ */ N.jsx(Vj, { labelId: t, className: r })
      ] })
    ] }),
    x && (T == null ? void 0 : T()),
    i && /* @__PURE__ */ N.jsx(kj, {}),
    u && /* @__PURE__ */ N.jsx(hU, { clearValues: L })
  ] });
}, V4 = (t) => /* @__PURE__ */ N.jsx(cU, { value: t, children: /* @__PURE__ */ N.jsx(Hj, {}) });
const W2 = ({
  children: t,
  label: r,
  renderSubLabel: i,
  renderCloseButton: u,
  segmentsConfig: c
}) => {
  var _;
  const { formatMessage: v } = La(), { pageMetadata: h } = Eo(), { isSearchPaneCollapsed: y, setIsSearchPaneCollapsed: g } = Qa(), { navigationSegment: S } = dd(), x = S == null ? void 0 : S.value, T = c ? (_ = c[x]) == null ? void 0 : _.isVisibleSubLabel : !!i;
  return /* @__PURE__ */ N.jsxs("div", { className: In(["search-control-pane", "search-control-pane-embedded"]), children: [
    u == null ? void 0 : u(),
    y && /* @__PURE__ */ N.jsx(
      Dn,
      {
        onClick: () => g(!1),
        className: "open-ctl",
        ariaLabel: v({ id: "ld.aria.searchPane.open" }),
        children: /* @__PURE__ */ N.jsx(zC, { className: "header-caret" })
      }
    ),
    /* @__PURE__ */ N.jsxs("div", { className: "search-control-pane-title", children: [
      /* @__PURE__ */ N.jsx("h2", { className: "search-control-pane-mainLabel", children: /* @__PURE__ */ N.jsx("span", { children: r }) }),
      T && !!i && /* @__PURE__ */ N.jsx("div", { className: "search-control-pane-subLabel", children: /* @__PURE__ */ N.jsx("span", { children: i == null ? void 0 : i(h == null ? void 0 : h.totalElements) }) })
    ] }),
    t
  ] });
}, jj = ({
  elementType: t,
  cellKey: r,
  header: i,
  label: u,
  className: c,
  onHeaderCellClick: v,
  ...h
}) => {
  const y = t;
  return /* @__PURE__ */ N.jsx(
    y,
    {
      "data-testid": `${t}-${r}`,
      className: In({ clickable: v }, c),
      onClick: () => i && (v == null ? void 0 : v({ [r]: i[r] })),
      ...h,
      children: /* @__PURE__ */ N.jsx("div", { className: "table-header-contents-wrapper", children: u ?? "" })
    }
  );
};
const H4 = ({ header: t, data: r, className: i, onRowClick: u, onHeaderCellClick: c, selectedRows: v }) => {
  const h = Object.entries(t).toSorted(
    ([y, g], [S, x]) => ((g == null ? void 0 : g.position) ?? 0) - ((x == null ? void 0 : x.position) ?? 0)
  );
  return /* @__PURE__ */ N.jsxs("table", { "data-testid": "table", className: In("table", i), children: [
    /* @__PURE__ */ N.jsx("thead", { children: /* @__PURE__ */ N.jsx("tr", { children: h.map(([y, { label: g, className: S, ...x }]) => /* @__PURE__ */ N.jsx(
      jj,
      {
        elementType: g ? "th" : "td",
        cellKey: y,
        label: g,
        className: S,
        onHeaderCellClick: c,
        header: t,
        ...x
      },
      y
    )) }) }),
    /* @__PURE__ */ N.jsx("tbody", { children: r.map((y) => {
      const g = y.__meta;
      return /* @__PURE__ */ N.jsx(
        "tr",
        {
          "data-testid": "table-row",
          className: In(
            { clickable: u, "row-selected": v == null ? void 0 : v.includes(g == null ? void 0 : g.id) },
            g == null ? void 0 : g.className
          ),
          onClick: () => u == null ? void 0 : u(y),
          children: h.map(([S]) => {
            const { label: x, children: T, className: _, ...L } = (y == null ? void 0 : y[S]) || {};
            return /* @__PURE__ */ N.jsx("td", { className: In(_), "data-testid": S, ...L, children: (T || x) ?? "" }, S);
          })
        },
        (g == null ? void 0 : g.key) || (g == null ? void 0 : g.id)
      );
    }) })
  ] });
}, Gj = ({ header: t, data: r, className: i, onRowClick: u, onHeaderCellClick: c, selectedRows: v }) => {
  const h = Object.entries(t).sort(
    ([G, Q], [W, oe]) => ((Q == null ? void 0 : Q.position) ?? 0) - ((oe == null ? void 0 : oe.position) ?? 0)
  ), y = k.useRef(null), g = k.useRef(null), S = k.useRef(null), { table: x, tableFlex: T, tableHead: _, tableHeadCell: L, tableRow: M, tableBodyContainer: U, tableBody: B } = Hg.classNames;
  k.useEffect(() => {
    var W, oe, j, re;
    const G = (oe = (W = g.current) == null ? void 0 : W.getBoundingClientRect()) == null ? void 0 : oe.width;
    G && ((j = g.current) == null || j.setAttribute("style", `width: ${G + BF}px`));
    const Q = (me) => {
      const { target: Se } = me;
      if (!Se)
        return;
      const { scrollLeft: Ne } = Se;
      requestAnimationFrame(() => {
        var Ge;
        (Ge = y == null ? void 0 : y.current) == null || Ge.scrollTo({ left: Ne });
      });
    };
    return (re = S.current) == null || re.addEventListener("scroll", Q), () => {
      var me;
      (me = S.current) == null || me.removeEventListener("scroll", Q);
    };
  }, []);
  const H = (G, Q) => {
    G.key === "Enter" && (G.preventDefault(), c == null || c({ [Q]: t[Q] }));
  }, Y = (G, Q) => {
    G.key === "Enter" && (G.preventDefault(), u == null || u(Q));
  };
  return /* @__PURE__ */ N.jsxs("div", { role: "table", "data-testid": "table", className: In(x, T, i), children: [
    /* @__PURE__ */ N.jsx("div", { role: "rowgroup", ref: y, className: _, children: /* @__PURE__ */ N.jsx("div", { role: "row", ref: g, className: M, children: h.map(([G, { label: Q, className: W, ...oe }]) => /* @__PURE__ */ N.jsx(
      "div",
      {
        "data-testid": `th-${G}`,
        role: "columnheader",
        tabIndex: 0,
        className: In(L, { clickable: c }, W),
        onClick: () => c == null ? void 0 : c({ [G]: t[G] }),
        onKeyDown: (j) => H(j, G),
        ...oe,
        children: /* @__PURE__ */ N.jsx("div", { className: "table-header-contents-wrapper", children: Q ?? "" })
      },
      G
    )) }) }),
    /* @__PURE__ */ N.jsx("div", { ref: S, className: U, children: /* @__PURE__ */ N.jsx("div", { className: B, children: r.map((G) => {
      const Q = G.__meta;
      return /* @__PURE__ */ N.jsx(
        "div",
        {
          "data-testid": "table-row",
          role: "row",
          tabIndex: 0,
          className: In(
            M,
            { clickable: u, "row-selected": v == null ? void 0 : v.includes(Q == null ? void 0 : Q.id) },
            Q == null ? void 0 : Q.className
          ),
          onClick: () => u == null ? void 0 : u(G),
          onKeyDown: (W) => Y(W, G),
          children: h.map(([W, { className: oe }]) => {
            const { label: j, children: re, className: me, ...Se } = (G == null ? void 0 : G[W]) || {};
            return /* @__PURE__ */ N.jsx(
              "div",
              {
                className: In("table-cell", me, oe),
                "data-testid": W,
                role: "cell",
                ...Se,
                children: /* @__PURE__ */ N.jsx("div", { className: "table-cell-content", children: (re || j) ?? "" })
              },
              W
            );
          })
        },
        (Q == null ? void 0 : Q.key) || (Q == null ? void 0 : Q.id)
      );
    }) }) })
  ] });
}, zj = ({
  onTitleClick: t,
  tableConfig: r,
  searchResultsFormatter: i
}) => {
  const { onAssignRecord: u } = dd(), { data: c, sourceData: v } = Eo(), { formatMessage: h } = La(), { checkFailedId: y } = O2(), g = k.useCallback(
    (T) => T == null ? void 0 : T.map((_) => {
      const L = { ..._ };
      return Object.entries(r.columns).forEach(([M, U]) => {
        L[M] = {
          ..._[M],
          children: U.formatter ? U.formatter({
            row: _,
            formatMessage: h,
            onAssign: u,
            onTitleClick: t,
            checkFailedId: y
          }) : _[M].label
        };
      }), L;
    }),
    [u, r]
  ), S = k.useMemo(
    () => g(i(c || [], v || [])),
    [g, c]
  ), x = k.useMemo(
    () => Object.keys(r.columns).reduce((T, _) => {
      const { label: L, position: M, className: U } = r.columns[_] || {};
      return T[_] = {
        label: L ? h({ id: L }) : "",
        position: M,
        className: U
      }, T;
    }, {}),
    [r]
  );
  return { formattedData: S, listHeader: x };
}, Wj = ({
  onTitleClick: t,
  tableConfig: r,
  searchResultsFormatter: i
}) => {
  const { listHeader: u, formattedData: c } = zj({
    onTitleClick: t,
    tableConfig: r,
    searchResultsFormatter: i
  });
  return /* @__PURE__ */ N.jsx("div", { className: "search-result-list", children: /* @__PURE__ */ N.jsx(Gj, { header: u, data: c, className: "results-list" }) });
};
const aT = (t) => t == null ? void 0 : t.replace(/\\/g, " "), Xj = ({ field: t }) => {
  var v;
  const r = Object.keys(t)[0], i = typeof t[r] != "string", u = t[r], c = i ? (v = u.subfields) == null ? void 0 : v.map((h, y) => {
    const g = Object.keys(h)[0], S = u.isHighlighted ? /* @__PURE__ */ N.jsx("mark", { children: h[g] }) : h[g];
    return /* @__PURE__ */ N.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ N.jsx("span", { children: "$" }),
      g,
      " ",
      S,
      " "
    ] }, `subfield-${y}-${g}`);
  }) : aT(t[r]);
  return /* @__PURE__ */ N.jsxs("tr", { className: "marc-field", "data-test-instance-marc-field": !0, children: [
    /* @__PURE__ */ N.jsx("td", { className: "field-code", children: r }),
    i && /* @__PURE__ */ N.jsx("td", { className: "field-indicators", children: `${aT(u == null ? void 0 : u.ind1)} ${aT(
      u == null ? void 0 : u.ind2
    )}` }),
    /* @__PURE__ */ N.jsx("td", { className: "field-contents", colSpan: i ? 2 : 3, children: c })
  ] });
}, j4 = ({ marc: t, ...r }) => {
  var u, c;
  const i = (u = t == null ? void 0 : t.parsedRecord) == null ? void 0 : u.content;
  return /* @__PURE__ */ N.jsx("section", { tabIndex: 0, ...r, children: /* @__PURE__ */ N.jsx("table", { children: /* @__PURE__ */ N.jsxs("tbody", { children: [
    /* @__PURE__ */ N.jsx("tr", { children: /* @__PURE__ */ N.jsx("td", { colSpan: 4, children: `LEADER ${i == null ? void 0 : i.leader}` }) }),
    (c = i == null ? void 0 : i.fields) == null ? void 0 : c.map((v) => /* @__PURE__ */ N.jsx(Xj, { field: v }, Object.keys(v)[0]))
  ] }) }) });
};
const Yj = ({ onClose: t }) => {
  const { onAssignRecord: r } = dd(), { formatMessage: i } = La(), { isMarcPreviewOpen: u } = Qa(), { complexValue: c, metadata: v } = ud(), { checkFailedId: h } = O2(), y = () => /* @__PURE__ */ N.jsx(
    Dn,
    {
      ariaLabel: i({ id: "ld.aria.complexLookup.marcPreview.close" }),
      "data-testid": "nav-close-button",
      type: Mn.Icon,
      onClick: t,
      className: "nav-close",
      children: /* @__PURE__ */ N.jsx(qs, {})
    }
  ), g = () => /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
    v == null ? void 0 : v.headingType,
    " • ",
    /* @__PURE__ */ N.jsx(mt, { id: "ld.lastUpdated" }),
    ":",
    /* @__PURE__ */ N.jsx("span", { className: "marc-preview-sub-label-date", children: /* @__PURE__ */ N.jsx(SF, { value: (c == null ? void 0 : c.metadata.updatedDate) ?? /* @__PURE__ */ new Date("now") }) })
  ] }), S = () => {
    r == null || r({
      id: (v == null ? void 0 : v.baseId) ?? "",
      title: (v == null ? void 0 : v.title) ?? "",
      linkedFieldValue: (v == null ? void 0 : v.headingType) ?? ""
    });
  }, x = h(v == null ? void 0 : v.baseId);
  return /* @__PURE__ */ N.jsx(N.Fragment, { children: u && c ? /* @__PURE__ */ N.jsxs("div", { className: "marc-preview-container", children: [
    /* @__PURE__ */ N.jsx(
      W2,
      {
        label: (v == null ? void 0 : v.title) ?? "",
        renderSubLabel: g,
        renderCloseButton: y,
        children: /* @__PURE__ */ N.jsx("div", { children: /* @__PURE__ */ N.jsx(
          Dn,
          {
            type: Mn.Highlighted,
            onClick: S,
            ariaLabel: i({ id: "ld.aria.marcAuthorityPreview.close" }),
            disabled: x,
            children: /* @__PURE__ */ N.jsx(mt, { id: "ld.assign" })
          }
        ) })
      }
    ),
    /* @__PURE__ */ N.jsxs("div", { className: "marc-preview-content", children: [
      /* @__PURE__ */ N.jsx("div", { className: "marc-preview-content-title", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.marcAuthorityRecord" }) }),
      /* @__PURE__ */ N.jsx(j4, { marc: c, className: "marc-contents" })
    ] })
  ] }) : null });
}, $j = ({
  row: t,
  onAssign: r,
  checkFailedId: i
}) => {
  const u = t.authorized.label === b2.Authorized, c = i(t.__meta.id);
  return u ? /* @__PURE__ */ N.jsx(
    Dn,
    {
      type: Mn.Primary,
      onClick: () => r({
        id: t.__meta.id,
        title: t.title.label || "",
        linkedFieldValue: t.subclass.label || ""
      }),
      "data-testid": `assign-button-${t.__meta.id}`,
      disabled: c,
      children: /* @__PURE__ */ N.jsx(mt, { id: "ld.assign" })
    }
  ) : null;
}, Zj = ({ row: t }) => {
  const r = t.authorized.label === b2.Authorized, { label: i } = t.authorized;
  return r ? /* @__PURE__ */ N.jsx("b", { children: i }) : /* @__PURE__ */ N.jsx("span", { children: i });
}, Jj = ({
  row: t,
  onTitleClick: r
}) => {
  const { __meta: i, title: u, subclass: c, authorized: v, authoritySource: h } = t, y = () => {
    r == null || r(i.id, u.label, c.label);
  };
  return i.isAnchor && !(c.label && v.label && h.label) ? /* @__PURE__ */ N.jsx("div", { className: "search-results-item-missing-match", children: /* @__PURE__ */ N.jsx(
    mt,
    {
      id: "ld.searchQueryWouldBeHere",
      values: {
        query: /* @__PURE__ */ N.jsx("span", { className: "search-results-item-missing-match-query", children: t.title.label })
      }
    }
  ) }) : /* @__PURE__ */ N.jsx(Dn, { type: Mn.Link, className: "search-results-item-title", onClick: y, children: i.isAnchor ? /* @__PURE__ */ N.jsx("strong", { children: t.title.label }) : t.title.label });
}, W_ = {
  columns: {
    assign: {
      label: "",
      position: 0,
      className: "cell-fixed cell-fixed-100",
      formatter: $j
    },
    authorized: {
      label: "ld.authorizedReference",
      position: 1,
      className: "cell-fixed cell-fixed-170",
      formatter: Zj
    },
    title: {
      label: "ld.headingReference",
      position: 2,
      className: "cell-fixed cell-fixed-370",
      formatter: Jj
    },
    subclass: {
      label: "ld.typeOfHeading",
      position: 3,
      className: "cell-fixed cell-fixed-140"
    },
    authoritySource: {
      label: "ld.authoritySource",
      position: 4,
      className: "cell-fixed cell-fixed-250"
    }
  }
}, X_ = {
  default: W_,
  authorities: W_
};
const Qj = k.memo(
  ({
    isOpen: t,
    onAssign: r,
    onClose: i,
    value: u,
    assignEntityName: c = s0.Authorities,
    baseLabelType: v = A2.Creator
  }) => {
    var st, We, he, ke;
    const {
      api: h,
      segments: y,
      labels: g,
      searchBy: S,
      searchableIndicesMap: x,
      filters: T = []
    } = OO[c], _ = X_[c] || X_.default, L = f_[c] || f_.default, M = p_[c] || p_.default, { setQuery: U, resetQuery: B } = Eo(), { getFacetsData: H, getSourceData: Y } = uU(h, T), { setIsMarcPreviewOpen: G } = Qa(), {
      setComplexValue: Q,
      resetComplexValue: W,
      setMetadata: oe,
      resetMetadata: j
    } = ud(), { fetchMarcData: re } = T2(Q);
    k.useEffect(() => {
      if (!u) {
        B();
        return;
      }
      U(u);
    }, [u]);
    const me = () => {
      G(!1);
    }, Se = () => {
      me(), W(), j(), i();
    }, Ne = (_e) => /* @__PURE__ */ N.jsx(
      mt,
      {
        id: "ld.recordsFound",
        values: {
          recordsCount: /* @__PURE__ */ N.jsx(xF, { value: _e, "data-testid": "records-found-count" })
        }
      }
    ), Ge = k.useCallback(
      () => /* @__PURE__ */ N.jsx(
        W2,
        {
          label: /* @__PURE__ */ N.jsx(mt, { id: g.modal.searchResults }),
          renderSubLabel: Ne,
          segmentsConfig: y.primary
        }
      ),
      [g.modal.searchResults]
    ), ze = k.useCallback(
      async (_e, q, pe) => {
        const $e = await re(_e, h.endpoints.marcPreview);
        $e && q && pe && (oe({ baseId: _e, marcId: $e.id, srsId: $e.matchedId, title: q, headingType: pe }), G(!0));
      },
      [h.endpoints.marcPreview]
    ), qe = k.useCallback(
      () => /* @__PURE__ */ N.jsx(
        Wj,
        {
          onTitleClick: ze,
          tableConfig: _,
          searchResultsFormatter: L
        }
      ),
      [ze, _, L]
    ), at = k.useCallback(() => /* @__PURE__ */ N.jsx(Yj, { onClose: me }), []);
    return /* @__PURE__ */ N.jsx(
      qg,
      {
        isOpen: t,
        title: /* @__PURE__ */ N.jsx(mt, { id: g.modal.title[v] }),
        onClose: Se,
        titleClassName: "modal-complex-lookup-title",
        showModalControls: !1,
        className: In(["modal-complex-lookup", "modal-complex-lookup-embedded"]),
        classNameHeader: In([
          "modal-complex-lookup-header",
          "modal-complex-lookup-header-embedded"
        ]),
        children: /* @__PURE__ */ N.jsx("div", { className: "complex-lookup-search-contents", "data-testid": "complex-lookup-search-contents", children: /* @__PURE__ */ N.jsx(
          V4,
          {
            endpointUrl: h.endpoints.base,
            endpointUrlsBySegments: h.endpoints.bySearchSegment,
            primarySegments: y == null ? void 0 : y.primary,
            searchFilter: h.searchQuery.filter,
            isSortedResults: !1,
            filters: T,
            hasSearchParams: !1,
            defaultNavigationSegment: ((st = y.defaultValues) == null ? void 0 : st.segment) ?? bo.Search,
            defaultSearchBy: ((We = y.defaultValues) == null ? void 0 : We.searchBy) ?? ((ke = (he = S[bo.Search]) == null ? void 0 : he[0]) == null ? void 0 : ke.value),
            defaultQuery: u,
            renderSearchControlPane: Ge,
            renderResultsList: qe,
            renderMarcPreview: at,
            isVisibleFilters: !1,
            isVisibleFullDisplay: !1,
            isVisibleAdvancedSearch: !1,
            isVisibleSearchByControl: !0,
            isVisibleSegments: !0,
            hasMultilineSearchInput: !0,
            hasMarcPreview: !0,
            hasCustomPagination: !0,
            searchByControlOptions: S,
            searchableIndicesMap: x,
            labelEmptySearch: "ld.chooseFilterOrEnterSearchQuery",
            classNameEmptyPlaceholder: "complex-lookup-search-empty",
            getSearchSourceData: Y,
            getSearchFacetsData: H,
            fetchSearchResults: iU,
            buildSearchQuery: M,
            searchResultsLimit: h.searchQuery.limit,
            precedingRecordsCount: h.searchQuery.precedingRecordsCount,
            searchResultsContainer: h.results.containers,
            onAssignRecord: r
          }
        ) })
      }
    );
  }
), Kj = ({
  id: t,
  label: r,
  handleDelete: i,
  noWarningValue: u
}) => {
  const { formatMessage: c } = La(), v = u !== void 0 && !u;
  return /* @__PURE__ */ N.jsxs(
    "div",
    {
      className: In([
        "complex-lookup-selected",
        "complex-lookup-selected-embedded",
        v && "complex-lookup-selected-withWarning"
      ]),
      "data-testid": "complex-lookup-selected",
      children: [
        /* @__PURE__ */ N.jsx("span", { className: "complex-lookup-selected-label", "data-testid": "complex-lookup-selected-label", children: r }),
        v && /* @__PURE__ */ N.jsx(cO, { className: "complex-lookup-selected-icon-warning" }),
        /* @__PURE__ */ N.jsx(
          "button",
          {
            onClick: () => i(t),
            className: "complex-lookup-selected-delete",
            "data-testid": "complex-lookup-selected-delete",
            "aria-label": c({ id: "ld.aria.edit.removeComplexLookupFieldValue" }),
            children: /* @__PURE__ */ N.jsx(qs, {})
          }
        )
      ]
    },
    t
  );
};
const qj = ({ value: t = void 0, id: r, entry: i, onChange: u }) => {
  var U, B;
  const { layout: c, htmlId: v } = i, h = OO[c == null ? void 0 : c.api], y = (U = h == null ? void 0 : h.labels) == null ? void 0 : U.button, { localValue: g, isModalOpen: S, openModal: x, closeModal: T, handleDelete: _, handleAssign: L, handleOnChangeBase: M } = q8({
    entry: i,
    value: t,
    lookupConfig: h,
    authority: c == null ? void 0 : c.baseLabelType,
    onChange: u
  });
  return /* @__PURE__ */ N.jsx(N.Fragment, { children: c != null && c.isNew ? /* @__PURE__ */ N.jsxs("div", { id: r, className: "complex-lookup", children: [
    !!g.length && /* @__PURE__ */ N.jsx("div", { className: "complex-lookup-value", "data-testid": "complex-lookup-value", children: g == null ? void 0 : g.map(({ id: H, label: Y, meta: G }) => /* @__PURE__ */ N.jsx(
      Kj,
      {
        id: H,
        label: Y,
        handleDelete: _,
        noWarningValue: G == null ? void 0 : G.isPreferred
      },
      H
    )) }),
    /* @__PURE__ */ N.jsx(
      "button",
      {
        "data-testid": UT(CC.ChangeComplexFieldValue, r),
        className: "complex-lookup-select-button button-passive",
        onClick: x,
        children: /* @__PURE__ */ N.jsx(mt, { id: g != null && g.length ? y == null ? void 0 : y.change : y == null ? void 0 : y.base })
      }
    ),
    /* @__PURE__ */ N.jsx(
      Qj,
      {
        value: (B = g == null ? void 0 : g[0]) == null ? void 0 : B.label,
        isOpen: S,
        onClose: T,
        onAssign: L,
        assignEntityName: c.api,
        baseLabelType: c.baseLabelType
      }
    )
  ] }) : /* @__PURE__ */ N.jsx(
    BC,
    {
      id: r,
      onChange: M,
      value: (g == null ? void 0 : g.map(({ label: H }) => H).join(Y8)) ?? "",
      disabled: !0,
      "data-testid": "complex-lookup-input",
      ariaLabelledBy: v
    }
  ) });
}, eG = ({
  options: t,
  uuid: r,
  id: i,
  htmlId: u,
  onChange: c,
  value: v,
  isDisabled: h = !1,
  "data-testid": y = "dropdown-field"
}) => {
  const [g, S] = k.useState(v);
  k.useEffect(() => {
    S(v);
  }, [v]);
  const x = (T) => {
    c(T, r, !0), S(T);
  };
  return /* @__PURE__ */ N.jsx(
    Qy,
    {
      id: i,
      options: t,
      onChange: x,
      value: g,
      disabled: h,
      className: "edit-section-field-input dropdown-field",
      "data-testid": y,
      ariaLabelledBy: u
    }
  );
}, tG = ({
  schema: t,
  entry: r,
  level: i,
  isDisabled: u
}) => {
  const { type: c, children: v } = r;
  let h = i === gm && !u;
  if (h) {
    const y = c === At.group, g = R8(t, v);
    y && !g && (h = g);
  }
  return h;
}, nG = ({
  schema: t,
  entry: r,
  isDisabled: i
}) => {
  const { type: u, path: c, constraints: v } = r;
  return !!(!i && (v == null ? void 0 : v.repeatable) && // show "Duplicate" button only for Provision Activity's subcomponents
  // change or remove to display "Duplicate" button for other groups
  IO({
    schema: t,
    path: c,
    key: "uriBFLite",
    value: Le.PROVISION_ACTIVITY
  }) && // remove this condition after updating the profile
  u === At.literal) && Jy.includes(u);
}, rG = () => {
  const { selectedEntriesService: t, schemaWithDuplicatesService: r } = xm(), { setCollapsibleEntries: i } = Qa(), { setUserValues: u, setSelectedEntries: c } = Ea(), { setIsRecordEdited: v } = Si(), { schema: h, setSchema: y } = cd();
  return { getSchemaWithCopiedEntries: (x, T) => {
    t.set(T), r.set(h);
    const _ = r.duplicateEntry(x);
    c(t.get()), i((L) => new Set(_ ? [...L, x.uuid, _] : [...L, x.uuid])), y(r.get()), v(!0);
  }, getSchemaWithDeletedEntries: (x) => {
    r.set(h);
    const T = r.deleteEntry(x);
    i((_) => _O(_, [x.uuid])), y(r.get()), u((_) => Object.fromEntries(Object.entries(_).filter(([L]) => !(T != null && T.includes(L))))), v(!0);
  } };
}, aG = (t) => /* @__PURE__ */ k.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("rect", { x: 5.20898, y: 0.5, width: 6.27871, height: 2.08696, rx: 1.04348, fill: "black", fillOpacity: 0.62 }), /* @__PURE__ */ k.createElement("rect", { x: 8.34863, y: 6.06525, width: 6.95652, height: 2.35451, rx: 1.17726, transform: "rotate(90 8.34863 6.06525)", fill: "black", fillOpacity: 0.62 }), /* @__PURE__ */ k.createElement("rect", { x: 11.4873, y: 6.06519, width: 6.95652, height: 2.35451, rx: 1.17726, transform: "rotate(90 11.4873 6.06519)", fill: "black", fillOpacity: 0.62 }), /* @__PURE__ */ k.createElement("rect", { x: 0.5, y: 3.28259, width: 15.6968, height: 2.08696, rx: 1.04348, fill: "black", fillOpacity: 0.62 }), /* @__PURE__ */ k.createElement("path", { d: "M4.81643 5.36957L2.46191 5.36957L2.46192 14.413C2.46192 14.413 2.46192 15.1087 3.24675 15.8044C4.03159 16.5 4.42401 16.5 4.42401 16.5L12.2724 16.5C12.2724 16.5 13.0572 16.5 13.8421 15.8043C14.6269 15.1087 14.6269 14.413 14.6269 14.413L14.6269 5.36957L12.2724 5.36957L12.2724 14.413L4.81643 14.413L4.81643 5.36957Z", fill: "black", fillOpacity: 0.62 }));
const QT = k.memo(
  ({ onClickDuplicate: t, onClickDelete: r, hasDeleteButton: i = !0, className: u, htmlId: c, deleteDisabled: v = !0 }) => {
    const { formatMessage: h } = La();
    return /* @__PURE__ */ N.jsxs("div", { className: In(["duplicate-group", u]), children: [
      /* @__PURE__ */ N.jsx(
        Dn,
        {
          "data-testid": UT(CC.Duplicate, c),
          type: Mn.Icon,
          onClick: t,
          ariaLabel: h({ id: "ld.aria.edit.duplicateComponent" }),
          children: /* @__PURE__ */ N.jsx(z2, {})
        }
      ),
      i && /* @__PURE__ */ N.jsx(
        Dn,
        {
          "data-testid": UT(CC.RemoveDuplicate, c),
          type: Mn.Icon,
          disabled: v,
          onClick: r,
          ariaLabel: h({ id: "ld.aria.edit.deleteComponent" }),
          children: /* @__PURE__ */ N.jsx(aG, {})
        }
      )
    ] });
  }
), iG = k.memo(
  ({
    children: t,
    entry: { deletable: r },
    displayName: i,
    showLabel: u,
    labelContainerClassName: c,
    htmlId: v,
    hasDuplicateGroupButton: h,
    onClickDuplicateGroup: y,
    onClickDeleteGroup: g
  }) => /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
    i && u && /* @__PURE__ */ N.jsx("div", { id: v, className: In("label", c), children: i }),
    /* @__PURE__ */ N.jsx("div", { className: "children-container", "data-testid": v, children: t }),
    h && /* @__PURE__ */ N.jsx(
      QT,
      {
        deleteDisabled: !r,
        htmlId: v,
        onClickDuplicate: y,
        onClickDelete: g
      }
    )
  ] })
), oG = k.memo(
  ({
    children: t,
    entry: { type: r, deletable: i },
    htmlId: u,
    displayName: c,
    showLabel: v,
    labelContainerClassName: h,
    hasDuplicateGroupButton: y,
    hasDuplicateSubcomponentButton: g,
    onClickDuplicateGroup: S,
    onClickDeleteGroup: x
  }) => /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
    /* @__PURE__ */ N.jsxs("div", { id: u, className: In({ "extended-layout-meta": y }), children: [
      c && v && /* @__PURE__ */ N.jsx("div", { className: In("label", h), children: c }),
      y && /* @__PURE__ */ N.jsx(
        QT,
        {
          htmlId: u,
          deleteDisabled: !i,
          onClickDuplicate: S,
          onClickDelete: x
        }
      )
    ] }),
    t && /* @__PURE__ */ N.jsxs("div", { className: "children-container", "data-testid": u, children: [
      r === At.dropdown && y && /* @__PURE__ */ N.jsx("div", { className: "label", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.type" }) }),
      t
    ] }),
    g && /* @__PURE__ */ N.jsx(
      QT,
      {
        htmlId: u,
        onClickDuplicate: S,
        hasDeleteButton: !1,
        className: "duplicate-subcomponent"
      }
    )
  ] })
);
const Bg = ({
  children: t,
  isCompact: r = !1,
  entry: i,
  className: u,
  labelContainerClassName: c,
  level: v,
  showLabel: h = !0,
  disabled: y = !1,
  ...g
}) => {
  const { schema: S } = cd(), { selectedEntries: x } = Ea(), { getSchemaWithCopiedEntries: T, getSchemaWithDeletedEntries: _ } = rG(), { uuid: L, displayName: M, htmlId: U } = i, B = tG({ schema: S, entry: i, level: v, isDisabled: y }), H = nG({ schema: S, entry: i, isDisabled: y }), Q = {
    entry: i,
    displayName: M,
    showLabel: h,
    htmlId: U,
    labelContainerClassName: c,
    hasDuplicateGroupButton: B,
    hasDuplicateSubcomponentButton: H,
    onClickDuplicateGroup: () => {
      T(i, x);
    },
    onClickDeleteGroup: () => {
      _(i);
    }
  };
  return /* @__PURE__ */ N.jsx(
    "div",
    {
      className: In(
        "field-with-meta-controls-container",
        { "field-with-meta-controls-container-extended": !r && B },
        u
      ),
      id: L,
      "data-testid": `field-with-meta-controls-${L}`,
      ...g,
      children: r ? /* @__PURE__ */ N.jsx(iG, { ...Q, children: t }) : /* @__PURE__ */ N.jsx(oG, { ...Q, children: t })
    }
  );
}, lG = ({
  uuid: t,
  htmlId: r,
  value: i = "",
  id: u,
  isDisabled: c = !1,
  onChange: v,
  "data-testid": h = "literal-field"
}) => {
  const [y, g] = k.useState(i), S = ({ target: { value: x } }) => {
    g(x), v(t, [{ label: x }]);
  };
  return /* @__PURE__ */ N.jsx(
    BC,
    {
      id: u,
      className: "edit-section-field-input",
      "data-testid": h,
      onChange: S,
      value: y,
      disabled: c,
      ariaLabelledBy: r
    }
  );
}, sG = ({
  schema: t,
  entry: r,
  disabledFields: i,
  level: u = 0,
  isCompact: c = !1,
  selectedEntriesService: v,
  selectedEntries: h,
  setSelectedEntries: y,
  userValues: g,
  collapsedEntries: S,
  collapsibleEntries: x,
  onChange: T,
  handleGroupsCollapseExpand: _
}) => {
  var oe, j;
  const { uuid: L, displayName: M = "", type: U, children: B, constraints: H, htmlId: Y } = r, G = !!(i != null && i.get(L)), Q = oO[M] || M, W = g[L];
  if (U === At.block)
    return /* @__PURE__ */ N.jsxs(
      Bg,
      {
        entry: r,
        level: u,
        isCompact: c,
        showLabel: !1,
        className: "entity-heading",
        children: [
          /* @__PURE__ */ N.jsx("strong", { className: "heading", children: Q }),
          !!x.size && /* @__PURE__ */ N.jsx(Dn, { className: "toggle-expansion-button", type: Mn.Link, onClick: _, children: /* @__PURE__ */ N.jsx(mt, { id: S.size ? "ld.expandAll" : "ld.collapseAll" }) })
        ]
      }
    );
  if ((U === At.group || U === At.groupComplex) && u < jB) {
    const re = U === At.groupComplex;
    return /* @__PURE__ */ N.jsx(Bg, { entry: r, level: u, isCompact: c, showLabel: re, children: !re && /* @__PURE__ */ N.jsx("span", { className: "group-label", children: Q }) });
  }
  if (U === At.literal)
    return /* @__PURE__ */ N.jsx(Bg, { entry: r, level: u, isCompact: c, children: /* @__PURE__ */ N.jsx(
      lG,
      {
        uuid: L,
        htmlId: Y,
        value: W == null ? void 0 : W.contents[0].label,
        onChange: T,
        isDisabled: G
      }
    ) });
  if (U === At.dropdown && B) {
    const re = B.map((Ne) => t.get(Ne)).map((Ne) => ({
      label: (Ne == null ? void 0 : Ne.displayName) ?? "",
      value: (Ne == null ? void 0 : Ne.uri) ?? "",
      // TBD
      uri: (Ne == null ? void 0 : Ne.uri) ?? "",
      id: Ne == null ? void 0 : Ne.uuid
    })), me = re == null ? void 0 : re.find(({ id: Ne }) => Ne && h.includes(Ne)), Se = (Ne) => {
      v.addNew(me == null ? void 0 : me.id, Ne.id), y(v.get());
    };
    return /* @__PURE__ */ N.jsx(Bg, { entry: r, level: u, isCompact: c, children: /* @__PURE__ */ N.jsx(
      eG,
      {
        options: re,
        uuid: L,
        htmlId: Y,
        onChange: Se,
        value: me,
        isDisabled: G || ((oe = r == null ? void 0 : r.layout) == null ? void 0 : oe.readOnly)
      }
    ) });
  }
  if (U === At.simple) {
    const re = IO({
      schema: t,
      path: r.path,
      key: "type",
      value: At.block
    });
    return /* @__PURE__ */ N.jsx(Bg, { entry: r, level: u, isCompact: c, children: /* @__PURE__ */ N.jsx(
      fj,
      {
        uri: (H == null ? void 0 : H.useValuesFrom[0]) ?? "",
        uuid: L,
        htmlId: Y,
        onChange: T,
        parentUri: (j = H == null ? void 0 : H.valueDataType) == null ? void 0 : j.dataTypeURI,
        value: W == null ? void 0 : W.contents,
        isDisabled: G,
        propertyUri: r.uri,
        parentBlockUri: re == null ? void 0 : re.uriBFLite
      }
    ) });
  }
  return U === At.complex ? /* @__PURE__ */ N.jsx(Bg, { entry: r, level: u, isCompact: c, children: /* @__PURE__ */ N.jsx(qj, { entry: r, onChange: T, value: W == null ? void 0 : W.contents }) }) : null;
}, uG = (t) => ({ schema: r, entry: i, disabledFields: u, level: c = 0, isCompact: v = !1 }) => /* @__PURE__ */ N.jsx(
  sG,
  {
    schema: r,
    entry: i,
    disabledFields: u,
    level: c,
    isCompact: v,
    ...t
  }
);
const cG = 100, fG = k.memo(() => {
  const { selectedEntriesService: t } = xm(), { selectedProfile: r, initialSchemaKey: i } = cd(), u = r == null ? void 0 : r.json.Profile.resourceTemplates, { userValues: c, addUserValuesItem: v, selectedEntries: h, setSelectedEntries: y } = Ea(), { isRecordEdited: g, setIsRecordEdited: S } = Si(), { collapsedEntries: x, setCollapsedEntries: T, collapsibleEntries: _, currentlyEditedEntityBfid: L } = Qa();
  Sm({ watchEditedState: !0 });
  const M = k.useRef(
    Qc.debounce((Y) => {
      v == null || v(Y);
    }, cG)
  ).current, H = uG({
    selectedEntriesService: t,
    selectedEntries: h,
    setSelectedEntries: y,
    userValues: c,
    collapsedEntries: x,
    collapsibleEntries: _,
    onChange: (Y, G) => {
      g || S(!0), M({
        [Y]: {
          uuid: Y,
          contents: G
        }
      });
    },
    handleGroupsCollapseExpand: () => T(x.size ? /* @__PURE__ */ new Set([]) : _)
  });
  return u ? /* @__PURE__ */ N.jsxs(
    "div",
    {
      id: iO,
      className: In("edit-section", {
        "edit-section-passive": L.has(Xu.WORK)
      }),
      children: [
        /* @__PURE__ */ N.jsx(W8, { when: g }),
        /* @__PURE__ */ N.jsx(
          HT,
          {
            drawComponent: H,
            uuid: i,
            groupClassName: "edit-section-group",
            scrollToEnabled: !0
          }
        )
      ]
    }
  ) : null;
}), dG = () => document.getElementById(PF), pG = (t) => {
  var r;
  return (r = dG()) == null ? void 0 : r.scrollTo(t);
}, hG = () => {
  const { recordStatus: t, setRecordStatus: r } = Si(), [i, u] = k.useState(null), { resourceId: c } = Cm(), v = () => r({ type: od.open });
  k.useEffect(() => {
    (!(t != null && t.type) || !i) && v(), c ? (i && i !== c && v(), u(c)) : v();
  }, [c]);
};
const vG = {
  title: {
    label: /* @__PURE__ */ N.jsx(mt, { id: "ld.title" }),
    position: 0
  },
  publisher: {
    label: /* @__PURE__ */ N.jsx(mt, { id: "ld.publisher" }),
    position: 1
  },
  pubDate: {
    label: /* @__PURE__ */ N.jsx(mt, { id: "ld.year" }),
    position: 2
  },
  editCtl: {
    position: 3
  }
}, mG = ({ contents: { keys: t, entries: r } = {}, type: i, refId: u }) => {
  const { getRecordAndInitializeParsing: c } = Tp(), { navigateToEditPage: v } = fd(), h = () => i && u && v(`${Va.RESOURCE_CREATE.uri}?${Mi.Type}=${i}&${Mi.Ref}=${u}`), g = ((S) => S.map((x) => {
    const T = () => (t == null ? void 0 : t.uri) && c({
      recordId: x.__meta.id,
      cachedRecord: yO({ [t == null ? void 0 : t.uri]: x.__meta }),
      previewParams: { singular: !0, noStateUpdate: !0 }
    }), _ = () => {
      var L;
      return v(Kh((L = x.__meta) == null ? void 0 : L.id));
    };
    return {
      ...x,
      title: {
        ...x.title,
        children: /* @__PURE__ */ N.jsx(Dn, { type: Mn.Link, onClick: T, "data-testid": `preview-button__${x.__meta.id}`, children: x.title.label })
      },
      editCtl: {
        className: "edit-ctl",
        children: /* @__PURE__ */ N.jsx(Dn, { type: Mn.Primary, onClick: _, "data-testid": `edit-button__${x.__meta.id}`, children: /* @__PURE__ */ N.jsx(mt, { id: "ld.edit" }) })
      }
    };
  }))(i8(r ?? []));
  return /* @__PURE__ */ N.jsxs("div", { className: "instances-list", "data-testid": "instances-list", children: [
    /* @__PURE__ */ N.jsxs("div", { className: "instances-list-header", children: [
      /* @__PURE__ */ N.jsx("h3", { children: /* @__PURE__ */ N.jsx(mt, { id: "ld.instances" }) }),
      /* @__PURE__ */ N.jsx(Dn, { type: Mn.Primary, onClick: h, disabled: !u, "data-testid": "new-instance", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.newInstance" }) })
    ] }),
    r != null && r.length ? /* @__PURE__ */ N.jsx(H4, { header: vG, data: g }) : /* @__PURE__ */ N.jsx("div", { className: "no-instances", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.noInstancesAdded" }) })
  ] });
}, gG = ({
  showCloseCtl: t = !0,
  ownId: r,
  refId: i,
  type: u,
  previewContent: c,
  onClickClose: v
}) => {
  const { formatMessage: h } = La(), { navigateToEditPage: y } = fd(), { title: g, id: S, base: x, initKey: T, userValues: _ } = c ?? {}, L = S ?? r, M = /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
    t ? /* @__PURE__ */ N.jsx(
      Dn,
      {
        "data-testid": "nav-close-button",
        type: Mn.Icon,
        onClick: v,
        ariaLabel: h({ id: "ld.aria.resourcePreview.close" }),
        children: /* @__PURE__ */ N.jsx(qs, {})
      }
    ) : /* @__PURE__ */ N.jsx("span", { className: "empty-block" }),
    /* @__PURE__ */ N.jsx("div", { className: "details", children: g && /* @__PURE__ */ N.jsx("h5", { children: g }) })
  ] }), U = () => L && y(Kh(L));
  return /* @__PURE__ */ N.jsxs("div", { className: "titled-preview", children: [
    /* @__PURE__ */ N.jsxs("div", { className: In("titled-preview-header", { "titled-preview-header-plain": !c }), children: [
      c ? M : /* @__PURE__ */ N.jsx("h3", { children: /* @__PURE__ */ N.jsx(mt, { id: `ld.${u}`, defaultMessage: "Resource" }) }),
      u === Co.work && !c && /* @__PURE__ */ N.jsx(
        Dn,
        {
          type: Mn.Primary,
          className: "toggle-entity-edit",
          "data-testid": "edit-self-as-ref",
          onClick: U,
          children: /* @__PURE__ */ N.jsx(mt, { id: "ld.editWork" })
        }
      ),
      u === Co.instance && /* @__PURE__ */ N.jsx(
        U4,
        {
          ownId: L,
          referenceId: i,
          entityType: u,
          handleNavigateToEditPage: U
        }
      )
    ] }),
    /* @__PURE__ */ N.jsx(WC, { altInitKey: T, altSchema: x, altUserValues: _, hideEntities: !0 })
  ] });
};
const bG = k.memo(() => {
  var M, U, B, H, Y;
  const { record: t, previewContent: r, setPreviewContent: i, resetPreviewContent: u } = Ea(), { currentlyPreviewedEntityBfid: c } = Qa(), v = mm(q9), { resourceId: h } = Cm(), [y] = qc(), g = c.has(Xu.INSTANCE) && c.values.length <= 1, S = y.get(Mi.Type), x = v && S === Co.work, T = V6(t), _ = ((M = T == null ? void 0 : T.entries) == null ? void 0 : M.length) === 1 && !x || r.length, L = r == null ? void 0 : r[0];
  return k.useEffect(() => {
    u();
  }, [h]), /* @__PURE__ */ N.jsx(
    "div",
    {
      className: In("preview-container", {
        "positioned-second": g
      }),
      children: _ ? /* @__PURE__ */ N.jsx(
        gG,
        {
          ownId: (H = (B = (U = T == null ? void 0 : T.entries) == null ? void 0 : U[0]) == null ? void 0 : B.id) == null ? void 0 : H.toString(),
          refId: h ?? y.get(Mi.Ref),
          type: T == null ? void 0 : T.type,
          previewContent: L,
          onClickClose: () => i((G) => G.filter(({ id: Q }) => Q !== L.id)),
          showCloseCtl: (((Y = T == null ? void 0 : T.entries) == null ? void 0 : Y.length) ?? 0) > 1
        }
      ) : /* @__PURE__ */ N.jsx(mG, { type: T == null ? void 0 : T.type, refId: h, contents: T })
    }
  );
});
const yG = () => {
  const { basicValue: t } = ud();
  return t && /* @__PURE__ */ N.jsx("div", { className: "view-marc-modal", children: /* @__PURE__ */ N.jsx(j4, { marc: t, className: "marc-contents" }) });
};
const CG = [od.saveAndClose, od.saveAndKeepEditing], EG = () => {
  const { getProfiles: t } = xO(), { fetchRecord: r, clearRecordState: i, fetchRecordAndSelectEntityValues: u } = Tp(), c = u8(), { resetRecord: v, resetUserValues: h, resetSelectedEntries: y } = Ea(), { recordStatus: g, addStatusMessagesItem: S } = Si(), { basicValue: x, resetBasicValue: T } = ud(), _ = g == null ? void 0 : g.type, { setIsLoading: L } = qu(), { setCurrentlyEditedEntityBfid: M, setCurrentlyPreviewedEntityBfid: U, resetHasShownAuthorityWarning: B } = Qa(), H = new URLSearchParams(window.location.search), Y = H.get(Mi.CloneOf), G = H.get(Mi.Type), Q = H.get(Mi.Ref), W = k.useRef(null), oe = k.useRef(null);
  function j() {
    const me = (G || Co.instance) === Co.instance, Se = me ? Xu.INSTANCE : Xu.WORK, Ne = me ? Xu.WORK : Xu.INSTANCE;
    M(/* @__PURE__ */ new Set([Se])), U(/* @__PURE__ */ new Set([Ne]));
  }
  return hG(), k.useEffect(() => {
    T(), pG({ top: 0, behavior: "instant" });
    async function re() {
      if (!(c ?? Y))
        try {
          L(!0), await t({}), j();
        } catch {
          S == null || S(Ei.createMessage(Tr.error, "ld.errorFetching"));
        } finally {
          L(!1);
        }
    }
    return re(), () => {
      v(), h(), y(), B();
    };
  }, []), k.useEffect(() => {
    B();
  }, [c]), k.useEffect(() => {
    async function re() {
      if (!_ || CG.includes(_))
        return;
      const me = c ?? Y;
      if (!(!Y && c && W.current === c || Y && oe.current === Y || !me && !Q)) {
        L(!0);
        try {
          if (me) {
            oe.current = Y, W.current = c, await r(me);
            return;
          }
          const Se = G || Co.instance, Ne = Q;
          j(), i();
          let Ge = null;
          Ne && (Ge = await u(
            Ne,
            Se.toUpperCase()
          )), await t({
            record: Ge
          });
        } catch {
          S == null || S(Ei.createMessage(Tr.error, "ld.errorLoadingResource"));
        } finally {
          L(!1);
        }
      }
    }
    re();
  }, [c, _, Y, G, Q]), /* @__PURE__ */ N.jsxs("div", { "data-testid": "edit-page", className: "edit-page", children: [
    !x && /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
      /* @__PURE__ */ N.jsx(bG, {}),
      /* @__PURE__ */ N.jsx(fG, {})
    ] }),
    /* @__PURE__ */ N.jsx(yG, {})
  ] });
}, Y_ = () => {
  const [t] = qc();
  return /* @__PURE__ */ N.jsx(EG, {}, t.get(Mi.Type));
};
const SG = ({
  id: t,
  contributors: r,
  languages: i,
  classifications: u,
  isOpen: c,
  toggleIsOpen: v,
  handleOpenPreview: h,
  titles: y
}) => {
  var M, U;
  const { formatMessage: g } = La(), { navigateToEditPage: S } = fd(), x = LO(y), T = (M = r == null ? void 0 : r.find(({ isCreator: B }) => B)) == null ? void 0 : M.name, _ = i == null ? void 0 : i.find((B) => B), L = (U = u == null ? void 0 : u.find(
    ({ number: B, source: H }) => B && (H === LT.DDC || H === LT.LC)
  )) == null ? void 0 : U.number;
  return /* @__PURE__ */ N.jsxs("div", { className: "work-details-card", children: [
    /* @__PURE__ */ N.jsxs("div", { className: "heading", children: [
      /* @__PURE__ */ N.jsx(
        Dn,
        {
          type: Mn.Ghost,
          onClick: v,
          "data-testid": "work-details-card-toggle",
          ariaLabel: g({ id: c ? "ld.aria.listEntry.close" : "ld.aria.listEntry.open" }),
          children: /* @__PURE__ */ N.jsx(zC, { className: In({ "icon-collapsed": !c }, "toggle-icon") })
        }
      ),
      /* @__PURE__ */ N.jsxs("div", { className: "title", children: [
        /* @__PURE__ */ N.jsx(M4, {}),
        /* @__PURE__ */ N.jsx("span", { children: /* @__PURE__ */ N.jsx(mt, { id: "ld.work" }) })
      ] }),
      /* @__PURE__ */ N.jsx(
        Dn,
        {
          type: Mn.Primary,
          onClick: () => S(Kh(t)),
          "data-testid": `edit-button__${t}`,
          className: In(["edit-button", "button-nowrap", "button-capitalize"]),
          children: /* @__PURE__ */ N.jsx(mt, { id: "ld.editWork" })
        }
      )
    ] }),
    /* @__PURE__ */ N.jsxs("div", { className: "details", children: [
      /* @__PURE__ */ N.jsx(
        Dn,
        {
          type: Mn.Ghost,
          onClick: () => h == null ? void 0 : h(t),
          className: "title",
          "data-testid": `preview-button__${t}`,
          children: x || /* @__PURE__ */ N.jsxs(N.Fragment, { children: [
            "<",
            /* @__PURE__ */ N.jsx(mt, { id: "ld.noTitleInBrackets" }),
            ">"
          ] })
        }
      ),
      T && /* @__PURE__ */ N.jsxs("div", { className: "details-item", children: [
        /* @__PURE__ */ N.jsx("span", { children: /* @__PURE__ */ N.jsx(mt, { id: "ld.creator" }) }),
        /* @__PURE__ */ N.jsx("span", { children: T })
      ] }),
      _ && /* @__PURE__ */ N.jsxs("div", { className: "details-item", children: [
        /* @__PURE__ */ N.jsx("span", { children: /* @__PURE__ */ N.jsx(mt, { id: "ld.language" }) }),
        /* @__PURE__ */ N.jsx("span", { children: _ })
      ] }),
      L && /* @__PURE__ */ N.jsxs("div", { className: "details-item", children: [
        /* @__PURE__ */ N.jsx("span", { children: /* @__PURE__ */ N.jsx(mt, { id: "ld.classificationNumber" }) }),
        /* @__PURE__ */ N.jsx("span", { children: L })
      ] })
    ] })
  ] });
}, xG = (t) => /* @__PURE__ */ k.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ k.createElement("g", { clipPath: "url(#clip0_4948_2360)" }, /* @__PURE__ */ k.createElement("path", { d: "M8.62497 3.9375H3.37497C3.16872 3.9375 2.99997 4.10625 2.99997 4.3125V4.6875C2.99997 4.89375 3.16872 5.0625 3.37497 5.0625H8.62497C8.83122 5.0625 8.99997 4.89375 8.99997 4.6875V4.3125C8.99997 4.10625 8.83122 3.9375 8.62497 3.9375ZM6.37497 6.1875H3.37497C3.16872 6.1875 2.99997 6.35625 2.99997 6.5625V6.9375C2.99997 7.14375 3.16872 7.3125 3.37497 7.3125H6.37497C6.58122 7.3125 6.74997 7.14375 6.74997 6.9375V6.5625C6.74997 6.35625 6.58122 6.1875 6.37497 6.1875ZM5.99997 0.75C2.68591 0.75 -3.14093e-05 2.93203 -3.14093e-05 5.625C-3.14093e-05 6.74062 0.466375 7.7625 1.23981 8.58516C0.890594 9.50859 0.164031 10.2914 0.152312 10.3008C-0.00237516 10.4648 -0.0445627 10.7039 0.0444998 10.9102C0.133562 11.1164 0.337469 11.25 0.562469 11.25C2.00387 11.25 3.14059 10.6477 3.82263 10.1648C4.49997 10.3781 5.23122 10.5 5.99997 10.5C9.31403 10.5 12 8.31797 12 5.625C12 2.93203 9.31403 0.75 5.99997 0.75ZM5.99997 9.375C5.37419 9.375 4.75544 9.27891 4.16247 9.09141L3.63044 8.92266L3.17341 9.24609C2.83825 9.48281 2.37887 9.74766 1.82575 9.92578C1.99684 9.64219 2.16325 9.32344 2.29216 8.98359L2.54059 8.325L2.05778 7.81406C1.63356 7.36172 1.12497 6.61406 1.12497 5.625C1.12497 3.55781 3.31169 1.875 5.99997 1.875C8.68825 1.875 10.875 3.55781 10.875 5.625C10.875 7.69219 8.68825 9.375 5.99997 9.375Z", fill: "#55585D" })), /* @__PURE__ */ k.createElement("defs", null, /* @__PURE__ */ k.createElement("clipPath", { id: "clip0_4948_2360" }, /* @__PURE__ */ k.createElement("rect", { width: 12, height: 12, fill: "white" }))));
const RG = {
  selectCtl: {
    position: 0,
    className: "table-head-empty"
  },
  title: {
    label: /* @__PURE__ */ N.jsx(mt, { id: "ld.title" }),
    position: 1
  },
  isbn: {
    label: /* @__PURE__ */ N.jsx(mt, { id: "ld.isbn" }),
    position: 2
  },
  lccn: {
    label: /* @__PURE__ */ N.jsx(mt, { id: "ld.lccn" }),
    position: 3
  },
  publisher: {
    label: /* @__PURE__ */ N.jsx(mt, { id: "ld.publisher" }),
    position: 4
  },
  pubDate: {
    label: /* @__PURE__ */ N.jsx(mt, { id: "ld.pubDateShort" }),
    position: 5
  },
  editCtl: {
    position: 6,
    className: "table-head-empty"
  }
}, TG = ({ instances: t, ...r }) => {
  const { formatMessage: i } = La(), { navigateToEditPage: u } = fd(), { navigationState: c, selectedInstances: v, setSelectedInstances: h } = Eo(), [y, g] = k.useState(!0), { setIsLoading: S } = qu(), { addStatusMessagesItem: x } = Si(), { previewContent: T } = Ea(), { resetFullDisplayComponentType: _, fullDisplayComponentType: L } = Qa(), M = () => g(!y), { fetchRecord: U } = Tp(), B = async (Q) => {
    try {
      S(!0), _(), await U(Q, { singular: !0 });
    } catch (W) {
      console.error(W), x == null || x(Ei.createMessage(Tr.error, "ld.errorFetching"));
    } finally {
      S(!1);
    }
  }, H = (Q, W) => h((oe) => W ? [...oe, Q] : oe.filter((j) => j !== Q)), G = ((Q) => Q.map((W) => {
    var re, me;
    const oe = v.findIndex((Se) => Se === W.__meta.id), j = W.title.label;
    return {
      ...W,
      title: {
        ...W.title,
        children: /* @__PURE__ */ N.jsxs("div", { className: "title-wrapper", children: [
          oe >= 0 && (T.length > 1 || L === Qh.Comparison) && /* @__PURE__ */ N.jsx("span", { className: "comparison-index", children: oe + 1 }),
          /* @__PURE__ */ N.jsx(
            Dn,
            {
              type: Mn.Link,
              onClick: () => {
                var Se;
                return B((Se = W == null ? void 0 : W.__meta) == null ? void 0 : Se.id);
              },
              "data-testid": `preview-button__${W.__meta.id}`,
              ariaLabel: i({ id: "ld.aria.sections.openResourcePreview" }, { title: j }),
              children: W.title.label
            }
          )
        ] })
      },
      editCtl: {
        children: /* @__PURE__ */ N.jsx(
          Dn,
          {
            type: Mn.Primary,
            onClick: () => {
              var Se;
              return u(Kh((Se = W.__meta) == null ? void 0 : Se.id));
            },
            "data-testid": `edit-button__${W.__meta.id}`,
            className: In(["button-nowrap", "button-capitalize"]),
            ariaLabel: i({ id: "ld.aria.sections.editInstance" }, { title: j }),
            children: /* @__PURE__ */ N.jsx(mt, { id: "ld.editInstance" })
          }
        )
      },
      selectCtl: {
        children: /* @__PURE__ */ N.jsx("div", { className: "row-select-container", children: /* @__PURE__ */ N.jsx(
          "input",
          {
            id: `row-select-ctl-${(re = W.__meta) == null ? void 0 : re.key}`,
            type: "checkbox",
            checked: v.includes((me = W.__meta) == null ? void 0 : me.id),
            onChange: (Se) => {
              var Ne;
              return H((Ne = W.__meta) == null ? void 0 : Ne.id, Se.target.checked);
            },
            "aria-label": i({ id: "ld.aria.table.selectRow" }, { title: j })
          }
        ) })
      }
    };
  }))(fU(t || []));
  return /* @__PURE__ */ N.jsxs("div", { className: "search-result-entry-container", children: [
    /* @__PURE__ */ N.jsx(
      SG,
      {
        isOpen: y,
        toggleIsOpen: M,
        handleOpenPreview: B,
        ...r
      }
    ),
    !!(t != null && t.length) && y && /* @__PURE__ */ N.jsx(
      H4,
      {
        header: RG,
        data: G,
        selectedRows: T == null ? void 0 : T.map(({ id: Q }) => Q),
        className: "instance-list"
      }
    ),
    !y && /* @__PURE__ */ N.jsxs("div", { className: "empty-or-closed", children: [
      /* @__PURE__ */ N.jsx(xG, {}),
      /* @__PURE__ */ N.jsx("span", { children: /* @__PURE__ */ N.jsx(mt, { id: "ld.instances" }) }),
      /* @__PURE__ */ N.jsx("span", { children: (t == null ? void 0 : t.length) ?? 0 })
    ] }),
    !(t != null && t.length) && y && /* @__PURE__ */ N.jsx("div", { className: "empty-or-closed", children: /* @__PURE__ */ N.jsxs("span", { children: [
      /* @__PURE__ */ N.jsx("span", { children: /* @__PURE__ */ N.jsx(mt, { id: "ld.noInstancesAvailable" }) }),
      /* @__PURE__ */ N.jsx(
        s2,
        {
          to: `${Va.RESOURCE_CREATE.uri}?type=${Co.instance}&ref=${r.id}`,
          state: c,
          children: /* @__PURE__ */ N.jsx(mt, { id: "ld.addAnInstance" })
        }
      )
    ] }) })
  ] });
}, wG = () => {
  const [t] = qc(), r = t.get(Wo.Query), i = t.get(Wo.SearchBy), u = t.get(Wo.Offset), { setNavigationState: c } = Eo();
  k.useEffect(() => {
    const v = L2(
      r,
      i,
      u
    );
    c(v);
  }, [t]);
};
const IG = () => {
  const { data: t } = Eo();
  return wG(), /* @__PURE__ */ N.jsx("div", { className: "search-result-list", children: t == null ? void 0 : t.map((r) => /* @__PURE__ */ N.jsx(TG, { ...r }, `result-entry-${r.id}`)) });
}, AG = [
  {
    labelId: "ld.publishDate",
    type: zl.Single,
    children: [
      {
        id: Wy.AllTime,
        type: $c.Radio,
        name: Ep.PublishDate,
        labelId: "ld.allTime"
      },
      {
        id: Wy.TwelveMonths,
        type: $c.Radio,
        name: Ep.PublishDate,
        labelId: "ld.past12Months"
      },
      {
        id: Wy.FiveYears,
        type: $c.Radio,
        name: Ep.PublishDate,
        labelId: "ld.past5Yrs"
      },
      {
        id: Wy.TenYears,
        type: $c.Radio,
        name: Ep.PublishDate,
        labelId: "ld.past10Yrs"
      }
    ]
  },
  {
    labelId: "ld.format",
    type: zl.Multi,
    children: [
      {
        id: NT.Volume,
        type: $c.Checkbox,
        name: Ep.Format,
        labelId: "ld.volume"
      },
      {
        id: NT.Ebook,
        type: $c.Checkbox,
        name: Ep.Format,
        labelId: "ld.onlineResource"
      }
    ]
  },
  {
    labelId: "ld.suppressed",
    type: zl.Single,
    children: [
      {
        id: _T.All,
        type: $c.Radio,
        name: Ep.Suppressed,
        labelId: "ld.volume"
      },
      {
        id: _T.NotSuppressed,
        type: $c.Radio,
        name: Ep.Suppressed,
        labelId: "ld.suppressed"
      }
    ]
  }
];
const NG = () => {
  const { navigateToEditPage: t } = fd(), { dispatchDropNavigateToOriginEvent: r } = Sm(), { selectedInstances: i, resetSelectedInstances: u } = Eo(), { setIsLoading: c } = qu(), { fetchRecord: v } = Tp(), { addStatusMessagesItem: h } = Si(), { setFullDisplayComponentType: y, resetFullDisplayComponentType: g } = Qa(), { resetPreviewContent: S } = Ea();
  k.useEffect(() => () => {
    g(), u();
  }, []), r();
  const x = async () => {
    try {
      c(!0), S(), y(Qh.Comparison);
      for (const M of i.toReversed())
        await v(M, {});
    } catch (M) {
      console.error(M), h == null || h(Ei.createMessage(Tr.error, "ld.errorFetching"));
    } finally {
      c(!1);
    }
  }, T = k.useMemo(
    () => [
      {
        id: "actions",
        labelId: "ld.actions",
        data: [
          {
            id: "newResource",
            type: Wu.basic,
            labelId: "ld.newResource",
            icon: /* @__PURE__ */ N.jsx(z2, {}),
            action: () => {
              t(`${Va.RESOURCE_CREATE.uri}?type=${Co.work}`);
            }
          },
          {
            id: "compare",
            type: Wu.basic,
            labelId: "ld.compareSelected",
            icon: /* @__PURE__ */ N.jsx(F4, {}),
            hidden: i.length < CB,
            action: x
          }
        ]
      }
      // Example of the dropdown option with a custom component instead of the standart button
      /* {
        id: 'sortBy',
        labelId: 'ld.newResource',
        data: [
          {
            id: 'sortBy',
            type: DropdownItemType.customComponent,
            renderComponent: (key: string | number) => <div key={key}>Custom</div>,
          },
        ],
      }, */
    ],
    [t]
  ), _ = k.useCallback(
    () => /* @__PURE__ */ N.jsx(W2, { label: /* @__PURE__ */ N.jsx(mt, { id: "ld.resources" }), children: /* @__PURE__ */ N.jsx(C2, { labelId: "ld.actions", items: T, buttonTestId: "search-view-actions-dropdown" }) }),
    [T]
  ), L = k.useCallback(() => /* @__PURE__ */ N.jsx(IG, {}), []);
  return /* @__PURE__ */ N.jsx("div", { className: "search", "data-testid": "search", id: "ld-search-container", children: /* @__PURE__ */ N.jsx(
    V4,
    {
      endpointUrl: NF,
      filters: AG,
      hasSearchParams: !0,
      defaultSearchBy: sO,
      labelEmptySearch: "ld.enterSearchCriteria",
      isVisibleFilters: c6,
      isVisibleFullDisplay: !0,
      isVisibleAdvancedSearch: !0,
      isVisibleSearchByControl: !0,
      renderSearchControlPane: _,
      renderResultsList: L
    }
  ) });
};
const _G = () => {
  const { externalId: t } = Cm();
  return /* @__PURE__ */ N.jsx("div", { className: "external-resource-loader", "data-testid": "external-resource-loader", children: /* @__PURE__ */ N.jsx("div", { className: "contents", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.fetchingExternalResourceById", values: { resourceId: t } }) }) });
};
const OG = k.memo(() => {
  const { isDuplicateImportedResourceModalOpen: t, setIsDuplicateImportedResourceModalOpen: r } = Qa(), { formatMessage: i } = La(), { dispatchNavigateToOriginEventWithFallback: u } = Sm();
  return /* @__PURE__ */ N.jsx(
    qg,
    {
      className: "duplicate-imported-resource",
      isOpen: t,
      title: i({ id: "ld.duplicateImportWarn" }),
      submitButtonLabel: i({ id: "ld.continue" }),
      submitButtonDisabled: !0,
      alignTitleCenter: !0,
      cancelButtonLabel: i({ id: "ld.backToInventory" }),
      onClose: () => r(!1),
      onCancel: () => u(),
      children: /* @__PURE__ */ N.jsx("div", { className: "duplicate-imported-resource-contents", "data-testid": "modal-duplicate-imported-resource", children: /* @__PURE__ */ N.jsx(mt, { id: "ld.rdPropertiesMatchContinue" }) })
    }
  );
});
const LG = () => {
  const { record: t } = Ea(), { fetchExternalRecordForPreview: r } = Tp(), { resetBasicValue: i } = ud(), { externalId: u } = Cm();
  return k.useEffect(() => {
    r(u, v2.Inventory), i();
  }, [u]), /* @__PURE__ */ N.jsxs("div", { className: "external-resource-preview", children: [
    t ? /* @__PURE__ */ N.jsx(WC, { altDisplayNames: oO, forceRenderAllTopLevelEntities: !0, entityRowDisplay: !0 }) : /* @__PURE__ */ N.jsx(_G, {}),
    /* @__PURE__ */ N.jsx(OG, {})
  ] });
}, G4 = {
  "ld.startEditing": "Start editing.",
  "ld.dashboard": "My dashboard",
  "ld.search": "Search",
  "ld.browse": "Browse",
  "ld.reset": "Reset",
  "ld.searchResource": "Search resources",
  "ld.create": "Create resource",
  "ld.edit": "Edit",
  "ld.editResource": "Edit resource",
  "ld.main": "Main",
  "ld.and": "AND",
  "ld.or": "OR",
  "ld.not": "NOT",
  "ld.saveRd": "Save resource",
  "ld.closeRd": "Close resource",
  "ld.deleteRd": "Delete resource",
  "ld.resources": "Resources",
  "ld.searchBy": "Search By",
  "ld.searchFor": "Search for",
  "ld.searchAndFilter": "Search & filter",
  "ld.enterSearchCriteria": "Enter search criteria to start search",
  "ld.chooseFilterOrEnterSearchQuery": "Choose a filter or enter a search query to show results.",
  "ld.searchNoRdsMatch": "No resource descriptions match your query",
  "ld.searchBySth": "Search by{by}...",
  "ld.errorFetching": "Error fetching data",
  "ld.errorLoadingResource": "Error loading resource",
  "ld.actions": "Actions",
  "ld.isbnLccn": "ISBN/LCCN",
  "ld.isbn": "ISBN",
  "ld.lccn": "LCCN",
  "ld.lcnaf": "LCNAF",
  "ld.title": "Title",
  "ld.contributor": "Contributor",
  "ld.author": "Author",
  "ld.pubDate": "Publication Date",
  "ld.pubDateShort": "Pub Date",
  "ld.edition": "Edition",
  "ld.select": "Select",
  "ld.subclass": "Subclass",
  "ld.heading": "Heading",
  "ld.selectForEditing": "Select a resource description for editing",
  "ld.startFromScratch": "Start from scratch",
  "ld.selectOrStartFromScratch": "{select} or {startFromScratch}",
  "ld.backToTop": "Back to top",
  "ld.backToInventory": "Back to inventory",
  "ld.properties": "Properties",
  "ld.preview": "Preview",
  "ld.confirmCloseRd": "Do you really want to close the resource description? All unsaved changes will be lost.",
  "ld.confirmDeleteRd": "Do you really want to delete the resource description?",
  "ld.saveClose": "Save and close",
  "ld.close": "Close",
  "ld.delete": "Delete",
  "ld.return": "Return",
  "ld.rdSaveSuccess": "Resource created. Expect a short delay before resource is visible in FOLIO.",
  "ld.rdUpdateSuccess": "Resource updated. Expect a short delay before changes are visible in FOLIO.",
  "ld.cantSaveRd": "Cannot save the resource description",
  "ld.cantDeleteRd": "Cannot delete the resource description",
  "ld.rdDeleted": "Resource description deleted",
  "ld.appFail": "An error occurred. Please, reload the page.",
  "ld.searchSelectIndex": "Please select an index",
  "ld.advancedSearch": "Advanced search",
  "ld.advanced": "Advanced",
  "ld.cancel": "Cancel",
  "ld.loading": "Loading...",
  "ld.paginationCount": "{startCount} - {endCount} of {totalResultsCount}",
  "ld.yes": "Yes",
  "ld.no": "No",
  "ld.cantLoadSimpleLookupData": "Cannot load data for a simple lookup",
  "ld.publishDate": "Publish date",
  "ld.format": "Format",
  "ld.suppressed": "Suppressed",
  "ld.notSuppressed": "Not suppressed",
  "ld.volume": "Volume",
  "ld.ebook": "eBook",
  "ld.allTime": "All time",
  "ld.past12Months": "Past 12 months",
  "ld.past10Yrs": "Past 10 years",
  "ld.past5Yrs": "Past 5 years",
  "ld.customRange": "Custom range",
  "ld.all": "All",
  "ld.onlineResource": "Online resource",
  "ld.startsWith": "Starts with",
  "ld.containsAll": "Contains all",
  "ld.exactPhrase": "Exact phrase",
  "ld.publisher": "Publisher",
  "ld.creator": "Creator",
  "ld.language": "Language",
  "ld.classificationNumber": "Classification number",
  "ld.work": "Work",
  "ld.instances": "Instances",
  "ld.instance": "Instance",
  "ld.year": "Year",
  "ld.noInstancesAvailable": "No instances available.",
  "ld.noInstancesAdded": "No instances added",
  "ld.addAnInstance": "Add an instance",
  "ld.type": "Type",
  "ld.expandAll": "Expand all",
  "ld.collapseAll": "Collapse all",
  "ld.showAllWithCount": "Show all ({amt})",
  "ld.showAdditionalComponents": "Show additional components ({amt})",
  "ld.hideAdditionalComponents": "Hide additional components",
  "ld.hide": "Hide",
  "ld.saveAndClose": "Save & close",
  "ld.saveAndContinue": "Save & continue",
  "ld.editInstance": "Edit instance",
  "ld.editWork": "Edit work",
  "ld.createInstance": "Create instance",
  "ld.createWork": "Create work",
  "ld.saveAndKeepEditing": "Save & keep editing",
  "ld.recordMappingToSchema": "Cannot apply a record to the schema",
  "ld.newResource": "New resource",
  "ld.addInstance": "Add instance",
  "ld.compareSelected": "Compare selected",
  "ld.newInstance": "New instance",
  "ld.newWork": "New work",
  "ld.new": "New",
  "ld.cantSelectReferenceContents": "Can't select reference contents while fetching a reference",
  "ld.addNewInstance": "Add new instance",
  "ld.askSaveChangesBeforeProceeding": "Would you like to save your changes before proceeding?",
  "ld.unsavedRecentEdits": "Recent edits made to the resource have not been saved. Unsaved changes will be lost.",
  "ld.unsavedChanges": "Unsaved changes",
  "ld.continueWithoutSaving": "Continue without saving",
  "ld.noTitleInBrackets": "No title",
  "ld.viewMarc": "View MARC",
  "ld.marcWithTitle": "MARC - {title}",
  "ld.cantLoadMarc": "Can't load MARC for this resource description",
  "ld.duplicate": "Duplicate",
  "ld.viewLinkedData": "View linked data",
  "ld.viewInInventory": "View in Inventory app",
  "ld.authorityType": "Authority Type",
  "ld.person": "Person",
  "ld.source": "Source",
  "ld.family": "Family",
  "ld.organization": "Organization",
  "ld.meeting": "Meeting",
  "ld.corporateBody": "Corporate body",
  "ld.jurisdiction": "Jurisdiction",
  "ld.conference": "Conference",
  "ld.authorizedReference": "Authorized/Reference",
  "ld.headingReference": "Heading/Reference",
  "ld.unauthorized": "Unauthorized",
  "ld.assign": "Assign",
  "ld.assignAuthority": "Assign authority",
  "ld.change": "Change",
  "ld.searchCreatorAuthority": "Search creator authority",
  "ld.selectMarcAuthority": "Select MARC authority",
  "ld.marcAuthority": "MARC authority",
  "ld.keyword": "Keyword",
  "ld.recordsFound": "{recordsCount} records found",
  "ld.resourceWithIdIsEmpty": "Resource description {id} is empty",
  "ld.duplicateInstance": "Duplicate instance",
  "ld.duplicateWork": "Duplicate work",
  "ld.duplicateInstanceInBrackets": "(DUPLICATE INSTANCE)",
  "ld.duplicateWorkInBrackets": "(DUPLICATE WORK)",
  "ld.identifierAll": "Identifier (all)",
  "ld.personalName": "Personal name",
  "ld.corporateName": "Corporate/Conference name",
  "ld.geographicName": "Geographic name",
  "ld.nameTitle": "Name-title",
  "ld.uniformTitle": "Uniform title",
  "ld.subject": "Subject",
  "ld.childrensSubjectHeading": "Children's subject heading",
  "ld.genre": "Genre",
  "ld.authoritySource": "Authority source",
  "ld.references": "References",
  "ld.thesaurus": "Thesaurus",
  "ld.typeOfHeading": "Type of heading",
  "ld.dateCreated": "Date created",
  "ld.dateUpdated": "Date updated",
  "ld.excludeSeeFrom": "Exclude see from",
  "ld.excludeSeeFromAlso": "Exclude see from also",
  "ld.previous": "Previous",
  "ld.next": "Next",
  "ld.from": "From",
  "ld.to": "To",
  "ld.apply": "Apply",
  "ld.notSpecified": "Not specified",
  "ld.externalResourcePreview": "External resource preview",
  "ld.errorFetchingExternalResourceForPreview": "Error fetching external resource for preview",
  "ld.errorFetchingExternalResourceForEditing": "Error fetching external resource for editing",
  "ld.fetchingExternalResourceById": "Fetching external resource id {resourceId}...",
  "ld.lastUpdated": "Last updated",
  "ld.marcAuthorityRecord": "MARC authority record",
  "ld.selectBrowseOption": "Select a browse option",
  "ld.searchQueryWouldBeHere": "{query} would be here",
  "ld.continue": "Continue",
  "ld.compareResources": "Compare resources",
  "ld.selectedResources": "Selected resources",
  "ld.nResourcesSelected": "{n} resources selected",
  "ld.clearSelections": "Clear selections",
  "ld.chooseTwoResourcesCompare": "Choose two or more resources to compare",
  "ld.chooseOneResourceCompare": "Choose another resource to compare",
  "ld.aria.comparison.close": "Close comparison section",
  "ld.aria.comparison.removeEntry": "Remove comparison entry",
  "ld.aria.searchPane.close": "Close search pane",
  "ld.aria.searchPane.open": "Open search pane",
  "ld.aria.modal.close": "Close {modalKind} modal",
  "ld.aria.complexLookup.marcPreview.close": "Close lookup MARC preview section",
  "ld.aria.advancedSearch.queryInput": "Advanced search row query input",
  "ld.aria.advancedSearch.operator": "Advanced search row operator",
  "ld.aria.advancedSearch.qualifier": "Advanced search row qualifier",
  "ld.aria.advancedSearch.identifier": "Advanced search row identifier",
  "ld.aria.filters.select": "Select search identifiers",
  "ld.aria.listEntry.open": "Open collapsible list entry",
  "ld.aria.listEntry.close": "Close collapsible list entry",
  "ld.aria.edit.close": "Close edit page",
  "ld.aria.edit.deleteComponent": "Delete component",
  "ld.aria.edit.duplicateComponent": "Duplicate component",
  "ld.aria.edit.removeComplexLookupFieldValue": "Remove complex lookup field value",
  "ld.aria.resourcePreview.close": "Close resource preview pane",
  "ld.aria.externalResourcePreview.close": "Close external resource preview page",
  "ld.aria.marcAuthorityPreview.close": "Close MARC authority preview",
  "ld.aria.marcPreview.close": "Close MARC preview modal",
  "ld.aria.filters.textbox": "Search query textbox",
  "ld.aria.table.selectRow": "Select resource: {title}",
  "ld.aria.sections.openResourcePreview": "Open resource preview section: {title}",
  "ld.aria.sections.editInstance": "Edit instance: {title}",
  "ld.aria.sections.closeResourcePreview": "Close resource preview section",
  "ld.aria.filters.reset": "Reset filters button",
  "ld.aria.filters.reset.announce": "Search field and filters are reset",
  "ld.duplicateImportWarn": "Duplicate import warning",
  "ld.rdPropertiesMatchContinue": "Properties of this resource match an existing resource. Do you want to continue?",
  "ld.errorMakingApiRequest": "Error making API request",
  "ld.errorAssigningAuthority": "Error assigning authority",
  "ld.errorAssigningAuthority.not_valid_for_target": "Please select an authority with a resource type matching the edited authority field (e.g. LCNAF authority for the Creator field)",
  "ld.errorAssigningAuthority.no_lccn": "Only Library of Congress authorities can be assigned for now. This is temporary until additional source types are supported.",
  "ld.errorAssigningAuthority.unsupported_marc": "The selected authority isn't mapped to Linked Data, and can't be assigned yet. This is temporary, since MARC mapping is in progress.",
  "ld.modal.uncontrolledAuthoritiesWarning.title": "Uncontrolled authorities warning",
  "ld.modal.uncontrolledAuthoritiesWarning.body": `This description includes one or more uncontrolled authorities.
 Do you want to save changes?`,
  "ld.required_primary_main_title": "Please add the main title in order to save.",
  "ld.lccn_does_not_match_pattern": "LCCN Pattern validation enabled: Please provide an LCCN that complies with standard structure.",
  "ld.lccn_not_unique": "LCCN uniqueness enabled: The LCCN you provided already exists. Please provide a different LCCN.",
  "ld.failed_dependency": "Unable to verify if LCCN is duplicated.",
  "ld.not_found": "The resource ID has been changed by another user while you had this resource open. Please refresh your browser’s window.",
  "ld.mapping": "There’s been a mapping issue. Please report this to your support team, with screenshots and a detailed account of what happened.",
  "ld.generic_bad_request": "There’s been a UI issue. Please report this to your support team, with screenshots and a detailed account of what happened.",
  "ld.server": "There’s been a server issue. Please report this to your support team, with screenshots and a detailed account of what happened.",
  "ld.already_exists": "The same resource ID already exists."
}, $_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G4
}, Symbol.toStringTag, { value: "Module" }));
class DG {
  constructor(r = []) {
    this.selectedEntries = r, this.set(r);
  }
  get() {
    return this.selectedEntries;
  }
  set(r) {
    this.selectedEntries = [...r];
  }
  addNew(r, i) {
    if (!i)
      return;
    const u = this.selectedEntries.filter((c) => c !== r);
    this.selectedEntries = [...u, i];
  }
  addDuplicated(r, i) {
    this.selectedEntries.includes(r) && this.selectedEntries.push(i);
  }
  remove(r) {
    r && (this.selectedEntries = this.selectedEntries.filter((i) => i !== r));
  }
  removeMultiple(r) {
    r && (this.selectedEntries = this.selectedEntries.filter((i) => !r.includes(i)));
  }
}
class MG {
  generate(r) {
    const { data: i, id: u, uuid: c, type: v } = r;
    return {
      uuid: c ?? "",
      contents: this.generateContents(i, u, v)
    };
  }
  generateContents(r, i, u) {
    return Array.isArray(r) ? this.handleArrayData(r, i, u) : this.handleSingleData(r, i, u);
  }
  handleArrayData(r, i, u) {
    return r.map((c) => ({
      id: this.getId(c, i),
      label: this.getLabel(c),
      meta: { type: u }
    }));
  }
  handleSingleData(r, i, u) {
    return [{
      id: i,
      label: this.getSingleLabel(r),
      meta: {
        type: u,
        ...this.getPreferredMeta(r)
      }
    }];
  }
  getId(r, i) {
    return (r == null ? void 0 : r.id) ?? i;
  }
  getLabel(r) {
    return typeof r == "object" ? r == null ? void 0 : r.label[0] : String(r);
  }
  getSingleLabel(r) {
    var i;
    return typeof r == "string" ? r : ((i = r == null ? void 0 : r.value) == null ? void 0 : i[0]) ?? "";
  }
  getPreferredMeta(r) {
    const i = r == null ? void 0 : r.isPreferred;
    return i !== void 0 ? { isPreferred: i } : {};
  }
}
class PG {
  constructor() {
    wn(this, "value");
    this.value = {};
  }
}
class kG extends PG {
  constructor(i, u) {
    super();
    wn(this, "uri");
    wn(this, "propertyUri");
    wn(this, "loadedData");
    wn(this, "contents");
    this.apiClient = i, this.cacheService = u;
  }
  async generate({ data: i, uri: u, uuid: c, labelSelector: v, uriSelector: h, type: y, propertyUri: g, groupUri: S, fieldUri: x }) {
    var _, L, M, U;
    if (this.uri = u, this.propertyUri = g, this.getCachedData() || await this.loadData(), this.contents = [], Array.isArray(i))
      for (const B of i) {
        const H = (_ = B[h]) == null ? void 0 : _[0];
        this.checkDefaultGroupValues(S, H) || this.generateContentItem({
          label: (L = B[v]) == null ? void 0 : L[0],
          itemUri: H,
          uri: u,
          groupUri: S,
          type: y,
          fieldUri: x
        });
      }
    else {
      const B = i, H = (M = B[h]) == null ? void 0 : M[0];
      this.checkDefaultGroupValues(S, H) || this.generateContentItem({
        label: (U = B[v]) == null ? void 0 : U[0],
        itemUri: H,
        uri: u,
        groupUri: S,
        type: y,
        fieldUri: x
      });
    }
    return this.value = {
      uuid: c ?? "",
      contents: this.contents
    }, this.value;
  }
  checkDefaultGroupValues(i, u) {
    var c;
    return !i || !u ? !1 : ((c = UB[i]) == null ? void 0 : c.value) === u;
  }
  generateContentItem({
    label: i,
    itemUri: u,
    uri: c,
    groupUri: v,
    type: h,
    fieldUri: y
  }) {
    var L, M, U, B, H, Y, G, Q;
    const g = E2[v], S = g && u ? ((M = (L = g == null ? void 0 : g.data) == null ? void 0 : L[u]) == null ? void 0 : M.uri) || ((Y = (H = (B = (U = g == null ? void 0 : g.fields) == null ? void 0 : U[y]) == null ? void 0 : B.data) == null ? void 0 : H[u]) == null ? void 0 : Y.uri) : u, x = (G = this.cacheService.getById(c)) == null ? void 0 : G.find(
      ({ label: W, value: oe }) => oe.uri === S || oe.label === i || W === i
    ), _ = {
      label: g && u ? (x == null ? void 0 : x.label) ?? u : (x == null ? void 0 : x.label) ?? i,
      meta: {
        parentUri: c,
        uri: u,
        type: h,
        basicLabel: x == null ? void 0 : x.value.label
      }
    };
    (Q = this.contents) == null || Q.push(_);
  }
  getCachedData() {
    return this.uri ? this.cacheService.getById(this.uri) : void 0;
  }
  saveLoadedData() {
    !this.uri || !this.loadedData || this.cacheService.save(this.uri, this.loadedData);
  }
  async loadData() {
    const i = await this.apiClient.loadSimpleLookupData(this.uri);
    if (!i)
      return;
    const u = w4(i, this.uri), c = A4(u, this.propertyUri);
    this.loadedData = c == null ? void 0 : c.toSorted(NO), this.saveLoadedData();
  }
}
class FG {
  generate(r) {
    const { data: i, uuid: u } = r, c = i;
    return {
      uuid: u ?? "",
      contents: [{ label: Array.isArray(c) ? c[0] : c }]
    };
  }
}
class BG {
  constructor(r, i, u) {
    wn(this, "generatedValue");
    wn(this, "type");
    wn(this, "key");
    wn(this, "value");
    wn(this, "userValueFactory");
    wn(this, "literalUserValueService");
    wn(this, "simpleLookupUserValueService");
    wn(this, "complexLookupUserValueService");
    this.userValues = r, this.apiClient = i, this.cacheService = u, this.set(r), this.initialize();
  }
  set(r) {
    this.userValues = Qc.cloneDeep(r);
  }
  async setValue({ type: r, key: i, value: u }) {
    this.type = r, this.key = i, this.value = u, this.selectFactoryByType(), await this.generateValue(), this.generatedValue && (this.userValues[i] = this.generatedValue);
  }
  getAllValues() {
    return this.userValues;
  }
  getValue(r) {
    return this.userValues[r];
  }
  initialize() {
    this.literalUserValueService = new FG(), this.simpleLookupUserValueService = new kG(this.apiClient, this.cacheService), this.complexLookupUserValueService = new MG();
  }
  selectFactoryByType() {
    switch (this.type) {
      case At.literal:
        this.userValueFactory = this.literalUserValueService;
        break;
      case At.simple:
        this.userValueFactory = this.simpleLookupUserValueService;
        break;
      case At.complex:
        this.userValueFactory = this.complexLookupUserValueService;
        break;
      default:
        this.userValueFactory = this.literalUserValueService;
        break;
    }
  }
  async generateValue() {
    var r, i, u;
    try {
      const c = { ...this.value };
      this.generatedValue = await ((r = this.userValueFactory) == null ? void 0 : r.generate({ ...c, uuid: this.key, type: this.type }));
    } catch (c) {
      console.error(
        "Error occurred generating value for %s field of the %s record entry",
        (i = this.value) == null ? void 0 : i.groupUri,
        (u = this.value) == null ? void 0 : u.fieldUri,
        c
      );
    }
  }
}
const UG = {
  loadSimpleLookupData: RO
}, VG = () => {
  const t = k.useRef({});
  return {
    save: (r, i) => {
      t.current = { ...t.current, [r]: i };
    },
    getAll: () => t.current,
    getById: (r) => t.current[r]
  };
};
class HG {
  constructor(r, i, u) {
    this.schema = r, this.selectedEntriesService = i, this.entryPropertiesGeneratorService = u, this.set(r);
  }
  get() {
    return this.schema;
  }
  set(r) {
    this.schema = Qc.cloneDeep(r);
  }
  duplicateEntry(r) {
    var x, T;
    const { path: i, children: u, constraints: c } = r;
    if (!(c != null && c.repeatable))
      return;
    const v = Jc(), h = this.getCopiedEntry(r, v);
    h.children = this.getUpdatedChildren(u, h);
    const y = $g(i), g = this.schema.get(y), S = this.getUpdatedParentEntry({
      parentEntry: g,
      originalEntry: r,
      updatedEntryUuid: v
    });
    if (S) {
      this.schema.set(y, S), this.schema.set(v, h);
      const _ = Yy(r);
      this.updateDeletabilityAndPositioning((x = S == null ? void 0 : S.twinChildren) == null ? void 0 : x[_]), (T = this.entryPropertiesGeneratorService) == null || T.applyHtmlIdToEntries(this.schema);
    }
    return v;
  }
  deleteEntry(r) {
    var S, x;
    const { deletable: i, uuid: u, path: c } = r;
    if (!i)
      return;
    const v = this.schema.get($g(c)), h = Yy(r), y = (S = v == null ? void 0 : v.twinChildren) == null ? void 0 : S[h];
    if (y) {
      const T = y == null ? void 0 : y.filter((_) => _ !== u);
      this.schema.set(v.uuid, {
        ...v,
        twinChildren: {
          ...v.twinChildren,
          [h]: T
        },
        children: (x = v.children) == null ? void 0 : x.filter((_) => _ !== u)
      }), this.updateDeletabilityAndPositioning(T);
    }
    const g = [];
    return this.deleteEntryAndChildren(r, g), g;
  }
  deleteEntryAndChildren(r, i) {
    if (!r)
      return;
    const { children: u, uuid: c } = r;
    if (u)
      for (const v of u)
        this.deleteEntryAndChildren(this.schema.get(v), i);
    i == null || i.push(c), this.schema.delete(c);
  }
  updateDeletabilityAndPositioning(r = []) {
    const i = r.length >= e6;
    r.forEach(
      (u, c) => this.schema.set(u, { ...this.schema.get(u) ?? {}, deletable: i, cloneIndex: c })
    );
  }
  getCopiedEntry(r, i, u) {
    var y;
    const { path: c, htmlId: v } = r, h = Qc.cloneDeep(r);
    return h.uuid = i, h.path = this.getUpdatedPath(c, i, u), v && ((y = this.entryPropertiesGeneratorService) == null || y.addEntryWithHtmlId(i)), h;
  }
  getUpdatedChildren(r, i) {
    const u = [], c = i == null ? void 0 : i.path, v = r == null ? void 0 : r.map(() => Jc());
    return r == null || r.forEach((h, y) => {
      const g = this.schema.get(h);
      if (!g)
        return;
      const { children: S } = g;
      let x = (v == null ? void 0 : v[y]) ?? Jc();
      const T = (i == null ? void 0 : i.dependsOn) && v && y === 0;
      T && (x = _2(i.uuid), v[y] = x), this.updateTwinChildrenEntry(g, x, i);
      const _ = this.getCopiedEntry(g, x, c);
      this.schema.set(x, _), _.children = this.getUpdatedChildren(S, _);
      const { updatedEntry: L, controlledByEntry: M } = this.getUpdatedAssociatedEntries({
        initialEntry: _,
        newUuids: v
      });
      M != null && M.uuid && this.schema.set(M.uuid, M), this.schema.set(x, L), T ? this.selectedEntriesService.addNew(void 0, x) : i != null && i.dependsOn || this.selectedEntriesService.addDuplicated(g.uuid, x), u.push(x);
    }), u;
  }
  updateTwinChildrenEntry(r, i, u) {
    if (!(u != null && u.twinChildren))
      return;
    const c = Yy(r), v = u.twinChildren[c];
    if (v != null && v.includes(r.uuid)) {
      const h = v.indexOf(r.uuid);
      v[h] = i;
    }
  }
  getUpdatedParentEntry({
    parentEntry: r,
    originalEntry: i,
    updatedEntryUuid: u
  }) {
    if (!r)
      return;
    const c = Qc.cloneDeep(r), { children: v } = c, h = v == null ? void 0 : v.indexOf(i.uuid), { uri: y } = i;
    if (y ?? "") {
      const S = Yy(i);
      c.twinChildren || (c.twinChildren = {}), c.twinChildren[S] = [
        .../* @__PURE__ */ new Set([...c.twinChildren[S] ?? [], i.uuid, u])
      ];
    }
    return h !== void 0 && h >= 0 && (v == null || v.splice(h + 1, 0, u)), c;
  }
  getUpdatedPath(r, i, u) {
    const c = u ? [...u] : [...r];
    return c[r.length - 1] = i, c;
  }
  getUpdatedAssociatedEntries({ initialEntry: r, newUuids: i }) {
    let u = r, c;
    if (u.dependsOn) {
      const v = AO({
        schema: this.schema,
        dependentEntry: u,
        parentEntryChildren: i,
        dependsOnId: u.dependsOn
      });
      c = v.controlledByEntry, u = v.dependentEntry;
    }
    return { updatedEntry: u, controlledByEntry: c };
  }
}
class jG {
  constructor(r, i) {
    wn(this, "templates");
    wn(this, "entry");
    wn(this, "schema");
    wn(this, "supportedEntries");
    this.selectedEntriesService = r, this.entryPropertiesGeneratorService = i, this.schema = /* @__PURE__ */ new Map(), this.supportedEntries = Object.keys(S2), this.templates = {}, this.entry = {};
  }
  init(r, i) {
    this.schema = /* @__PURE__ */ new Map(), this.templates = r, this.entry = i;
  }
  get() {
    return this.schema;
  }
  generate(r) {
    var i;
    try {
      this.traverseProfile({ entry: this.entry, uuid: r }), (i = this.entryPropertiesGeneratorService) == null || i.applyHtmlIdToEntries(this.schema);
    } catch (u) {
      console.error("Cannot generate a schema", u);
    }
  }
  traverseProfile({ entry: r, uuid: i = Jc(), path: u = [], auxType: c, firstOfSameType: v = !1 }) {
    var S;
    const h = c ?? U8(r), y = [...u, i], g = [At.literal, At.simple, At.complex];
    (S = this.entryPropertiesGeneratorService) == null || S.addEntryWithHtmlId(i), g.includes(h) ? this.processBranchEnd({
      entry: r,
      uuid: i,
      type: h,
      path: u
    }) : this.processNonBranchEnd({
      entry: r,
      uuid: i,
      type: h,
      updatedPath: y,
      path: u,
      firstOfSameType: v
    });
  }
  processBranchEnd({
    entry: r,
    uuid: i,
    type: u,
    path: c
  }) {
    const {
      id: v,
      propertyURI: h,
      propertyLabel: y,
      mandatory: g,
      repeatable: S,
      valueConstraint: { useValuesFrom: x, editable: T, valueDataType: _ },
      layout: L,
      dependsOn: M
    } = r, U = {
      ...KN,
      mandatory: !!g,
      repeatable: !!S,
      editable: !!T,
      useValuesFrom: x,
      valueDataType: _
    }, { uriBFLite: B } = YR({
      uri: h,
      dataTypeURI: _ == null ? void 0 : _.dataTypeURI,
      schema: this.schema,
      path: c
    });
    this.schema.set(
      i,
      this.generateSchemaEntry(
        {
          bfid: v,
          uuid: i,
          type: u,
          path: [...c, i],
          displayName: y,
          uri: h,
          uriBFLite: B,
          constraints: U
        },
        L,
        M
      )
    );
  }
  processNonBranchEnd({
    entry: r,
    uuid: i,
    type: u,
    updatedPath: c,
    path: v,
    firstOfSameType: h
  }) {
    switch (u) {
      case At.profile:
        this.processProfileType(r, i, c);
        break;
      case At.hidden:
      case At.dropdownOption:
      case At.block:
        this.processResourceTemplate({
          entry: r,
          uuid: i,
          type: u,
          updatedPath: c,
          path: v,
          firstOfSameType: h
        });
        break;
      case At.group:
      case At.groupComplex:
      case At.dropdown:
        this.processGroup({
          uuid: i,
          entry: r,
          type: u,
          path: v
        });
        break;
      default:
        console.error("Not implemented.", r);
        break;
    }
  }
  processProfileType(r, i, u) {
    const { title: c, id: v, resourceTemplates: h } = r.json.Profile, y = h.map(() => Jc());
    this.schema.set(i, {
      uuid: i,
      type: At.profile,
      path: u,
      displayName: c,
      bfid: v,
      children: y
    });
    for (const [g, S] of h.entries())
      this.traverseProfile({
        entry: S,
        uuid: y[g],
        path: u
      });
  }
  processResourceTemplate({
    entry: r,
    uuid: i,
    type: u,
    updatedPath: c,
    path: v,
    firstOfSameType: h
  }) {
    const { id: y, resourceURI: g, resourceLabel: S, propertyTemplates: x } = r, { uriBFLite: T } = YR({ uri: g, schema: this.schema, path: v }), _ = x.map(() => Jc()), L = v.length <= gm;
    if (!(!this.supportedEntries.includes(y) && L)) {
      u === At.dropdownOption && h && this.selectedEntriesService.addNew(void 0, i), this.schema.set(i, {
        uuid: i,
        type: u,
        path: c,
        displayName: S,
        bfid: y,
        uri: g,
        uriBFLite: T,
        children: _
      });
      for (const [M, U] of x.entries())
        this.traverseProfile({
          entry: U,
          uuid: _[M],
          path: c
        });
    }
  }
  processGroup({
    entry: r,
    path: i,
    uuid: u,
    type: c
  }) {
    var Q;
    const {
      propertyURI: v,
      propertyLabel: h,
      mandatory: y,
      repeatable: g,
      valueConstraint: { valueTemplateRefs: S, useValuesFrom: x, editable: T, valueDataType: _ },
      layout: L,
      dependsOn: M
    } = r, { uriBFLite: U } = YR({
      uri: v,
      dataTypeURI: _ == null ? void 0 : _.dataTypeURI,
      schema: this.schema,
      path: i
    }), B = {
      ...KN,
      mandatory: !!y,
      repeatable: !!g,
      editable: !!T,
      useValuesFrom: x,
      valueDataType: _
    }, H = u, Y = S.map(() => Jc()), G = this.generateSchemaEntry(
      {
        uuid: H,
        type: c,
        path: [...i, H],
        displayName: h,
        uri: v,
        uriBFLite: U,
        constraints: B,
        children: Y
      },
      L,
      M
    );
    if ((Q = G.linkedEntry) != null && Q.controlledBy) {
      const W = _2(H);
      G.children = G.children ? [W, ...G.children] : [], this.schema.set(W, {
        uuid: W,
        type: At.dropdownOption,
        path: [...i, H, W],
        displayName: "",
        bfid: "",
        uri: "",
        uriBFLite: "",
        children: []
      }), this.selectedEntriesService.addNew(void 0, W);
    }
    if (this.schema.set(H, G), c !== At.group)
      for (const [W, oe] of S.entries()) {
        const j = this.templates[oe];
        this.traverseProfile({
          entry: j,
          auxType: c === At.dropdown ? At.dropdownOption : At.hidden,
          uuid: Y[W],
          path: [...i, H],
          firstOfSameType: W === 0
        });
      }
  }
  generateSchemaEntry(r, i, u) {
    if (!i && !u)
      return r;
    let c = { ...r };
    if (i && (c.layout = I8(i)), u) {
      c.dependsOn = u;
      const v = this.schema.get($g(r.path)), { controlledByEntry: h, dependentEntry: y } = AO({
        schema: this.schema,
        dependentEntry: c,
        parentEntryChildren: v == null ? void 0 : v.children,
        dependsOnId: u
      });
      h && (this.schema.set(h.uuid, h), c = y);
    }
    return c;
  }
}
const X2 = (t, r, i) => {
  var c, v, h, y;
  const u = Xy;
  return ((y = (h = (v = (c = u == null ? void 0 : u[t]) == null ? void 0 : c[r]) == null ? void 0 : v.fields) == null ? void 0 : h[i]) == null ? void 0 : y.label) ?? "";
}, GG = (t, r, i, u) => {
  t[r][i].forEach((c) => {
    const v = { [i]: c }, h = t[r][u];
    t[r][u] = h ? [...h, v] : [v];
  }), delete t[r][i];
}, zG = (t, r, i) => {
  const u = X2(r, i, i);
  t[r][i] = t[r][i].map((c) => ({
    [u]: [c]
  }));
}, WG = (t, r) => {
  const i = Yu[Le.NOTE].container;
  if (!t[r][i])
    return;
  const u = X2(r, i, "type");
  t[r][i] = t[r][i].map((c) => ({
    ...c,
    type: [
      {
        [Le.LINK]: c.type,
        [u]: [""]
      }
    ]
  }));
}, XG = (t, r, i, u) => {
  t[r][i] = t[r][i].map(
    (c) => c[u]
  );
}, iT = (t, r, i, u) => {
  t[r][i] = t[r][i].map((c) => ({
    [u]: c
  }));
}, Z_ = (t, r, i) => {
  const u = Yu[Le.CREATOR].container, c = X2(r, i, u);
  t[r][i] = t[r][i].map((v) => {
    var y;
    const h = {
      id: [v.id],
      label: {
        value: [v.label],
        isPreferred: v.isPreferred
      }
    };
    return v[u] && (h[u] = (y = v[u]) == null ? void 0 : y.map((g) => ({
      [Le.LINK]: [g],
      [c]: [""]
    }))), {
      [v.type]: h
    };
  });
}, YG = (t, r, i, u) => {
  t[r][i] = t[r][i].map((c) => ({
    [u]: c
  }));
}, $G = (t, r, i, u, c) => {
  t[r][i] = t[r][i].map((v) => {
    const h = {};
    for (const y in v)
      y !== u && (h[y] = y === c ? v[y].map(({ id: g, label: S }) => ({
        id: g,
        label: [S]
      })) : v[y]);
    return { [v[u][0]]: h };
  });
}, aC = (t, r, i) => GG(t, r, i, Le.PROVISION_ACTIVITY), oT = {
  [Le.PRODUCTION]: {
    process: aC
  },
  [Le.PUBLICATION]: {
    process: aC
  },
  [Le.DISTRIBUTION]: {
    process: aC
  },
  [Le.MANUFACTURE]: {
    process: aC
  },
  [Le.COPYRIGHT]: {
    process: (t, r, i) => XG(t, r, i, Le.DATE)
  },
  [Le.ISSUANCE]: {
    process: zG
  },
  _notes: {
    process: WG
  },
  [Le.EXTENT]: {
    process: (t, r, i) => iT(t, r, i, "_extent")
  },
  _creatorReference: {
    process: Z_
  },
  _contributorReference: {
    process: Z_
  },
  [Le.SUMMARY]: {
    process: (t, r, i) => iT(t, r, i, "_notes")
  },
  [Le.TABLE_OF_CONTENTS]: {
    process: (t, r, i) => iT(t, r, i, "_notes")
  },
  [Le.LANGUAGE]: {
    process: (t, r, i) => YG(t, r, i, "_language")
  },
  [Le.CLASSIFICATION]: {
    process: (t, r, i) => $G(
      t,
      r,
      i,
      Le.SOURCE,
      "_assigningSourceReference"
    )
  }
};
class ZG {
  constructor() {
    wn(this, "record");
    wn(this, "block");
    wn(this, "reference");
    this.record = {}, this.block = void 0, this.reference = void 0;
  }
  init(r, i, u) {
    this.record = Qc.cloneDeep(r), this.block = i, this.reference = u, this.decoupleBlocks(), this.normalize();
  }
  get() {
    return this.record;
  }
  // Pass the block URIs for the required profile?
  decoupleBlocks() {
    var i, u, c, v, h;
    if (!this.block || !this.reference)
      return;
    const r = (u = this.record[this.block]) == null ? void 0 : u[(i = this.reference) == null ? void 0 : i.key];
    r && (this.record[(c = this.reference) == null ? void 0 : c.uri] = r[0], (h = this.record[this.block]) == null || delete h[(v = this.reference) == null ? void 0 : v.key]);
  }
  normalize() {
    var r, i;
    for (const u in this.record)
      for (const c in this.record[u])
        (i = (r = oT == null ? void 0 : oT[c]) == null ? void 0 : r.process) == null || i.call(
          r,
          this.record,
          u,
          c
        );
  }
}
class JG {
  constructor(r, i, u, c) {
    wn(this, "updatedSchema");
    wn(this, "schemaArray");
    wn(this, "record");
    wn(this, "recordBlocks");
    wn(this, "currentBlockUri");
    wn(this, "currentRecordGroupKey");
    wn(this, "recordMap");
    wn(this, "templateMetadata");
    wn(this, "getSchemaEntries", (r, i) => this.schemaArray.filter((u) => {
      var g, S, x, T;
      const c = u.uri === r, v = i ? ((S = (g = u.constraints) == null ? void 0 : g.valueDataType) == null ? void 0 : S.dataTypeURI) === i : !0;
      let h = !1, y = !1;
      return u.path.forEach((_) => {
        var M;
        ((M = this.updatedSchema) == null ? void 0 : M.get(_)).uriBFLite === this.currentBlockUri && (y = !0);
      }), ((T = (x = this.updatedSchema) == null ? void 0 : x.get($g(u.path))) == null ? void 0 : T.type) === At.block && (h = !0), c && v && y && h;
    }));
    this.selectedEntriesService = r, this.repeatableFieldsService = i, this.userValuesService = u, this.commonStatusService = c, this.updatedSchema = /* @__PURE__ */ new Map(), this.schemaArray = [], this.record = {}, this.recordBlocks = [];
  }
  async init({ schema: r, record: i, recordBlocks: u, templateMetadata: c }) {
    var v;
    this.updatedSchema = Qc.cloneDeep(r), this.schemaArray = r ? Array.from((v = this.updatedSchema) == null ? void 0 : v.values()) : [], this.record = i, this.recordBlocks = u, this.templateMetadata = c, await this.traverseBlocks();
  }
  get() {
    return this.updatedSchema;
  }
  async traverseBlocks() {
    for await (const r of this.recordBlocks.values())
      this.currentBlockUri = r, await this.traverseBlock();
  }
  async traverseBlock() {
    if (this.currentBlockUri)
      try {
        if (!this.record[this.currentBlockUri])
          return;
        for await (const [r, i] of Object.entries(this.record[this.currentBlockUri]))
          await this.processRecordEntry(r, i);
      } catch (r) {
        console.error("Cannot apply a record to the schema:", r), this.commonStatusService.set("ld.recordMappingToSchema", Tr.error);
      }
  }
  async processRecordEntry(r, i) {
    var h;
    if (this.recordMap = (h = Xy == null ? void 0 : Xy[this.currentBlockUri]) == null ? void 0 : h[r], this.currentRecordGroupKey = r, !this.recordMap)
      return;
    const u = this.recordMap.container.bf2Uri, c = this.recordMap.container.dataTypeUri, v = this.getSchemaEntries(u, c);
    for await (const [y, g] of Object.entries(i))
      await this.processRecordGroup(
        y,
        i,
        g,
        v,
        u,
        c
      );
  }
  async processRecordGroup(r, i, u, c, v, h) {
    var g, S, x, T, _;
    if (!(c != null && c.length))
      return;
    const y = (g = this.recordMap) == null ? void 0 : g.options;
    if (Array.isArray(i) && (i == null ? void 0 : i.length) > 1 && parseInt(r) !== 0) {
      const L = this.getSchemaEntries(v, h)[parseInt(r) - 1], M = ((S = this.repeatableFieldsService) == null ? void 0 : S.duplicateEntry(L, !1)) ?? "";
      this.updatedSchema = (x = this.repeatableFieldsService) == null ? void 0 : x.get(), this.schemaArray = Array.from(((T = this.updatedSchema) == null ? void 0 : T.values()) || []), await this.traverseEntries({
        dropdownOptionsMap: y,
        recordGroup: u,
        schemaEntry: (_ = this.updatedSchema) == null ? void 0 : _.get(M)
      });
    } else
      await this.traverseEntries({
        dropdownOptionsMap: y,
        recordGroup: u,
        schemaEntry: c[0]
      });
  }
  async traverseEntries({
    dropdownOptionsMap: r,
    recordGroup: i,
    schemaEntry: u
  }) {
    u && (r ? await this.traverseDropdownOptions(i, u) : await this.traverseGroupsAndUIControls(i, u));
  }
  async traverseDropdownOptions(r, i) {
    var u;
    for await (const [c, v] of Object.entries(r)) {
      const h = this.findSchemaDropdownOption(i, c), y = v;
      if (h) {
        const g = (u = this.updatedSchema) == null ? void 0 : u.get(h);
        await this.mapRecordListToSchemaEntry(y, g);
      } else
        await this.mapRecordListToSchemaEntry(y, i);
    }
  }
  async traverseGroupsAndUIControls(r, i) {
    Jy.includes(i == null ? void 0 : i.type) ? await this.mapRecordValueToSchemaEntry({
      schemaEntry: i,
      recordKey: this.currentRecordGroupKey,
      recordEntryValue: r
    }) : r && typeof r == "object" && await this.mapRecordListToSchemaEntry(r, i);
  }
  findSchemaDropdownOption(r, i, u) {
    var v;
    let c = u;
    return c || (r.children && ((v = r.children) == null || v.forEach((h) => {
      var g;
      const y = (g = this.updatedSchema) == null ? void 0 : g.get(h);
      y && ((y == null ? void 0 : y.type) === At.dropdownOption ? (this.selectedEntriesService.remove(y.uuid), y.uriBFLite === i && (c = y.uuid, this.selectedEntriesService.addNew(void 0, y.uuid))) : c = this.findSchemaDropdownOption(y, i, c));
    })), c);
  }
  findSchemaUIControl({
    schemaEntry: r,
    recordKey: i,
    selectedEntryId: u
  }) {
    var v;
    let c = u;
    return Jy.includes(r.type) && this.hasCorrectUuid(r, i) ? r.uuid : c || (r.children ? (v = r.children) == null || v.forEach((h) => {
      var g, S;
      if (c)
        return;
      const y = (g = this.updatedSchema) == null ? void 0 : g.get(h);
      y && (y.type && P6.includes(y.type) || (this.hasCorrectUuid(y, i) ? c = y.uuid : (S = y == null ? void 0 : y.children) != null && S.length && (c = this.findSchemaUIControl({
        schemaEntry: y,
        recordKey: i,
        selectedEntryId: c
      }))));
    }) : this.hasCorrectUuid(r, i) && (c = r.uuid), c);
  }
  hasCorrectUuid(r, i) {
    var S, x, T;
    const u = Jy.includes(r.type), c = r.uriBFLite === i, v = Xy, h = this.currentBlockUri ? (x = (S = v == null ? void 0 : v[this.currentBlockUri]) == null ? void 0 : S[this.currentRecordGroupKey]) == null ? void 0 : x.fields : void 0, y = (T = h == null ? void 0 : h[i]) == null ? void 0 : T.bf2Uri, g = r.uri === y;
    return u && (c || g);
  }
  async mapRecordListToSchemaEntry(r, i) {
    for await (const [u, c] of Object.entries(r))
      u !== "id" && await this.mapRecordValueToSchemaEntry({
        schemaEntry: i,
        recordKey: u,
        recordEntryValue: c,
        id: r == null ? void 0 : r.id
      });
  }
  async mapRecordValueToSchemaEntry({
    schemaEntry: r,
    recordKey: i,
    recordEntryValue: u,
    id: c
  }) {
    var _, L, M, U, B;
    let v = this.findSchemaUIControl({
      schemaEntry: r,
      recordKey: i
    });
    if (v || (v = this.findSchemaUIControl({
      schemaEntry: (_ = this.updatedSchema) == null ? void 0 : _.get(
        r.path[r.path.length - t6]
      ),
      recordKey: i
    })), !v)
      return;
    const h = (L = this.updatedSchema) == null ? void 0 : L.get(v), y = (B = (U = (M = this.recordMap) == null ? void 0 : M.fields) == null ? void 0 : U[i]) == null ? void 0 : B.label;
    if (!h)
      return;
    const { type: g, constraints: S } = h, x = v, T = u;
    g === At.literal && (S != null && S.repeatable) ? await this.handleRepeatableSubcomponents({
      schemaUiElem: h,
      recordEntryValue: u,
      id: c,
      recordKey: i,
      labelSelector: y,
      valueKey: x,
      data: T
    }) : await this.setUserValue({
      valueKey: x,
      data: T,
      fieldUri: i,
      schemaUiElem: h,
      id: c,
      labelSelector: y
    });
  }
  async handleRepeatableSubcomponents({
    schemaUiElem: r,
    recordEntryValue: i,
    id: u,
    recordKey: c,
    labelSelector: v,
    valueKey: h,
    data: y
  }) {
    let g = h, S = y;
    if (Array.isArray(i))
      for await (const [x, T] of Object.entries(i)) {
        if (this.shouldDuplicateEntry(i, x)) {
          const { newEntryUuid: _ } = this.createDuplicateEntry(r);
          g = _, S = T;
        }
        await this.setUserValue({
          valueKey: g,
          data: S,
          fieldUri: c,
          schemaUiElem: r,
          id: u,
          labelSelector: v
        });
      }
    else
      await this.setUserValue({
        valueKey: g,
        data: S,
        fieldUri: c,
        schemaUiElem: r,
        id: u,
        labelSelector: v
      });
  }
  shouldDuplicateEntry(r, i) {
    return r.length > 1 && parseInt(i) !== 0;
  }
  createDuplicateEntry(r) {
    var u, c, v;
    const i = ((u = this.repeatableFieldsService) == null ? void 0 : u.duplicateEntry(r, !1)) ?? "";
    return this.updatedSchema = (c = this.repeatableFieldsService) == null ? void 0 : c.get(), this.schemaArray = Array.from(((v = this.updatedSchema) == null ? void 0 : v.values()) || []), { newEntryUuid: i };
  }
  async setUserValue({
    valueKey: r,
    data: i,
    fieldUri: u,
    schemaUiElem: c,
    id: v,
    labelSelector: h
  }) {
    var _, L;
    const { type: y, constraints: g, uri: S } = c, x = (_ = this.templateMetadata) == null ? void 0 : _.filter(({ path: M }) => M.at(-1) === u);
    let T = i;
    x != null && x.length && (T = this.checkAndApplyTemplateToValue({
      schemaEntry: c,
      templates: x,
      value: i
    })), await this.userValuesService.setValue({
      type: y,
      key: r,
      value: {
        id: v,
        data: T,
        uri: (L = g == null ? void 0 : g.useValuesFrom) == null ? void 0 : L[0],
        labelSelector: h,
        uriSelector: Le.LINK,
        propertyUri: S,
        blockUri: this.currentBlockUri,
        groupUri: this.currentRecordGroupKey,
        fieldUri: u
      }
    });
  }
  checkAndApplyTemplateToValue({
    schemaEntry: r,
    templates: i,
    value: u
  }) {
    const c = Array.isArray(u);
    if (typeof u == "object" && !c)
      return u;
    const v = r.path.map((g) => {
      var S;
      return (S = this.updatedSchema.get(g)) == null ? void 0 : S.uriBFLite;
    }).filter((g) => g), h = i.filter(
      ({ path: g }) => g.length === v.length && String(g) === String(v)
    );
    return h.length ? [...h.map(({ template: g }) => g.prefix), ...c ? u : [u]].join(" ") : u;
  }
}
const QG = () => {
  const { addStatusMessagesItem: t } = Si();
  return {
    set: (r, i) => {
      t == null || t(Ei.createMessage(i, r));
    }
  };
};
class KG {
  constructor() {
    wn(this, "entriesWithHtmlId");
    this.entriesWithHtmlId = [];
  }
  addEntryWithHtmlId(r) {
    this.entriesWithHtmlId = [...this.entriesWithHtmlId, r];
  }
  applyHtmlIdToEntries(r) {
    for (const i of this.entriesWithHtmlId) {
      const u = r.get(i);
      u && r.set(i, { ...u, htmlId: N8(u, r) });
    }
    this.entriesWithHtmlId = [];
  }
}
const J_ = (t, r) => !!r && t.includes(r), qG = ({
  uriBFLite: t,
  label: r,
  basicLabel: i,
  uri: u,
  type: c,
  nonBFMappedGroup: v
}) => {
  let h;
  const y = i ?? r;
  return WB.includes(t) || c === At.complex ? h = y : v ? h = u != null && u.includes(qB) ? ez({ uri: u, nonBFMappedGroup: v }) : u : h = {
    [E8(t)]: [y],
    [Le.LINK]: [u]
  }, h;
}, ez = ({
  uri: t = "",
  nonBFMappedGroup: r
}) => {
  var c, v;
  if (!r)
    return t;
  const i = um[r.uri];
  let u = t;
  return i && (u = ((v = (c = Object.entries(i.data)) == null ? void 0 : c.find(([y, g]) => g.uri === t)) == null ? void 0 : v[0]) ?? t), u;
}, tz = (t) => Object.values(t).reduce((r, i) => {
  const { contents: u, uuid: c } = i;
  if (!u.length)
    return r;
  const v = u.filter(({ label: h }) => h == null ? void 0 : h.length);
  return v.length && (r[c] = { ...i, contents: v }), r;
}, {});
class nz {
  constructor() {
    wn(this, "schema");
    wn(this, "userValues");
    wn(this, "selectedEntries");
    wn(this, "initialContainer");
    this.schema = /* @__PURE__ */ new Map(), this.userValues = {}, this.selectedEntries = [], this.initialContainer = {};
  }
  init({ schema: r, userValues: i, selectedEntries: u, initialContainer: c }) {
    return this.schema = r, this.userValues = i, this.selectedEntries = u, this.initialContainer = c, this;
  }
  traverse({
    container: r,
    key: i,
    index: u = 0,
    shouldHaveRootWrapper: c = !1,
    parentEntryType: v,
    nonBFMappedGroup: h
  }) {
    const y = r ?? this.initialContainer, { children: g, uri: S, uriBFLite: x, bfid: T, type: _ } = this.schema.get(i) || {}, L = this.getSelector(S, x, T), M = this.userValues[i], U = this.shouldProceed(i), B = this.isArray(_), H = this.isArrayContainer(y, L);
    let Y = h;
    if (this.checkGroupIsNonBFMapped(S, v, _)) {
      const { nonBFMappedGroup: G } = w8({
        propertyURI: S,
        type: _,
        parentEntryType: v
      });
      G && (Y = G);
    }
    this.hasUserValueAndSelector(M, S, L) ? this.handleUserValueMatch({
      userValueMatch: M,
      uriBFLite: x,
      selector: L,
      isArrayContainer: H,
      nonBFMappedGroup: Y,
      container: y
    }) : this.shouldContinueGroupTraverse(U, u, L) && this.handleGroupTraverse({
      container: y,
      key: i,
      index: u,
      type: _,
      selector: L,
      uri: S,
      shouldHaveRootWrapper: c,
      updatedNonBFMappedGroup: Y,
      isArrayContainer: H,
      isArray: B,
      children: g
    });
  }
  getNonArrayTypes() {
    const { hidden: r, dropdownOption: i, profile: u } = At;
    return [r, i, u];
  }
  getSelector(r, i, u) {
    const c = i ?? r;
    return c && ZB[c] || c || u;
  }
  shouldProceed(r) {
    return Object.keys(this.userValues).map((i) => {
      var u;
      return (u = this.schema.get(i)) == null ? void 0 : u.path;
    }).flat().includes(r);
  }
  isArray(r) {
    return !this.getNonArrayTypes().includes(r);
  }
  isArrayContainer(r, i) {
    return !!i && Array.isArray(r[i]);
  }
  checkGroupIsNonBFMapped(r, i, u) {
    return wO({
      propertyURI: r,
      parentEntryType: i,
      type: u
    });
  }
  checkGroupShouldHaveWrapper({
    type: r,
    uri: i,
    nonBFMappedGroup: u,
    shouldHaveRootWrapper: c,
    selector: v
  }) {
    const { block: h, groupComplex: y, hidden: g } = At;
    return (r === h || r === y && J_(XB, i) || r === y && u || c || pO.includes(v) && r !== g) && !YB.includes(v);
  }
  shouldContinueGroupTraverse(r, i, u) {
    return u && (r || i < gm);
  }
  hasUserValueAndSelector(r, i, u) {
    return !!(r && i && u);
  }
  checkDropdownOptionWithoutUserValues(r, i) {
    return r === At.dropdownOption && !this.selectedEntries.includes(i);
  }
  checkEntryWithoutWrapper(r, i, u) {
    return r || i === At.hidden || i === At.groupComplex || JB.includes(u);
  }
  handleUserValueMatch({
    userValueMatch: r,
    uriBFLite: i,
    selector: u,
    isArrayContainer: c,
    nonBFMappedGroup: v,
    container: h
  }) {
    const y = S8(i), g = r.contents.map(
      ({ id: S, label: x, meta: { uri: T, parentUri: _, type: L, basicLabel: M, srsId: U } = {} }) => $B.includes(u) || L === At.complex ? { id: S, label: x, srsId: U } : (_ || T) && (!y || v) || L === At.simple ? qG({
        uriBFLite: i,
        label: x,
        basicLabel: M,
        uri: T ?? _,
        type: L,
        nonBFMappedGroup: v
      }) : y ? x8({ advancedValueField: y, label: x }) : L ? { label: x } : x
    );
    c && h[u].length ? h[u].push(...g) : h[u] = g;
  }
  handleGroupsWithWrapper({
    isArrayContainer: r,
    container: i,
    selector: u,
    type: c
  }) {
    const v = {};
    return r ? i[u].push(v) : i[u] = c === At.block ? v : [v], v;
  }
  handleDropdownOption({
    container: r,
    selector: i,
    identifierAsValueSelection: u
  }) {
    let c = {};
    return QB.includes(i) ? r[i] = c : u ? (c = {
      [u.field]: [u.value]
    }, r.push(c)) : r.push({ [i]: c }), c;
  }
  handleBasicGroup({
    isArray: r,
    container: i,
    selector: u,
    isArrayContainer: c
  }) {
    let v = r ? [] : {};
    return i[u] && c ? v = i[u] : i[u] = v, v;
  }
  handleGroupTraverse({
    container: r,
    key: i,
    index: u,
    type: c,
    selector: v,
    uri: h,
    shouldHaveRootWrapper: y,
    updatedNonBFMappedGroup: g,
    isArrayContainer: S,
    isArray: x,
    children: T
  }) {
    let _, L = y;
    const { profile: M, dropdownOption: U } = At, B = J_(zB, h), H = KB[v];
    if (c === M)
      _ = r;
    else if (this.checkGroupShouldHaveWrapper({
      type: c,
      uri: h,
      nonBFMappedGroup: g,
      shouldHaveRootWrapper: y,
      selector: v
    })) {
      if (this.checkDropdownOptionWithoutUserValues(c, i))
        return;
      _ = this.handleGroupsWithWrapper({
        isArrayContainer: S,
        container: r,
        selector: v,
        type: c
      });
    } else if (c === U) {
      if (!this.selectedEntries.includes(i))
        return;
      _ = this.handleDropdownOption({
        container: r,
        selector: v,
        identifierAsValueSelection: H
      });
    } else
      this.checkEntryWithoutWrapper(B, c, v) ? (_ = r, B && (L = !0)) : _ = this.handleBasicGroup({
        isArray: x,
        container: r,
        selector: v,
        isArrayContainer: S
      });
    T == null || T.forEach(
      (Y) => this.traverse({
        container: _,
        key: Y,
        index: u + 1,
        shouldHaveRootWrapper: L,
        parentEntryType: c,
        nonBFMappedGroup: g
      })
    );
  }
}
class rz {
  constructor(r) {
    wn(this, "schema");
    wn(this, "initKey");
    wn(this, "userValues");
    wn(this, "selectedEntries");
    this.schemaTraverser = r, this.schemaTraverser = r, this.schema = /* @__PURE__ */ new Map(), this.initKey = null, this.userValues = {}, this.selectedEntries = [];
  }
  init({
    schema: r,
    initKey: i,
    userValues: u,
    selectedEntries: c
  }) {
    this.schema = r, this.initKey = i, this.userValues = u, this.selectedEntries = c;
  }
  generate() {
    if (!Object.keys(this.userValues).length || !this.schema.size || !this.initKey)
      return;
    const r = tz(this.userValues), i = {};
    return this.schemaTraverser.init({
      schema: this.schema,
      userValues: r,
      selectedEntries: this.selectedEntries,
      initialContainer: i
    }).traverse({
      key: this.initKey
    }), i;
  }
}
const az = ({ children: t }) => {
  const r = VG(), i = QG(), u = k.useMemo(() => new KG(), []), c = k.useMemo(() => new DG([]), []), v = k.useMemo(
    () => new BG({}, UG, r),
    [r]
  ), h = k.useMemo(
    () => new HG({}, c, u),
    [c, u]
  ), y = k.useMemo(() => new ZG(), []), g = k.useMemo(
    () => new JG(
      c,
      h,
      v,
      i
    ),
    [c, h, v, i]
  ), S = k.useMemo(
    () => new jG(c, u),
    [c, u]
  ), x = k.useMemo(() => new rz(new nz()), []), T = k.useMemo(
    () => ({
      selectedEntriesService: c,
      userValuesService: v,
      schemaWithDuplicatesService: h,
      lookupCacheService: r,
      recordNormalizingService: y,
      recordToSchemaMappingService: g,
      schemaCreatorService: S,
      recordGeneratorService: x
    }),
    [
      c,
      v,
      h,
      r,
      y,
      g,
      S,
      x
    ]
  );
  return /* @__PURE__ */ N.jsx(SO.Provider, { value: T, children: t });
}, Q_ = (t, r) => {
  const i = t[r];
  return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((u, c) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(c.bind(null, new Error("Unknown variable dynamic import: " + r)));
  });
}, iz = async (t) => {
  let r;
  try {
    r = (await Q_(/* @__PURE__ */ Object.assign({ "../../../translations/ui-linked-data/ar.json": () => import("./ar-27667ec2.js"), "../../../translations/ui-linked-data/ber.json": () => import("./ber-8b2de921.js"), "../../../translations/ui-linked-data/ca.json": () => import("./ca-8b2de921.js"), "../../../translations/ui-linked-data/cs_CZ.json": () => import("./cs_CZ-b95b33e0.js"), "../../../translations/ui-linked-data/da.json": () => import("./da-8b2de921.js"), "../../../translations/ui-linked-data/de.json": () => import("./de-8b2de921.js"), "../../../translations/ui-linked-data/en.json": () => Promise.resolve().then(() => $_), "../../../translations/ui-linked-data/en_GB.json": () => import("./en_GB-8b2de921.js"), "../../../translations/ui-linked-data/en_SE.json": () => import("./en_SE-8b2de921.js"), "../../../translations/ui-linked-data/en_US.json": () => import("./en_US-8b2de921.js"), "../../../translations/ui-linked-data/es.json": () => import("./es-8b2de921.js"), "../../../translations/ui-linked-data/es_419.json": () => import("./es_419-8b2de921.js"), "../../../translations/ui-linked-data/es_ES.json": () => import("./es_ES-8b2de921.js"), "../../../translations/ui-linked-data/fr.json": () => import("./fr-8b2de921.js"), "../../../translations/ui-linked-data/fr_FR.json": () => import("./fr_FR-0859fc2d.js"), "../../../translations/ui-linked-data/he.json": () => import("./he-8b2de921.js"), "../../../translations/ui-linked-data/hi_IN.json": () => import("./hi_IN-8b2de921.js"), "../../../translations/ui-linked-data/hu.json": () => import("./hu-8b2de921.js"), "../../../translations/ui-linked-data/it_IT.json": () => import("./it_IT-8b2de921.js"), "../../../translations/ui-linked-data/ja.json": () => import("./ja-960b7b83.js"), "../../../translations/ui-linked-data/ko.json": () => import("./ko-8b2de921.js"), "../../../translations/ui-linked-data/nb.json": () => import("./nb-8b2de921.js"), "../../../translations/ui-linked-data/nl.json": () => import("./nl-a5fd9203.js"), "../../../translations/ui-linked-data/nn.json": () => import("./nn-8b2de921.js"), "../../../translations/ui-linked-data/pl.json": () => import("./pl-209e9526.js"), "../../../translations/ui-linked-data/pt_BR.json": () => import("./pt_BR-20701e6c.js"), "../../../translations/ui-linked-data/pt_PT.json": () => import("./pt_PT-8b2de921.js"), "../../../translations/ui-linked-data/ru.json": () => import("./ru-8b2de921.js"), "../../../translations/ui-linked-data/sk.json": () => import("./sk-8b2de921.js"), "../../../translations/ui-linked-data/sv.json": () => import("./sv-8b2de921.js"), "../../../translations/ui-linked-data/uk.json": () => import("./uk-d68829aa.js"), "../../../translations/ui-linked-data/ur.json": () => import("./ur-8b2de921.js"), "../../../translations/ui-linked-data/zh_CN.json": () => import("./zh_CN-10ee3067.js"), "../../../translations/ui-linked-data/zh_TW.json": () => import("./zh_TW-bb499d21.js"), "../../../translations/ui-linked-data/zu.json": () => import("./zu-8b2de921.js") }), `../../../translations/ui-linked-data/${t.replace("-", "_")}.json`)).default;
  } catch {
    try {
      r = (await Q_(/* @__PURE__ */ Object.assign({ "../../../translations/ui-linked-data/ar.json": () => import("./ar-27667ec2.js"), "../../../translations/ui-linked-data/ber.json": () => import("./ber-8b2de921.js"), "../../../translations/ui-linked-data/ca.json": () => import("./ca-8b2de921.js"), "../../../translations/ui-linked-data/cs_CZ.json": () => import("./cs_CZ-b95b33e0.js"), "../../../translations/ui-linked-data/da.json": () => import("./da-8b2de921.js"), "../../../translations/ui-linked-data/de.json": () => import("./de-8b2de921.js"), "../../../translations/ui-linked-data/en.json": () => Promise.resolve().then(() => $_), "../../../translations/ui-linked-data/en_GB.json": () => import("./en_GB-8b2de921.js"), "../../../translations/ui-linked-data/en_SE.json": () => import("./en_SE-8b2de921.js"), "../../../translations/ui-linked-data/en_US.json": () => import("./en_US-8b2de921.js"), "../../../translations/ui-linked-data/es.json": () => import("./es-8b2de921.js"), "../../../translations/ui-linked-data/es_419.json": () => import("./es_419-8b2de921.js"), "../../../translations/ui-linked-data/es_ES.json": () => import("./es_ES-8b2de921.js"), "../../../translations/ui-linked-data/fr.json": () => import("./fr-8b2de921.js"), "../../../translations/ui-linked-data/fr_FR.json": () => import("./fr_FR-0859fc2d.js"), "../../../translations/ui-linked-data/he.json": () => import("./he-8b2de921.js"), "../../../translations/ui-linked-data/hi_IN.json": () => import("./hi_IN-8b2de921.js"), "../../../translations/ui-linked-data/hu.json": () => import("./hu-8b2de921.js"), "../../../translations/ui-linked-data/it_IT.json": () => import("./it_IT-8b2de921.js"), "../../../translations/ui-linked-data/ja.json": () => import("./ja-960b7b83.js"), "../../../translations/ui-linked-data/ko.json": () => import("./ko-8b2de921.js"), "../../../translations/ui-linked-data/nb.json": () => import("./nb-8b2de921.js"), "../../../translations/ui-linked-data/nl.json": () => import("./nl-a5fd9203.js"), "../../../translations/ui-linked-data/nn.json": () => import("./nn-8b2de921.js"), "../../../translations/ui-linked-data/pl.json": () => import("./pl-209e9526.js"), "../../../translations/ui-linked-data/pt_BR.json": () => import("./pt_BR-20701e6c.js"), "../../../translations/ui-linked-data/pt_PT.json": () => import("./pt_PT-8b2de921.js"), "../../../translations/ui-linked-data/ru.json": () => import("./ru-8b2de921.js"), "../../../translations/ui-linked-data/sk.json": () => import("./sk-8b2de921.js"), "../../../translations/ui-linked-data/sv.json": () => import("./sv-8b2de921.js"), "../../../translations/ui-linked-data/uk.json": () => import("./uk-d68829aa.js"), "../../../translations/ui-linked-data/ur.json": () => import("./ur-8b2de921.js"), "../../../translations/ui-linked-data/zh_CN.json": () => import("./zh_CN-10ee3067.js"), "../../../translations/ui-linked-data/zh_TW.json": () => import("./zh_TW-bb499d21.js"), "../../../translations/ui-linked-data/zu.json": () => import("./zu-8b2de921.js") }), `../../../translations/ui-linked-data/${t.split("-")[0]}.json`)).default;
    } catch (i) {
      console.error("Error occured while loading i18n messages", i);
    }
  }
  return r;
}, oz = (t, r = "en") => {
  const i = (c) => {
    if (t != null && t[c])
      return t == null ? void 0 : t[c];
    throw u(c);
  }, u = async (c) => {
    const v = await iz(c);
    v && (t[c] = { ...t[r], ...v });
  };
  return { getMessages: i, loadMessages: u };
}, lz = ({ cachedMessages: t, children: r }) => {
  const { locale: i } = y2(), { getMessages: u } = oz(t, IT), c = u(i);
  return /* @__PURE__ */ N.jsx(CF, { messages: c || {}, locale: i, defaultLocale: IT, children: r });
};
const sz = [
  {
    path: "/",
    element: /* @__PURE__ */ N.jsx(C8, {}),
    children: [
      {
        index: !0,
        element: /* @__PURE__ */ N.jsx(TN, { to: Va.SEARCH.uri, replace: !0 })
      },
      {
        path: Va.SEARCH.uri,
        element: /* @__PURE__ */ N.jsx(NG, {})
      },
      {
        path: Va.RESOURCE_EDIT.uri,
        element: /* @__PURE__ */ N.jsx(Y_, {})
      },
      {
        path: Va.RESOURCE_CREATE.uri,
        element: /* @__PURE__ */ N.jsx(Y_, {})
      },
      {
        path: Va.EXTERNAL_RESOURCE_PREVIEW.uri,
        element: /* @__PURE__ */ N.jsx(LG, {})
      },
      {
        path: "*",
        element: /* @__PURE__ */ N.jsx(TN, { to: Va.SEARCH.uri, replace: !0 })
        // TODO: UILD-441 - create a component for 404 page
      }
    ]
  }
], uz = (t) => IP(sz, { basename: t }), cz = ({ routePrefix: t = "", config: r }) => {
  const { setCustomEvents: i, setHasNavigationOrigin: u } = y2(), c = k.useRef({ [IT]: G4 });
  return k.useEffect(() => {
    i(r == null ? void 0 : r.customEvents), r != null && r.navigationOrigin && u(!0);
  }, [r]), /* @__PURE__ */ N.jsx(k.Suspense, { fallback: /* @__PURE__ */ N.jsx(J9, { hasLabel: !1, "data-testid": "loading" }), children: /* @__PURE__ */ N.jsx(lz, { cachedMessages: c.current, children: /* @__PURE__ */ N.jsx(RF, { children: /* @__PURE__ */ N.jsx(az, { children: /* @__PURE__ */ N.jsx(MP, { router: uz(t) }) }) }) }) });
}, fz = ({ routePrefix: t = "", config: r }) => (k.useEffect(() => {
  r && m2.serialize(p2, r);
}, [r]), /* @__PURE__ */ N.jsx(cz, { routePrefix: t, config: r }));
class dz extends HTMLElement {
  constructor() {
    super(...arguments);
    // TODO: UILD-147 - uncomment for using with Shadow DOM
    // private template: any | undefined;
    wn(this, "mountElement");
    wn(this, "rootElement");
  }
  connectedCallback() {
    this.setupRoot(), this.render();
  }
  disconnectedCallback() {
    var i;
    (i = this.rootElement) == null || i.unmount();
  }
  // A workaround for 'forcing' the navigation to homepage
  // triggered from outside the web component.
  //
  // The routers in parent application and inside the web component
  // don't share the same history (are not aware of each other),
  // so, app<->web-component navigation doesn't seem to work in some cases.
  remount() {
    var i;
    (i = this.rootElement) == null || i.unmount(), this.render();
  }
  // TODO: UILD-147 - create template with all styles for Shadow DOM
  /* private createTemplate() {
      const template = document.createElement('template');
      const styles = this.getAllStyles();
  
      template.innerHTML = `
        <style>${styles}</style>
      `;
  
      this.template = template;
    } */
  // TODO: UILD-147 - get all styles for Shadow DOM
  // private getAllStyles() {
  //   const filesGlob = import.meta.glob('./**/*.scss', { as: 'scss', eager: true });
  //   return Object.values(filesGlob).reduce((accum: string, current: any) => {
  //     return accum + current.default;
  //   }, '');
  // }
  // TODO: UILD-147 - this is used for setting up Shadow DOM
  /* private setupShadowRoot() {
      if (!this.template) return;
  
      const shadowRoot = this.attachShadow({ mode: 'open' });
      shadowRoot.appendChild(this.template.content.cloneNode(true));
  
      const mountElement = this.createMountElement();
      shadowRoot.appendChild(mountElement);
    } */
  setupRoot() {
    const i = this.createMountElement();
    this.appendChild(i);
  }
  createMountElement() {
    const i = document.createElement("div");
    return i.className = "embed-container", this.mountElement = i, i;
  }
  render() {
    var v;
    const i = this.getAttribute("route-prefix"), u = this.getAttribute("config"), c = u && JSON.parse(u);
    this.mountElement && (this.rootElement = Gy.createRoot(this.mountElement), (v = this.rootElement) == null || v.render(
      /* @__PURE__ */ N.jsx(hC.StrictMode, { children: /* @__PURE__ */ N.jsx(fz, { routePrefix: i, config: c }) })
    ));
  }
}
window.customElements.get(FT) || window.customElements.define(FT, dz);
